var prefix = "https://www.digitale-luftbilder.de/products/luftbild-";

var suffixes = [
"abenberg-abenberg-n292320",
"abenberg-abenberg-n292480",
"abenberg-burg_abenberg-n292380",
"abenberg-burg_abenberg-n292410",
"abenberg-burg_abenberg-n292430",
"abenberg-burg_abenberg-n292460",
"abenberg-burg_abenberg-n515130",
"abenberg-burg_abenberg-n515140",
"abenberg-burg_abenberg-n515150",
"abenberg-ebersbach-f502330",
"abenberg-kleinabenberg-f431250",
"abenberg-kreisverkehr_bei_aurau-f431270",
"abenberg-maedchenralschule_marienburg-n515110",
"abenberg-marienburg-n515120",
"absberg-brombachsee-c214130",
"absberg-brombachsee-c214150",
"absberg-brombachsee-c214180",
"absberg-brombachsee-c214190",
"absberg-brombachsee-c214210",
"absberg-brombachsee-c214220",
"absberg-brombachsee-c214230",
"absberg-brombachsee-c214240",
"adelschlag-adelschlag-f48990",
"adelschlag-photovoltaikanlage_in_untermoeckenlohe-f481010",
"adelschlag-photovoltaikanlage_in_untermoeckenlohe-f481020",
"adelsdorf-neuhaus-n268550",
"adelsdorf-neuhaus-n268590",
"adelsdorf-neuhaus-n268600",
"adelsdorf-neuhaus-n268610",
"adelsdorf-neuhaus-n268620",
"adelsdorf-neuhaus-n268700",
"adelsdorf-wasserschloss_neuhaus-n268480",
"adelsdorf-wasserschloss_neuhaus-n268490",
"adelsdorf-wasserschloss_neuhaus-n268500",
"adelsdorf-wasserschloss_neuhaus-n268510",
"adelsdorf-wasserschloss_neuhaus-n268520",
"adelsdorf-wasserschloss_neuhaus-n268530",
"adelsdorf-wasserschloss_neuhaus-n268540",
"adelsdorf-wasserschloss_neuhaus-n268560",
"adelsdorf-wasserschloss_neuhaus-n268570",
"adelsdorf-wasserschloss_neuhaus-n268580",
"adelsdorf-wasserschloss_neuhaus-n268630",
"adelsdorf-wasserschloss_neuhaus-n268640",
"adelsdorf-wasserschloss_neuhaus-n268680",
"adelsdorf-wasserschloss_neuhaus-n268690",
"adelsdorf-wasserschloss_neuhaus-n268720",
"ahorntal-burg_rabenstein-n267670",
"ahorntal-burg_rabenstein-n267680",
"ahorntal-burg_rabenstein-n267690",
"ahorntal-burg_rabenstein-n267710",
"ahorntal-burg_rabenstein-n267720",
"ahorntal-burg_rabenstein-n267730",
"ahorntal-burg_rabenstein-n267740",
"ahorntal-burg_rabenstein-n267750",
"ahorntal-burg_rabenstein-n267760",
"ahorntal-burg_rabenstein-n267770",
"ahorntal-burg_rabenstein-n267790",
"ahorntal-burg_rabenstein-n267800",
"ahorntal-burg_rabenstein-n551860",
"ahorntal-burg_rabenstein-n551870",
"ahorntal-burg_rabenstein-n551880",
"ahorntal-hubschrauberlandeplatz-n267660",
"ahorntal-pfaffenberg-f553380",
"ahorntal-pfaffenberg-f553390",
"ahorntal-vor-n551900",
"aichach-aichach-n514720",
"aichach-biogasanlage_bei_aichach-n514730",
"aichach-biogasanlage_bei_aichach-n514740",
"aichach-schlagmann_poroton_gmbh-n514690",
"aichach-schlagmann_poroton_gmbh-n514710",
"aichach-schloss_blumenthal-n514650",
"aichach-schloss_blumenthal-n514670",
"aichach-schloss_blumenthal-n514680",
"ainhofen-ainhofen-f481270",
"aischgrund-aischgrund-cd19000",
"aischgrund-aischgrund-cd19010",
"aischgrund-aischgrund-f42150",
"aischgrund-aischgrund-f4220",
"aischgrund-holz-c137490",
"aischgrund-karpfenweiher-c158420",
"aischgrund-karpfenweiher-c255180",
"aischgrund-karpfenweiher-cd18950",
"aischgrund-karpfenweiher-cd19110",
"aischgrund-karpfenweiher-f411440",
"aischgrund-karpfenweiher-f411470",
"aischgrund-landwirtschaft-f411280",
"aischgrund-naehe_herzogenaurach-n056490",
"aiterhofen-ainbrach-n523090",
"aiterhofen-moosdorf-n523140",
"alfeld-alfeld_bei_poppberg-f453330",
"alfeld-alfeld_bei_poppberg-f453330",
"alfeld-molsberg_bei_alfeld-f442970",
"allach-baggersee-f481430",
"allach-baggersee-f481440",
"allersberg-abrichtplatz__schoenbrunn_bei_allersberg_-f421700",
"allersberg-allersberg-n34690",
"allersberg-allersberg-n34710",
"allersberg-allersberg-n34740",
"allersberg-allersberg-n34750",
"allersberg-allersberg-n34760",
"allersberg-allersberg-n34770",
"allersberg-allersberg-n34830",
"allersberg-altenfelden-n34650",
"allersberg-gaertnerei-n34720",
"allersberg-hebelsricht-f431340",
"allersberg-labyrinth_bei_allersberg-f431400",
"allersberg-lampersdorf_bei_allersberg-f421680",
"allersberg-pfarrkirche_allerheiligen-n34780",
"allersberg-pferdehof_bei_rohr__allersberg_-f431370",
"allersberg-rastplatz_goeggelsbuch-f421670",
"allersberg-rohr_bei_allersberg-f431390",
"allersberg-schoenbrunn_bei_allersberg-f421690",
"allersberg-schoenbrunn-f431330",
"allersberg-sybilla-maurer_grundschule-n34820",
"allgaeu-allgaeu-f500550",
"allgaeu-allgaeu-f500560",
"allgaeu-allgaeu-f501030",
"allgaeu-allgaeu-f501040",
"allmannsdorf-allmannsdorf-n515030",
"allmannsdorf-allmannsdorf-n515040",
"allmannshofen-gut_schwaighof-n325840",
"allmannshofen-kloster_holzen-n325700",
"allmannshofen-kloster_holzen-n325730",
"allmannshofen-kloster_holzen-n325750",
"allmannshofen-kloster_holzen-n325780",
"allmannshofen-kloster_holzen-n325810",
"alpen-alpen-n512610",
"alpen-alpen-n512620",
"alpen-alpen-n512630",
"alpen-alpen-n512640",
"alpen-alpen-n512650",
"alpen-alpen-n512660",
"alpen-alpen-n512670",
"alpen-alpen-n512680",
"alpen-alpen-n512690",
"alpen-alpen-n512700",
"alpen-alpen-n512710",
"alpen-alpen-n512720",
"alpen-alpen-n512760",
"alpen-alpen-n512770",
"alpen-alpen-n512780",
"alpen-alpen-n512840",
"alpen-alpen-n512860",
"alpen-alpen-n512870",
"alpen-alpen-n512890",
"alpen-alpen-n512900",
"alpen-alpen-n512910",
"alpen-alpen-n512920",
"alpen-alpen-n512930",
"alpen-alpen-n512950",
"alpen-alpen-n512970",
"alpen-alpen-n512980",
"alpen-alpen-n513000",
"altdorf-altdorf-c161010",
"altdorf-altdorf-c161150",
"altdorf-altdorf-c161220",
"altdorf-altdorf-c161240",
"altdorf-altdorf-c161280",
"altdorf-altdorf-c161320",
"altdorf-altdorf-c16930",
"altdorf-altdorf-c171170",
"altdorf-altdorf-c171180",
"altdorf-autobahn_a9-f402750",
"altdorf-autobahnkreuz_altdorf-f402680",
"altdorf-autobahnkreuz_altdorf-f402710",
"altdorf-autobahnkreuz_altdorf-f402760",
"altdorf-autobahnkreuz_altdorf-f402780",
"altdorf-klaerbecken_bei_altdorf___rasch-f461740",
"altdorf-lkw_altdorf-c16870",
"altenbeuthen_-altenbeuthen-n356460",
"altenbeuthen_-altenbeuthen-n356470",
"altisheim-altisheim-c500800",
"amberg-a6_bei_amberg-f422660",
"amberg-alt-eglsee-f522460",
"amberg-amberg_eisberg-f522450",
"amberg-amberg_ost-n524350",
"amberg-amberg-f422950",
"amberg-amberg-f422960",
"amberg-amberg-f422970",
"amberg-amberg-f522320",
"amberg-amberg-f522330",
"amberg-amberg-f522360",
"amberg-amberg-f522370",
"amberg-amberg-f522390",
"amberg-amberg-f522410",
"amberg-amberg-f522430",
"amberg-amberg-f522440",
"amberg-amberg-n524480",
"amberg-amberg-n524530",
"amberg-autobahn_a6_amberg-ost-f422640",
"amberg-autobahn_a6_amberg-sued-f422760",
"amberg-autobahn_a6_amberg-sued-f422800",
"amberg-autobahn_a6_amberg-sued-f422830",
"amberg-autobahn_a6_amberg-sued-f422910",
"amberg-autobahn_a6_amberg-sued-f422920",
"amberg-autobahn_a6_amberg-sued-f422930",
"amberg-autobahn_a6_amberg-sued-f422940",
"amberg-autobahnbruecke_amberg_sued-f432380",
"amberg-englhard_steinbruch_gmbh-n524560",
"amberg-englhard_steinbruch_gmbh-n524570",
"amberg-gewerbegebiet_amberg_west-f432590",
"amberg-gewerbegebiet_theuern-f422900",
"amberg-glasmacherkathedrale__gropius-bau_-n524470",
"amberg-industriegebiet_schafhof_ii-f422650",
"amberg-jura-werkstaetten_amberg-n524500",
"amberg-kurfuerstenbad_amberg-n524520",
"amberg-landesgartenschau_gelaende_amberg-n524510",
"amberg-maria_hilf_kirche-f522350",
"amberg-maria_hilf_kirche-n524550",
"amberg-raststaette_oberpfaelzer_alb-n524620",
"amberg-schaeflohe-f522470",
"amberg-sportzentrum_kuemmersbruck-f432580",
"amberg-windrad_oberpfaelzer_alb-n524640",
"amberg-windrad_oberpfaelzer_alb-n524670",
"amberg-windrad_oberpfaelzer_alb-n524710",
"amendingen-amendingen-c504110",
"amendingen-amendingen-c504180",
"amendingen-amendingen-c504190",
"amendingen-amendingen-c504210",
"amendingen-amendingen-c504230",
"amendingen-amendingen-c504240",
"amendingen-bauhaus_memmingen-c504160",
"amendingen-bauhaus_memmingen-f501740",
"amendingen-freiwillige_feuerwehr_amendingen-c504170",
"ametsbichl-erdgasspeicher_schmidhausen-n513650",
"ametsbichl-erdgasspeicher_schmidhausen-n513660",
"ammerndorf-ammerndorf-n264990",
"ammerndorf-ammerndorf-n265000",
"ammerndorf-ammerndorf-n265040",
"ammerndorf-ammerndorf-n265080",
"ammerndorf-bubenmuehle-n265060",
"ansbach-ansbach-n272160",
"ansbach-ansbach-n272280",
"ansbach-ansbach-n272310",
"ansbach-ansbach-n272340",
"ansbach-ansbach-n327400",
"ansbach-ansbach-n327410",
"ansbach-ansbach-n327420",
"ansbach-ansbach-n327430",
"ansbach-ansbach-n327450",
"ansbach-ansbach-n327460",
"ansbach-ansbach-n327490",
"ansbach-ausfahrt_ansbach-f461130",
"ansbach-ausfahrt_ansbach-f461190",
"ansbach-ausfahrt_ansbach-f46990",
"ansbach-autobahn_a6_bei_ansbach-f451170",
"ansbach-autobahnanschluss_a6___b13-f43870",
"ansbach-autobahnanschluss_a6___b13-f43950",
"ansbach-biokraftwerk_bei_ansbach-f46940",
"ansbach-bruecken-center-n272180",
"ansbach-bruecken-center-n327470",
"ansbach-burg_colmberg-n271950",
"ansbach-burg_colmberg-n272010",
"ansbach-burg_colmberg-n272040",
"ansbach-burg_colmberg-n272070",
"ansbach-burg_colmberg-n272080",
"ansbach-ellingen-n272690",
"ansbach-ellingen-n272710",
"ansbach-funkturm_bei_ansbach-f431190",
"ansbach-haundorf-n272530",
"ansbach-hofgarten-n327380",
"ansbach-orangerie-n272200",
"ansbach-orangerie-n272220",
"ansbach-orangerie-n272290",
"ansbach-orangerie-n272350",
"ansbach-orangerie-n272360",
"ansbach-orangerie-n272370",
"ansbach-orangerie-n272380",
"ansbach-residenz_ansbach-n327370",
"ansbach-residenz_ellingen-n272570",
"ansbach-residenz_ellingen-n272620",
"ansbach-residenz_ellingen-n272630",
"ansbach-schloss_ruegland-n271390",
"ansbach-schloss_ruegland-n271500",
"ansbach-schloss_ruegland-n271550",
"ansbach-schloss_ruegland-n271570",
"ansbach-schloss_ruegland-n271580",
"ansbach-schloss_ruegland-n271590",
"ansbach-schloss_ruegland-n271600",
"ansbach-wolfartswinden-n272400",
"ansbach-wolfartswinden-n272410",
"appenfelden-appenfelden-f37190",
"aresing-oberlauterbach-f481250",
"aresing-pfarrkirche_st__wenzeslaus-f481250",
"arzbach-arzbach_bei_crailsheim-f42980",
"aschaffenburg-adenauerbruecke-f371800",
"aschaffenburg-adenauerbruecke-f371820",
"aschaffenburg-aschaffenburg_-_altstadt-c562800",
"aschaffenburg-aschaffenburg_-_altstadt-c562830",
"aschaffenburg-aschaffenburg_-_basilika-c562840",
"aschaffenburg-aschaffenburg_-_godelsberg-s561520",
"aschaffenburg-aschaffenburg-c562890",
"aschaffenburg-aschaffenburg-c562900",
"aschaffenburg-aschaffenburg-f371810",
"aschaffenburg-aschaffenburg-f372070",
"aschaffenburg-aschaffenburg-f372170",
"aschaffenburg-aschaffenburg-f372210",
"aschaffenburg-aschaffenburg-f372220",
"aschaffenburg-aschaffenburg-f372340",
"aschaffenburg-aschaffenburg-f372350",
"aschaffenburg-aschaffenburg-f372360",
"aschaffenburg-aschaffenburg-f372380",
"aschaffenburg-aschaffenburg-f372390",
"aschaffenburg-aschaffenburg-f372400",
"aschaffenburg-aschaffenburg-f372410",
"aschaffenburg-aschaffenburg-f372440",
"aschaffenburg-aschaffenburg-f372560",
"aschaffenburg-aschaffenburg-f372620",
"aschaffenburg-aschaffenburg-s561530",
"aschaffenburg-aschaffenburg-s561540",
"aschaffenburg-aschaffenburg-s561550",
"aschaffenburg-aschaffenburg-s561570",
"aschaffenburg-aschaffenburg-s561580",
"aschaffenburg-aschaffenburg-s561590",
"aschaffenburg-bauhaus-f371780",
"aschaffenburg-ebertbruecke-f372540",
"aschaffenburg-freibad_aschaffenburg-s561610",
"aschaffenburg-freibad_aschaffenburg-s561630",
"aschaffenburg-freizeitwelt_aschaffenburg-f372020",
"aschaffenburg-freizeitwelt_aschaffenburg-f372160",
"aschaffenburg-freizeitwelt_aschaffenburg-f372550",
"aschaffenburg-goldbach_und_hoesbach-s561490",
"aschaffenburg-hafen_aschaffenburg-f372500",
"aschaffenburg-hauptbahnhof_aschaffenburg-c562780",
"aschaffenburg-hauptbahnhof_aschaffenburg-f371900",
"aschaffenburg-hauptbahnhof_aschaffenburg-f371910",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372110",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372130",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372230",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372240",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372250",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372260",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372280",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372370",
"aschaffenburg-hauptbahnhof_aschaffenburg-f372580",
"aschaffenburg-hauptbahnhof_aschaffenburg-s561640",
"aschaffenburg-kapuzinerkirche-f372150",
"aschaffenburg-keilberg-s561440",
"aschaffenburg-kleingartenanlage_moerswiese-f372450",
"aschaffenburg-klinikum_aschaffenburg-s561500",
"aschaffenburg-neubaugebiet_anwandeweg-f371860",
"aschaffenburg-neubaugebiet_anwandeweg-f371880",
"aschaffenburg-schloss_johannisburg-c562850",
"aschaffenburg-schloss_johannisburg-c562870",
"aschaffenburg-schloss_johannisburg-c562880",
"aschaffenburg-schloss_johannisburg-f371920",
"aschaffenburg-schloss_johannisburg-f371940",
"aschaffenburg-schloss_johannisburg-f371950",
"aschaffenburg-schloss_johannisburg-f371990",
"aschaffenburg-schloss_johannisburg-f372010",
"aschaffenburg-schloss_johannisburg-f372080",
"aschaffenburg-schloss_johannisburg-f372090",
"aschaffenburg-schloss_johannisburg-f372120",
"aschaffenburg-schloss_johannisburg-f372300",
"aschaffenburg-schloss_johannisburg-f372320",
"aschaffenburg-schmerlenbach-s561460",
"aschaffenburg-schweinheim_aschaffenburg-f371790",
"aschaffenburg-speedboot_am_main-f371870",
"aschaffenburg-speedboot_am_main-f371890",
"aschaffenburg-stadttheater_aschaffenburg-f371970",
"aschaffenburg-willigbruecke-f371830",
"aschaffenburg-willigisbruecke-f372030",
"aufham-aufham-f511340",
"aufham-hans-peter-porsche_traumwerk-n512560",
"aufham-hans-peter-porsche_traumwerk-n512570",
"augsburg-abfallverwertungsanlage-n325450",
"augsburg-abfallverwertungsanlage-n325470",
"augsburg-augsburg-c501100",
"augsburg-augsburg-c501120",
"augsburg-augsburg-c501130",
"augsburg-augsburger_dom-n325220",
"augsburg-augsburger_dom-n325230",
"augsburg-augsburger_dom-n325340",
"augsburg-augsburger_dom-n325350",
"augsburg-augsburger_dom-n325380",
"augsburg-augsburger_dom-n325390",
"augsburg-augsburg-f500470",
"augsburg-augsburg-f500480",
"augsburg-augsburg-f500490",
"augsburg-augsburg-f500500",
"augsburg-augsburg-f500520",
"augsburg-augsburg-n324910",
"augsburg-augsburg-n324940",
"augsburg-augsburg-n324960",
"augsburg-augsburg-n324980",
"augsburg-augsburg-n325000",
"augsburg-augsburg-n325010",
"augsburg-augsburg-n325020",
"augsburg-augsburg-n325030",
"augsburg-augsburg-n325040",
"augsburg-augsburg-n325070",
"augsburg-augsburg-n325080",
"augsburg-augsburg-n325170",
"augsburg-augsburg-n325240",
"augsburg-augsburg-n325300",
"augsburg-augsburg-n325490",
"augsburg-autobahnbruecke_a8_augsburg-c501040",
"augsburg-bayernkolleg_augsburg-c501080",
"augsburg-bayernkolleg_augsburg-c501090",
"augsburg-gersthofen-n324280",
"augsburg-gersthofen-n324290",
"augsburg-gersthofen-n324400",
"augsburg-gersthofen-n324460",
"augsburg-gersthofen-n324610",
"augsburg-gersthofen-n324660",
"augsburg-gersthofen-n324700",
"augsburg-gersthofen-n324770",
"augsburg-heizkraftwerk-n325410",
"augsburg-klaerwerk-c501050",
"augsburg-man-bruecke-c501110",
"augsburg-premium_aerotec-f500540",
"augsburg-prinzregentenplatz-n325320",
"augsburg-rathausplatz-n325250",
"augsburg-rathausplatz-n325260",
"augsburg-rathausplatz-n325280",
"augsburg-rathausplatz-n325310",
"augsburg-rosenaustadion-n325120",
"augsburg-sigma_technopark_augsburg-f500510",
"augsburg-sportgelaende_tsg_1885_augsburg-c501070",
"augsburg-sportgelaende_tsv_firnhaberau-c501060",
"augsburg-stadtarchiv_augsburg-c501140",
"augsburg-universitaetsviertel_augsburg-f500530",
"aurach-autobahnraststaette_frankenhoehe-f401170",
"aurachtal-gewerbegebiet_wirtshoehe-n265250",
"aurachtal-landwirtschaft-n265260",
"auwald-iller-c504260",
"auwald-iller-c504300",
"auwald-klaeranlage_au-c504250",
"auwald-klaeranlage_au-c504270",
"bad_groenenbach-bad_groenenbach-c504010",
"bad_groenenbach-bad_groenenbach-c504070",
"bad_groenenbach-bad_groenenbach-c504080",
"bad_groenenbach-bad_groenenbach-f501590",
"bad_groenenbach-bad_groenenbach-f501610",
"bad_groenenbach-bad_groenenbach-f501620",
"bad_groenenbach-hohes_schloss-c504030",
"bad_groenenbach-hohes_schloss-c504050",
"bad_groenenbach-saegewerk_bad_groenenbach-c504090",
"bad_groenenbach-woeringen-f501630",
"bad_kissingen-bad_kissingen_-_ludwigsturm-c563210",
"bad_kissingen-bad_kissingen_-_ludwigsturm-c563220",
"bad_kissingen-bad_kissingen_-_multimediabrunnen-c563110",
"bad_kissingen-bad_kissingen-c563080",
"bad_kissingen-bad_kissingen-c563090",
"bad_kissingen-bad_kissingen-c563130",
"bad_kissingen-bad_kissingen-c563140",
"bad_kissingen-bad_kissingen-c563150",
"bad_kissingen-bad_kissingen-c563170",
"bad_kissingen-bad_kissingen-c563180",
"bad_kissingen-bad_kissingen-c563190",
"bad_kissingen-bad_kissingen-c563260",
"bad_kissingen-bad_kissingen-c563270",
"bad_kissingen-bad_kissingen-s561670",
"bad_kissingen-bad_kissingen-s561690",
"bad_kissingen-flugplatz_bad_kissingen-c563230",
"bad_kissingen-kisssalis_therme-c563290",
"bad_kissingen-klaeranlage_bad_kissingen-c563300",
"bad_kissingen-marbachtalklinik-c563200",
"bad_kissingen-max-littmann-saal-c563100",
"bad_kissingen-max-littmann-saal-c563120",
"bad_kissingen-pfarrkirche_herz_jesu-c563160",
"bad_kissingen-stadtstrand_bad_kissingen-c563240",
"bad_reichenhall-bad_reichenhall-f511400",
"bad_reichenhall-bad_reichenhall-f511410",
"bad_reichenhall-bad_reichenhall-n512580",
"bad_reichenhall-bad_reichenhall-n512590",
"bad_reichenhall-bad_reichenhall-n512600",
"bad_staffelstein-altmainsee_bei_moenchshof-n357810",
"bad_staffelstein-basilika_vierzehnheiligen-n357560",
"bad_staffelstein-basilika_vierzehnheiligen-n357580",
"bad_staffelstein-basilika_vierzehnheiligen-n357600",
"bad_staffelstein-basilika_vierzehnheiligen-n357630",
"bad_staffelstein-basilika_vierzehnheiligen-n357650",
"bad_staffelstein-kloster_banz-n357330",
"bad_staffelstein-kloster_banz-n357370",
"bad_staffelstein-kloster_banz-n357390",
"bad_staffelstein-kloster_banz-n357400",
"bad_staffelstein-kloster_banz-n357410",
"bad_staffelstein-kloster_banz-n357450",
"bad_staffelstein-kloster_banz-n357470",
"bad_staffelstein-kloster_banz-n357480",
"bad_staffelstein-kloster_banz-n357500",
"bad_staffelstein-kloster_banz-n357510",
"bad_staffelstein-kloster_banz-n357520",
"bad_staffelstein-kloster_banz-n551530",
"bad_staffelstein-kloster_banz-n551550",
"bad_staffelstein-kloster_banz-n551580",
"bad_staffelstein-kloster_banz-n551590",
"bad_staffelstein-kloster_banz-n551600",
"bad_staffelstein-kloster_banz-n551610",
"bad_staffelstein-kloster_banz-n551620",
"bad_staffelstein-kloster_banz-n551630",
"bad_staffelstein-neubanz-n357340",
"bad_staffelstein-staffelberg-n357670",
"bad_staffelstein-staffelberg-n357680",
"bad_staffelstein-staffelberg-n357710",
"bad_staffelstein-staffelberg-n357720",
"bad_staffelstein-staffelberg-n357740",
"bad_staffelstein-staffelberg-n357750",
"bad_staffelstein-staffelberg-n357780",
"bad_staffelstein-staffelberg-n357790",
"bad_staffelstein-staffelberg-n357800",
"bad_windsheim-bad_windsheim__illesheimer_strasse-c560640",
"bad_windsheim-bad_windsheim__illesheimer_strasse-c560650",
"bad_windsheim-bad_windsheim__illesheimer_strasse-c560660",
"bad_windsheim-bad_windsheim__illesheimer_strasse-c560670",
"bad_windsheim-bad_windsheim_-_sonnenberg-s560150",
"bad_windsheim-bad_windsheim_-_sonnenberg-s560160",
"bad_windsheim-bad_windsheim_-_sonnenberg-s560170",
"bad_windsheim-bad_windsheim-c560520",
"bad_windsheim-bad_windsheim-c560530",
"bad_windsheim-bad_windsheim-c560540",
"bad_windsheim-bad_windsheim-c560570",
"bad_windsheim-bad_windsheim-c560610",
"bad_windsheim-bad_windsheim-c560620",
"bad_windsheim-bad_windsheim-f378510",
"bad_windsheim-bad_windsheim-f378520",
"bad_windsheim-bad_windsheim-s560210",
"bad_windsheim-eichelberg-c560440",
"bad_windsheim-eichelberg-c560450",
"bad_windsheim-friefhof_bad_windsheim-c560630",
"bad_windsheim-holzhausen-c560470",
"bad_windsheim-klaerwerk_bad_windsheim-c560550",
"bad_windsheim-lenkersheim-c560500",
"bad_windsheim-lenkersheim-c560510",
"bad_windsheim-marktplatz_bad_windsheim-c560580",
"bad_windsheim-marktplatz_bad_windsheim-c560590",
"bad_windsheim-oberndorf-c560480",
"bad_windsheim-oberndorf-s560200",
"bad_windsheim-schullandheim_bad_windsheim-c560600",
"bad_windsheim-wiebelsheim-c560680",
"bad_windsheim-wiebelsheim-c560700",
"baierbach-simssee-n513510",
"baiern-jakobsbaiern-n513760",
"baiern-jakobsbaiern-n513770",
"baiern-jakobsbaiern-n513780",
"baiern-piusheim-n513790",
"baiern-piusheim-n513800",
"baiersdorf-autobahn_a73_-_ausfahrt_baiersdorf_nord-n276740",
"baiersdorf-autobahn_a73_-_ausfahrt_baiersdorf_nord-n276750",
"baiersdorf-autobahn_a73_-_ausfahrt_baiersdorf_nord-n276760",
"baiersdorf-autobahn_a73_-_ausfahrt_baiersdorf_nord-n276770",
"baiersdorf-bubenreuth_und_baiersdorf-f494750",
"bamberg-altenburg-n358470",
"bamberg-autobahnkreuz_bamberg_a70___a73-n266260",
"bamberg-autobahnkreuz_bamberg_a70___a73-n266290",
"bamberg-bamberger_dom-n265960",
"bamberg-bamberger_dom-n265980",
"bamberg-bamberger_dom-n265990",
"bamberg-bamberger_dom-n266000",
"bamberg-bamberger_dom-n266100",
"bamberg-bamberger_dom-n358180",
"bamberg-bamberger_dom-n358200",
"bamberg-bamberger_dom-n358250",
"bamberg-bamberger_dom-n358300",
"bamberg-bamberger_dom-n358400",
"bamberg-bamberger_dom-n358410",
"bamberg-bamberg-n265920",
"bamberg-bamberg-n266020",
"bamberg-bamberg-n266030",
"bamberg-bamberg-n266040",
"bamberg-bamberg-n266060",
"bamberg-bamberg-n266120",
"bamberg-bamberg-n266130",
"bamberg-bamberg-n266140",
"bamberg-bamberg-n266160",
"bamberg-bamberg-n266170",
"bamberg-bamberg-n266180",
"bamberg-bamberg-n358110",
"bamberg-bamberg-n358120",
"bamberg-bamberg-n358130",
"bamberg-bamberg-n358140",
"bamberg-bamberg-n358190",
"bamberg-bamberg-n358350",
"bamberg-bamberg-n358440",
"bamberg-bamberg-n358450",
"bamberg-biotop_bei_bamberg-n357830",
"bamberg-burg_altenburg-n265730",
"bamberg-burg_altenburg-n265740",
"bamberg-burg_altenburg-n265750",
"bamberg-burg_altenburg-n265760",
"bamberg-burg_altenburg-n265780",
"bamberg-burg_altenburg-n265800",
"bamberg-burg_altenburg-n265830",
"bamberg-burg_altenburg-n265870",
"bamberg-burg_altenburg-n265880",
"bamberg-burg_altenburg-n265890",
"bamberg-friedhof-n266210",
"bamberg-gewerbegebiet-n266220",
"bamberg-kloster_michelsberg-n265930",
"bamberg-kloster_michelsberg-n265950",
"bamberg-kloster_michelsberg-n265970",
"bamberg-kloster_michelsberg-n266010",
"bamberg-kloster_michelsberg-n266070",
"bamberg-kloster_michelsberg-n266080",
"bamberg-kloster_michelsberg-n266150",
"bamberg-kloster_michelsberg-n358260",
"bamberg-kloster_michelsberg-n358320",
"bamberg-kloster_michelsberg-n358330",
"bamberg-kloster_michelsberg-n358380",
"bamberg-loewenbruecke_bamberg-n358420",
"bamberg-luitpoldbruecke_bamberg-n358360",
"bamberg-regnitz-n266190",
"bamberg-regnitz-n266200",
"bamberg-rosengarten-n265940",
"bamberg-stank_jakob_kirche-n266090",
"bamberg-theresianum-n266050",
"bamberg-villa_remeis-n266110",
"bayreuth-airport-n35880",
"bayreuth-airport-n35890",
"bayreuth-airport-n35900",
"bayreuth-bayreuth_-_altes_schloss-n551710",
"bayreuth-bayreuth_-_altes_schloss-n551750",
"bayreuth-bayreuth_-_altstadt-n551680",
"bayreuth-bayreuth_-_altstadt-n551690",
"bayreuth-bayreuth_-_altstadt-n551720",
"bayreuth-bayreuth_-_altstadt-n551730",
"bayreuth-bayreuth_-_altstadt-n551790",
"bayreuth-bayreuth_-_hofgarten-n551800",
"bayreuth-bayreuth_-_hofgarten-n551820",
"bayreuth-bayreuth_-_hofgarten-n551830",
"bayreuth-bayreuth_-_hohenzollernplatz-n551780",
"bayreuth-bayreuth_-_sprtplatz-n551740",
"bayreuth-bayreuther_festspielhaus-n35560",
"bayreuth-bayreuther_festspielhaus-n35600",
"bayreuth-bayreuther_festspielhaus-n35610",
"bayreuth-bayreuther_festspielhaus-n35620",
"bayreuth-bayreuther_festspielhaus-n35660",
"bayreuth-bayreuther_turnerschaft-n551810",
"bayreuth-bayreuth-f553120",
"bayreuth-bayreuth-f553130",
"bayreuth-bayreuth-f553140",
"bayreuth-bayreuth-f553150",
"bayreuth-bayreuth-f553160",
"bayreuth-bayreuth-f553170",
"bayreuth-bayreuth-f553180",
"bayreuth-bayreuth-f553190",
"bayreuth-bayreuth-f553210",
"bayreuth-bayreuth-f553230",
"bayreuth-bayreuth-f553240",
"bayreuth-bayreuth-f553250",
"bayreuth-bayreuth-f553260",
"bayreuth-bayreuth-f553280",
"bayreuth-bayreuth-f553290",
"bayreuth-bayreuth-f553300",
"bayreuth-bayreuth-f553310",
"bayreuth-bayreuth-n35770",
"bayreuth-bernecker_strasse-n35720",
"bayreuth-bernecker_strasse-n35730",
"bayreuth-bindlacher_berg-n35780",
"bayreuth-eckersdorf-eschen-n35340",
"bayreuth-eckersdorf-lahm-n35350",
"bayreuth-elfenweg-n35440",
"bayreuth-festspielhaus_bayreuth-n551640",
"bayreuth-festspielhaus_bayreuth-n551650",
"bayreuth-festspielhaus_bayreuth-n551660",
"bayreuth-gewerbegebiet-n35740",
"bayreuth-gewerbegebiet-n35760",
"bayreuth-klinik_hohe_warte-n35490",
"bayreuth-klinik_hohe_warte-n35500",
"bayreuth-klinik_hohe_warte-n35510",
"bayreuth-klinik_hohe_warte-n35520",
"bayreuth-klinik_hohe_warte-n35530",
"bayreuth-klinik_hohe_warte-n35550",
"bayreuth-klinikum_bayreuth-n35370",
"bayreuth-klinikum_bayreuth-n35400",
"bayreuth-klinikum_bayreuth-n35410",
"bayreuth-klinikum_bayreuth-n35420",
"bayreuth-klinikum_bayreuth-n35430",
"bayreuth-klinikum_bayreuth-n35460",
"bayreuth-landwirtschaftliche_lehranstalten_bayreuth-f553320",
"bayreuth-landwirtschaftliche_lehranstalten_bayreuth-f553330",
"bayreuth-oschenberg-n35800",
"bayreuth-oschenberg-n35820",
"bayreuth-oschenberg-n35840",
"bayreuth-oschenberg-n35860",
"bayreuth-weiherhaus-n35750",
"bayreuth-windrad_bei_bayreuth-n35920",
"bechhofen-golfclub_abenberg-f513800",
"bechhofen-grossenried-n326720",
"bechhofen-kleinried-n326730",
"behringersdorf-behringersdorf-c224710",
"behringersdorf-behringersdorf-c225000",
"behringersdorf-behringersdorf-c225080",
"behringersdorf-behringersdorf-c225090",
"behringersdorf-behringersdorf-c225120",
"behringersdorf-behringersdorf-c225220",
"behringersdorf-behringersdorf-c225490",
"behringersdorf-behringersdorf-c225500",
"beratzhausen-brunn_bei_beratzhausen-f520680",
"beratzhausen-buxlohe-n302550",
"beratzhausen-buxlohe-n302560",
"beratzhausen-gramteshof-n302610",
"beratzhausen-hinterthann-n302580",
"beratzhausen-hinterthann-n302590",
"beratzhausen-hinterthann-n302600",
"beratzhausen-hoelzlhof-n520880",
"beratzhausen-kompostierhof_beratzhausen-n520870",
"beratzhausen-panorama-n302630",
"beratzhausen-schwarzenthonhausen-f520670",
"beratzhausen-solarpark_kreuth-f520660",
"beratzhausen-unterlichtenberg-n301250",
"beratzhausen-vorderkreith-n520850",
"berchtesgaden-alpen-f511430",
"berchtesgaden-alpen-f511460",
"berchtesgaden-alpen-f511470",
"berchtesgaden-alpen-f511500",
"berchtesgaden-alpen-f511520",
"berchtesgaden-alpen-f511660",
"berchtesgaden-alpen-f511670",
"berchtesgaden-alpen-f511680",
"berchtesgaden-alpen-f511730",
"berchtesgaden-alpen-f511740",
"berchtesgaden-alpen-f511750",
"berchtesgaden-alpen-f511760",
"berchtesgaden-alpen-f511770",
"berchtesgaden-alpen-f511790",
"berchtesgaden-alpen-f511800",
"berchtesgaden-alpen-f511810",
"berchtesgaden-alpen-f511820",
"berchtesgaden-alpen-f511830",
"berchtesgaden-alpenvorland-f511390",
"berchtesgaden-alpenvorland-f511590",
"berchtesgaden-alpenvorland-f511600",
"berchtesgaden-anger__reitberg-f511350",
"berchtesgaden-berchdesgardener_land-f511620",
"berchtesgaden-berchdesgardener_land-f511640",
"berchtesgaden-berchdesgardener_land-f511700",
"berchtesgaden-berchdesgardener_land-f511710",
"berchtesgaden-berchdesgardener_land-f511720",
"berchtesgaden-berchdesgardener_land-f511780",
"berchtesgaden-berchtesgadener_hochthron-f511610",
"berchtesgaden-berchtesgaden-f511530",
"berchtesgaden-berchtesgaden-f511540",
"berchtesgaden-berchtesgaden-f511550",
"berchtesgaden-berchtesgaden-f511560",
"berchtesgaden-berchtesgaden-f511570",
"berchtesgaden-berchtesgaden-f511580",
"berchtesgaden-berchtesgaden-n512790",
"berchtesgaden-berchtesgaden-n512810",
"berchtesgaden-berchtesgaden-n512820",
"berchtesgaden-berchtesgaden-n512830",
"berchtesgaden-berchtesgaden-n512850",
"berchtesgaden-chiemsee-f511840",
"berchtesgaden-hintersee-f511690",
"berchtesgaden-koenigssee-n512740",
"berchtesgaden-koenigssee-n512750",
"berg-haimburg-n524840",
"berg-haslach-f522530",
"berg-oberoelsbach-n524850",
"bergrothenfels-burg_rothenfels-f371560",
"bergrothenfels-forst-f371600",
"berg-unteroelsbach-f461610",
"berg-unteroelsbach-f522510",
"berletzhof-berletzhof-f510580",
"berletzhof-berletzhof-f510590",
"bertoldsheim-donau_bei_bertoldsheim-n323440",
"bertoldsheim-donau_bei_bertoldsheim-n323610",
"bertoldsheim-laufwasserkraftwerk-n323510",
"bertoldsheim-laufwasserkraftwerk-n323560",
"bertoldsheim-laufwasserkraftwerk-n323570",
"bertoldsheim-schloss_bertoldsheim-n323500",
"bertoldsheim-schloss_bertoldsheim-n323550",
"bessenbach-waldmichelbacher_hof-f371670",
"bieg-bieg-f42690",
"birgland-matzenhof-n524740",
"birgland-riedelhof-n524720",
"birgland-umspannwerk-n524730",
"bischbrunn-sportgelaende_auf_der_kreuzhoeh-s561350",
"bischbrunn-sportgelaende_auf_der_kreuzhoeh-s561360",
"bischofswiesen-bischofswiesen-f511490",
"bodenwoehr-erzhaeuser-f522240",
"bodenwoehr-erzhaeuser-f522250",
"bodenwoehr-windmais-f522230",
"bogen-ainbrach-f521770",
"bogen-boden-n523130",
"bogen-pfelling-f521750",
"bogen-pfelling-f521760",
"bottenbach-bottenbach-f42280",
"breitenbrunn-hamberg-f510550",
"breitenbrunn-hamberg-f510560",
"breitenbrunn-hamberg-f510570",
"bruehl-bruehl_bei_heidelberg-f376980",
"brunn-babetsberg-n302470",
"brunn-brunn-f42220",
"brunn-brunn-f42230",
"brunn-brunn-n302480",
"brunn-brunn-n302500",
"brunn-konstein-n302440",
"brunn-muenchsried-n302420",
"bubenreuth-bubenreuth-c15470",
"bubenreuth-bubenreuth-c15480",
"buch_am_wald-buch_am_wald-f42770",
"buch_am_wald-buch_am_wald-f42790",
"buchenberg-buchenberg-c502660",
"buchenberg-langenmoos-c502670",
"buchen-buchen-f40160",
"buchen-buchen-f42360",
"buckenhof-buckenhof_schule-c15310",
"buckenhof-buckenhof_schule-c15380",
"buckenhof-buckenhof-c15170",
"buckenhof-buckenhof-c15180",
"buckenhof-buckenhof-c15190",
"buckenhof-buckenhof-c15200",
"buckenhof-buckenhof-c15210",
"buckenhof-buckenhof-c15220",
"buckenhof-buckenhof-c15230",
"buckenhof-buckenhof-c15240",
"buckenhof-buckenhof-c15250",
"buckenhof-buckenhof-c15260",
"buckenhof-buckenhof-c15270",
"buckenhof-buckenhof-c15290",
"buckenhof-buckenhof-c15320",
"buckenhof-buckenhof-c15330",
"buckenhof-buckenhof-c15340",
"buckenhof-buckenhof-c15350",
"buckenhof-buckenhof-c15360",
"buckenhof-buckenhof-c15370",
"buckenhof-buckenhof-c15390",
"buckenhof-buckenhof-c15400",
"buckenhof-buckenhof-c15450",
"buechenbach-buechenbach-f514320",
"buechenbach-buechenbach-f514330",
"burgbernheim-burgbernheim-f378450",
"burgbernheim-egersheim-c560780",
"burgbernheim-gewerbegebiet_ermetzhofen_knauf-c560810",
"burgbernheim-gewerbegebiet_ermetzhofen_knauf-c560840",
"burgbernheim-gewerbegebiet_im_grund-f378410",
"burgbernheim-gewerbegebiet_im_grund-f378440",
"burgbernheim-gewerbegebiet_im_grund-f378480",
"burgbernheim-gewerbegebiet_industriestrasse-f378420",
"burgbernheim-neuherberg-c560820",
"burgbernheim-pfaffenhofen-c560800",
"burgbernheim-rettenmeier_holzindustrie-f378430",
"burgbernheim-rettenmeier_holzindustrie-f378460",
"burgbernheim-rettenmeier_holzindustrie-f378470",
"burgbernheim-sonnenpark_buchheim_ii-c560720",
"burgbernheim-sonnenpark_buchheim_ii-c560730",
"burgbernheim-sonnenpark_buchheim_ii-c560750",
"burgbernheim-ziegelmuehle-c560790",
"burgenlandkreis-braunkohletagebau_profen-n352150",
"burgenlandkreis-braunkohletagebau_profen-n352160",
"burgenlandkreis-braunkohletagebau_profen-n352180",
"burgenlandkreis-braunkohletagebau_profen-n352190",
"burgenlandkreis-braunkohletagebau_profen-n352220",
"burgenlandkreis-braunkohletagebau_profen-n352230",
"burgenlandkreis-braunkohletagebau_profen-n352250",
"burgenlandkreis-braunkohletagebau_profen-n352260",
"burgenlandkreis-braunkohletagebau_profen-n352270",
"burgenlandkreis-braunkohletagebau_profen-n352280",
"burgenlandkreis-braunkohletagebau_profen-n352290",
"burgenlandkreis-braunkohletagebau_profen-n352330",
"burgenlandkreis-braunkohletagebau_profen-n352350",
"burgenlandkreis-braunkohletagebau_profen-n352360",
"burgenlandkreis-braunkohletagebau_profen-n352370",
"burghasslach-autohof_burghasslach-c563570",
"burghasslach-big_spielwarenfabrik-c563580",
"burgoberbach-schloss_sommersdorf-n326770",
"burgoberbach-schloss_sommersdorf-n326810",
"burgoberbach-schloss_sommersdorf-n326820",
"burgoberbach-schloss_sommersdorf-n326870",
"burgoberbach-schloss_sommersdorf-n326900",
"burgoberbach-schloss_sommersdorf-n326920",
"burgoberbach-schloss_sommersdorf-n326950",
"burgoberbach-schloss_sommersdorf-n326980",
"burgoberbach-schloss_sommersdorf-n327000",
"burgthann-burgthann-n303410",
"burgthann-burgthann-n303420",
"burgthann-burgthann-n303430",
"burgthann-burgthann-n303440",
"burgthann-burgthann-n510680",
"burgthann-burgthann-n510690",
"burgthann-die_kinderarche_in_burgthann-n510650",
"burgthann-die_kinderarche_in_burgthann-n510660",
"burgthann-die_kinderarche_in_burgthann-n510670",
"burgthann-ezelsdorf-n303360",
"burgthann-ezelsdorf-n303370",
"burgthann-ezelsdorf-n303380",
"burgthann-ezelsdorf-n303390",
"burgthann-historisches_treidelschiff_elfriede-f441820",
"burgthann-kapplershof-n520570",
"burgthann-kirche_christkoenig-n510700",
"burgthann-oberferrieden-n067880",
"burgthann-oberferrieden-n067990",
"burgthann-oberferrieden-n068060",
"burgthann-oberferrieden-n068090",
"burgthann-oberferrieden-n068100",
"burgthann-oberferrieden-n068120",
"burgthann-oberferrieden-n068200",
"burgthann-oberferrieden-n068270",
"burgthann-schwarzenbach-n303400",
"burgthann-sv_1928_unterferrieden-n520540",
"burgthann-sv_1928_unterferrieden-n520550",
"burgthann-unterferrieden-n30610",
"burgthann-unterferrieden-n30620",
"burgthann-unterferrieden-n520560",
"burthann-grub-f522540",
"cadolzburg-aussichtsturm-c175090",
"cadolzburg-aussichtsturm-c175110",
"cadolzburg-aussichtsturm-c175120",
"cadolzburg-aussichtsturm-c175140",
"cadolzburg-bauernhof-c162850",
"cadolzburg-blumenfeld-c163570",
"cadolzburg-blumenfeld-c163580",
"cadolzburg-cadolzburg-c157830",
"cadolzburg-cadolzburg-c157840",
"cadolzburg-cadolzburg-c157850",
"cadolzburg-cadolzburg-c157860",
"cadolzburg-cadolzburg-c157870",
"cadolzburg-cadolzburg-c157880",
"cadolzburg-cadolzburg-c157890",
"cadolzburg-cadolzburg-c157900",
"cadolzburg-cadolzburg-c157920",
"cadolzburg-cadolzburg-c157940",
"cadolzburg-cadolzburg-c157950",
"cadolzburg-cadolzburg-c157990",
"cadolzburg-cadolzburg-c158010",
"cadolzburg-cadolzburg-c162940",
"cadolzburg-cadolzburg-c163190",
"cadolzburg-cadolzburg-c163430",
"cadolzburg-cadolzburg-c163530",
"cadolzburg-cadolzburg-c163550",
"cadolzburg-cadolzburg-c175160",
"cadolzburg-cadolzburg-c175170",
"cadolzburg-cadolzburg-c175180",
"cadolzburg-cadolzburg-c246050",
"cadolzburg-cadolzburg-c246060",
"cadolzburg-cadolzburg-c246070",
"cadolzburg-cadolzburg-c246080",
"cadolzburg-cadolzburg-c246090",
"cadolzburg-cadolzburg-c246100",
"cadolzburg-cadolzburg-c246110",
"cadolzburg-cadolzburg-c246130",
"cadolzburg-cadolzburg-c246200",
"cadolzburg-cadolzburg-c246210",
"cadolzburg-cadolzburg-c246240",
"cadolzburg-cadolzburg-c246250",
"cadolzburg-cadolzburg-c246260",
"cadolzburg-cadolzburg-c246280",
"cadolzburg-cadolzburg-c246310",
"cadolzburg-cadolzburg-f392550",
"cadolzburg-cadolzburg-f392560",
"cadolzburg-cadolzburg-f392570",
"cadolzburg-cadolzburg-f392580",
"cadolzburg-cadolzburg-f392590",
"cadolzburg-cadolzburg-f392600",
"cadolzburg-cadolzburg-f392610",
"cadolzburg-cadolzburg-f392620",
"cadolzburg-cadolzburg-f392630",
"cadolzburg-cadolzburg-f392640",
"cadolzburg-cadolzburg-f392700",
"cadolzburg-cadolzburg-n264970",
"cadolzburg-cadolzburg-n264980",
"cadolzburg-egersdorf_schule-c284610",
"cadolzburg-egersdorf-c284410",
"cadolzburg-egersdorf-c284420",
"cadolzburg-egersdorf-c284440",
"cadolzburg-egersdorf-c284460",
"cadolzburg-egersdorf-c284480",
"cadolzburg-egersdorf-c284490",
"cadolzburg-egersdorf-c284510",
"cadolzburg-egersdorf-c284520",
"cadolzburg-egersdorf-c284540",
"cadolzburg-egersdorf-c284560",
"cadolzburg-egersdorf-c284570",
"cadolzburg-egersdorf-c284590",
"cadolzburg-egersdorf-c284600",
"cadolzburg-egersdorf-c284620",
"cadolzburg-egersdorf-c284660",
"cadolzburg-egersdorf-c284690",
"cadolzburg-egersdorf-c284700",
"cadolzburg-egersdorf-c284720",
"cadolzburg-egersdorf-c284770",
"cadolzburg-egersdorf-c284780",
"cadolzburg-egersdorf-c284790",
"cadolzburg-egersdorf-c284800",
"cadolzburg-egersdorf-c284810",
"cadolzburg-egersdorf-c284820",
"cadolzburg-egersdorf-f392710",
"cadolzburg-egersdorf-f392720",
"cadolzburg-egersdorf-f392730",
"cadolzburg-egersdorf-f392740",
"cadolzburg-egersdorf-f392750",
"cadolzburg-egersdorf-n264960",
"cadolzburg-erzleitenmuehle-c158070",
"cadolzburg-erzleitenmuehle-c158080",
"cadolzburg-erzleitenmuehle-c158110",
"cadolzburg-erzleitenmuehle-c163590",
"cadolzburg-erzleitenmuehle-c163600",
"cadolzburg-greimersdorf-c158020",
"cadolzburg-greimersdorf-f392650",
"cadolzburg-greimersdorf-f392660",
"cadolzburg-greimersdorf-f392680",
"cadolzburg-greimersdorf-f392690",
"cadolzburg-naehe_cadolzburg-c158130",
"cadolzburg-naehe_cadolzburg-c175200",
"cadolzburg-sportplatz_hinter_cadolzburg-c175360",
"cadolzburg-tsv_wachendorf-c284400",
"cadolzburg-vogtsreichenbach-n265070",
"cadolzburg-wachendorf-c136930",
"cadolzburg-wachendorf-c136940",
"cadolzburg-wachendorf-c136950",
"cadolzburg-wachendorf-c136960",
"cadolzburg-wachendorf-c136970",
"cadolzburg-wachendorf-c136980",
"cadolzburg-wachendorf-c136990",
"cadolzburg-wachendorf-c137000",
"cadolzburg-wachendorf-c137020",
"cadolzburg-wachendorf-c137030",
"cadolzburg-wachendorf-c137050",
"cadolzburg-wachendorf-c137140",
"cadolzburg-wachendorf-c157660",
"cadolzburg-wachendorf-c157680",
"cadolzburg-wachendorf-c157690",
"cadolzburg-wachendorf-c157710",
"cadolzburg-wachendorf-c157740",
"cadolzburg-wachendorf-c157800",
"cadolzburg-wachendorf-c215350",
"cadolzburg-wachendorf-c215380",
"cadolzburg-wachendorf-c215530",
"cadolzburg-wachendorf-c215550",
"cadolzburg-wachendorf-c223320",
"cadolzburg-wachendorf-c223340",
"cadolzburg-wachendorf-c223370",
"cadolzburg-wachendorf-c223450",
"cadolzburg-wachendorf-c223480",
"cadolzburg-wachendorf-c223500",
"cadolzburg-wachendorf-c246320",
"cadolzburg-wachendorf-c246410",
"cadolzburg-wachendorf-c246440",
"cadolzburg-wachendorf-c246450",
"cadolzburg-wachendorf-c246460",
"cadolzburg-wachendorf-c246470",
"cadolzburg-wachendorf-c246480",
"cadolzburg-wachendorf-c246500",
"cadolzburg-wachendorf-c246540",
"cadolzburg-wachendorf-c246550",
"cadolzburg-wachendorf-c284740",
"cadolzburg-wachendorf-n264950",
"cadolzburg-weiherhof-c157630",
"cadolzburg-weiherhof-c157640",
"cadolzburg-weiherhof-c157650",
"cadolzburg-weiherhof-c215320",
"cadolzburg-weiherhof-c215330",
"cadolzburg-weiherhof-c215340",
"cadolzburg-weiherhof-n264890",
"cadolzburg-weiherhof-n264900",
"cadolzburg-weiherhof-n264910",
"cadolzburg-weiherhof-n264920",
"cadolzburg-weiherhof-n264930",
"cadolzburg-weiherhof-n264940",
"cham-cham-f522170",
"cham-cham-f522180",
"cham-cham-n523570",
"cham-cham-n523640",
"cham-cham-n523650",
"cham-cham-n523670",
"cham-cham-n523680",
"cham-cham-n523710",
"cham-cham-n523780",
"cham-flusslauf_regen-n523560",
"cham-grossbergerdorf-n523790",
"cham-klosterkirche_maria_hilf-n523720",
"cham-klosterkirche_maria_hilf-n523740",
"cham-klosterkirche_maria_hilf-n523770",
"cham-michelsdorf-f522110",
"cham-michelsdorf-f522120",
"cham-michelsdorf-f522130",
"cham-pemfling-f522190",
"cham-pfarrkirche_st__jakob-n523660",
"cham-pfarrkirche_st__jakob-n523700",
"cham-pitzling-f522210",
"cham-pitzling-f522220",
"cham-stadl_bei_cham-n523540",
"cham-wellenfreizeitbad_cham-n523630",
"chiemsee-chiemsee-f511130",
"chiemsee-chiemsee-n512090",
"chiemsee-chiemsee-n512110",
"coburg-autohaus_heinrich-n357110",
"coburg-coburg_-_altstadt-n551240",
"coburg-coburg_-_dr__stocke_anlage-f552540",
"coburg-coburg_-_dr__stocke_anlage-f552550",
"coburg-coburg_-_dr__stocke_anlage-f552560",
"coburg-coburg_-_flugzeug-n551040",
"coburg-coburg_-_hauptbahnhof-n551290",
"coburg-coburg_-_marktplatz-n551260",
"coburg-coburg_-_rosengarten-f552710",
"coburg-coburg_-_schlossplatz-n551200",
"coburg-coburg_-_schlossplatz-n551210",
"coburg-coburg_-_schlossplatz-n551220",
"coburg-coburg_-_schlossplatz-n551280",
"coburg-coburg-f552580",
"coburg-coburg-f552590",
"coburg-coburg-f552600",
"coburg-coburg-f552610",
"coburg-coburg-f552620",
"coburg-coburg-f552680",
"coburg-coburg-f552690",
"coburg-coburg-f552700",
"coburg-coburg-f552720",
"coburg-coburg-f552730",
"coburg-coburg-f552740",
"coburg-coburg-n357130",
"coburg-coburg-n357140",
"coburg-coburg-n357150",
"coburg-coburg-n357160",
"coburg-coburg-n357240",
"coburg-coburg-n357260",
"coburg-coburg-n357290",
"coburg-coburg-n357300",
"coburg-coburg-n551050",
"coburg-coburg-n551060",
"coburg-coburg-n551070",
"coburg-coburg-n551080",
"coburg-coburg-n551090",
"coburg-coburg-n551110",
"coburg-coburg-n551130",
"coburg-coburg-n551140",
"coburg-coburg-n551150",
"coburg-coburg-n551160",
"coburg-coburg-n551170",
"coburg-coburg-n551180",
"coburg-coburg-n551190",
"coburg-coburg-n551270",
"coburg-flugplatz_coburg-f552430",
"coburg-flugplatz_coburg-f552570",
"coburg-flugplatz-n356920",
"coburg-flugplatz-n356930",
"coburg-itztalbruecke-n357080",
"coburg-itztalbruecke-n357090",
"coburg-landestheater-n357230",
"coburg-neuses_bei_coburg-f552750",
"coburg-panorama_richtung_norden-n276780",
"coburg-panorama_richtung_norden-n276790",
"coburg-schloss_ehrenburg-n357180",
"coburg-schloss_ehrenburg-n357210",
"coburg-schlossplatz-n357220",
"coburg-schlossplatz-n357270",
"coburg-stadtkirche_st__moritz-n357200",
"coburg-veste_coburg-f552420",
"coburg-veste_coburg-f552450",
"coburg-veste_coburg-f552460",
"coburg-veste_coburg-f552470",
"coburg-veste_coburg-f552480",
"coburg-veste_coburg-f552500",
"coburg-veste_coburg-f552510",
"coburg-veste_coburg-f552520",
"coburg-veste_coburg-f552650",
"coburg-veste_coburg-f552660",
"coburg-veste_coburg-n356940",
"coburg-veste_coburg-n356970",
"coburg-veste_coburg-n356980",
"coburg-veste_coburg-n356990",
"coburg-veste_coburg-n357010",
"coburg-veste_coburg-n357020",
"coburg-veste_coburg-n357030",
"coburg-veste_coburg-n357040",
"coburg-veste_coburg-n357050",
"coburg-veste_coburg-n357060",
"coburg-veste_coburg-n357070",
"coburg-veste_coburg-n357120",
"coburg-veste_coburg-n357250",
"coburg-veste_coburg-n551020",
"coburg-waldrich_coburg-f552630",
"colmberg-altmuehl_bei_colmberg-f42680",
"colmberg-burg_colmberg-f42620",
"colmberg-burg_colmberg-f42630",
"colmberg-burg_colmberg-f42640",
"colmberg-burg_colmberg-n272090",
"colmberg-colmberg-f40290",
"colmberg-golfplatz_colmberg-f42660",
"crailsheim-autobahn_a6_bei_crailsheim-f421000",
"crailsheim-autobahn_a6_bei_crailsheim-f421000",
"crailsheim-autobahn_a6_bei_crailsheim-f421290",
"crailsheim-autobahn_a6_bei_crailsheim-f421290",
"dachau-bundesstrasse-f481390",
"dachau-groebenried-f481410",
"dachau-klaeranlage_amperverband-n514520",
"dachau-klaeranlage_amperverband-n514530",
"dachau-mitterndorf-f481380",
"dachau-oberaugustenfeld-f483220",
"dachau-oberaugustenfeld-f483230",
"dachau-pellheim-f481330",
"dachau-schwimmbad_dachau-f481360",
"dachau-schwimmbad_dachau-f481370",
"dachau-steinbruch_bei_etzenhausen-f483240",
"dachau-steinbruch_bei_etzenhausen-f483250",
"dachau-teich_bei_pellheim-f483260",
"dachau-waldschwaigsee-f483190",
"dachau-waldschwaigsee-f483200",
"dachau-waldschwaigsee-f483210",
"dachau-waldschwaigsee-f483210",
"dachsbach-dachsbach-f37100",
"dachsbach-dachsbach-f37110",
"daiting-daiting-c500660",
"daiting-daiting-c500670",
"daiting-natterholz-c500640",
"daiting-natterholz-c500650",
"daiting-natterholz-n326080",
"dechsendorf-dechsendorfer_weiher-n276820",
"dechsendorf-dechsendorfer_weiher-n276830",
"dechsendorf-dechsendorfer_weiher-n276840",
"dechsendorf-dechsendorf-n276860",
"dechsendorf-dechsendorf-n276880",
"deggendorf-comenius_gymnasium-n522830",
"deggendorf-deggenau__bucha-f521450",
"deggendorf-deggenau__reinprechting-f521460",
"deggendorf-deggendorf_mitte-n522750",
"deggendorf-deggendorf-f521470",
"deggendorf-deggendorf-f521480",
"deggendorf-deggendorf-f521550",
"deggendorf-deggendorf-f521570",
"deggendorf-deggendorf-f521590",
"deggendorf-deggendorf-f521610",
"deggendorf-deggendorf-n522780",
"deggendorf-deggendorf-n522790",
"deggendorf-deggendorf-n522840",
"deggendorf-donaubruecke_fischerdorf-n522800",
"deggendorf-donaubruecke_fischerdorf-n522810",
"deggendorf-donauisar_klinikum_deggendorf-f521530",
"deggendorf-flohmarkt_deggendorf-n522760",
"deggendorf-gewerbegebiet_land-au-f521650",
"deggendorf-hausstein-f521440",
"deggendorf-hengersberg-f521400",
"deggendorf-man_werk_deggendorf-f521490",
"deggendorf-man_werk_deggendorf-f521500",
"deggendorf-metten-f521670",
"deggendorf-sachinger_garten-f521630",
"deggendorf-saegewerk_hengersberg-f521390",
"deggendorf-schulzentrum_deggendorf-n522820",
"deggendorf-steinbruch_bei_deggendorf-n522930",
"deggendorf-technische_hochschule_deggendorf-f521510",
"deggendorf-technische_hochschule_deggendorf-n522720",
"deggendorf-technische_hochschule_deggendorf-n522730",
"deggendorf-technische_hochschule_deggendorf-n522740",
"deggendorf-twd_fibres_gmbh-f521430",
"deining-bruecke-n301060",
"deining-bruecke-n301120",
"deining-bruecke-n301130",
"deining-deining_bahnhof-f520630",
"deining-deining-n303020",
"deining-deining-n303030",
"deining-feldweg-n301180",
"deining-grassahof-n30960",
"deining-grossalfalterbach-n301170",
"deining-hacklsberg-f520640",
"deining-leutenbach-n30990",
"deining-siegenhofen-n303040",
"deining-siegenhofen-n303050",
"deining-siegenhofen-n303060",
"deining-straussmuehle-n301000",
"deining-tauernfeld-n30970",
"deining-waltersberg-n511020",
"deining-weichselberg-n511010",
"dettendorf-dettendorf-f378570",
"dettenheim-dettenheim-c500530",
"dettenheim-dettenheim-c500540",
"dettenhofen-dettenhofen-c501300",
"dettenhofen-dettenhofen-c501330",
"dettingen_am_albuch-dettingen_am_albuch-f502020",
"dettingen_am_albuch-dettingen_am_albuch-f502040",
"dietfurt-bergnershof-c500590",
"dietfurt-tsv_dietfurt-c500580",
"dillberg-antennenanlage_dillberg-f510350",
"dillberg-antennenanlage_dillberg-f510360",
"dillberg-antennenanlage_dillberg-f510370",
"dillberg-dillberg-f510380",
"dillberg-dillberg-f510390",
"dingolfing-altstadt_dingolfing-f521050",
"dingolfing-altstadt_dingolfing-f521060",
"dingolfing-bmw_werk_dingolfing-f520990",
"dingolfing-bmw_werk_dingolfing-n521540",
"dingolfing-dingofing_kratau-f521070",
"dingolfing-dingolfing-f521020",
"dingolfing-dingolfing-f521030",
"dingolfing-dingolfing-f521040",
"dingolfing-dingolfing-n521480",
"dingolfing-flugplatz_dingolfing-f521000",
"dingolfing-flugplatz_dingolfing-f521010",
"dingolfing-isar-wald-stadion_dingolfing-n521470",
"dingolfing-isar-wald-stadion_dingolfing-n521490",
"dingolfing-laufwasserkraftwerk_dingolfing-n521530",
"dingolfing-st__johannes_kirche-n521500",
"dingolfing-st__johannes_kirche-n521510",
"doernhof-doernhof-n35240",
"donauwoerth-alte_donau-c500680",
"donauwoerth-alte_donau-f500360",
"donauwoerth-alte_donau-f500380",
"dorndorf-steudnitz-baustoffwerk-n355540",
"dorndorf-steudnitz-baustoffwerk-n355550",
"dorndorf-steudnitz-forst-n355560",
"dorndorf-steudnitz-forst-n355570",
"dossenheim-dossenheim-f376920",
"duernberg-duernberg-f551390",
"duernberg-duernberg-f551400",
"duggendorf-panorama-n302510",
"ebbs-ebbs-f512540",
"ebenried-baumschule_bei_ebenried-f421710",
"eberbach-kloster_eberbach-f374740",
"ebermannsdorf-bruder_konrad_kirche-n524390",
"ebermannsdorf-diebis-n524310",
"ebermannsdorf-diebis-n524320",
"ebermannsdorf-ebermannsdorf-n524400",
"ebermannsdorf-ipflheim-n524340",
"ebermannsdorf-pittersberg-n524260",
"ebermannsdorf-pittersberg-n524290",
"ebermannsdorf-pittersberg-n524300",
"ebermannstadt-burg_feuerstein-n267210",
"ebermannstadt-burg_feuerstein-n267220",
"ebermannstadt-burg_feuerstein-n267240",
"ebermannstadt-burg_feuerstein-n267250",
"ebermannstadt-burg_feuerstein-n267270",
"ebermannstadt-burg_feuerstein-n267280",
"ebermannstadt-burg_feuerstein-n267290",
"ebermannstadt-burg_feuerstein-n267300",
"ebermannstadt-burggaillenreuth_wiesent-f553450",
"ebermannstadt-burggaillenreuth_wiesent-f553460",
"ebermannstadt-burggaillenreuth_wiesent-f553470",
"ebermannstadt-burggaillenreuth_wiesent-f553480",
"ebermannstadt-segelflugzeug-n267340",
"ebermannstadt-segelflugzeug-n267360",
"ebermannstadt-segelflugzeug-n267410",
"ebermannstadt-unterleinleitner-n35210",
"ebersbach-ebersbach-c560160",
"eckenhaid-eckenhaid-c314130",
"eckenhaid-hormesweiher-c314080",
"eckental-eckental-f38140",
"eckental-eckental-f38150",
"eckental-eckental-f38160",
"eckental-forth-f38120",
"eckental-unterschoellenbach-c314550",
"eckental-unterschoellenbach-c314560",
"edingen-edingen-f376970",
"eggolsheim-eggolsheim-n358550",
"eggolsheim-hallerndorf-n268460",
"eggolsheim-schotterwerk-n267160",
"eggolsheim-schotterwerk-n267180",
"eggolsheim-schotterwerk-n267190",
"eggolsheim-unterstuermig-n358520",
"egloffstein-burg_egloffstein-n276140",
"egloffstein-burg_egloffstein-n276150",
"egloffstein-burg_egloffstein-n276180",
"egloffstein-burg_egloffstein-n276200",
"egloffstein-burg_egloffstein-n276260",
"egloffstein-burg_egloffstein-n276280",
"egloffstein-burg_egloffstein-n276310",
"egloffstein-burg_egloffstein-n276320",
"egloffstein-egloffsteinerhuell-n276350",
"egloffstein-egloffsteinerhuell-n276360",
"egloffstein-hundsboden-n276370",
"eglwang-zementwerk_eglwang-n520790",
"eichholz-eichholz-f40340",
"eichstaett-dom_zu_eichstaett-n322800",
"eichstaett-eichstaett_seidlkreuz-f48930",
"eichstaett-eichstaett-f48910",
"eichstaett-eichstaett-f48920",
"eichstaett-eichstaett-f48950",
"eichstaett-eichstaett-f48960",
"eichstaett-eichstaett-n322740",
"eichstaett-eichstaett-n322750",
"eichstaett-eichstaett-n322830",
"eichstaett-eichstaett-n322850",
"eichstaett-eichstaett-n322860",
"eichstaett-gewerbegebiet_eichstaett_sollnau-f48940",
"eichstaett-kreisverkehr_weissenkirchen-f48980",
"eichstaett-rebdorf-n323240",
"eichstaett-rebdorf-n323260",
"eichstaett-sandgruben_bei_eichstaett-n322690",
"eichstaett-sandgruben-n322920",
"eichstaett-schutzengelkirche-n322720",
"eichstaett-schutzengelkirche-n322730",
"eichstaett-schutzengelkirche-n322760",
"eichstaett-schutzengelkirche-n322770",
"eichstaett-schutzengelkirche-n322820",
"eichstaett-steinbruch_bei_eichstaett-f48890",
"eichstaett-willibaldsburg-n322900",
"eichstaett-willibaldsburg-n322960",
"eichstaett-willibaldsburg-n323000",
"eichstaett-willibaldsburg-n323040",
"eichstaett-willibaldsburg-n323060",
"eichstaett-willibaldsburg-n323070",
"eichstaett-willibaldsburg-n323080",
"eichstaett-willibaldsburg-n323140",
"eichstaett-willibaldsburg-n323210",
"eichstaett-willibaldsburg-n323270",
"eintuernen-metzisweiler_weiher-f501540",
"eintuernen-metzisweiler_weiher-f501550",
"eitensheim-eitensheim-f484000",
"ellingen-deutschordenschloss_ellingen-n514950",
"ellingen-deutschordenschloss_ellingen-n514970",
"ellingen-ellingen-f513770",
"ellingen-ellingen-n291270",
"ellingen-ellingen-n291280",
"ellingen-erschliessung_in_ellingen-n322070",
"ellingen-gaertnerei_ellingen-n322030",
"ellingen-karlshof-n322010",
"ellingen-residenz_ellingen-n272650",
"ellingen-residenz_ellingen-n322110",
"empfing-trauntalbruecke-n512150",
"empfing-trauntalbruecke-n512160",
"emskirchen-aurachtalbruecke_emskirchen-f46340",
"emskirchen-aurachtalbruecke_emskirchen-f46350",
"emskirchen-aurachtalbruecke_emskirchen-f46360",
"emskirchen-aurachtalbruecke_emskirchen-f46370",
"emskirchen-aurachtalbruecke-c560200",
"emskirchen-aurachtalbruecke-c560210",
"emskirchen-aurachtalbruecke-c560220",
"emskirchen-aurachtalbruecke-c560240",
"emskirchen-aurachtalbruecke-n327620",
"emskirchen-aurachtalbruecke-n327630",
"emskirchen-aurachtalbruecke-n327640",
"emskirchen-baumschatten_bei_emskirchen-f46510",
"emskirchen-brunn-n327670",
"emskirchen-brunn-n327680",
"emskirchen-duerrnbuch-n327590",
"emskirchen-emskirchen-c560250",
"emskirchen-emskirchen-c560260",
"emskirchen-emskirchen-f46380",
"emskirchen-emskirchen-f46390",
"emskirchen-emskirchen-n327650",
"emskirchen-finkenmuehle-f43140",
"emskirchen-gewerbegebiet_emskirchen-f42270",
"emskirchen-gewerbegebiet_nord-f43100",
"emskirchen-gewerbegebiet_nord-f43110",
"emskirchen-kirche_bei_emskirchen-f46470",
"emskirchen-labyrinth_bei_emskirchen-f46480",
"emskirchen-labyrinth_bei_emskirchen-f46480",
"emskirchen-mausdorf-n265240",
"emskirchen-neidhardswinden-c560270",
"emskirchen-neidhardswinden-c560280",
"emskirchen-neidhardswinden-c560290",
"emskirchen-neidhardswinden-c560310",
"emskirchen-neidhardswinden-f46420",
"emskirchen-neuschauerberg-f43120",
"emskirchen-pirkach-n265220",
"emskirchen-pirkach-n265230",
"emskirchen-weiler_bei_emskirchen-f46520",
"engelsberg-eigelwald-f511010",
"engelsberg-schmidseidl-f511090",
"engelsberg-schmidseidl-f511100",
"engelsberg-schmidseidl-f511110",
"eppstein-bremthal-f374510",
"erbendorf-seltmann_porzelanfabrik-n550140",
"erbendorf-seltmann_porzelanfabrik-n550150",
"erlabrunn-erlabrunn-s560920",
"erlabrunn-weinberg_bei_erlabrunn-s560890",
"erlabrunn-weinberg_bei_erlabrunn-s560900",
"erlabrunn-weinberg_bei_erlabrunn-s560910",
"erlangen-alterlangen-c222090",
"erlangen-alterlangen-c255000",
"erlangen-alterlangen-n26420",
"erlangen-am_europakanal-c255060",
"erlangen-anschlussstelle_erlangen-west-s562470",
"erlangen-anschlussstelle_erlangen-west-s562480",
"erlangen-arcaden-c15850",
"erlangen-arcaden-n067550",
"erlangen-architektur-c1680",
"erlangen-arevapark-cc19490",
"erlangen-arevapark-cc19500",
"erlangen-autobahn_a3_-_brueckenbau-n2940",
"erlangen-autobahn_a3_-_brueckenbau-n2950",
"erlangen-autobahn_a3_bei_erlangen-f427000",
"erlangen-autobahn_a3_bei_erlangen-f427130",
"erlangen-autobahn_a3_bei_tennenlohe-f485200",
"erlangen-autobahn_a3-n343270",
"erlangen-autobahn_stau-cb940",
"erlangen-autobahnbaustelle_bei_hessdorf-f472690",
"erlangen-autobahnbaustelle_bei_hessdorf-f485430",
"erlangen-autobahnbruecke_a3___a73-c506110",
"erlangen-autobahnbruecke_a3_erlangen-n525690",
"erlangen-autobahnbruecke_a3-c506230",
"erlangen-autobahnbruecke_a3-c506250",
"erlangen-autobahnbruecke-c246710",
"erlangen-autobahn-c1570",
"erlangen-autobahnkreut_a3___a73-f385040",
"erlangen-autobahnkreut_a3___a73-f435670",
"erlangen-autobahnkreuz_a3___a73-c199550",
"erlangen-autobahnkreuz_a3___a73-c199600",
"erlangen-autobahnkreuz_a3___a73-c254960",
"erlangen-autobahnkreuz_a3___a73-c506080",
"erlangen-autobahnkreuz_a3___a73-c506120",
"erlangen-autobahnkreuz_a3___a73-c506130",
"erlangen-autobahnkreuz_a3___a73-c564890",
"erlangen-autobahnkreuz_a3___a73-f404120",
"erlangen-autobahnkreuz_a3___a73-f404150",
"erlangen-autobahnkreuz_a3___a73-f404420",
"erlangen-autobahnkreuz_a3___a73-f404430",
"erlangen-autobahnkreuz_a3___a73-f426950",
"erlangen-autobahnkreuz_a3___a73-f426960",
"erlangen-autobahnkreuz_a3___a73-f426970",
"erlangen-autobahnkreuz_a3___a73-f426980",
"erlangen-autobahnkreuz_a3___a73-f427030",
"erlangen-autobahnkreuz_a3___a73-f427040",
"erlangen-autobahnkreuz_a3___a73-f427210",
"erlangen-autobahnkreuz_a3___a73-f427220",
"erlangen-autobahnkreuz_a3___a73-f435460",
"erlangen-autobahnkreuz_a3___a73-f435470",
"erlangen-autobahnkreuz_a3___a73-f435550",
"erlangen-autobahnkreuz_a3___a73-f435560",
"erlangen-autobahnkreuz_a3___a73-f435690",
"erlangen-autobahnkreuz_a3___a73-f435730",
"erlangen-autobahnkreuz_a3___a73-f435910",
"erlangen-autobahnkreuz_a3___a73-f435930",
"erlangen-autobahnkreuz_a3___a73-f435940",
"erlangen-autobahnkreuz_a3___a73-f456310",
"erlangen-autobahnkreuz_a3___a73-f456410",
"erlangen-autobahnkreuz_a3___a73-f456510",
"erlangen-autobahnkreuz_a3___a73-f464070",
"erlangen-autobahnkreuz_a3___a73-f494530",
"erlangen-autobahnkreuz_a3___a73-f494540",
"erlangen-autobahnkreuz_a3___a73-f514250",
"erlangen-autobahnkreuz_a3___a73-f514260",
"erlangen-autobahnkreuz_a3___a73-f514270",
"erlangen-autobahnkreuz_a3___a73-f514280",
"erlangen-autobahnkreuz_a3___a73-f541250",
"erlangen-autobahnkreuz_a3___a73-n078020",
"erlangen-autobahnkreuz_a3___a73-n078040",
"erlangen-autobahnkreuz_a3___a73-n26570",
"erlangen-autobahnkreuz_a3___a73-n2960",
"erlangen-autobahnkreuz_a3___a73-n296220",
"erlangen-autobahnkreuz_a3___a73-n296300",
"erlangen-autobahnkreuz_a3___a73-n296350",
"erlangen-autobahnkreuz_a3___a73-n296430",
"erlangen-autobahnkreuz_a3___a73-n296440",
"erlangen-autobahnkreuz_a3___a73-n296450",
"erlangen-autobahnkreuz_a3___a73-n3080",
"erlangen-autobahnkreuz_a3___a73-n510300",
"erlangen-autobahnkreuz_a3___a73-n525700",
"erlangen-autobahnkreuz_erlangen_tennenlohe-f510120",
"erlangen-autobahnkreuz_erlangen-tennenlohe-f404060",
"erlangen-autobahnkreuz-c2480",
"erlangen-autobahnkreuz-c2490",
"erlangen-autobahnmeisterei_erlangen-c506040",
"erlangen-autobahnmeisterei_erlangen-f404080",
"erlangen-autobahnmeisterei-c151490",
"erlangen-autobahnmeisterei-f426920",
"erlangen-autobahnmeisterei-n3240",
"erlangen-bauernhof-n2990",
"erlangen-baumaschinen_case-cb9180",
"erlangen-baustelle_krankenhaus-c2450",
"erlangen-baustoffe-c21320",
"erlangen-bayerisches_landesamt_fuer_gesundheit_und_lebensmittelsicherheit-n525720",
"erlangen-bei_eltersdorf-f494480",
"erlangen-bei_eltersdorf-f494490",
"erlangen-bei_erlangen-c112170",
"erlangen-bei_erlangen-c255030",
"erlangen-bei_erlangen-cc26610",
"erlangen-bei_erlangen-f385200",
"erlangen-bergkirchweih-nn68200",
"erlangen-berufsschule-c16260",
"erlangen-berufsschule-c314740",
"erlangen-bruck-f494580",
"erlangen-brucklyn_factory-f494550",
"erlangen-bruck-n074440",
"erlangen-bruecke_a3-n249320",
"erlangen-bruecke_a3-n249330",
"erlangen-bruecke_a3-n249360",
"erlangen-bruecke_bei_kosbach-f48110",
"erlangen-bruecke_erlangen_west-c314940",
"erlangen-bruecke_main-donau-kanal-c254970",
"erlangen-bruecke-c21210",
"erlangen-bruecke-c21230",
"erlangen-bruecke-c21250",
"erlangen-bruecke-c21270",
"erlangen-bruecke-c21290",
"erlangen-brueckenbau_kleingruendlach-c151460",
"erlangen-brueckenbau-c112120",
"erlangen-brueckenbau-c151360",
"erlangen-brueckenbau-c151370",
"erlangen-brueckenbau-c151380",
"erlangen-brueckenbau-c151390",
"erlangen-brueckenbau-cb99990",
"erlangen-brueckentransport-cb9220",
"erlangen-brueckentransport-cb9240",
"erlangen-buckenhof-c314660",
"erlangen-buckenhof-c314670",
"erlangen-buckenhof-c314680",
"erlangen-buechenbach-b1860",
"erlangen-buechenbach-b1870",
"erlangen-buechenbach-c088880",
"erlangen-buechenbach-c246800",
"erlangen-buechenbach-c246840",
"erlangen-buechenbach-c255040",
"erlangen-buechenbach-c255050",
"erlangen-buechenbach-c285220",
"erlangen-buechenbach-c506190",
"erlangen-buechenbach-c506200",
"erlangen-buechenbach-c506220",
"erlangen-buechenbach-c564990",
"erlangen-buechenbach-c565000",
"erlangen-buechenbach-c565010",
"erlangen-buechenbach-cc34230",
"erlangen-buechenbacher_damm-c506170",
"erlangen-buechenbacher_damm-c564970",
"erlangen-buechenbacher_freibad-n074340",
"erlangen-buechenbacher_freibad-n074360",
"erlangen-buechenbach-f385150",
"erlangen-buechenbach-f385180",
"erlangen-buechenbach-f485390",
"erlangen-buechenbach-f541330",
"erlangen-buechenbach-f541340",
"erlangen-buechenbach-f550050",
"erlangen-buechenbach-n249480",
"erlangen-buechenbach-n249520",
"erlangen-buechenbach-n26100",
"erlangen-buechenbach-n2670",
"erlangen-buechenbach-n2680",
"erlangen-buechenbach-n269250",
"erlangen-buechenbach-n269260",
"erlangen-buechenbach-n269270",
"erlangen-buechenbach-n269280",
"erlangen-buechenbach-n269290",
"erlangen-buechenbach-n269300",
"erlangen-buechenbach-n269310",
"erlangen-buechenbach-n296500",
"erlangen-buechenbach-n296520",
"erlangen-buechenbach-n296530",
"erlangen-buechenbach-n296550",
"erlangen-buechenbach-n296570",
"erlangen-buechenbach-n296580",
"erlangen-buechenbach-n328250",
"erlangen-buechenbach-n510230",
"erlangen-buechenbach-n510240",
"erlangen-buntes_haus-c15140",
"erlangen-burgberg_erlangen-f494630",
"erlangen-burgberg_erlangen-f494640",
"erlangen-cat_baufahrzeuge-c222240",
"erlangen-city-c12100",
"erlangen-city-c12140",
"erlangen-dechsendorf-c222110",
"erlangen-dechsendorf-c2430",
"erlangen-dechsendorf-c2440",
"erlangen-dechsendorf-c255090",
"erlangen-dechsendorfer_weiher-n304580",
"erlangen-dechsendorf-f494770",
"erlangen-dechsendorf-f494780",
"erlangen-dechsendorf-f494790",
"erlangen-dechsendorf-f553710",
"erlangen-dechsendorf-f553720",
"erlangen-dechsendorf-n249530",
"erlangen-dechsendorf-n249550",
"erlangen-dechsendorf-n249560",
"erlangen-dechsendorf-n296640",
"erlangen-dechsendorf-n304590",
"erlangen-dechsendorf-n304600",
"erlangen-dechsendorf-n304610",
"erlangen-dechsendorf-n525880",
"erlangen-dechsendorf-n525910",
"erlangen-dhl_frauenaurach-f541260",
"erlangen-egelanger-f494740",
"erlangen-eltersdorf_rehau-c112020",
"erlangen-eltersdorf_rehau-c125060",
"erlangen-eltersdorf-c112040",
"erlangen-eltersdorf-c112090",
"erlangen-eltersdorf-c222040",
"erlangen-eltersdorf-c254890",
"erlangen-eltersdorf-c254910",
"erlangen-eltersdorf-c254920",
"erlangen-eltersdorf-c506060",
"erlangen-eltersdorf-c564870",
"erlangen-eltersdorf-f385000",
"erlangen-eltersdorf-f385020",
"erlangen-eltersdorf-f464040",
"erlangen-eltersdorf-f494500",
"erlangen-eltersdorf-f494510",
"erlangen-eltersdorf-f514240",
"erlangen-eltersdorf-f550100",
"erlangen-eltersdorf-f550120",
"erlangen-eltersdorf-f550130",
"erlangen-eltersdorf-n249280",
"erlangen-eltersdorf-n249300",
"erlangen-erlangen__schallershof-f485370",
"erlangen-erlangen_bruck-c506160",
"erlangen-erlangen_bruck-f41650",
"erlangen-erlangen_bruck-f435600",
"erlangen-erlangen_bruck-f494550",
"erlangen-erlangen_bruck-f494560",
"erlangen-erlangen_innenstadt-n525790",
"erlangen-erlangen_nord-f494690",
"erlangen-erlangen_ost-f494590",
"erlangen-erlangen_panorama-f464170",
"erlangen-erlangen_panorama-f465600",
"erlangen-erlangen_schallershof-f41660",
"erlangen-erlangen_schallershof-f41690",
"erlangen-erlangen_schallershof-f436050",
"erlangen-erlangen_schallershof-f541280",
"erlangen-erlangen_schallershof-f541300",
"erlangen-erlangen-b18100",
"erlangen-erlangen-b18110",
"erlangen-erlangen-b18120",
"erlangen-erlangen-b18130",
"erlangen-erlangen-b18140",
"erlangen-erlangen-b18150",
"erlangen-erlangen-b18170",
"erlangen-erlangen-b18200",
"erlangen-erlangen-b18210",
"erlangen-erlangen-b18230",
"erlangen-erlangen-b18240",
"erlangen-erlangen-b18270",
"erlangen-erlangen-b1880",
"erlangen-erlangen-buechenbach-f404510",
"erlangen-erlangen-buechenbach-f555860",
"erlangen-erlangen-buechenbach-f555870",
"erlangen-erlangen-buechenbach-f555880",
"erlangen-erlangen-c12120",
"erlangen-erlangen-c151000",
"erlangen-erlangen-c151030",
"erlangen-erlangen-c151040",
"erlangen-erlangen-c151070",
"erlangen-erlangen-c151080",
"erlangen-erlangen-c151090",
"erlangen-erlangen-c151100",
"erlangen-erlangen-c151140",
"erlangen-erlangen-c151170",
"erlangen-erlangen-c151190",
"erlangen-erlangen-c151200",
"erlangen-erlangen-c151230",
"erlangen-erlangen-c151240",
"erlangen-erlangen-c151250",
"erlangen-erlangen-c151260",
"erlangen-erlangen-c151270",
"erlangen-erlangen-c15520",
"erlangen-erlangen-c15530",
"erlangen-erlangen-c15540",
"erlangen-erlangen-c15550",
"erlangen-erlangen-c15560",
"erlangen-erlangen-c15580",
"erlangen-erlangen-c15590",
"erlangen-erlangen-c15600",
"erlangen-erlangen-c15610",
"erlangen-erlangen-c15620",
"erlangen-erlangen-c15650",
"erlangen-erlangen-c15660",
"erlangen-erlangen-c15670",
"erlangen-erlangen-c15690",
"erlangen-erlangen-c15700",
"erlangen-erlangen-c15710",
"erlangen-erlangen-c15730",
"erlangen-erlangen-c15740",
"erlangen-erlangen-c15750",
"erlangen-erlangen-c15760",
"erlangen-erlangen-c15770",
"erlangen-erlangen-c15780",
"erlangen-erlangen-c15790",
"erlangen-erlangen-c15800",
"erlangen-erlangen-c15810",
"erlangen-erlangen-c15820",
"erlangen-erlangen-c15840",
"erlangen-erlangen-c15870",
"erlangen-erlangen-c15890",
"erlangen-erlangen-c15900",
"erlangen-erlangen-c159090",
"erlangen-erlangen-c15920",
"erlangen-erlangen-c15940",
"erlangen-erlangen-c15950",
"erlangen-erlangen-c15980",
"erlangen-erlangen-c15990",
"erlangen-erlangen-c16140",
"erlangen-erlangen-c16290",
"erlangen-erlangen-c188650",
"erlangen-erlangen-c188660",
"erlangen-erlangen-c188680",
"erlangen-erlangen-c188690",
"erlangen-erlangen-c188720",
"erlangen-erlangen-c188740",
"erlangen-erlangen-c188750",
"erlangen-erlangen-c188770",
"erlangen-erlangen-c188780",
"erlangen-erlangen-c199510",
"erlangen-erlangen-c199520",
"erlangen-erlangen-c199530",
"erlangen-erlangen-c199630",
"erlangen-erlangen-c208610",
"erlangen-erlangen-c208640",
"erlangen-erlangen-c208650",
"erlangen-erlangen-c208660",
"erlangen-erlangen-c208670",
"erlangen-erlangen-c208690",
"erlangen-erlangen-c208700",
"erlangen-erlangen-c208710",
"erlangen-erlangen-c208720",
"erlangen-erlangen-c208730",
"erlangen-erlangen-c208850",
"erlangen-erlangen-c208860",
"erlangen-erlangen-c208880",
"erlangen-erlangen-c208970",
"erlangen-erlangen-c208980",
"erlangen-erlangen-c2460",
"erlangen-erlangen-c2470",
"erlangen-erlangen-c28290",
"erlangen-erlangen-c314750",
"erlangen-erlangen-c314760",
"erlangen-erlangen-c314770",
"erlangen-erlangen-c314780",
"erlangen-erlangen-c314830",
"erlangen-erlangen-c314840",
"erlangen-erlangen-c564980",
"erlangen-erlangen-cb910",
"erlangen-erlangen-cc19550",
"erlangen-erlangen-cc19560",
"erlangen-erlangen-cc19570",
"erlangen-erlangen-cc31190",
"erlangen-erlangen-cc31200",
"erlangen-erlangen-elterdorf-c564860",
"erlangen-erlangen-eltersdorf-f404320",
"erlangen-erlangen-f404480",
"erlangen-erlangen-f41620",
"erlangen-erlangen-f41630",
"erlangen-erlangen-f41640",
"erlangen-erlangen-f41670",
"erlangen-erlangen-f426910",
"erlangen-erlangen-f427330",
"erlangen-erlangen-f427340",
"erlangen-erlangen-f427350",
"erlangen-erlangen-f427360",
"erlangen-erlangen-f427370",
"erlangen-erlangen-f427380",
"erlangen-erlangen-f427390",
"erlangen-erlangen-f427400",
"erlangen-erlangen-f427410",
"erlangen-erlangen-f456690",
"erlangen-erlangen-f456710",
"erlangen-erlangen-f485320",
"erlangen-erlangen-f485340",
"erlangen-erlangen-f494700",
"erlangen-erlangen-f494710",
"erlangen-erlangen-f514300",
"erlangen-erlangen-f522640",
"erlangen-erlangen-f522650",
"erlangen-erlangen-n26140",
"erlangen-erlangen-n26150",
"erlangen-erlangen-n26160",
"erlangen-erlangen-n26170",
"erlangen-erlangen-n26210",
"erlangen-erlangen-n26220",
"erlangen-erlangen-n26230",
"erlangen-erlangen-n26260",
"erlangen-erlangen-n26270",
"erlangen-erlangen-n26280",
"erlangen-erlangen-n26290",
"erlangen-erlangen-n26300",
"erlangen-erlangen-n26310",
"erlangen-erlangen-n26320",
"erlangen-erlangen-n26330",
"erlangen-erlangen-n26350",
"erlangen-erlangen-n26360",
"erlangen-erlangen-n26400",
"erlangen-erlangen-n26430",
"erlangen-erlangen-n26440",
"erlangen-erlangen-n26450",
"erlangen-erlangen-n26460",
"erlangen-erlangen-n26480",
"erlangen-erlangen-n26490",
"erlangen-erlangen-n26500",
"erlangen-erlangen-n26510",
"erlangen-erlangen-n26520",
"erlangen-erlangen-n26530",
"erlangen-erlangen-n26550",
"erlangen-erlangen-n296480",
"erlangen-erlangen-n296610",
"erlangen-erlangen-n304040",
"erlangen-erlangen-n304050",
"erlangen-erlangen-n304090",
"erlangen-erlangen-n304100",
"erlangen-erlangen-n304110",
"erlangen-erlangen-n304120",
"erlangen-erlangen-n304130",
"erlangen-erlangen-n304140",
"erlangen-erlangen-n304150",
"erlangen-erlangen-n304160",
"erlangen-erlangen-n304170",
"erlangen-erlangen-n304190",
"erlangen-erlangen-n304200",
"erlangen-erlangen-n304210",
"erlangen-erlangen-n304220",
"erlangen-erlangen-n304230",
"erlangen-erlangen-n304240",
"erlangen-erlangen-n304250",
"erlangen-erlangen-n304280",
"erlangen-erlangen-n304290",
"erlangen-erlangen-n304300",
"erlangen-erlangen-n304310",
"erlangen-erlangen-n304320",
"erlangen-erlangen-n304340",
"erlangen-erlangen-n304360",
"erlangen-erlangen-n304370",
"erlangen-erlangen-n304380",
"erlangen-erlangen-n304390",
"erlangen-erlangen-n304400",
"erlangen-erlangen-n304410",
"erlangen-erlangen-n304420",
"erlangen-erlangen-n304430",
"erlangen-erlangen-n304440",
"erlangen-erlangen-n304450",
"erlangen-erlangen-n304460",
"erlangen-erlangen-n304480",
"erlangen-erlangen-n304510",
"erlangen-erlangen-n304540",
"erlangen-erlangen-n304550",
"erlangen-erlangen-n525760",
"erlangen-erlangen-stadtrandsiedlung-f404490",
"erlangen-erlanger_arcaden-f41480",
"erlangen-erlanger_bergkirchweih-f494670",
"erlangen-erlanger_hoefe-f41510",
"erlangen-erschliessung_in_hessdorf-f436110",
"erlangen-erschliessung-c151210",
"erlangen-erschliessung-n365120",
"erlangen-estw_erlanger_stadtwerke_ag-f41430",
"erlangen-estw_erlanger_stadtwerke_ag-f41440",
"erlangen-estw_erlanger_stadtwerke_ag-f41450",
"erlangen-estw_erlanger_stadtwerke_ag-f41470",
"erlangen-estw_erlanger_stadtwerke_ag-f41500",
"erlangen-estw_erlanger_stadtwerke-f522660",
"erlangen-fabrik-c151310",
"erlangen-fabrik-c151340",
"erlangen-fertighauswelt_nuernberg-c222120",
"erlangen-fertighauswelt_nuernberg-c255110",
"erlangen-fertighauswelt_nuernberg-c255120",
"erlangen-fertighauswelt_nuernberg-c285250",
"erlangen-fertighauswelt_nuernberg-c285280",
"erlangen-fertighauswelt_nuernberg-c285290",
"erlangen-fertighauswelt_nuernberg-c285300",
"erlangen-fertighauswelt_nuernberg-c285310",
"erlangen-fertighauswelt_nuernberg-n078230",
"erlangen-fertighauswelt_nuernberg-n269320",
"erlangen-fertighauswelt_nuernberg-n269330",
"erlangen-fertighauswelt_nuernberg-n276910",
"erlangen-fertighauswelt_nuernberg-n296670",
"erlangen-fertighauswelt_nuernberg-n296680",
"erlangen-fertighauswelt_nuernberg-n296690",
"erlangen-fertighauswelt_nuernberg-n296700",
"erlangen-fertighauswelt_nuernberg-n296710",
"erlangen-flugzeugschatten-f472800",
"erlangen-frankenschnellweg-f472630",
"erlangen-frauenaurach-f41210",
"erlangen-frauenaurach-f41260",
"erlangen-frauenaurach-f41370",
"erlangen-frauenaurach-f41380",
"erlangen-frauenaurach-f41390",
"erlangen-frauenaurach-f41400",
"erlangen-frauenaurach-f41410",
"erlangen-frauenaurach-f41420",
"erlangen-frauenaurach-f541270",
"erlangen-frauenaurach-n249420",
"erlangen-fraunhofer_institut_fuer_integrierte_schaltungen__iis_-f485240",
"erlangen-fritz_baustoffe_gmbh___co__kg-c500160",
"erlangen-fsv_erlangen_bruck-c564900",
"erlangen-gewerbegebiet_hutacker-n249440",
"erlangen-gewerbegebiet_weinstrasse-f472590",
"erlangen-gewerbegebiet_zeppelinstrasse-n249370",
"erlangen-gewerbegebiet_zeppelinstrasse-n249380",
"erlangen-gewerbegebiet_zeppelinstrasse-n249400",
"erlangen-gewerbepark_hessdorf-n304630",
"erlangen-grosser_bischofsweiher-f553700",
"erlangen-grossseebach-n304650",
"erlangen-haeusling-f550040",
"erlangen-haeusling-n3010",
"erlangen-haeusling-n328210",
"erlangen-hafen_erlangen-f472650",
"erlangen-hafen_erlangen-f472650",
"erlangen-hafen_erlangen-f472660",
"erlangen-hafen_erlangen-f472660",
"erlangen-hafen_erlangen-f485380",
"erlangen-hafen_erlangen-n510260",
"erlangen-hafen_erlangen-n510270",
"erlangen-hafen-c151430",
"erlangen-hafen-c216380",
"erlangen-hafen-n249450",
"erlangen-haundorf-f550030",
"erlangen-heilig_kreuz_kirche-f494580",
"erlangen-heinrich-kirchner-schule-f541320",
"erlangen-herzobase-f490030",
"erlangen-hessdorf-c216470",
"erlangen-hessdorf-c25170",
"erlangen-hessdorf-c285260",
"erlangen-hessdorf-c285270",
"erlangen-hessdorf-f553730",
"erlangen-hessdorf-f553740",
"erlangen-hessdorf-f553750",
"erlangen-hessdorf-f553760",
"erlangen-hessdorf-n249600",
"erlangen-hessdorf-n249610",
"erlangen-hessdorf-n249630",
"erlangen-hochhaus-c16100",
"erlangen-hornbach-c151330",
"erlangen-hornbach-c151350",
"erlangen-huetendorf-n2490",
"erlangen-huettendorf-c222300",
"erlangen-huettendorf-f48160",
"erlangen-huettendorf-f500150",
"erlangen-in_der_reuth-c565020",
"erlangen-industrie-cb9280",
"erlangen-industriegebiet_eltersdorf_weinstrasse-n077990",
"erlangen-industriepark_frauenaurach-f41190",
"erlangen-industriepark_frauenaurach-f41200",
"erlangen-industriepark_frauenaurach-f550070",
"erlangen-industriepark_frauenaurach-f550090",
"erlangen-industriepark_frauenaurach-n2930",
"erlangen-karpfenweiher-b1850",
"erlangen-karpfenweiher-c112300",
"erlangen-karpfenweiher-cc26690",
"erlangen-karpfenweiher-f385350",
"erlangen-karpfenweiher-f465800",
"erlangen-kirche_bei_erlangen-f485390",
"erlangen-kirche-c208930",
"erlangen-kirche-f41650",
"erlangen-klaerwerk_erlangen-n525830",
"erlangen-klaerwerk-c15500",
"erlangen-kosbach-c21110",
"erlangen-kosbach-c21130",
"erlangen-kosbach-c246860",
"erlangen-kosbach-f48120",
"erlangen-kosbach-f490050",
"erlangen-kosbach-f490070",
"erlangen-kosbach-n343260",
"erlangen-kosbach-n510220",
"erlangen-kreisverkehr-c16230",
"erlangen-kreisverkehr-c16240",
"erlangen-kriegenbrunn-f48150",
"erlangen-kriegenbrunn-f555540",
"erlangen-landratsamt-f41480",
"erlangen-landwirtschaft-c246700",
"erlangen-landwirtschaft-f385380",
"erlangen-landwirtschaft-f385390",
"erlangen-landwirtschaft-n269400",
"erlangen-landwirtschaft-n269410",
"erlangen-langensendelbach-n33190",
"erlangen-langer_johann-n525800",
"erlangen-lkw_unfall_-_bierkaesten-cb9100",
"erlangen-lkw_unfall_-_bierkaesten-cb9140",
"erlangen-luftbildarchaeologie-n29100",
"erlangen-main_donau_kanal-f555510",
"erlangen-main_donau_kanal-f555530",
"erlangen-main-donau-kanal_bei_erlangen-f464100",
"erlangen-main-donau-kanal_bei_erlangen-f464110",
"erlangen-main-donau-kanal_bei_erlangen-f465690",
"erlangen-main-donau-kanal_bei_erlangen-f465710",
"erlangen-main-donau-kanal_bei_erlangen-f465720",
"erlangen-main-donau-kanal_bei_erlangen-f465750",
"erlangen-main-donau-kanal-c221980",
"erlangen-main-donau-kanal-c222020",
"erlangen-main-donau-kanal-f41680",
"erlangen-minderleinsmuehle_bei_dormitz-c314580",
"erlangen-minderleinsmuehle_bei_dormitz-c314610",
"erlangen-mischwald-n249700",
"erlangen-moehrendorf-f494760",
"erlangen-moehrendorf-f553690",
"erlangen-moehrendorf-n249490",
"erlangen-moehrendorf-n249500",
"erlangen-moehrendorf-n525870",
"erlangen-montessori-kindergarten_in_erlangen-f472670",
"erlangen-musterhausdorf-f385290",
"erlangen-neubau-c15420",
"erlangen-neubau-c15440",
"erlangen-neubausiedlung-cb9390",
"erlangen-neuer_markt_erlangen-f41520",
"erlangen-orangerie-c314800",
"erlangen-panorama-c112190",
"erlangen-panorama-c254980",
"erlangen-panorama-c254990",
"erlangen-photovoltaikanlage-f485350",
"erlangen-photovoltaikanlage-n525680",
"erlangen-photovoltaik-c222160",
"erlangen-photovoltaik-c222180",
"erlangen-produktionshalle-c112280",
"erlangen-rapsfeld-n269390",
"erlangen-rast_autobahn-c116360",
"erlangen-rastplatz_weisser_graben-f490120",
"erlangen-rastplatz_weisser_graben-f490130",
"erlangen-raststaette_aurach_sued-n33900",
"erlangen-regnitzbruecke-f456550",
"erlangen-regnitzbruecke-f490100",
"erlangen-regnitz-c564930",
"erlangen-regnitz-f472640",
"erlangen-rehau-f404600",
"erlangen-reutles-f490110",
"erlangen-roethelheimpark-c314710",
"erlangen-roethelheimpark-c314720",
"erlangen-schallershof-c564950",
"erlangen-schallershof-f490080",
"erlangen-schallershof-f490090",
"erlangen-schallershof-f490090",
"erlangen-schallershof-n510280",
"erlangen-schiff-c131900",
"erlangen-schlachthof_erlangen-f494610",
"erlangen-schlachthof_erlangen-f494730",
"erlangen-schleuse_-_kriegenbrunn-c222270",
"erlangen-schleuse_erlangen-n525860",
"erlangen-schleuse_kriegbrunn-f404590",
"erlangen-schleuse_kriegbrunn-f41230",
"erlangen-schleuse_kriegbrunn-f41240",
"erlangen-schleuse_kriegbrunn-f41250",
"erlangen-schleuse_kriegbrunn-f41270",
"erlangen-schleuse-c314910",
"erlangen-schleuse-n078220",
"erlangen-schleuse-n304470",
"erlangen-schleuse-nn68340",
"erlangen-schleusenstrasse-c222010",
"erlangen-schloss_atzelsberg-n33160",
"erlangen-schloss_atzelsberg-n33180",
"erlangen-schloss_atzelsberg-n33210",
"erlangen-schloss_erlangen-n26120",
"erlangen-schloss_erlangen-n26130",
"erlangen-schloss_erlangen-n26180",
"erlangen-schloss_erlangen-n26190",
"erlangen-schloss_erlangen-n26240",
"erlangen-schloss_erlangen-n26250",
"erlangen-schloss_erlangen-n26340",
"erlangen-schloss_erlangen-n26370",
"erlangen-schloss_erlangen-n26380",
"erlangen-schloss_erlangen-n26390",
"erlangen-schlossgarten-c16160",
"erlangen-schlossgarten-c16180",
"erlangen-schlossgarten-c16200",
"erlangen-schlossgarten-c16220",
"erlangen-schlossgarten-n26200",
"erlangen-schnee-c209040",
"erlangen-sebaldussiedlung-n304080",
"erlangen-senkrechtaufnahme-cc31210",
"erlangen-siemens_campus_erlangen-c506150",
"erlangen-siemens_campus-f41540",
"erlangen-siemens_campus-f41560",
"erlangen-siemens_campus-f41570",
"erlangen-siemens_campus-f41580",
"erlangen-siemens_campus-f41590",
"erlangen-siemens_campus-f41600",
"erlangen-siemens_campus-f41610",
"erlangen-siemens_campus-f494570",
"erlangen-siemens_campus-f514290",
"erlangen-siemens_campus-f522600",
"erlangen-siemens_campus-f522610",
"erlangen-siemens_campus-n525710",
"erlangen-siemens_campus-n525740",
"erlangen-siemens_campus-n525750",
"erlangen-siemens_erlangen-f465630",
"erlangen-siemens-f41550",
"erlangen-siemens-n067570",
"erlangen-solarhaus_rehau-f541220",
"erlangen-spardorf-c314650",
"erlangen-spargelfeld-f427490",
"erlangen-sperber_spedition-n144020",
"erlangen-sperber_spedition-n144030",
"erlangen-sportanlage_sc_eltersdorf-f456270",
"erlangen-sportboothafen_suess-n525840",
"erlangen-st__heinrich_kirche-c314870",
"erlangen-st__matthaeuskirche-f41530",
"erlangen-st__peter_und_paul_kirche-f385100",
"erlangen-st__peter_und_paul_kirche-f385120",
"erlangen-steudach-c246790",
"erlangen-steudach-n3020",
"erlangen-strommasten-c216350",
"erlangen-stromtrasse-c565040",
"erlangen-stromversorgung-f385260",
"erlangen-tennenlohe-c131940",
"erlangen-tennenlohe-c131950",
"erlangen-tennenlohe-c131980",
"erlangen-tennenlohe-c132030",
"erlangen-tennenlohe-c132050",
"erlangen-tennenlohe-c132070",
"erlangen-tennenlohe-c208580",
"erlangen-tennenlohe-c208600",
"erlangen-tennenlohe-c22280",
"erlangen-tennenlohe-c22300",
"erlangen-tennenlohe-c506050",
"erlangen-tennenlohe-f404100",
"erlangen-tennenlohe-f426920",
"erlangen-tennenlohe-f485230",
"erlangen-tennenlohe-f485250",
"erlangen-tennenlohe-f485260",
"erlangen-tennenlohe-f485270",
"erlangen-tennenlohe-f485280",
"erlangen-tennenlohe-f490180",
"erlangen-tennenlohe-f510100",
"erlangen-tennenlohe-f510110",
"erlangen-tennenlohe-n01620",
"erlangen-tennenlohe-n01660",
"erlangen-tennenlohe-n33860",
"erlangen-tennenlohe-nn64610",
"erlangen-tennenlohe-nn64650",
"erlangen-tennenlohe-nn64690",
"erlangen-tsv_1861_erlangen_bruck_e_v_-c564920",
"erlangen-turnverein_1848-c314900",
"erlangen-umspannwerk_kriegenbrunn-f41220",
"erlangen-umspannwerk_kriegenbrunn-f427270",
"erlangen-umspannwerk_steudach-f48130",
"erlangen-umspannwerk-c105010",
"erlangen-umspannwerk-c21240",
"erlangen-umspannwerk-c222190",
"erlangen-umspannwerk-n249310",
"erlangen-universitaetsklinik-c314790",
"erlangen-unsere_liebe_frau_kirche-f494770",
"erlangen-uttenreuth-c314630",
"erlangen-uttenreuth-c314640",
"erlangen-vach-f41330",
"erlangen-vorort-cc4120",
"erlangen-waldorfschule-f472750",
"erlangen-wasserkraftwerk_wohrmuehle-n525780",
"erlangen-wasserturm_auf_dem_burgberg-f494620",
"erlangen-wasserwerk_west-n525820",
"erlangen-wehrkirche_sankt_xystus-f385190",
"erlangen-wildpferdegehege-c24100",
"erlangen-windraeder_sonne-f465870",
"erlangen-wohngebiet-f385250",
"erlangen-wohrmuehlinsel-f494600",
"erlangen-yachthafen-n144000",
"erlangen-zentrum-n067620",
"erlangen-zirkus_bei_buechenbach-n296600",
"erlangen-zoebelein_schuler_logistik-c564940",
"erlangen-zugbruecke__autobahn_a3-f472610",
"erlangen-zugbruecke__autobahn_a3-f472610",
"erlangen-zugbruecke_a3-f485300",
"erlangen-zug-c21330",
"erlingsdorf-erlingsdorf-n515050",
"erpfendorf-erpfendorf-f511980",
"erpfendorf-erpfendorf-f511990",
"erpfendorf-erpfendorf-f512000",
"eschenau-bartholomaeuskirche-c314120",
"eschenau-eschenau-c314100",
"eschenau-gymnasium_eckental-c314140",
"eschenau-gymnasium_eckental-c314150",
"eschenau-gymnasium_eckental-c314160",
"esselbach-esselbach_-_steinmark-s561300",
"esselbach-esselbach_-_steinmark-s561310",
"falkenfels-hirschberg-n523460",
"falkenfels-roth_bei_falkenfels-n523450",
"feldgeding-feldgeding-n514540",
"feldgeding-feldgeding-n514550",
"feldgeding-feldgeding-n514560",
"feldgeding-gada_bergkirchen-n514570",
"feldgeding-gada_bergkirchen-n514580",
"fensterbach-autobahn_a6_bei_fensterbach-f422400",
"fensterbach-steinwerk_godelmann-f422580",
"fensterbach-steinwerk_godelmann-f422590",
"feucht-autobahn_a9_bei_feucht-f451390",
"feucht-autobahn_a9_bei_feucht-f451770",
"feucht-autobahnbruecke_bei_sperslohe-f441650",
"feucht-feucht_bei_nuernberg-f520440",
"feucht-feucht_bei_nuernberg-f520450",
"feucht-feucht_bei_nuernberg-f522580",
"feucht-feucht_ost-f522570",
"feucht-feucht-c281800",
"feucht-feucht-c281820",
"feucht-feucht-f510270",
"feucht-feucht-n30540",
"feucht-feucht-n510620",
"feucht-feucht-n510640",
"feucht-feucht-n520500",
"feucht-feucht-n520510",
"feucht-feucht-n520520",
"feucht-feucht-n520530",
"feucht-gewerbepark_nuernberg_feucht-c171310",
"feucht-gewerbepark-n32220",
"feucht-moosbach-n303480",
"feucht-paketzentrum_dhl-n068820",
"feucht-rasthof_feucht_ost-c098630",
"feucht-rasthof_feucht_ost-c098670",
"feucht-raststaette_feucht-ost-f441570",
"feucht-raststaette_feucht-ost-f461320",
"feucht-schwarzachtalbruecke-f461410",
"feucht-waldbad_feuchtasia-n510630",
"feuchtwangen-atmosphaere-f46700",
"feuchtwangen-autobahn_a6_-_feuchtwangen_nord-f421410",
"feuchtwangen-autobahn_a6__grenze_zu_bayern_-f40540",
"feuchtwangen-autobahn_a6__grenze_zu_bayern_-f40580",
"feuchtwangen-autobahn_a6_bei_feuchtwangen-f42930",
"feuchtwangen-autobahn_a6_bei_feuchtwangen-f42940",
"feuchtwangen-autobahn_a6_schnelldorf-f43350",
"feuchtwangen-autobahn_feuchtwangen_nord-f40350",
"feuchtwangen-autobahn_feuchtwangen_nord-f40360",
"feuchtwangen-autobahnkreuz_a6___a7-f40370",
"feuchtwangen-autobahnkreuz_a6___a7-f40420",
"feuchtwangen-autobahnkreuz_a6___a7-f40430",
"feuchtwangen-autobahnkreuz_a6___a7-f40440",
"feuchtwangen-autobahnkreuz_a6___a7-f40450",
"feuchtwangen-autobahnkreuz_a6___a7-f40690",
"feuchtwangen-autobahnkreuz_a6___a7-f40730",
"feuchtwangen-autobahnkreuz_a6___a7-f40740",
"feuchtwangen-autobahnkreuz_a6___a7-f40760",
"feuchtwangen-autobahnkreuz_a6___a7-f40800",
"feuchtwangen-autobahnkreuz_a6___a7-f421160",
"feuchtwangen-autobahnkreuz_a6___a7-f421190",
"feuchtwangen-autobahnkreuz_a6___a7-f421230",
"feuchtwangen-autobahnkreuz_a6___a7-f43230",
"feuchtwangen-autobahnkreuz_a6___a7-f43270",
"feuchtwangen-autobahnkreuz_a6___a7-f43440",
"feuchtwangen-autobahnkreuz_a6___a7-f43490",
"feuchtwangen-autobahnkreuz_a6___a7-f43530",
"feuchtwangen-autobahnkreuz_a6___a7-f45490",
"feuchtwangen-autobahnkreuz_a6___a7-f45570",
"feuchtwangen-autobahnkreuz_a6___a7-f45750",
"feuchtwangen-autobahnkreuz_a6___a7-f45790",
"feuchtwangen-autobahnkreuz_a6___a7-f45930",
"feuchtwangen-autobahnkreuz_a6___a7-f46590",
"feuchtwangen-autobahnkreuz_a6___a7-f46640",
"feuchtwangen-autobahnkreuz_a6___a7-f46800",
"feuchtwangen-autobahnkreuz_a6___a7-f46820",
"feuchtwangen-feuchtwangen_nord-f46550",
"feuchtwangen-feuchtwangen-nord-f421430",
"feuchtwangen-kloster-f401220",
"feuchtwangen-parkplatz_rothensteig-f421270",
"feuchtwangen-rotberg__bei_feuchtwangen_-f421450",
"feuchtwangen-zug_bei_crailsheim-f421400",
"fischbach_bei_kelkheim-fischbach_bei_kelkheim-f374460",
"flachslanden-bruecke_bei_flachslanden-f43190",
"flachslanden-campingplatz_sonnensee-n271620",
"flachslanden-flachslanden-f40240",
"flachslanden-flachslanden-f40250",
"flachslanden-neustetten-n271630",
"flachslanden-neustetten-n271650",
"forchheim-buckenhofen-n268390",
"forchheim-buckenhofen-n268400",
"forchheim-buckenhofen-n268410",
"forchheim-buckenhofen-n268420",
"forchheim-buckenhofen-n268430",
"forchheim-buckenhofen-n268440",
"forchheim-burk-n268450",
"forchheim-forchheim-f3860",
"forchheim-forchheim-f553650",
"forchheim-forchheim-n268150",
"forchheim-forchheim-n268160",
"forchheim-forchheim-n268170",
"forchheim-forchheim-n268180",
"forchheim-forchheim-n268190",
"forchheim-forchheim-n268200",
"forchheim-forchheim-n268210",
"forchheim-forchheim-n268220",
"forchheim-forchheim-n268230",
"forchheim-forchheim-n268240",
"forchheim-forchheim-n268250",
"forchheim-forchheim-n268260",
"forchheim-forchheim-n268270",
"forchheim-forchheim-n268280",
"forchheim-forchheim-n268290",
"forchheim-forchheim-n268300",
"forchheim-forchheim-n268310",
"forchheim-forchheim-n268330",
"forchheim-forchheim-n268340",
"forchheim-forchheim-n276660",
"forchheim-hauptbahnhof-n35170",
"forchheim-ice_bei_forchheim-n276670",
"forchheim-ice_bei_forchheim-n276680",
"forchheim-ice_bei_forchheim-n276700",
"forchheim-kersbach-n276640",
"forchheim-kersbach-n276650",
"forchheim-sportinsel-n268370",
"forchheim-sportinsel-n268380",
"forchheim-yachtclub-n268360",
"forkendorf-deponie_forstmuehle_lauterbach-f553340",
"fraenkische_schweiz-rabeneck-n267860",
"frankenjura-frankenjura-n275920",
"frankfurt_am_main-agaplesion_markus_krankenhaus-f373490",
"frankfurt_am_main-agaplesion_markus_krankenhaus-f373530",
"frankfurt_am_main-alte_oper-f374240",
"frankfurt_am_main-brentanobad-f373890",
"frankfurt_am_main-commerzbank_tower-f373640",
"frankfurt_am_main-commerzbank_tower-f373730",
"frankfurt_am_main-commerzbank_tower-f373740",
"frankfurt_am_main-deka_trianon_tower-f374180",
"frankfurt_am_main-deutsche_bank_park-f373370",
"frankfurt_am_main-deutschherrnbruecke-f374120",
"frankfurt_am_main-europaeische_zentralbank-f373940",
"frankfurt_am_main-europaeische_zentralbank-f373970",
"frankfurt_am_main-europaeische_zentralbank-f374090",
"frankfurt_am_main-europaeische_zentralbank-f374140",
"frankfurt_am_main-europaeische_zentralbank-f374170",
"frankfurt_am_main-europagarten-f373400",
"frankfurt_am_main-europaturm-f373560",
"frankfurt_am_main-eurotower-f374210",
"frankfurt_am_main-festhalle_messe-f373430",
"frankfurt_am_main-festhalle-f374300",
"frankfurt_am_main-frankfurt_am_main__europaviertel-f374320",
"frankfurt_am_main-frankfurt_am_main-f372810",
"frankfurt_am_main-frankfurt_am_main-f372820",
"frankfurt_am_main-frankfurt_am_main-f372830",
"frankfurt_am_main-frankfurt_am_main-f372870",
"frankfurt_am_main-frankfurt_am_main-f372910",
"frankfurt_am_main-frankfurt_am_main-f372920",
"frankfurt_am_main-frankfurt_am_main-f372940",
"frankfurt_am_main-frankfurt_am_main-f373030",
"frankfurt_am_main-frankfurt_am_main-f373080",
"frankfurt_am_main-frankfurt_am_main-f373090",
"frankfurt_am_main-frankfurt_am_main-f373140",
"frankfurt_am_main-frankfurt_am_main-f373180",
"frankfurt_am_main-frankfurt_am_main-f373240",
"frankfurt_am_main-frankfurt_am_main-f373250",
"frankfurt_am_main-frankfurt_am_main-f373260",
"frankfurt_am_main-frankfurt_am_main-f373270",
"frankfurt_am_main-frankfurt_am_main-f373290",
"frankfurt_am_main-frankfurt_am_main-f373330",
"frankfurt_am_main-frankfurt_am_main-f373340",
"frankfurt_am_main-frankfurt_am_main-f373360",
"frankfurt_am_main-frankfurt_am_main-f373420",
"frankfurt_am_main-frankfurt_am_main-f373470",
"frankfurt_am_main-frankfurt_am_main-f373480",
"frankfurt_am_main-frankfurt_am_main-f373610",
"frankfurt_am_main-frankfurt_am_main-f373820",
"frankfurt_am_main-frankfurt_am_main-f373910",
"frankfurt_am_main-frankfurt_am_main-f373920",
"frankfurt_am_main-frankfurt_am_main-f373980",
"frankfurt_am_main-frankfurt_am_main-f374010",
"frankfurt_am_main-frankfurt_am_main-f374060",
"frankfurt_am_main-frankfurt_am_main-f374130",
"frankfurt_am_main-frankfurt_am_main-f374160",
"frankfurt_am_main-frankfurt_am_main-f374290",
"frankfurt_am_main-frankfurt_am_main-f374310",
"frankfurt_am_main-frankfurt_am_main-f374380",
"frankfurt_am_main-frankfurt_am_main-f374390",
"frankfurt_am_main-frankfurt_am_main-f374400",
"frankfurt_am_main-frankfurt_am_main-f374410",
"frankfurt_am_main-frankfurt_am_main-f374420",
"frankfurt_am_main-frankfurt_am_main-f374430",
"frankfurt_am_main-frankfurt_city_west-f374340",
"frankfurt_am_main-frankfurt_city-f373130",
"frankfurt_am_main-frankfurt_city-f373170",
"frankfurt_am_main-frankfurt_city-f373210",
"frankfurt_am_main-frankfurt_city-f373230",
"frankfurt_am_main-frankfurt_city-f373280",
"frankfurt_am_main-frankfurt_messe-f373410",
"frankfurt_am_main-frankfurt_messe-f373460",
"frankfurt_am_main-frankfurter_hafen-f373960",
"frankfurt_am_main-frankfurter_zoo-f373950",
"frankfurt_am_main-gallileo_hochhaus-f374260",
"frankfurt_am_main-gallusanlage-f373710",
"frankfurt_am_main-gallusanlage-f373720",
"frankfurt_am_main-grand_tower-f373840",
"frankfurt_am_main-grand_tower-f374280",
"frankfurt_am_main-gutleutviertel-f373390",
"frankfurt_am_main-gutleutviertel-f374250",
"frankfurt_am_main-hafenpark_quartier-f374030",
"frankfurt_am_main-hauptbahnhof__frankfurt_am_main-f374350",
"frankfurt_am_main-hauptbahnhof_frankfurt-f372970",
"frankfurt_am_main-hauptbahnhof-f372930",
"frankfurt_am_main-hauptbahnhof-f373310",
"frankfurt_am_main-hauptbahnhof-f373350",
"frankfurt_am_main-hauptbahnhof-f373660",
"frankfurt_am_main-hauptwache-f373690",
"frankfurt_am_main-hauptwache-f374190",
"frankfurt_am_main-heimatsiedlung-f373320",
"frankfurt_am_main-hochhausquartier_four-f373630",
"frankfurt_am_main-hochhausquartier_four-f374270",
"frankfurt_am_main-ibc_tower-f373880",
"frankfurt_am_main-kahl_am_main-f372670",
"frankfurt_am_main-maininsel-f374000",
"frankfurt_am_main-mainkai-f374200",
"frankfurt_am_main-marina_westhafen-f373680",
"frankfurt_am_main-messe_frankfurt-f372990",
"frankfurt_am_main-messe_frankfurt-f373050",
"frankfurt_am_main-messe_frankfurt-f373870",
"frankfurt_am_main-messe_turm-f373670",
"frankfurt_am_main-messe-f373060",
"frankfurt_am_main-messe-f373800",
"frankfurt_am_main-messe-f373810",
"frankfurt_am_main-messe-f373860",
"frankfurt_am_main-messeturm-f373770",
"frankfurt_am_main-nextower-f373700",
"frankfurt_am_main-offenbach-f372840",
"frankfurt_am_main-opernturm-f373620",
"frankfurt_am_main-opernturm-f374230",
"frankfurt_am_main-palmengarten-f373520",
"frankfurt_am_main-parktower-f373590",
"frankfurt_am_main-rebstockbad__frankfurt_am_main-f374330",
"frankfurt_am_main-rebstockbad-f373830",
"frankfurt_am_main-sc_frankfurt_1880_e_v_-f373540",
"frankfurt_am_main-silver_tower-f373750",
"frankfurt_am_main-skyline_plaza-f373760",
"frankfurt_am_main-skyline-f372890",
"frankfurt_am_main-taunusanlage-f374220",
"frankfurt_am_main-walther-von-cronberg-platz-f374100",
"frankfurt_am_main-walther-von-cronberg-platz-f374150",
"frankfurt_am_main-westend_tower-f373650",
"frankfurt_am_main-westend_tower-f373780",
"frankfurt_am_main-westendgate-f373790",
"frauenaurach-aurachtalbruecke-c500140",
"frauenaurach-autobahnraststaette_frauenaurach-n328090",
"frauenaurach-autobahnraststaette_frauenaurach-n328110",
"frauenaurach-autobahnraststaette_frauenaurach-n328130",
"frauenaurach-autobahnraststaette_frauenaurach-n328150",
"frauenaurach-autobahnraststaette_frauenaurach-n328180",
"frauenaurach-autobahnraststaette_frauenaurach-n328200",
"frauenaurach-autobahnunterfuehrung_a3_frauenaurach-f555900",
"frauenaurach-autobahnunterfuehrung_a3_frauenaurach-f555910",
"frauenaurach-baustelle_bei_aurachtalbruecke-c500150",
"frauenaurach-erlangen-frauenaurach-f555830",
"frauenaurach-frauenaurach-n061230",
"frauenaurach-industriepark_frauenaurach-n3040",
"frauenaurach-raststaette_aurach_sued-n343200",
"frauenaurach-raststaette_aurach_sued-n343230",
"frauenaurach-raststaette_frauenaurach-f41700",
"frauenaurach-raststaette-cb81580",
"frauenaurach-schallershof-c506180",
"frauenaurach-tsv_1891_frauenaurach-f41710",
"frauenpriessnitz-windpark_bei_frauenpriessnitz-n355470",
"freystadt-moeninger_berg-f421770",
"freystadt-reiterhof__rohr_bei_freystadt_-f421740",
"frickenhausen_am_main-frickenhausen_am_main-c561380",
"frickenhausen_am_main-frickenhausen_am_main-c561390",
"friedberg-friedberg-n325500",
"friedrichsgmuend-gewerbegebiet-n321770",
"friedrichshafen-bodensee-c503570",
"friedrichshafen-flughafen_friedrichshafen-f501390",
"friedrichshafen-flughafen_friedrichshafen-f501400",
"friedrichshafen-friedrichshafen-c503430",
"friedrichshafen-friedrichshafen-c503440",
"friedrichshafen-friedrichshafen-c503510",
"friedrichshafen-friedrichshafen-c503520",
"friedrichshafen-friedrichshafen-c503530",
"friedrichshafen-friedrichshafen-c503540",
"friedrichshafen-friedrichshafen-c503560",
"friedrichshafen-friedrichshafen-c503630",
"friedrichshafen-friedrichshafen-f501260",
"friedrichshafen-friedrichshafen-f501270",
"friedrichshafen-gunzenhaus-f501410",
"friedrichshafen-hafen_friedrichshafen-c503470",
"friedrichshafen-hafen_friedrichshafen-c503550",
"friedrichshafen-hauptfriedhof_friedrichshafen-f501280",
"friedrichshafen-messe_friedrichshafen-c503660",
"friedrichshafen-messe_friedrichshafen-f501320",
"friedrichshafen-messe_friedrichshafen-f501330",
"friedrichshafen-messe_friedrichshafen-f501340",
"friedrichshafen-rolls-royce_solutions-f501290",
"friedrichshafen-rolls-royce_solutions-f501300",
"friedrichshafen-schloss_friedrichshafen-c503580",
"friedrichshafen-schloss_friedrichshafen-c503610",
"friedrichshafen-schloss_friedrichshafen-c503620",
"friedrichshafen-schloss_montfort-c503400",
"friedrichshafen-schloss_montfort-c503410",
"friedrichshafen-schlosspark_friedrichshafen-c503600",
"friedrichshafen-segelboot_am_bodensee-c503460",
"friedrichshafen-strandbad_langenargen-c503420",
"friedrichshafen-uferpromenade_friedrichshafen-c503490",
"friedrichshafen-uferpromenade_friedrichshafen-c503500",
"friedrichshafen-uferpromenade_friedrichshafen-c503590",
"friedrichshafen-zeppelin_gmbh-f501310",
"friedrichshafen-zf_arena-c503640",
"friedrichshafen-zf_arena-c503650",
"friedrichshafen-zf_zeppelin-c503370",
"friedrichshafen-zf_zeppelin-c503750",
"fuerth-alte_feuerwache-c245800",
"fuerth-altstadt_fuerth-f393000",
"fuerth-altstadt_fuerth-f493820",
"fuerth-am_annaberg-c564670",
"fuerth-amalienstrasse-c223190",
"fuerth-amalienstrasse-c284270",
"fuerth-architektur_in_fuerth-c111780",
"fuerth-atzenhof-c222430",
"fuerth-atzenhof-c222440",
"fuerth-atzenhof-c222460",
"fuerth-atzenhof-c22420",
"fuerth-atzenhof-c22430",
"fuerth-atzenhof-c500190",
"fuerth-atzenhof-c500200",
"fuerth-atzenhof-f48220",
"fuerth-auferstehungskirche-f494250",
"fuerth-ausfahrt_b8-c245480",
"fuerth-bachstrasse-c223170",
"fuerth-bahnhofplatz-c223110",
"fuerth-bahnhofplatz-c223120",
"fuerth-bahnhofplatz-c284300",
"fuerth-bauflaeche_fussballstadion-nn75240",
"fuerth-baugelaende_fussballstadion-nn75270",
"fuerth-baustelle_hauptfeuerwache-n264670",
"fuerth-baustelle_moebelhaus_hoeffner-c069010",
"fuerth-baustelle_moebelhaus_hoeffner-n061030",
"fuerth-baustelle-c216020",
"fuerth-baustelle-c245860",
"fuerth-bielinganlage-f392820",
"fuerth-bielinganlage-f493850",
"fuerth-bielinganlage-f493850",
"fuerth-bielinganlage-n264690",
"fuerth-bielinganlage-n264710",
"fuerth-bislohe-c254780",
"fuerth-bislohe-f407150",
"fuerth-blockheizkraftwerk_fronmuellerstrasse-f4150",
"fuerth-burgfarrnbach-c246560",
"fuerth-burgfarrnbach-c246580",
"fuerth-burgfarrnbach-c246590",
"fuerth-burgfarrnbach-c246600",
"fuerth-burgfarrnbach-c246610",
"fuerth-burgfarrnbach-c246620",
"fuerth-burgfarrnbach-c246630",
"fuerth-burgfarrnbach-c284830",
"fuerth-burgfarrnbach-c284840",
"fuerth-burgfarrnbach-c284850",
"fuerth-burgfarrnbach-c284860",
"fuerth-burgfarrnbach-c284870",
"fuerth-burgfarrnbach-c284880",
"fuerth-burgfarrnbach-n343090",
"fuerth-burgfarrnbach-n343100",
"fuerth-burgfarrnbach-n343140",
"fuerth-charley-mai-sportanlage-f393040",
"fuerth-charly-mai-sportanlage-c245810",
"fuerth-charly-mai-sportanlage-c284100",
"fuerth-charly-mai-sportanlage-c284130",
"fuerth-charly-mai-sportanlage-n077470",
"fuerth-charly-mai-sportanlage-n248540",
"fuerth-charly-mai-sportanlage-n248980",
"fuerth-charly-mai-sportanlage-n248990",
"fuerth-charly-mai-sportanlage-n295770",
"fuerth-charly-mai-sportanlage-s562460",
"fuerth-charly-mai-sportplatz-f493940",
"fuerth-christkoenig_kirche-n295820",
"fuerth-christkoenig-kirche-c500220",
"fuerth-christkoenigkirche-f493890",
"fuerth-christkoenigkirche-f493890",
"fuerth-city-center-c124890",
"fuerth-dambach-c500260",
"fuerth-dambacher_strasse-c222540",
"fuerth-dambacher_strasse-c222590",
"fuerth-dambacher_strasse-c222660",
"fuerth-dambacher_strasse-c284230",
"fuerth-dr_-gustav-schickedanz-schule-f48250",
"fuerth-dr_-mack-strasse-f531080",
"fuerth-dr_-mack-strasse-n530830",
"fuerth-dr_-mack-strasse-n530840",
"fuerth-dr_-mack-strasse-n530850",
"fuerth-eckershof-f48400",
"fuerth-ehem__lungenheilstaette-f392490",
"fuerth-ehem__lungenheilstaette-f392500",
"fuerth-eichenhain-f493880",
"fuerth-espan-n264640",
"fuerth-euromedclinic-c111730",
"fuerth-euromedclinic-c111740",
"fuerth-europaallee-n530820",
"fuerth-fernwaerme-f411940",
"fuerth-feuerwehr_fuerth-n530870",
"fuerth-finkenschlag-f48250",
"fuerth-flexdorf-c221820",
"fuerth-flexdorf-c221850",
"fuerth-flugplatzstrasse-f48240",
"fuerth-flurbruecke-f493840",
"fuerth-frankenschnellweg-f392860",
"fuerth-friedhof-n077480",
"fuerth-friedhof-n248520",
"fuerth-friedrich-ebert-grundschule-f493910",
"fuerth-friedrich-ebert-grundschule-f493910",
"fuerth-friedrichstrasse-c223140",
"fuerth-fronmuellerstrasse-f4140",
"fuerth-fuerth_-_altstadt-f554180",
"fuerth-fuerth__bislohe-f494370",
"fuerth-fuerth__bislohe-f494380",
"fuerth-fuerth__eigenes_heim-f493870",
"fuerth-fuerth__eigenes_heim-f493900",
"fuerth-fuerth__espan-f494220",
"fuerth-fuerth__innenstadt-f494270",
"fuerth-fuerth__kronach-f494360",
"fuerth-fuerth__schwand-f493920",
"fuerth-fuerth__stadtpark-f494230",
"fuerth-fuerth__stadtpark-f494240",
"fuerth-fuerth__stadtpark-f494250",
"fuerth-fuerth__stadtpark-f494260",
"fuerth-fuerth__suedstadt-f494030",
"fuerth-fuerth__suedstadt-f494040",
"fuerth-fuerth_-_suedstadt-f554120",
"fuerth-fuerth_-_suedstadt-f554130",
"fuerth-fuerth_-_uferstadt-f554060",
"fuerth-fuerth_-_waldstrasse-f554410",
"fuerth-fuerth__westvorstadt-f494080",
"fuerth-fuerth__westvorstadt-f494090",
"fuerth-fuerth__westvorstadt-f494100",
"fuerth-fuerth__westvorstadt-f494110",
"fuerth-fuerth__westvorstadt-f494120",
"fuerth-fuerth_altstadt-s562440",
"fuerth-fuerth_altstadt-s562450",
"fuerth-fuerth_espan-c564460",
"fuerth-fuerth_espan-c564470",
"fuerth-fuerth_espan-c564480",
"fuerth-fuerth_espan-f464950",
"fuerth-fuerth_hardhoehe-f531130",
"fuerth-fuerth_hauptbahnhof-f4190",
"fuerth-fuerth_hauptbahnhof-f493980",
"fuerth-fuerth_panorama-f4170",
"fuerth-fuerth_suedstadt-f531220",
"fuerth-fuerth_suedstadt-n530960",
"fuerth-fuerth_suedstadt-s562360",
"fuerth-fuerth_suedstadt-s562400",
"fuerth-fuerth_westwinkel-c564660",
"fuerth-fuerth-bb8510",
"fuerth-fuerth-bb8540",
"fuerth-fuerth-c111800",
"fuerth-fuerth-c136630",
"fuerth-fuerth-c136860",
"fuerth-fuerth-c137360",
"fuerth-fuerth-c157060",
"fuerth-fuerth-c157070",
"fuerth-fuerth-c157090",
"fuerth-fuerth-c157100",
"fuerth-fuerth-c157120",
"fuerth-fuerth-c157170",
"fuerth-fuerth-c157180",
"fuerth-fuerth-c157200",
"fuerth-fuerth-c157210",
"fuerth-fuerth-c157230",
"fuerth-fuerth-c157240",
"fuerth-fuerth-c157260",
"fuerth-fuerth-c157270",
"fuerth-fuerth-c157280",
"fuerth-fuerth-c157310",
"fuerth-fuerth-c174240",
"fuerth-fuerth-c174270",
"fuerth-fuerth-c174280",
"fuerth-fuerth-c174350",
"fuerth-fuerth-c174380",
"fuerth-fuerth-c174390",
"fuerth-fuerth-c174420",
"fuerth-fuerth-c174440",
"fuerth-fuerth-c174450",
"fuerth-fuerth-c174460",
"fuerth-fuerth-c174470",
"fuerth-fuerth-c174500",
"fuerth-fuerth-c174530",
"fuerth-fuerth-c174550",
"fuerth-fuerth-c174690",
"fuerth-fuerth-c187890",
"fuerth-fuerth-c253810",
"fuerth-fuerth-c254010",
"fuerth-fuerth-c254050",
"fuerth-fuerth-c254100",
"fuerth-fuerth-c254110",
"fuerth-fuerth-c254120",
"fuerth-fuerth-c254140",
"fuerth-fuerth-c254230",
"fuerth-fuerth-c254270",
"fuerth-fuerth-c254510",
"fuerth-fuerth-c284220",
"fuerth-fuerth-c284290",
"fuerth-fuerth-c284310",
"fuerth-fuerth-c284320",
"fuerth-fuerth-c284330",
"fuerth-fuerth-c284340",
"fuerth-fuerth-c284350",
"fuerth-fuerth-c284370",
"fuerth-fuerther_freiheit-s562420",
"fuerth-fuerthermare-c215850",
"fuerth-fuerthermare-c254150",
"fuerth-fuerthermare-c500230",
"fuerth-fuerthermare-c500240",
"fuerth-fuerthermare-c564610",
"fuerth-fuerthermare-f494130",
"fuerth-fuerthermare-f494140",
"fuerth-fuerthermare-n264860",
"fuerth-fuerth-f384880",
"fuerth-fuerth-f384920",
"fuerth-fuerth-f392420",
"fuerth-fuerth-f392450",
"fuerth-fuerth-f392790",
"fuerth-fuerth-f392800",
"fuerth-fuerth-f392810",
"fuerth-fuerth-f392840",
"fuerth-fuerth-f392880",
"fuerth-fuerth-f392890",
"fuerth-fuerth-f392950",
"fuerth-fuerth-f392960",
"fuerth-fuerth-f392970",
"fuerth-fuerth-f392980",
"fuerth-fuerth-f392990",
"fuerth-fuerth-f393010",
"fuerth-fuerth-f393020",
"fuerth-fuerth-f393070",
"fuerth-fuerth-f393080",
"fuerth-fuerth-f393100",
"fuerth-fuerth-f493980",
"fuerth-fuerth-f493990",
"fuerth-fuerth-f494150",
"fuerth-fuerth-f531090",
"fuerth-fuerth-f531110",
"fuerth-fuerth-f531250",
"fuerth-fuerth-f531890",
"fuerth-fuerth-f532290",
"fuerth-fuerth-f532300",
"fuerth-fuerth-f532320",
"fuerth-fuerth-f554070",
"fuerth-fuerth-f554080",
"fuerth-fuerth-f554090",
"fuerth-fuerth-f554100",
"fuerth-fuerth-f554110",
"fuerth-fuerth-f554140",
"fuerth-fuerth-f554150",
"fuerth-fuerth-f554160",
"fuerth-fuerth-f554170",
"fuerth-fuerth-f554190",
"fuerth-fuerth-f554420",
"fuerth-fuerth-n242910",
"fuerth-fuerth-n264220",
"fuerth-fuerth-n264230",
"fuerth-fuerth-n264240",
"fuerth-fuerth-n264250",
"fuerth-fuerth-n264260",
"fuerth-fuerth-n264270",
"fuerth-fuerth-n264280",
"fuerth-fuerth-n264290",
"fuerth-fuerth-n264300",
"fuerth-fuerth-n264310",
"fuerth-fuerth-n264390",
"fuerth-fuerth-n264400",
"fuerth-fuerth-n264420",
"fuerth-fuerth-n264720",
"fuerth-fuerth-n264730",
"fuerth-fuerth-n264740",
"fuerth-fuerth-n264750",
"fuerth-fuerth-n264760",
"fuerth-fuerth-n264770",
"fuerth-fuerth-n264780",
"fuerth-fuerth-n264790",
"fuerth-fuerth-n264820",
"fuerth-fuerth-n264830",
"fuerth-fuerth-n264840",
"fuerth-fuerth-n264850",
"fuerth-fuerth-n264870",
"fuerth-fuerth-n295780",
"fuerth-fuerth-n295810",
"fuerth-fuerth-n295860",
"fuerth-fuerth-n295870",
"fuerth-fuerth-n295880",
"fuerth-fuerth-n295890",
"fuerth-fuerth-n295900",
"fuerth-fuerth-n295910",
"fuerth-fuerth-n295920",
"fuerth-fuerth-n295940",
"fuerth-fuerth-n295950",
"fuerth-fuerth-n295960",
"fuerth-fuerth-n295970",
"fuerth-fuerth-n295980",
"fuerth-fuerth-n295990",
"fuerth-fuerth-n296000",
"fuerth-fuerth-n296050",
"fuerth-fuerth-n296070",
"fuerth-fuerth-n296140",
"fuerth-fuerth-n296150",
"fuerth-fuerth-n343070",
"fuerth-fuerth-n364670",
"fuerth-fuerth-n364680",
"fuerth-fuerth-n364690",
"fuerth-fuerth-steinach-f384960",
"fuerth-fussballstadion-n077460",
"fuerth-gartenanlage-n364910",
"fuerth-gebhardtstrasse-c222760",
"fuerth-gebhardtstrasse-c222840",
"fuerth-gebhardtstrasse-c222870",
"fuerth-gebhardtstrasse-c222880",
"fuerth-gebhardtstrasse-c222890",
"fuerth-gebhardtstrasse-c222980",
"fuerth-gebhardtstrasse-c222990",
"fuerth-gebhardtstrasse-n248640",
"fuerth-gebhardtstrasse-n248750",
"fuerth-gebhardtstrasse-n248920",
"fuerth-gebhardtstrasse-n248970",
"fuerth-gewerbegebiet_bislohe-f494390",
"fuerth-gewerbegebiet_hardhoehe_west-f392780",
"fuerth-gewerbegebiet_hardhoehe_west-f41130",
"fuerth-goethestrasse-c223010",
"fuerth-golfplatz-n364790",
"fuerth-golfplatz-n364800",
"fuerth-graf-staufenberg-bruecke-f531160",
"fuerth-grundigpark-c174730",
"fuerth-grundigpark-c174780",
"fuerth-grundigpark-c500270",
"fuerth-grundigpark-f48320",
"fuerth-hafen_fuerth-f41160",
"fuerth-hafen_fuerth-f41170",
"fuerth-hafen_fuerth-f41180",
"fuerth-hafen-c221780",
"fuerth-hafen-c221800",
"fuerth-hafen-cd18360",
"fuerth-hafen-cd18380",
"fuerth-hafen-f41120",
"fuerth-hainberg-f391460",
"fuerth-hallstrasse-c124830",
"fuerth-hans-vogel-strasse-c564500",
"fuerth-hans-vogel-strasse-n295710",
"fuerth-hardhoehe-c284380",
"fuerth-hardhoehe-c564620",
"fuerth-hardhoehe-c564630",
"fuerth-hardhoehe-c564640",
"fuerth-hardhoehe-c564650",
"fuerth-hardhoehe-c564680",
"fuerth-hardhoehe-f41100",
"fuerth-hardhoehe-f41110",
"fuerth-hardhoehe-f41140",
"fuerth-hardhoehe-f48260",
"fuerth-hardhoehe-f48280",
"fuerth-hardhoehe-f531140",
"fuerth-hardhoehe-n530890",
"fuerth-hauptbahnhof_fuerth-s562410",
"fuerth-hauptbahnhof-c157140",
"fuerth-hauptbahnhof-c157150",
"fuerth-hauptbahnhof-c195240",
"fuerth-hauptbahnhof-c223090",
"fuerth-hauptbahnhof-c253860",
"fuerth-hauptbahnhof-c253970",
"fuerth-hauptbahnhof-c253980",
"fuerth-hauptbahnhof-c253990",
"fuerth-hauptbahnhof-c254000",
"fuerth-heilige_dreifaltigkeit_kirche-n296100",
"fuerth-helene-lange-gymnasium-f384830",
"fuerth-herboldshof-c22350",
"fuerth-herboldshof-n24130",
"fuerth-herboldshof-n249220",
"fuerth-herrnstrasse-c136890",
"fuerth-herrnstrasse-c136900",
"fuerth-herrnstrasse-c222530",
"fuerth-herrnstrasse-n248870",
"fuerth-hoefener_spange-c245690",
"fuerth-hoefener_spange-c254180",
"fuerth-hoefener_spange-c254210",
"fuerth-hoefener_spange-c254220",
"fuerth-hoefener_strasse-c564420",
"fuerth-hoefener_strasse-c564430",
"fuerth-hoefner_spange-c281720",
"fuerth-hornbach-f392380",
"fuerth-hornschuchpromenade-n248810",
"fuerth-huettendorf-c221940",
"fuerth-huettendorf-c221960",
"fuerth-ikea_fuerth-c564540",
"fuerth-ikea_fuerth-c564550",
"fuerth-ikea_fuerth-c564710",
"fuerth-ikea-bb8840",
"fuerth-ikea-c215910",
"fuerth-ikea-c254690",
"fuerth-ikea-f393110",
"fuerth-ikea-f493750",
"fuerth-innenstadt-c253840",
"fuerth-innenstadt-c253870",
"fuerth-innenstadt-c253890",
"fuerth-innenstadt-n264800",
"fuerth-innenstadt-n264810",
"fuerth-isaak-loewi-strasse-c136530",
"fuerth-isaak-loewi-strasse-c136660",
"fuerth-johannisstrasse-c284280",
"fuerth-julius-hirsch-sportzentrum-n264320",
"fuerth-julius-hirsch-sportzentrum-n264330",
"fuerth-julius-hirsch-sportzentrum-n264360",
"fuerth-julius-hirsch-sportzentrum-n264370",
"fuerth-kaiserstrasse-c136580",
"fuerth-kanalbruecke_bei_fuerth-c245440",
"fuerth-kanalbruecke_bei_fuerth-c245460",
"fuerth-kanalbruecke_bei_fuerth-c245490",
"fuerth-kanalbruecke_bei_fuerth-c245510",
"fuerth-kanalbruecke_bei_fuerth-c245520",
"fuerth-kanalbruecke_bei_fuerth-c245540",
"fuerth-kanalbruecke_zenn-n364840",
"fuerth-kanalbruecke-c245910",
"fuerth-kanalbruecke-c245920",
"fuerth-kanalbruecke-c245990",
"fuerth-karlsteg-f494170",
"fuerth-karolinenstrasse-n248690",
"fuerth-kirche_bei_fuerth-cb89870",
"fuerth-kirche-n248710",
"fuerth-klaerwerk-n248530",
"fuerth-klinikum_fuerth-c222470",
"fuerth-klinikum_fuerth-c284360",
"fuerth-klinikum_fuerth-c564590",
"fuerth-klinikum_fuerth-cd18330",
"fuerth-klinikum_fuerth-f392830",
"fuerth-klinikum_fuerth-f493860",
"fuerth-klinikum_fuerth-f493930",
"fuerth-klinikum_fuerth-f531120",
"fuerth-klinikum_fuerth-n077610",
"fuerth-klinikum_fuerth-n077710",
"fuerth-klinikum_fuerth-n364720",
"fuerth-klinikum_fuerth-n364730",
"fuerth-klinikum-n295850",
"fuerth-koenigstrasse-f493950",
"fuerth-koenigstrasse-f493960",
"fuerth-koenigstrasse-f493960",
"fuerth-koenigstrasse-f493970",
"fuerth-koenigstrasse-f494180",
"fuerth-koenigswarterstrasse-f493980",
"fuerth-kronach-c216100",
"fuerth-kuhweide-n364920",
"fuerth-kunstmuehle-f48170",
"fuerth-kutzerstrasse-n264380",
"fuerth-kutzerstrasse-n264430",
"fuerth-kutzerstrasse-n264440",
"fuerth-kutzerstrasse-n264450",
"fuerth-kutzerstrasse-n264460",
"fuerth-kutzerstrasse-n264470",
"fuerth-kutzerstrasse-n264480",
"fuerth-kutzerstrasse-n264490",
"fuerth-kutzerstrasse-n264500",
"fuerth-kutzerstrasse-n264510",
"fuerth-kutzerstrasse-n264520",
"fuerth-kutzerstrasse-n264530",
"fuerth-kutzerstrasse-n264540",
"fuerth-kutzerstrasse-n264550",
"fuerth-kutzerstrasse-n264560",
"fuerth-kutzerstrasse-n264570",
"fuerth-kutzerstrasse-n264580",
"fuerth-kutzerstrasse-n264610",
"fuerth-kutzerstrasse-n264650",
"fuerth-lagerzentrum_norma-c157580",
"fuerth-landwirtschaft_bei_bertelsdorf-f48370",
"fuerth-landwirtschaft-c246160",
"fuerth-lebenshilfe_fuerth-n530950",
"fuerth-ludwigbruecke-c284140",
"fuerth-ludwigbruecke-f494290",
"fuerth-ludwigsbruecke-n295740",
"fuerth-ludwigsbruecke-n530860",
"fuerth-main-donau-kanal-c157020",
"fuerth-main-donau-kanal-f48310",
"fuerth-main-donau-park-f411970",
"fuerth-maislabyrinth-c246010",
"fuerth-malzboeden-c284240",
"fuerth-mannhof-n24120",
"fuerth-mannhof-n296160",
"fuerth-max-grundig-schule-c284260",
"fuerth-metropol_medical_center-c111590",
"fuerth-metropol_medical_center-c111600",
"fuerth-metropol_medical_center-c111640",
"fuerth-metropol_medical_center-c111710",
"fuerth-moebelhaus_flamme-c157320",
"fuerth-moebelhaus_hoeffner-c111930",
"fuerth-moebelhaus_hoeffner-c111940",
"fuerth-moebelhaus_hoeffner-c111970",
"fuerth-moebelhaus_hoeffner-c313000",
"fuerth-moebelhaus_hoeffner-c313020",
"fuerth-moebelhaus_hoeffner-c313030",
"fuerth-moebelhaus_hoeffner-c313040",
"fuerth-moebelhaus_hoeffner-c313050",
"fuerth-moebelhaus_hoeffner-c313060",
"fuerth-moebelhaus_hoeffner-c313080",
"fuerth-moebelhaus_hoeffner-c564800",
"fuerth-moebelhaus_hoeffner-cb81410",
"fuerth-moebelhaus_hoeffner-n077840",
"fuerth-moebelhaus_hoeffner-n077920",
"fuerth-moebelhaus_kibek-cb81420",
"fuerth-moerikeweg-n295700",
"fuerth-moststrasse-c124850",
"fuerth-muehle-c245790",
"fuerth-neubau_naehe_oberfuerberg-n14730",
"fuerth-neue_mitte-c174510",
"fuerth-neumannstrasse-cd18160",
"fuerth-norma_lager-c215820",
"fuerth-norma_zentrallager-f41150",
"fuerth-norma-c215670",
"fuerth-norma-c215710",
"fuerth-norma-c215770",
"fuerth-norma-c215800",
"fuerth-norma-c221390",
"fuerth-norma-c22460",
"fuerth-norma-c22480",
"fuerth-norma-c22520",
"fuerth-norma-c22850",
"fuerth-norma-c22880",
"fuerth-nuernberger_strasse-f384790",
"fuerth-nuernberger_strasse-f384810",
"fuerth-oberfuerberg-c157590",
"fuerth-oberfuerberg-c157600",
"fuerth-oberfuerberg-c157610",
"fuerth-oberfuerberg-c157620",
"fuerth-oberfuerberg-c223220",
"fuerth-oberfuerberg-c223230",
"fuerth-oberfuerberg-c223240",
"fuerth-oberfuerberg-c223270",
"fuerth-oberfuerberg-c223280",
"fuerth-panorama-c254240",
"fuerth-panorama-c254540",
"fuerth-pappelsteig-f494200",
"fuerth-pegnitz-c254650",
"fuerth-petershoehe-f48360",
"fuerth-phoenix_center_fuerth-n531820",
"fuerth-phoenix_center_fuerth-n531830",
"fuerth-poppenreuth-c215890",
"fuerth-poppenreuth-c216000",
"fuerth-poppenreuth-c216030",
"fuerth-poppenreuth-c254680",
"fuerth-poppenreuth-c254700",
"fuerth-poppenreuth-c283980",
"fuerth-poppenreuth-c283990",
"fuerth-poppenreuth-c284000",
"fuerth-poppenreuth-c284050",
"fuerth-poppenreuth-c564510",
"fuerth-poppenreuth-c564520",
"fuerth-poppenreuth-c564530",
"fuerth-poppenreuth-c564700",
"fuerth-poppenreuth-cd17480",
"fuerth-poppenreuth-cd17500",
"fuerth-poppenreuther_bruecke-f493780",
"fuerth-poppenreuther_strasse-c284010",
"fuerth-poppenreuther_strasse-c284020",
"fuerth-poppenreuther_strasse-f384850",
"fuerth-poppenreuther_strasse-f392900",
"fuerth-poppenreuther_strasse-n249010",
"fuerth-poppenreuther_strasse-n264590",
"fuerth-poppenreuther_strasse-n264600",
"fuerth-poppenreuther_strasse-n264620",
"fuerth-poppenreuther_strasse-n264630",
"fuerth-poppenreuther_strasse-n264660",
"fuerth-poppenreuther_strasse-n295730",
"fuerth-poppenreuth-f392850",
"fuerth-poppenreuth-f393120",
"fuerth-poppenreuth-f393130",
"fuerth-poppenreuth-f393140",
"fuerth-poppenreuth-f493680",
"fuerth-poppenreuth-f493720",
"fuerth-poppenreuth-f493730",
"fuerth-poppenreuth-f493740",
"fuerth-poppenreuth-f493750",
"fuerth-poppenreuth-f493760",
"fuerth-poppenreuth-f493770",
"fuerth-poppenreuth-f493780",
"fuerth-poppenreuth-f493800",
"fuerth-pyramide_fuerth-n530970",
"fuerth-pyramide-c157030",
"fuerth-pyramide-c157040",
"fuerth-pyramide-c187880",
"fuerth-pyramide-n531000",
"fuerth-pyramide-n531040",
"fuerth-pyramide-n531070",
"fuerth-pyramide-n531100",
"fuerth-pyramide-n531150",
"fuerth-rednitz-c254660",
"fuerth-rednitz-n248550",
"fuerth-rednitz-n248560",
"fuerth-ronhof_stadion-c284070",
"fuerth-ronhof-c111890",
"fuerth-ronhof-c216040",
"fuerth-ronhof-c216060",
"fuerth-ronhof-c216120",
"fuerth-ronhof-c216150",
"fuerth-ronhof-c254740",
"fuerth-ronhof-f384870",
"fuerth-ronhof-f38700",
"fuerth-ronhof-f393060",
"fuerth-ronhof-f493790",
"fuerth-ronhof-f494300",
"fuerth-ronhof-f494310",
"fuerth-ronhof-f494320",
"fuerth-ronhof-f494330",
"fuerth-ronhof-f494350",
"fuerth-ronhof-n249020",
"fuerth-ronhof-n249040",
"fuerth-ronhof-n249060",
"fuerth-ronhof-n249090",
"fuerth-roseggerstrasse-n295690",
"fuerth-rundfunkmuseum-c124750",
"fuerth-rundfunkmuseum-c253790",
"fuerth-rundfunkmuseum-n248830",
"fuerth-sack-c313120",
"fuerth-sack-c313140",
"fuerth-sack-c313170",
"fuerth-sack-n26720",
"fuerth-sack-n26730",
"fuerth-sack-n525550",
"fuerth-sack-n525560",
"fuerth-schickedanz_sportgelaende-n364760",
"fuerth-schiessanger-f493810",
"fuerth-schloss_burgfarrnbach-n343120",
"fuerth-schloss_burgfarrnbach-n343130",
"fuerth-schoen_klinik-f411960",
"fuerth-schoen_klinik-f411960",
"fuerth-schwabacher_strasse-c222680",
"fuerth-schwabacher_strasse-c254060",
"fuerth-schwabacher_strasse-c254080",
"fuerth-schwabacher_strasse-c254090",
"fuerth-schwabacher_strasse-c254130",
"fuerth-schwabacher_strasse-c284150",
"fuerth-schwabacher_strasse-c284210",
"fuerth-schwabacher_strasse-c284250",
"fuerth-schwabacher_strasse-f392430",
"fuerth-schwabacher_strasse-f392440",
"fuerth-schwabacher_strasse-n248570",
"fuerth-schwabacher_strasse-n248580",
"fuerth-schwabacher_strasse-n248590",
"fuerth-segelflieger-n264880",
"fuerth-selgros-f493770",
"fuerth-senkrechtaufnahme-n243380",
"fuerth-senkrechtaufnahme-n243390",
"fuerth-senkrechtaufnahme-n243400",
"fuerth-senkrechtaufnahme-n243410",
"fuerth-siebenbogenbruecke-f494070",
"fuerth-solarberg-c222360",
"fuerth-solarberg-c22410",
"fuerth-solarberg-c500170",
"fuerth-solarberg-c500180",
"fuerth-solarberg-f48190",
"fuerth-solarberg-f48210",
"fuerth-solarberg-n077780",
"fuerth-solarberg-n364810",
"fuerth-solarberg-n364830",
"fuerth-sonnenstrasse-c223040",
"fuerth-sportanlage-c253910",
"fuerth-sportanlage-c253920",
"fuerth-sportpark_ronhof-c564560",
"fuerth-sportpark_ronhof-f494300",
"fuerth-sportzentrum_kleeblatt-f494340",
"fuerth-spvgg_greuther_fuerth-c068940",
"fuerth-st__heinrich_kirche-c174230",
"fuerth-st__heinrich_kirche-f494010",
"fuerth-st__heinrich_kirche-f494020",
"fuerth-st__martin_kirche-f493870",
"fuerth-st__michael_kirche-f493820",
"fuerth-st__paul_kirche-f493990",
"fuerth-st__paul_kirche-f494030",
"fuerth-st__peter_und_paul_kirche-f493740",
"fuerth-stadeln-n077790",
"fuerth-stadeln-n296090",
"fuerth-stadion-c111830",
"fuerth-stadthalle_fuerth-f393050",
"fuerth-stadthalle_fuerth-f493830",
"fuerth-stadthalle-n295790",
"fuerth-stadthalle-n295800",
"fuerth-stadtpark__sued_-cd18130",
"fuerth-stadtpark_fuerth-f531100",
"fuerth-stadtpark-c222770",
"fuerth-stadtpark-c253820",
"fuerth-stadtpark-c254630",
"fuerth-stadtpark-c254640",
"fuerth-stadtpark-f411950",
"fuerth-staedtisches_klaerwerk_fuerth-c564570",
"fuerth-staedtisches_klaerwerk_fuerth-c564580",
"fuerth-steinach-c111900",
"fuerth-steinach-c216160",
"fuerth-steinach-c216170",
"fuerth-steinach-c216180",
"fuerth-steinach-c216240",
"fuerth-steinach-c216260",
"fuerth-steinach-n077820",
"fuerth-steinach-n249190",
"fuerth-steinach-n249200",
"fuerth-suedstadt_fuerth-f4180",
"fuerth-suedstadt-c254530",
"fuerth-suedstadt-f4130",
"fuerth-suedstadtpark-c136540",
"fuerth-suedstadtpark-c136610",
"fuerth-suedstadtpark-c136870",
"fuerth-suedstadtpark-c136880",
"fuerth-suedstadtpark-c254590",
"fuerth-suedstadtpark-c254600",
"fuerth-suedstadtpark-c254610",
"fuerth-suedstadtpark-f392400",
"fuerth-suedstadtpark-f411940",
"fuerth-suedstadtpark-f4160",
"fuerth-suedstadtpark-f494000",
"fuerth-suedstadtpark-s562380",
"fuerth-suedtstadtpark_fuerth-n530940",
"fuerth-suedwesttangente-c156990",
"fuerth-suedwesttangente-f392470",
"fuerth-suedwesttangente-f392910",
"fuerth-suedwesttangente-f392930",
"fuerth-sv_fuerth-poppenreuth-f554050",
"fuerth-tennisfreunde_gruen_weiss_fuerth-c564490",
"fuerth-theodor-heuss-bruecke-f392760",
"fuerth-trolli_arena-n077500",
"fuerth-uferpromenade-n364700",
"fuerth-uferstadt_fuerth-c564450",
"fuerth-uferstadt-n343050",
"fuerth-unten_links-f41320",
"fuerth-unterasbach-f48350",
"fuerth-unterfarrnbach-c221720",
"fuerth-unterfarrnbach-n364770",
"fuerth-unterfuerberg-n14740",
"fuerth-unterfuerberg-n14750",
"fuerth-vach-c221870",
"fuerth-vach-c221880",
"fuerth-vach-c221900",
"fuerth-vach-c221910",
"fuerth-vach-c222330",
"fuerth-vach-f41280",
"fuerth-vach-f41290",
"fuerth-vach-f41320",
"fuerth-vach-f41340",
"fuerth-vach-f41350",
"fuerth-vach-f48170",
"fuerth-vach-f48180",
"fuerth-vapiano-c215920",
"fuerth-vapiano-c215960",
"fuerth-vapiano-c215980",
"fuerth-verkehrsuebungsplatz_fuerth-f435410",
"fuerth-verkehrsuebungsplatz_fuerth-f435420",
"fuerth-waldmannsweiher-f494050",
"fuerth-wasserwerk_fuerth-c500250",
"fuerth-weihnachtsmarkt-bb8580",
"fuerth-weihnachtsmarkt-bb8600",
"fuerth-weihnachtsmarkt-bb8720",
"fuerth-weihnachtsmarkt-bb8770",
"fuerth-westvorstadt-f48300",
"fuerth-wiesengrund_fuerth-s562430",
"fuerth-wolf_butterback-c245550",
"fuerth-wolf_butterback-c245580",
"fuerth-wolf_butterback-c245600",
"fuerth-wolf_butterback-c245610",
"fuerth-wolf_butterback-c245620",
"fuerth-wolf_butterback-c245650",
"fuerth-wolf_butterback-c245720",
"fuerth-wolf_butterback-c245760",
"fuerth-wolfsgrubenmuehle-f494160",
"fuerth-wolfsgrubenmuehle-f494160",
"fuerth-wuerzburger_strasse-c157330",
"fuerth-wuerzburger_strasse-c157340",
"fuerth-wuerzburger_strasse-c157350",
"fuerth-wuerzburger_strasse-c157360",
"fuerth-wuerzburger_strasse-c157370",
"fuerth-wuerzburger_strasse-c157380",
"fuerth-wuerzburger_strasse-c157390",
"fuerth-wuerzburger_strasse-c157400",
"fuerth-wuerzburger_strasse-c157410",
"fuerth-wuerzburger_strasse-c157420",
"fuerth-wuerzburger_strasse-c157430",
"fuerth-wuerzburger_strasse-c157440",
"fuerth-wuerzburger_strasse-c157450",
"fuerth-wuerzburger_strasse-c157460",
"fuerth-wuerzburger_strasse-c157470",
"fuerth-wuerzburger_strasse-c157480",
"fuerth-wuerzburger_strasse-c157490",
"fuerth-wuerzburger_strasse-c157500",
"fuerth-wuerzburger_strasse-c157510",
"fuerth-wuerzburger_strasse-c157520",
"fuerth-wuerzburger_strasse-c157530",
"fuerth-wuerzburger_strasse-c157540",
"fuerth-wuerzburger_strasse-c157550",
"fuerth-wuerzburger_strasse-c157560",
"fuerth-wuerzburger_strasse-c221150",
"fuerth-yachthafen-c215830",
"fuerth-zirndorfer_bruecke-c500280",
"fuerth-zirndorf-f48330",
"fuerth-zug-c221170",
"fuerth-zug-c221180",
"fuessen-autobahn_a7-c502070",
"fuessen-festspielhaus_neuschwanstein-c501930",
"fuessen-festspielhaus_neuschwanstein-c502010",
"fuessen-festspielhaus_neuschwanstein-c502040",
"fuessen-forggensee-c501960",
"fuessen-fuessen_west-f500910",
"fuessen-fuessen_west-f500920",
"fuessen-fuessen-c501900",
"fuessen-fuessen-c501910",
"fuessen-fuessen-c501950",
"fuessen-fuessen-f500870",
"fuessen-fuessen-f500890",
"fuessen-hpfensee-c502050",
"fuessen-schloss_neuschwanstein-c501970",
"fuessen-schloss_neuschwanstein-c501980",
"fuessen-schwangau-c501920",
"fuessen-weissensee-c502090",
"fuessen-weissensee-f500940",
"gablingen-wullenwever-antenne-c500990",
"gablingen-wullenwever-antenne-f500460",
"gablingen-wullenwever-antennenanlage-n324190",
"gablingen-wullenwever-antennenanlage-n324210",
"gablingen-wullenwever-antennenanlage-n324240",
"gablingen-wullenwever-antennenanlage-n324260",
"garmisch-partenkirchen-1__fc_garmisch_stadion_am_groeben-c501620",
"garmisch-partenkirchen-alpen-c501530",
"garmisch-partenkirchen-alpen-c501590",
"garmisch-partenkirchen-alpen-c501640",
"garmisch-partenkirchen-alpen-c501660",
"garmisch-partenkirchen-alpen-c501690",
"garmisch-partenkirchen-alpen-c501700",
"garmisch-partenkirchen-alpen-c501710",
"garmisch-partenkirchen-alpen-c501720",
"garmisch-partenkirchen-alpen-c501730",
"garmisch-partenkirchen-alpen-c501780",
"garmisch-partenkirchen-alpen-c501790",
"garmisch-partenkirchen-alpen-c501820",
"garmisch-partenkirchen-alpen-c501830",
"garmisch-partenkirchen-alpen-c501840",
"garmisch-partenkirchen-alpen-c506290",
"garmisch-partenkirchen-alpen-c506300",
"garmisch-partenkirchen-alpen-c506320",
"garmisch-partenkirchen-alpen-c506330",
"garmisch-partenkirchen-alpen-f500650",
"garmisch-partenkirchen-alpen-f500700",
"garmisch-partenkirchen-alpen-f500740",
"garmisch-partenkirchen-alpen-f500760",
"garmisch-partenkirchen-alpen-f500770",
"garmisch-partenkirchen-alpen-f500780",
"garmisch-partenkirchen-alpen-f500800",
"garmisch-partenkirchen-alpen-f500810",
"garmisch-partenkirchen-alpen-f500820",
"garmisch-partenkirchen-alpengipfel-c501510",
"garmisch-partenkirchen-alpenvorland-c501860",
"garmisch-partenkirchen-alpenvorland-f500600",
"garmisch-partenkirchen-alpenvorland-f500610",
"garmisch-partenkirchen-alpenvorland-f501230",
"garmisch-partenkirchen-alpenvorland-f501240",
"garmisch-partenkirchen-bayerniederhofen-c501880",
"garmisch-partenkirchen-buching-c501870",
"garmisch-partenkirchen-eibsee-c501650",
"garmisch-partenkirchen-eibsee-c501670",
"garmisch-partenkirchen-eibsee-c501680",
"garmisch-partenkirchen-eibsee-f500750",
"garmisch-partenkirchen-forggensee-c501890",
"garmisch-partenkirchen-garmisch-partenkirchen-c501560",
"garmisch-partenkirchen-garmisch-partenkirchen-c501570",
"garmisch-partenkirchen-garmisch-partenkirchen-c501580",
"garmisch-partenkirchen-garmisch-partenkirchen-c501600",
"garmisch-partenkirchen-garmisch-partenkirchen-c501610",
"garmisch-partenkirchen-garmisch-partenkirchen-c501850",
"garmisch-partenkirchen-garmisch-partnkirchen-f500710",
"garmisch-partenkirchen-garmisch-partnkirchen-f500720",
"garmisch-partenkirchen-garmisch-partnkirchen-f500730",
"garmisch-partenkirchen-zugspitze-c501740",
"garmisch-partenkirchen-zugspitze-c501750",
"garmisch-partenkirchen-zugspitze-c501760",
"garmisch-partenkirchen-zugspitze-c501770",
"garmisch-partenkirchen-zugspitze-c501800",
"garmisch-partenkirchen-zugspitze-c506260",
"garmisch-partenkirchen-zugspitze-c506280",
"garmisch-partenkirchen-zuspitze-c501550",
"gastenfelden-gastenfelden-f42800",
"geiselhoering-geiselhoering-n521410",
"geiselhoering-geiselhoering-n521420",
"geiselhoering-gingkofen-n521460",
"geiselhoering-hainsbach-n521440",
"geiselhoering-hainsbach-n521450",
"geiselhoerung-geiselhoerung-f520890",
"geiselhoerung-geiselhoerung-f520900",
"geiselhoerung-kreisverkehr_bei_geiselhoering-f520910",
"geislohe-geislohe-f502290",
"geislohe-geislohe-f513750",
"geislohe-geislohe-f513760",
"geltendorf-arena_schloss_kaltenberg-c501200",
"geltendorf-arena_schloss_kaltenberg-c501230",
"geltendorf-kaltenberg-c501240",
"georgenbronn-georgenbronn-f374650",
"georgensgmuend-friedrichsgmuend-n273350",
"georgensgmuend-friedrichsgmuend-n273360",
"georgensgmuend-friedrichsgmuend-n273390",
"georgensgmuend-friedrichsgmuend-n273420",
"georgensgmuend-friedrichsgmuend-n273430",
"georgensgmuend-georgensgmuend-n273410",
"georgensgmuend-georgensgmuend-n273450",
"georgensgmuend-georgensgmuend-n273460",
"georgensgmuend-georgensgmuend-n273480",
"georgensgmuend-georgensgmuend-n273510",
"georgensgmuend-kleine_kapelle-n273570",
"georgensgmuend-maebenberg-n273530",
"georgensgmuend-maebenberg-n273580",
"georgensgmuend-oberheckenhofen-n321730",
"georgensgmuend-untersteinbach_ob_gmuend-c500410",
"georgensgmuend-untersteinbach_ob_gmuend-c500420",
"gera-ernsee-n351990",
"gera-gera-n351680",
"gera-gera-n351690",
"gera-gera-n351710",
"gera-gewerbegebiet-n352000",
"gera-grossaga-n352050",
"gera-historisches_bahnbetriebswerk-n351740",
"gera-hofwiesenpark-n351760",
"gera-hofwiesenpark-n351770",
"gera-hofwiesenpark-n351780",
"gera-hofwiesenpark-n351790",
"gera-hofwiesenpark-n351800",
"gera-hofwiesenpark-n351810",
"gera-hofwiesenpark-n351820",
"gera-hofwiesenpark-n351830",
"gera-hofwiesenpark-n351840",
"gera-hofwiesenpark-n351850",
"gera-hofwiesenpark-n351860",
"gera-industriegebiet_langenberg-n352010",
"gera-kunstsammlung-n351750",
"gera-lessen-n352040",
"gera-ringlokschuppen-n351730",
"gera-srh_wald-klinikum-n351890",
"gera-srh_wald-klinikum-n351900",
"gera-srh_wald-klinikum-n351930",
"gera-srh_wald-klinikum-n351950",
"gera-srh_wald-klinikum-n351960",
"gera-srh_wald-klinikum-n351970",
"gera-srh_wald-klinikum-n351980",
"gera-stadion_der_freundschaft-n351720",
"gerhardshofen-goettelhoef-n327690",
"gerhardshofen-rappoldshofen-n327730",
"gersthofen-freibad_gersthofen-c501020",
"gersthofen-gersthofer_wehr-c501030",
"gersthofen-gewerbegebiet_gersthofen-c501000",
"gersthofen-gewerbegebiet_gersthofen-c501010",
"gessmannszell-gessmannszell-f522070",
"glonn-frauenreuth-n513810",
"glonn-frauenreuth-n513820",
"glonn-muenster-n513830",
"glonn-muenster-n513840",
"gnotzheim-schloss_spielberg-n326280",
"gnotzheim-schloss_spielberg-n326290",
"gnotzheim-schloss_spielberg-n326300",
"gnotzheim-schloss_spielberg-n326330",
"gnotzheim-schloss_spielberg-n326360",
"gnotzheim-schloss_spielberg-n326390",
"gnotzheim-schloss_spielberg-n326420",
"gnotzheim-schloss_spielberg-n326460",
"gnotzheim-schloss_spielberg-n326500",
"goessweinstein-basilika_zur_heiligsten_dreifaltigkeit-n267980",
"goessweinstein-basilika_zur_heiligsten_dreifaltigkeit-n268010",
"goessweinstein-burg_goessweinstein-n267960",
"goessweinstein-burg_goessweinstein-n267970",
"goessweinstein-burg_goessweinstein-n267990",
"goessweinstein-burg_goessweinstein-n268000",
"goessweinstein-burg_goessweinstein-n268020",
"goessweinstein-hungenberg-f553420",
"goessweinstein-kohlstein-n276090",
"goessweinstein-kohlstein-n276100",
"goessweinstein-moritz-n276120",
"goessweinstein-moschendorf-f553440",
"goettelhof-goettelhof-f378590",
"gohren-gohren__campingplatz-c503320",
"gohren-gohren__hafen-c503330",
"gosberg-abfalldeponie_gosberg-f553620",
"gosberg-abfalldeponie_gosberg-f553630",
"gosberg-entsorgungsdeponie-n276630",
"gosberg-gosberg-f553600",
"gosberg-pinzberg-f553610",
"gosberg-wiesenthau-f553580",
"gosberg-wiesenthau-f553590",
"graefenberg-graefenberg-f38100",
"graefenberg-schotterwerke_bei_graefenberg-c314460",
"graefenberg-schotterwerke-f3880",
"graefenberg-schotterwerke-f3890",
"graefenberg-steinbruch_bei_graefenberg-c314240",
"graefenberg-steinbruch_bei_graefenberg-c314260",
"graefenberg-steinbruch_bei_graefenberg-c314280",
"graefenberg-steinbruch_bei_graefenberg-c314300",
"graefenberg-steinbruch_bei_graefenberg-c314310",
"graefenbuch-graefenbuch-f40270",
"gremsdorf-gremsdorf-n265390",
"gremsdorf-gremsdorf-n265400",
"gremsdorf-gremsdorf-n265410",
"gremsdorf-gremsdorf-n265420",
"gremsdorf-karpfenweiher_bei_gremsdorf-n268730",
"gremsdorf-krausenbechhofen-n265370",
"gremsdorf-krausenbechhofen-n265380",
"gremsdorf-poppenwind-n265360",
"groebenzell-lusssee-f481420",
"grossenseebach-grossenseebach-f4030",
"grossenseebach-grossenseebach-f4240",
"grosskarolinenfeld-tattenhausen-f512950",
"grosskrotzenburg-kraftwerk_staudiger-f372680",
"grosskrotzenburg-kraftwerk_staudiger-f372740",
"grosspuerschuetz-grosspuerschuetz-n356230",
"grossschwarzenlohe-grossschwarzenlohe-n29870",
"gruenenbach-saegewerk_schuettentobel-c502680",
"gruenenbach-saegewerk_schuettentobel-c502690",
"gruenenbach-saegewerk_schuettentobel-c502700",
"gruenmorsbach-winzenhohl-s561450",
"gunzendorf-gunzendorf-c560180",
"gunzendorf-gunzendorf-c560190",
"gunzenhausen-altmuehlsee-f421610",
"gunzenhausen-baugrube-c09960",
"gunzenhausen-baugrube-c09970",
"gunzenhausen-beseitigungsanstalt-c504960",
"gunzenhausen-brombachsee-c504940",
"gunzenhausen-feuerwache_naehe_gunzenhause-c09660",
"gunzenhausen-gunzenhausen-c214270",
"gunzenhausen-gunzenhausen-c214280",
"gunzenhausen-gunzenhausen-c214290",
"gunzenhausen-gunzenhausen-c214300",
"gunzenhausen-gunzenhausen-c214310",
"gunzenhausen-gunzenhausen-c214320",
"gunzenhausen-gunzenhausen-c214330",
"gunzenhausen-gunzenhausen-c214340",
"gunzenhausen-gunzenhausen-c504930",
"gunzenhausen-gunzenhausen-f502240",
"gunzenhausen-gunzenhausen-f502250",
"gunzenhausen-gunzenhausen-f502270",
"gunzenhausen-krankenhaus-c09650",
"gunzenhausen-lithon_plus_steinmanufaktur-f502220",
"gunzenhausen-staedtereinigung_rudolf_ernst-c504900",
"gunzenhausen-staedtereinigung_rudolf_ernst-c504920",
"gustenfelden-gustenfelden-f513850",
"gutenborn-lonzig-n352070",
"gutenstetten-bei_gutenstetten-n327780",
"gutenstetten-gutenstetten-n328010",
"gutenstetten-gutenstetten-n328020",
"gutenstetten-landschloesschen_rockenbach-n27430",
"gutenstetten-lerchenhoechstadt-n27490",
"gutenstetten-obersteinbach-n27480",
"gutenstetten-reinhardshofen-n327750",
"gutenstetten-rockenbach-n27390",
"gutenstetten-rockenbach-n27420",
"gutenstetten-rockenbach-n27440",
"gutenstetten-rockenbach-n327770",
"haeslabronn-haeslabronn-f40280",
"hahnenwald-planungsprojekt_aparthotel_am_hahnenwald-f374700",
"hahnenwald-planungsprojekt_aparthotel_am_hahnenwald-f374720",
"haibach-freilwillige_feuerwehr_haibach-f371750",
"haibach-haibach-f371770",
"haimendorfer_forst-sandgrube-c223750",
"haimendorfer_forst-sandgrube-c223820",
"haimendorfer_forst-sandgrube-c224040",
"haimendorfer_forst-sandgrube-c224180",
"haimendorfer_forst-sandgrube-c224380",
"haimendorfer_forst-sandgrube-c224390",
"hainhof-hainhof-f42750",
"hallgarten-hallgarten-f374760",
"hallgarten-hallgarten-f374770",
"hammerbach-lindenhof_erlebnishof-n520230",
"handzell-handzell-n514770",
"handzell-handzell-n514790",
"happurg-flusslauf_bei_happurg-f462410",
"happurg-happurger_stausee-f423390",
"happurg-happurger_stausee-f442980",
"happurg-happurger_stausee-f443000",
"happurg-happurger_stausee-f443010",
"happurg-happurger_stausee-f443020",
"happurg-happurg-f453370",
"happurg-happurg-f453450",
"happurg-happurg-f453490",
"happurg-happurg-f453510",
"happurg-happurg-f453530",
"happurg-happurg-f462370",
"happurg-kainsbach_bei_happurg-f423380",
"happurg-oberbecken_am_happurger_see-f423410",
"happurg-oberbecken_happurg-f432810",
"happurg-umspannwerk_happurg-f453490",
"hausen-buch-n511400",
"hausen-hausen-f553670",
"hausen-hausen-f553680",
"hausen-sippenau-n511390",
"hechelbach-hechelbach-f42440",
"heideck-altenheideck-n291130",
"heideck-tautenwind-n291110",
"heidelberg-altstadt_heidelberg-f376800",
"heidelberg-altstadt-f376740",
"heidelberg-altstadt-f376770",
"heidelberg-altstadt-f376780",
"heidelberg-altstadt-f376810",
"heidelberg-altstadt-f376830",
"heidelberg-handschuhsheim-f376910",
"heidelberg-hauptbahnhof-f377750",
"heidelberg-heidelberger_schloss-f376660",
"heidelberg-heidelberger_schloss-f376690",
"heidelberg-heidelberger_schloss-f376710",
"heidelberg-heidelberger_schloss-f376720",
"heidelberg-heidelberger_schloss-f376750",
"heidelberg-heidelberger_schloss-f376870",
"heidelberg-heidelberg-f376530",
"heidelberg-heidelberg-f376550",
"heidelberg-heidelberg-f376570",
"heidelberg-heidelberg-f376590",
"heidelberg-heidelberg-f376610",
"heidelberg-heidelberg-f376640",
"heidelberg-heidelberg-f376700",
"heidelberg-heidelberg-f376820",
"heidelberg-heidelberg-f376850",
"heidelberg-heidelberg-f376890",
"heidelberg-heidelberg-f376900",
"heidelberg-heiliggeistkirche-f376680",
"heidelberg-klaerwerk_zv_schwetzingen-f377010",
"heidelberg-klinikum-f376520",
"heidelberg-ladenburg-f376960",
"heidelberg-max-planck-institut_fuer_astronomie-f377780",
"heidelberg-schifffahrt_am_rhein-f377020",
"heidelberg-stauwehr_wieblingen-f376490",
"heidelberg-universitaetsklinikum_heidelberg-f376500",
"heidelberg-universitaetsklinikum_heidelberg-f376630",
"heidelberg-volkshochschule-f377770",
"heidelberg-waltzkuppel-f377790",
"heidelberg-wehrsteg_wieblingen-f376510",
"heidelberg-wehrsteg_wieblingen-f376580",
"heidelberg-wehrsteg_wieblingen-f376600",
"heidelberg-weststadt-f377760",
"heidelberg-wieblingen-f376930",
"heidelberg-x-house-f376540",
"heidenheim-rohrach-n326260",
"heiligenstadt-heiligenstadt-n267130",
"heiligenstadt-heiligenstadt-n267140",
"heiligenstadt-heiligenstadt-n267150",
"heiligenstadt-schloss_greifenstein-n267000",
"heiligenstadt-schloss_greifenstein-n267020",
"heiligenstadt-schloss_greifenstein-n267030",
"heiligenstadt-schloss_greifenstein-n267050",
"heiligenstadt-schloss_greifenstein-n267060",
"heiligenstadt-schloss_greifenstein-n267080",
"heiligenstadt-schloss_greifenstein-n267090",
"heiligenstadt-schloss_greifenstein-n267120",
"heimhofen-kapelle_maria_opferung-c502760",
"hemau-eichlberg-n511030",
"hemau-eichlberg-n511050",
"hemau-flinksberg-n511080",
"hemau-hemau-f510630",
"hemau-hemau-f510640",
"hemau-hemau-f510650",
"hemau-hemau-f510660",
"hemau-hemau-f510670",
"hemau-neunkirchen-n511060",
"henfenfeld-henfenfeld-c313490",
"hengersberg-hengersberg-n522610",
"hengersberg-hengersberg-n522640",
"hengersberg-hengersberg-n522650",
"hengersberg-hengersberg-n522660",
"hengersberg-raststaette_ohetal-n522590",
"hengersberg-raststaette_ohetal-n522630",
"hengersberg-solarpark_hengersberg-n522670",
"hengersberg-unterellenbach-n522690",
"herbertshofen-lech_stahlwerke_gmbh-c500930",
"herbertshofen-lech_stahlwerke_gmbh-c500940",
"herbertshofen-lech_stahlwerke_gmbh-c500950",
"herbrechtingen-herbrechtingen-f502060",
"herbrechtingen-herbrechtingen-f502070",
"herbrechtingen-herbrechtingen-f502080",
"herbrechtingen-herbrechtingen-f502090",
"herbrechtingen-kloster_anhausen-c504750",
"herbrechtingen-steinbruch_mergelstetten-f502120",
"heroldsberg-heroldsberg-f38180",
"heroldsberg-heroldsberg-f463010",
"heroldsberg-heroldsberg-f463020",
"heroldsberg-heroldsberg-f463030",
"heroldsberg-heroldsberg-f463040",
"herrieden-kompostieranlage_bei_seebronn-f43800",
"herrngiersdorf-sittelsdorf-n511430",
"herrngiersdorf-sittelsdorf-n511440",
"herrngiersdorf-walpersdorf-n511450",
"herrngiersdorf-walpersdorf-n511460",
"herrngiersdorf-walpersdorf-n511480",
"hersbruck-altstadtkern-c313710",
"hersbruck-altstadtkern-c313740",
"hersbruck-altstadtkern-c313750",
"hersbruck-altstadtkern-c313760",
"hersbruck-finanzamt_hersbruck-f462430",
"hersbruck-freilwillige_feuerwehr_hersbruck-f423440",
"hersbruck-freiwillige_feuerwehr_hersbruck-f443050",
"hersbruck-friedhof_hersbruck-f423450",
"hersbruck-happurger_strasse-c313670",
"hersbruck-hersbruck-c17300",
"hersbruck-hersbruck-c17440",
"hersbruck-hersbruck-c17470",
"hersbruck-hersbruck-c17480",
"hersbruck-hersbruck-c17600",
"hersbruck-hersbruck-c17740",
"hersbruck-hersbruck-c17750",
"hersbruck-hersbruck-c17780",
"hersbruck-hersbruck-c17790",
"hersbruck-hersbruck-f443040",
"hersbruck-hohenstadt__hersbruck_-f462350",
"hersbruck-hohenstadt__hersbruck_-f462360",
"hersbruck-krankenhaus_hersbruck-f462440",
"hersbruck-kreisverkehr_altenstittenbach-f432850",
"hersbruck-kuehnhofen-c313810",
"hersbruck-kuehnhofen-f462450",
"hersbruck-michelsberg-c313780",
"hersbruck-unterkrumbach_bei_hersbruck-f423480",
"herzogenaurach-adi_dassler_sportplatz-n061390",
"herzogenaurach-adidas_headquarters-cb81970",
"herzogenaurach-adidas_headquarters-n268740",
"herzogenaurach-adidas_headquarters-n268750",
"herzogenaurach-adidas_headquarters-n268760",
"herzogenaurach-adidas_headquarters-n268770",
"herzogenaurach-adidas_headquarters-n268780",
"herzogenaurach-adidas_headquarters-n268790",
"herzogenaurach-adidas_headquarters-n268800",
"herzogenaurach-adidas_headquarters-n268810",
"herzogenaurach-adidas_headquarters-n268820",
"herzogenaurach-adidas_headquarters-n268830",
"herzogenaurach-adidas_headquarters-n268840",
"herzogenaurach-adidas_headquarters-n268850",
"herzogenaurach-adidas_headquarters-n268860",
"herzogenaurach-adidas_headquarters-n268870",
"herzogenaurach-adidas_headquarters-n268880",
"herzogenaurach-adidas_headquarters-n268890",
"herzogenaurach-adidas_headquarters-n268900",
"herzogenaurach-adidas_headquarters-n268910",
"herzogenaurach-adidas_headquarters-n268920",
"herzogenaurach-adidas_headquarters-n268930",
"herzogenaurach-adidas_headquarters-n268940",
"herzogenaurach-adidas_headquarters-n268950",
"herzogenaurach-adidas_headquarters-n268960",
"herzogenaurach-adidas_headquarters-n268970",
"herzogenaurach-adidas_headquarters-n268980",
"herzogenaurach-adidas_headquarters-n268990",
"herzogenaurach-adidas_headquarters-n269000",
"herzogenaurach-adidas_headquarters-n269040",
"herzogenaurach-adidas_headquarters-n269050",
"herzogenaurach-adidas_headquarters-n269060",
"herzogenaurach-adidas_headquarters-n269070",
"herzogenaurach-adidas_headquarters-n269150",
"herzogenaurach-adidas_headquarters-n269190",
"herzogenaurach-adidas_headquarters-n269200",
"herzogenaurach-adidas_headquarters-n269210",
"herzogenaurach-adidas_headquarters-n269220",
"herzogenaurach-autobahnbruecke-n530040",
"herzogenaurach-autobahnbruecke-n530060",
"herzogenaurach-autobahnkreuz_a3___a73-f520320",
"herzogenaurach-bauernhof-c1620",
"herzogenaurach-bauernhof-c1630",
"herzogenaurach-baustoffe-c158990",
"herzogenaurach-baustoffhandel-n269230",
"herzogenaurach-bei_erlangen-n365130",
"herzogenaurach-bruecke_bei_herzogenaurach-n328230",
"herzogenaurach-burgstall-f411240",
"herzogenaurach-burgstall-f411250",
"herzogenaurach-burgstall-f411260",
"herzogenaurach-deponie_herzogenaurach-f411340",
"herzogenaurach-deponie_herzogenaurach-f411350",
"herzogenaurach-deponie_herzogenaurach-f555760",
"herzogenaurach-dorf-c21140",
"herzogenaurach-dorf-c21150",
"herzogenaurach-dorf-c21160",
"herzogenaurach-fahrzeuge_wormser-c158650",
"herzogenaurach-falkendorf-f411550",
"herzogenaurach-flugplatz_herzogenaurach-f41870",
"herzogenaurach-flugplatz_herzogenaurach-n056620",
"herzogenaurach-flugplatz-c159270",
"herzogenaurach-gewerbegebiet_kuhwasen-f411070",
"herzogenaurach-gewerbegebiet_kuhwasen-f411100",
"herzogenaurach-gewerbegebiet_kuhwasen-f411370",
"herzogenaurach-gewerbegebiet_nord_ii-f41940",
"herzogenaurach-gewerbegebiet-n269140",
"herzogenaurach-gewerbepark_hessdorf-f411380",
"herzogenaurach-gewerbepark_hessdorf-f411400",
"herzogenaurach-golf_club_herzogenaurach-f555780",
"herzogenaurach-golf-club_herzogenaurach_ev-f411230",
"herzogenaurach-golf-club_herzogenaurach_ev-f411290",
"herzogenaurach-haeusling-c22110",
"herzogenaurach-haeusling-c22120",
"herzogenaurach-haeusling-n365100",
"herzogenaurach-haundorf-n2630",
"herzogenaurach-heissluftballon-n358580",
"herzogenaurach-heissluftballon-n358630",
"herzogenaurach-herzo_base-c116340",
"herzogenaurach-herzo_base-c116350",
"herzogenaurach-herzo_base-c158520",
"herzogenaurach-herzo_base-c158540",
"herzogenaurach-herzo_base-c158720",
"herzogenaurach-herzo_base-c285070",
"herzogenaurach-herzo_base-c285160",
"herzogenaurach-herzo_base-c285190",
"herzogenaurach-herzo_base-cb81630",
"herzogenaurach-herzo_base-f411000",
"herzogenaurach-herzo_base-f411010",
"herzogenaurach-herzo_base-f411020",
"herzogenaurach-herzo_base-f411060",
"herzogenaurach-herzo_base-f411360",
"herzogenaurach-herzo_base-f41720",
"herzogenaurach-herzo_base-f41720",
"herzogenaurach-herzo_base-f41760",
"herzogenaurach-herzo_base-f520280",
"herzogenaurach-herzo_base-f555590",
"herzogenaurach-herzo_base-f555600",
"herzogenaurach-herzo_base-f555610",
"herzogenaurach-herzo_base-f555620",
"herzogenaurach-herzo_base-f555630",
"herzogenaurach-herzo_base-f555640",
"herzogenaurach-herzo_base-f555650",
"herzogenaurach-herzo_base-f555660",
"herzogenaurach-herzo_base-f555670",
"herzogenaurach-herzo_base-f555680",
"herzogenaurach-herzo_base-f555690",
"herzogenaurach-herzo_base-f555710",
"herzogenaurach-herzo_base-f555720",
"herzogenaurach-herzo_base-f555730",
"herzogenaurach-herzo_base-f555740",
"herzogenaurach-herzo_base-f555750",
"herzogenaurach-herzo_base-n364940",
"herzogenaurach-herzo_base-n364950",
"herzogenaurach-herzo_base-n364960",
"herzogenaurach-herzo_base-n365000",
"herzogenaurach-herzo_base-n365060",
"herzogenaurach-herzo_base-n365070",
"herzogenaurach-herzobase-f411030",
"herzogenaurach-herzobase-f411030",
"herzogenaurach-herzobase-f411130",
"herzogenaurach-herzogenaurach-c158510",
"herzogenaurach-herzogenaurach-c158550",
"herzogenaurach-herzogenaurach-c158560",
"herzogenaurach-herzogenaurach-c158700",
"herzogenaurach-herzogenaurach-c158750",
"herzogenaurach-herzogenaurach-c158770",
"herzogenaurach-herzogenaurach-c158780",
"herzogenaurach-herzogenaurach-c158860",
"herzogenaurach-herzogenaurach-c158880",
"herzogenaurach-herzogenaurach-c159050",
"herzogenaurach-herzogenaurach-c159060",
"herzogenaurach-herzogenaurach-c159110",
"herzogenaurach-herzogenaurach-c159250",
"herzogenaurach-herzogenaurach-c163860",
"herzogenaurach-herzogenaurach-c163890",
"herzogenaurach-herzogenaurach-c163920",
"herzogenaurach-herzogenaurach-c163930",
"herzogenaurach-herzogenaurach-c163960",
"herzogenaurach-herzogenaurach-c188810",
"herzogenaurach-herzogenaurach-c188820",
"herzogenaurach-herzogenaurach-c188880",
"herzogenaurach-herzogenaurach-c188910",
"herzogenaurach-herzogenaurach-c188950",
"herzogenaurach-herzogenaurach-c188960",
"herzogenaurach-herzogenaurach-c188970",
"herzogenaurach-herzogenaurach-c189050",
"herzogenaurach-herzogenaurach-c189080",
"herzogenaurach-herzogenaurach-c189090",
"herzogenaurach-herzogenaurach-c189100",
"herzogenaurach-herzogenaurach-c189120",
"herzogenaurach-herzogenaurach-c189140",
"herzogenaurach-herzogenaurach-c189180",
"herzogenaurach-herzogenaurach-c189190",
"herzogenaurach-herzogenaurach-c189210",
"herzogenaurach-herzogenaurach-c209070",
"herzogenaurach-herzogenaurach-c209080",
"herzogenaurach-herzogenaurach-c209090",
"herzogenaurach-herzogenaurach-c209100",
"herzogenaurach-herzogenaurach-c209110",
"herzogenaurach-herzogenaurach-c209120",
"herzogenaurach-herzogenaurach-c209160",
"herzogenaurach-herzogenaurach-c209180",
"herzogenaurach-herzogenaurach-c209190",
"herzogenaurach-herzogenaurach-c209220",
"herzogenaurach-herzogenaurach-c209230",
"herzogenaurach-herzogenaurach-c209240",
"herzogenaurach-herzogenaurach-c209250",
"herzogenaurach-herzogenaurach-c209260",
"herzogenaurach-herzogenaurach-c222130",
"herzogenaurach-herzogenaurach-c227610",
"herzogenaurach-herzogenaurach-c285140",
"herzogenaurach-herzogenaurach-c285150",
"herzogenaurach-herzogenaurach-c285170",
"herzogenaurach-herzogenaurach-cb81840",
"herzogenaurach-herzogenaurach-f404530",
"herzogenaurach-herzogenaurach-f411050",
"herzogenaurach-herzogenaurach-f411140",
"herzogenaurach-herzogenaurach-f411330",
"herzogenaurach-herzogenaurach-f41800",
"herzogenaurach-herzogenaurach-f41950",
"herzogenaurach-herzogenaurach-f41960",
"herzogenaurach-herzogenaurach-f41980",
"herzogenaurach-herzogenaurach-f41990",
"herzogenaurach-herzogenaurach-f494890",
"herzogenaurach-herzogenaurach-f494990",
"herzogenaurach-herzogenaurach-f495000",
"herzogenaurach-herzogenaurach-n014020",
"herzogenaurach-herzogenaurach-n014070",
"herzogenaurach-herzogenaurach-n061470",
"herzogenaurach-herzogenaurach-n2610",
"herzogenaurach-herzogenaurach-n2620",
"herzogenaurach-herzogenaurach-n364970",
"herzogenaurach-herzogenaurach-n364980",
"herzogenaurach-herzogenaurach-n364990",
"herzogenaurach-herzogenaurach-n365010",
"herzogenaurach-herzogenaurach-n365020",
"herzogenaurach-in_der_reuth-cb81880",
"herzogenaurach-karpfenweiher_am_aischgrund-c285390",
"herzogenaurach-karpfenweiher-cb82160",
"herzogenaurach-karpfenweiher-f385280",
"herzogenaurach-karpfenweiher-f411430",
"herzogenaurach-karpfenweiher-f411490",
"herzogenaurach-karpfenweiher-f411500",
"herzogenaurach-karpfenweiher-f411520",
"herzogenaurach-karpfenweiher-f411540",
"herzogenaurach-karpfenweiher-f4210",
"herzogenaurach-karpfenweiher-f485470",
"herzogenaurach-karpfenweiher-f485470",
"herzogenaurach-karpfenweiher-n358640",
"herzogenaurach-klaerwerk_herzogenaurach-f555570",
"herzogenaurach-klaerwerk_herzogenaurach-f555820",
"herzogenaurach-kornfeld-f41730",
"herzogenaurach-kornfeld-f41730",
"herzogenaurach-kreisverkehr-c285180",
"herzogenaurach-kreisverkehr-n365040",
"herzogenaurach-landebahn-n056640",
"herzogenaurach-landschaft-c285010",
"herzogenaurach-landwirtschaft-f494970",
"herzogenaurach-naehe_herzogenaurach-c137450",
"herzogenaurach-naehe_herzogenaurach-c159120",
"herzogenaurach-natur_und_bruecke_bei_herzogenaurach-cb9590",
"herzogenaurach-neubau_erschliessung_herzogenaurach-c158580",
"herzogenaurach-neubau_erschliessung_herzogenaurach-c158590",
"herzogenaurach-neuses-f555580",
"herzogenaurach-novina_hotel-cb82020",
"herzogenaurach-novina_hotel-n061310",
"herzogenaurach-novina_hotel-n061330",
"herzogenaurach-novina_hotel-n061350",
"herzogenaurach-novina_hotel-n061440",
"herzogenaurach-novina_hotel-n061520",
"herzogenaurach-olympiaring_herzogenaurach_-f411090",
"herzogenaurach-olympiaring_herzogenaurach_-f411110",
"herzogenaurach-olympiaring_herzogenaurach_-f411120",
"herzogenaurach-pferdekoppel-c285410",
"herzogenaurach-pferdekoppel-c285420",
"herzogenaurach-pferdekoppel-c285430",
"herzogenaurach-puma_ag-f41780",
"herzogenaurach-puma_ag-f41790",
"herzogenaurach-puma_headquaters-c05790",
"herzogenaurach-puma_headquaters-c158890",
"herzogenaurach-puma_headquaters-c158950",
"herzogenaurach-puma_headquaters-cb81680",
"herzogenaurach-puma_headquaters-n269010",
"herzogenaurach-puma_headquaters-n269020",
"herzogenaurach-puma_headquaters-n269030",
"herzogenaurach-puma_headquaters-n269080",
"herzogenaurach-puma_headquaters-n269090",
"herzogenaurach-puma_headquaters-n269100",
"herzogenaurach-puma_headquaters-n269110",
"herzogenaurach-puma_headquaters-n269120",
"herzogenaurach-puma_headquaters-n269130",
"herzogenaurach-puma_headquaters-n269160",
"herzogenaurach-puma_headquaters-n269170",
"herzogenaurach-puma_headquaters-n269180",
"herzogenaurach-puma-f41770",
"herzogenaurach-quad-rennbahn-c163900",
"herzogenaurach-rapsfeld-c21190",
"herzogenaurach-rastplatz-c158670",
"herzogenaurach-raststaette_aurach-f520290",
"herzogenaurach-reha-klinik-c163950",
"herzogenaurach-schaeffler_ag_-_stammwerk-f411190",
"herzogenaurach-schaeffler_ag_-_stammwerk-f411200",
"herzogenaurach-schaeffler_ag_-_stammwerk-f411210",
"herzogenaurach-schaeffler_ag_-_stammwerk-f411220",
"herzogenaurach-schaeffler_ag_-_stammwerk-f411320",
"herzogenaurach-schaeffler_ag-f411180",
"herzogenaurach-scheune_bei_herzogenaurach-f411480",
"herzogenaurach-schwimmbad_herzogenaurach-f41970",
"herzogenaurach-spargelanbau-f494910",
"herzogenaurach-spargelanbau-f494910",
"herzogenaurach-spielanlage-c116300",
"herzogenaurach-sportflugplatz_edqh-f41810",
"herzogenaurach-sportflugplatz_edqh-f41820",
"herzogenaurach-sportflugplatz_edqh-f41850",
"herzogenaurach-sportflugplatz_edqh-f41860",
"herzogenaurach-sportflugplatz_edqh-f41880",
"herzogenaurach-sportflugplatz_edqh-f41890",
"herzogenaurach-sportflugplatz_edqh-f41910",
"herzogenaurach-sportflugplatz_edqh-f41930",
"herzogenaurach-sportflugplatz_in_herzogenaurach-f41920",
"herzogenaurach-sportflugplatz_in_herzogenaurach-f41920",
"herzogenaurach-steudach-c22160",
"herzogenaurach-steudach-c22170",
"herzogenaurach-untermembach-f411410",
"herzogenaurach-untermembach-f411420",
"herzogenaurach-untermembach-f411450",
"herzogenaurach-welkenbach-f41830",
"herzogenaurach-welkenbach-f41840",
"herzogenaurach-wildtiere-f411460",
"hessdorf-autobahnbaustelle_bei_hessdorf-f456790",
"hessdorf-autobahnbaustelle_bei_hessdorf-f472700",
"hessdorf-autobahnbaustelle_bei_hessdorf-f472710",
"hessdorf-autobahnbaustelle_bei_hessdorf-f472720",
"hessdorf-hessdorf-c255150",
"hessdorf-hessdorf-c255160",
"hessdorf-hessdorf-c255170",
"hessdorf-hessdorf-f456750",
"hessdorf-hessdorf-f456790",
"hessdorf-hessdorf-f456810",
"hessdorf-hessdorf-f472730",
"hessdorf-hessdorf-f485450",
"hessdorf-hessdorf-f494810",
"hessdorf-hessdorf-f494840",
"hessdorf-hessdorf-f494860",
"hessdorf-hessdorf-n276930",
"hessdorf-mittelmembach-f456930",
"hessdorf-mittelmembach-n277010",
"hessdorf-untermembach-f456850",
"hessdorf-untermembach-f456890",
"hessdorf-untermembach-n269340",
"hessdorf-untermembach-n269350",
"hessdorf-untermembach-n269360",
"hessdorf-untermembach-n269370",
"hessdorf-wehrkirche_hannberg-c285360",
"hilpoltstein-burgruine_hilpoltstein-f484160",
"hilpoltstein-burgruine_hilpoltstein-f484170",
"hilpoltstein-burgruine_hilpoltstein-f484200",
"hilpoltstein-fuchsmuehle-f48650",
"hilpoltstein-hilpoltstein-f484130",
"hilpoltstein-hilpoltstein-f484180",
"hilpoltstein-karpfenweiher_bei_unterroedel-f48660",
"hilpoltstein-kirche_hilpoltstein-f484160",
"hilpoltstein-kirche_hilpoltstein-f484200",
"hilpoltstein-klaeranlage_hilpoltstein-f48640",
"hilpoltstein-oberroedel-f48670",
"hilpoltstein-oberroedel-f48680",
"hiltpoltstein-hiltpoltstein-c314330",
"hiltpoltstein-hiltpoltstein-c314360",
"hiltpoltstein-hiltpoltstein-c314370",
"hiltpoltstein-hiltpoltstein-c314380",
"hiltpoltstein-hiltpoltstein-c314400",
"hiltpoltstein-hiltpoltstein-c314410",
"hiltpoltstein-hiltpoltstein-c314420",
"hiltpoltstein-hiltpoltstein-c314430",
"hiltpoltstein-obstbaumplantage-c314200",
"hochstahl-hochstahl-n35230",
"hoechstadt_an_der_aisch-etzelskirchen-n265430",
"hoechstadt_an_der_aisch-friedhof-n265440",
"hoechstadt_an_der_aisch-gymnasium-n265460",
"hoechstadt_an_der_aisch-hoechstadt_an_der_aisch-n265450",
"hoechstadt_an_der_aisch-hoechstadt_an_der_aisch-n27340",
"hoechstadt_an_der_aisch-hoechstadt_an_der_aisch-n27350",
"hoechstadt_an_der_aisch-muehlhausen-n265470",
"hoechstadt_an_der_aisch-schloss_hoechstadt-n27360",
"hoechstadt_an_der_aisch-schloss_hoechstadt-n27370",
"hoegling-autobahn_a6_bei_hoegling-f422430",
"hoegling-autobahn_a6_bei_hoegling-f422500",
"hoegling-bruecke_bei_hoegling-f432400",
"hoegling-bruecke_bei_hoegling-f432470",
"hoegling-huettenhof_bei_hoegling-f422460",
"hoehenspeissenberg-friedhof_hoehenspeisenberg-c501390",
"hoehenspeissenberg-hoehenspeissenberg-c501380",
"hoehenspeissenberg-wetterradar_hoehenspeissenberg-c501370",
"hoehenspeissenberg-wetterradar_hoehenspeissenberg-c501410",
"hoehenspeissenberg-wetterradar_hoehenspeissenberg-c501420",
"hoerhof-hoerhof-f42450",
"hoerlbach-st__oswald_kirche-c500480",
"hoerlbach-st__oswald_kirche-c500490",
"hoerlbach-st__oswald_kirche-c500500",
"hoersteiner_see-camping-f372640",
"hoersteiner_see-camping-f372650",
"hoersteiner_see-camping-f372660",
"hoettingen-hoettingen-n291190",
"hoettingen-oberndorf-n291260",
"hoettingen-ottmarsfeld-n273210",
"hoettingen-ottmarsfeld-n291240",
"hof-epplas-f551720",
"hof-funkanlage-n351050",
"hof-funkanlage-n351080",
"hof-funkanlage-n351100",
"hof-funkanlage-n351110",
"hof-funkanlage-n351120",
"hof-funkanlage-n351140",
"hof-funkanlage-n351150",
"hof-funkanlage-n351170",
"hof-funkanlage-n351190",
"hof-funkanlage-n351240",
"hof-gewerbegebiet_hof-f551680",
"hof-hartsteinwerke_hof-n351210",
"hof-hof_-_botanischer_garten-n550700",
"hof-hof_-_bundesstrasse_b15-f551730",
"hof-hof_-_eisstadion-f551530",
"hof-hof_-_eisstadion-n550680",
"hof-hof_-_eisstadion-n550710",
"hof-hof_-_hochschule_fuer_den_oeffentlichen_dienst-n550730",
"hof-hof_-_lettenbachsee-n550720",
"hof-hof_-_michaeliskirche-n550670",
"hof-hof_-_michaeliskirche-n550740",
"hof-hof_-_michaeliskirche-n550750",
"hof-hof_-_michaeliskirche-n550770",
"hof-hof_-_michaeliskirche-n550780",
"hof-hof_-_michaeliskirche-n550790",
"hof-hof_-_michaeliskirche-n550800",
"hof-hof_-_spedition_dachser-f551690",
"hof-hof_hauptbahnhof-f551660",
"hof-hof-f551490",
"hof-hof-f551500",
"hof-hof-f551520",
"hof-hof-f551540",
"hof-hof-f551570",
"hof-hof-f551590",
"hof-hof-f551600",
"hof-hof-f551620",
"hof-hof-f551630",
"hof-hof-f551640",
"hof-hof-f551670",
"hof-hof-n550640",
"hof-hof-n550650",
"hof-hof-n550760",
"hof-koeditz-n351260",
"hof-textilgruppe_hof-f551580",
"hof-untreusee_in_hof-f551470",
"hof-untreusee_in_hof-f551480",
"hof-windrad_bei_hof-n351280",
"hof-windrad_bei_hof-n351290",
"hof-windraeder_bei_hof-n351300",
"hohenau-hohenau-f42580",
"hohenkemnath-autobahn_a6_hohenkemnath-f422980",
"hohenkemnath-hohenkemnath-f422990",
"hohenroth-hohenroth-f40180",
"huettendorf-huettendorf-f41300",
"huettendorf-huettendorf-f41310",
"huettendorf-huettendorf-f41360",
"igensdorf-mittelruesselbach-c314190",
"illertissen-illertissen-f501750",
"illertissen-illertissen-f501760",
"illertissen-illertissen-f501770",
"illerzell-illerzell-f501890",
"ingelheim_am_rhein-ingelheim_am_rhein-f374870",
"ingelheim_am_rhein-ingelheim_am_rhein-f374880",
"ingelheim_am_rhein-ingelheim_am_rhein-f374890",
"ingolstadt-altstadt-f483820",
"ingolstadt-altstadt-f483830",
"ingolstadt-altstadt-f483850",
"ingolstadt-altstadt-f483860",
"ingolstadt-arzneipflanzengarten-f483360",
"ingolstadt-audi_sportpark-f483710",
"ingolstadt-audi-f483930",
"ingolstadt-audi-f483950",
"ingolstadt-bayerische_polizeimuseum-f483800",
"ingolstadt-donau-city-center-f483420",
"ingolstadt-flughafen_ingolstadt-f483510",
"ingolstadt-flughafen_ingolstadt-f483520",
"ingolstadt-freibad_gaimersheim-f483980",
"ingolstadt-gaimersheim-f483960",
"ingolstadt-gaimersheim-f483970",
"ingolstadt-gewerbegebiet_ingolstadt_sued-f483740",
"ingolstadt-gewerbegebiet_ingolstadt-f483430",
"ingolstadt-gewerbegebiet_ingolstadt-f483440",
"ingolstadt-gewerbegebiet_ingolstadt-f483450",
"ingolstadt-hindenburgpark-f483410",
"ingolstadt-ingolstadt_nord-f483400",
"ingolstadt-ingolstadt-f483350",
"ingolstadt-ingolstadt-f483360",
"ingolstadt-ingolstadt-f483470",
"ingolstadt-kirche_bei_ingolstadt-f483470",
"ingolstadt-klaeranlage_manching-f483700",
"ingolstadt-liebfrauenmuenster-f483340",
"ingolstadt-liebfrauenmuenster-f483340",
"ingolstadt-liebfrauenmuenster-f483370",
"ingolstadt-liebfrauenmuenster-f483380",
"ingolstadt-liebfrauenmuenster-f483380",
"ingolstadt-liebfrauenmuenster-f483840",
"ingolstadt-liebfrauenmuenster-f483870",
"ingolstadt-liebfrauenmuenster-f483880",
"ingolstadt-liebfrauenmuenster-f483880",
"ingolstadt-liebfrauenmuenster-f483900",
"ingolstadt-luftwaffe-f483650",
"ingolstadt-neues_schloss-f483330",
"ingolstadt-neues_schloss-f483780",
"ingolstadt-neues_schloss-f483790",
"ingolstadt-neues_schloss-f483790",
"ingolstadt-rathhausplatz-f483350",
"ingolstadt-reduit_tilly-f483330",
"ingolstadt-reduit_tilly-f483330",
"ingolstadt-reduit_tilly-f483770",
"ingolstadt-rudolph_logistik-f483730",
"ingolstadt-saturn_arena-f483750",
"ingolstadt-st__moritz_kirche-f483350",
"ingolstadt-st__moritz_kirche-f483830",
"ingolstadt-st__moritz_kirche-f483860",
"ingolstadt-technische_hochschule-f483760",
"ingolstadt-technische_hochschule-f483810",
"ingolstadt-xaver-ernst-sportanlage-f483990",
"ipsheim-burg_hoheneck-n271010",
"ipsheim-burg_hoheneck-n271030",
"ipsheim-burg_hoheneck-n271040",
"ipsheim-burg_hoheneck-n271050",
"ipsheim-burg_hoheneck-n271070",
"ipsheim-burg_hoheneck-n271080",
"ipsheim-burg_hoheneck-n271090",
"ipsheim-burg_hoheneck-n271100",
"ipsheim-burg_hoheneck-n271140",
"ipsheim-burg_hoheneck-n271160",
"ipsheim-ipsheim-n271180",
"jechling-jechling-f511360",
"jechling-jechling-f511380",
"jena-aussichtsturm_landgrafen-n355810",
"jena-ernst-abbe-platz-n355730",
"jena-ernst-abbe-platz-n355800",
"jena-funkturm_jena_kernberg-n355860",
"jena-galgenberg-n355610",
"jena-hanfried-n355710",
"jena-jagdbergtunnel-n355910",
"jena-jena-n355600",
"jena-jena-n355620",
"jena-jena-n355660",
"jena-jena-n355690",
"jena-jena-n355700",
"jena-jena-n355750",
"jena-jena-n355780",
"jena-jena-n355790",
"jena-jena-n355840",
"jena-jena-n355850",
"jena-jena-n355880",
"jena-jena-n356240",
"jena-jentower-n355640",
"jena-jentower-n355680",
"jena-jentower-n355720",
"jena-jentower-n355760",
"jena-kernberg-n355890",
"jena-kreisverkehr-n355900",
"jena-kreisverkehr-n355930",
"jena-kreisverkehr-n355940",
"jena-kreisverkehr-n355970",
"jena-kreisverkehr-n355980",
"jena-kreisverkehr-n356010",
"jena-lobdeburgtunnel-n356050",
"jena-saaletalbruecke-n356020",
"jena-saaletalbruecke-n356070",
"jena-stadtkirche_st__michael-n355650",
"jochsberg-jochsberg-f40310",
"kairlindach-biogasanlage_kairlindach-f378650",
"kairlindach-kairlindach-f378670",
"kairlindach-kairlindach-f4230",
"kaisheim-leitheim-c500690",
"kaisheim-leitheim-c500710",
"kaisheim-leitheim-c500730",
"kaisheim-leitheim-c500740",
"kaisheim-leitheim-c500750",
"kaisheim-leitheim-c500780",
"kalchreuth-kalchreuth-c314490",
"kalchreuth-kalchreuth-c314500",
"kalchreuth-kalchreuth-c314510",
"kalchreuth-kalchreuth-c314520",
"kalchreuth-kalchreuth-c314530",
"kalchreuth-roeckenhof-c314470",
"kalchreuth-schiestlstrasse-c314540",
"kalchreuth-st__andreas_kirche-c314480",
"kaltenneuses-kaltenneuses-f4080",
"kammerstein-alter_sendeturm-c500370",
"kammerstein-kammerstein-f502360",
"kammerstein-kammerstein-f502370",
"kammerstein-kammerstein-f513810",
"kammerstein-kreisverkehr_kammerstein-c500360",
"kammerstein-raststaette_kammersteiner_land_sued-f513820",
"kammerstein-sender_heidenberg-c500400",
"karbach-karbach-s561190",
"karbach-karbach-s561200",
"karbach-karbach-s561210",
"karbach-schotterwerk_schebler-f371510",
"karlstadt-freibad_karlstadt-c562370",
"karlstadt-industriegebiet_laudenbacher_weg-s561000",
"karlstadt-industriegebiet_laudenbacher_weg-s561010",
"karlstadt-industriegebiet_laudenbacher_weg-s561030",
"karlstadt-kalksteinbruch_der_schwenk_kg-s561050",
"karlstadt-kalksteinbruch_der_schwenk_kg-s561070",
"karlstadt-karlstadt_-_altstadt-c562390",
"karlstadt-karlstadt_-_altstadt-c562400",
"karlstadt-karlstadt_-_altstadt-c562410",
"karlstadt-karlstadt_-_altstadt-c562420",
"karlstadt-karlstadt_-_altstadt-c562450",
"karlstadt-karlstadt_-_altstadt-c562460",
"karlstadt-karlstadt_-_altstadt-c562480",
"karlstadt-karlstadt_-_altstadt-c562500",
"karlstadt-karlstadt_-_mainbruecke-c562470",
"karlstadt-karlstadt_-_mainbruecke-c562520",
"karlstadt-karlstadt_-_marktplatz-c562430",
"karlstadt-karlstadt_-_marktplatz-c562490",
"karlstadt-karlstadt_-_oberer_tortum-c562440",
"karlstadt-karlstadt-c562380",
"karpfenweiher_am_aischgrund-karpfenweiher_am_aischgrund-f378640",
"kelheim-affecking-f510750",
"kelheim-affecking-f510760",
"kelheim-befreiungshallte_kelheim__michlsberg-n511210",
"kelheim-befreiungshallte_kelheim-n511130",
"kelheim-befreiungshallte_kelheim-n511160",
"kelheim-befreiungshallte_kelheim-n511180",
"kelheim-befreiungshallte_kelheim-n511200",
"kelheim-befreiungshallte_kelheim-n511240",
"kelheim-befreiungshallte_kelheim-n511270",
"kelheim-befreiungshallte_kelheim-n511340",
"kelheim-befreiungshallte_kelheim-n511350",
"kelheim-herrnwahlthann-f510800",
"kelheim-industriegebiet_saal-f510720",
"kelheim-industriegebiet_saal-f510730",
"kelheim-industriegebiet_saal-f510740",
"kelheim-kalkwerk_saal-f510780",
"kelheim-kelheim-f510680",
"kelheim-kelheim-f510690",
"kelheim-kelheim-f510700",
"kelheim-kelheim-f510710",
"kelheim-kelheim-n511150",
"kelheim-kelheim-n511300",
"kelheim-schleuse_kelheim-n511140",
"kelheim-schleuse_kelheim-n511260",
"kelkheim-kelkheim-f374450",
"kempten-basilika_st__lorenz-c502330",
"kempten-basilika_st__lorenz-c502340",
"kempten-basilika_st__lorenz-c502370",
"kempten-basilika_st__lorenz-c502440",
"kempten-basilika_st__lorenz-c502450",
"kempten-basilika_st__lorenz-c502470",
"kempten-basilika_st__lorenz-c502500",
"kempten-basilika_st__lorenz-c502530",
"kempten-basilika_st__lorenz-c502540",
"kempten-berufschule_kempten-c502230",
"kempten-bruecken_in_kempten-c502220",
"kempten-forum_allgaeu-c502240",
"kempten-forum_allgaeu-c502250",
"kempten-forum_allgaeu-c502400",
"kempten-freibad_kempten-c502280",
"kempten-gartenanlage_westlicher_stadtweiher-c502620",
"kempten-hauptbahnhof_kempten-c502420",
"kempten-kempten-c502200",
"kempten-kempten-c502210",
"kempten-kempten-c502260",
"kempten-kempten-c502270",
"kempten-kempten-c502290",
"kempten-kempten-c502300",
"kempten-kempten-c502390",
"kempten-kempten-c502430",
"kempten-kempten-c502460",
"kempten-kempten-c502490",
"kempten-kempten-c502550",
"kempten-kempten-c502560",
"kempten-kempten-c502600",
"kempten-kempten-c502610",
"kempten-kempten-c502640",
"kempten-kempten-f500990",
"kempten-kempten-f501000",
"kempten-klinikum_kempten-oberallgaeu-c502310",
"kempten-klinikum_kempten-oberallgaeu-c502360",
"kempten-klinikum_kempten-oberallgaeu-c502580",
"kempten-thingers__kempten_-f501020",
"kempten-wasserkraftwerk__illerstrasse-c502380",
"kersbach-simon_hegele_gmbh-f553640",
"kesselberg-kesselberg-f550480",
"kiefersfelden-kiefersfelden-f512330",
"kiefersfelden-kiefersfelden-f512450",
"kiefersfelden-kiefersfelden-f512460",
"kiefersfelden-kiefersfelden-f512470",
"kiefersfelden-kiefersfelden-f512480",
"kiefersfelden-kiefersfelden-f512490",
"kiefersfelden-kiefersfelden-f512500",
"kiefersfelden-kiefersfelden-f512510",
"kirchehrenbach-walberla_-_kirchehrenbach-f553540",
"kirchehrenbach-walberla_-_kirchehrenbach-f553550",
"kirchehrenbach-walberla_-_kirchehrenbach-f553560",
"kirchehrenbach-walberla_-_kirchehrenbach-f553570",
"kirchenlamnitz-kirchenlamnitz-f551430",
"kirchenlamnitz-kirchenlamnitz-f551440",
"kirchenlamnitz-kirchenlamnitz-f551450",
"kirchenlamnitz-reicholdsgruen-f551420",
"kirchensittenbach-burg_hohenstein-c17110",
"kirchensittenbach-burg_hohenstein-c17150",
"kirchensittenbach-burg_hohenstein-c17190",
"kirchensittenbach-oberkrumbach-c313840",
"kirchensittenbach-oberkrumbach-c313860",
"kirchensittenbach-oberkrumbach-c313890",
"kirchensittenbach-steinensittenbach-n275670",
"kirchensittenbach-steinensittenbach-n275690",
"kirchrimbach-kirchrimbach-f37170",
"kirchroth-autobahnmeisterei_kirchroth-f522060",
"kirchroth-kirchroth-f522040",
"kirchroth-kirchroth-f522050",
"kirchsittenbach-oberkrumbach-f423490",
"kitzingen-altstadt_kitzingen-c561680",
"kitzingen-altstadt_kitzingen-c561690",
"kitzingen-altstadt_kitzingen-c561710",
"kitzingen-autobahnkreuz_a7___a3_biebelried-c561830",
"kitzingen-autobahnkreuz_a7___a3_biebelried-c561840",
"kitzingen-autobahnkreuz_a7___a3_biebelried-c561850",
"kitzingen-autobahnkreuz_a7___a3_biebelried-c561860",
"kitzingen-autobahnkreuz_a7___a3_biebelried-c561870",
"kitzingen-autobahnkreuz_a7___a3_biebelried-c561880",
"kitzingen-evangelische_stadtkirche_kitzingen-c561610",
"kitzingen-evangelische_stadtkirche_kitzingen-c561650",
"kitzingen-evangelische_stadtkirche_kitzingen-c561670",
"kitzingen-evangelische_stadtkirche_kitzingen-c561700",
"kitzingen-flugplatz_kitzingen-f37290",
"kitzingen-flugplatz_kitzingen-f37310",
"kitzingen-flugplatz_kitzingen-f37330",
"kitzingen-golfclub_kitzingen-f37420",
"kitzingen-gwf_gebietswinzergenossenschaft_franken-c561760",
"kitzingen-innopark__kitzingen-f37380",
"kitzingen-innopark__kitzingen-f37390",
"kitzingen-kitzingen_-_altstadt-s560470",
"kitzingen-kitzingen_-_altstadt-s560490",
"kitzingen-kitzingen_-_altstadt-s560500",
"kitzingen-kitzingen_-_altstadt-s560520",
"kitzingen-kitzingen-c561600",
"kitzingen-kitzingen-c561630",
"kitzingen-kitzingen-c561660",
"kitzingen-kitzingen-c561720",
"kitzingen-kitzingen-c561730",
"kitzingen-kitzingen-c561750",
"kitzingen-kitzingen-f37320",
"kitzingen-kitzingen-f37350",
"kitzingen-kitzingen-f37360",
"kitzingen-kitzingen-f37410",
"kitzingen-krankenhaus_kitzingen-c561740",
"kitzingen-marktturm_kitzingen-c561620",
"kitzingen-marktturm_kitzingen-c561640",
"kitzingen-solarpark_bei_kitzingen-f37430",
"kitzingen-windrad_bei_kitzingen-c561770",
"kitzingen-windrad_bei_kitzingen-c561780",
"kitzingen-windrad_bei_kitzingen-c561820",
"kleinschwarzenlohe-allerheiligenkirche-n29860",
"konradsreuth-ahornberg-f551740",
"konradsreuth-ahornberg-f551750",
"kosbach-bruecke_bei_kosbach-c500110",
"kosbach-brueckenbau_a3-c500120",
"kosbach-brueckenbau_a3-c500130",
"kressbronn_am_bodensee-bodan-werft_freizeit_und_hafen-c503300",
"kressbronn_am_bodensee-bodan-werft_freizeit_und_hafen-c503310",
"kressbronn_am_bodensee-hafen_kressbronn-c503290",
"kroening-erlebniswelt_voglsam-n521560",
"kronach-festung_rosenberg-n550960",
"kronach-festung_rosenberg-n550990",
"kronach-festung_rosenberg-n551000",
"kronach-forst-n356720",
"kronach-kehlbach-n356700",
"kronach-kronach_-_altstadt-n550970",
"kronach-kronach_-_altstadt-n550980",
"kronach-kronach_-_altstadt-n551010",
"kronach-kronach-f552090",
"kronach-kronach-f552100",
"kronach-kronach-f552110",
"kronach-kronach-f552120",
"kronach-kronach-f552140",
"kronach-kronach-f552200",
"kronach-kronach-f552230",
"kronach-kronach-f552240",
"kronach-kronach-f552260",
"kronach-kronach-f552270",
"kronach-kronach-geiersgraben-f552280",
"kronach-kronach-rotberg-f552330",
"kronach-kronach-schmolz-f552310",
"kronach-steinbach_am_wald-n356690",
"kronburg-illerstufe-c503980",
"kuemmersbruck-penkhof-n524420",
"laaber-anger-n301270",
"laaber-autobahnausfahrt_a3-n301260",
"laaber-autobahnausfahrt_a3-n301290",
"laaber-herz_im_kornfeld-n520900",
"laaber-hinterzhof-n520890",
"landshut-autobahn_a92-n511770",
"landshut-burg_trausnitz-n511610",
"landshut-burg_trausnitz-n511660",
"landshut-burg_trausnitz-n511680",
"landshut-burg_trausnitz-n511690",
"landshut-burg_trausnitz-n511700",
"landshut-burg_trausnitz-n511710",
"landshut-burg_trausnitz-n511720",
"landshut-ergolding-f510830",
"landshut-ergolding-f510840",
"landshut-ergolding-f510850",
"landshut-fanatec_arena-n511550",
"landshut-fanatec_arena-n511760",
"landshut-kreiskrankenhaus_achdorf-n511530",
"landshut-landshut-f510860",
"landshut-landshut-f510870",
"landshut-landshut-f510880",
"landshut-landshut-f510890",
"landshut-landshut-f510900",
"landshut-landshut-f510910",
"landshut-landshut-f510920",
"landshut-landshut-f510930",
"landshut-landshut-f510950",
"landshut-landshut-n511560",
"landshut-landshut-n511570",
"landshut-landshut-n511730",
"landshut-landshut-n511740",
"landshut-landshut-n511750",
"landshut-poeffelkofener_kieswerk-f510960",
"landshut-poeffelkofener_kieswerk-f510970",
"landshut-sausteg_in_landshut-n511650",
"landshut-st__jodok_kirche-n511580",
"landshut-st__jodok_kirche-n511590",
"landshut-st__jodok_kirche-n511600",
"landshut-st__jodok_kirche-n511620",
"landshut-st__jodok_kirche-n511630",
"landshut-st__jodok_kirche-n511670",
"landshut-st__margaret_landshut-n511540",
"langenaltheim-kreisverkehr_langenaltheim-c500600",
"langenaltheim-kreisverkehr_langenaltheim-c500610",
"langenaltheim-langenaltheim-c500620",
"langendorf-weissenfels-n355100",
"langendorf-weissenfels-n355110",
"langendorf-weissenfels-n355140",
"langendorf-weissenfels-n355150",
"langenzenn-burggrafenhof-n265140",
"langenzenn-gut_zennhof-c284890",
"langenzenn-hardhof-n265190",
"langenzenn-keidenzell-n265100",
"langenzenn-keidenzell-n265120",
"langenzenn-langenzenn-n265130",
"langenzenn-langenzenn-n265150",
"langenzenn-langenzenn-n265160",
"langenzenn-langenzenn-n265170",
"langenzenn-langenzenn-n265180",
"langweid_am_lech-baggersee-n324100",
"langweid_am_lech-foret-n324130",
"langweid_am_lech-langweid_am_lech-n324080",
"langweid_am_lech-langweid_am_lech-n324090",
"langwied_am_lech-b2_stettenhofen-f500440",
"langwied_am_lech-gewerbegebiet_foret-f500430",
"langwied_am_lech-langwied_am_lech-c500970",
"langwied_am_lech-langwied_am_lech-c500980",
"langwied_am_lech-langwied_am_lech-f500400",
"langwied_am_lech-langwied_am_lech-f500420",
"laubenthal-sandgrube_laubenthal-n322620",
"lauf_an_der_pegnitz-autobahn_a9_bei_letten-f423590",
"lauf_an_der_pegnitz-autobahn_a9_bei_letten-f423710",
"lauf_an_der_pegnitz-autobahn_a9_bei_letten-f423730",
"lauf_an_der_pegnitz-autobahn_a9_bei_letten-f423740",
"lauf_an_der_pegnitz-autobahn_a9_bei_letten-f423770",
"lauf_an_der_pegnitz-autobahnausfahrt_lauf_hersbruck-f433120",
"lauf_an_der_pegnitz-autobahnbruecke_a9_bei_lauf-f433140",
"lauf_an_der_pegnitz-autobahnbruecken_a9_bei_lauf-f433170",
"lauf_an_der_pegnitz-brueckenbau_bei_letten-f433250",
"lauf_an_der_pegnitz-brueckenbau_bei_letten-f433290",
"lauf_an_der_pegnitz-brueckenbau_bei_letten-f443360",
"lauf_an_der_pegnitz-brueckenbau_bei_letten-f443420",
"lauf_an_der_pegnitz-brueckenbau_bei_letten-f443500",
"lauf_an_der_pegnitz-bullach-c314050",
"lauf_an_der_pegnitz-bullach-c314060",
"lauf_an_der_pegnitz-freibad-c116850",
"lauf_an_der_pegnitz-freibad-c116890",
"lauf_an_der_pegnitz-gewerbegebiet_lauf__bei_wetzendorf_-f462990",
"lauf_an_der_pegnitz-gewerbegebiet_lauf_sued-f462820",
"lauf_an_der_pegnitz-gewerbegebiet_lauf-f423670",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116660",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116670",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116690",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116710",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116730",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116740",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116760",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116810",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c116830",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c117010",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c117020",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c117160",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16390",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16410",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16440",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16450",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16480",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16500",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16520",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16530",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16550",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16560",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16580",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16620",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16630",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16640",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16700",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16720",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-c16730",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f433180",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f433190",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f443320",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f443340",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f443350",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550320",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550330",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550340",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550350",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550360",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550370",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550380",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550390",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-f550400",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-n275110",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-n275130",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-n275210",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-n275240",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-n275260",
"lauf_an_der_pegnitz-lauf_an_der_pegnitz-n275270",
"lauf_an_der_pegnitz-letten_bei_lauf-f423560",
"lauf_an_der_pegnitz-letten_bei_lauf-f433450",
"lauf_an_der_pegnitz-letten_bei_lauf-f433460",
"lauf_an_der_pegnitz-letten_bei_lauf-f433470",
"lauf_an_der_pegnitz-letten_bei_lauf-f454110",
"lauf_an_der_pegnitz-letten_bei_lauf-f454210",
"lauf_an_der_pegnitz-letten-f462860",
"lauf_an_der_pegnitz-montessorischule_lauf-f550410",
"lauf_an_der_pegnitz-rueckersdorf_kotzenberger_weg-c116860",
"lauf_an_der_pegnitz-rueckersdorf_kotzenberger_weg-c116920",
"lauf_an_der_pegnitz-rueckersdorf_kotzenberger_weg-c116980",
"lauf_an_der_pegnitz-rueckersdorf_kotzenberger_weg-c117080",
"lauf_an_der_pegnitz-rueckersdorf_kotzenberger_weg-c117100",
"lauf_an_der_pegnitz-rueckersdorf_strengenberger_strasse-c117180",
"lauf_an_der_pegnitz-rueckersdorf_strengenberger_strasse-c117190",
"lauf_an_der_pegnitz-rueckersdorf_strengenberger_strasse-c117350",
"lauf_an_der_pegnitz-rueckersdorf-c106940",
"lauf_an_der_pegnitz-rueckersdorf-c107030",
"lauf_an_der_pegnitz-rueckersdorf-c107200",
"lauf_an_der_pegnitz-rueckersdorf-c107350",
"lauf_an_der_pegnitz-rueckersdorf-c107450",
"lauf_an_der_pegnitz-rueckersdorf-c107510",
"lauf_an_der_pegnitz-rueckersdorf-c107540",
"lauf_an_der_pegnitz-rueckersdorf-c107560",
"lauf_an_der_pegnitz-thomas_sabo__lauf_-f462810",
"lauf_an_der_pegnitz-ueberfuehrung_bei_lauf-f423530",
"lauf_an_der_pegnitz-ueberfuehrung_bei_lauf-f423530",
"lauf_an_der_pegnitz-waldgasthof_am_letten-f433220",
"lauf_an_der_pegnitz-wenzelschloss-n275140",
"lauf_an_der_pegnitz-wenzelschloss-n275150",
"lauf_an_der_pegnitz-wenzelschloss-n275160",
"lauf_an_der_pegnitz-wenzelschloss-n275170",
"lauf_an_der_pegnitz-wenzelschloss-n275180",
"lauf_an_der_pegnitz-wenzelschloss-n275200",
"lauf_an_der_pegnitz-wenzelschloss-n275220",
"lauf_an_der_pegnitz-wenzelschloss-n275230",
"lauf_an_der_pegnitz-wenzelschloss-n275250",
"lauterbach-schloss_lauterbach-n514590",
"lauterbach-schloss_lauterbach-n514600",
"lauterbach-schloss_lauterbach-n514610",
"lauterhofen-muttenshofen-f402420",
"lauterhofen-nattershofen-f402020",
"lauterhofen-reitelshofen-f402400",
"lauterhofen-schweibach-n524760",
"leerstetten-schleuse-n29930",
"leerstetten-schleuse-n29940",
"lehrberg-b13_bei_lehrberg-f45270",
"leinburg-diepersdorf-c253110",
"leinburg-diepersdorf-c253130",
"leinburg-diepersdorf-c253140",
"leinburg-diepersdorf-c253160",
"leinburg-diepersdorf-c253170",
"leinburg-gersberg-c313480",
"leinburg-moritzberg-c253060",
"leinburg-moritzberg-c253070",
"leinburg-moritzberg-c253080",
"leinburg-moritzberg-c253090",
"leinburg-moritzberg-f402720",
"leinburg-moritzberg-n303490",
"leinburg-reuth-c313460",
"leinburg-weihersberg-c252990",
"leinburg-weihersberg-c253000",
"leinburg-weihersberg-c253010",
"leinburg-weihersberg-c253040",
"leipzig-airport_leipzig-halle-n353810",
"leipzig-airport_leipzig-halle-n353830",
"leipzig-airport_leipzig-halle-n353840",
"leipzig-airport_leipzig-halle-n353850",
"leipzig-airport_leipzig-halle-n353860",
"leipzig-alt-west-n352470",
"leipzig-autobahn_a14-n353540",
"leipzig-baustelle-n353320",
"leipzig-bei_soessen-n355040",
"leipzig-braunkohlekraftwerk_lippendorf-n354920",
"leipzig-braunkohlekraftwerk-n352390",
"leipzig-breitenfeld-n353530",
"leipzig-bundesverwaltungsgericht-n354190",
"leipzig-bundesverwaltungsgericht-n354230",
"leipzig-city-hochhaus-n354120",
"leipzig-city-hochhaus-n354220",
"leipzig-city-hochhaus-n354290",
"leipzig-containerbahnhof-n352480",
"leipzig-dhl-n353330",
"leipzig-dhl-n353360",
"leipzig-eisdorf-n352450",
"leipzig-erich-kaestner-schule-n354090",
"leipzig-feldstrasse-n353550",
"leipzig-flugzeugschatten-n353570",
"leipzig-flugzeugschatten-n353590",
"leipzig-gasometer_nord-n354110",
"leipzig-gasometer_nord-n354310",
"leipzig-gerstewitz-n355070",
"leipzig-glockenturm-n354410",
"leipzig-gueterverkehrszentrum_nord-n352560",
"leipzig-gueterverkehrszentrum_nord-n352590",
"leipzig-gueterverkehrszentrum_nord-n352820",
"leipzig-gueterverkehrszentrum_nord-n352840",
"leipzig-gueterverkehrszentrum_nord-n352900",
"leipzig-gueterverkehrszentrum_nord-n353150",
"leipzig-gueterverkehrszentrum_nord-n353170",
"leipzig-gueterverkehrszentrum_nord-n353890",
"leipzig-hartmannsdorf-n354820",
"leipzig-hartsteinwerke_mitteldeutschland-n352930",
"leipzig-hartsteinwerke_mitteldeutschland-n353220",
"leipzig-hauptbahnhof-n354340",
"leipzig-hauptbahnhof-n354540",
"leipzig-hauptbahnhof-n354560",
"leipzig-hauptbahnhof-n354570",
"leipzig-hohenmoelsen-n355050",
"leipzig-jacobstrasse-n354040",
"leipzig-jacobstrasse-n354050",
"leipzig-knautnaundorf-n352460",
"leipzig-kohlrabizirkus-n354610",
"leipzig-kongresshalle_am_zoo-n353990",
"leipzig-leipzig-n353460",
"leipzig-leipzig-n353470",
"leipzig-leipzig-n353520",
"leipzig-leipzig-n353940",
"leipzig-leipzig-n354100",
"leipzig-leipzig-n354300",
"leipzig-leipzig-n354330",
"leipzig-leipzig-n354590",
"leipzig-leipzig-n354680",
"leipzig-leipzig-n354690",
"leipzig-luetzen-grossgoerschen-n354950",
"leipzig-luetzen-grossgoerschen-n354960",
"leipzig-luetzen-grossgoerschen-n354980",
"leipzig-luetzen-grossgoerschen-n354990",
"leipzig-luetzen-grossgoerschen-n355000",
"leipzig-markkleeberger_see-n354710",
"leipzig-markkleeberger_see-n354780",
"leipzig-markkleeberg-n354720",
"leipzig-martin-luther-kirche-n354730",
"leipzig-mitteldeutscher_rundfunk-n354640",
"leipzig-panometer-n354660",
"leipzig-pax_jugendkirche-n354520",
"leipzig-pegau-kitzen-n354940",
"leipzig-pittlerstrasse-n353480",
"leipzig-porsche_werk-n352980",
"leipzig-porsche_werk-n353230",
"leipzig-porsche_werk-n353240",
"leipzig-porsche_werk-n353250",
"leipzig-porsche_werk-n353260",
"leipzig-porsche_werk-n353290",
"leipzig-porsche_werk-n353380",
"leipzig-porsche_werk-n353390",
"leipzig-porsche_werk-n353420",
"leipzig-porsche_werk-n353440",
"leipzig-porsche_werk-n353510",
"leipzig-porsche_werk-n353870",
"leipzig-porsche_werk-n353880",
"leipzig-porsche-n352490",
"leipzig-porsche-n352550",
"leipzig-rathaus-n354150",
"leipzig-rathaus-n354180",
"leipzig-rathaus-n354200",
"leipzig-rathaus-n354210",
"leipzig-rathaus-n354250",
"leipzig-rathaus-n354260",
"leipzig-red_bull_arena-n354440",
"leipzig-red_bull_arena-n354460",
"leipzig-red_bull_arena-n354490",
"leipzig-red_bull_arena-n354500",
"leipzig-rosestrasse-n353490",
"leipzig-runie_bei_soessen-n355010",
"leipzig-spedition_nagel-n353450",
"leipzig-stadtzentrum-n354270",
"leipzig-stahl-_und_hartgusswerk_boesdorf-n354900",
"leipzig-suez_energie_und_abfallverwertung-n355090",
"leipzig-the_westin-n354320",
"leipzig-thomaskirche-n354280",
"leipzig-tschaikowskistrasse-n354350",
"leipzig-tschaikowskistrasse-n354370",
"leipzig-tschaikowskistrasse-n354380",
"leipzig-universitaetsbibliothek-n354240",
"leipzig-verteilerbauwerk_knauthain-n354800",
"leipzig-weisse_elster_staustufe-n354830",
"leipzig-werbener_see-n352410",
"leipzig-werben-n352420",
"leipzig-zentrum-ost-n354580",
"leipzig-zoo_leipzig-n353970",
"leipzig-zoo_leipzig-n353980",
"leipzig-zoo_leipzig-n354000",
"leipzig-zoo_leipzig-n354030",
"leipzig-zoo_leipzig-n354080",
"leipzig-zwenkauer_see-n354840",
"leipzig-zwenkauer_see-n354850",
"leipzig-zwenkauer_see-n354860",
"leipzig-zwenkauer_see-n354870",
"leonberg-muenchsgruen-f550890",
"leonberg-muenchsgruen-f550900",
"leutenbach-dietzhof-n276450",
"leutenbach-leutenbach-n276430",
"leutenbach-leutenbach-n276440",
"leutenbach-leutenbach-n276460",
"leutenbach-seidmar-n276390",
"leutenbach-st__moritz_kapelle-n276400",
"leutenbach-st__moritz_kapelle-n276420",
"leutershausen-biogasanlage_bei_leutershausen-f45370",
"leutershausen-biogasanlage_leutershausen-f40320",
"leutershausen-eckartsweiler_und_brunst-f40330",
"leutershausen-frommetsfelden-f42730",
"leutershausen-karpfenweiher_bei_leutershausen-f4040",
"leutershausen-leutershausen-f40300",
"leutershausen-leutershausen-f45330",
"lichtenau-festung_lichtenau-n327050",
"lichtenau-festung_lichtenau-n327080",
"lichtenau-festung_lichtenau-n327100",
"lichtenau-festung_lichtenau-n327120",
"lichtenau-festung_lichtenau-n327130",
"lichtenau-festung_lichtenau-n327140",
"lichtenau-festung_lichtenau-n327220",
"lichtenau-festung_lichtenau-n327250",
"lichtenau-gewerbegebiet_lichtenau-n327200",
"lichtenau-lichtenau-n327040",
"lichtenau-malmersdorf-n327190",
"lichtenau-oberrammersdorf-n272430",
"lichtenau-oberrammersdorf-n272440",
"lichtenfels-1_fc_lichtenfels-n551390",
"lichtenfels-basilika_vierzehnheiligen-f552980",
"lichtenfels-basilika_vierzehnheiligen-f552990",
"lichtenfels-basilika_vierzehnheiligen-f553000",
"lichtenfels-basilika_vierzehnheiligen-f553010",
"lichtenfels-basilika_vierzehnheiligen-f553020",
"lichtenfels-basilika_vierzehnheiligen-f553030",
"lichtenfels-basilika_vierzehnheiligen-f553040",
"lichtenfels-buch_am_forst-n357320",
"lichtenfels-lichtenfels_-_altstadt-n551410",
"lichtenfels-lichtenfels_-_altstadt-n551420",
"lichtenfels-lichtenfels_-_altstadt-n551430",
"lichtenfels-lichtenfels_-_altstadt-n551440",
"lichtenfels-lichtenfels_-_altstadt-n551450",
"lichtenfels-lichtenfels_-_altstadt-n551470",
"lichtenfels-lichtenfels_-_altstadt-n551480",
"lichtenfels-lichtenfels_-_altstadt-n551490",
"lichtenfels-lichtenfels_-_altstadt-n551500",
"lichtenfels-lichtenfels_-_klaeranlage-f552940",
"lichtenfels-lichtenfels_-_main-f552790",
"lichtenfels-lichtenfels_-_rathaus-n551460",
"lichtenfels-lichtenfels_-_reundorf-f553070",
"lichtenfels-lichtenfels_ortswiesensee-f552760",
"lichtenfels-lichtenfels_ortswiesensee-f552770",
"lichtenfels-lichtenfels_ortswiesensee-f552780",
"lichtenfels-lichtenfels_ortswiesensee-f552800",
"lichtenfels-lichtenfels-f552810",
"lichtenfels-lichtenfels-f552820",
"lichtenfels-lichtenfels-f552830",
"lichtenfels-lichtenfels-f552840",
"lichtenfels-lichtenfels-f552850",
"lichtenfels-lichtenfels-f552860",
"lichtenfels-lichtenfels-f552870",
"lichtenfels-lichtenfels-f552880",
"lichtenfels-lichtenfels-f552890",
"lichtenfels-lichtenfels-f552900",
"lichtenfels-lichtenfels-f552910",
"lichtenfels-lichtenfels-f552920",
"lichtenfels-lichtenfels-f552930",
"lichtenfels-lichtenfels-f552950",
"lichtenfels-lichtenfels-f552960",
"lichtenfels-lichtenfels-f553050",
"lichtenfels-lichtenfels-f553060",
"lichtenfels-wehr_in_lichtenfels-n551400",
"lindau-aeschacher_bad-c503210",
"lindau-aeschacher_bad-c503220",
"lindau-alpenvorland-c503160",
"lindau-bayerische_spielbank_lindau-c503070",
"lindau-bc_bodolz-c503270",
"lindau-bei_lindau-c502820",
"lindau-bei_lindau-c502850",
"lindau-bodensee__rhein-c503170",
"lindau-bodensee__rhein-c503180",
"lindau-bodensee-c503010",
"lindau-bodensee-c503020",
"lindau-bodensee-c503030",
"lindau-bodensee-c503190",
"lindau-bodensee-f501250",
"lindau-bsb-hafen_lindau-c502980",
"lindau-bsb-hafen_lindau-c503110",
"lindau-chelles-allee-c502940",
"lindau-holdereggen_schloessle-c503040",
"lindau-hoyren-c503260",
"lindau-inselhalle-c503050",
"lindau-lindau__st__verena_kirche-c502890",
"lindau-lindau-c502900",
"lindau-lindau-c502950",
"lindau-lindau-c502960",
"lindau-lindau-c502970",
"lindau-lindau-c503060",
"lindau-lindau-c503080",
"lindau-lindau-c503090",
"lindau-lindau-c503120",
"lindau-lindau-c503150",
"lindau-lindauer_dahlienschau-c502880",
"lindau-lindau-f501170",
"lindau-lindau-f501180",
"lindau-lindau-f501190",
"lindau-lindau-f501210",
"lindau-streitelsfingen-c502870",
"lindau-tennisclub_lindau_1930_e_v_-c503230",
"lindau-vier_linden_quartier-c502920",
"lindau-vier_linden_quartier-c502930",
"lindau-volkshochschule_lindau-c503000",
"lindau-volkshochschule_lindau-c503140",
"lindau-wasserburg_bodensee-c503280",
"lindenberg_im_allgaeu-lindenberg_im_allgaeu-f501050",
"lindenberg_im_allgaeu-lindenberg_im_allgaeu-f501070",
"lindenberg_im_allgaeu-lindenberg_im_allgaeu-f501080",
"lindenberg_im_allgaeu-lindenberg_im_allgaeu-f501090",
"lindenberg_im_allgaeu-lindenberg_im_allgaeu-f501110",
"lindenberg_im_allgaeu-waldsee-f501130",
"lindenberg_im_allgaeu-waldsee-f501140",
"linden-linden-f42390",
"linden-linden-f42420",
"litzendorf-tiefenellern-n266960",
"litzendorf-tiefenellern-n266970",
"lochhausen-birkensee_bei_muenchen-n514500",
"lochhausen-birkensee_bei_muenchen-n514510",
"lockenmuehle-lockenmuehle-f40230",
"lohrbach-flugplatz_lohrbach-f377880",
"lohrbach-flugplatz_lohrbach-f377890",
"losaurach-losaurach-f40140",
"losaurach-losaurach-f42350",
"ludwigshafen-basf_ludwigshafen-f375800",
"ludwigshafen-basf_ludwigshafen-f375830",
"ludwigshafen-basf_ludwigshafen-f375840",
"ludwigshafen-basf_ludwigshafen-f375850",
"ludwigshafen-basf_ludwigshafen-f375860",
"ludwigshafen-basf_ludwigshafen-f375870",
"ludwigshafen-berliner_platz__ludwigshafen-f375890",
"ludwigshafen-rhein-galerie_ludwigshafen-f375760",
"ludwigshafen-rhein-galerie_ludwigshafen-f375780",
"lupburg-lupburg-n302660",
"lupburg-lupburg-n302670",
"lupburg-lupburg-n302690",
"lupburg-lupburg-n302720",
"lupburg-niederhofen-n520800",
"lupburg-niederhofen-n520830",
"lupburg-seibertshofen-n302650",
"lupburg-vorderkreith-n520840",
"mainz-baumschule_bei_mainz-f375100",
"mainz-fernmeldeturm_ober-olm-f375060",
"mainz-funkturm_bei_mainz-f375000",
"mainz-funkturm_bei_mainz-f375010",
"mainz-obstbaeume_bei_mainz-f375110",
"mainz-obstbaumplantage_bei_mainz-f375080",
"mainz-panorama_richtung_mainz-f375040",
"mainz-richtung_mainz-f374990",
"mannheim-carl-benz-stadion-f376460",
"mannheim-christuskirche-f376290",
"mannheim-christuskirche-f376320",
"mannheim-christuskirche-f376330",
"mannheim-christuskirche-f376380",
"mannheim-citykirche_konkorden-f376340",
"mannheim-collini_steg-f375940",
"mannheim-collini_steg-f376210",
"mannheim-fernmeldeturm-f376020",
"mannheim-fernmeldeturm-f376040",
"mannheim-fernmeldeturm-f376050",
"mannheim-friedrichsplatz-f375620",
"mannheim-friedrichsplatz-f375650",
"mannheim-friedrichsplatz-f375660",
"mannheim-friedrichsplatz-f375670",
"mannheim-friedrichsplatz-f376250",
"mannheim-friedrichsring-f376200",
"mannheim-hafen-f375820",
"mannheim-hafen-f375960",
"mannheim-hauptbahnhof-f376240",
"mannheim-heilig-geist-kirche-f376120",
"mannheim-innenstadt-f375750",
"mannheim-innenstadt-f375900",
"mannheim-innenstadt-f375910",
"mannheim-innenstadt-f375930",
"mannheim-innenstadt-f376000",
"mannheim-john_deere_werk-f375630",
"mannheim-jungbuschbruecke-f375980",
"mannheim-justizvollzugsanstalt-f375610",
"mannheim-klaerwerk_mannheim-f375550",
"mannheim-konrad-adenauer-bruecke-f375680",
"mannheim-konrad-adenauer-bruecke-f375730",
"mannheim-luisenpark-f376060",
"mannheim-mannheim___ludwigshafen-f375770",
"mannheim-mannheim_mitte-f375790",
"mannheim-mannheim-f375700",
"mannheim-mannheim-f376100",
"mannheim-mannheim-f376400",
"mannheim-mannheim-f376410",
"mannheim-mannheim-f376430",
"mannheim-mannheim-f377000",
"mannheim-marktplatz-f376230",
"mannheim-neckarpromenade-f375950",
"mannheim-neckarvorlandbruecke-f375970",
"mannheim-paradeplatz-f376220",
"mannheim-rheinvorlandstrasse-f375740",
"mannheim-sap_arena-f376450",
"mannheim-sap_arena-f376470",
"mannheim-schloss-f375710",
"mannheim-stadtbibliothek-f375920",
"mannheim-universitaet_mannheim-f375720",
"mannheim-victoria-turm-f375690",
"mannheim-wasserturm-f376150",
"mannheim-wasserturm-f376160",
"mannheim-wasserturm-f376180",
"mannheim-wasserturm-f376360",
"mannheim-zellstoffsiedlung-f375560",
"mannheim-zellstoffsiedlung-f375590",
"mariaposching-breitenrain-f521730",
"mariaposching-breitenrain-f521740",
"mariaposching-haberswoehr-f521720",
"mariaposching-haberswoehr-n522990",
"mariaposching-moderner_bauernhof-n523000",
"markt_bibart-altmannshausen-n27810",
"markt_bibart-altmannshausen-n27820",
"markt_bibart-photovoltaikanlage-n27840",
"markt_erlbach-kappersberg-c560320",
"markt_erlbach-kappersberg-c560330",
"markt_erlbach-klausaurach-c560410",
"markt_erlbach-klausaurach-c560420",
"markt_erlbach-klausaurach-c560430",
"markt_erlbach-markt_erlbach-f45210",
"markt_erlbach-mettelaurach-c560400",
"markt_erlbach-oberulsenbach-c560360",
"markt_erlbach-oberulsenbach-c560370",
"markt_erlbach-oberulsenbach-c560380",
"markt_erlbach-wasserturm_markt_erlbach-f46430",
"markt_indersdorf-kirche-f481320",
"markt_indersdorf-markt_indersdorf-f481280",
"markt_indersdorf-markt_indersdorf-f481290",
"markt_indersdorf-pasenbach-f483270",
"markt_indersdorf-pasenbach-f483280",
"marktbreit-mainbruecke_marktbreit-c561170",
"marktbreit-mainbruecke_marktbreit-c561180",
"marktbreit-mainbruecke_marktbreit-c561190",
"marktbreit-mainbruecke_marktbreit-c561240",
"marktbreit-mainbruecke_marktbreit-c561250",
"marktbreit-mainbruecke_marktbreit-c561270",
"marktbreit-mainbruecke_marktbreit-c561280",
"marktbreit-mainbruecke_marktbreit-c561320",
"marktbreit-mainbruecke_marktbreit-c561340",
"marktbreit-marktbreit-c561300",
"marktbreit-marktbreit-c561310",
"marktbreit-segnitz-c561200",
"marktbreit-segnitz-c561210",
"marktbreit-segnitz-c561220",
"marktbreit-wasserkraftwerk_marktbreit-c561290",
"marktbreit-wasserkraftwerk_marktbreit-c561330",
"marktbreit-wasserkraftwerk_marktbreit-c561350",
"marktheidenfeld-berger_rohstoffe-c562560",
"marktheidenfeld-bischbrunn_-_strassluecke-s561330",
"marktheidenfeld-bischbrunn-s561340",
"marktheidenfeld-glasofen-s561260",
"marktheidenfeld-glasofen-s561280",
"marktheidenfeld-marktheidenfeld_-_dillberg-c562580",
"marktheidenfeld-marktheidenfeld_-_gewerbegebiet-c562590",
"marktheidenfeld-marktheidenfeld-c562570",
"marktheidenfeld-marktheidenfeld-c562600",
"marktheidenfeld-marktheidenfeld-c562610",
"marktheidenfeld-marktheidenfeld-c562620",
"marktheidenfeld-marktheidenfeld-c562630",
"marktheidenfeld-marktheidenfeld-c562640",
"marktheidenfeld-marktheidenfeld-c562650",
"marktheidenfeld-marktheidenfeld-c562660",
"marktheidenfeld-marktheidenfeld-c562670",
"marktheidenfeld-marktheidenfeld-c562680",
"marktheidenfeld-marktheidenfeld-s561230",
"marktheidenfeld-marktheidenfeld-s561250",
"marktleugast-neuensorg-f551900",
"marktredwitz-krankenhaus_marktredwitz-f551120",
"marktredwitz-marktredwitz_-_altstadt-n550620",
"marktredwitz-marktredwitz_-_auenpark-n550590",
"marktredwitz-marktredwitz_-_auenpark-n550600",
"marktredwitz-marktredwitz_-_doerflas-n550550",
"marktredwitz-marktredwitz_-_doerflas-n550560",
"marktredwitz-marktredwitz_-_fabrikstrasse-n550610",
"marktredwitz-marktredwitz-f551040",
"marktredwitz-marktredwitz-f551050",
"marktredwitz-marktredwitz-f551070",
"marktredwitz-marktredwitz-f551080",
"marktredwitz-marktredwitz-f551100",
"marktredwitz-marktredwitz-f551130",
"marktredwitz-marktredwitz-f551150",
"marktredwitz-marktredwitz-f551160",
"marktredwitz-marktredwitz-f551170",
"marktredwitz-marktredwitz-f551180",
"marktredwitz-marktredwitz-f551190",
"marktredwitz-marktredwitz-f551200",
"marktredwitz-marktredwitz-f551210",
"marktredwitz-marktredwitz-f551220",
"marktredwitz-marktredwitz-f551230",
"marktredwitz-marktredwitz-n550570",
"marktredwitz-marktredwitz-n550580",
"marktredwitz-marktredwitz-n550630",
"marktredwitz-marktredwitz-oberredwitz-f551110",
"marktredwitz-naturfreibad_marktredwitz-f551090",
"marktredwitz-tiefenbach-f551240",
"marktschorgast-ziegenburg-n35930",
"marxheim-bruecke_ueber_donau-n326050",
"marxheim-marxheim_an_der_donau-n326020",
"marxheim-marxheim_an_der_donau-n326060",
"massenbach-massenbach-c500510",
"meckenbeuren-gewerbegebiet_meckenbeuren-c503800",
"meckenbeuren-meckenbeuren-c503790",
"meckenbeuren-sportplatz_meckenbeuren-c503810",
"meckenbeuren-theodor-heuss-schule-c503770",
"meckenbeuren-theodor-heuss-schule-c503780",
"meitingen-gewerbegebiet_meitingen-n325650",
"meitingen-kraftwerk_meitingen-n325630",
"meitingen-lech_stahlwerke_in_meitingen-n324010",
"meitingen-lech_stahlwerke_in_meitingen-n324020",
"meitingen-lech-c500910",
"meitingen-lech-c500920",
"meitingen-lechmuseum_bayern-n324030",
"meitingen-lechmuseum_bayern-n324050",
"meitingen-meitingen_nord-n325670",
"meitingen-meitingen_sgl-c500830",
"meitingen-meitingen-c500810",
"meitingen-meitingen-c500850",
"meitingen-meitingen-c500900",
"meitingen-meitingen-n325640",
"meitingen-meitingen-n325660",
"meitingen-tsv_meitingen-c500840",
"meitingen-umspannwerk_meitingen-c500860",
"meitingen-umspannwerk-c500870",
"meitingen-umspannwerk-c500880",
"memmelsdorf-friedhof_fasanerie-n266580",
"memmelsdorf-meedensdorf-n266630",
"memmelsdorf-schloss_seehof-n266300",
"memmelsdorf-schloss_seehof-n266320",
"memmelsdorf-schloss_seehof-n266330",
"memmelsdorf-schloss_seehof-n266340",
"memmelsdorf-schloss_seehof-n266350",
"memmelsdorf-schloss_seehof-n266370",
"memmelsdorf-schloss_seehof-n266380",
"memmelsdorf-schloss_seehof-n266390",
"memmelsdorf-schloss_seehof-n266400",
"memmelsdorf-schloss_seehof-n266410",
"memmelsdorf-schloss_seehof-n266420",
"memmelsdorf-schloss_seehof-n266430",
"memmelsdorf-schloss_seehof-n266440",
"memmelsdorf-schloss_seehof-n266450",
"memmelsdorf-schloss_seehof-n266460",
"memmelsdorf-schloss_seehof-n266470",
"memmelsdorf-schloss_seehof-n266480",
"memmelsdorf-schloss_seehof-n266490",
"memmelsdorf-schloss_seehof-n266500",
"memmelsdorf-schloss_seehof-n266510",
"memmelsdorf-schloss_seehof-n266520",
"memmelsdorf-schloss_seehof-n266530",
"memmelsdorf-schloss_seehof-n266540",
"memmelsdorf-schloss_seehof-n266550",
"memmelsdorf-schloss_seehof-n266560",
"memmelsdorf-schloss_seehof-n266570",
"memmelsdorf-schloss_seehof-n266600",
"memmelsdorf-schloss_seehof-n357850",
"memmelsdorf-schloss_seehof-n357860",
"memmelsdorf-schloss_seehof-n357880",
"memmelsdorf-schloss_seehof-n357890",
"memmelsdorf-schloss_seehof-n357900",
"memmelsdorf-schloss_seehof-n357910",
"memmelsdorf-schloss_seehof-n357920",
"memmelsdorf-schloss_seehof-n357950",
"memmelsdorf-schloss_seehof-n358000",
"memmelsdorf-schloss_seehof-n358010",
"memmelsdorf-schloss_seehof-n358020",
"memmelsdorf-schloss_seehof-n358030",
"memmelsdorf-schloss_seehof-n358040",
"memmelsdorf-schloss_seehof-n358050",
"memmelsdorf-schloss_seehof-n358060",
"memmelsdorf-schloss_seehof-n358070",
"memmelsdorf-schloss_seehof-n358090",
"memmelsdorf-schmerldorf-n266650",
"memmelsdorf-sv_memmelsdorf-n266360",
"memmelsdorf-windradpanorama-n266640",
"memmingen-autobahn_a96_memmingen-f501710",
"memmingen-flughafen_memmingen-c504100",
"memmingen-memmingen-c504130",
"memmingen-memmingen-f501650",
"memmingen-memmingen-f501660",
"memmingen-memmingen-f501670",
"memmingen-memmingen-f501680",
"memmingen-memmingen-f501690",
"memmingen-memmingen-f501720",
"memmingen-memmingen-f501730",
"memmingen-metzeler_in_memmingen-f501700",
"memmingen-sv_amendingen-c504120",
"mengkofen-martinsbuch-f520920",
"mengkofen-mengkofen-f520930",
"mengkofen-mengkofen-f520940",
"mengkofen-mengkofen-f520950",
"mengkofen-mengkofen-f520960",
"mengkofen-mengkofen-f520970",
"mering-gymnasium_mering-c501150",
"mering-mering__ludwig_leuchten-c501160",
"mering-mering-c501170",
"merkendorf-gebersdorf-n272460",
"merzbach-merzbach-f40190",
"mettelaurach-mettelaurach-f42380",
"metten-kalberweide-n522940",
"metten-metten-n522880",
"metten-metten-n522890",
"metten-metten-n522910",
"mimberg-mimberg-f510320",
"mimberg-mimberg-f510330",
"mintraching-fc_mintraching-n521330",
"mintraching-mintraching-f520880",
"mintraching-moosham-n521360",
"mistelgau-brunnberg-f553350",
"mitteldachstetten-mitteldachstetten-f42560",
"mitteldorf-mitteldorf-f42140",
"mitteldorf-mitteldorf-f46260",
"mittelmembach-mittelmembach-c560050",
"mittelmembach-mittelmembach-f4010",
"mittersthal-rauch_bei_mittersthal-f431450",
"mittersthal-rauch_bei_mittersthal-f431460",
"mitterteich-grossensterz-f550920",
"mitterteich-mitterteich-f550930",
"mitterteich-mitterteich-f550950",
"mitterteich-mitterteich-f550960",
"mitterteich-mitterteich-f550970",
"mitterteich-mitterteich-f550980",
"mitterteich-mitterteich-nord-f551000",
"mitterteich-mitterteich-sued-f550940",
"mitwitz-leutendorf-f552340",
"molau-radwegekirche-n355430",
"monheim-motocross_strecke_warching-f500330",
"monheim-warching-f500350",
"moosthenning-unterholsbach-f520980",
"mosbach-energiegewinnung_bei_mosbach-f42310",
"mosbach-mosbach-f42330",
"mosbach-mosbach-f42340",
"motzenhofen-raiffeisen-agrar-zentrum-n514760",
"muehlbach-muehlbach_-_funkturm-c562540",
"muehldorf_am_inn-lohkirchen-n511930",
"muehldorf_am_inn-lohkirchen-n511940",
"muehldorf_am_inn-muehldorf_am_inn-n511960",
"muehldorf_am_inn-muehldorf_am_inn-n511970",
"muehldorf_am_inn-muehldorf_am_inn-n511980",
"muehldorf_am_inn-muehldorf_am_inn-n512000",
"muehldorf_am_inn-sankt_salvador-n511990",
"muehlheim-muehlheimer_berg-n514800",
"muehlheim-muehlheimer_berg-n514810",
"muehlheim-muehlheimer_berg-n514820",
"muehlheim-muehlheimer_berg-n514830",
"muehlstetten-sandgrube-n321810",
"muenchberg-ahornis-f551850",
"muenchberg-ahornis-n35940",
"muenchberg-freibad_muenchberg-n550810",
"muenchberg-freibad_muenchberg-n550820",
"muenchberg-horlachen-f552070",
"muenchberg-muenchberg_-_altstadt-n550850",
"muenchberg-muenchberg_-_gewerbegebiet-n550900",
"muenchberg-muenchberg_-_stadtkirche_peter_und_paul-n550830",
"muenchberg-muenchberg_-_stadtkirche_peter_und_paul-n550840",
"muenchberg-muenchberg_-_stadtkirche_peter_und_paul-n550860",
"muenchberg-muenchberg_-_stadtkirche_peter_und_paul-n550870",
"muenchberg-muenchberg_-_stadtkirche_peter_und_paul-n550880",
"muenchberg-muenchberg-f551770",
"muenchberg-muenchberg-f551780",
"muenchberg-muenchberg-f551810",
"muenchberg-muenchberg-f551830",
"muenchberg-muenchberg-f551840",
"muenchberg-muenchberg-n550890",
"muenchberg-muenchberg-n550930",
"muenchberg-naturpark_frankenwald-f552060",
"muenchberg-sauerhof-f551870",
"muenchen-ackermannbogen_in_muenchen-f481730",
"muenchen-ackermannbogen_in_muenchen-f481730",
"muenchen-adac_muenchen-f482320",
"muenchen-adac_muenchen-f482380",
"muenchen-adac_muenchen-f482390",
"muenchen-adac_muenchen-n514060",
"muenchen-adac_muenchen-n514070",
"muenchen-adac_muenchen-n514080",
"muenchen-adac_muenchen-n514340",
"muenchen-adac_muenchen-n514350",
"muenchen-adac_muenchen-n514360",
"muenchen-adac_muenchen-n514370",
"muenchen-adac-c098000",
"muenchen-adac-c098130",
"muenchen-adac-c098190",
"muenchen-adac-c098260",
"muenchen-adac-f482360",
"muenchen-allach-f513620",
"muenchen-allianz_arena-c091570",
"muenchen-allianz_arena-c091720",
"muenchen-allianz_arena-c092310",
"muenchen-allianz_arena-c092740",
"muenchen-allianz_arena-c092940",
"muenchen-allianz_arena-c096900",
"muenchen-allianz_arena-c097130",
"muenchen-allianz_arena-c097260",
"muenchen-allianz_arena-c097470",
"muenchen-allianz_arena-c098410",
"muenchen-alter_botanischer_garten-f513250",
"muenchen-alter_botanischer_garten-f513260",
"muenchen-altstadt_muenchen-f482510",
"muenchen-altstadt_muenchen-f482710",
"muenchen-altstadt_muenchen-f482720",
"muenchen-altstadt_muenchen-f482730",
"muenchen-altstadt_muenchen-f482740",
"muenchen-altstadt_muenchen-n513980",
"muenchen-altstadt_muenchen-n514250",
"muenchen-anatomische_anstalt_muenchen-n514280",
"muenchen-apothekenhof-f482630",
"muenchen-apothekenhof-f482640",
"muenchen-arnulfstrasse-f481770",
"muenchen-au__muenchen-f513190",
"muenchen-au__muenchen-f513200",
"muenchen-audi_dome_muenchen-f482260",
"muenchen-audi_dome_muenchen-f482270",
"muenchen-audi_dome_muenchen-f482280",
"muenchen-audi_dome_muenchen-f482290",
"muenchen-audi_dome_muenchen-f482340",
"muenchen-audi_dome_muenchen-f482350",
"muenchen-badeburger_see-n514460",
"muenchen-badeburg-n514430",
"muenchen-baustelle_marienhof-f482620",
"muenchen-baustelle_sap_garten_muenchen-f483080",
"muenchen-bavariaring-f482770",
"muenchen-berliner_viertel-f482880",
"muenchen-birketweg-n514110",
"muenchen-bmw_ag-f481700",
"muenchen-bmw_ag-f482960",
"muenchen-bmw_ag-f482970",
"muenchen-bmw_ag-f482980",
"muenchen-bmw_muenchen-f513410",
"muenchen-bmw-c097510",
"muenchen-bruecke_an_der_dachauer_strasse-f483140",
"muenchen-burg_gruenwald-f482090",
"muenchen-burg_schwaneck-f482060",
"muenchen-busbetriebshof_moosach-f483100",
"muenchen-campus_justiz_muenchen-n513870",
"muenchen-christoph-rapparini-bogen-f481840",
"muenchen-christoph-rapparini-bogen-n514400",
"muenchen-christoph-rapparini-bogen-n514410",
"muenchen-dhl_zustellbasis-f481790",
"muenchen-dhl_zustellbasis-f481790",
"muenchen-dhl_zustellbasis-f481880",
"muenchen-donnersberger_bruecke-f481780",
"muenchen-donnersbergerbruecke-f481890",
"muenchen-etting-f513660",
"muenchen-europaeisches_patentamt-f482550",
"muenchen-europaeisches_patentamt-f482590",
"muenchen-firmengebaeude-c091470",
"muenchen-flaucher___isar-f482040",
"muenchen-forstenried-f482120",
"muenchen-frauenkirche_muenchen-f482430",
"muenchen-frauenkirche_muenchen-f482610",
"muenchen-frauenkirche_muenchen-f482610",
"muenchen-frauenkirche-n514260",
"muenchen-friedenheim-n514380",
"muenchen-friedhof_haidhausen-n514180",
"muenchen-friedhof_haidhausen-n514190",
"muenchen-fuerstenrieder_strasse-f482170",
"muenchen-gaertnerplatz-n514220",
"muenchen-gaertnerplatz-n514230",
"muenchen-gewerbegebiet_hohenbrunn-f512960",
"muenchen-gewerbegebiet_hohenbrunn-f512970",
"muenchen-gewerbegebiet_ottobrunn_mitte-f513040",
"muenchen-gewerbegebiet_ottobrunn_mitte-f513050",
"muenchen-gewerbegebiet_ottobrunn_nord-f513060",
"muenchen-graggenauerviertel-f482690",
"muenchen-grosshesseloher_bruecke-f482050",
"muenchen-grossmarkthalle_muenchen-f482020",
"muenchen-hackenviertel_muenchen-f482750",
"muenchen-hansapark_muenchen-f482300",
"muenchen-hansapark_muenchen-f482330",
"muenchen-hauptbahnhof_muenchen-f481900",
"muenchen-hauptbahnhof_muenchen-f481940",
"muenchen-hauptbahnhof-c097670",
"muenchen-hauptbahnhof-c097680",
"muenchen-hauptbahnhof-c097700",
"muenchen-hauptbahnhof-c097730",
"muenchen-hauptbahnhof-c098330",
"muenchen-hauptbahnhof-f481760",
"muenchen-heilig_kreuz_kirche_muenchen-n513850",
"muenchen-heilig-geist-kirche-f482700",
"muenchen-heizkraftwerk_muenchen_sued-f482010",
"muenchen-heizkraftwerk_muenchen_sued-f482010",
"muenchen-highlight_towers__ibm_-f482800",
"muenchen-highlight_towers__ibm_-f482810",
"muenchen-highlight_towers__ibm_-f482820",
"muenchen-highlight_towers__ibm_-f482830",
"muenchen-highlight_towers__ibm_-f482870",
"muenchen-hochbunker-f482930",
"muenchen-hochbunker-f482940",
"muenchen-hohenbrunn-f512990",
"muenchen-hohenbrunn-f513000",
"muenchen-hohenbrunn-f513010",
"muenchen-ice_bahnbetriebswerk_muenchen-f481800",
"muenchen-ice_bahnbetriebswerk_muenchen-f481810",
"muenchen-ice_bahnbetriebswerk_muenchen-f481830",
"muenchen-ice_bahnbetriebswerk_muenchen-n514100",
"muenchen-innerer_ludwigsbruecke-n514210",
"muenchen-isar-f481990",
"muenchen-isar-f482000",
"muenchen-isar-f482030",
"muenchen-isartor-f482520",
"muenchen-justizpalast_muenchen-f481950",
"muenchen-karl-scharnagl-ring-f482650",
"muenchen-karlsplatz-f481920",
"muenchen-karlsplatz-f481930",
"muenchen-karlsplatz-f482420",
"muenchen-karlsplatz-f482420",
"muenchen-kieswerk_allach-f513630",
"muenchen-kieswerk_allach-f513640",
"muenchen-kirche-c091350",
"muenchen-kirche-c091410",
"muenchen-kirche-c091430",
"muenchen-kleine_isar-f482560",
"muenchen-klinikviertel_muenchen-f482760",
"muenchen-kunstrasenplatz-c091540",
"muenchen-laim-n514390",
"muenchen-landschaftspark_hachinger_tal-f513070",
"muenchen-landschaftspark_hachinger_tal-f513080",
"muenchen-landschaftspark_hachinger_tal-f513090",
"muenchen-laufwasserkraftwerk_pullach-f482070",
"muenchen-laufwasserkraftwerk_pullach-f482080",
"muenchen-leopoldstrasse-f482890",
"muenchen-leopoldstrasse-f482900",
"muenchen-lerchenauer_strasse-f481710",
"muenchen-leuchtenbergring__muenchen_ost-n514170",
"muenchen-leuchtenbergring-n514160",
"muenchen-ludlstrasse-f482160",
"muenchen-ludlstrasse-f482200",
"muenchen-lusssee-f513650",
"muenchen-mariannenplatz-f482680",
"muenchen-marienplatz_muenchen-f482600",
"muenchen-marienplatz_muenchen-f482700",
"muenchen-marienplatz_muenchen-f482700",
"muenchen-marienplatz-n514240",
"muenchen-maximilianeum-n513960",
"muenchen-max-joseph-platz-f482640",
"muenchen-maxvorstadt-f481740",
"muenchen-maxvorstadt-f481750",
"muenchen-maxvorstadt-f513270",
"muenchen-maxvorstadt-f513280",
"muenchen-maxvorstadt-f513290",
"muenchen-maxvorstadt-f513300",
"muenchen-mercedes_benz-c098320",
"muenchen-mercedes_benz-c098380",
"muenchen-monopteros_apollotmepel-n514450",
"muenchen-muenchen_auenstrasse-n514000",
"muenchen-muenchen_birketweg-f481870",
"muenchen-muenchen_laim-f481820",
"muenchen-muenchen_laim-f482190",
"muenchen-muenchen_moosach-f481610",
"muenchen-muenchen_nord-f482910",
"muenchen-muenchen_nord-f482920",
"muenchen-muenchen_pullach-f482060",
"muenchen-muenchen-f481540",
"muenchen-muenchen-f481550",
"muenchen-muenchen-f481560",
"muenchen-muenchen-f481570",
"muenchen-muenchen-f481580",
"muenchen-muenchen-f481630",
"muenchen-muenchen-f481690",
"muenchen-muenchen-f481720",
"muenchen-muenchen-f481850",
"muenchen-muenchen-f481950",
"muenchen-muenchen-f481960",
"muenchen-muenchen-f481970",
"muenchen-muenchen-f482150",
"muenchen-muenchen-f482210",
"muenchen-muenchen-f482310",
"muenchen-muenchen-f482790",
"muenchen-muenchen-f483060",
"muenchen-muenchen-f483070",
"muenchen-muenchen-f513170",
"muenchen-muenchen-f513220",
"muenchen-muenchen-f513230",
"muenchen-muenchen-f513240",
"muenchen-muenchen-n513860",
"muenchen-muenchner_tor-f482780",
"muenchen-munich_re-f482860",
"muenchen-museumsinsel-f482540",
"muenchen-museumsinsel-f482570",
"muenchen-museumsinsel-f482580",
"muenchen-museumsinsel-f513210",
"muenchen-museumsinsel-n513970",
"muenchen-neuer_suedfriedhof__perlach-f513150",
"muenchen-neuer_suedfriedhof__perlach-f513160",
"muenchen-neuhadern-f482140",
"muenchen-neuhadern-f482220",
"muenchen-neuhadern-f482240",
"muenchen-neuperlach-f513120",
"muenchen-nymphenburg-f513500",
"muenchen-nymphenburg-f513520",
"muenchen-nymphenburg-f513540",
"muenchen-nymphenburg-f513550",
"muenchen-nymphenburg-f513560",
"muenchen-nymphenburg-f513570",
"muenchen-nymphenburg-n514470",
"muenchen-nymphenburg-n514480",
"muenchen-nymphenburg-n514490",
"muenchen-o2_tower-f513360",
"muenchen-obersendling-f482110",
"muenchen-odeonsplatz__hofgarten-f482440",
"muenchen-odeonsplatz__hofgarten-f482440",
"muenchen-odeonsplatz__hofgarten-f482450",
"muenchen-odeonsplatz__hofgarten-f482470",
"muenchen-odeonsplatz__hofgarten-f482480",
"muenchen-odeonsplatz__hofgarten-f482490",
"muenchen-odeonsplatz__hofgarten-f482500",
"muenchen-odeonsplatz__hofgarten-f482660",
"muenchen-odeonsplatz__hofgarten-f482660",
"muenchen-odeonsplatz__hofgarten-f482670",
"muenchen-olympiapark_-f513320",
"muenchen-olympiapark_muenchen-f481640",
"muenchen-olympiapark_muenchen-f481650",
"muenchen-olympiapark_muenchen-f481670",
"muenchen-olympiapark_muenchen-f483020",
"muenchen-olympiapark_muenchen-f483030",
"muenchen-olympiapark_muenchen-f483040",
"muenchen-olympiapark_muenchen-f483050",
"muenchen-olympiapark_nord-f481680",
"muenchen-olympiapark_nord-f482950",
"muenchen-olympiapark-f513330",
"muenchen-olympiapark-f513340",
"muenchen-olympiapark-f513350",
"muenchen-olympiastadion-f513370",
"muenchen-olympiastadion-f513380",
"muenchen-olympiastadion-f513390",
"muenchen-olympiaturm_muenchen-f483010",
"muenchen-olympiaturm_muenchen-f483020",
"muenchen-olympiaturm-f513400",
"muenchen-ostfriedhof_aussegnungshalle-n513880",
"muenchen-ostfriedhof_aussegnungshalle-n513890",
"muenchen-ostfriedhof_aussegnungshalle-n513900",
"muenchen-ostfriedhof_aussegnungshalle-n513920",
"muenchen-ostfriedhof_aussegnungshalle-n513930",
"muenchen-ottobrunn-f513030",
"muenchen-perlach-f513130",
"muenchen-perlach-f513140",
"muenchen-pfarrkirche_sankt_martin-f483120",
"muenchen-photovoltaikanlage_hohenbrunn-f513020",
"muenchen-rangierbahnhof_muenchen-nord-f483150",
"muenchen-rangierbahnhof_muenchen-nord-f483160",
"muenchen-rangierbahnhof_muenchen-nord-f483170",
"muenchen-rangierbahnhof_muenchen-nord-f483180",
"muenchen-rathaus_muenchen-n514270",
"muenchen-renolit_se_muenchen-f482100",
"muenchen-residenz_muenchen-f482460",
"muenchen-riedlerstrasse-f482370",
"muenchen-rosa-luxemburg-platz-f513310",
"muenchen-schloss_nymphenburg-f481470",
"muenchen-schloss_nymphenburg-f481480",
"muenchen-schloss_nymphenburg-f481490",
"muenchen-schloss_nymphenburg-f481500",
"muenchen-schloss_nymphenburg-f481510",
"muenchen-schloss_nymphenburg-f481530",
"muenchen-schulzentrum_an_der_gerastrasse-f483130",
"muenchen-schwabing-f513420",
"muenchen-schwanthalerhoehe-n514090",
"muenchen-schwenk_beton_suedbayern-f483170",
"muenchen-sparkasse_muenchen-f482850",
"muenchen-spedition_nagel-c09620",
"muenchen-spielzeugmuseum-f482700",
"muenchen-st__johann_baptist-n514200",
"muenchen-st__ludwig_kirche-n514130",
"muenchen-st__ludwig_kirche-n514140",
"muenchen-st__ludwig_kirche-n514150",
"muenchen-st__peter_kirche-f482700",
"muenchen-st__rupert_kirche-n514050",
"muenchen-stadtautobahnen-c097570",
"muenchen-suedfriedhof_muenchen-f513180",
"muenchen-technologiepark_muenchen-f483090",
"muenchen-telefonica_germany-f483110",
"muenchen-thalkirchener_strasse-n514010",
"muenchen-theresienwiese-f481910",
"muenchen-theresienwiese-f481980",
"muenchen-theresienwiese-f482400",
"muenchen-theresienwiese-f482410",
"muenchen-theresienwiese-f513440",
"muenchen-theresienwiese-n513990",
"muenchen-theresienwiese-n514030",
"muenchen-theresienwiese-n514040",
"muenchen-theresienwiese-n514290",
"muenchen-theresienwiese-n514300",
"muenchen-theresienwiese-n514310",
"muenchen-theresienwiese-n514320",
"muenchen-theresienwiese-n514330",
"muenchen-tumblinger_strasse-n514020",
"muenchen-turm-c097840",
"muenchen-turm-c097850",
"muenchen-turm-c097900",
"muenchen-u-bahn_station_nordfriedhof-f482840",
"muenchen-unterbiberg-f513100",
"muenchen-unterbiberg-f513110",
"muenchen-untermenzing-f481450",
"muenchen-untermenzing-f481460",
"muenchen-untermenzing-f513580",
"muenchen-untermenzing-f513590",
"muenchen-untermenzing-f513600",
"muenchen-untermenzing-f513610",
"muenchen-wasserkraftwerk_pullach-f482080",
"muenchen-wehranlage_oberfoehring-n513940",
"muenchen-wehranlage_oberfoehring-n513950",
"muenchen-wehrsteg___kabelsteg_an_der_isar-f482530",
"muenchen-wehrsteg_an_der_isar-f482530",
"muenchen-westfriedhof_muenchen-f481590",
"muenchen-westpark_muenchen-f482230",
"muenchen-wotanstrasse-f481860",
"muenchen-wotanstrasse-n514120",
"muenchsried-brunn-n301320",
"muenster__lech_-gaertnerei-n323750",
"muenster__lech_-muenster__lech_-n323770",
"muenster__lech_-muenster__lech_-n323780",
"muenster__lech_-sulz-n323730",
"muhr_am_see-altmuehlsee-c214400",
"muhr_am_see-altmuehlsee-c214420",
"muhr_am_see-altmuehlsee-c214430",
"muhr_am_see-altmuehlsee-c214450",
"muhr_am_see-altmuehlsee-c214500",
"muhr_am_see-altmuehlsee-c214510",
"muhr_am_see-altmuehlsee-c214530",
"naumburg-gewerbepark_weissenfels-n355080",
"naumburg-naumburger_dom-n355300",
"naumburg-naumburger_dom-n355330",
"naumburg-naumburger_dom-n355350",
"naumburg-oberlandesgericht-n355360",
"naumburg-priessnitz-n355410",
"naumburg-priessnitz-n355420",
"naumburg-saale-n355260",
"naumburg-saale-n355390",
"naumburg-schoenburg-n355170",
"naumburg-schoenburg-n355200",
"naumburg-schoenburg-n355210",
"naumburg-schoenburg-n355220",
"naumburg-schoenburg-n355230",
"naurod-forst_bei_naurod-f374570",
"naurod-naurod_bei_wiesbaden-f374540",
"naurod-naurod_bei_wiesbaden-f374550",
"neckargemuend-neckargemuend-f377810",
"neideck-burgruine_neideck-n267520",
"neideck-segelflugzeug-n267400",
"nennslingen-kirche_nennslingen-f484120",
"nennslingen-kohlmuehle-f480790",
"nennslingen-kohlmuehle-f48790",
"nennslingen-nennslingen-f484110",
"nennslingen-nennslingen-f484120",
"nennslingen-nennslingen-f48760",
"neresheim-kloster_neresheim-c504780",
"neresheim-kloster_neresheim-c504790",
"neresheim-kloster_neresheim-c504810",
"neuburg_an_der_donau-audi_driving_experience_center-f481090",
"neuburg_an_der_donau-bruck-f481120",
"neuburg_an_der_donau-industriegebiet_neuburg-gruenau-f481050",
"neuburg_an_der_donau-industriegebiet_neuburg-gruenau-f481080",
"neuburg_an_der_donau-karlshuld-f481160",
"neuburg_an_der_donau-karlshuld-f481170",
"neuburg_an_der_donau-rathei_see-f481150",
"neuenkirchen_am_sand-neuenkirchen_am_sand-f454070",
"neufahrn-ettenkofen-n511500",
"neufahrn-hebramsdorf-n511510",
"neufahrn-roehrberg-n511520",
"neuhaus-burg_veldenstein-n275730",
"neuhaus-burg_veldenstein-n275770",
"neuhaus-burg_veldenstein-n275810",
"neuhausen-neuhausen-f513700",
"neuhausen-neuhausen-f513710",
"neuhof_an_der_zenn-hirschneuses-n327550",
"neuhof_an_der_zenn-kreisverkehr-f43150",
"neukirchen_bei_sulzbach_rosenberg-fabrik_bei_holnstein-f550500",
"neukirchen-balbini-dehnhof-n523920",
"neumarkt_i__d__oberpfalz-hasenheide-f510510",
"neumarkt_i_d__oberpfalz-gewerbegebiet_weissmarter-n510950",
"neumarkt_i_d__oberpfalz-kirche_st__josef-n510760",
"neumarkt_i_d__oberpfalz-klaerwerk-n510740",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510710",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510720",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510750",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510770",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510780",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510800",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510810",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510820",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510850",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510860",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510880",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510890",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510900",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510910",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510920",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510940",
"neumarkt_i_d__oberpfalz-neumarkt_i_d__oberpfalz-n510980",
"neumarkt_i_d__oberpfalz-pfleiderer_deutschland_gmbh-n510930",
"neumarkt_i_d__oberpfalz-staatliche_berufsschule_neumarkt-n510790",
"neumarkt_in_der_oberpfalz-baggersee_schlierfer_heide-f520590",
"neumarkt_in_der_oberpfalz-baggersee_schlierfer_heide-f520610",
"neumarkt_in_der_oberpfalz-burgruine_wolfstein-f432270",
"neumarkt_in_der_oberpfalz-burgruine_wolfstein-f432280",
"neumarkt_in_der_oberpfalz-burgruine_wolfstein-f432290",
"neumarkt_in_der_oberpfalz-burgruine_wolfstein-f432320",
"neumarkt_in_der_oberpfalz-erlangen-c314810",
"neumarkt_in_der_oberpfalz-gewerbegebiet_stauf-sued-f520560",
"neumarkt_in_der_oberpfalz-gewerbegebiet_stauf-sued-f520570",
"neumarkt_in_der_oberpfalz-gewerbegebiet_stauf-sued-f520580",
"neumarkt_in_der_oberpfalz-golfplaetze_bei_neumarkt__oberpfalz_-f442730",
"neumarkt_in_der_oberpfalz-laehr-n303080",
"neumarkt_in_der_oberpfalz-laehr-n303090",
"neumarkt_in_der_oberpfalz-mariahilfberg-n303120",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510400",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510410",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510420",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510430",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510440",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510450",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510460",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510470",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510490",
"neumarkt_in_der_oberpfalz-neumarkt_i__d__oberpfalz-f510500",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303130",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303140",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303150",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303160",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303170",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303190",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303200",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303210",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303220",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303230",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303240",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n303250",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n30860",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n30900",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n30910",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n30920",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n30930",
"neumarkt_in_der_oberpfalz-neumarkt_in_der_oberpfalz-n30940",
"neumarkt_in_der_oberpfalz-panorama_in_der_oberpfalz-f421790",
"neumarkt_in_der_oberpfalz-pfleiderer_deutschland_gmbh-f510480",
"neumarkt_in_der_oberpfalz-rittershof-f520540",
"neumarkt_in_der_oberpfalz-talbruecke_pilsach-f432340",
"neumarkt_in_der_oberpfalz-talbruecke_pilsach-f432360",
"neumarkt_in_der_oberpfalz-tsv_ochsenbruck-n068770",
"neunkirchen_am_sand-neunkirchen_am_sand-f550450",
"neunkirchen_am_sand-neunkirchen_am_sand-f550460",
"neunkirchen_am_sand-neunkirchen_am_sand-n275280",
"neunkirchen_am_sand-neunkirchen_am_sand-n275290",
"neunkirchen_am_sand-neunkirchen_am_sand-n275310",
"neunkirchen_am_sand-speck_pumpen-f550440",
"neunkirchen_am_sand-wertstoffhof_neunkirchen_am_sand-f550430",
"neunkirchen-neunkirchen-f510600",
"neunkirchen-neunkirchen-f510610",
"neunkirchen-neunkirchen-f510620",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n327790",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n327820",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n327860",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n327870",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n327890",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n327960",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n327980",
"neustadt_an_der_aisch-brand_bei_neustadt_aisch-n328000",
"neu-ulm-donauklinik-c504540",
"neu-ulm-herdbruecke-c504530",
"neu-ulm-neu-ulm_bahnhof-c504330",
"neu-ulm-neu-ulm-c504340",
"niederjosbach-niederjosbach-f374490",
"niederpoellnitz-niederpoellnitz-n351670",
"niederschoenenfeld-niederschoenenfeld-n325980",
"niederschoenenfeld-niederschoenenfeld-n326000",
"niederwinkling-mittenrain-n523010",
"niederwinkling-niederwinkling-n523080",
"niederwinkling-welchenberg-n523020",
"niederwinkling-welchenberg-n523040",
"nittendorf-viergstetten-n511090",
"nittendorf-viergstetten-n511100",
"nittendorf-viergstetten-n511120",
"noerdlingen-ehingen_am_ries-c504860",
"noerdlingen-geweregebiet_noerdlingen-f502210",
"noerdlingen-noerdlingen-c504820",
"noerdlingen-noerdlingen-c504830",
"noerdlingen-noerdlingen-c504840",
"noerdlingen-noerdlingen-c504850",
"noerdlingen-noerdlingen-f502150",
"noerdlingen-noerdlingen-f502170",
"noerdlingen-noerdlingen-f502180",
"nordenberg-biogasanlage-f378390",
"nordenberg-nordenberg-f378400",
"nordendorf-blankenburg-n325690",
"nuernberg-_-c1900",
"nuernberg-_-f381410",
"nuernberg-_-n249230",
"nuernberg-1__fcn_vs__werder_bremen-c106560",
"nuernberg-1_fcn__valznerweiher_-f47810",
"nuernberg-a73_nuernberg-hafen-f424610",
"nuernberg-a73_nuernberg-hafen-f424640",
"nuernberg-aachener_strasse-c312410",
"nuernberg-abriss_lessingstrasse-c122530",
"nuernberg-achterbahn__volksfest_-n069040",
"nuernberg-acker-c207040",
"nuernberg-adac-c133090",
"nuernberg-adac-c194430",
"nuernberg-adam-klein-strasse-f554990",
"nuernberg-adam-klein-strasse-f555000",
"nuernberg-adam-klein-strasse-f555010",
"nuernberg-adam-klein-strasse-f555020",
"nuernberg-adam-klein-strasse-f555030",
"nuernberg-adam-klein-strasse-f555160",
"nuernberg-adam-klein-strasse-f555170",
"nuernberg-adam-klein-strasse-f555180",
"nuernberg-adam-klein-strasse-f555200",
"nuernberg-adam-klein-strasse-f555210",
"nuernberg-adam-kraft-realschule-f490400",
"nuernberg-adlerparkhaus-n149270",
"nuernberg-adlerstrasse-n149280",
"nuernberg-adolf-reichwein-schule-f492650",
"nuernberg-aecker-c151670",
"nuernberg-aeg_campus-c214960",
"nuernberg-aeg_campus-c214980",
"nuernberg-aeg_campus-c215020",
"nuernberg-aeg_campus-c215040",
"nuernberg-aeg_campus-c215050",
"nuernberg-aeg_campus-c215100",
"nuernberg-aeg_campus-c215160",
"nuernberg-aeg_campus-f392350",
"nuernberg-aeg_campus-f406250",
"nuernberg-aeg_campus-f407240",
"nuernberg-aeg_campus-f407250",
"nuernberg-aeg_campus-f407310",
"nuernberg-aeg_campus-f407320",
"nuernberg-aeg_campus-f411900",
"nuernberg-aeg_campus-f465470",
"nuernberg-aeg_fuerther_strasse-c068810",
"nuernberg-aeg_gelaende-c124690",
"nuernberg-aeg-cd17600",
"nuernberg-aeg-n245120",
"nuernberg-aerztehaus_am_stadtpark-nn81170",
"nuernberg-aeussere-bayreuther-strasse-c283370",
"nuernberg-aeussere-bayreuther-strasse-n145030",
"nuernberg-aeussere-bayreuther-strasse-n303790",
"nuernberg-aeussere-bucher-strasse-c244660",
"nuernberg-aeussere-cramer-klett-strasse-c173070",
"nuernberg-aeussere-cramer-klett-strasse-c173100",
"nuernberg-aeussere-grossweidenmuehlstrasse-c241200",
"nuernberg-aeussere-grossweidenmuehlstrasse-c241220",
"nuernberg-aeussere-grossweidenmuehlstrasse-c241230",
"nuernberg-aeussere-grossweidenmuehlstrasse-c241250",
"nuernberg-aeussere-sulzbacher-strasse-c081340",
"nuernberg-aeussere-sulzbacher-strasse-c133240",
"nuernberg-aeussere-sulzbacher-strasse-c133250",
"nuernberg-aeussere-sulzbacher-strasse-f404840",
"nuernberg-aeussere-sulzbacher-strasse-f493030",
"nuernberg-aeussere-sulzbacher-strasse-n303690",
"nuernberg-aeussere-sulzbacher-strasse-n362330",
"nuernberg-aeussere-sulzbacher-strasse-n36360",
"nuernberg-aeussere-sulzbacher-strasse-nn82880",
"nuernberg-airport-n245370",
"nuernberg-albrecht-duerer-airport-c035870",
"nuernberg-albrecht-duerer-airport-c051080",
"nuernberg-albrecht-duerer-airport-c052360",
"nuernberg-albrecht-duerer-airport-c056310",
"nuernberg-albrecht-duerer-airport-c068240",
"nuernberg-albrecht-duerer-airport-c193010",
"nuernberg-albrecht-duerer-airport-c193040",
"nuernberg-albrecht-duerer-airport-c193070",
"nuernberg-albrecht-duerer-airport-c193380",
"nuernberg-albrecht-duerer-airport-c196820",
"nuernberg-albrecht-duerer-airport-c25240",
"nuernberg-albrecht-duerer-airport-c28320",
"nuernberg-albrecht-duerer-airport-c28330",
"nuernberg-albrecht-duerer-airport-c312800",
"nuernberg-albrecht-duerer-airport-c3130",
"nuernberg-albrecht-duerer-airport-c3150",
"nuernberg-albrecht-duerer-airport-c563590",
"nuernberg-albrecht-duerer-airport-cc31330",
"nuernberg-albrecht-duerer-airport-f381570",
"nuernberg-albrecht-duerer-airport-f381580",
"nuernberg-albrecht-duerer-airport-f382050",
"nuernberg-albrecht-duerer-airport-f38260",
"nuernberg-albrecht-duerer-airport-f38270",
"nuernberg-albrecht-duerer-airport-f38280",
"nuernberg-albrecht-duerer-airport-f38340",
"nuernberg-albrecht-duerer-airport-f38350",
"nuernberg-albrecht-duerer-airport-f38590",
"nuernberg-albrecht-duerer-airport-f396200",
"nuernberg-albrecht-duerer-airport-f396220",
"nuernberg-albrecht-duerer-airport-f396380",
"nuernberg-albrecht-duerer-airport-f396390",
"nuernberg-albrecht-duerer-airport-f407140",
"nuernberg-albrecht-duerer-airport-f407840",
"nuernberg-albrecht-duerer-airport-f407860",
"nuernberg-albrecht-duerer-airport-f407870",
"nuernberg-albrecht-duerer-airport-f424130",
"nuernberg-albrecht-duerer-airport-f424140",
"nuernberg-albrecht-duerer-airport-f424150",
"nuernberg-albrecht-duerer-airport-f424160",
"nuernberg-albrecht-duerer-airport-f424180",
"nuernberg-albrecht-duerer-airport-f426850",
"nuernberg-albrecht-duerer-airport-f463850",
"nuernberg-albrecht-duerer-airport-f463900",
"nuernberg-albrecht-duerer-airport-f463900",
"nuernberg-albrecht-duerer-airport-f47120",
"nuernberg-albrecht-duerer-airport-f490230",
"nuernberg-albrecht-duerer-airport-f490240",
"nuernberg-albrecht-duerer-airport-f502550",
"nuernberg-albrecht-duerer-airport-f502560",
"nuernberg-albrecht-duerer-airport-f502570",
"nuernberg-albrecht-duerer-airport-f502590",
"nuernberg-albrecht-duerer-airport-f510130",
"nuernberg-albrecht-duerer-airport-f510140",
"nuernberg-albrecht-duerer-airport-f510150",
"nuernberg-albrecht-duerer-airport-f531380",
"nuernberg-albrecht-duerer-airport-f532390",
"nuernberg-albrecht-duerer-airport-f532400",
"nuernberg-albrecht-duerer-airport-f532410",
"nuernberg-albrecht-duerer-airport-f532420",
"nuernberg-albrecht-duerer-airport-f532440",
"nuernberg-albrecht-duerer-airport-f532460",
"nuernberg-albrecht-duerer-airport-f532470",
"nuernberg-albrecht-duerer-airport-f532480",
"nuernberg-albrecht-duerer-airport-f532500",
"nuernberg-albrecht-duerer-airport-f540050",
"nuernberg-albrecht-duerer-airport-f540060",
"nuernberg-albrecht-duerer-airport-f540070",
"nuernberg-albrecht-duerer-airport-f554030",
"nuernberg-albrecht-duerer-airport-n05240",
"nuernberg-albrecht-duerer-airport-n261340",
"nuernberg-albrecht-duerer-airport-n261350",
"nuernberg-albrecht-duerer-airport-n29150",
"nuernberg-albrecht-duerer-airport-n29170",
"nuernberg-albrecht-duerer-airport-n303940",
"nuernberg-albrecht-duerer-airport-n303960",
"nuernberg-albrecht-duerer-airport-n303970",
"nuernberg-albrecht-duerer-airport-n33780",
"nuernberg-albrecht-duerer-airport-n33790",
"nuernberg-albrecht-duerer-airport-n33830",
"nuernberg-albrecht-duerer-airport-n36300",
"nuernberg-albrecht-duerer-airport-n510380",
"nuernberg-albrecht-duerer-airport-n515810",
"nuernberg-albrecht-duerer-airport-n520240",
"nuernberg-albrecht-duerer-airport-n520260",
"nuernberg-albrecht-duerer-airport-n531870",
"nuernberg-albrecht-duerer-airport-n531890",
"nuernberg-albrecht-duerer-airport-nn64890",
"nuernberg-albrecht-duerer-airport-nn67990",
"nuernberg-allersberger_strasse___koehnstrasse-nn77420",
"nuernberg-allersberger_strasse_-_baustelle-n147830",
"nuernberg-allersberger_strasse_-_baustelle-n149420",
"nuernberg-allersberger_strasse-c108670",
"nuernberg-allersberger_strasse-c108680",
"nuernberg-allersberger_strasse-c121980",
"nuernberg-allersberger_strasse-c122300",
"nuernberg-allersberger_strasse-c155150",
"nuernberg-allersberger_strasse-c19810",
"nuernberg-allersberger_strasse-c243970",
"nuernberg-allersberger_strasse-c244030",
"nuernberg-allersberger_strasse-c251070",
"nuernberg-allersberger_strasse-c251090",
"nuernberg-allersberger_strasse-c251100",
"nuernberg-allersberger_strasse-c251110",
"nuernberg-allersberger_strasse-c251120",
"nuernberg-allersberger_strasse-c251130",
"nuernberg-allersberger_strasse-c251140",
"nuernberg-allersberger_strasse-c282660",
"nuernberg-allersberger_strasse-c563660",
"nuernberg-allersberger_strasse-f391760",
"nuernberg-allersberger_strasse-f391770",
"nuernberg-allersberger_strasse-f406460",
"nuernberg-allersberger_strasse-f426630",
"nuernberg-allersberger_strasse-f444950",
"nuernberg-allersberger_strasse-n361390",
"nuernberg-allersberger_strasse-n361400",
"nuernberg-allersberger_strasse-nn76820",
"nuernberg-allianz__thon_-n06510",
"nuernberg-allianz__thon_-n06570",
"nuernberg-almoshof-c208350",
"nuernberg-almoshof-c208360",
"nuernberg-almoshof-f381730",
"nuernberg-almoshof-f490250",
"nuernberg-almoshof-f490260",
"nuernberg-almoshof-n32100",
"nuernberg-alstadt_im_winter-c191460",
"nuernberg-alstadt_im_winter-c191470",
"nuernberg-alstadt_im_winter-c191480",
"nuernberg-alte_feuerwache_1-n263970",
"nuernberg-alte_feuerwache-f492530",
"nuernberg-alte_feuerwache-f492540",
"nuernberg-alte_messehaus_am_stadtpark-f383480",
"nuernberg-alte_messehaus-c283180",
"nuernberg-alte_messehaus-n247830",
"nuernberg-alte_messehaus-n303730",
"nuernberg-alte_messehaus-n303750",
"nuernberg-alte_messehaus-n303760",
"nuernberg-altenfurt-c281370",
"nuernberg-altenfurt-c281430",
"nuernberg-altenfurt-f510180",
"nuernberg-altenfurt-f510200",
"nuernberg-altenfurt-f520380",
"nuernberg-altenfurt-f520390",
"nuernberg-altenfurt-n145560",
"nuernberg-altenfurt-n145570",
"nuernberg-altenfurt-n145580",
"nuernberg-altenfurt-n145590",
"nuernberg-altenfurt-n145600",
"nuernberg-altenfurt-n293470",
"nuernberg-altenfurt-n293480",
"nuernberg-altenfurt-n293490",
"nuernberg-altenfurt-n293500",
"nuernberg-altenfurt-n293510",
"nuernberg-altenfurt-n293520",
"nuernberg-altenfurt-n293530",
"nuernberg-altenfurt-n30480",
"nuernberg-altenfurt-n30490",
"nuernberg-altenfurt-n510560",
"nuernberg-altenfurt-n510570",
"nuernberg-altenfurt-n510580",
"nuernberg-altenfurt-n510590",
"nuernberg-altstadt_baustelle-b181140",
"nuernberg-altstadt_baustelle-b181150",
"nuernberg-altstadt_bei_nacht-f395070",
"nuernberg-altstadt_bei_nacht-f395080",
"nuernberg-altstadt_bei_nacht-f396070",
"nuernberg-altstadt_im_winter-c191640",
"nuernberg-altstadt_im_winter-c196250",
"nuernberg-altstadt_nord-f514180",
"nuernberg-altstadt_sued-west-f492480",
"nuernberg-altstadt-b181120",
"nuernberg-altstadt-b181160",
"nuernberg-altstadt-b18940",
"nuernberg-altstadt-bb86380",
"nuernberg-altstadt-bb86590",
"nuernberg-altstadt-c053920",
"nuernberg-altstadt-c053940",
"nuernberg-altstadt-c056740",
"nuernberg-altstadt-c109170",
"nuernberg-altstadt-c187070",
"nuernberg-altstadt-c187150",
"nuernberg-altstadt-c191020",
"nuernberg-altstadt-c191390",
"nuernberg-altstadt-c193730",
"nuernberg-altstadt-c193960",
"nuernberg-altstadt-c194030",
"nuernberg-altstadt-c195340",
"nuernberg-altstadt-c195930",
"nuernberg-altstadt-c211980",
"nuernberg-altstadt-c212050",
"nuernberg-altstadt-cc25190",
"nuernberg-altstadt-cc25210",
"nuernberg-altstadt-cc31470",
"nuernberg-altstadt-cc31500",
"nuernberg-altstadt-cc31710",
"nuernberg-altstadt-cc31720",
"nuernberg-altstadt-cc4490",
"nuernberg-altstadt-f383850",
"nuernberg-altstadt-f391000",
"nuernberg-altstadt-f391010",
"nuernberg-altstadt-f392190",
"nuernberg-altstadt-f392200",
"nuernberg-altstadt-f392210",
"nuernberg-altstadt-f393450",
"nuernberg-altstadt-f393460",
"nuernberg-altstadt-f393480",
"nuernberg-altstadt-f393500",
"nuernberg-altstadt-f405300",
"nuernberg-altstadt-f405480",
"nuernberg-altstadt-f406160",
"nuernberg-altstadt-f406170",
"nuernberg-altstadt-f407390",
"nuernberg-altstadt-f407400",
"nuernberg-altstadt-f407440",
"nuernberg-altstadt-f407580",
"nuernberg-altstadt-f407590",
"nuernberg-altstadt-f407610",
"nuernberg-altstadt-f407730",
"nuernberg-altstadt-f412780",
"nuernberg-altstadt-f412920",
"nuernberg-altstadt-f412930",
"nuernberg-altstadt-f412970",
"nuernberg-altstadt-f413020",
"nuernberg-altstadt-f413030",
"nuernberg-altstadt-f425690",
"nuernberg-altstadt-f426200",
"nuernberg-altstadt-f445020",
"nuernberg-altstadt-f445030",
"nuernberg-altstadt-f445040",
"nuernberg-altstadt-f445060",
"nuernberg-altstadt-f445080",
"nuernberg-altstadt-f445090",
"nuernberg-altstadt-f445100",
"nuernberg-altstadt-f445110",
"nuernberg-altstadt-f445120",
"nuernberg-altstadt-f455370",
"nuernberg-altstadt-f455690",
"nuernberg-altstadt-f455710",
"nuernberg-altstadt-f484810",
"nuernberg-altstadt-f530740",
"nuernberg-altstadt-f531510",
"nuernberg-altstadt-f532650",
"nuernberg-altstadt-f532710",
"nuernberg-altstadt-f532790",
"nuernberg-altstadt-f540250",
"nuernberg-altstadt-f550250",
"nuernberg-altstadt-f554930",
"nuernberg-altstadtfest-c282850",
"nuernberg-altstadt-n053820",
"nuernberg-altstadt-n055780",
"nuernberg-altstadt-n055800",
"nuernberg-altstadt-n055890",
"nuernberg-altstadt-n055910",
"nuernberg-altstadt-n149110",
"nuernberg-altstadt-n294750",
"nuernberg-altstadt-n29580",
"nuernberg-altstadt-n33240",
"nuernberg-altstadt-n33450",
"nuernberg-altstadt-n342050",
"nuernberg-altstadt-n530180",
"nuernberg-altstadtpanorama-c233340",
"nuernberg-altstadtpanorama-c233360",
"nuernberg-altstadtpanorama-n363880",
"nuernberg-altstadtring-cc25230",
"nuernberg-altstadtring-cc31610",
"nuernberg-altstadtring-f492500",
"nuernberg-altstadtring-n054320",
"nuernberg-altstadtring-n054340",
"nuernberg-altstadtring-n054370",
"nuernberg-altstadtring-n054500",
"nuernberg-am_anger-c25250",
"nuernberg-am_fuchsloch-f531040",
"nuernberg-am_fuchsloch-f531050",
"nuernberg-am_fuchsloch-f531060",
"nuernberg-am_goldhammer-c225540",
"nuernberg-am_goldhammer-c225550",
"nuernberg-am_goldhammer-f492910",
"nuernberg-am_goldhammer-f492910",
"nuernberg-am_goldhammer-f492920",
"nuernberg-am_goldhammer-f492920",
"nuernberg-am_goldhammer-f554520",
"nuernberg-am_ostbahnhof-f471560",
"nuernberg-am_pferdemarkt-c226670",
"nuernberg-am_pferdemarkt-s562120",
"nuernberg-am_stadtpark-c563910",
"nuernberg-am_stadtpark-f393540",
"nuernberg-am_stadtpark-f393550",
"nuernberg-am_stadtpark-f393560",
"nuernberg-am_wegfeld-b18460",
"nuernberg-am_wegfeld-c151900",
"nuernberg-am_wegfeld-c151930",
"nuernberg-am_wegfeld-c174040",
"nuernberg-am_wegfeld-c174060",
"nuernberg-am_wegfeld-c174090",
"nuernberg-am_wegfeld-c174100",
"nuernberg-am_wegfeld-c188470",
"nuernberg-am_wegfeld-c21420",
"nuernberg-am_wegfeld-c21430",
"nuernberg-am_wegfeld-c21450",
"nuernberg-am_wegfeld-c21620",
"nuernberg-am_wegfeld-c21640",
"nuernberg-am_wegfeld-c23320",
"nuernberg-am_wegfeld-c23380",
"nuernberg-am_wegfeld-c23420",
"nuernberg-am_wegfeld-c244910",
"nuernberg-am_wegfeld-c244970",
"nuernberg-am_wegfeld-c245010",
"nuernberg-am_wegfeld-c312810",
"nuernberg-am_wegfeld-c312880",
"nuernberg-am_wegfeld-c312900",
"nuernberg-am_wegfeld-f532860",
"nuernberg-an_den_rampen-c037240",
"nuernberg-an_den_rampen-c037300",
"nuernberg-an_den_rampen-c134550",
"nuernberg-an_den_rampen-c172500",
"nuernberg-an_den_rampen-c172510",
"nuernberg-an_den_rampen-c172570",
"nuernberg-an_den_rampen-c226630",
"nuernberg-an_den_rampen-c226700",
"nuernberg-an_den_rampen-cc17670",
"nuernberg-an_den_rampen-cd17720",
"nuernberg-an_den_rampen-f435210",
"nuernberg-an_den_rampen-n075420",
"nuernberg-an_den_rampen-n075440",
"nuernberg-andernacher_strasse-b185330",
"nuernberg-andernacher_strasse-n303930",
"nuernberg-andreij-sacharow-platz-c563700",
"nuernberg-annapark-c122420",
"nuernberg-annapark-n147290",
"nuernberg-annapark-n147720",
"nuernberg-antennenanlage_vor-n515820",
"nuernberg-antennenanlage-f485150",
"nuernberg-aok_am_frauentorgraben-c226470",
"nuernberg-aok_am_frauentorgraben-c282760",
"nuernberg-aok_am_frauentorgraben-c282770",
"nuernberg-aok_am_frauentorgraben-c282900",
"nuernberg-aok_am_frauentorgraben-c311610",
"nuernberg-aok_am_frauentorgraben-c311630",
"nuernberg-aok_am_frauentorgraben-c311640",
"nuernberg-aok_am_frauentorgraben-c311660",
"nuernberg-aok_am_frauentorgraben-f39680",
"nuernberg-aok_am_frauentorgraben-f426240",
"nuernberg-aok_am_frauentorgraben-n148270",
"nuernberg-aok_am_frauentorgraben-n148280",
"nuernberg-aok_am_frauentorgraben-n263480",
"nuernberg-aok_am_frauentorgraben-n263490",
"nuernberg-aok_am_frauentorgraben-n263500",
"nuernberg-aok_am_frauentorgraben-n263510",
"nuernberg-aok_am_frauentorgraben-n263520",
"nuernberg-aok_am_frauentorgraben-n263530",
"nuernberg-aok_am_frauentorgraben-n263540",
"nuernberg-aok_am_frauentorgraben-n263550",
"nuernberg-aok_am_frauentorgraben-n274680",
"nuernberg-aok_am_frauentorgraben-n274690",
"nuernberg-aok_am_frauentorgraben-n294970",
"nuernberg-aok_am_frauentorgraben-n295050",
"nuernberg-aok_am_frauentorgraben-n342850",
"nuernberg-aok_am_frauentorgraben-n342910",
"nuernberg-aok_am_frauentorgraben-n364060",
"nuernberg-aok_am_frauentorgraben-n364140",
"nuernberg-aok_am_frauentorgraben-n364160",
"nuernberg-arbeitsgericht_nuernberg-f492520",
"nuernberg-archivpark-c212200",
"nuernberg-archivpark-c212210",
"nuernberg-archivpark-f39880",
"nuernberg-archivpark-f407630",
"nuernberg-archivpark-f530990",
"nuernberg-archivpark-n362920",
"nuernberg-arena_nuernberg-f455050",
"nuernberg-arena-f464590",
"nuernberg-aro-c105210",
"nuernberg-aro-f393730",
"nuernberg-asv_buchenbuehl-n05280",
"nuernberg-atv_wallensteinstrasse-n24270",
"nuernberg-atv_wallensteinstrasse-n24370",
"nuernberg-atv_wallensteinstrasse-n24700",
"nuernberg-atv_wallensteinstrasse-n24730",
"nuernberg-atzenhof-f407180",
"nuernberg-auf_aeg-f471290",
"nuernberg-auf_aeg-f471320",
"nuernberg-auf_aeg-f471330",
"nuernberg-auf_aeg-f485010",
"nuernberg-auf_aeg-f485030",
"nuernberg-auf_aeg-f493420",
"nuernberg-auf_aeg-f493420",
"nuernberg-auf_aeg-f493500",
"nuernberg-auf_aeg-f493510",
"nuernberg-auf_aeg-f493510",
"nuernberg-auf_aeg-f493520",
"nuernberg-auf_aeg-f531030",
"nuernberg-auf_aeg-f531290",
"nuernberg-auf_aeg-f531300",
"nuernberg-auf_aeg-f554370",
"nuernberg-auf_aeg-n515660",
"nuernberg-auf_aeg-n515690",
"nuernberg-auf_aeg-n515700",
"nuernberg-auf_aeg-n515720",
"nuernberg-auf_aeg-n515730",
"nuernberg-auf_aeg-n525440",
"nuernberg-auf_aeg-n530400",
"nuernberg-auf_aeg-n531320",
"nuernberg-aufsessplatz___pillenreuther_strasse-cc32050",
"nuernberg-aufsessplatz-c11430",
"nuernberg-aufsessplatz-c134430",
"nuernberg-aufsessplatz-c134440",
"nuernberg-aufsessplatz-c212830",
"nuernberg-aufsessplatz-cc25410",
"nuernberg-aufsessplatz-f406440",
"nuernberg-aufsessplatz-f406440",
"nuernberg-aufsessplatz-f426260",
"nuernberg-aufsessplatz-f426260",
"nuernberg-aufsessplatz-f426280",
"nuernberg-aufsessplatz-f426280",
"nuernberg-aufsessplatz-f426310",
"nuernberg-aufsessplatz-f444990",
"nuernberg-aufsessplatz-f445000",
"nuernberg-aufsessplatz-n076850",
"nuernberg-aufsessplatz-n076870",
"nuernberg-aufsessplatz-n246960",
"nuernberg-aufsessplatz-n361380",
"nuernberg-aufsessplatz-nn65730",
"nuernberg-aufsessplatz-nn75110",
"nuernberg-augsburger_strasse-n264070",
"nuernberg-augsburger_strasse-n264090",
"nuernberg-augsburger_strasse-n363270",
"nuernberg-augsburger_strasse-n363280",
"nuernberg-augsburger_strasse-n363330",
"nuernberg-augsburger_strasse-n363340",
"nuernberg-augsburger_strasse-n363510",
"nuernberg-augsburger_strasse-n364620",
"nuernberg-augsburger_strasse-n531240",
"nuernberg-augustinerhof-c244190",
"nuernberg-augustinerhof-c244210",
"nuernberg-augustinerhof-c244250",
"nuernberg-augustinerhof-c244320",
"nuernberg-augustinerhof-c251240",
"nuernberg-augustinerhof-c251250",
"nuernberg-augustinerhof-c251270",
"nuernberg-augustinerhof-c251350",
"nuernberg-augustinerhof-c251420",
"nuernberg-augustinerhof-c251460",
"nuernberg-augustinerhof-c251610",
"nuernberg-augustinerhof-c282420",
"nuernberg-augustinerhof-c282910",
"nuernberg-augustinerhof-c283000",
"nuernberg-augustinerhof-c283030",
"nuernberg-augustinerhof-c283140",
"nuernberg-augustinerhof-f426150",
"nuernberg-augustinerhof-f426160",
"nuernberg-augustinerhof-f445070",
"nuernberg-augustinerhof-f492390",
"nuernberg-augustinerhof-f492420",
"nuernberg-augustinerhof-n054920",
"nuernberg-augustinerhof-n069800",
"nuernberg-augustinerhof-n149530",
"nuernberg-augustinerhof-n263660",
"nuernberg-augustinerhof-n263700",
"nuernberg-augustinerhof-n274430",
"nuernberg-augustinerhof-n274470",
"nuernberg-augustinerhof-n274550",
"nuernberg-augustinerhof-n274600",
"nuernberg-augustinerhof-n274610",
"nuernberg-augustinerhof-n342070",
"nuernberg-augustinerhof-n342100",
"nuernberg-augustinerhof-n342160",
"nuernberg-augustinerstrasse-n263770",
"nuernberg-ausfahrt_b4_nach_grossgruendlach-n3250",
"nuernberg-ausfahrt_hafen-maiach-n146600",
"nuernberg-ausfahrt_wendelstein_a73-c281780",
"nuernberg-ausfahrt-n146630",
"nuernberg-austrasse-bb8390",
"nuernberg-austrasse-c19580",
"nuernberg-austrasse-c19590",
"nuernberg-austrasse-n245140",
"nuernberg-autobahn_a3___a9-n524970",
"nuernberg-autobahn_a3___a9-n525000",
"nuernberg-autobahn_a3___a9-n525010",
"nuernberg-autobahn_a3___a9-n525020",
"nuernberg-autobahn_a3__buchenbuehl_-f403980",
"nuernberg-autobahn_a3__buchenbuehl_-f404010",
"nuernberg-autobahn_a3_bei_buchenbuehl-f403850",
"nuernberg-autobahn_a3_bei_buchenbuehl-f403880",
"nuernberg-autobahn_a3_bei_buchenbuehl-f424120",
"nuernberg-autobahn_a3_bei_hessdorf-f445980",
"nuernberg-autobahn_a3_bei_hessdorf-f446010",
"nuernberg-autobahn_a3_nuernberg_nord-n520350",
"nuernberg-autobahn_a3_nuernberg-nord-f550270",
"nuernberg-autobahn_a3-f403780",
"nuernberg-autobahn_a3-f424050",
"nuernberg-autobahn_a6_bei_moorenbrunn-f424390",
"nuernberg-autobahn_a6_nuernberg-langwasser-f424440",
"nuernberg-autobahn_a6_nuernberg-langwasser-f424450",
"nuernberg-autobahn_a6_nuernberg-langwasser-f424460",
"nuernberg-autobahn_a73_-_koenigshof-f424530",
"nuernberg-autobahn_a73_-_koenigshof-f424550",
"nuernberg-autobahn_a73_-_koenigshof-f424700",
"nuernberg-autobahn_a73__nuernberg-koenigshof_-f402910",
"nuernberg-autobahn_a73__nuernberg-koenigshof_-f403040",
"nuernberg-autobahn_a73__nuernberg-koenigshof_-f403420",
"nuernberg-autobahn_a73__nuernberg-koenigshof_-f403470",
"nuernberg-autobahn_a73_zollhaus-f424510",
"nuernberg-autobahn_a73-f424340",
"nuernberg-autobahn_a73-f424740",
"nuernberg-autobahn_a73-f425560",
"nuernberg-autobahn_a73-f434330",
"nuernberg-autobahn_a9_bei_schwaig-f423840",
"nuernberg-autobahnausfahrt_a73_koenigshof-n29710",
"nuernberg-autobahnausfahrt_a73_nuernberg_zollhaus-n293270",
"nuernberg-autobahnausfahrt_a73_nuernberg_zollhaus-n293320",
"nuernberg-autobahnausfahrt_a73_nuernberg_zollhaus-n293340",
"nuernberg-autobahnausfahrt_nuernberg-nord-f38190",
"nuernberg-autobahnausfahrt-f381060",
"nuernberg-autobahn-c171420",
"nuernberg-autobahn-c171600",
"nuernberg-autobahn-c171620",
"nuernberg-autobahnkreuz_a3___a73-cc34190",
"nuernberg-autobahnkreuz_a3___a73-cc34200",
"nuernberg-autobahnkreuz_a3___a73-f445630",
"nuernberg-autobahnkreuz_a3___a73-f445710",
"nuernberg-autobahnkreuz_a3___a73-f445800",
"nuernberg-autobahnkreuz_a3___a73-f445930",
"nuernberg-autobahnkreuz_a3___a73-n056360",
"nuernberg-autobahnkreuz_a6___a3-c171200",
"nuernberg-autobahnkreuz_a6___a3-c171210",
"nuernberg-autobahnkreuz_a6___a73-f381020",
"nuernberg-autobahnkreuz_a6___a73-f381050",
"nuernberg-autobahnkreuz_a6___a73-f38950",
"nuernberg-autobahnkreuz_a6___a73-f38980",
"nuernberg-autobahnkreuz_a6___a73-f402820",
"nuernberg-autobahnkreuz_a6___a73-f402870",
"nuernberg-autobahnkreuz_a6___a73-f403210",
"nuernberg-autobahnkreuz_a6___a73-f403250",
"nuernberg-autobahnkreuz_a6___a73-f424420",
"nuernberg-autobahnkreuz_a6___a73-f424420",
"nuernberg-autobahnkreuz_a6___a73-f424480",
"nuernberg-autobahnkreuz_a6___a73-f444060",
"nuernberg-autobahnkreuz_a6___a73-f444070",
"nuernberg-autobahnkreuz_a6___a73-f444140",
"nuernberg-autobahnkreuz_a6___a73-f444150",
"nuernberg-autobahnkreuz_a6___a73-f454670",
"nuernberg-autobahnkreuz_a6___a73-f454690",
"nuernberg-autobahnkreuz_a6___a73-f463320",
"nuernberg-autobahnkreuz_a6___a9-f424400",
"nuernberg-autobahnkreuz_a6___a9-f510220",
"nuernberg-autobahnkreuz_a6___a9-f510230",
"nuernberg-autobahnkreuz_a6___a9-f520420",
"nuernberg-autobahnkreuz_a6___a9-n510600",
"nuernberg-autobahnkreuz_a6___a9-n510610",
"nuernberg-autobahnkreuz_a9___a6-n293370",
"nuernberg-autobahnkreuz_a9___a6-n293410",
"nuernberg-autobahnkreuz_a9___a6-n30500",
"nuernberg-autobahnkreuz_nuernberg-ost__a6_-c171260",
"nuernberg-autobahnkreuz_nuernberg-ost__a6_-c171270",
"nuernberg-autobahnkreuz_nuernberg-ost-c281410",
"nuernberg-autobahnkreuz_nuernberg-sued-f434340",
"nuernberg-autobahnkreuz_nuernberg-sued-f434390",
"nuernberg-autobahnkreuz_nuernberg-sued-n293160",
"nuernberg-autobahnkreuz_nuernberg-sued-n293200",
"nuernberg-autobahnkreuz_nuernberg-sued-n293220",
"nuernberg-autobahnkreuz_nuernberg-sued-n293250",
"nuernberg-autobahnkreuz_sued-c232170",
"nuernberg-autobahnkreuz-cc44400",
"nuernberg-autobahnmeisterei_fischbach-n145460",
"nuernberg-autobahn-n051980",
"nuernberg-autobahn-n145190",
"nuernberg-autobahnzufahrt_a3___b4-c035770",
"nuernberg-autohaus_feser_marienbergstrasse-c12810",
"nuernberg-autohaus_feser-b185300",
"nuernberg-autohaus_feser-b185320",
"nuernberg-autohaus_feser-c12700",
"nuernberg-autohaus_feser-c12710",
"nuernberg-autohaus_feser-c12790",
"nuernberg-autohaus_feser-c12850",
"nuernberg-autohaus_feser-c135420",
"nuernberg-autohaus_feser-c135450",
"nuernberg-autohaus_feser-c135480",
"nuernberg-autohaus_feser-c135530",
"nuernberg-autohaus_feser-graf-f472190",
"nuernberg-autohaus_fester-b185310",
"nuernberg-autos-b183260",
"nuernberg-autos-b183370",
"nuernberg-autos-n144300",
"nuernberg-avenariusstrasse-c132670",
"nuernberg-avenariusstrasse-c133840",
"nuernberg-avenariusstrasse-c208250",
"nuernberg-avenariusstrasse-c208260",
"nuernberg-avenariusstrasse-n29430",
"nuernberg-avenariusstrasse-n362510",
"nuernberg-avenariusstrasse-n362520",
"nuernberg-b4_reutles-n510310",
"nuernberg-badstrasse-c226300",
"nuernberg-baerenschanze_icn-c136350",
"nuernberg-baerenschanze-c136310",
"nuernberg-baerenschanze-c136330",
"nuernberg-baerenschanze-c241440",
"nuernberg-baerenschanze-c241450",
"nuernberg-baerenschanze-c283470",
"nuernberg-baerenschanze-f383910",
"nuernberg-baerenschanze-f492550",
"nuernberg-baerenschanze-nn75080",
"nuernberg-baerenschanze-s562180",
"nuernberg-baerenschanzstrasse-cc51130",
"nuernberg-bahndepot-c3180",
"nuernberg-bahnfest-cc17340",
"nuernberg-bahnhofplatz-n263180",
"nuernberg-bahnhofplatz-n263210",
"nuernberg-bahnhofsplatz-c056450",
"nuernberg-bahnhofsplatz-c251170",
"nuernberg-bahnhofsplatz-c251180",
"nuernberg-bahnhofstrasse_grossbaustelle-c108610",
"nuernberg-bahnhofstrasse_grossbaustelle-c108640",
"nuernberg-bahnhofstrasse-b182520",
"nuernberg-bahnhofstrasse-b182560",
"nuernberg-bahnhofstrasse-b182590",
"nuernberg-bahnhofstrasse-bb8150",
"nuernberg-bahnhofstrasse-c11240",
"nuernberg-bahnhofstrasse-c11250",
"nuernberg-bahnhofstrasse-c11260",
"nuernberg-bahnhofstrasse-c122000",
"nuernberg-bahnhofstrasse-c133420",
"nuernberg-bahnhofstrasse-c133440",
"nuernberg-bahnhofstrasse-c133510",
"nuernberg-bahnhofstrasse-c133530",
"nuernberg-bahnhofstrasse-c133540",
"nuernberg-bahnhofstrasse-c134370",
"nuernberg-bahnhofstrasse-c155080",
"nuernberg-bahnhofstrasse-c155100",
"nuernberg-bahnhofstrasse-c155110",
"nuernberg-bahnhofstrasse-c155130",
"nuernberg-bahnhofstrasse-c19830",
"nuernberg-bahnhofstrasse-c226280",
"nuernberg-bahnhofstrasse-c243950",
"nuernberg-bahnhofstrasse-c244060",
"nuernberg-bahnhofstrasse-c25720",
"nuernberg-bahnhofstrasse-c25730",
"nuernberg-bahnhofstrasse-c25740",
"nuernberg-bahnhofstrasse-c283090",
"nuernberg-bahnhofstrasse-c311120",
"nuernberg-bahnhofstrasse-c311130",
"nuernberg-bahnhofstrasse-c311150",
"nuernberg-bahnhofstrasse-c505510",
"nuernberg-bahnhofstrasse-c505520",
"nuernberg-bahnhofstrasse-c505570",
"nuernberg-bahnhofstrasse-c564060",
"nuernberg-bahnhofstrasse-f384250",
"nuernberg-bahnhofstrasse-f39960",
"nuernberg-bahnhofstrasse-f405220",
"nuernberg-bahnhofstrasse-f406050",
"nuernberg-bahnhofstrasse-f413290",
"nuernberg-bahnhofstrasse-f413340",
"nuernberg-bahnhofstrasse-f435090",
"nuernberg-bahnhofstrasse-f435100",
"nuernberg-bahnhofstrasse-f435110",
"nuernberg-bahnhofstrasse-f435120",
"nuernberg-bahnhofstrasse-f435160",
"nuernberg-bahnhofstrasse-f444970",
"nuernberg-bahnhofstrasse-f471650",
"nuernberg-bahnhofstrasse-f471850",
"nuernberg-bahnhofstrasse-f471870",
"nuernberg-bahnhofstrasse-f471880",
"nuernberg-bahnhofstrasse-f540330",
"nuernberg-bahnhofstrasse-f540390",
"nuernberg-bahnhofstrasse-f540400",
"nuernberg-bahnhofstrasse-f540420",
"nuernberg-bahnhofstrasse-f540520",
"nuernberg-bahnhofstrasse-f540530",
"nuernberg-bahnhofstrasse-n077010",
"nuernberg-bahnhofstrasse-n147180",
"nuernberg-bahnhofstrasse-n147190",
"nuernberg-bahnhofstrasse-n147200",
"nuernberg-bahnhofstrasse-n147890",
"nuernberg-bahnhofstrasse-n147900",
"nuernberg-bahnhofstrasse-n147910",
"nuernberg-bahnhofstrasse-n147920",
"nuernberg-bahnhofstrasse-n148150",
"nuernberg-bahnhofstrasse-n148200",
"nuernberg-bahnhofstrasse-n262740",
"nuernberg-bahnhofstrasse-n263010",
"nuernberg-bahnhofstrasse-n263020",
"nuernberg-bahnhofstrasse-n263030",
"nuernberg-bahnhofstrasse-n263130",
"nuernberg-bahnhofstrasse-n263140",
"nuernberg-bahnhofstrasse-n263190",
"nuernberg-bahnhofstrasse-n294660",
"nuernberg-bahnhofstrasse-n364420",
"nuernberg-bahnhoftrasse_hotels-c122010",
"nuernberg-bahnhoftrasse_hotels-c122030",
"nuernberg-bahnkreisel-n14630",
"nuernberg-bahnkreisel-n14660",
"nuernberg-bahnmuseum-f392240",
"nuernberg-bahnwasserturm-f491310",
"nuernberg-bahnwerkstatt_austrasse-cb8840",
"nuernberg-bahnwerkstatt_austrasse-cb8870",
"nuernberg-bahnwerkstatt_austrasse-f384410",
"nuernberg-bahnwerkstatt_austrasse-f384420",
"nuernberg-bahnwerkstatt_austrasse-f391280",
"nuernberg-bahnwerkstatt_austrasse-f391290",
"nuernberg-bahnwerkstatt_austrasse-f392270",
"nuernberg-bahnwerkstatt_austrasse-f392280",
"nuernberg-bahnwerkstatt_austrasse-f392290",
"nuernberg-bahnwerkstatt_austrasse-f392300",
"nuernberg-bahnwerkstatt_austrasse-f392310",
"nuernberg-bahnwerkstatt_austrasse-f394790",
"nuernberg-bahnwerkstatt_austrasse-n053870",
"nuernberg-bahnwerkstatt_austrasse-nn75190",
"nuernberg-bahnwerkstatt_bei_nacht-c041200",
"nuernberg-bahnwerkstatt_nuernberg_west-f434760",
"nuernberg-bahnwerkstatt-c054820",
"nuernberg-bahnwerkstatt-c056370",
"nuernberg-bahnwerkstatt-c056650",
"nuernberg-bahnwerkstatt-c194980",
"nuernberg-bahnwerkstatt-c195000",
"nuernberg-bahnwerkstatt-c212770",
"nuernberg-bahnwerkstatt-c212790",
"nuernberg-bahnwerkstatt-f406190",
"nuernberg-bahnwerkstatt-f413410",
"nuernberg-bahnwerkstatt-f413420",
"nuernberg-bahnwerkstatt-f532130",
"nuernberg-bahnwerkstatt-f540930",
"nuernberg-bahnwerkstatt-n054040",
"nuernberg-bahnwerkstatt-n245620",
"nuernberg-bahnwerkstatt-n245650",
"nuernberg-bahnwerkstatt-n531190",
"nuernberg-bam_mischwerk-n36490",
"nuernberg-bamberger_strasse-b185130",
"nuernberg-bankgasse-n263380",
"nuernberg-barmer_ersatzkasse-c109980",
"nuernberg-barmer_krankenkasse-f47980",
"nuernberg-bartholomaeusfriedhof-n294140",
"nuernberg-bartholomaeusstrasse-c232820",
"nuernberg-bartholomaeusstrasse-cb8610",
"nuernberg-bartholomaeusstrasse-cc17850",
"nuernberg-bartholomaeusstrasse-f472090",
"nuernberg-bau_der_neuen_feuerwache-c251690",
"nuernberg-bau_der_neuen_feuerwache-c251700",
"nuernberg-bau_der_neuen_feuerwache-c251710",
"nuernberg-bau_der_neuen_feuerwache-c251720",
"nuernberg-bau_der_neuen_feuerwache-c251800",
"nuernberg-bau_des_sebald_kontores-c039030",
"nuernberg-bauabschnitt_2_2_u-bahnlinie_3-f471140",
"nuernberg-bauabschnitt_2_2_u-bahnlinie_3-f471150",
"nuernberg-bauabschnitt_2_2_u-bahnlinie_3-f471170",
"nuernberg-bauabschnitt_2_2_u-bahnlinie_3-f471180",
"nuernberg-bauernfeind-b183500",
"nuernberg-bauernfeind-b183520",
"nuernberg-bauernfeind-b184260",
"nuernberg-bauernfeind-c051630",
"nuernberg-bauernfeind-c08110",
"nuernberg-bauernfeind-c08130",
"nuernberg-bauernhof-f472580",
"nuernberg-bauhaus_liebe_ostendstrasse-c132790",
"nuernberg-bauhaus_liebe_ostendstrasse-c132830",
"nuernberg-bauhaus_liebe_ostendstrasse-c132880",
"nuernberg-bauhaus_liebe_ostendstrasse-c132930",
"nuernberg-bauhaus-f445320",
"nuernberg-bauhof___bauamt-f540440",
"nuernberg-bauhof_70_in_gebersdorf-f471100",
"nuernberg-bauhof-c192250",
"nuernberg-bauhof-c192260",
"nuernberg-bauhof-n148480",
"nuernberg-bauhof-n148610",
"nuernberg-bauhof-n148650",
"nuernberg-bauhof-n148660",
"nuernberg-bauhof-n148670",
"nuernberg-bauindustrie_zentrum-c564310",
"nuernberg-bauindustrie_zentrum-f540150",
"nuernberg-baustelle_aeg_gelaende-f471320",
"nuernberg-baustelle_aeussere-bayreuther-strasse-nn67130",
"nuernberg-baustelle_allersberger_strasse-c133460",
"nuernberg-baustelle_allersberger_strasse-c133500",
"nuernberg-baustelle_am_wegfeld-c132160",
"nuernberg-baustelle_am_woehrder_see-f381810",
"nuernberg-baustelle_am_woehrder_see-f383370",
"nuernberg-baustelle_am_woehrder_see-f383400",
"nuernberg-baustelle_autobahn_a6-c171320",
"nuernberg-baustelle_autobahn_a6-c171340",
"nuernberg-baustelle_autobahn_a9_bei_fischbach-f484360",
"nuernberg-baustelle_baerenschanzstrasse_im_winter-cc43820",
"nuernberg-baustelle_bei_mannerststrasse-n245630",
"nuernberg-baustelle_bei_mannerststrasse-n245660",
"nuernberg-baustelle_bei_marktkauf-c23430",
"nuernberg-baustelle_bei_marktkauf-c23450",
"nuernberg-baustelle_bei_marktkauf-c23470",
"nuernberg-baustelle_bei_marktkauf-c23530",
"nuernberg-baustelle_bei_rothenburger-n24420",
"nuernberg-baustelle_beuthener_strasse-n293560",
"nuernberg-baustelle_bielingplatz-c241080",
"nuernberg-baustelle_bielingplatz-c24910",
"nuernberg-baustelle_chrysler-c132260",
"nuernberg-baustelle_datev-c037110",
"nuernberg-baustelle_datev-c037490",
"nuernberg-baustelle_datev-n053880",
"nuernberg-baustelle_erlanger_strasse-c244610",
"nuernberg-baustelle_erlanger_strasse-c244640",
"nuernberg-baustelle_feuerwache-n263980",
"nuernberg-baustelle_flora54-f471390",
"nuernberg-baustelle_frankencampus-c24350",
"nuernberg-baustelle_frankencampus-c24490",
"nuernberg-baustelle_frankencampus-c24530",
"nuernberg-baustelle_fuchsgaerten-n530080",
"nuernberg-baustelle_fuchsgaerten-n530100",
"nuernberg-baustelle_hirsvogelstrasse-c108030",
"nuernberg-baustelle_karlstrasse-f484800",
"nuernberg-baustelle_katzwanger_strasse-c252330",
"nuernberg-baustelle_katzwanger_strasse-c252450",
"nuernberg-baustelle_langwasser-c161810",
"nuernberg-baustelle_lessingstrasse-c108220",
"nuernberg-baustelle_lessingstrasse-c108720",
"nuernberg-baustelle_messe-n241020",
"nuernberg-baustelle_naehe_fuerther_strasse-nn65250",
"nuernberg-baustelle_neben_gericht-c215130",
"nuernberg-baustelle_neben_langwasserbad-c281900",
"nuernberg-baustelle_nordring-c123190",
"nuernberg-baustelle_nordring-c152140",
"nuernberg-baustelle_nordwestring-nn8380",
"nuernberg-baustelle_park_lane-c505610",
"nuernberg-baustelle_park_lane-c505630",
"nuernberg-baustelle_park_lane-c505640",
"nuernberg-baustelle_pillenreuther-n247240",
"nuernberg-baustelle_pillenreuther-n247310",
"nuernberg-baustelle_plaerrer-n246980",
"nuernberg-baustelle_porsche-n06710",
"nuernberg-baustelle_regensburger_strasse-b182850",
"nuernberg-baustelle_reindelstrasse-c212270",
"nuernberg-baustelle_sheraton-c244130",
"nuernberg-baustelle_sparkasse-cc32760",
"nuernberg-baustelle_sparkasse-cc32780",
"nuernberg-baustelle_tafelfeldstrasse-c122100",
"nuernberg-baustelle_teambank-c08930",
"nuernberg-baustelle_teambank-n052530",
"nuernberg-baustelle_tiergarten-cc18920",
"nuernberg-baustelle_u-bahn-c251910",
"nuernberg-baustelle_ulmenstrasse-c241500",
"nuernberg-baustelle_umweltbank-n515560",
"nuernberg-baustelle_umweltbank-n515570",
"nuernberg-baustelle_umweltbank-n515610",
"nuernberg-baustelle_umweltbank-n515620",
"nuernberg-baustelle_umweltbank-n515630",
"nuernberg-baustelle_umweltbank-n515640",
"nuernberg-baustelle_wassertorstrasse-c121440",
"nuernberg-baustelle_wassertorstrasse-c121460",
"nuernberg-baustelle_wassertorstrasse-c121470",
"nuernberg-baustelle_wassertorstrasse-c121560",
"nuernberg-baustelle-b18600",
"nuernberg-baustelle-b18620",
"nuernberg-baustelle-c125290",
"nuernberg-baustelle-c186930",
"nuernberg-baustelle-c186960",
"nuernberg-baustelle-c207080",
"nuernberg-baustoffe-c21820",
"nuernberg-baustoffe-c21830",
"nuernberg-bayerische_asphaltmischwerke-c231730",
"nuernberg-bayerische_rundfunk_studio_franken-f412020",
"nuernberg-bayerische_rundfunk-f491960",
"nuernberg-bayerischer_bauindustrieverband-f435330",
"nuernberg-bayerischer_rundfunk_studio_franken-c135980",
"nuernberg-bayerischer_rundfunk-f530670",
"nuernberg-bayernstrasse-f406760",
"nuernberg-bayernstrasse-f514070",
"nuernberg-baywa-c193460",
"nuernberg-beachvolleyball-cc32960",
"nuernberg-bei_altdorf-c161070",
"nuernberg-bei_buchenbuehl-n520330",
"nuernberg-bei_buchenbuehl-n520340",
"nuernberg-bei_mannertstrasse-n248020",
"nuernberg-bei_mannertstrasse-n248050",
"nuernberg-beim_fuchsloch-c123540",
"nuernberg-beim_fuchsloch-c123570",
"nuernberg-beim_hafen-n244260",
"nuernberg-ben-gurion-ring-c563810",
"nuernberg-ben-gurion-ring-f47980",
"nuernberg-ben-gurion-ring-n30410",
"nuernberg-berckhauserstrasse-c173380",
"nuernberg-berckhauserstrasse-cc32120",
"nuernberg-berckhauserstrasse-n14390",
"nuernberg-bereitschaftspolizei-c226030",
"nuernberg-bernadottestrasse-f471740",
"nuernberg-bernadottestrasse-f471760",
"nuernberg-bernadottestrasse-f471760",
"nuernberg-bernadottestrasse-n363900",
"nuernberg-bertastrasse-c563820",
"nuernberg-bertolt-brecht-schule-b184360",
"nuernberg-bertolt-brecht-schule-b184400",
"nuernberg-bertolt-brecht-schule-b184420",
"nuernberg-bertolt-brecht-schule-c111020",
"nuernberg-bertolt-brecht-schule-c111080",
"nuernberg-bertolt-brecht-schule-c207720",
"nuernberg-bertolt-brecht-schule-c232100",
"nuernberg-bertolt-brecht-schule-c281990",
"nuernberg-bertolt-brecht-schule-f425080",
"nuernberg-bertolt-brecht-schule-f47940",
"nuernberg-bertolt-brecht-schule-f47950",
"nuernberg-bertolt-brecht-schule-n052100",
"nuernberg-bertolt-brecht-schule-n293600",
"nuernberg-bertolt-brecht-schule-n293680",
"nuernberg-bertolt-brecht-schule-nn76100",
"nuernberg-berufsbildungszentrum_nuernberg-c563880",
"nuernberg-berufsfoerderungswerk-c174210",
"nuernberg-berufsfoerderungswerk-c564320",
"nuernberg-berufsfoerderungswerk-c564330",
"nuernberg-berufsfoerderungswerk-cc43290",
"nuernberg-berufsfoerderungswerk-f383010",
"nuernberg-berufsfoerderungswerk-f391170",
"nuernberg-berufsfoerderungswerk-n011510",
"nuernberg-berufsfoerderungswerk-n011550",
"nuernberg-berufsfoerderungswerk-n074760",
"nuernberg-berufsfoerderungswerk-n077400",
"nuernberg-berufsschule-n14360",
"nuernberg-berufsschule-n144940",
"nuernberg-bessemerstrasse-f382870",
"nuernberg-bessemerstrasse-f393610",
"nuernberg-bessemerstrasse-f406920",
"nuernberg-bessemerstrasse-n145050",
"nuernberg-beuthener_strasse-c08810",
"nuernberg-beuthener_strasse-c231780",
"nuernberg-beuthener_strasse-c281460",
"nuernberg-beuthener_strasse-c281880",
"nuernberg-beuthener_strasse-f412220",
"nuernberg-beuthener_strasse-f455110",
"nuernberg-beuthener_strasse-f464600",
"nuernberg-beuthener_strasse-f47840",
"nuernberg-beuthener_strasse-f554750",
"nuernberg-beuthener_strasse-n293550",
"nuernberg-beuthener_strasse-n32190",
"nuernberg-beuthener_strasse-n36480",
"nuernberg-beuthener_strasse-n36500",
"nuernberg-bewegungspark_am_woehrder_see-c563850",
"nuernberg-bewegungspark_am_woehrder_see-n261940",
"nuernberg-bewegungspark_am_woehrder_see-n262160",
"nuernberg-bewegungspark_am_woehrder_see-n30370",
"nuernberg-bielefelder_strasse-f404640",
"nuernberg-bielingplatz-c241070",
"nuernberg-bielingplatz-c312510",
"nuernberg-bielingplatz-c312550",
"nuernberg-bielingplatz-c312590",
"nuernberg-bielingplatz-f391260",
"nuernberg-bielingplatz-f39860",
"nuernberg-bielingplatz-f412740",
"nuernberg-bielingplatz-f426230",
"nuernberg-bielingplatz-f492280",
"nuernberg-bielingplatz-f492300",
"nuernberg-bielingplatz-f531000",
"nuernberg-bielingplatz-n261390",
"nuernberg-bielingplatz-n261450",
"nuernberg-bielingplatz-n261470",
"nuernberg-bielingplatz-n261480",
"nuernberg-bierfest_im_burggraben-c119920",
"nuernberg-biergarten_am_woerhder_see-n262690",
"nuernberg-biergarten_am_woerhder_see-n262700",
"nuernberg-biergarten_an_der_woehrder_wiese-c038610",
"nuernberg-biergarten-n144690",
"nuernberg-bierweg-b185340",
"nuernberg-bierweg-b185350",
"nuernberg-bierweg-b185360",
"nuernberg-bierweg-b185370",
"nuernberg-bierweg-b185380",
"nuernberg-bierweg-b185390",
"nuernberg-bildungszentrum_statuen-c212700",
"nuernberg-bildungszentrum-c156170",
"nuernberg-bildungszentrum-c156180",
"nuernberg-bildungszentrum-c194120",
"nuernberg-bildungszentrum-f554960",
"nuernberg-bildzungszentrum-c192190",
"nuernberg-bildzungszentrum-c192200",
"nuernberg-bingstrasse-c037670",
"nuernberg-bingstrasse-c037760",
"nuernberg-bingstrasse-c195490",
"nuernberg-bingstrasse-c207420",
"nuernberg-bingstrasse-c207430",
"nuernberg-bingstrasse-c207440",
"nuernberg-bingstrasse-f413210",
"nuernberg-bingstrasse-n510500",
"nuernberg-biotop_am_marienbergweiher-f434000",
"nuernberg-birnthon-c171240",
"nuernberg-bismarckschule-c155900",
"nuernberg-bismarckschule-f393690",
"nuernberg-bismarckschule-n515490",
"nuernberg-bismarckschule-n525210",
"nuernberg-bismarkschule-c119440",
"nuernberg-bismarkschule-c119460",
"nuernberg-bismarkschule-c119480",
"nuernberg-bismarkschule-n294120",
"nuernberg-blaue_nacht__blick_ueber_die_altstadt-ce13240",
"nuernberg-blaue_nacht_-_hauptmarkt-ce12140",
"nuernberg-blaue_nacht_-_hauptmarkt-ce14130",
"nuernberg-blaue_nacht_-_lessingstrasse-ce13130",
"nuernberg-blaue_nacht_-_lessingstrasse-ce15750",
"nuernberg-blaue_nacht_-_neues_museum-ce12000",
"nuernberg-blaue_nacht_-_opernhaus-ce14020",
"nuernberg-blaue_nacht_-_sebalduskirche-ce14170",
"nuernberg-blaue_nacht_-_sebalduskirche-ce14260",
"nuernberg-blaue_nacht_-_strasse_der_menschenrechte-ce14230",
"nuernberg-blaue_nacht-ce12240",
"nuernberg-blaue_nacht-ce13150",
"nuernberg-blaue_nacht-ce13590",
"nuernberg-blick_in_richtung_fuerth-n075470",
"nuernberg-blick_in_richtung_fuerth-n075480",
"nuernberg-blick_richtung_osten-f403630",
"nuernberg-blick_richtung_ost-f455230",
"nuernberg-blick_richtung_schwabach-f412630",
"nuernberg-blick_richtung_sued-osten-f404770",
"nuernberg-blick_richtung_sued-osten-f406320",
"nuernberg-blick_richtung_westen-f412360",
"nuernberg-blick_richtung_westen-f413060",
"nuernberg-blick_richtung_westen-f424250",
"nuernberg-blick_ueber_altstadt-cc17230",
"nuernberg-blick_ueber_altstadt-cc17260",
"nuernberg-blick_ueber_altstadt-cc17270",
"nuernberg-blick_ueber_die_altstadt-c056630",
"nuernberg-blick_ueber_die_altstadt-c056780",
"nuernberg-blick_ueber_nuernberg__ost_-nn66260",
"nuernberg-blick_ueber_nuernberg__richtung_ost_-n069940",
"nuernberg-blick_ueber_nuernberg_bei_nacht-c041150",
"nuernberg-blick_ueber_nuernberg_sued-c056870",
"nuernberg-blick_ueber_nuernberg-cc25250",
"nuernberg-blick_ueber_nuernberg-f412240",
"nuernberg-blick_ueber_nuernberg-f413010",
"nuernberg-blindenheim-f445480",
"nuernberg-bluecherstrasse-cd17980",
"nuernberg-bluetenstrasse-f484460",
"nuernberg-bmw_niederlassung__baustelle_-f383120",
"nuernberg-bmw_niederlassung__baustelle_-f383210",
"nuernberg-bmw_niederlassung__baustelle_-f383230",
"nuernberg-bmw_niederlassung__baustelle_-f383240",
"nuernberg-bmw_niederlassung__baustelle_-n363520",
"nuernberg-bmw_niederlassung__baustelle_-n363530",
"nuernberg-bmw_niederlassung__baustelle_-n363580",
"nuernberg-bmw_niederlassung-f39720",
"nuernberg-bmw_niederlassung-f39730",
"nuernberg-bmw_niederlassung-f405570",
"nuernberg-bmw_niederlassung-f405590",
"nuernberg-bmw_niederlassung-f405710",
"nuernberg-bmw_niederlassung-f405710",
"nuernberg-bmw_niederlassung-f412060",
"nuernberg-bmw_niederlassung-f445180",
"nuernberg-bmw_niederlassung-f445220",
"nuernberg-bmw_niederlassung-f445260",
"nuernberg-bmw_witschelstrasse-cb89580",
"nuernberg-bogenstrasse-n148450",
"nuernberg-bootsverleih_am_woehrder_see-n274740",
"nuernberg-bootsverleih-c243900",
"nuernberg-bosch-rexroth-f445210",
"nuernberg-boulevardsteg_am_woehrder_see-c04790",
"nuernberg-boulevardsteg_am_woehrder_see-n012920",
"nuernberg-boulevardsteg_am_woehrder_see-n012970",
"nuernberg-boulevardsteg_am_woehrder_see-nn82830",
"nuernberg-boulevardsteg-c038120",
"nuernberg-boulevardsteg-f383750",
"nuernberg-boulevardsteg-f471600",
"nuernberg-boulevardsteg-f471600",
"nuernberg-boulevardsteg-f530910",
"nuernberg-bowling_brunswick-n362410",
"nuernberg-bowling_brunswick-n362420",
"nuernberg-bowling_brunswick-n362430",
"nuernberg-bowling_brunswick-n362450",
"nuernberg-bowling_brunswick-n362470",
"nuernberg-bowling_brunswick-n362480",
"nuernberg-bowling_brunswick-n362490",
"nuernberg-boxdorf__staedlter-f485170",
"nuernberg-boxdorf-c151780",
"nuernberg-boxdorf-c151790",
"nuernberg-boxdorf-c151800",
"nuernberg-boxdorf-c151810",
"nuernberg-boxdorf-c151820",
"nuernberg-boxdorf-c21340",
"nuernberg-boxdorf-c21350",
"nuernberg-boxdorf-c21360",
"nuernberg-boxdorf-c22240",
"nuernberg-boxdorf-c227260",
"nuernberg-boxdorf-c227300",
"nuernberg-boxdorf-c254810",
"nuernberg-boxdorf-c505970",
"nuernberg-boxdorf-c506000",
"nuernberg-boxdorf-cb81210",
"nuernberg-boxdorf-cc16860",
"nuernberg-boxdorf-cc34070",
"nuernberg-boxdorf-f456010",
"nuernberg-boxdorf-f472540",
"nuernberg-boxdorf-f472550",
"nuernberg-boxdorf-f485150",
"nuernberg-boxdorf-f485160",
"nuernberg-boxdorf-f485180",
"nuernberg-boxdorf-f485190",
"nuernberg-boxdorf-f494410",
"nuernberg-boxdorf-n26600",
"nuernberg-boxdorf-n26610",
"nuernberg-boxdorf-n26620",
"nuernberg-boxdorf-n26630",
"nuernberg-boxdorf-n26650",
"nuernberg-boxdorf-n26660",
"nuernberg-boxdorf-n26670",
"nuernberg-boxdorf-n26680",
"nuernberg-boxdorf-n26690",
"nuernberg-boxdorf-n26700",
"nuernberg-boxdorf-n26710",
"nuernberg-boxdorf-n36170",
"nuernberg-boxdorf-n510330",
"nuernberg-boxdorf-n515830",
"nuernberg-boxdorf-n515840",
"nuernberg-boxdorf-n515860",
"nuernberg-boxdorf-n525570",
"nuernberg-boxdorf-n525580",
"nuernberg-boxdorf-n525600",
"nuernberg-boxdorf-n525610",
"nuernberg-boxdorf-n550090",
"nuernberg-brachflaeche_gutav_adolf_strasse-n075290",
"nuernberg-brachflaeche_in_buch-c12490",
"nuernberg-brachflaeche_in_buch-c12500",
"nuernberg-brachflaeche_marienbergstrasse-cb99320",
"nuernberg-brachflaeche_virnsberger_strasse-f384440",
"nuernberg-brailllestrasse-f472150",
"nuernberg-brand-f405740",
"nuernberg-breite_gasse-f471900",
"nuernberg-breite_gasse-n149330",
"nuernberg-breite_gasse-n149350",
"nuernberg-breite_gasse-n364120",
"nuernberg-breslauer_strasse-n515270",
"nuernberg-brettergartenstrasse-cb99770",
"nuernberg-brettergartenstrasse-cb99810",
"nuernberg-brettergartenstrasse-cb99820",
"nuernberg-brettergartenstrasse-f532330",
"nuernberg-breuninger-c196120",
"nuernberg-brezen_kolb-bb81990",
"nuernberg-brezen_kolb-bb82020",
"nuernberg-briefzentrum_beuthener_strasse-c31570",
"nuernberg-briefzentrum_beuthener_strasse-c31620",
"nuernberg-brieger_strasse-c153690",
"nuernberg-brieger_strasse-c231710",
"nuernberg-briegerstrasse-c281940",
"nuernberg-brochier-cc18840",
"nuernberg-bruck-c227380",
"nuernberg-bruck-c227390",
"nuernberg-bruck-c227400",
"nuernberg-bruck-c227470",
"nuernberg-bruckecker_strasse-f454970",
"nuernberg-bruecke_bei_buchenbuehl-f463200",
"nuernberg-bruecke_bei_buchenbuehl-f463250",
"nuernberg-bruecke_bei_schwaig-f463120",
"nuernberg-bruecke_maxi-n14670",
"nuernberg-bruecke_rampen-c188120",
"nuernberg-bruecke_rampen-n24820",
"nuernberg-brueckebau_autobahn_a3_bei_buchenbuehl-f454490",
"nuernberg-brueckebau_bei_buchenbuehl-f443670",
"nuernberg-brueckebau_bei_buchenbuehl-f443720",
"nuernberg-brueckebau_bei_buchenbuehl-f443770",
"nuernberg-bruecke-c19550",
"nuernberg-bruecke-c19570",
"nuernberg-bruecken_an_der_suedwesttangente-c124060",
"nuernberg-bruecken_hafenstrasse-f424280",
"nuernberg-brueckenbau_bei_buchenbuehl-f423920",
"nuernberg-brueckenbau_bei_buchenbuehl-f433860",
"nuernberg-brueckenbau_bei_schwaig-f443590",
"nuernberg-brueckenbau_bei_schwaig-f443630",
"nuernberg-brueckenbau-c213440",
"nuernberg-brueckenbau-c213460",
"nuernberg-brueckenbau-c213480",
"nuernberg-bruecken-c135860",
"nuernberg-brueckenstrasse-c241360",
"nuernberg-brunecker_strasse-b183110",
"nuernberg-brunecker_strasse-b183120",
"nuernberg-brunecker_strasse-b183130",
"nuernberg-brunecker_strasse-b183140",
"nuernberg-brunecker_strasse-b183150",
"nuernberg-brunecker_strasse-b183230",
"nuernberg-brunecker_strasse-b183250",
"nuernberg-brunecker_strasse-b183280",
"nuernberg-brunecker_strasse-b183310",
"nuernberg-brunecker_strasse-b183330",
"nuernberg-brunecker_strasse-b183400",
"nuernberg-brunecker_strasse-b183450",
"nuernberg-brunecker_strasse-b183460",
"nuernberg-brunecker_strasse-c226190",
"nuernberg-brunecker_strasse-c226210",
"nuernberg-brunecker_strasse-c226230",
"nuernberg-brunecker_strasse-c226240",
"nuernberg-brunecker_strasse-c252170",
"nuernberg-brunecker_strasse-c252180",
"nuernberg-brunecker_strasse-c252200",
"nuernberg-brunecker_strasse-c252220",
"nuernberg-brunecker_strasse-c252230",
"nuernberg-brunecker_strasse-c252320",
"nuernberg-brunecker_strasse-f38800",
"nuernberg-brunecker_strasse-f38820",
"nuernberg-brunecker_strasse-f38840",
"nuernberg-brunecker_strasse-f38860",
"nuernberg-brunecker_strasse-f403660",
"nuernberg-brunecker_strasse-f405870",
"nuernberg-brunecker_strasse-f406500",
"nuernberg-brunecker_strasse-f406720",
"nuernberg-brunecker_strasse-f412150",
"nuernberg-brunecker_strasse-f412160",
"nuernberg-brunecker_strasse-f443980",
"nuernberg-brunecker_strasse-f443990",
"nuernberg-brunecker_strasse-f444000",
"nuernberg-brunecker_strasse-f444010",
"nuernberg-brunecker_strasse-f444020",
"nuernberg-brunecker_strasse-f464550",
"nuernberg-brunecker_strasse-f491520",
"nuernberg-brunecker_strasse-f491560",
"nuernberg-brunecker_strasse-f491570",
"nuernberg-brunecker_strasse-f491580",
"nuernberg-brunecker_strasse-f491610",
"nuernberg-brunecker_strasse-f491630",
"nuernberg-brunecker_strasse-f491640",
"nuernberg-brunecker_strasse-f491650",
"nuernberg-brunecker_strasse-f491690",
"nuernberg-brunecker_strasse-f491730",
"nuernberg-brunecker_strasse-f513950",
"nuernberg-brunecker_strasse-f513960",
"nuernberg-brunecker_strasse-f513970",
"nuernberg-brunecker_strasse-f513980",
"nuernberg-brunecker_strasse-f513990",
"nuernberg-brunecker_strasse-f514010",
"nuernberg-brunecker_strasse-f514020",
"nuernberg-brunecker_strasse-f514050",
"nuernberg-brunecker_strasse-n244200",
"nuernberg-brunecker_strasse-n294240",
"nuernberg-brunecker_strasse-n294260",
"nuernberg-brunecker_strasse-n294270",
"nuernberg-brunecker_strasse-n294290",
"nuernberg-brunecker_strasse-n294340",
"nuernberg-brunecker_strasse-n361290",
"nuernberg-brunecker_strasse-n361310",
"nuernberg-brunecker_strasse-n361320",
"nuernberg-brunecker_strasse-n361350",
"nuernberg-brunecker_strasse-n36950",
"nuernberg-brunecker_strasse-n36990",
"nuernberg-brunn__netzstall-n524860",
"nuernberg-brunn__netzstall-n524870",
"nuernberg-brunn__netzstall-n524880",
"nuernberg-brunn__netzstall-n524890",
"nuernberg-brunn__netzstall-n524900",
"nuernberg-brunn__netzstall-n524910",
"nuernberg-brunn__netzstall-n524920",
"nuernberg-brunn__netzstall-n524940",
"nuernberg-brunn__netzstall-n524950",
"nuernberg-brunn__netzstall-n524960",
"nuernberg-brunn-c16800",
"nuernberg-brunn-n145210",
"nuernberg-brunn-n145230",
"nuernberg-brunn-n145270",
"nuernberg-brunn-n145280",
"nuernberg-brunn-n145290",
"nuernberg-brunn-n145300",
"nuernberg-brunn-n145370",
"nuernberg-brunn-n145380",
"nuernberg-brunn-n145400",
"nuernberg-brunn-n145410",
"nuernberg-brunn-n145420",
"nuernberg-brunswick-n362440",
"nuernberg-brunswick-n362500",
"nuernberg-buch-c173840",
"nuernberg-buch-c173880",
"nuernberg-buch-c173920",
"nuernberg-buch-c173940",
"nuernberg-buch-c173970",
"nuernberg-buch-c199750",
"nuernberg-buch-c199760",
"nuernberg-buch-c208380",
"nuernberg-buch-c208390",
"nuernberg-buch-c208400",
"nuernberg-buch-c208410",
"nuernberg-buch-c208420",
"nuernberg-buch-c208430",
"nuernberg-buch-c208440",
"nuernberg-buch-c208450",
"nuernberg-buch-c208460",
"nuernberg-buch-c208470",
"nuernberg-buch-c208480",
"nuernberg-buch-c21380",
"nuernberg-buch-c21390",
"nuernberg-buch-c21460",
"nuernberg-buch-c21470",
"nuernberg-buch-c21480",
"nuernberg-buch-c21500",
"nuernberg-buch-c21520",
"nuernberg-buch-c21570",
"nuernberg-buch-c21590",
"nuernberg-buch-c227200",
"nuernberg-buch-c245030",
"nuernberg-buch-c245070",
"nuernberg-buch-c245080",
"nuernberg-buch-c505880",
"nuernberg-buch-c505890",
"nuernberg-buch-c505900",
"nuernberg-buch-c505910",
"nuernberg-buch-c505920",
"nuernberg-buch-c505930",
"nuernberg-buch-cc24520",
"nuernberg-buch-cc26560",
"nuernberg-buch-cc33990",
"nuernberg-buch-cc44270",
"nuernberg-buchenbuehl_schule-c121110",
"nuernberg-buchenbuehl-c121180",
"nuernberg-buchenbuehl-cc42720",
"nuernberg-buchenbuehl-f424010",
"nuernberg-buchenbuehl-f433960",
"nuernberg-buchenbuehl-f433970",
"nuernberg-buchenbuehl-n05310",
"nuernberg-buchenbuehl-n05360",
"nuernberg-buchenbuehl-n245430",
"nuernberg-bucher_bruecke-c118810",
"nuernberg-bucher_strasse_ecke_nordring-n077350",
"nuernberg-bucher_strasse-b18810",
"nuernberg-bucher_strasse-b18820",
"nuernberg-bucher_strasse-b18830",
"nuernberg-bucher_strasse-b18840",
"nuernberg-bucher_strasse-b18850",
"nuernberg-bucher_strasse-b18860",
"nuernberg-bucher_strasse-b18870",
"nuernberg-bucher_strasse-b18910",
"nuernberg-bucher_strasse-b18920",
"nuernberg-bucher_strasse-b18930",
"nuernberg-bucher_strasse-c207830",
"nuernberg-bucher_strasse-f3920",
"nuernberg-bucher_strasse-f393260",
"nuernberg-bucher_strasse-f394530",
"nuernberg-bucher_strasse-f434980",
"nuernberg-bucher_strasse-n077340",
"nuernberg-buch-f393920",
"nuernberg-buch-f393930",
"nuernberg-buch-f393950",
"nuernberg-buch-f393960",
"nuernberg-buch-f407100",
"nuernberg-buch-f407110",
"nuernberg-buch-f407130",
"nuernberg-buch-f445540",
"nuernberg-buch-f485120",
"nuernberg-buch-f541110",
"nuernberg-buch-f553770",
"nuernberg-buch-f553780",
"nuernberg-buch-f555350",
"nuernberg-buch-f555360",
"nuernberg-buch-f555370",
"nuernberg-buch-f555380",
"nuernberg-buch-n510370",
"nuernberg-buch-n515800",
"nuernberg-buch-n525520",
"nuernberg-buch-n525530",
"nuernberg-buch-n525540",
"nuernberg-buck_am_albrecht-duerer-airport-n520360",
"nuernberg-budesagentur_fuer_arbeit-f412310",
"nuernberg-budesamt_fuer_migration_und_fluechtlinge-f406480",
"nuernberg-buechenbach-c227520",
"nuernberg-buechenbach-c227540",
"nuernberg-buechenbach-c227560",
"nuernberg-buechenbach-f404520",
"nuernberg-bundesagentur_fuer_arbeit___meistersingerhalle-c037650",
"nuernberg-bundesagentur_fuer_arbeit-c037630",
"nuernberg-bundesagentur_fuer_arbeit-c04770",
"nuernberg-bundesagentur_fuer_arbeit-c047920",
"nuernberg-bundesagentur_fuer_arbeit-c051920",
"nuernberg-bundesagentur_fuer_arbeit-c057230",
"nuernberg-bundesagentur_fuer_arbeit-c111150",
"nuernberg-bundesagentur_fuer_arbeit-c191790",
"nuernberg-bundesagentur_fuer_arbeit-c19860",
"nuernberg-bundesagentur_fuer_arbeit-c19880",
"nuernberg-bundesagentur_fuer_arbeit-c19910",
"nuernberg-bundesagentur_fuer_arbeit-c19940",
"nuernberg-bundesagentur_fuer_arbeit-ca88440",
"nuernberg-bundesagentur_fuer_arbeit-f384180",
"nuernberg-bundesagentur_fuer_arbeit-f405930",
"nuernberg-bundesagentur_fuer_arbeit-f405980",
"nuernberg-bundesagentur_fuer_arbeit-f406770",
"nuernberg-bundesagentur_fuer_arbeit-f406780",
"nuernberg-bundesagentur_fuer_arbeit-n012220",
"nuernberg-bundesagentur_fuer_arbeit-n053030",
"nuernberg-bundesagentur_fuer_arbeit-n148020",
"nuernberg-bundesagentur_fuer_arbeit-n33320",
"nuernberg-bundesagentur_fuer_arbeit-nn66850",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-b183180",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-b183190",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-c035970",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-c11630",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-c124470",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-cc41400",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-cc41480",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-f391980",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-f412320",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-f412340",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-n076750",
"nuernberg-bundesamt_fuer_migration_und_fluechtlinge-n341600",
"nuernberg-bundeseisenbahvermoegen-c563670",
"nuernberg-burg-c191080",
"nuernberg-burggarten_der_kaiserburg_im_herbst-nn8740",
"nuernberg-burggarten_der_kaiserburg-c121840",
"nuernberg-burggarten-c108770",
"nuernberg-burggarten-c108790",
"nuernberg-burggarten-c156310",
"nuernberg-burggarten-c156320",
"nuernberg-burggarten-c191050",
"nuernberg-burggarten-c191420",
"nuernberg-burggarten-c191450",
"nuernberg-burggarten-cc42060",
"nuernberg-burggarten-f424200",
"nuernberg-burggarten-n149630",
"nuernberg-burggarten-n263810",
"nuernberg-burggarten-n525290",
"nuernberg-burggraben-c191000",
"nuernberg-burghof-f424200",
"nuernberg-burgstrasse-c119980",
"nuernberg-burgstrasse-c196170",
"nuernberg-business_tower-bb81740",
"nuernberg-business_tower-bb81750",
"nuernberg-business_tower-bb82040",
"nuernberg-business_tower-bb86470",
"nuernberg-business_tower-bb86550",
"nuernberg-business_tower-c047610",
"nuernberg-business_tower-c052530",
"nuernberg-business_tower-c132990",
"nuernberg-business_tower-c194300",
"nuernberg-business_tower-c194320",
"nuernberg-business_tower-c225760",
"nuernberg-business_tower-c28820",
"nuernberg-business_tower-cc17020",
"nuernberg-business_tower-cc18640",
"nuernberg-business_tower-cc19000",
"nuernberg-business_tower-cc19030",
"nuernberg-business_tower-cc19040",
"nuernberg-business_tower-cc41910",
"nuernberg-business_tower-cc43620",
"nuernberg-business_tower-f381640",
"nuernberg-business_tower-f383700",
"nuernberg-business_tower-f383730",
"nuernberg-business_tower-f39550",
"nuernberg-business_tower-f405000",
"nuernberg-business_tower-f405060",
"nuernberg-business_tower-f405850",
"nuernberg-business_tower-f405860",
"nuernberg-business_tower-f406850",
"nuernberg-business_tower-f413100",
"nuernberg-business_tower-f413190",
"nuernberg-business_tower-f444880",
"nuernberg-business_tower-f464710",
"nuernberg-business_tower-f472050",
"nuernberg-business_tower-n144890",
"nuernberg-business_tower-n144910",
"nuernberg-business_tower-n262180",
"nuernberg-business_tower-n262420",
"nuernberg-business_tower-n262430",
"nuernberg-business_tower-n262440",
"nuernberg-business_tower-n262450",
"nuernberg-business_tower-n262460",
"nuernberg-business_tower-n303620",
"nuernberg-business_tower-n303630",
"nuernberg-business_tower-n33620",
"nuernberg-business_tower-n33640",
"nuernberg-businesspark_am_woehrder_see_b_-f484700",
"nuernberg-businesspark_am_woehrder_see_b_-f484710",
"nuernberg-cam-c12770",
"nuernberg-cam-c12800",
"nuernberg-campestrasse-c119610",
"nuernberg-campestrasse-c191010",
"nuernberg-campestrasse-n525300",
"nuernberg-campus_marienberg-f381350",
"nuernberg-campus_marienberg-f382000",
"nuernberg-campus_marienberg-f382150",
"nuernberg-campus_marienberg-f382210",
"nuernberg-campus_marienberg-f38230",
"nuernberg-campus_marienberg-f38400",
"nuernberg-campus_marienberg-f38650",
"nuernberg-campus_marienberg-f38670",
"nuernberg-campus_marienberg-f407830",
"nuernberg-campus_marienberg-f472180",
"nuernberg-campus_marienberg-f472190",
"nuernberg-cargo-b18680",
"nuernberg-carlina_park-f493150",
"nuernberg-celtisunterfuehrung-c192350",
"nuernberg-christian-wildner-strasse-c152310",
"nuernberg-christkindlesmarkt-b181000",
"nuernberg-christkindlesmarkt-b181020",
"nuernberg-christkindlesmarkt-b181050",
"nuernberg-christkindlesmarkt-b181070",
"nuernberg-christkindlesmarkt-b181100",
"nuernberg-christkindlesmarkt-b181400",
"nuernberg-christkindlesmarkt-b18960",
"nuernberg-christkindlesmarkt-b18970",
"nuernberg-christkindlesmarkt-b18980",
"nuernberg-christkindlesmarkt-b18990",
"nuernberg-christkindlesmarkt-bb86300",
"nuernberg-christkindlesmarkt-bb86410",
"nuernberg-christkindlesmarkt-bb86770",
"nuernberg-christkindlesmarkt-bb86810",
"nuernberg-christkindlesmarkt-bb86820",
"nuernberg-christkindlesmarkt-bb87080",
"nuernberg-christkindlesmarkt-bb87870",
"nuernberg-christkindlesmarkt-bb88150",
"nuernberg-christkindlesmarkt-c233130",
"nuernberg-christkindlesmarkt-c233140",
"nuernberg-christuskirche-c109210",
"nuernberg-christuskirche-c124530",
"nuernberg-christuskirche-c124550",
"nuernberg-christuskirche-n055840",
"nuernberg-christuskirche-n076410",
"nuernberg-christuskirche-nn76740",
"nuernberg-chrysler-c151990",
"nuernberg-chrysler-c152030",
"nuernberg-chrysler-c152040",
"nuernberg-chrysler-c152070",
"nuernberg-city_point-c192530",
"nuernberg-city_point-c193860",
"nuernberg-city_point-c193870",
"nuernberg-city-bb87060",
"nuernberg-city-bb87110",
"nuernberg-city-c211800",
"nuernberg-club_am_marienberg_e__v_-f472200",
"nuernberg-clubbad-c242710",
"nuernberg-clubbad-c242730",
"nuernberg-conradtystrasse-f47220",
"nuernberg-containerbahnhof_am_hafen-f39160",
"nuernberg-container-c153350",
"nuernberg-containerhafen-c242100",
"nuernberg-container-n146200",
"nuernberg-container-n146220",
"nuernberg-container-n146230",
"nuernberg-cramer-klett-park-f381780",
"nuernberg-cuxhavener_strasse-c244560",
"nuernberg-cuxhavener_strasse-c244570",
"nuernberg-cuxhavener_strasse-f411790",
"nuernberg-cuxhavener_strasse-n26890",
"nuernberg-cuxhavener_strasse-n26900",
"nuernberg-danziger_strasse-cc53690",
"nuernberg-danziger_strasse-cc53700",
"nuernberg-danziger_strasse-cc53730",
"nuernberg-danziger_strasse-cc53750",
"nuernberg-datev_baustelle-c108290",
"nuernberg-datev_baustelle-c108330",
"nuernberg-datev_campus-c136190",
"nuernberg-datev_campus-c136260",
"nuernberg-datev_campus-cb99690",
"nuernberg-datev_campus-cb99710",
"nuernberg-datev_it-campus_111-f531330",
"nuernberg-datev_it-campus_111-n525350",
"nuernberg-datev_orange_campus-f530720",
"nuernberg-datev_unterfuehrung_fuerther_strasse-c108400",
"nuernberg-datev_virnsberger_strasse-c111530",
"nuernberg-datev_virnsberger_strasse-c111540",
"nuernberg-datev-bb8360",
"nuernberg-datev-c041600",
"nuernberg-datev-c089970",
"nuernberg-datev-c108270",
"nuernberg-datev-c123260",
"nuernberg-datev-c123280",
"nuernberg-datev-c123350",
"nuernberg-datev-c123390",
"nuernberg-datev-c19630",
"nuernberg-datev-cb89680",
"nuernberg-datev-cb89750",
"nuernberg-datev-cd17640",
"nuernberg-datev-n14580",
"nuernberg-datev-n14590",
"nuernberg-datev-n14620",
"nuernberg-datev-n364580",
"nuernberg-db_fahrzeuginstandhaltung_werk-c194840",
"nuernberg-db_fahrzeuginstandhaltung_werk-c194860",
"nuernberg-db_fahrzeuginstandhaltung_werk-c194870",
"nuernberg-db_fahrzeuginstandhaltung_werk-c194900",
"nuernberg-db_gartenanlage-f491330",
"nuernberg-db_werkstatt-f555050",
"nuernberg-dehner-c312060",
"nuernberg-dehner-c312080",
"nuernberg-dehner-c312090",
"nuernberg-dehner-n295360",
"nuernberg-delphi-c213020",
"nuernberg-delphinlagune-c037740",
"nuernberg-delphinlagune-c037840",
"nuernberg-delphinlagune-cc53910",
"nuernberg-delphinlagune-nn67580",
"nuernberg-dennerstrasse-f413520",
"nuernberg-deponie-c152530",
"nuernberg-deponie-c152540",
"nuernberg-deponie-n146930",
"nuernberg-deponie-n245730",
"nuernberg-deponie-n245750",
"nuernberg-deponie-n245780",
"nuernberg-desi-c241380",
"nuernberg-deutsche_bundesbank-f471940",
"nuernberg-deutsche_hefewerke_dhw-cb98990",
"nuernberg-deutsche_hefewerke_dhw-cc33970",
"nuernberg-deutsche_hefewerke-c118680",
"nuernberg-deutsche_rentenversicherung-c119040",
"nuernberg-deutsche_rentenversicherung-c119060",
"nuernberg-deutsches_museum-c311470",
"nuernberg-deutsches_museum-c311600",
"nuernberg-deutsches_museum-f382420",
"nuernberg-deutsches_museum-f383840",
"nuernberg-deutsches_museum-f407520",
"nuernberg-deutsches_museum-n263580",
"nuernberg-deutsches_museum-n263600",
"nuernberg-deutsches_museum-n263610",
"nuernberg-deutsches_museum-n263650",
"nuernberg-deutsches_museum-n263670",
"nuernberg-deutsches_museum-n263690",
"nuernberg-deutsches_museum-n263720",
"nuernberg-deutsches_museum-n263740",
"nuernberg-deutsches_museum-n263750",
"nuernberg-deutsches_museum-n263760",
"nuernberg-deutsches_museum-n263790",
"nuernberg-deutsches_museum-n263800",
"nuernberg-deutsches_museum-n294930",
"nuernberg-deutsches_museum-n363960",
"nuernberg-deutsches_museum-n363980",
"nuernberg-deutsches_museum-n364010",
"nuernberg-deutsches_museum-n364020",
"nuernberg-deutsches_museum-n364040",
"nuernberg-deutsches_museum-n364100",
"nuernberg-deutschherrnstrasse-f484980",
"nuernberg-deutschherrnstrasse-n263570",
"nuernberg-deutschherrnstrasse-n263900",
"nuernberg-deutschherrnstrasse-n294960",
"nuernberg-dhl_am_hafen-f395440",
"nuernberg-dhl_paketzentrum_90-n36590",
"nuernberg-dhl_wittekindstrasse-f413640",
"nuernberg-dhl-bb8470",
"nuernberg-dhl-f4110",
"nuernberg-dhl-f4110",
"nuernberg-dhl-f412610",
"nuernberg-dhl-n145710",
"nuernberg-dhl-n145740",
"nuernberg-dhl-n14690",
"nuernberg-dianaplatz-c053580",
"nuernberg-dianaplatz-c194750",
"nuernberg-dianaplatz-f391670",
"nuernberg-dianaplatz-f394380",
"nuernberg-dianaplatz-f405730",
"nuernberg-dianaplatz-f540880",
"nuernberg-dianaplatz-f540890",
"nuernberg-dianaplatz-n147570",
"nuernberg-dianaplatz-s562070",
"nuernberg-dianastrasse-c135440",
"nuernberg-dianastrasse-n246490",
"nuernberg-dieselstrasse-f445300",
"nuernberg-doerfleinstrasse-f540950",
"nuernberg-doerflerstrasse_abstellgleis-n363220",
"nuernberg-donaustrasse_36-n146620",
"nuernberg-doos-nn74860",
"nuernberg-dorf-c125420",
"nuernberg-dpd-f39140",
"nuernberg-dpd-f39150",
"nuernberg-dr__calo_schmid-n530700",
"nuernberg-dr_-carlo-schmid-strasse-c207360",
"nuernberg-dr_-carlo-schmid-strasse-cc52420",
"nuernberg-dr_-carlo-schmid-strasse-f404860",
"nuernberg-dr_-carlo-schmid-strasse-f492970",
"nuernberg-dr_-carlo-schmid-strasse-f492990",
"nuernberg-dr_-carlo-schmid-strasse-f492990",
"nuernberg-dr_-carlo-schmid-strasse-f493000",
"nuernberg-dr_-carlo-schmid-strasse-f493010",
"nuernberg-dr_-carlo-schmid-strasse-f493010",
"nuernberg-dr_-carlo-schmid-strasse-f493020",
"nuernberg-dr_-carlo-schmid-strasse-n145120",
"nuernberg-dr_-erler-klinik-c156470",
"nuernberg-dr_-erler-klinik-cc42620",
"nuernberg-dr_-erler-klinik-cc53080",
"nuernberg-dr_-erler-klinik-f383880",
"nuernberg-dr_-erler-klinik-f484820",
"nuernberg-dr_-erler-klinik-n149190",
"nuernberg-dr_-erler-klinik-nn66900",
"nuernberg-dr_-gustav-heinemann-bruecke-c225750",
"nuernberg-dr_-gustav-heinemann-bruecke-f405090",
"nuernberg-dr_-gustav-heinemann-bruecke-f405090",
"nuernberg-dr_-gustav-heinemann-bruecke-f471980",
"nuernberg-dr_-gustav-heinemann-bruecke-f472080",
"nuernberg-dr_-gustav-heinemann-bruecke-f530900",
"nuernberg-dr_-gustav-heinemann-bruecke-n144790",
"nuernberg-dr_-gustav-heinemann-bruecke-n144930",
"nuernberg-dr_-gustav-heinemann-bruecke-n510440",
"nuernberg-dr_-gustav-heinemann-strasse-n293930",
"nuernberg-dr_-gustav-heinemann-strasse-n361540",
"nuernberg-dr_-gustav-heinemann-strasse-n361590",
"nuernberg-dr_-kurt-schumacher-strasse-c211690",
"nuernberg-dr_-kurt-schumacher-strasse-c211730",
"nuernberg-dr_-kurt-schumacher-strasse-c211780",
"nuernberg-dr_-kurt-schumacher-strasse-c211790",
"nuernberg-dr_-kurt-schumacher-strasse-c211890",
"nuernberg-dr_-kurt-schumacher-strasse-c211900",
"nuernberg-dr_-kurt-schumacher-strasse-c211960",
"nuernberg-dr_-luppe-platz-c134500",
"nuernberg-dr_-luppe-platz-f392080",
"nuernberg-dr_-luppe-platz-f392090",
"nuernberg-dr_-luppe-platz-f412660",
"nuernberg-dr_-luppe-platz-f424230",
"nuernberg-dr_-luppe-platz-f434140",
"nuernberg-dr_-luppe-platz-s562080",
"nuernberg-dr_-luppe-platz-s562090",
"nuernberg-dr_-luppe-platz-s562100",
"nuernberg-dr_-theo-schoeller-schule-f493220",
"nuernberg-dr_-theo-schoeller-schule-f493330",
"nuernberg-dreieinigkeitskirche_in_gostenhof-cb99500",
"nuernberg-dreieinigkeitskirche-c212800",
"nuernberg-dresdener_strasse-c313200",
"nuernberg-dresdener_strasse-c313220",
"nuernberg-dresdener_strasse-c313250",
"nuernberg-dresdener_strasse-n36330",
"nuernberg-duerrenhof-c19840",
"nuernberg-duerrenhof-c311170",
"nuernberg-duerrenhof-cc4300",
"nuernberg-duerrenhof-f406040",
"nuernberg-duerrenhof-f413250",
"nuernberg-duerrenhof-f444600",
"nuernberg-duerrenhof-f444720",
"nuernberg-duerrenhof-f444720",
"nuernberg-duerrenhof-f444930",
"nuernberg-duerrenhof-n053630",
"nuernberg-duerrenhof-nn76440",
"nuernberg-duerrenhof-nn76840",
"nuernberg-duerrenhoftunnel-nn76300",
"nuernberg-duerrenhoftunnel-nn76370",
"nuernberg-dutzendteich_im_winter-cc41270",
"nuernberg-dutzendteich-c047960",
"nuernberg-dutzendteich-c232760",
"nuernberg-dutzendteich-c242520",
"nuernberg-dutzendteich-c252130",
"nuernberg-dutzendteich-c252140",
"nuernberg-dutzendteich-c252150",
"nuernberg-dutzendteich-c252880",
"nuernberg-dutzendteich-f391840",
"nuernberg-dutzendteich-f391850",
"nuernberg-dutzendteich-f391860",
"nuernberg-dutzendteich-f405760",
"nuernberg-dutzendteich-f405970",
"nuernberg-dutzendteich-f406730",
"nuernberg-dutzendteich-f412230",
"nuernberg-dutzendteich-f443920",
"nuernberg-dutzendteich-n076260",
"nuernberg-dutzendteich-n076620",
"nuernberg-dutzendteich-n244190",
"nuernberg-dutzendteich-n247380",
"nuernberg-dutzendteich-n294250",
"nuernberg-dutzendteich-n361150",
"nuernberg-dutzendteich-n361190",
"nuernberg-dutzendteich-n361250",
"nuernberg-dutzendteich-n361270",
"nuernberg-dutzendteichstrasse-c242700",
"nuernberg-dutzendzeich_und_kongresshalle-c563630",
"nuernberg-ebensteeg-c225530",
"nuernberg-ebensteg-c225510",
"nuernberg-eberhardshoefe-n364610",
"nuernberg-eberhardshof-f384000",
"nuernberg-eberhardshof-f39760",
"nuernberg-eberhardshof-f406240",
"nuernberg-eberhardshof-f406280",
"nuernberg-eberhardshof-f406290",
"nuernberg-eberhardshof-f411890",
"nuernberg-eberhardshof-f465440",
"nuernberg-eberhardshof-f471190",
"nuernberg-eberhardshof-n363320",
"nuernberg-eberhardshof-n364630",
"nuernberg-eberhardshofstrasse-cb99460",
"nuernberg-eberhardshofstrasse-cc17330",
"nuernberg-eberhardshofstrasse-f555120",
"nuernberg-eberhardshofstrasse-f555130",
"nuernberg-eberhardshofstrasse-f555140",
"nuernberg-egidienplatz-f484900",
"nuernberg-egidienplatz-n29560",
"nuernberg-ehem__aeg_gelaende_fuerther_strasse-n074820",
"nuernberg-ehem__aeg_gelaende_fuerther_strasse-n074830",
"nuernberg-ehem__akzo_nobel_areal-f491870",
"nuernberg-ehem__akzo-nobel_areal-f383100",
"nuernberg-ehem__akzo-nobel_areal-n363790",
"nuernberg-ehem__branntweinareal__baudenkmal_-f444800",
"nuernberg-ehem__branntweinareal-c505680",
"nuernberg-ehem__branntweinareal-c505710",
"nuernberg-ehem__branntweinareal-c505720",
"nuernberg-ehem__branntweinareal-f381440",
"nuernberg-ehem__branntweinareal-f381830",
"nuernberg-ehem__branntweinareal-f382100",
"nuernberg-ehem__branntweinareal-f382110",
"nuernberg-ehem__branntweinareal-f383410",
"nuernberg-ehem__branntweinareal-f383410",
"nuernberg-ehem__branntweinareal-f383440",
"nuernberg-ehem__branntweinareal-f404900",
"nuernberg-ehem__branntweinareal-f404900",
"nuernberg-ehem__branntweinareal-f404910",
"nuernberg-ehem__branntweinareal-f405150",
"nuernberg-ehem__branntweinareal-f405150",
"nuernberg-ehem__branntweinareal-f426400",
"nuernberg-ehem__branntweinareal-f426420",
"nuernberg-ehem__branntweinareal-f426470",
"nuernberg-ehem__branntweinareal-f426490",
"nuernberg-ehem__branntweinareal-f444750",
"nuernberg-ehem__branntweinareal-f444760",
"nuernberg-ehem__branntweinareal-f444790",
"nuernberg-ehem__branntweinareal-f444810",
"nuernberg-ehem__branntweinareal-f444820",
"nuernberg-ehem__branntweinareal-f465200",
"nuernberg-ehem__branntweinareal-f471500",
"nuernberg-ehem__branntweinareal-f471500",
"nuernberg-ehem__branntweinareal-f471550",
"nuernberg-ehem__branntweinareal-f484600",
"nuernberg-ehem__branntweinareal-f484600",
"nuernberg-ehem__branntweinareal-f492880",
"nuernberg-ehem__branntweinareal-f492890",
"nuernberg-ehem__branntweinareal-f492930",
"nuernberg-ehem__branntweinareal-f492940",
"nuernberg-ehem__branntweinareal-f492940",
"nuernberg-ehem__branntweinareal-f492950",
"nuernberg-ehem__branntweinareal-f530760",
"nuernberg-ehem__branntweinareal-f530810",
"nuernberg-ehem__branntweinareal-f530830",
"nuernberg-ehem__branntweinareal-f530840",
"nuernberg-ehem__branntweinareal-f530850",
"nuernberg-ehem__branntweinareal-n361610",
"nuernberg-ehem__branntweinareal-n361630",
"nuernberg-ehem__branntweinareal-n361690",
"nuernberg-ehem__branntweinareal-n361730",
"nuernberg-ehem__branntweinareal-n361790",
"nuernberg-ehem__branntweinareal-n361900",
"nuernberg-ehem__branntweinareal-n362280",
"nuernberg-ehem__branntweinareal-n362300",
"nuernberg-ehem__branntweinareal-n362320",
"nuernberg-ehem__branntweinareal-n530670",
"nuernberg-ehem__branntweinareal-n530720",
"nuernberg-ehem__branntweinareal-n530740",
"nuernberg-ehem__branntweinareal-n530770",
"nuernberg-ehem__branntweinareal-n530780",
"nuernberg-ehem__branntweinareal-n530790",
"nuernberg-ehem__brunswick-f472250",
"nuernberg-ehem__brunswick-f472260",
"nuernberg-ehem__brunswick-f484540",
"nuernberg-ehem__coca_cola_areal-f444870",
"nuernberg-ehem__coca_cola_areal-f472040",
"nuernberg-ehem__coca_cola_areal-f484670",
"nuernberg-ehem__coca-cola_areal-f404980",
"nuernberg-ehem__coca-cola_areal-f405010",
"nuernberg-ehem__coca-cola_areal-f405120",
"nuernberg-ehem__coca-cola_areal-f405120",
"nuernberg-ehem__coca-cola_areal-f413110",
"nuernberg-ehem__coca-cola_areal-f426510",
"nuernberg-ehem__coca-cola_areal-f465240",
"nuernberg-ehem__coca-cola_areal-f484480",
"nuernberg-ehem__coca-cola-areal-c242750",
"nuernberg-ehem__coca-cola-areal-c242790",
"nuernberg-ehem__coca-cola-areal-c242800",
"nuernberg-ehem__coca-cola-areal-c242820",
"nuernberg-ehem__coca-cola-areal-c242850",
"nuernberg-ehem__coca-cola-areal-f381800",
"nuernberg-ehem__coca-cola-areal-f383360",
"nuernberg-ehem__coca-cola-areal-f383680",
"nuernberg-ehem__coca-cola-areal-n361740",
"nuernberg-ehem__coca-cola-areal-n36370",
"nuernberg-ehem__coca-cola-areal-n36390",
"nuernberg-ehem__deutsche_hefewerke__dhw_-n551950",
"nuernberg-ehem__deutsche_hefewerke__dhw_-n551970",
"nuernberg-ehem__deutsche_hefewerke__dhw_-n551980",
"nuernberg-ehem__gartencenter_radloff-f426030",
"nuernberg-ehem__gartencenter_radloff-f426070",
"nuernberg-ehem__gfk_am_nordwestring-f426000",
"nuernberg-ehem__gfk_am_nordwestring-f426020",
"nuernberg-ehem__gfk_am_nordwestring-f426060",
"nuernberg-ehem__gfk-f404660",
"nuernberg-ehem__gfk-f404700",
"nuernberg-ehem__gfk-f404700",
"nuernberg-ehem__kaufhof_am_aufsessplatz-f426320",
"nuernberg-ehem__kaufhof_am_aufsessplatz-f426340",
"nuernberg-ehem__kaufhof-f405260",
"nuernberg-ehem__kaufhof-f47180",
"nuernberg-ehem__kaufhof-f47190",
"nuernberg-ehem__kfz_zulassungsstelle-c244510",
"nuernberg-ehem__kfz_zulassungsstelle-f472160",
"nuernberg-ehem__kfz_zulassungsstelle-n26920",
"nuernberg-ehem__kloesterle-c089170",
"nuernberg-ehem__kloesterle-c089210",
"nuernberg-ehem__kloesterle-c089280",
"nuernberg-ehem__kloesterle-c089330",
"nuernberg-ehem__marktkauf-n077360",
"nuernberg-ehem__marktkauf-n077380",
"nuernberg-ehem__mercedes_wilhelmshavener_strasse-c118940",
"nuernberg-ehem__mercedes-c082330",
"nuernberg-ehem__milchhof-f406830",
"nuernberg-ehem__moebelhaus_m1-f407160",
"nuernberg-ehem__moebelhaus_mz-n05140",
"nuernberg-ehem__moebelhaus_mz-nn83280",
"nuernberg-ehem__nordbahnhof-___ehem__tucher-areal-c10190",
"nuernberg-ehem__nordbahnhof-c048770",
"nuernberg-ehem__nordbahnhof-c081430",
"nuernberg-ehem__nordbahnhof-c10170",
"nuernberg-ehem__nordbahnhof-c123710",
"nuernberg-ehem__nordbahnhof-c123740",
"nuernberg-ehem__nordbahnhof-c132540",
"nuernberg-ehem__nordbahnhof-c132550",
"nuernberg-ehem__nordbahnhof-c132740",
"nuernberg-ehem__nordbahnhof-c133890",
"nuernberg-ehem__nordbahnhof-c173260",
"nuernberg-ehem__nordbahnhof-c191340",
"nuernberg-ehem__nordbahnhof-c223590",
"nuernberg-ehem__nordbahnhof-c25620",
"nuernberg-ehem__nordbahnhof-c25640",
"nuernberg-ehem__nordbahnhof-c25660",
"nuernberg-ehem__nordbahnhof-c283420",
"nuernberg-ehem__nordbahnhof-c563760",
"nuernberg-ehem__nordbahnhof-cb99360",
"nuernberg-ehem__nordbahnhof-cc44050",
"nuernberg-ehem__nordbahnhof-cc53300",
"nuernberg-ehem__nordbahnhof-f382080",
"nuernberg-ehem__nordbahnhof-f383560",
"nuernberg-ehem__nordbahnhof-f383560",
"nuernberg-ehem__nordbahnhof-f426130",
"nuernberg-ehem__nordbahnhof-f434060",
"nuernberg-ehem__nordbahnhof-f47150",
"nuernberg-ehem__nordbahnhof-f490290",
"nuernberg-ehem__nordbahnhof-f492330",
"nuernberg-ehem__nordbahnhof-f492350",
"nuernberg-ehem__nordbahnhof-f492620",
"nuernberg-ehem__nordbahnhof-f514160",
"nuernberg-ehem__nordbahnhof-f530980",
"nuernberg-ehem__nordbahnhof-n012540",
"nuernberg-ehem__nordbahnhof-n06370",
"nuernberg-ehem__nordbahnhof-n06410",
"nuernberg-ehem__nordbahnhof-n077310",
"nuernberg-ehem__nordbahnhof-n32110",
"nuernberg-ehem__nordbahnhof-n342470",
"nuernberg-ehem__nordbahnhof-n342480",
"nuernberg-ehem__nordbahnhof-n342530",
"nuernberg-ehem__nordbahnhof-n342540",
"nuernberg-ehem__nordbahnhof-n362620",
"nuernberg-ehem__nordbahnhof-n362630",
"nuernberg-ehem__nordbahnhof-n362650",
"nuernberg-ehem__nordbahnhof-n362700",
"nuernberg-ehem__nordbahnhof-nn67860",
"nuernberg-ehem__nordbahnhof-nn76590",
"nuernberg-ehem__nordbahnof-c231060",
"nuernberg-ehem__nordbahnof-c23810",
"nuernberg-ehem__nordbahnof-c23850",
"nuernberg-ehem__porsche-f405140",
"nuernberg-ehem__porsche-f406950",
"nuernberg-ehem__porsche-f406950",
"nuernberg-ehem__post_allersberger_strasse-n076330",
"nuernberg-ehem__prinovis-f47880",
"nuernberg-ehem__prinovis-f47900",
"nuernberg-ehem__prinovis-f491380",
"nuernberg-ehem__prinovis-f491400",
"nuernberg-ehem__prinovis-f491490",
"nuernberg-ehem__prinovis-f491510",
"nuernberg-ehem__quelle_areal-f391180",
"nuernberg-ehem__quelle_areal-f39770",
"nuernberg-ehem__quelle_areal-f39780",
"nuernberg-ehem__quelle_areal-f39790",
"nuernberg-ehem__quelle_areal-nn74900",
"nuernberg-ehem__quelle_areal-nn74910",
"nuernberg-ehem__quelle_areal-nn74960",
"nuernberg-ehem__quelle_areal-nn75030",
"nuernberg-ehem__quelle_areal-nn75200",
"nuernberg-ehem__quelleareal-f530350",
"nuernberg-ehem__quelleareal-f531260",
"nuernberg-ehem__quelleareal-f531270",
"nuernberg-ehem__quelleareal-f531280",
"nuernberg-ehem__quelleareal-f531310",
"nuernberg-ehem__quelleareal-n531360",
"nuernberg-ehem__quelleareal-n531390",
"nuernberg-ehem__quelle-c048390",
"nuernberg-ehem__quelle-f407260",
"nuernberg-ehem__quelle-f407300",
"nuernberg-ehem__quelle-f445140",
"nuernberg-ehem__quelle-f445150",
"nuernberg-ehem__quelle-f471220",
"nuernberg-ehem__quelle-f471280",
"nuernberg-ehem__quelle-f493540",
"nuernberg-ehem__quelle-f493550",
"nuernberg-ehem__quelle-f493590",
"nuernberg-ehem__quelle-f493610",
"nuernberg-ehem__quelle-f493620",
"nuernberg-ehem__quellegelaende-cc54640",
"nuernberg-ehem__quelle-n243520",
"nuernberg-ehem__quelle-nn74930",
"nuernberg-ehem__quelle-nn75210",
"nuernberg-ehem__radloff-f404680",
"nuernberg-ehem__radloff-f404680",
"nuernberg-ehem__reichsparteitagsgelaende-n361120",
"nuernberg-ehem__ringlokschuppen-c283870",
"nuernberg-ehem__ringlokschuppen-f383970",
"nuernberg-ehem__ringlokschuppen-f413440",
"nuernberg-ehem__ringlokschuppen-n531220",
"nuernberg-ehem__schlachthof-c241480",
"nuernberg-ehem__schlachthof-f3940",
"nuernberg-ehem__schlachthof-f530710",
"nuernberg-ehem__schlachthof-f540900",
"nuernberg-ehem__schlachthof-f554880",
"nuernberg-ehem__schlachthof-f554890",
"nuernberg-ehem__schlachthof-n075590",
"nuernberg-ehem__schlachthof-n531170",
"nuernberg-ehem__schwesternwohnheim-c081580",
"nuernberg-ehem__schwesternwohnheim-c119630",
"nuernberg-ehem__siemens-n525360",
"nuernberg-ehem__telekom-c564120",
"nuernberg-ehem__tembank-c173110",
"nuernberg-ehem__tucher-areal___ehem__nordbahnhof-c036590",
"nuernberg-ehem__tucher-areal___ehem__nordbahnhof-c036700",
"nuernberg-ehem__tucher-areal___nordbahnhof-c123650",
"nuernberg-ehem__tucher-areal___nordbahnhof-c187180",
"nuernberg-ehem__tucher-areal___nordbahnhof-n06390",
"nuernberg-ehem__tucher-areal___nordbahnhof-n149960",
"nuernberg-ehem__tucher-areal___nordbahnhof-n247640",
"nuernberg-ehem__tucher-areal___nordbahnhof-nn64970",
"nuernberg-ehem__tucher-areal-c048810",
"nuernberg-ehem__tucher-areal-c048820",
"nuernberg-ehem__tucher-areal-c081410",
"nuernberg-ehem__tucher-areal-c10130",
"nuernberg-ehem__tucher-areal-c123690",
"nuernberg-ehem__tucher-areal-c123730",
"nuernberg-ehem__tucher-areal-c132510",
"nuernberg-ehem__tucher-areal-c132690",
"nuernberg-ehem__tucher-areal-c132700",
"nuernberg-ehem__tucher-areal-c133860",
"nuernberg-ehem__tucher-areal-c133900",
"nuernberg-ehem__tucher-areal-c155600",
"nuernberg-ehem__tucher-areal-c155610",
"nuernberg-ehem__tucher-areal-c155620",
"nuernberg-ehem__tucher-areal-c155630",
"nuernberg-ehem__tucher-areal-c155640",
"nuernberg-ehem__tucher-areal-c155670",
"nuernberg-ehem__tucher-areal-c155740",
"nuernberg-ehem__tucher-areal-c173340",
"nuernberg-ehem__tucher-areal-c173350",
"nuernberg-ehem__tucher-areal-c173410",
"nuernberg-ehem__tucher-areal-c191310",
"nuernberg-ehem__tucher-areal-c191320",
"nuernberg-ehem__tucher-areal-c207920",
"nuernberg-ehem__tucher-areal-c207930",
"nuernberg-ehem__tucher-areal-c211500",
"nuernberg-ehem__tucher-areal-c211530",
"nuernberg-ehem__tucher-areal-c211540",
"nuernberg-ehem__tucher-areal-c211580",
"nuernberg-ehem__tucher-areal-c223630",
"nuernberg-ehem__tucher-areal-c231010",
"nuernberg-ehem__tucher-areal-c23950",
"nuernberg-ehem__tucher-areal-c25580",
"nuernberg-ehem__tucher-areal-c25590",
"nuernberg-ehem__tucher-areal-c25680",
"nuernberg-ehem__tucher-areal-c25700",
"nuernberg-ehem__tucher-areal-c283410",
"nuernberg-ehem__tucher-areal-cb99390",
"nuernberg-ehem__tucher-areal-cc25510",
"nuernberg-ehem__tucher-areal-cc44070",
"nuernberg-ehem__tucher-areal-cc53260",
"nuernberg-ehem__tucher-areal-cc53480",
"nuernberg-ehem__tucher-areal-cc53680",
"nuernberg-ehem__tucher-areal-n012600",
"nuernberg-ehem__tucher-areal-n012670",
"nuernberg-ehem__tucher-areal-n029040",
"nuernberg-ehem__tucher-areal-n06300",
"nuernberg-ehem__tucher-areal-n077320",
"nuernberg-ehem__tucher-areal-n144450",
"nuernberg-ehem__tucher-areal-n144460",
"nuernberg-ehem__tucher-areal-n149880",
"nuernberg-ehem__tucher-areal-n149910",
"nuernberg-ehem__tucher-areal-n149950",
"nuernberg-ehem__tucher-areal-n247580",
"nuernberg-ehem__tucher-areal-n247620",
"nuernberg-ehem__tucher-areal-nn67840",
"nuernberg-ehem__tucher-areal-nn76550",
"nuernberg-ehem_branntweinareal-f484610",
"nuernberg-ehem_quelleareal-n530420",
"nuernberg-eibach-c241720",
"nuernberg-eibach-c241730",
"nuernberg-eibach-c241740",
"nuernberg-eibach-c241760",
"nuernberg-eibach-c241770",
"nuernberg-eibach-c241780",
"nuernberg-eibach-c252740",
"nuernberg-eibach-c252760",
"nuernberg-eibach-c252770",
"nuernberg-eibach-f381150",
"nuernberg-eibach-f381160",
"nuernberg-eibach-f381170",
"nuernberg-eibach-f381180",
"nuernberg-eibach-f39190",
"nuernberg-eibach-f39200",
"nuernberg-eibach-f39210",
"nuernberg-eibach-f39220",
"nuernberg-eibach-f39230",
"nuernberg-eibach-f490840",
"nuernberg-eibach-f490850",
"nuernberg-eibach-f490860",
"nuernberg-eibach-f490870",
"nuernberg-eibach-f491200",
"nuernberg-eichenkreuz_sportanlage-f411750",
"nuernberg-eichquartier-f424790",
"nuernberg-eichquartier-f424810",
"nuernberg-eichquartier-f424920",
"nuernberg-eichquartier-f47850",
"nuernberg-eichquartier-f47860",
"nuernberg-eichquartier-f491390",
"nuernberg-eichquartier-f491410",
"nuernberg-eilgutstrasse-f39610",
"nuernberg-eilgutstrasse-f435170",
"nuernberg-eilgutstrasse-f471670",
"nuernberg-einkaufszentrum_mercado-c119220",
"nuernberg-einkaufszentrum_vogelherd-f493200",
"nuernberg-einsteinring-c252730",
"nuernberg-einsteinring-cc4910",
"nuernberg-einsteinring-n245970",
"nuernberg-einsteinring-n246010",
"nuernberg-einsteinring-n246070",
"nuernberg-einsteinring-n246080",
"nuernberg-einsteinring-n246150",
"nuernberg-einsteinring-n246180",
"nuernberg-einsteinring-n246250",
"nuernberg-einsteinring-n246300",
"nuernberg-eisenbahnbruecke_main-donau-kanal-f471070",
"nuernberg-eisenbahn-bundesamt_aussenstelle-f471660",
"nuernberg-elbinger_strasse-c155780",
"nuernberg-elbinger_strasse-c155910",
"nuernberg-elbinger_strasse-c23720",
"nuernberg-elbinger_strasse-c25320",
"nuernberg-elisabeth_kirche-f413510",
"nuernberg-elisabeth-bach-haus-f471600",
"nuernberg-elisabeth-kirche-f412980",
"nuernberg-elisenstrasse-c283670",
"nuernberg-eltersdorf-c227370",
"nuernberg-eltersdorf-c227410",
"nuernberg-emilienstrasse-c311340",
"nuernberg-emilienstrasse-c311440",
"nuernberg-endterstrasse-c11420",
"nuernberger_land-autobahn-c224090",
"nuernberger_land-autobahnkreuz_a3___a9-c224060",
"nuernberger_land-bei_behringersdorf-c225410",
"nuernberger_land-bei_behringersdorf-c225430",
"nuernberg-erfahrungsfeld_zur_entfaltung_der_sinne-c243790",
"nuernberg-erfahrungsfeld_zur_entfaltung_der_sinne-n144700",
"nuernberg-erlanger_strasse_bruecke-cb99020",
"nuernberg-erlanger_strasse-b185140",
"nuernberg-erlanger_strasse-b185200",
"nuernberg-erlanger_strasse-b185230",
"nuernberg-erlanger_strasse-b185240",
"nuernberg-erlanger_strasse-c048960",
"nuernberg-erlanger_strasse-c192660",
"nuernberg-erlanger_strasse-c192670",
"nuernberg-erlanger_strasse-c208330",
"nuernberg-erlanger_strasse-f382980",
"nuernberg-erlanger_strasse-f391150",
"nuernberg-erlanger_strasse-f391160",
"nuernberg-erlanger_strasse-f393790",
"nuernberg-erlanger_strasse-f393970",
"nuernberg-erlanger_strasse-n06340",
"nuernberg-erlanger_strasse-n06360",
"nuernberg-erlenstegen___nordostpark-f465220",
"nuernberg-erlenstegen-c208080",
"nuernberg-erlenstegen-f381650",
"nuernberg-erschliessung-f472410",
"nuernberg-erziehungswissenschaftliche_fakultaet-c191860",
"nuernberg-erziehungswissenschaftliche_fakultaet-c191880",
"nuernberg-erziehungswissenschaftliche_fakultaet-c191890",
"nuernberg-eschenausteg-n530920",
"nuernberg-eschenbach_optik-cb89320",
"nuernberg-esv_fluegelrad_nuernberg_e_v_-f47230",
"nuernberg-euckenweg-c111060",
"nuernberg-eurocom_nuernberg__langwasser_-n361200",
"nuernberg-eurocom_nuernberg__langwasser_-n361210",
"nuernberg-eurocom_nuernberg__langwasser_-n36870",
"nuernberg-eurocom_nuernberg-f406540",
"nuernberg-eurocom_nuernberg-f406550",
"nuernberg-euromedclinic-cb89820",
"nuernberg-euromedclinic-cc54450",
"nuernberg-europakai-f463490",
"nuernberg-europakai-f47690",
"nuernberg-europaplatz-f383450",
"nuernberg-europaplatz-f383460",
"nuernberg-europaplatz-f39450",
"nuernberg-europaplatz-f471490",
"nuernberg-europaplatz-f471570",
"nuernberg-europaplatz-f471580",
"nuernberg-europaplatz-f484520",
"nuernberg-ewf-c153850",
"nuernberg-fabrik_-_ipsheimer_strasse-n069460",
"nuernberg-fabrik_langwasser-c161750",
"nuernberg-faerberstrasse-c122450",
"nuernberg-faerberstrasse-f426780",
"nuernberg-faerberstrasse-f426800",
"nuernberg-faerberstrasse-f434080",
"nuernberg-fai__rant_a_jet_-c193340",
"nuernberg-fai__rant_a_jet_-c193350",
"nuernberg-fai__rant_a_jet_-c193400",
"nuernberg-falkenheim-f490530",
"nuernberg-fankurve-c105510",
"nuernberg-federal_mogul_werk-f39290",
"nuernberg-fembohaus-c119950",
"nuernberg-fembohaus-c119970",
"nuernberg-fenitzerplatz-c119490",
"nuernberg-fenitzerplatz-c208200",
"nuernberg-fenitzerplatz-c208210",
"nuernberg-fenitzerplatz-cc24740",
"nuernberg-fenitzerplatz-f381420",
"nuernberg-fenitzerplatz-f472100",
"nuernberg-fenitzerplatz-f472100",
"nuernberg-fenitzerplatz-n144500",
"nuernberg-fernmeldeturm-c048200",
"nuernberg-fernmeldeturm-c124090",
"nuernberg-fernmeldeturm-c187800",
"nuernberg-fernmeldeturm-c188070",
"nuernberg-fernmeldeturm-c188100",
"nuernberg-fernmeldeturm-cc32040",
"nuernberg-fernmeldeturm-f405610",
"nuernberg-fernmeldeturm-f405640",
"nuernberg-fernmeldeturm-n027950",
"nuernberg-fernmeldeturm-n074930",
"nuernberg-fernmeldeturm-n074940",
"nuernberg-fernmeldeturm-n075260",
"nuernberg-fernmeldeturm-n075270",
"nuernberg-fernmeldeturm-n295310",
"nuernberg-fernmeldeturm-nn75470",
"nuernberg-fernmeldeturm-nn75500",
"nuernberg-fernsehturm-c172720",
"nuernberg-fernsehturm-c172730",
"nuernberg-fernsehturm-c172760",
"nuernberg-fernsehturm-cc51410",
"nuernberg-fernsehturm-f391580",
"nuernberg-fernsehturm-f391590",
"nuernberg-fernsehturm-f391600",
"nuernberg-fernsehturm-f445250",
"nuernberg-fernsehturm-f445280",
"nuernberg-fernsehturm-f464390",
"nuernberg-fernsehturm-f464410",
"nuernberg-fernsehturm-f464500",
"nuernberg-fernsehturm-n274350",
"nuernberg-fernwaerme_rennweg-c232960",
"nuernberg-fernwaerme_rennweg-n247730",
"nuernberg-fernwaermekraftwerk_am_rennweg-n274980",
"nuernberg-festplatz_buch-n531500",
"nuernberg-festplatz_grossgruendlach-n550060",
"nuernberg-feucht-n242330",
"nuernberg-feuerleinstrasse_baustellle-nn74760",
"nuernberg-feuerwache_1-c311870",
"nuernberg-feuerwache_1-c311900",
"nuernberg-feuerwache_1-c311910",
"nuernberg-feuerwache_1-c311920",
"nuernberg-feuerwache_1-f383960",
"nuernberg-feuerwache_1-f471250",
"nuernberg-feuerwache_1-f554430",
"nuernberg-feuerwache_1-n264010",
"nuernberg-feuerwache_1-n342750",
"nuernberg-feuerwache_1-n342810",
"nuernberg-feuerwache_1-n363100",
"nuernberg-feuerwache_1-n363150",
"nuernberg-feuerwache_1-n363160",
"nuernberg-feuerwache_1-n363170",
"nuernberg-feuerwache_1-n363180",
"nuernberg-feuerwache_1-n363190",
"nuernberg-feuerwache_1-n363200",
"nuernberg-feuerwache_1-n363210",
"nuernberg-feuerwache_2-f471600",
"nuernberg-feuerwache_4-b183680",
"nuernberg-feuerwache_4-b183710",
"nuernberg-feuerwache_4-b183730",
"nuernberg-feuerwache_4-b183780",
"nuernberg-feuerwache_4-f463660",
"nuernberg-feuerwache_4-f47700",
"nuernberg-feuerwache_am_hafen-c109280",
"nuernberg-feuerwache_am_hafen-c109310",
"nuernberg-feuerwache_am_hafen-c213580",
"nuernberg-feuerwache_am_hafen-f491260",
"nuernberg-feuerwache_hafen-c109360",
"nuernberg-feuerwache_hafen-c109400",
"nuernberg-feuerwache_innenstadt-c108240",
"nuernberg-feuerwache_langwasser-c106260",
"nuernberg-feuerwache_langwasser-c106300",
"nuernberg-feuerwache_langwasser-c106330",
"nuernberg-feuerwache_willstrasse-cd17670",
"nuernberg-feuerwache-c242110",
"nuernberg-feuerwache-f434080",
"nuernberg-feuerwache-n146130",
"nuernberg-feuerwache-n146180",
"nuernberg-feuerwache-n295170",
"nuernberg-feuerwache-n295190",
"nuernberg-feuerwache-n295200",
"nuernberg-feuerwasche_1-f540970",
"nuernberg-finanzamt-f426230",
"nuernberg-findelwiesenstrasse-n147850",
"nuernberg-findelwiesenstrasse-n147860",
"nuernberg-findelwiesenstrasse-n147870",
"nuernberg-findelwiesenstrasse-n147880",
"nuernberg-finkenbrunn-c252490",
"nuernberg-finkenbrunn-c252500",
"nuernberg-finkenbrunn-c252830",
"nuernberg-finkenbrunn-c252840",
"nuernberg-finkenbrunn-c252850",
"nuernberg-firma_durner-c564390",
"nuernberg-fischbach-c161720",
"nuernberg-fischbach-c161730",
"nuernberg-fischbach-c281420",
"nuernberg-fischbach-c281850",
"nuernberg-fischbach-cc41720",
"nuernberg-fischbach-cc41790",
"nuernberg-fischbach-cc43140",
"nuernberg-fischbach-f484380",
"nuernberg-fischbach-n145470",
"nuernberg-fischbach-n145490",
"nuernberg-fischbach-n145500",
"nuernberg-fischbach-n145510",
"nuernberg-fischbach-n145520",
"nuernberg-fischbach-n145530",
"nuernberg-fischbach-n303520",
"nuernberg-fischbach-n303530",
"nuernberg-fischbach-n303540",
"nuernberg-fischbach-n303560",
"nuernberg-fischbach-n303570",
"nuernberg-fischbach-n303580",
"nuernberg-fischbach-n303590",
"nuernberg-fischbach-n303600",
"nuernberg-fischbach-n520460",
"nuernberg-fischbach-n520470",
"nuernberg-fischbach-n520480",
"nuernberg-fischbach-n520490",
"nuernberg-flaschenhof-c282340",
"nuernberg-flaschenhof-c311160",
"nuernberg-flaschenhof-f39940",
"nuernberg-flaschenhof-f39950",
"nuernberg-flaschenhof-f413260",
"nuernberg-flaschenhof-f435040",
"nuernberg-flaschenhof-f435070",
"nuernberg-flaschenhof-n364410",
"nuernberg-flaschenhof-n364510",
"nuernberg-flaschenhofstrasse-b182600",
"nuernberg-flaschenhofstrasse-c212330",
"nuernberg-flaschenhofstrasse-c251010",
"nuernberg-flaschenhofstrasse-c25760",
"nuernberg-flaschenhofstrasse-c25810",
"nuernberg-flaschenhofstrasse-c25830",
"nuernberg-flaschenhofstrasse-f406020",
"nuernberg-flaschenhofstrasse-f406030",
"nuernberg-flataustrasse-c24190",
"nuernberg-fleischbruecke-c212190",
"nuernberg-fliegerstrasse-b182820",
"nuernberg-flixtrain-c25780",
"nuernberg-flixtrain-c25790",
"nuernberg-flora_54-f493220",
"nuernberg-flora_54-f493360",
"nuernberg-flora54-f404730",
"nuernberg-flora54-f471340",
"nuernberg-flora54-f555240",
"nuernberg-flughafen_panorama-c152330",
"nuernberg-flughafen-b184740",
"nuernberg-flughafen-b184890",
"nuernberg-flughafen-b184980",
"nuernberg-flughafen-b185040",
"nuernberg-flughafen-b185050",
"nuernberg-flughafen-b185080",
"nuernberg-flughafen-b18640",
"nuernberg-flughafen-b18650",
"nuernberg-flughafen-bb81130",
"nuernberg-flughafen-bb81150",
"nuernberg-flughafen-bb81190",
"nuernberg-flughafen-bb81220",
"nuernberg-flughafen-bb81250",
"nuernberg-flughafen-bb81280",
"nuernberg-flughafen-bb81320",
"nuernberg-flughafen-bb81440",
"nuernberg-flughafen-bb81500",
"nuernberg-flughafen-bb81580",
"nuernberg-flughafen-bb81630",
"nuernberg-flughafen-c057730",
"nuernberg-flughafen-c192680",
"nuernberg-flughafen-c192900",
"nuernberg-flughafen-c192910",
"nuernberg-flughafen-c192930",
"nuernberg-flughafen-c192950",
"nuernberg-flughafen-c192990",
"nuernberg-flughafen-c196530",
"nuernberg-flughafen-c24160",
"nuernberg-flughafen-c28340",
"nuernberg-flughafen-c28360",
"nuernberg-flughafen-cc5670",
"nuernberg-flughafen-n144310",
"nuernberg-flughafen-n144320",
"nuernberg-flughafen-n245470",
"nuernberg-flughafen-n261360",
"nuernberg-flughafen-nn74590",
"nuernberg-flughafen-nn74610",
"nuernberg-flugzeug_unfall-c24110",
"nuernberg-flugzeug_unfall-c24120",
"nuernberg-flugzeug_unfall-c24130",
"nuernberg-flugzeug-c068060",
"nuernberg-flugzeugschatten-c206990",
"nuernberg-flugzeugschatten-f423900",
"nuernberg-flusskraftwerk_hammer-c243150",
"nuernberg-flusskraftwerk_hammer-c243160",
"nuernberg-flusskraftwerk_hammer-c243250",
"nuernberg-flusskraftwerk_hammer-c243260",
"nuernberg-flusskraftwerk_hammer-c243300",
"nuernberg-flusskraftwerk_hammer-c243330",
"nuernberg-flusskraftwerk_hammer-c243360",
"nuernberg-foerderzentrum_foerderschwerpunkt_sprache-c283830",
"nuernberg-foerderzentrum-c312180",
"nuernberg-forchheimer_strasse-c119810",
"nuernberg-forchheimer_strasse-c119820",
"nuernberg-forchheimer_strasse-c119830",
"nuernberg-forchheimer_strasse-c119840",
"nuernberg-forchheimer_strasse-c174170",
"nuernberg-forchheimer_strasse-c226940",
"nuernberg-forchheimer_strasse-c244750",
"nuernberg-forchheimer_strasse-c312620",
"nuernberg-forchheimer_strasse-c312630",
"nuernberg-forchheimer_strasse-c312650",
"nuernberg-forchheimer_strasse-c312660",
"nuernberg-forchheimer_strasse-cc33900",
"nuernberg-forchheimer_strasse-f383670",
"nuernberg-forchheimer_strasse-f425990",
"nuernberg-forchheimer_strasse-f434790",
"nuernberg-forchheimer_strasse-f434860",
"nuernberg-forchheimer_strasse-f434880",
"nuernberg-forchheimer_strasse-f434910",
"nuernberg-forchheimer_strasse-f434930",
"nuernberg-forchheimer_strasse-f472390",
"nuernberg-forchheimer_strasse-f540140",
"nuernberg-forchheimer_strasse-f550170",
"nuernberg-forchheimer_strasse-f553910",
"nuernberg-forchheimer_strasse-f553920",
"nuernberg-forchheimer_strasse-f554000",
"nuernberg-forchheimer_strasse-f554010",
"nuernberg-forchheimer_strasse-f554020",
"nuernberg-forchheimer_strasse-n540200",
"nuernberg-forchheimer_strasse-n540210",
"nuernberg-forst_bei_heideck-n291120",
"nuernberg-franken_campus-f391740",
"nuernberg-franken_campus-f412350",
"nuernberg-frankencampus-c117590",
"nuernberg-frankencampus-c252440",
"nuernberg-frankencampus-c252460",
"nuernberg-frankencampus-c252470",
"nuernberg-frankencampus-c282470",
"nuernberg-frankencampus-c282480",
"nuernberg-frankencampus-c282500",
"nuernberg-frankencampus-c282510",
"nuernberg-frankencampus-c282530",
"nuernberg-frankencampus-c31890",
"nuernberg-frankencampus-n262780",
"nuernberg-frankencampus-n262790",
"nuernberg-frankencampus-n262930",
"nuernberg-frankencampus-n262940",
"nuernberg-franken-center_nuernberg-c505170",
"nuernberg-frankengemuese-f407910",
"nuernberg-frankenkraftwerk_1-n530620",
"nuernberg-frankenschnellweg_am_hafen-f491230",
"nuernberg-frankenschnellweg-c136150",
"nuernberg-frankenschnellweg-f383270",
"nuernberg-frankenschnellweg-f413390",
"nuernberg-frankenschnellweg-f492010",
"nuernberg-frankenschnellweg-n525400",
"nuernberg-frankenstrasse-c122360",
"nuernberg-frankenstrasse-c122380",
"nuernberg-frankenstrasse-c135320",
"nuernberg-frankenstrasse-c194630",
"nuernberg-frankenstrasse-c194820",
"nuernberg-frankenstrasse-c194830",
"nuernberg-frankenstrasse-c194940",
"nuernberg-frankenstrasse-c213060",
"nuernberg-frankenstrasse-c563990",
"nuernberg-frankenstrasse-cb8480",
"nuernberg-frankenstrasse-f391710",
"nuernberg-frankenstrasse-f391720",
"nuernberg-frankenstrasse-f391730",
"nuernberg-frankenstrasse-f540560",
"nuernberg-frankenstrasse-n076300",
"nuernberg-frankenstrasse-n262950",
"nuernberg-frauenholzstrasse-n261490",
"nuernberg-frauenkirche-f445040",
"nuernberg-frauenkirche-f471960",
"nuernberg-frauentorgraben_bei_nacht-c041440",
"nuernberg-frauentorgraben-b182230",
"nuernberg-frauentorgraben-b182240",
"nuernberg-frauentorgraben-c191530",
"nuernberg-frauentorgraben-c191540",
"nuernberg-frauentorgraben-c191560",
"nuernberg-frauentorgraben-c191960",
"nuernberg-frauentorgraben-c191970",
"nuernberg-frauentorgraben-c192400",
"nuernberg-frauentorgraben-c194040",
"nuernberg-frauentorgraben-c196390",
"nuernberg-frauentorgraben-c211650",
"nuernberg-frauentorgraben-c226480",
"nuernberg-frauentorgraben-c251950",
"nuernberg-frauentorgraben-c311330",
"nuernberg-frauentorgraben-c505530",
"nuernberg-frauentorgraben-c505540",
"nuernberg-frauentorgraben-c505550",
"nuernberg-frauentorgraben-f393300",
"nuernberg-frauentorgraben-f39690",
"nuernberg-frauentorgraben-f406090",
"nuernberg-frauentorgraben-f406100",
"nuernberg-frauentorgraben-f406110",
"nuernberg-frauentorgraben-f406120",
"nuernberg-frauentorgraben-f406400",
"nuernberg-frauentorgraben-f406410",
"nuernberg-frauentorgraben-f412950",
"nuernberg-frauentorgraben-f413330",
"nuernberg-frauentorgraben-f471670",
"nuernberg-frauentorgraben-f484950",
"nuernberg-frauentorgraben-n294740",
"nuernberg-frauentormauer-c193810",
"nuernberg-frauentormauer-c193830",
"nuernberg-frauentormauer-c194050",
"nuernberg-frauentormauer-c196310",
"nuernberg-frauentormauer-cc18290",
"nuernberg-frauentormauer-f492450",
"nuernberg-frauentormauer-f492460",
"nuernberg-frauentormauer-n149080",
"nuernberg-frauentormauer-n149100",
"nuernberg-frauentormauer-n342020",
"nuernberg-frauentrograben-n148210",
"nuernberg-frauentrograben-n148220",
"nuernberg-frauentrograben-n148720",
"nuernberg-frauentrograben-n148730",
"nuernberg-frauentrograben-n148740",
"nuernberg-fraunhoferstrasse-c283380",
"nuernberg-freibad_bayern_07-c038100",
"nuernberg-freibad_bayern_07-c105330",
"nuernberg-freibad_bayern_07-c207760",
"nuernberg-freibad_bayern_07-c563860",
"nuernberg-freibad_bayern_07-cc18150",
"nuernberg-freibad_bayern_07-cc31400",
"nuernberg-freibad_bayern_07-f383740",
"nuernberg-freibad_bayern_07-f444740",
"nuernberg-freibad_bayern_07-f484680",
"nuernberg-freibad_bayern_07-n053390",
"nuernberg-freibad_bayern_07-n144850",
"nuernberg-freibad_bayern_07-n361530",
"nuernberg-freibad_bayern_07-n361580",
"nuernberg-freibad_bayern_07-nn67110",
"nuernberg-freibad_bayern_07-nn76980",
"nuernberg-freibad_freibad_bayern_07-f381790",
"nuernberg-freibad_freibad_bayern_07-n261960",
"nuernberg-freibad_freibad_bayern_07-n262150",
"nuernberg-freibad_langsee-c242990",
"nuernberg-freiwillige_feuerwehr_buch-n551910",
"nuernberg-freiwillige_feuerwehr_buch-n551990",
"nuernberg-freiwillige_feuerwehr_buch-n552000",
"nuernberg-freiwillige_feuerwehr_buch-n552010",
"nuernberg-fressnapf-c195150",
"nuernberg-friedenskirche-c187260",
"nuernberg-friedenskirche-c187290",
"nuernberg-friedenskirche-c187310",
"nuernberg-friedenskirche-f407620",
"nuernberg-friedenskirche-f492590",
"nuernberg-friedhof_boxdorf-f555460",
"nuernberg-friedhof_moegeldorf-n262520",
"nuernberg-friedhof_st__leonhard-n075670",
"nuernberg-friedhof_st__leonhard-n075680",
"nuernberg-friedhof_st__leonhard-n075720",
"nuernberg-friedhof-c242910",
"nuernberg-friedhof-c242970",
"nuernberg-friedhof-c243620",
"nuernberg-friedhof-f444820",
"nuernberg-friedrich_alexander_universitaet-c052070",
"nuernberg-friedrich_alexander_universitaet-cb820",
"nuernberg-friedrich-alexander-universitaet-c191170",
"nuernberg-friedrich-alexander-universitaet-c243680",
"nuernberg-friedrich-alexander-universitaet-cc17520",
"nuernberg-friedrich-alexander-universitaet-cc18430",
"nuernberg-friedrich-alexander-universitaet-cc31680",
"nuernberg-friedrich-alexander-universitaet-f39890",
"nuernberg-friedrich-alexander-universitaet-f413040",
"nuernberg-friedrich-alexander-universitaet-n525270",
"nuernberg-friedrich-ebert-platz-c038970",
"nuernberg-friedrich-ebert-platz-c119880",
"nuernberg-friedrich-ebert-platz-c119890",
"nuernberg-friedrich-ebert-platz-c193520",
"nuernberg-friedrich-ebert-platz-c196750",
"nuernberg-friedrich-ebert-platz-c233280",
"nuernberg-friedrich-ebert-platz-c241120",
"nuernberg-friedrich-ebert-platz-c241140",
"nuernberg-friedrich-ebert-platz-c241150",
"nuernberg-friedrich-ebert-platz-c24940",
"nuernberg-friedrich-ebert-platz-cc18350",
"nuernberg-friedrich-ebert-platz-cc53320",
"nuernberg-friedrich-ebert-platz-f383570",
"nuernberg-friedrich-ebert-platz-f39870",
"nuernberg-friedrich-ebert-platz-f412730",
"nuernberg-friedrich-ebert-platz-f492310",
"nuernberg-friedrich-ebert-platz-f492600",
"nuernberg-friedrich-ebert-platz-f532160",
"nuernberg-friedrich-ebert-platz-f532280",
"nuernberg-friedrich-ebert-platz-n14440",
"nuernberg-friedrich-ebert-platz-n14450",
"nuernberg-friedrich-ebert-platz-n14460",
"nuernberg-friedrich-ebert-platz-n14470",
"nuernberg-friedrich-ebert-platz-n247390",
"nuernberg-friedrich-ebert-platz-n531690",
"nuernberg-friedrich-hegel-schule-f493150",
"nuernberg-froeschl_parkhaus-f434080",
"nuernberg-frost-c2320",
"nuernberg-frost-c2350",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14420",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14540",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14640",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14870",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14910",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14920",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14960",
"nuernberg-fruehlingsfest_-_feuerwerk-ce14970",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15070",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15090",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15120",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15280",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15340",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15370",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15390",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15530",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15560",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15580",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15610",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15620",
"nuernberg-fruehlingsfest_-_feuerwerk-ce15630",
"nuernberg-fruehlingsfest_freefall-c105710",
"nuernberg-fruehlingsfest_riesenrad-c105840",
"nuernberg-fruehlingsfest_riesenrad-c105890",
"nuernberg-fruehlingsfest_rollercoaster-c105800",
"nuernberg-fruehlingsfest-c153780",
"nuernberg-fruehlingsfest-c252870",
"nuernberg-fruehlingsfest-cc52240",
"nuernberg-fruehlingsfest-cc52310",
"nuernberg-fruehlingsfest-ce12260",
"nuernberg-fruehlingsfest-ce12280",
"nuernberg-fruehlingsfest-ce12340",
"nuernberg-fruehlingsfest-ce12350",
"nuernberg-fruehlingsfest-ce12440",
"nuernberg-fruehlingsfest-ce12460",
"nuernberg-fruehlingsfest-ce12510",
"nuernberg-fruehlingsfest-ce12550",
"nuernberg-fruehlingsfest-ce12670",
"nuernberg-fruehlingsfest-ce12960",
"nuernberg-fruehlingsfest-ce13070",
"nuernberg-fuchsgaerten-n515850",
"nuernberg-fuchsloch-c123530",
"nuernberg-fuchsloch-c283940",
"nuernberg-fuchsloch-f485080",
"nuernberg-fuchsloch-f493650",
"nuernberg-fuchsloch-f554290",
"nuernberg-fuchsloch-f554300",
"nuernberg-fuchsloch-n515740",
"nuernberg-fuchslochwelle-f472440",
"nuernberg-fuchslochwelle-f472450",
"nuernberg-fuchslochwelle-f472470",
"nuernberg-fuchslochwelle-f472480",
"nuernberg-fuchslochwelle-n552040",
"nuernberg-fuchslochwelle-n552080",
"nuernberg-fuchslochwelle-n552100",
"nuernberg-fuchslochwelle-n552110",
"nuernberg-fuchsstrasse-c283930",
"nuernberg-fuenferplatz-n149650",
"nuernberg-fuerther_hauptbahnhof-f407200",
"nuernberg-fuerther_hauptbahnhof-f407210",
"nuernberg-fuerther_strasse_-_datev-c311770",
"nuernberg-fuerther_strasse_-_datev-c311790",
"nuernberg-fuerther_strasse_-_datev-c311820",
"nuernberg-fuerther_strasse_-_datev-c311830",
"nuernberg-fuerther_strasse_-_datev-c311840",
"nuernberg-fuerther_strasse-c196460",
"nuernberg-fuerther_strasse-c199800",
"nuernberg-fuerther_strasse-c215120",
"nuernberg-fuerther_strasse-c245280",
"nuernberg-fuerther_strasse-c251730",
"nuernberg-fuerther_strasse-c251810",
"nuernberg-fuerther_strasse-c251830",
"nuernberg-fuerther_strasse-f392170",
"nuernberg-fuerther_strasse-f407290",
"nuernberg-fuerther_strasse-f555110",
"nuernberg-fuerther_strasse-n264100",
"nuernberg-fuerther_strasse-nn74970",
"nuernberg-fuerth-f383070",
"nuernberg-fuggerstrasse-c283840",
"nuernberg-fuggerstrasse-f382780",
"nuernberg-fuggerstrasse-f382790",
"nuernberg-fuggerstrasse-f384390",
"nuernberg-fuggerstrasse-f384400",
"nuernberg-fuggerstrasse-f434750",
"nuernberg-fuggerstrasse-f471470",
"nuernberg-fuggerstrasse-f471730",
"nuernberg-fuggerstrasse-f540910",
"nuernberg-fuggerstrasse-f540920",
"nuernberg-fuggerstrasse-n24780",
"nuernberg-fuggerstrasse-s562240",
"nuernberg-funkmast-c2370",
"nuernberg-fussballfeld-bb81790",
"nuernberg-fussballfeld-bb81850",
"nuernberg-fussballfelder_des_1__fcn-c036010",
"nuernberg-fussballplatz_im_winter-cc41800",
"nuernberg-fussballplatz-c123590",
"nuernberg-fussballplatz-c195110",
"nuernberg-fussballplatz-n147540",
"nuernberg-fussballstadion_1__fcn-c036020",
"nuernberg-fussballstadion_1__fcn-c047220",
"nuernberg-fussballstadion_1__fcn-c282070",
"nuernberg-fussballstadion_1__fcn-ca84150",
"nuernberg-fussballstadion_1__fcn-ca84190",
"nuernberg-fussballstadion_1__fcn-ca84270",
"nuernberg-fussballstadion_1__fcn-ca84320",
"nuernberg-fussballstadion_1__fcn-ca84380",
"nuernberg-fussballstadion_1__fcn-ca84470",
"nuernberg-fussballstadion_1__fcn-ca84590",
"nuernberg-fussballstadion_1__fcn-ca84620",
"nuernberg-fussballstadion_1__fcn-ca84680",
"nuernberg-fussballstadion_1__fcn-ca84740",
"nuernberg-fussballstadion_1__fcn-ca84870",
"nuernberg-fussballstadion_1__fcn-ca85000",
"nuernberg-fussballstadion_1__fcn-ca85050",
"nuernberg-fussballstadion_1__fcn-ca85910",
"nuernberg-fussballstadion_1__fcn-ca86260",
"nuernberg-fussballstadion_1__fcn-ca86450",
"nuernberg-fussballstadion_1__fcn-ca88520",
"nuernberg-fussballstadion_1__fcn-ca88730",
"nuernberg-fussballstadion_1__fcn-ca88800",
"nuernberg-fussballstadion_1__fcn-n052310",
"nuernberg-fussballstadion_1__fcn-n052630",
"nuernberg-fussballstadion-c242260",
"nuernberg-fussballstadion-c242330",
"nuernberg-gaerten_bei_woehrd-f405190",
"nuernberg-gaerten_bei_woehrd-n262020",
"nuernberg-gaerten_bei_woehrd-n262030",
"nuernberg-gaerten_bei_woehrd-n262040",
"nuernberg-gaerten_bei_woehrd-n303660",
"nuernberg-gaerten_bei_woehrd-n361430",
"nuernberg-gaerten_hinter_der_veste-f493160",
"nuernberg-garnisonmuseum-c135740",
"nuernberg-garnisonmuseum-f464440",
"nuernberg-garnisonmuseum-f464440",
"nuernberg-garnisonmuseum-f464450",
"nuernberg-garten-n146350",
"nuernberg-gartenstadt-b183620",
"nuernberg-gartenstadt-b183630",
"nuernberg-gartenstadt-c111410",
"nuernberg-gartenstadt-c152460",
"nuernberg-gartenstadt-n146120",
"nuernberg-gartenstadt-n29650",
"nuernberg-gartenstadt-n29660",
"nuernberg-gartenstadt-n29670",
"nuernberg-gartenstadt-n29680",
"nuernberg-gartenstadt-n29690",
"nuernberg-gartenstadt-n29700",
"nuernberg-gaulnhofen-f412640",
"nuernberg-gebaeudekomplex_der_novartis-cc43800",
"nuernberg-gebersdorf-c156620",
"nuernberg-gebersdorf-c156630",
"nuernberg-gebersdorf-f391350",
"nuernberg-gebersdorf-f391360",
"nuernberg-gebersdorf-f391370",
"nuernberg-gebersdorf-f391520",
"nuernberg-gebersdorf-f411980",
"nuernberg-gebersdorf-f492140",
"nuernberg-gebersdorf-f492180",
"nuernberg-gebersdorf-f492190",
"nuernberg-gebersdorf-f530430",
"nuernberg-gebersdorf-f530620",
"nuernberg-gebersdorf-n146780",
"nuernberg-gebersdorf-n274310",
"nuernberg-gebertstrasse-c068440",
"nuernberg-gebertstrasse-c068460",
"nuernberg-gebertstrasse-cb89450",
"nuernberg-gebrueder-grimm-schule-n361890",
"nuernberg-gehoerlosten-_und_schwerhoerigenschule-c19650",
"nuernberg-geiseestrasse-f491820",
"nuernberg-geisseestrasse-n075950",
"nuernberg-geisseestrasse-n295370",
"nuernberg-gemeinschaftshaus-f491470",
"nuernberg-gemeinschaftshaus-f491470",
"nuernberg-gemuesehof_hussnaetter-f541140",
"nuernberg-georg_ledebour_strasse-n068890",
"nuernberg-georg_simon_ohm_hochschule-n076990",
"nuernberg-georg-hennch-strasse-f413590",
"nuernberg-georg-hennch-strasse-n363260",
"nuernberg-georg-hennch-strasse-n363290",
"nuernberg-georg-paul-amberger-schule-f491890",
"nuernberg-georg-simon-ohm-hochschule-c117560",
"nuernberg-georg-simon-ohm-hochschule-c154810",
"nuernberg-georg-simon-ohm-hochschule-cc17570",
"nuernberg-georg-simon-ohm-hochschule-n144720",
"nuernberg-georg-strobel-strasse-c225700",
"nuernberg-gerasmuehle-c241800",
"nuernberg-gerasmuehle-c241830",
"nuernberg-gerasmuehle-c241870",
"nuernberg-gerasmuehle-c241880",
"nuernberg-gerasmuehle-c241930",
"nuernberg-gerasmuehle-c241960",
"nuernberg-gerasmuehle-c242020",
"nuernberg-gerasmuehle-n246090",
"nuernberg-gerasmuehle-n246100",
"nuernberg-gerasmuehle-n246330",
"nuernberg-gericht_-f435090",
"nuernberg-germanisches_nationalmuseum-b182000",
"nuernberg-germanisches_nationalmuseum-b182020",
"nuernberg-germanisches_nationalmuseum-b182110",
"nuernberg-germanisches_nationalmuseum-b182160",
"nuernberg-germanisches_nationalmuseum-c155180",
"nuernberg-germanisches_nationalmuseum-c155270",
"nuernberg-germanisches_nationalmuseum-c156220",
"nuernberg-germanisches_nationalmuseum-c212920",
"nuernberg-germanisches_nationalmuseum-c226590",
"nuernberg-germanisches_nationalmuseum-c226600",
"nuernberg-germanisches_nationalmuseum-cb99430",
"nuernberg-germanisches_nationalmuseum-f392220",
"nuernberg-germanisches_nationalmuseum-f393290",
"nuernberg-germanisches_nationalmuseum-f550260",
"nuernberg-germanisches_nationalmuseum-n053810",
"nuernberg-germanisches_nationalmuseum-n148460",
"nuernberg-germanisches_nationalmuseum-n148750",
"nuernberg-germanisches_nationalmuseum-n148910",
"nuernberg-germanisches_nationalmuseum-n148920",
"nuernberg-germanisches_nationalmuseum-n246740",
"nuernberg-germanisches_nationalmuseum-n263000",
"nuernberg-germanisches_nationalmuseum-n263460",
"nuernberg-germanisches_nationalmuseum-n263470",
"nuernberg-germanisches_nationalmuseum-n342000",
"nuernberg-germersheimerstrasse-c153470",
"nuernberg-gertrude-neumark-weg-c312000",
"nuernberg-gertrud-krueger-weg-f493080",
"nuernberg-gertrudstrasse-c156500",
"nuernberg-gesellschaft_fuer_markt-_und_konsumforschung-c048490",
"nuernberg-gesellschaft_fuer_markt-_und_konsumforschung-c186920",
"nuernberg-gesellschaft_fuer_markt-_und_konsumforschung-c312350",
"nuernberg-gesellschaft_fuer_markt-_und_konsumforschung-cc43370",
"nuernberg-gesellschaft_fuer_markt-_und_konsumforschung-n026740",
"nuernberg-gewaechshaeuser__lohe-f47130",
"nuernberg-gewaechshaeuser_kraftshof-c188520",
"nuernberg-gewaechshaeuser_kraftshof-c188550",
"nuernberg-gewaechshaeuser_kraftshof-c188580",
"nuernberg-gewaechshaeuser_neunhof-c188590",
"nuernberg-gewaechshaeuser-b18630",
"nuernberg-gewaechshaeuser-c082360",
"nuernberg-gewaechshaeuser-c082920",
"nuernberg-gewaechshaeuser-c118570",
"nuernberg-gewaechshaeuser-c188430",
"nuernberg-gewaechshaeuser-c208340",
"nuernberg-gewaechshaeuser-f555300",
"nuernberg-gewaechshaeuser-n144330",
"nuernberg-gewaechshaeuser-n144340",
"nuernberg-gewaechshaus-c151840",
"nuernberg-gewaechshaus-c193110",
"nuernberg-gewaechshaus-f435350",
"nuernberg-gewaechshaus-f435360",
"nuernberg-gewerbe_sigmundstrasse-n14680",
"nuernberg-gewerbegebiet_altenfurt-f520410",
"nuernberg-gewerbegebiet_andanacher_strasse-c505810",
"nuernberg-gewerbegebiet_hahnenbalz-f424110",
"nuernberg-gewerbegebiet_hahnenbalz-n520310",
"nuernberg-gewerbegebiet_hahnenbalz-n520320",
"nuernberg-gewerbegebiet_katzwanger_strasse-c281560",
"nuernberg-gewerbegebiet_katzwanger_strasse-n262820",
"nuernberg-gewerbegebiet_katzwanger_strasse-n262830",
"nuernberg-gewerbegebiet_nordostpark-nn67210",
"nuernberg-gewerbegebiet-f530390",
"nuernberg-gewerbemuseumsplatz-c134180",
"nuernberg-gewerbemuseumsplatz-cc42190",
"nuernberg-gewerbemuseumsplatz-f426660",
"nuernberg-gewerbemuseumsplatz-f540280",
"nuernberg-gewerbemuseumsplatz-n148590",
"nuernberg-gewerbepark_feucht-n36620",
"nuernberg-gewerbepark_hessdorf-c227590",
"nuernberg-gewerkschaftshaus-c226620",
"nuernberg-gewerkschaftshaus-n055320",
"nuernberg-gewerkschaftshaus-n055330",
"nuernberg-gfk_in_schnepfenreuth-c048950",
"nuernberg-gfk_in_schnepfenreuth-c118830",
"nuernberg-gfk_orange_campus-f384330",
"nuernberg-gfk_orange_campus-f392130",
"nuernberg-gfk_orange_campus-f392260",
"nuernberg-gfk_orange_campus-f395000",
"nuernberg-gfk_orange_campus-f406370",
"nuernberg-gfk_orange_campus-f413380",
"nuernberg-gfk_orange_campus-f435230",
"nuernberg-gfk_orange_campus-f435240",
"nuernberg-gfk_orange_campus-f471700",
"nuernberg-gibitzenhof-f412110",
"nuernberg-gibitzenhof-f412120",
"nuernberg-gibitzenhof-f412650",
"nuernberg-gibitzenhof-f424230",
"nuernberg-gibitzenhof-f424240",
"nuernberg-gibitzenhof-f434130",
"nuernberg-gibitzenhofstrasse-f471050",
"nuernberg-gibitzenhofstrasse-n147590",
"nuernberg-gibitzenhofstrasse-n147600",
"nuernberg-gibitzenhofstrasse-n147620",
"nuernberg-gibitzenhofstrasse-n147630",
"nuernberg-gibitzenhofstrasse-n341670",
"nuernberg-gibitzenhofstrasse-n341680",
"nuernberg-glasdach_messezentrum-c124310",
"nuernberg-gleissbuehlstrasse-f484470",
"nuernberg-gleissbuehlstrasse-f540290",
"nuernberg-gleissbuehlstrasse-f540300",
"nuernberg-gleisshammer-c563840",
"nuernberg-gleisshammer-c564030",
"nuernberg-gleisshammer-f413230",
"nuernberg-gleisshammer-f514100",
"nuernberg-gleisshammer-f554560",
"nuernberg-gleisshammer-f554570",
"nuernberg-gleisshammer-f554580",
"nuernberg-gleisshammer-n361080",
"nuernberg-gleisshammerstrasse-f492810",
"nuernberg-gleiwitzer_strasse-n068870",
"nuernberg-glockenhof-f490370",
"nuernberg-glockenhof-f540410",
"nuernberg-goethestrasse-c283400",
"nuernberg-goldener_stern-c083160",
"nuernberg-golf_club_am_reichswald-n304010",
"nuernberg-gostenhof_-_austrasse-f555150",
"nuernberg-gostenhof-c11290",
"nuernberg-gostenhof-c211990",
"nuernberg-gostenhof-c212970",
"nuernberg-gostenhof-c241460",
"nuernberg-gostenhof-c281670",
"nuernberg-gostenhof-cb99660",
"nuernberg-gostenhof-f383940",
"nuernberg-gostenhof-f383980",
"nuernberg-gostenhof-f384350",
"nuernberg-gostenhof-f392140",
"nuernberg-gostenhof-f392150",
"nuernberg-gostenhof-f3930",
"nuernberg-gostenhof-f39350",
"nuernberg-gostenhof-f39360",
"nuernberg-gostenhof-f39700",
"nuernberg-gostenhof-f39710",
"nuernberg-gostenhof-f406180",
"nuernberg-gostenhof-f406350",
"nuernberg-gostenhof-f406380",
"nuernberg-gostenhof-f407380",
"nuernberg-gostenhof-f411870",
"nuernberg-gostenhof-f411880",
"nuernberg-gostenhof-f465430",
"nuernberg-gostenhof-f471440",
"nuernberg-gostenhof-f540940",
"nuernberg-gostenhof-f554360",
"nuernberg-gostenhof-n364560",
"nuernberg-gostenhof-s562130",
"nuernberg-gostenhof-s562140",
"nuernberg-gostenhof-s562270",
"nuernberg-grand_hotel-c192070",
"nuernberg-grand_hotel-c192270",
"nuernberg-grand_hotel-c251160",
"nuernberg-grand_hotel-f471940",
"nuernberg-grand_hotel-nn81040",
"nuernberg-griechische_orthodoxe_kirche-n294940",
"nuernberg-grolandstrasse-c212220",
"nuernberg-grolandstrasse-c212230",
"nuernberg-grolandstrasse-f530970",
"nuernberg-grossbaustelle_kieslingstrasse-c081860",
"nuernberg-grossbaustelle_nordostbahnhof-c081930",
"nuernberg-grossbaustelle-n013030",
"nuernberg-grosse_strasse-f425250",
"nuernberg-grossgruendlach_-_reutles-n30120",
"nuernberg-grossgruendlach-c105040",
"nuernberg-grossgruendlach-c116430",
"nuernberg-grossgruendlach-c151500",
"nuernberg-grossgruendlach-c151510",
"nuernberg-grossgruendlach-c151520",
"nuernberg-grossgruendlach-c151530",
"nuernberg-grossgruendlach-c151540",
"nuernberg-grossgruendlach-c151550",
"nuernberg-grossgruendlach-c151560",
"nuernberg-grossgruendlach-c151570",
"nuernberg-grossgruendlach-c151580",
"nuernberg-grossgruendlach-c151590",
"nuernberg-grossgruendlach-c151600",
"nuernberg-grossgruendlach-c151610",
"nuernberg-grossgruendlach-c151620",
"nuernberg-grossgruendlach-c151630",
"nuernberg-grossgruendlach-c151640",
"nuernberg-grossgruendlach-c151650",
"nuernberg-grossgruendlach-c151660",
"nuernberg-grossgruendlach-c216270",
"nuernberg-grossgruendlach-c227310",
"nuernberg-grossgruendlach-c227330",
"nuernberg-grossgruendlach-c254850",
"nuernberg-grossgruendlach-c506010",
"nuernberg-grossgruendlach-f472560",
"nuernberg-grossgruendlach-f494420",
"nuernberg-grossgruendlach-f494430",
"nuernberg-grossgruendlach-f494440",
"nuernberg-grossgruendlach-f514230",
"nuernberg-grossgruendlach-f541180",
"nuernberg-grossgruendlach-f541190",
"nuernberg-grossgruendlach-n05100",
"nuernberg-grossgruendlach-n144110",
"nuernberg-grossgruendlach-n144120",
"nuernberg-grossgruendlach-n144130",
"nuernberg-grossgruendlach-n144140",
"nuernberg-grossgruendlach-n26580",
"nuernberg-grossgruendlach-n26590",
"nuernberg-grossgruendlach-n30100",
"nuernberg-grossgruendlach-n30110",
"nuernberg-grossgruendlach-n30130",
"nuernberg-grossgruendlach-n30150",
"nuernberg-grossgruendlach-n30160",
"nuernberg-grossgruendlach-n30200",
"nuernberg-grossgruendlach-n525630",
"nuernberg-grossgruendlach-n525640",
"nuernberg-grossgruendlach-n525650",
"nuernberg-grosskraftwerk_franken-c187940",
"nuernberg-grosskraftwerk_franken-c187980",
"nuernberg-grosskraftwerk_franken-c188000",
"nuernberg-grosskraftwerk_franken-c188040",
"nuernberg-grosskraftwerk_franken-c19170",
"nuernberg-grosskraftwerk_franken-c19180",
"nuernberg-grossmarkt_nuernberg-f530360",
"nuernberg-grossreuth_bei_schweinau-f391320",
"nuernberg-grossreuth_bei_schweinau-f425740",
"nuernberg-grossreuth_bei_schweinau-f464260",
"nuernberg-grossreuth_bei_schweinau-f491990",
"nuernberg-grossreuth_bei_schweinau-f492090",
"nuernberg-grossreuth_bei_schweinau-f492090",
"nuernberg-grossreuth_bei_schweinau-n363720",
"nuernberg-grossreuth_hinter_der_veste-c208300",
"nuernberg-grossreuth_hinter_der_veste-c208310",
"nuernberg-grossreuth_hinter_der_veste-c244540",
"nuernberg-grossreuth_hinter_der_veste-f382920",
"nuernberg-grossreuth_hinter_der_veste-f464910",
"nuernberg-grossreuth_hinter_der_veste-f492660",
"nuernberg-grossreuth_hinter_der_veste-n144410",
"nuernberg-grossreuth_hinter_der_veste-n26910",
"nuernberg-grossreuth_hinter_der_veste-n26930",
"nuernberg-grossreuther_strasse-c032070",
"nuernberg-grossweidenmuehle-n525310",
"nuernberg-grundig_stadion-b184500",
"nuernberg-grundig_tuerme-b184570",
"nuernberg-grundig-gewerbe-park-c31370",
"nuernberg-grundigstadion_-_zuschauer-c105430",
"nuernberg-grundigstadion_anfpiff-c106520",
"nuernberg-grundigstadion_des_1__fcn-n052330",
"nuernberg-grundigstadion_fans-c105990",
"nuernberg-grundigstadion-c105410",
"nuernberg-grundigstadion-c106700",
"nuernberg-grundigstadion-c153710",
"nuernberg-grundigstadion-c231900",
"nuernberg-grundigstadion-c232160",
"nuernberg-grundigtuerme___teambank-c08830",
"nuernberg-grundigtuerme___teambank-c08850",
"nuernberg-grundigtuerme___teambank-c08870",
"nuernberg-grundigtuerme-b184510",
"nuernberg-grundigtuerme-c047250",
"nuernberg-grundigtuerme-c225770",
"nuernberg-grundigtuerme-c225820",
"nuernberg-grundigtuerme-c225850",
"nuernberg-grundigtuerme-c231540",
"nuernberg-grundigtuerme-c231560",
"nuernberg-grundig-tuerme-cc41570",
"nuernberg-grundigtuerme-n011930",
"nuernberg-grundigtuerme-nn81710",
"nuernberg-grundschule_grossgruendlach-n550040",
"nuernberg-grundschule_paniersplatz-f407480",
"nuernberg-grundschule_paniersplatz-f471970",
"nuernberg-grundschule_zerzabelshof-f47790",
"nuernberg-guelle-c213860",
"nuernberg-gueterverkehrszentrum_hafen-f490820",
"nuernberg-gugelstrasse-c194950",
"nuernberg-guggenheimer_strasse-c311950",
"nuernberg-guggenheimer_strasse-c311960",
"nuernberg-guggenheimer_strasse-f412040",
"nuernberg-guggenheimer_strasse-f425760",
"nuernberg-guggenheimer_strasse-f425780",
"nuernberg-guggenheimer_strasse-f425790",
"nuernberg-guggenheimer_strasse-f425800",
"nuernberg-guggenheimer_strasse-f425820",
"nuernberg-guggenheimer_strasse-f425920",
"nuernberg-guggenheimer_strasse-f491970",
"nuernberg-guggenheimer_strasse-f492080",
"nuernberg-guggenheimer_strasse-n242850",
"nuernberg-guggenheimer_strasse-n342980",
"nuernberg-guggenheimer_strasse-n363620",
"nuernberg-guggenheimer_strasse-n363640",
"nuernberg-guggenheimer_strasse-n363730",
"nuernberg-guggenheimerstrasse-c251840",
"nuernberg-guggenheimerstrasse-c251870",
"nuernberg-guggenheimerstrasse-c251920",
"nuernberg-guggenheimerstrasse-c281680",
"nuernberg-guggenheimerstrasse-f412030",
"nuernberg-guggenheimerstrasse-f425750",
"nuernberg-guggenheimerstrasse-n295420",
"nuernberg-guggenheimerstrasse-n295470",
"nuernberg-gustav-adolf-gedaechtniskirche-f384240",
"nuernberg-gustav-adolf-gedaechtniskirche-nn8960",
"nuernberg-gustav-adolf-strasse-c28420",
"nuernberg-gustav-adolf-strasse-c28760",
"nuernberg-gustav-adolf-strasse-f394340",
"nuernberg-gustav-adolf-strasse-n295260",
"nuernberg-gustav-adolf-strasse-n295280",
"nuernberg-gustav-adolf-strasse-n295350",
"nuernberg-gwaechshaus_eventlocation-f472340",
"nuernberg-hadermuehle-f540450",
"nuernberg-hafen_dhl-c052720",
"nuernberg-hafen_dhl-f532020",
"nuernberg-hafen_dhl-f532030",
"nuernberg-hafen_dhl-f532040",
"nuernberg-hafen_lkw-n245860",
"nuernberg-hafen_nuernberg-f424670",
"nuernberg-hafen_nuernberg-f47650",
"nuernberg-hafen_nuernberg-f47660",
"nuernberg-hafen_nuernberg-f47670",
"nuernberg-hafen_nuernberg-f47680",
"nuernberg-hafen_nuernberg-f490810",
"nuernberg-hafen_nuernberg-f490830",
"nuernberg-hafen_nuernberg-f491210",
"nuernberg-hafen_nuernberg-f491220",
"nuernberg-hafen_nuernberg-f491250",
"nuernberg-hafen_nuernberg-f491280",
"nuernberg-hafen_nuernberg-f532070",
"nuernberg-hafen_raben-c153320",
"nuernberg-hafen_schrottplatz-n245880",
"nuernberg-hafen_silo-b183960",
"nuernberg-hafen_ups-n245920",
"nuernberg-hafen_ups-n245930",
"nuernberg-hafen-b183860",
"nuernberg-hafen-b183880",
"nuernberg-hafen-bb81030",
"nuernberg-hafen-bb8320",
"nuernberg-hafen-bb87040",
"nuernberg-hafenbecken-cc4950",
"nuernberg-hafenbruecken-f381230",
"nuernberg-hafenbruecken-f491290",
"nuernberg-hafen-c032270",
"nuernberg-hafen-c051350",
"nuernberg-hafen-c053090",
"nuernberg-hafen-c056480",
"nuernberg-hafen-c089370",
"nuernberg-hafen-c117620",
"nuernberg-hafen-c117640",
"nuernberg-hafen-c117670",
"nuernberg-hafen-c117690",
"nuernberg-hafen-c117750",
"nuernberg-hafen-c117770",
"nuernberg-hafen-c117860",
"nuernberg-hafen-c117870",
"nuernberg-hafen-c117890",
"nuernberg-hafen-c117900",
"nuernberg-hafen-c117910",
"nuernberg-hafen-c117920",
"nuernberg-hafen-c117940",
"nuernberg-hafen-c117950",
"nuernberg-hafen-c117960",
"nuernberg-hafen-c118010",
"nuernberg-hafen-c118020",
"nuernberg-hafen-c118030",
"nuernberg-hafen-c124050",
"nuernberg-hafen-c152550",
"nuernberg-hafen-c152570",
"nuernberg-hafen-c152590",
"nuernberg-hafen-c152600",
"nuernberg-hafen-c152610",
"nuernberg-hafen-c152620",
"nuernberg-hafen-c153280",
"nuernberg-hafen-c153290",
"nuernberg-hafen-c153300",
"nuernberg-hafen-c153370",
"nuernberg-hafen-c153380",
"nuernberg-hafen-c153390",
"nuernberg-hafen-c153400",
"nuernberg-hafen-c153420",
"nuernberg-hafen-c153450",
"nuernberg-hafen-c153460",
"nuernberg-hafen-c213600",
"nuernberg-hafen-c213620",
"nuernberg-hafen-c213630",
"nuernberg-hafen-c213640",
"nuernberg-hafen-c213660",
"nuernberg-hafen-c227490",
"nuernberg-hafen-c252540",
"nuernberg-hafen-c252560",
"nuernberg-hafen-c252570",
"nuernberg-hafen-c252580",
"nuernberg-hafen-c252590",
"nuernberg-hafen-c252600",
"nuernberg-hafen-c252700",
"nuernberg-hafen-c252780",
"nuernberg-hafen-c281170",
"nuernberg-hafen-c281750",
"nuernberg-hafen-cc4810",
"nuernberg-hafen-cc4890",
"nuernberg-hafen-f381090",
"nuernberg-hafen-f381130",
"nuernberg-hafen-f38870",
"nuernberg-hafen-f39110",
"nuernberg-hafen-f39180",
"nuernberg-hafen-f395390",
"nuernberg-hafen-f395420",
"nuernberg-hafen-f395530",
"nuernberg-hafen-f395600",
"nuernberg-hafen-f403000",
"nuernberg-hafen-f412580",
"nuernberg-hafen-f412590",
"nuernberg-hafen-f463670",
"nuernberg-hafen-f531930",
"nuernberg-hafen-n05720",
"nuernberg-hafen-n05970",
"nuernberg-hafen-n146860",
"nuernberg-hafen-n146870",
"nuernberg-hafen-n146880",
"nuernberg-hafen-n146890",
"nuernberg-hafen-n146900",
"nuernberg-hafen-n146910",
"nuernberg-hafen-n146960",
"nuernberg-hafen-n147020",
"nuernberg-hafen-n147040",
"nuernberg-hafen-n147050",
"nuernberg-hafen-n147060",
"nuernberg-hafen-n147070",
"nuernberg-hafen-n147080",
"nuernberg-hafen-n147090",
"nuernberg-hafen-n147100",
"nuernberg-hafen-n147110",
"nuernberg-hafen-n147120",
"nuernberg-hafen-n246400",
"nuernberg-hafen-n249990",
"nuernberg-hafen-nn65110",
"nuernberg-hafen-nn75570",
"nuernberg-hafen-nuernberg-ost-f444350",
"nuernberg-hafenstrasse-f402970",
"nuernberg-hafenstrasse-f531940",
"nuernberg-hainstrasse-bb8100",
"nuernberg-hainstrasse-bb860",
"nuernberg-hainstrasse-bb870",
"nuernberg-hainstrasse-c135270",
"nuernberg-hainstrasse-c191900",
"nuernberg-hainstrasse-c19920",
"nuernberg-hainstrasse-c281080",
"nuernberg-hainstrasse-c282090",
"nuernberg-hainstrasse-c282120",
"nuernberg-hainstrasse-c282150",
"nuernberg-hainstrasse-c282220",
"nuernberg-hainstrasse-c282280",
"nuernberg-hainstrasse-c282290",
"nuernberg-hainstrasse-c282300",
"nuernberg-hainstrasse-c282310",
"nuernberg-hainstrasse-c282330",
"nuernberg-hainstrasse-c28960",
"nuernberg-hainstrasse-c28970",
"nuernberg-hainstrasse-c31780",
"nuernberg-hainstrasse-f384070",
"nuernberg-hainstrasse-f384190",
"nuernberg-hainstrasse-f405880",
"nuernberg-hainstrasse-f405900",
"nuernberg-hainstrasse-f405900",
"nuernberg-hainstrasse-f405940",
"nuernberg-hainstrasse-f426590",
"nuernberg-hainstrasse-f444680",
"nuernberg-hainstrasse-f444690",
"nuernberg-hainstrasse-f471010",
"nuernberg-hainstrasse-f471030",
"nuernberg-hainstrasse-n33310",
"nuernberg-hallenbad_ebensee-c225520",
"nuernberg-hallertorbruecke-c211840",
"nuernberg-hallertorbruecke-c211850",
"nuernberg-hallertorbruecke-f407600",
"nuernberg-hallerwiese-c241160",
"nuernberg-hallerwiese-cc18790",
"nuernberg-hallerwiese-f405490",
"nuernberg-hallerwiese-f464760",
"nuernberg-hallerwiese-f540240",
"nuernberg-hallerwiese-n263860",
"nuernberg-hallerwiese-n341960",
"nuernberg-hallplatz-c156200",
"nuernberg-hallplatz-c191690",
"nuernberg-hallplatz-c251210",
"nuernberg-hallplatz-f39970",
"nuernberg-hallplatz-n076100",
"nuernberg-handwerkerhof-c282380",
"nuernberg-handwerkerhof-n149510",
"nuernberg-handwerkerhof-n149520",
"nuernberg-handwerkerhof-n263450",
"nuernberg-hansastrasse-n363540",
"nuernberg-hans-bunte-strasse-f384430",
"nuernberg-hans-bunte-strasse-f406200",
"nuernberg-hans-bunte-strasse-f413430",
"nuernberg-hans-bunte-strasse-f413450",
"nuernberg-hans-bunte-strasse-n363230",
"nuernberg-hans-fallada-strasse-c187540",
"nuernberg-hans-fallada-strasse-c187550",
"nuernberg-hans-fallada-strasse-n068920",
"nuernberg-hans-fallada-strasse-n241080",
"nuernberg-hans-fallada-strasse-n24930",
"nuernberg-hans-sachs-gymnasium-c23980",
"nuernberg-hans-sachs-platz-c193640",
"nuernberg-hans-sachs-platz-c311550",
"nuernberg-hans-sachs-platz-c311570",
"nuernberg-harsdoerffer_platz-c564040",
"nuernberg-harsdoerffer_platz-c564050",
"nuernberg-harsdoerffer_platz-f444940",
"nuernberg-harsdoerfferplatz-n147950",
"nuernberg-hasenbuck-c111180",
"nuernberg-hasenbuck-f491620",
"nuernberg-hasenbuck-n294360",
"nuernberg-hasstrasse-n248030",
"nuernberg-hauptbahnhof_baustelle-c243850",
"nuernberg-hauptbahnhof_baustelle-c244110",
"nuernberg-hauptbahnhof_baustelle-c244140",
"nuernberg-hauptbahnhof_bei_nacht-c04260",
"nuernberg-hauptbahnhof_bei_nacht-c0430",
"nuernberg-hauptbahnhof_bei_nacht-c04620",
"nuernberg-hauptbahnhof_bei_nacht-c04720",
"nuernberg-hauptbahnhof_bei_nacht-f395670",
"nuernberg-hauptbahnhof_bei_nacht-f395880",
"nuernberg-hauptbahnhof-b182190",
"nuernberg-hauptbahnhof-bb8170",
"nuernberg-hauptbahnhof-bb87120",
"nuernberg-hauptbahnhof-bb87130",
"nuernberg-hauptbahnhof-bb87140",
"nuernberg-hauptbahnhof-c04710",
"nuernberg-hauptbahnhof-c055590",
"nuernberg-hauptbahnhof-c055630",
"nuernberg-hauptbahnhof-c057110",
"nuernberg-hauptbahnhof-c057140",
"nuernberg-hauptbahnhof-c134410",
"nuernberg-hauptbahnhof-c191730",
"nuernberg-hauptbahnhof-c191740",
"nuernberg-hauptbahnhof-c191750",
"nuernberg-hauptbahnhof-c191920",
"nuernberg-hauptbahnhof-c191950",
"nuernberg-hauptbahnhof-c192050",
"nuernberg-hauptbahnhof-c192310",
"nuernberg-hauptbahnhof-c192360",
"nuernberg-hauptbahnhof-c192370",
"nuernberg-hauptbahnhof-c195360",
"nuernberg-hauptbahnhof-c195400",
"nuernberg-hauptbahnhof-c195420",
"nuernberg-hauptbahnhof-c233380",
"nuernberg-hauptbahnhof-c233390",
"nuernberg-hauptbahnhof-c251040",
"nuernberg-hauptbahnhof-c251050",
"nuernberg-hauptbahnhof-c251150",
"nuernberg-hauptbahnhof-c25770",
"nuernberg-hauptbahnhof-c25840",
"nuernberg-hauptbahnhof-c25850",
"nuernberg-hauptbahnhof-c25870",
"nuernberg-hauptbahnhof-c25890",
"nuernberg-hauptbahnhof-c25930",
"nuernberg-hauptbahnhof-c25950",
"nuernberg-hauptbahnhof-c25980",
"nuernberg-hauptbahnhof-c25990",
"nuernberg-hauptbahnhof-c281300",
"nuernberg-hauptbahnhof-c281310",
"nuernberg-hauptbahnhof-c281570",
"nuernberg-hauptbahnhof-c281590",
"nuernberg-hauptbahnhof-c282710",
"nuernberg-hauptbahnhof-c282730",
"nuernberg-hauptbahnhof-c282750",
"nuernberg-hauptbahnhof-c282800",
"nuernberg-hauptbahnhof-ca85520",
"nuernberg-hauptbahnhof-cc18450",
"nuernberg-hauptbahnhof-f382620",
"nuernberg-hauptbahnhof-f382700",
"nuernberg-hauptbahnhof-f383300",
"nuernberg-hauptbahnhof-f384260",
"nuernberg-hauptbahnhof-f384280",
"nuernberg-hauptbahnhof-f38770",
"nuernberg-hauptbahnhof-f394860",
"nuernberg-hauptbahnhof-f394880",
"nuernberg-hauptbahnhof-f394900",
"nuernberg-hauptbahnhof-f394910",
"nuernberg-hauptbahnhof-f394980",
"nuernberg-hauptbahnhof-f395280",
"nuernberg-hauptbahnhof-f395910",
"nuernberg-hauptbahnhof-f395920",
"nuernberg-hauptbahnhof-f39600",
"nuernberg-hauptbahnhof-f396040",
"nuernberg-hauptbahnhof-f405200",
"nuernberg-hauptbahnhof-f405790",
"nuernberg-hauptbahnhof-f406080",
"nuernberg-hauptbahnhof-f406420",
"nuernberg-hauptbahnhof-f412380",
"nuernberg-hauptbahnhof-f445010",
"nuernberg-hauptbahnhof-f471660",
"nuernberg-hauptbahnhof-f490350",
"nuernberg-hauptbahnhof-f531690",
"nuernberg-hauptbahnhof-f531700",
"nuernberg-hauptbahnhof-f531710",
"nuernberg-hauptbahnhof-f531720",
"nuernberg-hauptbahnhof-f531750",
"nuernberg-hauptbahnhof-f531790",
"nuernberg-hauptbahnhof-f532610",
"nuernberg-hauptbahnhof-f532620",
"nuernberg-hauptbahnhof-n148030",
"nuernberg-hauptbahnhof-n148180",
"nuernberg-hauptbahnhof-n149480",
"nuernberg-hauptbahnhof-n149500",
"nuernberg-hauptbahnhof-n262770",
"nuernberg-hauptbahnhof-n263220",
"nuernberg-hauptbahnhof-n263230",
"nuernberg-hauptbahnhof-n263250",
"nuernberg-hauptbahnhof-n294200",
"nuernberg-hauptbahnhof-n294630",
"nuernberg-hauptbahnhof-nn65640",
"nuernberg-hauptbahnhof-nn77450",
"nuernberg-hauptbahnhof-nn81010",
"nuernberg-hauptbahnhof-nn81260",
"nuernberg-hauptmarkt__volleyball_-n274480",
"nuernberg-hauptmarkt__volleyball_-n274510",
"nuernberg-hauptmarkt__volleyball_-n274520",
"nuernberg-hauptmarkt__volleyball_-n274560",
"nuernberg-hauptmarkt__volleyball_-n274580",
"nuernberg-hauptmarkt__volleyball_-n274590",
"nuernberg-hauptmarkt__volleyball_-n274620",
"nuernberg-hauptmarkt__volleyball_-n274710",
"nuernberg-hauptmarkt_bei_nacht-c041390",
"nuernberg-hauptmarkt_bei_nacht-c04200",
"nuernberg-hauptmarkt_schoeneer_brunnen-n148490",
"nuernberg-hauptmarkt-c109010",
"nuernberg-hauptmarkt-c155000",
"nuernberg-hauptmarkt-c195780",
"nuernberg-hauptmarkt-c212160",
"nuernberg-hauptmarkt-cc17770",
"nuernberg-hauptmarkt-cc18560",
"nuernberg-hauptmarkt-cc24710",
"nuernberg-hauptmarkt-cc33240",
"nuernberg-hauptmarkt-cc42290",
"nuernberg-hauptmarkt-f382800",
"nuernberg-hauptmarkt-f445030",
"nuernberg-hauptmarkt-f455370",
"nuernberg-hauptmarkt-f471960",
"nuernberg-hauptmarkt-f484780",
"nuernberg-hauptmarkt-f531670",
"nuernberg-hauptmarkt-n055400",
"nuernberg-hauptmarkt-n263730",
"nuernberg-hauptmarkt-n294790",
"nuernberg-hauptmarkt-n294810",
"nuernberg-hauptmarkt-n294850",
"nuernberg-hauptmarkt-n294860",
"nuernberg-hauptmarkt-n29570",
"nuernberg-hauptmarkt-n342170",
"nuernberg-hauptmarkt-nn77280",
"nuernberg-hdi-b182610",
"nuernberg-hdi-cc17580",
"nuernberg-heideloffstrasse-n149410",
"nuernberg-heideloffstrasse-nn82010",
"nuernberg-heilig-geist-spital-c133570",
"nuernberg-heilig-geist-spital-c134160",
"nuernberg-heilig-geist-spital-cb8680",
"nuernberg-heilig-geist-spital-cc4620",
"nuernberg-heilig-geist-spital-cc4630",
"nuernberg-heilig-geist-spital-n148570",
"nuernberg-heilig-geist-spital-n148580",
"nuernberg-heimatministerium-c134130",
"nuernberg-heimerichstrasse-n261540",
"nuernberg-heissluftballon-c082560",
"nuernberg-heistersteg-c213490",
"nuernberg-heistersteg-c233410",
"nuernberg-heistersteg-c233430",
"nuernberg-heistersteg-c233530",
"nuernberg-heisterstrasse-c187680",
"nuernberg-heisterstrasse-c187690",
"nuernberg-heizkraftwerk_franken_1-f391470",
"nuernberg-heizkraftwerk_franken_1-f391490",
"nuernberg-heizkraftwerk_franken_1-f391510",
"nuernberg-heizkraftwerk_franken_1-f464280",
"nuernberg-heizkraftwerk_franken_1-f464350",
"nuernberg-heizkraftwerk_franken_1-f464350",
"nuernberg-heizkraftwerk_franken_1-f464520",
"nuernberg-heizkraftwerk_franken_1-f464540",
"nuernberg-heizkraftwerk_franken_i-f412500",
"nuernberg-heizkraftwerk_kesselbau-c108470",
"nuernberg-heizkraftwerk_kesselbau-c108510",
"nuernberg-heizkraftwerk_nuernberg_langwasser-f406520",
"nuernberg-heizkraftwerk_nuernberg_langwasser-f406530",
"nuernberg-heizkraftwerk_nuernberg_langwasser-f406560",
"nuernberg-heizkraftwerk_sandreuth-f381240",
"nuernberg-heizkraftwerk_sandreuth-f382760",
"nuernberg-heizkraftwerk_sandreuth-f391200",
"nuernberg-heizkraftwerk_sandreuth-f392100",
"nuernberg-heizkraftwerk_sandreuth-f406360",
"nuernberg-heizkraftwerk_sandreuth-f407330",
"nuernberg-heizkraftwerk_sandreuth-f412410",
"nuernberg-heizkraftwerk_sandreuth-f412670",
"nuernberg-heizkraftwerk_sandreuth-f412680",
"nuernberg-heizkraftwerk_sandreuth-f412700",
"nuernberg-heizkraftwerk_sandreuth-f413400",
"nuernberg-heizkraftwerk_sandreuth-f554850",
"nuernberg-heizkraftwerk_sandreuth-s562110",
"nuernberg-heizkraftwerk-c108560",
"nuernberg-heizkraftwerk-c11460",
"nuernberg-heizkraftwerk-c11520",
"nuernberg-heizkraftwerk-c11550",
"nuernberg-heizkraftwerk-c187970",
"nuernberg-heizkraftwerk-cc4250",
"nuernberg-heizkraftwerk-cc4660",
"nuernberg-heizkraftwerk-n075340",
"nuernberg-heizkraftwerk-n148990",
"nuernberg-heizwerk_maxfeld-f472240",
"nuernberg-heizwerk_maxfeld-f472260",
"nuernberg-henkersteg-f445090",
"nuernberg-henkersteg-n247000",
"nuernberg-herbartstrasse-nn76350",
"nuernberg-herbstlaub-c125330",
"nuernberg-herbstlaub-c125390",
"nuernberg-herbstmarkt-c282980",
"nuernberg-herbstmarkt-c283070",
"nuernberg-herbstvolkfest-s561960",
"nuernberg-herbstvolksfest-n33340",
"nuernberg-herbstvolksfest-n33350",
"nuernberg-herbstvolksfest-n33360",
"nuernberg-herbstvolksfest-n341580",
"nuernberg-herpersdorf-f490730",
"nuernberg-herpersdorf-f490740",
"nuernberg-herpersdorf-n051950",
"nuernberg-herpersdorf-n146420",
"nuernberg-herpersdorf-n146430",
"nuernberg-herpersdorf-n146450",
"nuernberg-herpersdorf-n146460",
"nuernberg-herpersdorf-n146520",
"nuernberg-herpersdorf-n242060",
"nuernberg-herrenhaus-c119320",
"nuernberg-herrenhaus-c119340",
"nuernberg-herrenhaus-c119360",
"nuernberg-herrenhaus-c119390",
"nuernberg-herrenhaus-c119400",
"nuernberg-herrenhaus-c119410",
"nuernberg-herrenhaus-c155850",
"nuernberg-herrenhaus-c155860",
"nuernberg-herrenhaus-c155870",
"nuernberg-herrenhaus-c155880",
"nuernberg-herrenhaus-c155920",
"nuernberg-herrenhaus-c155950",
"nuernberg-herrenhaus-c283230",
"nuernberg-herrenhaus-c283310",
"nuernberg-herrenhaus-n274990",
"nuernberg-herrenhaus-n275010",
"nuernberg-herrenschiesshaus-f490330",
"nuernberg-herrnhuette-f381850",
"nuernberg-herrnhuette-f382850",
"nuernberg-herrnhuette-f382860",
"nuernberg-herrnhuette-f382880",
"nuernberg-herrnhuette-f407010",
"nuernberg-herrnhuette-f531360",
"nuernberg-herrnhuette-n05440",
"nuernberg-herrnhuette-n261190",
"nuernberg-herrnhuette-n261200",
"nuernberg-herrnhuettestrasse-c119010",
"nuernberg-herrnhuettestrasse-c119020",
"nuernberg-herz-jesu-kirche-n294230",
"nuernberg-herzogstrasse-c105380",
"nuernberg-herzogstrasse-c207500",
"nuernberg-hesperidengaerten-c24820",
"nuernberg-hesperidengaerten-c24870",
"nuernberg-hesperidengaerten-cc42020",
"nuernberg-hesperidengaerten-n261520",
"nuernberg-himpfelshof-f39370",
"nuernberg-himpfelshof-f492520",
"nuernberg-himpfelshof-f492530",
"nuernberg-himpfelshof-f492540",
"nuernberg-hintere-markt-strasse-c28630",
"nuernberg-hinterhofstrasse-f412550",
"nuernberg-hinterm_bahnhof-c11220",
"nuernberg-hintermayrstrasse-c25490",
"nuernberg-hirsvogelstrasse_baustelle-c108050",
"nuernberg-hirsvogelstrasse-c133300",
"nuernberg-hirsvogelstrasse-c173030",
"nuernberg-hirsvogelstrasse-c173090",
"nuernberg-hirsvogelstrasse-c173160",
"nuernberg-hirsvogelstrasse-c194140",
"nuernberg-hirsvogelstrasse-c194150",
"nuernberg-hirsvogelstrasse-n055650",
"nuernberg-hirsvogelstrasse-n14100",
"nuernberg-hirsvogelstrasse-n14130",
"nuernberg-hirsvogelstrasse-n14150",
"nuernberg-hirsvogelstrasse-n14170",
"nuernberg-hirsvogelstrasse-n14190",
"nuernberg-hirsvogelstrasse-n14220",
"nuernberg-hirsvogelstrasse-n14230",
"nuernberg-hirsvogelstrasse-n1490",
"nuernberg-historischer_verein_fuer_mittelfranken-f492310",
"nuernberg-historischer_verein_fuer_mittelfranken-f492360",
"nuernberg-hockey_gesellschaft_nuernberg-f38570",
"nuernberg-hockey_gesellschaft_nuernberg-n05330",
"nuernberg-hockey-club_nuernberg__hgn_-n36210",
"nuernberg-hockey-club_nuernberg__hgn_-n36240",
"nuernberg-hockey-club_nuernberg__hgn_-n36260",
"nuernberg-hockey-club_nuernberg__hgn_-n36280",
"nuernberg-hockey-club_nuernberg__hgn_-n36310",
"nuernberg-hoefen-c254480",
"nuernberg-hoefen-c254490",
"nuernberg-hoefen-c254500",
"nuernberg-hoefen-c254520",
"nuernberg-hoefen-c254550",
"nuernberg-hoefen-c28520",
"nuernberg-hoefener_spange-c215240",
"nuernberg-hoefener_spange-c215250",
"nuernberg-hoefener_spange-c215290",
"nuernberg-hoefener_spange-c254560",
"nuernberg-hoefener_spange-f531210",
"nuernberg-hoefener_spange-f531230",
"nuernberg-hoefener_spange-f531240",
"nuernberg-hoefener_strasse-f411930",
"nuernberg-hoefles-c152110",
"nuernberg-hoefles-c152120",
"nuernberg-hoefles-cc54860",
"nuernberg-hoefles-f435380",
"nuernberg-hoefles-f435390",
"nuernberg-hoefles-f455950",
"nuernberg-hoefles-f541090",
"nuernberg-hoefles-f550160",
"nuernberg-hoefles-n06850",
"nuernberg-hoefles-n295660",
"nuernberg-hoefles-n515790",
"nuernberg-hoefles-n525510",
"nuernberg-hoefnener_spange-n295550",
"nuernberg-hoefnener_spange-n295560",
"nuernberg-hoefnener_spange-n295600",
"nuernberg-hoefner_spange-n530930",
"nuernberg-hoerberweg-c152230",
"nuernberg-hoerberweg-c152240",
"nuernberg-hoerberweg-c152290",
"nuernberg-hoerberweg-c152300",
"nuernberg-hoerberweg-c207240",
"nuernberg-hoerberweg-c207250",
"nuernberg-hoerberweg-c207260",
"nuernberg-hoerberweg-c207270",
"nuernberg-hoerberweg-c313300",
"nuernberg-hoerberweg-f38580",
"nuernberg-hohe_marter-f383190",
"nuernberg-holzgartenschule-c108660",
"nuernberg-holzgartenschule-c117570",
"nuernberg-holzgartenschule-f384230",
"nuernberg-holzgartenschule-n33300",
"nuernberg-holzheim-n273950",
"nuernberg-holzschuherstrasse-cb8200",
"nuernberg-holzwiesenstrasse-c283620",
"nuernberg-holzwiesenstrasse-c283630",
"nuernberg-horizont-f395250",
"nuernberg-hornbach-ca85190",
"nuernberg-horneckerweg-c132470",
"nuernberg-horneckerweg-c132580",
"nuernberg-hotel_an_der_meistersingerhalle-c111140",
"nuernberg-hotel_mercure-c154020",
"nuernberg-hotels-c192110",
"nuernberg-hubschrauber-c088990",
"nuernberg-hubschrauber-c231990",
"nuernberg-hubschrauber-c232020",
"nuernberg-hubschrauber-cd16690",
"nuernberg-hubschrauberlandeplatz_des_business_towers-f472050",
"nuernberg-hubschrauberlandeplatz-c281890",
"nuernberg-hubschrauberlandeplatz-f424760",
"nuernberg-huegelstrasse-f425850",
"nuernberg-hufelandstrasse-f411820",
"nuernberg-hufelandstrasse-f411830",
"nuernberg-hugo-distler-strasse-c119070",
"nuernberg-hugo-distler-strasse-c121290",
"nuernberg-hugo-distler-strasse-c152200",
"nuernberg-hugo-distler-strasse-c152210",
"nuernberg-hugo-distler-strasse-c152220",
"nuernberg-hugo-distler-strasse-cc43080",
"nuernberg-huldstrasse-c213070",
"nuernberg-hummelsteiner_schloss-c11740",
"nuernberg-hummelsteiner_schloss-c11760",
"nuernberg-hummelsteiner_schloss-c11770",
"nuernberg-hummelsteiner_schloss-c11830",
"nuernberg-hummelsteiner_schloss-c122250",
"nuernberg-hummelsteiner_schloss-c122260",
"nuernberg-hummelsteiner_schloss-c282450",
"nuernberg-hummelsteiner_schloss-c282460",
"nuernberg-hummelsteiner_schloss-c282540",
"nuernberg-hummelsteiner_schloss-c282590",
"nuernberg-hummelsteiner_schloss-c282630",
"nuernberg-hummelsteiner_schloss-c282650",
"nuernberg-hummelsteiner_schloss-c563640",
"nuernberg-hummelsteiner_schloss-f540700",
"nuernberg-hummelsteiner_schloss-f540720",
"nuernberg-hummelsteiner_schloss-f540730",
"nuernberg-hummelsteiner_schloss-f540740",
"nuernberg-hummelsteiner_schloss-n294420",
"nuernberg-hummelstein-f391750",
"nuernberg-hummelstein-n262980",
"nuernberg-ihk_akademie_schnepfenreuth-cc26530",
"nuernberg-ihk_waaggasse-c108750",
"nuernberg-ihk_waaggasse-c108900",
"nuernberg-ihk_waaggasse-c108930",
"nuernberg-ihk_waaggasse-c108980",
"nuernberg-ihk_waaggasse-c121760",
"nuernberg-ihk_waaggasse-c121790",
"nuernberg-ihk_waaggasse-c121810",
"nuernberg-ihk_waaggasse-c133940",
"nuernberg-ihk_waaggasse-c133960",
"nuernberg-ihk_waaggasse-c133970",
"nuernberg-ihk_waaggasse-c134020",
"nuernberg-ihk_waaggasse-c134040",
"nuernberg-ihk_waaggasse-c154880",
"nuernberg-ihk_waaggasse-c154890",
"nuernberg-ihk_waaggasse-c154940",
"nuernberg-ihk_waaggasse-c154960",
"nuernberg-ihk_waaggasse-c155020",
"nuernberg-ihk_waaggasse-c156400",
"nuernberg-ihk_waaggasse-c233320",
"nuernberg-ihk_waaggasse-c244200",
"nuernberg-ihk_waaggasse-c244240",
"nuernberg-ihk_waaggasse-c244330",
"nuernberg-ihk_waaggasse-c251400",
"nuernberg-ihk_waaggasse-c251440",
"nuernberg-ihk_waaggasse-c283010",
"nuernberg-ihk_waaggasse-c311480",
"nuernberg-ihk_waaggasse-c311500",
"nuernberg-ihk_waaggasse-c311520",
"nuernberg-ihk_waaggasse-c311580",
"nuernberg-ihk_waaggasse-n148510",
"nuernberg-ihk_waaggasse-n148550",
"nuernberg-ihk_waaggasse-n149550",
"nuernberg-ihk_waaggasse-n149600",
"nuernberg-ihk_waaggasse-n149670",
"nuernberg-ihk_waaggasse-n149700",
"nuernberg-ihk_waaggasse-n149720",
"nuernberg-ihk_waaggasse-n149740",
"nuernberg-ihk_waaggasse-n149750",
"nuernberg-ihk_waaggasse-n263620",
"nuernberg-ihk_waaggasse-n263630",
"nuernberg-ihk_waaggasse-n263680",
"nuernberg-ihk_waaggasse-n263710",
"nuernberg-ihk_waaggasse-n263780",
"nuernberg-ihk_waaggasse-n294910",
"nuernberg-ihk_waaggasse-n341980",
"nuernberg-ihk_waaggasse-n342130",
"nuernberg-ihk_waaggasse-n363970",
"nuernberg-ihk_waaggasse-n364000",
"nuernberg-ihk-f426160",
"nuernberg-ihk-f426180",
"nuernberg-im_posthof-c563650",
"nuernberg-im_tower-c10610",
"nuernberg-industrie_ipsheimerstrasse-cd18090",
"nuernberg-industriegebaeude__altbau_-f424220",
"nuernberg-industriegebiet_boxdorf-cc5270",
"nuernberg-industriegebiet_brunecker_strasse-c281060",
"nuernberg-industriegebiet_brunecker_strasse-c281220",
"nuernberg-industriegebiet_brunecker_strasse-c281510",
"nuernberg-industriegebiet_brunecker_strasse-c281520",
"nuernberg-industriegebiet_brunecker_strasse-c281530",
"nuernberg-industriegebiet_brunecker_strasse-c282440",
"nuernberg-industriegebiet_brunecker_strasse-c282570",
"nuernberg-industriegebiet_brunecker_strasse-c28990",
"nuernberg-industriegebiet_katzwanger_strasse-c056820",
"nuernberg-industriegebiet_katzwanger_strasse-n05660",
"nuernberg-industriegebiet_schmalau-nn64800",
"nuernberg-industriegebiet-c111450",
"nuernberg-ingolstaedter_strasse-n294350",
"nuernberg-ingolstaedter_strasse-n294370",
"nuernberg-innenstadt_nuernberg-f471930",
"nuernberg-innenstadt-ca85400",
"nuernberg-innenstadt-f484960",
"nuernberg-innenstadt-f492400",
"nuernberg-innenstadt-f492410",
"nuernberg-innenstadt-f492430",
"nuernberg-innenstadt-n149340",
"nuernberg-innere_laufer_gasse-f391030",
"nuernberg-innere-laufer-gasse-n29540",
"nuernberg-innerer_kleinreuther_weg-f407740",
"nuernberg-innerer_kleinreuther_weg-f407750",
"nuernberg-innerer-kleinreuther-weg-n362880",
"nuernberg-innerer-kleinreuther-weg-n362900",
"nuernberg-innerer-kleinreuther-weg-n362910",
"nuernberg-innerer-kleinreuther-weg-n362970",
"nuernberg-innerer-kleinreuther-weg-n362980",
"nuernberg-insel_schuett-c154590",
"nuernberg-insel_schuett-c154860",
"nuernberg-insel_schuett-c154870",
"nuernberg-insel_schuett-c191380",
"nuernberg-insel_schuett-c211920",
"nuernberg-insel_schuett-c211930",
"nuernberg-insel_schuett-cc17790",
"nuernberg-insel_schuett-cc18580",
"nuernberg-insel_schuett-cc31880",
"nuernberg-insel_schuett-cc32940",
"nuernberg-insel_schuett-cc54110",
"nuernberg-insel_schuett-f490340",
"nuernberg-insell_schuett-c563690",
"nuernberg-ipsheimer_strasse-c564380",
"nuernberg-ipsheimer_strasse-f384770",
"nuernberg-irgendwo_bei_roethenbach-c111470",
"nuernberg-jakobsplatz-c156260",
"nuernberg-jakobsplatz-f424210",
"nuernberg-jakobsplatz-f492480",
"nuernberg-jakobsplatz-f531810",
"nuernberg-jakobsplatz-n342440",
"nuernberg-jamnitzerplatz-f407340",
"nuernberg-jamnitzerplatz-f407350",
"nuernberg-jamnitzerplatz-f407360",
"nuernberg-jamnitzerplatz-f471430",
"nuernberg-jamnitzerplatz-s562150",
"nuernberg-jansenbruecke-f39750",
"nuernberg-jean-paul-platz-n076770",
"nuernberg-johanneskirche-f490850",
"nuernberg-johannes-scharrer-gymnasium-b181080",
"nuernberg-johannes-scharrer-gymnasium-b181090",
"nuernberg-johannes-scharrer-gymnasium-c242590",
"nuernberg-johannes-scharrer-gymnasium-c251510",
"nuernberg-johannes-scharrer-gymnasium-c282950",
"nuernberg-johannes-scharrer-gymnasium-c282970",
"nuernberg-johannes-scharrer-gymnasium-f471970",
"nuernberg-johannes-scharrer-gymnasium-f471970",
"nuernberg-johannis_friedhof-f411860",
"nuernberg-johannisfriedhof-c233170",
"nuernberg-johannisfriedhof-c24900",
"nuernberg-johannisfriedhof-cc31800",
"nuernberg-johannisfriedhof-cc42010",
"nuernberg-johannisfriedhof-f407420",
"nuernberg-johannisfriedhof-f455790",
"nuernberg-johannisfriedhof-f484840",
"nuernberg-johannisfriedhof-f492580",
"nuernberg-johannisfriedhof-f514210",
"nuernberg-johannisfriedhof-n054480",
"nuernberg-johannisfriedhof-nn77190",
"nuernberg-johannisstrasse-c123120",
"nuernberg-johannisstrasse-c173700",
"nuernberg-johannisstrasse-c173790",
"nuernberg-johannisstrasse-c173810",
"nuernberg-johann-pachelbell-schule-f384750",
"nuernberg-johann-pachelbel-realschule-n295510",
"nuernberg-johann-pachelbel-realschule-n295530",
"nuernberg-johann-pachelbel-realschule-n363710",
"nuernberg-johann-pachelbel-schule-f406270",
"nuernberg-josephsplatz-c213000",
"nuernberg-josephsplatz-c226540",
"nuernberg-josephsplatz-n247020",
"nuernberg-josephsplatz-n247060",
"nuernberg-josephsplatz-n247120",
"nuernberg-jugendherberge_kaiserburg-n012370",
"nuernberg-jugenherberge-f424200",
"nuernberg-julius-hirsch-sportzentrum-n264340",
"nuernberg-jura_firmengebaeude-n074710",
"nuernberg-justizpalast___baustelle_datev-c035250",
"nuernberg-justizpalast___jva-n053930",
"nuernberg-justizpalast___jva-n053980",
"nuernberg-justizpalast-c123270",
"nuernberg-justizpalast-c19640",
"nuernberg-justizpalast-cc51060",
"nuernberg-justizpalast-cc51220",
"nuernberg-justizpalast-f383950",
"nuernberg-justizpalast-f406210",
"nuernberg-justizpalast-f406220",
"nuernberg-justizpalast-f413550",
"nuernberg-justizpalast-f540960",
"nuernberg-justizpalast-f555040",
"nuernberg-justizpalast-n295630",
"nuernberg-justizpalast-n363410",
"nuernberg-justizpalast-n363500",
"nuernberg-justizpalast-n364600",
"nuernberg-justizpalast-nn66310",
"nuernberg-justizpalast-nn66320",
"nuernberg-justizpalast-nn74790",
"nuernberg-justizpalast-s562280",
"nuernberg-justizvollzugsanstalt-f394190",
"nuernberg-justizvollzugsanstalt-f396520",
"nuernberg-juvenellstrasse-f382340",
"nuernberg-juvenellstrasse-f492290",
"nuernberg-juvenellstrasse-n362680",
"nuernberg-kaeppelstrasse-f484550",
"nuernberg-kafkastrasse-c281960",
"nuernberg-kaiserburg_bei_nacht-c04190",
"nuernberg-kaiserburg_bei_nacht-c04440",
"nuernberg-kaiserburg_bei_nacht-c053820",
"nuernberg-kaiserburg_bei_nacht-c053860",
"nuernberg-kaiserburg_bei_nacht-c126260",
"nuernberg-kaiserburg_bei_nacht-f395090",
"nuernberg-kaiserburg_bei_nacht-f395100",
"nuernberg-kaiserburg_bei_nacht-f395140",
"nuernberg-kaiserburg_burghof-f412800",
"nuernberg-kaiserburg_im_herbst-n077100",
"nuernberg-kaiserburg_im_herbst-nn81360",
"nuernberg-kaiserburg_im_herbst-nn8720",
"nuernberg-kaiserburg_innenhof-c108810",
"nuernberg-kaiserburg_sinwellturm-f412800",
"nuernberg-kaiserburg-bb86640",
"nuernberg-kaiserburg-bb86690",
"nuernberg-kaiserburg-c038710",
"nuernberg-kaiserburg-c038720",
"nuernberg-kaiserburg-c041800",
"nuernberg-kaiserburg-c055450",
"nuernberg-kaiserburg-c082810",
"nuernberg-kaiserburg-c108830",
"nuernberg-kaiserburg-c119560",
"nuernberg-kaiserburg-c119570",
"nuernberg-kaiserburg-c119910",
"nuernberg-kaiserburg-c173240",
"nuernberg-kaiserburg-c187000",
"nuernberg-kaiserburg-c187020",
"nuernberg-kaiserburg-c187140",
"nuernberg-kaiserburg-c187340",
"nuernberg-kaiserburg-c191100",
"nuernberg-kaiserburg-c191120",
"nuernberg-kaiserburg-c193550",
"nuernberg-kaiserburg-c193570",
"nuernberg-kaiserburg-c193580",
"nuernberg-kaiserburg-c193950",
"nuernberg-kaiserburg-c196710",
"nuernberg-kaiserburg-c233010",
"nuernberg-kaiserburg-ca85760",
"nuernberg-kaiserburg-cc18060",
"nuernberg-kaiserburg-cc19110",
"nuernberg-kaiserburg-cc19140",
"nuernberg-kaiserburg-cc19170",
"nuernberg-kaiserburg-cc26270",
"nuernberg-kaiserburg-cc42050",
"nuernberg-kaiserburg-cc52890",
"nuernberg-kaiserburg-cc52970",
"nuernberg-kaiserburg-f382510",
"nuernberg-kaiserburg-f382520",
"nuernberg-kaiserburg-f382530",
"nuernberg-kaiserburg-f382550",
"nuernberg-kaiserburg-f391240",
"nuernberg-kaiserburg-f393510",
"nuernberg-kaiserburg-f393520",
"nuernberg-kaiserburg-f405460",
"nuernberg-kaiserburg-f407450",
"nuernberg-kaiserburg-f407460",
"nuernberg-kaiserburg-f407470",
"nuernberg-kaiserburg-f407530",
"nuernberg-kaiserburg-f407540",
"nuernberg-kaiserburg-f407640",
"nuernberg-kaiserburg-f407650",
"nuernberg-kaiserburg-f407670",
"nuernberg-kaiserburg-f407690",
"nuernberg-kaiserburg-f407700",
"nuernberg-kaiserburg-f412800",
"nuernberg-kaiserburg-f412820",
"nuernberg-kaiserburg-f412830",
"nuernberg-kaiserburg-f424200",
"nuernberg-kaiserburg-f464740",
"nuernberg-kaiserburg-f465020",
"nuernberg-kaiserburg-f47160",
"nuernberg-kaiserburg-f514170",
"nuernberg-kaiserburg-f531520",
"nuernberg-kaiserburg-f531530",
"nuernberg-kaiserburg-f531540",
"nuernberg-kaiserburg-f531630",
"nuernberg-kaiserburg-f531640",
"nuernberg-kaiserburg-n013000",
"nuernberg-kaiserburg-n06190",
"nuernberg-kaiserburg-n149620",
"nuernberg-kaiserburg-n33270",
"nuernberg-kaiserburg-n33530",
"nuernberg-kaiserburg-n342270",
"nuernberg-kaiserburg-n342280",
"nuernberg-kaiserburg-n342310",
"nuernberg-kaiserburg-n525280",
"nuernberg-kaiserburg-nn83090",
"nuernberg-kaiserstrasse-c134210",
"nuernberg-kaiserstrasse-c134220",
"nuernberg-kaiserstrasse-c134240",
"nuernberg-kaiserstrasse-n148890",
"nuernberg-karl-broeger-platz-c155190",
"nuernberg-karl-broeger-platz-n246600",
"nuernberg-karl-broeger-strasse-c191510",
"nuernberg-karl-broeger-strasse-c281980",
"nuernberg-karl-broeger-strasse-c282010",
"nuernberg-karl-broeger-strasse-c282040",
"nuernberg-karl-broeger-strasse-c282050",
"nuernberg-karl-broeger-tunnel-n246580",
"nuernberg-karl-grillenberger-strasse-cc24550",
"nuernberg-karl-grillenberger-strasse-cc33750",
"nuernberg-karl-martell-strasse-n14700",
"nuernberg-karlsbruecke-n069930",
"nuernberg-karl-schoenleben-park-c231790",
"nuernberg-karl-schoenleben-park-c231810",
"nuernberg-karl-schoenleben-park-c231910",
"nuernberg-karl-schoenleben-park-c232060",
"nuernberg-karl-schoenleben-park-c232080",
"nuernberg-karl-schoenleben-park-c242230",
"nuernberg-karl-schoenleben-strasse-b184370",
"nuernberg-karl-schoenleben-strasse-b184450",
"nuernberg-karl-schoenleben-strasse-c187570",
"nuernberg-karl-schoenleben-strasse-c207580",
"nuernberg-karl-schoenleben-strasse-c225910",
"nuernberg-karl-schoenleben-strasse-c225940",
"nuernberg-karl-schoenleben-strasse-c225980",
"nuernberg-karl-schoenleben-strasse-c281470",
"nuernberg-karl-schoenleben-strasse-c31180",
"nuernberg-karl-schoenleben-strasse-c31200",
"nuernberg-karl-schoenleben-strasse-c31220",
"nuernberg-karl-schoenleben-strasse-c31230",
"nuernberg-karl-schoenleben-strasse-c31270",
"nuernberg-karl-schoenleben-strasse-c31290",
"nuernberg-karl-schoenleben-strasse-f391890",
"nuernberg-karl-schoenleben-strasse-f391900",
"nuernberg-karl-schoenleben-strasse-n341370",
"nuernberg-karl-schoenleben-strasse-n341400",
"nuernberg-karl-schoenleben-strasse-n341440",
"nuernberg-karl-schoenleben-strasse-n341450",
"nuernberg-karl-schoenleben-strasse-n341500",
"nuernberg-karl-schoenleben-strasse-n36790",
"nuernberg-karl-schoenleben-strasse-n36820",
"nuernberg-karl-schoenleben-strasse-n36860",
"nuernberg-karl-schoenleben-strasse-n36890",
"nuernberg-karolinenstrasse-n149290",
"nuernberg-karolinenstrasse-n342080",
"nuernberg-karpfenweiher-c119110",
"nuernberg-katharinengasse-c226390",
"nuernberg-katharinengasse-n148600",
"nuernberg-katharinenkirche-n148620",
"nuernberg-katharinenruine-c133610",
"nuernberg-katharinenruine-c133650",
"nuernberg-katharinenruine-f426660",
"nuernberg-katharinenruine-n148080",
"nuernberg-katzwang-c213690",
"nuernberg-katzwang-c213700",
"nuernberg-katzwanger_strasse-b184230",
"nuernberg-katzwanger_strasse-c051610",
"nuernberg-katzwanger_strasse-c053550",
"nuernberg-katzwanger_strasse-c213410",
"nuernberg-katzwanger_strasse-c213430",
"nuernberg-katzwanger_strasse-f392020",
"nuernberg-katzwanger_strasse-f392030",
"nuernberg-katzwanger_strasse-f403650",
"nuernberg-katzwanger_strasse-f405750",
"nuernberg-katzwanger_strasse-f412140",
"nuernberg-katzwanger_strasse-f490440",
"nuernberg-katzwanger_strasse-f490450",
"nuernberg-katzwanger_strasse-f490460",
"nuernberg-katzwanger_strasse-f491740",
"nuernberg-katzwanger_strasse-f540830",
"nuernberg-katzwanger_strasse-f540850",
"nuernberg-katzwanger_strasse-f540860",
"nuernberg-katzwanger_strasse-n241550",
"nuernberg-katzwanger_strasse-n262810",
"nuernberg-katzwang-f47280",
"nuernberg-katzwang-f47290",
"nuernberg-katzwang-f47300",
"nuernberg-katzwang-f47360",
"nuernberg-katzwang-f47380",
"nuernberg-katzwang-n051850",
"nuernberg-katzwang-n146400",
"nuernberg-katzwang-n146410",
"nuernberg-kaufhof-bb8200",
"nuernberg-kaufland_dianaplatz-f540870",
"nuernberg-kesslerplatz-c192710",
"nuernberg-kesslerplatz-c192720",
"nuernberg-kesslerplatz-c243730",
"nuernberg-kesslerplatz-cc18610",
"nuernberg-kesslerplatz-n055660",
"nuernberg-kesslerplatz-n055670",
"nuernberg-kesslerplatz-n274780",
"nuernberg-kesslerplatz-n274790",
"nuernberg-kesslerplatz-n274800",
"nuernberg-kesslerplatz-n274810",
"nuernberg-kettelersiedlung-c226010",
"nuernberg-kettelersiedlung-c226040",
"nuernberg-kettelersiedlung-c226100",
"nuernberg-kettelersiedlung-c226110",
"nuernberg-kettelersiedlung-c226120",
"nuernberg-kettelersiedlung-c226130",
"nuernberg-kettelersiedlung-c226140",
"nuernberg-kettelersiedlung-n36760",
"nuernberg-kettensteg-f434070",
"nuernberg-kettnesteg-f445020",
"nuernberg-kgv_marienberg_west-c563960",
"nuernberg-kia_metropol_arena-f445310",
"nuernberg-kia-b18540",
"nuernberg-kia-b18550",
"nuernberg-kia-b18560",
"nuernberg-kieslingstrasse_-_nordostbahnhof-c313350",
"nuernberg-kieslingstrasse_-_nordostbahnhof-c313380",
"nuernberg-kieslingstrasse_-_nordostbahnhof-c313410",
"nuernberg-kieslingstrasse_-_nordostbahnhof-c313440",
"nuernberg-kieslingstrasse_baustelle-c121230",
"nuernberg-kieslingstrasse-b184670",
"nuernberg-kieslingstrasse-c156030",
"nuernberg-kieslingstrasse-c156090",
"nuernberg-kieslingstrasse-c173530",
"nuernberg-kieslingstrasse-c173540",
"nuernberg-kieslingstrasse-c173610",
"nuernberg-kieslingstrasse-c173620",
"nuernberg-kieslingstrasse-c173660",
"nuernberg-kieslingstrasse-c173670",
"nuernberg-kieslingstrasse-c207290",
"nuernberg-kieslingstrasse-c207300",
"nuernberg-kieslingstrasse-c211360",
"nuernberg-kieslingstrasse-c211380",
"nuernberg-kieslingstrasse-c211460",
"nuernberg-kieslingstrasse-c25280",
"nuernberg-kieslingstrasse-c25300",
"nuernberg-kieslingstrasse-c25340",
"nuernberg-kieslingstrasse-c25370",
"nuernberg-kieslingstrasse-c283330",
"nuernberg-kieslingstrasse-c505700",
"nuernberg-kieslingstrasse-c505750",
"nuernberg-kieslingstrasse-n145020",
"nuernberg-kieslingstrasse-n145060",
"nuernberg-kieslingstrasse-n247840",
"nuernberg-kieslingstrasse-n247880",
"nuernberg-kieslingstrasse-n247930",
"nuernberg-kieslingstrasse-n247970",
"nuernberg-kieslingstrasse-n261030",
"nuernberg-kieslingstrasse-n275020",
"nuernberg-kilian_1-c505850",
"nuernberg-kilian_1-c505870",
"nuernberg-kilian1-n540220",
"nuernberg-kilianstrasse-c152270",
"nuernberg-kilianstrasse-c152280",
"nuernberg-kilianstrasse-c193510",
"nuernberg-kilianstrasse-c208290",
"nuernberg-kilianstrasse-c563770",
"nuernberg-kilianstrasse-c563780",
"nuernberg-kilianstrasse-c563930",
"nuernberg-kilianstrasse-c563940",
"nuernberg-kilianstrasse-f382910",
"nuernberg-kilianstrasse-f382950",
"nuernberg-kilianstrasse-f393740",
"nuernberg-kilianstrasse-f407050",
"nuernberg-kilianstrasse-f407060",
"nuernberg-kilianstrasse-f411800",
"nuernberg-kilianstrasse-f434030",
"nuernberg-kilianstrasse-f434040",
"nuernberg-kilianstrasse-f472300",
"nuernberg-kilianstrasse-n149820",
"nuernberg-kilianstrasse-n149860",
"nuernberg-kilianstrasse-n26940",
"nuernberg-kilianstrasse-n26950",
"nuernberg-kilianstrasse-n30330",
"nuernberg-kilianstrasse-n303820",
"nuernberg-kilianstrasse-n362840",
"nuernberg-kinder-_und_jungendhaus_stapf-c283800",
"nuernberg-kinder-_und_jungendhaus_stapf-cd17960",
"nuernberg-kindergarten_fenitzerplatz-f472100",
"nuernberg-kindergarten_lerchenstrasse-f472320",
"nuernberg-kindergarten_lerchenstrasse-f472320",
"nuernberg-kinderhaus_tafelfeldtunnel-c155450",
"nuernberg-kindertageseinrichtung_hauchstrasse-f471060",
"nuernberg-kindertagesstaette_woelckernstrasse-c154150",
"nuernberg-kindertagesstaette_woelckernstrasse-c154170",
"nuernberg-kindertagesstaette_woelckernstrasse-c154190",
"nuernberg-kindertagesstaette_woelckernstrasse-c154210",
"nuernberg-kirche__die_jetzt_abgrissen_ist-f445090",
"nuernberg-kirche_allerheiligen-c10370",
"nuernberg-kirche_allerheiligen-c119290",
"nuernberg-kirche_allerheiligen-f492690",
"nuernberg-kirche_st__kunigund-b182770",
"nuernberg-kirche_st__martin-c132520",
"nuernberg-kirche_st__michael-c173800",
"nuernberg-kirche_st__thomas-c208520",
"nuernberg-kirche_verklaerung_christi-f540680",
"nuernberg-kirche-c207910",
"nuernberg-kirche-c207950",
"nuernberg-kirche-f39420",
"nuernberg-kirche-f405500",
"nuernberg-kirche-f411870",
"nuernberg-kirche-f412650",
"nuernberg-kirche-f424210",
"nuernberg-kirche-f4760",
"nuernberg-kirche-f4770",
"nuernberg-kirschbaumweg-c133170",
"nuernberg-klaeranlage_muggenhof-c215010",
"nuernberg-klaeranlage_nuernberg-c564440",
"nuernberg-klaeranlage-c251740",
"nuernberg-klaeranlage-f411920",
"nuernberg-klaeranlage-f425940",
"nuernberg-klaeranlage-f472490",
"nuernberg-klaeranlage-n011630",
"nuernberg-klaeranlage-n343040",
"nuernberg-klaerbecken-c082090",
"nuernberg-klaerbecken-c124740",
"nuernberg-klaerbecken-c136410",
"nuernberg-klaerwerk_1-f485060",
"nuernberg-klaerwerk_1-f485070",
"nuernberg-klaerwerk_1-f485070",
"nuernberg-klaerwerk_1-f485090",
"nuernberg-klaerwerk_1-n515750",
"nuernberg-klaerwerk_ii-f471230",
"nuernberg-klaerwerk-c068840",
"nuernberg-klaerwerk-cb99760",
"nuernberg-klaerwerk-cc54370",
"nuernberg-klaerwerk-f395800",
"nuernberg-klaerwerk-f396510",
"nuernberg-klaerwerk-f39820",
"nuernberg-klaerwerk-f540990",
"nuernberg-klarissenplatz-c211860",
"nuernberg-klarissenplatz-c211870",
"nuernberg-klarissenplatz-c211880",
"nuernberg-klarissenplatz-c251190",
"nuernberg-klarissenplatz-c251200",
"nuernberg-klarissenplatz-c25880",
"nuernberg-klarissenplatz-c25900",
"nuernberg-klarissenplatz-c25910",
"nuernberg-klarissenplatz-c25920",
"nuernberg-klarissenplatz-f540430",
"nuernberg-klarissenplatz-n263430",
"nuernberg-klarissenplatz-n263440",
"nuernberg-klassik_open_air__aufbau_-n052920",
"nuernberg-klassik_open_air-n052910",
"nuernberg-kleingartenanlage_am_marienbergpark-f434020",
"nuernberg-kleingartenanlage_ideal_e_v_-f39240",
"nuernberg-kleingartenanlage_raiffeisenstrasse-f435370",
"nuernberg-kleingartenanlage_stiller_winkel-f464250",
"nuernberg-kleingartenanlage-f391630",
"nuernberg-kleingartenanlage-f540080",
"nuernberg-kleingartenkolonie-c231570",
"nuernberg-kleingartenverein_nuernberg-nordwest-f541050",
"nuernberg-kleingruendlach-c116410",
"nuernberg-kleingruendlach-c151690",
"nuernberg-kleingruendlach-c151720",
"nuernberg-kleingruendlach-c22190",
"nuernberg-kleingruendlach-c22330",
"nuernberg-kleingruendlach-c254860",
"nuernberg-kleingruendlach-c254870",
"nuernberg-kleingruendlach-c564850",
"nuernberg-kleingruendlach-f456130",
"nuernberg-kleingruendlach-f494460",
"nuernberg-kleingruendlach-f530190",
"nuernberg-kleingruendlach-f541210",
"nuernberg-kleingruendlach-f550140",
"nuernberg-kleingruendlach-n30220",
"nuernberg-kleingruendlach-n550010",
"nuernberg-kleinreuth_bei_schweinau-f391330",
"nuernberg-kleinreuth_bei_schweinau-f391340",
"nuernberg-kleinreuth_bei_schweinau-f425830",
"nuernberg-kleinreuth_bei_schweinau-f425840",
"nuernberg-kleinreuth_bei_schweinau-f492110",
"nuernberg-kleinreuth_bei_schweinau-f492120",
"nuernberg-kleinreuth_bei_schweinau-f492210",
"nuernberg-kleinreuth_hinter_der_veste-c207140",
"nuernberg-kleinreuth_hinter_der_veste-c207150",
"nuernberg-kleinreuth_hinter_der_veste-c21780",
"nuernberg-kleinreuth_hinter_der_veste-f391130",
"nuernberg-kleinreuth_hinter_der_veste-f393750",
"nuernberg-kleinreuth_hinter_der_veste-f393760",
"nuernberg-kleinreuth_hinter_der_veste-f393770",
"nuernberg-kleinreuth_hinter_der_veste-f407070",
"nuernberg-kleinreuth_hinter_der_veste-f407080",
"nuernberg-kleinreuth_hinter_der_veste-f490270",
"nuernberg-kleinreuth_hinter_der_veste-f490280",
"nuernberg-kleinreuther_weg-c564170",
"nuernberg-kleinreuther_weg-f382960",
"nuernberg-kleinreuther_weg-n149790",
"nuernberg-kleinreuther_weg-n149800",
"nuernberg-kleinschwarzenlohe-c232200",
"nuernberg-kleinschwarzenlohe-c232240",
"nuernberg-kleinschwarzenlohe-c232250",
"nuernberg-kleinweidenmuehle-f484830",
"nuernberg-kleinweidenmuehle-f492570",
"nuernberg-kleinweidenmuehle-n341950",
"nuernberg-klingenhof-f463300",
"nuernberg-klinik_hallerwiese-cc33380",
"nuernberg-klinik_hallerwiese-cc54250",
"nuernberg-klinik_hallerwiese-n263820",
"nuernberg-klinik_hallerwiese-n263850",
"nuernberg-klinikum_fuerth-n530880",
"nuernberg-klinikum_nuernberg_nord-f39400",
"nuernberg-klinikum_nuernberg_nord-f411840",
"nuernberg-klinikum_nuernberg_nord-f455510",
"nuernberg-klinikum_nuernberg_nord-f455510",
"nuernberg-klinikum_nuernberg_nord-f530260",
"nuernberg-klinikum_nuernberg_nord-f532150",
"nuernberg-klinikum_nuernberg_nord-f553840",
"nuernberg-klinikum_nuernberg_nord-n530200",
"nuernberg-klinikum_nuernberg_sued-c505190",
"nuernberg-klinikum_nuernberg_sued-f444420",
"nuernberg-klinikum_nuernberg_sued-n515200",
"nuernberg-klinikum_nuernberg_sued-n515230",
"nuernberg-klinikum_nuernberg_sued-n515240",
"nuernberg-klinikum_nuernberg_sued-n515250",
"nuernberg-klinikum_nuernberg_sued-n515260",
"nuernberg-klinikum-nuernberg-nord-bb81120",
"nuernberg-klinikum-nuernberg-nord-c035910",
"nuernberg-klinikum-nuernberg-nord-c048540",
"nuernberg-klinikum-nuernberg-nord-c123040",
"nuernberg-klinikum-nuernberg-nord-c156490",
"nuernberg-klinikum-nuernberg-nord-c195300",
"nuernberg-klinikum-nuernberg-nord-c196770",
"nuernberg-klinikum-nuernberg-nord-c241090",
"nuernberg-klinikum-nuernberg-nord-c253690",
"nuernberg-klinikum-nuernberg-nord-cc32300",
"nuernberg-klinikum-nuernberg-nord-cc33860",
"nuernberg-klinikum-nuernberg-nord-cc33880",
"nuernberg-klinikum-nuernberg-nord-cc43430",
"nuernberg-klinikum-nuernberg-nord-cc43440",
"nuernberg-klinikum-nuernberg-nord-n013200",
"nuernberg-klinikum-nuernberg-nord-n013250",
"nuernberg-klinikum-nuernberg-nord-n054420",
"nuernberg-klinikum-nuernberg-nord-n14480",
"nuernberg-klinikum-nuernberg-nord-n14490",
"nuernberg-klinikum-nuernberg-nord-n14500",
"nuernberg-klinikum-nuernberg-nord-n14520",
"nuernberg-klinikum-nuernberg-nord-n33220",
"nuernberg-klinikum-nuernberg-sued-c047420",
"nuernberg-klinikum-nuernberg-sued-c109760",
"nuernberg-klinikum-nuernberg-sued-c11950",
"nuernberg-klinikum-nuernberg-sued-c124160",
"nuernberg-klinikum-nuernberg-sued-c153600",
"nuernberg-klinikum-nuernberg-sued-c153640",
"nuernberg-klinikum-nuernberg-sued-c153650",
"nuernberg-klinikum-nuernberg-sued-c187480",
"nuernberg-klinikum-nuernberg-sued-c281910",
"nuernberg-klinikum-nuernberg-sued-c31390",
"nuernberg-klinikum-nuernberg-sued-cc51820",
"nuernberg-klinikum-nuernberg-sued-n052120",
"nuernberg-klinikum-nuernberg-sued-n052190",
"nuernberg-klinikum-nuernberg-sued-n052230",
"nuernberg-klinikum-nuernberg-sued-n145620",
"nuernberg-klinikum-nuernberg-sued-n145630",
"nuernberg-klinikum-nuernberg-sued-n145810",
"nuernberg-klinikum-nuernberg-sued-n293540",
"nuernberg-kloesterle-n146480",
"nuernberg-kloesterle-n146490",
"nuernberg-kloesterle-n242080",
"nuernberg-knauerstrasse-cb8160",
"nuernberg-knoblauchsland-c227340",
"nuernberg-knoblauchsland-c244890",
"nuernberg-knoblauchsland-c253760",
"nuernberg-knoblauchsland-c253770",
"nuernberg-knoblauchsland-c254800",
"nuernberg-knoblauchsland-c505940",
"nuernberg-knoblauchsland-c563970",
"nuernberg-knoblauchsland-c564200",
"nuernberg-knoblauchsland-f393780",
"nuernberg-knoblauchsland-f393880",
"nuernberg-knoblauchsland-f393980",
"nuernberg-knoblauchsland-f393990",
"nuernberg-knoblauchsland-f472420",
"nuernberg-knoblauchsland-f494400",
"nuernberg-knoblauchsland-f510170",
"nuernberg-knoblauchsland-f531070",
"nuernberg-knoblauchsland-f531340",
"nuernberg-knoblauchsland-f554040",
"nuernberg-knoblauchsland-n243430",
"nuernberg-knoblauchsland-n245490",
"nuernberg-knoblauchsland-n364710",
"nuernberg-knoblauchsland-n530130",
"nuernberg-kobergerstrasse-f393280",
"nuernberg-kobergerstrasse-f39410",
"nuernberg-kobergerstrasse-f490310",
"nuernberg-koehnstrasse-cc17220",
"nuernberg-koehnstrasse-cc17600",
"nuernberg-koehnstrasse-n33290",
"nuernberg-koelner_strasse-c035900",
"nuernberg-koelner_strasse-f382330",
"nuernberg-koelner_strasse-f393240",
"nuernberg-koelner_strasse-n363020",
"nuernberg-koenigshof-f444250",
"nuernberg-koenigshof-n146150",
"nuernberg-koenigshof-n146590",
"nuernberg-koenigstorgraben-n263280",
"nuernberg-koenigstrasse-c311000",
"nuernberg-koenigstrasse-f39630",
"nuernberg-koenigstrasse-f39640",
"nuernberg-koenigstrasse-f484930",
"nuernberg-koenigstrasse-n148760",
"nuernberg-koenigstrasse-n149380",
"nuernberg-koenigstrasse-n263290",
"nuernberg-koenigstrasse-n263310",
"nuernberg-koenigstrasse-n263320",
"nuernberg-koenigstrasse-n263330",
"nuernberg-koenigstrasse-n263370",
"nuernberg-koenigstrasse-n263390",
"nuernberg-koepfleinsberg-f445090",
"nuernberg-kohlenhof-b181550",
"nuernberg-kohlenhof-b181560",
"nuernberg-kohlenhof-b181580",
"nuernberg-kohlenhof-b181690",
"nuernberg-kohlenhof-c122780",
"nuernberg-kohlenhof-c154540",
"nuernberg-kohlenhof-c154550",
"nuernberg-kohlenhof-c154560",
"nuernberg-kohlenhof-c154570",
"nuernberg-kohlenhof-c172950",
"nuernberg-kohlenhof-c251990",
"nuernberg-kohlenhof-c252010",
"nuernberg-kohlenhof-c252040",
"nuernberg-kohlenhof-c252050",
"nuernberg-kohlenhof-c252060",
"nuernberg-kohlenhof-c281600",
"nuernberg-kohlenhof-c281640",
"nuernberg-kohlenhof-c28790",
"nuernberg-kohlenhof-cb8420",
"nuernberg-kohlenhof-f425680",
"nuernberg-kohlenhof-n263260",
"nuernberg-kohlenhof-n263270",
"nuernberg-kohlenhof-n274380",
"nuernberg-kohlenhof-n274390",
"nuernberg-kohlenhof-n274410",
"nuernberg-kohlenhof-n295080",
"nuernberg-kompostieranlage-n30520",
"nuernberg-kompostwerk_fischbach-c281830",
"nuernberg-kompostwerk_fischbach-c281840",
"nuernberg-kompostwerk_fischbach-f484340",
"nuernberg-kompostwerk_fischbach-f484350",
"nuernberg-kongresshalle___dutzendteich-f391790",
"nuernberg-kongresshalle___dutzendteich-f391950",
"nuernberg-kongresshalle_im_winter-cc41360",
"nuernberg-kongresshalle-c047560",
"nuernberg-kongresshalle-c124410",
"nuernberg-kongresshalle-c191800",
"nuernberg-kongresshalle-c191830",
"nuernberg-kongresshalle-c232770",
"nuernberg-kongresshalle-c232780",
"nuernberg-kongresshalle-c281500",
"nuernberg-kongresshalle-c28980",
"nuernberg-kongresshalle-c505410",
"nuernberg-kongresshalle-cc24610",
"nuernberg-kongresshalle-cc41100",
"nuernberg-kongresshalle-f391960",
"nuernberg-kongresshalle-f405960",
"nuernberg-kongresshalle-f406750",
"nuernberg-kongresshalle-f412170",
"nuernberg-kongresshalle-f412250",
"nuernberg-kongresshalle-f412290",
"nuernberg-kongresshalle-f412300",
"nuernberg-kongresshalle-f425030",
"nuernberg-kongresshalle-f502490",
"nuernberg-kongresshalle-f514000",
"nuernberg-kongresshalle-f514030",
"nuernberg-kongresshalle-f514040",
"nuernberg-kongresshalle-f514080",
"nuernberg-konrad-gross-schule-f393650",
"nuernberg-konrad-gross-schule-f405140",
"nuernberg-konrad-gross-schule-n261610",
"nuernberg-kontrollturm_am_flughafen-c105080",
"nuernberg-kontumazgarten-c156460",
"nuernberg-kontumazgarten-cc43870",
"nuernberg-kontumazgarten-n263870",
"nuernberg-kontumazgarten-n263880",
"nuernberg-kontumazgarten-n263890",
"nuernberg-kontumazgarten-n263910",
"nuernberg-kopernikusschule-n262990",
"nuernberg-koperstrasse-f403590",
"nuernberg-koppenhof-n246110",
"nuernberg-koppenhof-n246220",
"nuernberg-koppenhof-n246270",
"nuernberg-kornburg-c232300",
"nuernberg-kornburg-c232310",
"nuernberg-kornburg-c232330",
"nuernberg-kornburg-c232340",
"nuernberg-kornburg-c232350",
"nuernberg-kornburg-c232360",
"nuernberg-kornburg-c232410",
"nuernberg-kornburg-c232420",
"nuernberg-kornburg-c232430",
"nuernberg-kornburg-c232460",
"nuernberg-kornburg-c232480",
"nuernberg-kornburg-c232500",
"nuernberg-kornburg-c232530",
"nuernberg-kornburg-c232540",
"nuernberg-kornburg-c232560",
"nuernberg-kornburg-c232570",
"nuernberg-kornburger_schloss-c232440",
"nuernberg-kornburg-f425300",
"nuernberg-kornburg-f425350",
"nuernberg-kornburg-f425400",
"nuernberg-kornburg-f425460",
"nuernberg-kornburg-f425490",
"nuernberg-kornburg-f490660",
"nuernberg-kornburg-f490690",
"nuernberg-kornburg-n051240",
"nuernberg-kornburg-n293130",
"nuernberg-kornburg-n29810",
"nuernberg-kornburg-n29830",
"nuernberg-kornfeld_im_knoblauchsland-n3260",
"nuernberg-kornmarkt-cb8100",
"nuernberg-kornmarkt-cc18270",
"nuernberg-kraftshof-b18380",
"nuernberg-kraftshof-b18420",
"nuernberg-kraftshof-b18430",
"nuernberg-kraftshof-c199710",
"nuernberg-kraftshof-c208510",
"nuernberg-kraftshof-c23270",
"nuernberg-kraftshof-c23280",
"nuernberg-kraftshof-cc34130",
"nuernberg-kraftshof-f426840",
"nuernberg-kraftshof-f426870",
"nuernberg-kraftshof-f490220",
"nuernberg-kraftshof-n144240",
"nuernberg-kraftshof-n29140",
"nuernberg-kraftshof-n3290",
"nuernberg-kraftwerk_franken_1-f391420",
"nuernberg-kraftwerk_gebersdorf-cc51540",
"nuernberg-kraftwerk_gebersdorf-n028160",
"nuernberg-kraftwerk_gebersdorf-n274290",
"nuernberg-kraftwerk_gebersdorf-nn66040",
"nuernberg-kraftwerk_sandreuth-n147490",
"nuernberg-kraftwerk-c188180",
"nuernberg-kreisverkehr-c213820",
"nuernberg-kreisverkehr-c213830",
"nuernberg-kreisverkehr-nn75330",
"nuernberg-krematorium-n530380",
"nuernberg-kreulstrasse-c038960",
"nuernberg-kreuz_nuernberg_hafen-f434660",
"nuernberg-kreuz_nuernberg_hafen-f434680",
"nuernberg-kreuz_nuernberg-hafen-f381190",
"nuernberg-kreuz_nuernberg-hafen-f403010",
"nuernberg-kreuz_nuernberg-hafen-f403530",
"nuernberg-kreuzburger_strasse-c281950",
"nuernberg-kreuzgassenviertel-cc17740",
"nuernberg-kreuzgassenviertel-f382590",
"nuernberg-kreuzgassenviertel-f383860",
"nuernberg-kreuzkirche-c19470",
"nuernberg-kreuzkirche-n069170",
"nuernberg-kreuzkirche-n295240",
"nuernberg-kreuzung_fraeberstrasse-f492440",
"nuernberg-kriegsopfersiedlung-f383020",
"nuernberg-kriegsopfersiedlung-f383050",
"nuernberg-kriegsopfersiedlung-f393150",
"nuernberg-kriegsopfersiedlung-f393170",
"nuernberg-kriegsopfersiedlung-f541030",
"nuernberg-kriegsopfersiedlung-n515770",
"nuernberg-kriegsopfersiedlung-n515780",
"nuernberg-kriegsopfersiedlung-n525490",
"nuernberg-krottenbach-n273960",
"nuernberg-krottenbach-n273970",
"nuernberg-krottenbach-n273980",
"nuernberg-kuehne___nagel_hafen-c153330",
"nuernberg-kunstbrunnen_am_aufsessplatz-n342210",
"nuernberg-kunstbrunnen_am_aufsessplatz-n342250",
"nuernberg-lager-n145760",
"nuernberg-lahmannstrasse-c119790",
"nuernberg-landeanflug-c125450",
"nuernberg-landeanflug-c125520",
"nuernberg-landeanflug-c564740",
"nuernberg-landeanflug-c564760",
"nuernberg-landeanflug-f407960",
"nuernberg-landeanflug-f407970",
"nuernberg-landeanflug-n33770",
"nuernberg-landebahn-n056210",
"nuernberg-landesamt_fuer_steuern-c563740",
"nuernberg-landgrabenstrasse-c122050",
"nuernberg-landgrabenstrasse-c122090",
"nuernberg-landgrabenstrasse-c122160",
"nuernberg-landgrabenstrasse-c122190",
"nuernberg-landgrabenstrasse-f405250",
"nuernberg-landgrabenstrasse-f405280",
"nuernberg-landgrabenstrasse-f531740",
"nuernberg-landschaft-c151880",
"nuernberg-landschaft-c151890",
"nuernberg-landschaft-c208560",
"nuernberg-landschaft-nn78530",
"nuernberg-landung_2-f464230",
"nuernberg-landwirtschaft_knoblauchsland-f393890",
"nuernberg-landwirtschaft_knoblauchsland-f393900",
"nuernberg-lange_strasse-n343060",
"nuernberg-langseestrasse-n262490",
"nuernberg-langseestrasse-n262500",
"nuernberg-langwasser_nord-f491350",
"nuernberg-langwasser_prinovis-c053260",
"nuernberg-langwasser_prinovis-c053380",
"nuernberg-langwasserbad_neubau-c109620",
"nuernberg-langwasserbad_neubau-c109650",
"nuernberg-langwasserbad_neubau-c109740",
"nuernberg-langwasserbad_neubau-c109840",
"nuernberg-langwasserbad_und_eichquartier-c505180",
"nuernberg-langwasserbad-c111000",
"nuernberg-langwasserbad-c11900",
"nuernberg-langwasserbad-c11980",
"nuernberg-langwasserbad-c11990",
"nuernberg-langwasserbad-c124250",
"nuernberg-langwasserbad-c124270",
"nuernberg-langwasserbad-c153510",
"nuernberg-langwasserbad-c153520",
"nuernberg-langwasserbad-c153540",
"nuernberg-langwasserbad-c153580",
"nuernberg-langwasserbad-c153590",
"nuernberg-langwasserbad-c187430",
"nuernberg-langwasserbad-c31410",
"nuernberg-langwasserbad-c31460",
"nuernberg-langwasserbad-c31510",
"nuernberg-langwasserbad-c31590",
"nuernberg-langwasserbad-f424870",
"nuernberg-langwasserbad-f424920",
"nuernberg-langwasserbad-n145650",
"nuernberg-langwasserbad-n145680",
"nuernberg-langwasserbad-n145690",
"nuernberg-langwasserbad-n145800",
"nuernberg-langwasserbad-n145840",
"nuernberg-langwasserbad-n36830",
"nuernberg-langwasser-c053240",
"nuernberg-langwasser-c207630",
"nuernberg-langwasser-c207640",
"nuernberg-langwasser-c207660",
"nuernberg-langwasser-c207670",
"nuernberg-langwasser-c207680",
"nuernberg-langwasser-c207690",
"nuernberg-langwasser-c207710",
"nuernberg-langwasser-c225950",
"nuernberg-langwasser-c31440",
"nuernberg-langwasser-c31470",
"nuernberg-langwasser-c31500",
"nuernberg-langwasser-c31540",
"nuernberg-langwasser-c505140",
"nuernberg-langwasser-c505150",
"nuernberg-langwasser-c505200",
"nuernberg-langwasser-f38890",
"nuernberg-langwasser-f406620",
"nuernberg-langwasser-f406670",
"nuernberg-langwasser-f444030",
"nuernberg-langwasser-f444040",
"nuernberg-langwasser-f444400",
"nuernberg-langwasser-f444430",
"nuernberg-langwasser-f444460",
"nuernberg-langwasser-f491420",
"nuernberg-langwasser-f491430",
"nuernberg-langwasser-f491440",
"nuernberg-langwasser-f513880",
"nuernberg-langwasser-n145640",
"nuernberg-langwasser-n145750",
"nuernberg-langwasser-n145850",
"nuernberg-langwasser-n145860",
"nuernberg-langwasser-n145870",
"nuernberg-langwasser-n145880",
"nuernberg-langwasser-n145890",
"nuernberg-langwasser-n145900",
"nuernberg-langwasser-n145910",
"nuernberg-langwasser-n145920",
"nuernberg-langwasser-n145930",
"nuernberg-langwasser-n145940",
"nuernberg-langwasser-n145950",
"nuernberg-langwasser-n145960",
"nuernberg-langwasser-n145970",
"nuernberg-langwasser-n145980",
"nuernberg-langwasser-n145990",
"nuernberg-langwasser-n146000",
"nuernberg-langwasser-n146010",
"nuernberg-langwasser-n146020",
"nuernberg-langwasser-n146030",
"nuernberg-langwasser-n146040",
"nuernberg-langwasser-n146050",
"nuernberg-langwasser-n146060",
"nuernberg-langwasser-n146070",
"nuernberg-langwasser-n146080",
"nuernberg-langwasser-n146090",
"nuernberg-langwasser-n146100",
"nuernberg-langwasser-n146110",
"nuernberg-langwasser-n293580",
"nuernberg-langwasser-n293620",
"nuernberg-langwasser-n361220",
"nuernberg-langwasser-n36660",
"nuernberg-langwasser-n36690",
"nuernberg-langwasser-n36710",
"nuernberg-langwasser-n36730",
"nuernberg-langwasser-n36910",
"nuernberg-laufamholz-c132900",
"nuernberg-laufamholz-c211290",
"nuernberg-laufamholz-c211300",
"nuernberg-laufamholz-c211320",
"nuernberg-laufamholz-c226780",
"nuernberg-laufamholz-c243100",
"nuernberg-laufamholz-c253370",
"nuernberg-laufamholz-c253380",
"nuernberg-laufamholz-f464640",
"nuernberg-laufamholz-f522590",
"nuernberg-laufamholz-n520430",
"nuernberg-laufamholz-n520440",
"nuernberg-laufamholz-n520450",
"nuernberg-laufamholzstrasse-n145140",
"nuernberg-laufer_gasse-cc33470",
"nuernberg-laufer_schlagturm-c121510",
"nuernberg-laufer_schlagturm-c134000",
"nuernberg-laufer_schlagturm-cc54180",
"nuernberg-laufer_schlagturm-cc54220",
"nuernberg-laufer_schlagturm-f490320",
"nuernberg-laufer_schlagturm-f490320",
"nuernberg-laufer_tor-c173220",
"nuernberg-laufer_tor-c193670",
"nuernberg-laufer_torturm_am_rathenauplatz-n076940",
"nuernberg-laufer_torturm-c121490",
"nuernberg-laufer_torturm-c505600",
"nuernberg-laufer_torturm-c563790",
"nuernberg-laufer_torturm-c563800",
"nuernberg-laufer_torturm-c564110",
"nuernberg-laufer_torturm-n530640",
"nuernberg-laufertorgraben-c232910",
"nuernberg-laufertorgraben-f405420",
"nuernberg-laufertorgraben-f405430",
"nuernberg-laufertorgraben-n33480",
"nuernberg-laufertorgraben-n33540",
"nuernberg-lechstrasse-f39120",
"nuernberg-leerstand-b183480",
"nuernberg-leipziger_platz_bei_nacht-c042000",
"nuernberg-leipziger_platz-c041960",
"nuernberg-leipziger_platz-c068520",
"nuernberg-leipziger_platz-c081910",
"nuernberg-leipziger_platz-c107690",
"nuernberg-leipziger_platz-c119260",
"nuernberg-leipziger_platz-c119280",
"nuernberg-leipziger_platz-c121240",
"nuernberg-leipziger_platz-c207280",
"nuernberg-leipziger_platz-c25390",
"nuernberg-leipziger_platz-c25420",
"nuernberg-leipziger_platz-f393600",
"nuernberg-leipziger_platz-f393640",
"nuernberg-leipziger_platz-f394660",
"nuernberg-leipziger_platz-f406960",
"nuernberg-leipziger_platz-f406990",
"nuernberg-leipziger_platz-n145040",
"nuernberg-leipziger_platz-nn77630",
"nuernberg-leipziger_platz-nn77650",
"nuernberg-leipziger_platz-nn77690",
"nuernberg-leonhardspark-f471720",
"nuernberg-leopoldstrasse-cd17830",
"nuernberg-leopoldstrasse-cd17930",
"nuernberg-leopoldstrasse-cd18000",
"nuernberg-leopoldstrasse-cd18020",
"nuernberg-lerchenstrasse-f472310",
"nuernberg-lessingstrasse-b182300",
"nuernberg-lessingstrasse-b182340",
"nuernberg-lessingstrasse-b182350",
"nuernberg-lessingstrasse-b182440",
"nuernberg-lessingstrasse-b182460",
"nuernberg-lessingstrasse-b182470",
"nuernberg-lessingstrasse-c155200",
"nuernberg-lessingstrasse-c155260",
"nuernberg-lessingstrasse-c155330",
"nuernberg-lessingstrasse-c172820",
"nuernberg-lessingstrasse-n148290",
"nuernberg-lessingstrasse-n148340",
"nuernberg-lessingstrasse-n148410",
"nuernberg-lessingstrasse-n148420",
"nuernberg-leyh-c215220",
"nuernberg-leyh-c233550",
"nuernberg-leyh-c233570",
"nuernberg-leyh-c233580",
"nuernberg-leyh-c564410",
"nuernberg-leyh-cc17360",
"nuernberg-leyher_strasse-c136830",
"nuernberg-leyher_strasse-c245380",
"nuernberg-leyher_strasse-f493600",
"nuernberg-leyher_strasse-n264110",
"nuernberg-leyher_strasse-n264120",
"nuernberg-leyher_strasse-n264130",
"nuernberg-leyher_strasse-n264140",
"nuernberg-leyher_strasse-n264150",
"nuernberg-leyher_strasse-n264160",
"nuernberg-leyh-f384470",
"nuernberg-leyh-f392320",
"nuernberg-leyh-f425730",
"nuernberg-leyh-f554400",
"nuernberg-leyh-n264170",
"nuernberg-leyh-n264180",
"nuernberg-leyh-n264190",
"nuernberg-leyh-n264200",
"nuernberg-lichtenreuth-c563610",
"nuernberg-lichtenreuth-c563620",
"nuernberg-lichtenreuth-f540580",
"nuernberg-lichtenreuth-f540590",
"nuernberg-lichtenreuth-f540600",
"nuernberg-lichtenreuth-f540610",
"nuernberg-lichtenreuth-f540620",
"nuernberg-lichtenreuth-f540650",
"nuernberg-lichtenreuth-f540760",
"nuernberg-lichtenreuth-f540770",
"nuernberg-lichtenreuth-f540780",
"nuernberg-lichtenreuth-f540790",
"nuernberg-lichtenreuth-f540810",
"nuernberg-lichtenreuth-s561970",
"nuernberg-lichtenreuth-s561980",
"nuernberg-lichtenreuth-s561990",
"nuernberg-lichtenreuth-s562000",
"nuernberg-lichtenreuth-s562010",
"nuernberg-lichtenreuth-s562020",
"nuernberg-lichtenreuth-s562030",
"nuernberg-lichtenreuth-s562040",
"nuernberg-liebesinsel-cc4550",
"nuernberg-liebesinsel-f426160",
"nuernberg-lina-ammon-strasse-c109500",
"nuernberg-lina-ammon-strasse-c109520",
"nuernberg-lina-ammon-strasse-c111030",
"nuernberg-lina-ammon-strasse-c111050",
"nuernberg-lina-ammon-strasse-nn66720",
"nuernberg-lkw-n145320",
"nuernberg-lochnerstrasse-f39300",
"nuernberg-lochnerstrasse-n295250",
"nuernberg-loebleinstrasse-f493150",
"nuernberg-loebleinstrasse-n14400",
"nuernberg-loehe_schule-cc19190",
"nuernberg-loewensaal-cc18910",
"nuernberg-logistikzentrale_dpd-f531960",
"nuernberg-logistikzentrale_dpd-f531970",
"nuernberg-logistikzentrale_dpd-f531980",
"nuernberg-logistikzentrale_dpd-f532000",
"nuernberg-logistikzentrale_dpd-f532010",
"nuernberg-logistikzentrale_ups-f532050",
"nuernberg-lohe_almoshof-n144360",
"nuernberg-lohe-b185100",
"nuernberg-lohe-c207100",
"nuernberg-lohe-c207120",
"nuernberg-lohe-c24170",
"nuernberg-lohe-c244550",
"nuernberg-lohe-f381940",
"nuernberg-lohe-f382030",
"nuernberg-lohe-f382040",
"nuernberg-lohe-f391110",
"nuernberg-lohe-f407850",
"nuernberg-lohe-f502540",
"nuernberg-lohe-f510160",
"nuernberg-lohe-n144350",
"nuernberg-lohe-n29190",
"nuernberg-lohe-n29200",
"nuernberg-lohe-n29210",
"nuernberg-lohe-n29220",
"nuernberg-lohe-n29230",
"nuernberg-lohe-n30300",
"nuernberg-lohhof-n274000",
"nuernberg-lokschuppen-c111280",
"nuernberg-lokschuppen-c11570",
"nuernberg-lorenzer_platz-c133620",
"nuernberg-lorenzer_platz-c192240",
"nuernberg-lorenzer_platz-nn65910",
"nuernberg-lorenzkirche_bei_nacht-c04160",
"nuernberg-lorenzkirche-c04140",
"nuernberg-lorenzkirche-c055190",
"nuernberg-lorenzkirche-c055270",
"nuernberg-lorenzkirche-c109060",
"nuernberg-lorenzkirche-c134140",
"nuernberg-lorenzkirche-c195790",
"nuernberg-lorenzkirche-c195800",
"nuernberg-lorenzkirche-c195960",
"nuernberg-lorenzkirche-c195990",
"nuernberg-lorenzkirche-c196030",
"nuernberg-lorenzkirche-c196060",
"nuernberg-lorenzkirche-c196100",
"nuernberg-lorenzkirche-c251230",
"nuernberg-lorenzkirche-cb860",
"nuernberg-lorenzkirche-cb99420",
"nuernberg-lorenzkirche-cc42210",
"nuernberg-lorenzkirche-cc42530",
"nuernberg-lorenzkirche-cc52740",
"nuernberg-lorenzkirche-cc52790",
"nuernberg-lorenzkirche-f391020",
"nuernberg-lorenzkirche-f39980",
"nuernberg-lorenzkirche-f39990",
"nuernberg-lorenzkirche-f405440",
"nuernberg-lorenzkirche-f412860",
"nuernberg-lorenzkirche-f412880",
"nuernberg-lorenzkirche-f412890",
"nuernberg-lorenzkirche-f532750",
"nuernberg-lorenzkirche-f532760",
"nuernberg-lorenzkirche-f540260",
"nuernberg-lorenzkirche-f540270",
"nuernberg-lorenzkirche-n055190",
"nuernberg-lorenzkirche-n148060",
"nuernberg-lorenzkirche-n29590",
"nuernberg-lorenzkirche-n33440",
"nuernberg-lorenzkirche-nn77520",
"nuernberg-lucent___alcatel-c052430",
"nuernberg-lucent___alcatel-c193230",
"nuernberg-lucent___alcatel-c193270",
"nuernberg-ludwig-donau-main-kanal-f484290",
"nuernberg-ludwig-donau-main-kanal-f484290",
"nuernberg-ludwig-erhard-bruecke-f39490",
"nuernberg-ludwig-erhard-bruecke-f484560",
"nuernberg-ludwig-erhard-bruecke-n362130",
"nuernberg-ludwig-feuerbach-strasse-c3160",
"nuernberg-ludwig-scholz-bruecke-f391560",
"nuernberg-ludwig-scholz-bruecke-f491930",
"nuernberg-ludwigsplatz-f426740",
"nuernberg-ludwigsplatz-f471910",
"nuernberg-ludwigsplatz-f471920",
"nuernberg-ludwigstor-c109070",
"nuernberg-ludwigstor-c11330",
"nuernberg-ludwigstor-c226490",
"nuernberg-ludwigstrasse-n148470",
"nuernberg-ludwig-uhland-grundschule-f393270",
"nuernberg-ludwig-uhland-grundschule-f490300",
"nuernberg-ludwig-uhland-schule-c119710",
"nuernberg-ludwig-uhland-schule-c564150",
"nuernberg-luitpoldhain-c111120",
"nuernberg-luitpoldhain-c111130",
"nuernberg-luitpoldhain-c153860",
"nuernberg-luitpoldhain-f391800",
"nuernberg-luitpoldhain-f514090",
"nuernberg-luitpoldhain-n076700",
"nuernberg-luitpoldhain-n293800",
"nuernberg-luitpoldpark-f384160",
"nuernberg-luitpoldviertel-c505450",
"nuernberg-luitpoldviertel-c505470",
"nuernberg-luitpoldviertel-c505480",
"nuernberg-luitpoldviertel-f406790",
"nuernberg-luitpoldviertel-f471780",
"nuernberg-luitpoldviertel-f471790",
"nuernberg-luitpoldviertel-f471810",
"nuernberg-luitpoldviertel-f471820",
"nuernberg-luitpoldviertel-f471830",
"nuernberg-luitpoldviertel-f471840",
"nuernberg-luitpoldviertel-f540340",
"nuernberg-luitpoldviertel-f540350",
"nuernberg-luitpoldviertel-f554590",
"nuernberg-luitpoldviertel-n515280",
"nuernberg-luitpoldviertel-n515290",
"nuernberg-luitpolhain-c035980",
"nuernberg-lux_-_junge_kirche-c25430",
"nuernberg-maiach-c241530",
"nuernberg-maiach-f463650",
"nuernberg-main-donau-kanal-c052670",
"nuernberg-main-donau-kanal-c22180",
"nuernberg-main-donau-kanal-c252510",
"nuernberg-main-donau-kanal-f383150",
"nuernberg-main-donau-kanal-f39260",
"nuernberg-main-donau-kanal-f39270",
"nuernberg-main-donau-kanal-f412450",
"nuernberg-main-donau-kanal-f412480",
"nuernberg-main-donau-kanal-f434740",
"nuernberg-man_motorenwerke-f425640",
"nuernberg-man_motorenwerke-f47210",
"nuernberg-man_motorenwerke-f47710",
"nuernberg-man_motorenwerke-s562050",
"nuernberg-man_vogelweiherstrasse-c135350",
"nuernberg-man-c152420",
"nuernberg-man-c152440",
"nuernberg-man-c152450",
"nuernberg-mannertstrasse-c245230",
"nuernberg-mannertstrasse-c245250",
"nuernberg-mannertstrasse-c245270",
"nuernberg-mannertstrasse-c245300",
"nuernberg-marcado-c191220",
"nuernberg-marcado-c191240",
"nuernberg-maria-ward-schule-c243780",
"nuernberg-maria-ward-schule-c282940",
"nuernberg-maria-ward-schule-c311400",
"nuernberg-maria-ward-schule-c311420",
"nuernberg-maria-ward-schule-c311430",
"nuernberg-maria-ward-schule-f383790",
"nuernberg-maria-ward-schule-f471620",
"nuernberg-maria-ward-schule-f540470",
"nuernberg-maria-ward-schule-f540490",
"nuernberg-maria-ward-schule-f540500",
"nuernberg-maria-ward-schule-n262120",
"nuernberg-maria-ward-schule-n274960",
"nuernberg-marie-beeg-strasse-n075800",
"nuernberg-marienberg_campus-c505770",
"nuernberg-marienberg_campus-c505780",
"nuernberg-marienberg_campus-c505790",
"nuernberg-marienberg_campus-f381310",
"nuernberg-marienberg_campus-f381320",
"nuernberg-marienberg_campus-f381330",
"nuernberg-marienberg_campus-f381340",
"nuernberg-marienberg_campus-f381370",
"nuernberg-marienberg_campus-f381380",
"nuernberg-marienberg_campus-f381390",
"nuernberg-marienberg_campus-f381470",
"nuernberg-marienberg_campus-f381480",
"nuernberg-marienberg_campus-f381490",
"nuernberg-marienberg_campus-f381500",
"nuernberg-marienberg_campus-f381510",
"nuernberg-marienberg_campus-f381520",
"nuernberg-marienberg_campus-f381670",
"nuernberg-marienberg_campus-f381680",
"nuernberg-marienberg_campus-f381690",
"nuernberg-marienberg_campus-f381700",
"nuernberg-marienberg_campus-f381720",
"nuernberg-marienberg_campus-f381860",
"nuernberg-marienberg_campus-f381900",
"nuernberg-marienberg_campus-f381910",
"nuernberg-marienberg_campus-f381920",
"nuernberg-marienberg_campus-f382010",
"nuernberg-marienberg_campus-f382020",
"nuernberg-marienberg_campus-f382170",
"nuernberg-marienberg_campus-f382260",
"nuernberg-marienberg_campus-f382320",
"nuernberg-marienberg_campus-f38320",
"nuernberg-marienberg_campus-f38410",
"nuernberg-marienberg_campus-f38430",
"nuernberg-marienberg_campus-f38450",
"nuernberg-marienberg_campus-f38490",
"nuernberg-marienberg_campus-f38730",
"nuernberg-marienberg-c207220",
"nuernberg-marienberg-c207230",
"nuernberg-marienbergcenter-f407810",
"nuernberg-marienbergpark_kino-n510390",
"nuernberg-marienbergpark-c207190",
"nuernberg-marienbergpark-c244530",
"nuernberg-marienbergpark-c563980",
"nuernberg-marienbergpark-f391090",
"nuernberg-marienbergpark-f391100",
"nuernberg-marienbergpark-f407020",
"nuernberg-marienbergpark-f464880",
"nuernberg-marienbergpark-f464890",
"nuernberg-marienbergpark-f502530",
"nuernberg-marienbergpark-n303860",
"nuernberg-marienbergstrasse-c12820",
"nuernberg-marienbergstrasse-c196540",
"nuernberg-marienbergstrasse-c196830",
"nuernberg-marienbergstrasse-c207130",
"nuernberg-marienbergstrasse-c505800",
"nuernberg-marienbergstrasse-cc33920",
"nuernberg-marienbergstrasse-cc33930",
"nuernberg-marienbergstrasse-f381400",
"nuernberg-marienbergstrasse-f531370",
"nuernberg-marienbergstrasse-f540090",
"nuernberg-marienbergstrasse-n261060",
"nuernberg-marienbergstrasse-n261070",
"nuernberg-marienbergstrasse-n261080",
"nuernberg-marienbergstrasse-n261090",
"nuernberg-marienbergstrasse-n261100",
"nuernberg-marienbergstrasse-n261110",
"nuernberg-marienbergstrasse-n261120",
"nuernberg-marienbergstrasse-n261130",
"nuernberg-marienbergstrasse-n261150",
"nuernberg-marienbergstrasse-n261230",
"nuernberg-marienbergstrasse-n261240",
"nuernberg-marienbergstrasse-n261250",
"nuernberg-marienbergstrasse-n261260",
"nuernberg-marienbergstrasse-n261270",
"nuernberg-marienbergstrasse-n261300",
"nuernberg-marienbergstrasse-n261320",
"nuernberg-marienbergstrasse-n261330",
"nuernberg-marienbergstrasse-n303870",
"nuernberg-marienbergstrasse-n303880",
"nuernberg-marienbergstrasse-n303890",
"nuernberg-marienbergstrasse-n303900",
"nuernberg-marienbergstrasse-n303910",
"nuernberg-marienbergweiher-f411770",
"nuernberg-marienbergweiher-f433990",
"nuernberg-marienpark-n144370",
"nuernberg-marienstrasse_baustelle-n262720",
"nuernberg-marienstrasse_baustelle-n262730",
"nuernberg-marienstrasse_baustelle-n263040",
"nuernberg-marienstrasse_baustelle-n263070",
"nuernberg-marienstrasse_baustelle-n263080",
"nuernberg-marienstrasse_baustelle-n263110",
"nuernberg-marienstrasse_baustelle-n263150",
"nuernberg-marienstrasse-c212340",
"nuernberg-marienstrasse-c243800",
"nuernberg-marienstrasse-c243960",
"nuernberg-marienstrasse-c25710",
"nuernberg-marienstrasse-c282350",
"nuernberg-marienstrasse-c282670",
"nuernberg-marienstrasse-c283080",
"nuernberg-marienstrasse-c311370",
"nuernberg-marienstrasse-c563680",
"nuernberg-marienstrasse-cc18220",
"nuernberg-marienstrasse-f471890",
"nuernberg-marienstrasse-f550220",
"nuernberg-marienstrasse-f550230",
"nuernberg-marienstrasse-n263200",
"nuernberg-marienstrasse-n274750",
"nuernberg-marienstrasse-n274860",
"nuernberg-marienstrasse-n274880",
"nuernberg-marienstrasse-n274890",
"nuernberg-marienstrasse-n274950",
"nuernberg-marienstrasse-n294690",
"nuernberg-marienstrasse-n294700",
"nuernberg-marienstrasse-n341830",
"nuernberg-marienstrasse-n341840",
"nuernberg-marienstrasse-n341870",
"nuernberg-marienstrasse-n364430",
"nuernberg-marientorgraben-c196650",
"nuernberg-marientorgraben-c196660",
"nuernberg-marientorgraben-c226310",
"nuernberg-marientorgraben-c226320",
"nuernberg-marientorgraben-c226330",
"nuernberg-marienvorstadt-f382680",
"nuernberg-marienvorstadt-f405780",
"nuernberg-marienvorstadt-f426610",
"nuernberg-marienvorstadt-f426650",
"nuernberg-marienvorstadt-f435140",
"nuernberg-marienvorstadt-f435150",
"nuernberg-marienvorstadt-f444960",
"nuernberg-marienvorstadt-n263120",
"nuernberg-marienvorstadt-n33280",
"nuernberg-marienvorstadt-n341910",
"nuernberg-marienvorstadt-n341920",
"nuernberg-marktamt-c136460",
"nuernberg-marktamt-c136500",
"nuernberg-marktamt-c215210",
"nuernberg-marktamt-f384480",
"nuernberg-marktamt-f384490",
"nuernberg-marktamt-f392330",
"nuernberg-marktamt-f530370",
"nuernberg-marktamt-f531880",
"nuernberg-marktamt-n264210",
"nuernberg-marktkauf_baustelle-c21690",
"nuernberg-marktkauf_baustelle-c21730",
"nuernberg-marktkauf_baustelle-c21810",
"nuernberg-marktkauf_erlanger_strasse-c226950",
"nuernberg-marktkauf-bb81700",
"nuernberg-marktkauf-c082310",
"nuernberg-marktkauf-c152350",
"nuernberg-marktkauf-c188410",
"nuernberg-marktkauf-c21840",
"nuernberg-marktkauf-c244630",
"nuernberg-marktkauf-c312780",
"nuernberg-marktkauf-c564210",
"nuernberg-marktkauf-n342580",
"nuernberg-martha_kirche-c11110",
"nuernberg-martha_kirche-c11160",
"nuernberg-martha_kirche-c11190",
"nuernberg-martha_kirche-c1180",
"nuernberg-martha_kirche-c283110",
"nuernberg-martha_kirche-c283120",
"nuernberg-martha-maria-krankenhaus-c117520",
"nuernberg-martha-maria-krankenhaus-c211050",
"nuernberg-martha-maria-krankenhaus-c211100",
"nuernberg-martha-maria-krankenhaus-c211170",
"nuernberg-martha-maria-krankenhaus-c211180",
"nuernberg-martha-maria-krankenhaus-c211190",
"nuernberg-martha-maria-krankenhaus-c21990",
"nuernberg-martha-maria-krankenhaus-cb89400",
"nuernberg-martha-maria-krankenhaus-n361920",
"nuernberg-martha-maria-krankenhaus-n520390",
"nuernberg-martin-behaim-gymnasium-c242580",
"nuernberg-martin-behaim-gymnasium-c242640",
"nuernberg-martin-behaim-gymnasium-c242670",
"nuernberg-martin-behaim-gymnasium-c242690",
"nuernberg-martinskirche-c10140",
"nuernberg-mathildenstrasse-f39440",
"nuernberg-maxbruecke-n148810",
"nuernberg-maxfeld-c253640",
"nuernberg-maxfeld-cc18090",
"nuernberg-maxfeld-cc18390",
"nuernberg-maxfeld-f383520",
"nuernberg-maxfeld-n076930",
"nuernberg-maxfeld-n362560",
"nuernberg-maxfeld-n362570",
"nuernberg-maxfeld-n362580",
"nuernberg-maxfeld-n362740",
"nuernberg-maximilianstrasse-c283480",
"nuernberg-maximilianstrasse-c283560",
"nuernberg-maximilianstrasse-c283880",
"nuernberg-maximilianstrasse-cb99730",
"nuernberg-maximilianstrasse-f394210",
"nuernberg-maximilianstrasse-f406230",
"nuernberg-maximilianstrasse-f413560",
"nuernberg-maximilianstrasse-f413570",
"nuernberg-maximilianstrasse-f413580",
"nuernberg-maximilianstrasse-f531320",
"nuernberg-maximilianstrasse-f554350",
"nuernberg-maximilianstrasse-n263990",
"nuernberg-maximilianstrasse-n264000",
"nuernberg-maximilianstrasse-n264020",
"nuernberg-maximilianstrasse-n264030",
"nuernberg-maximilianstrasse-n525410",
"nuernberg-maximilianstrasse-n525420",
"nuernberg-maximilianstrasse-n531200",
"nuernberg-maximilienstrasse-f471240",
"nuernberg-max-morlock-stadion-f391930",
"nuernberg-max-morlock-stadion-f47960",
"nuernberg-max-ottenstein-strasse-c28570",
"nuernberg-maxplatz-f426200",
"nuernberg-maxtor-c191360",
"nuernberg-maxtor-c196690",
"nuernberg-maxtor-f391050",
"nuernberg-maxtor-f394510",
"nuernberg-maxtor-f531560",
"nuernberg-maxtorgraben-c035210",
"nuernberg-maxtorgraben-f391060",
"nuernberg-maxtorhof-c563730",
"nuernberg-maxtormauer-c225720",
"nuernberg-maybachstrasse-f392060",
"nuernberg-maybachstrasse-f392070",
"nuernberg-meistersingerhalle-c047850",
"nuernberg-meistersingerhalle-c154030",
"nuernberg-meistersingerhalle-f384170",
"nuernberg-meistersingerhalle-f444700",
"nuernberg-meistersingerhalle-f471020",
"nuernberg-meistersingerhalle-f554550",
"nuernberg-meistersingerhalle-n076160",
"nuernberg-meistersingerhalle-n076180",
"nuernberg-meistersingerhalle-n076190",
"nuernberg-melanchtonstrasse-c252020",
"nuernberg-mensa-f540460",
"nuernberg-mensa-n1450",
"nuernberg-mercado-b184640",
"nuernberg-mercado-b184650",
"nuernberg-mercado-b184660",
"nuernberg-mercado-bb8920",
"nuernberg-mercado-c191200",
"nuernberg-mercado-c25400",
"nuernberg-mercado-ca85880",
"nuernberg-mercado-f394630",
"nuernberg-mercado-f395210",
"nuernberg-mercado-f395240",
"nuernberg-mercado-f406910",
"nuernberg-mercado-f407800",
"nuernberg-mercado-f493120",
"nuernberg-mercado-n510400",
"nuernberg-merianstrasse-f406900",
"nuernberg-merianstrasse-f406980",
"nuernberg-merianstrasse-n362380",
"nuernberg-merianstrasse-n362730",
"nuernberg-merianstrasse-n550110",
"nuernberg-merivastrasse-n147580",
"nuernberg-messe_baustelle-c231840",
"nuernberg-messe_nuernberg-f391910",
"nuernberg-messe_nuernberg-f425040",
"nuernberg-messe_nuernberg-f425100",
"nuernberg-messe_nuernberg-f444540",
"nuernberg-messe_nuernberg-f444550",
"nuernberg-messe_nuernberg-f513890",
"nuernberg-messe_nuernberg-f513900",
"nuernberg-messe_nuernberg-f513910",
"nuernberg-messe_nuernberg-f513930",
"nuernberg-messe-b184320",
"nuernberg-messe-b184330",
"nuernberg-messe-b184350",
"nuernberg-messe-c053460",
"nuernberg-messe-c124350",
"nuernberg-messe-c187610",
"nuernberg-messe-c187620",
"nuernberg-messe-c207610",
"nuernberg-messe-c207620",
"nuernberg-messe-c231860",
"nuernberg-messe-c231870",
"nuernberg-messe-c232140",
"nuernberg-messegelaende-c036080",
"nuernberg-messegelaende-ca86660",
"nuernberg-messe-n068950",
"nuernberg-messe-n36810",
"nuernberg-messe-n36920",
"nuernberg-messe-nn76060",
"nuernberg-messesiedlung-c207590",
"nuernberg-messezentrum_im_winter-cc41410",
"nuernberg-messezentrum_nuenberg-n027010",
"nuernberg-messezentrum_und_dutzendteich-c036140",
"nuernberg-messezentrum_und_langwasser-nn65410",
"nuernberg-messezentrum-c036040",
"nuernberg-messezentrum-c036130",
"nuernberg-messezentrum-c036180",
"nuernberg-messezentrum-c053430",
"nuernberg-messezentrum-c053450",
"nuernberg-messezentrum-c281490",
"nuernberg-messezentrum-cc41320",
"nuernberg-messezentrum-cc41460",
"nuernberg-messezentrum-nn66750",
"nuernberg-messezentrum-nn66770",
"nuernberg-metro-c174110",
"nuernberg-metro-c208370",
"nuernberg-metro-c21410",
"nuernberg-metro-c21440",
"nuernberg-metro-f532870",
"nuernberg-metropol_medical_center-c233590",
"nuernberg-metropol_medical_center-c233630",
"nuernberg-metropol_medical_center-c233720",
"nuernberg-metropol_midical_clinic-n530980",
"nuernberg-meuschelstrasse-c035190",
"nuernberg-meuschelstrasse-c035220",
"nuernberg-meuschelstrasse-cc18370",
"nuernberg-meuschelstrasse-cc43490",
"nuernberg-meuschelstrasse-f381970",
"nuernberg-meuschelstrasse-f382350",
"nuernberg-meuschelstrasse-n06320",
"nuernberg-meuschelstrasse-n077280",
"nuernberg-meuschelstrasse-n14410",
"nuernberg-meuschelstrasse-n14420",
"nuernberg-milchhof_palais-b182620",
"nuernberg-milchhof_palais-b182650",
"nuernberg-milchhof_palais-b182680",
"nuernberg-milchhof_palais-bb820",
"nuernberg-milchhof_palais-bb880",
"nuernberg-milchhof_palais-c1040",
"nuernberg-milchhof_palais-c105370",
"nuernberg-milchhof_palais-c1080",
"nuernberg-milchhof_palais-c121420",
"nuernberg-milchhof_palais-c133350",
"nuernberg-milchhof_palais-c133400",
"nuernberg-milchhof_palais-c154730",
"nuernberg-milchhof_palais-c154740",
"nuernberg-milchhof_palais-c154760",
"nuernberg-milchhof_palais-c154790",
"nuernberg-milchhof_palais-c194500",
"nuernberg-milchhof_palais-c194520",
"nuernberg-milchhof_palais-c195480",
"nuernberg-milchhof_palais-c195620",
"nuernberg-milchhof_palais-c195640",
"nuernberg-milchhof_palais-c195650",
"nuernberg-milchhof_palais-c231220",
"nuernberg-milchhof_palais-c242530",
"nuernberg-milchhof_palais-c243910",
"nuernberg-milchhof_palais-ca88360",
"nuernberg-milchhof_palais-cc31410",
"nuernberg-milchhof_palais-cc52460",
"nuernberg-milchhof_palais-cc52470",
"nuernberg-milchhof_palais-n028950",
"nuernberg-milchhof_palais-n029000",
"nuernberg-milchhof_palais-n053590",
"nuernberg-milchhof_palais-n053720",
"nuernberg-milchhof_palais-n077000",
"nuernberg-milchhof_palais-n144520",
"nuernberg-milchhof_palais-n144570",
"nuernberg-milchhof_palais-n144660",
"nuernberg-milchhof_palais-n144670",
"nuernberg-milchhof_palais-n144680",
"nuernberg-milchhof_palais-n293860",
"nuernberg-milchhof_palais-n293870",
"nuernberg-milchhof_palais-n293880",
"nuernberg-milchhof_palais-n293900",
"nuernberg-milchhof_palais-nn67040",
"nuernberg-milchhof_palais-nn76230",
"nuernberg-milchhof_palais-nn76260",
"nuernberg-mittelschule_st__leonhard-cb8260",
"nuernberg-modellautoclub_nuernberg_zollhausring-f434350",
"nuernberg-modellautoclub-f381040",
"nuernberg-modellautoclub-f38990",
"nuernberg-moebelhaus_segmueller-c132890",
"nuernberg-moebelhaus_xxxlutz-b183210",
"nuernberg-moebelhaus_xxxlutz-c054330",
"nuernberg-moebelhaus_xxxlutz-c106740",
"nuernberg-moebelhaus_xxxlutz-c153930",
"nuernberg-moebelhaus_xxxlutz-c213210",
"nuernberg-moebelhaus_xxxlutz-f391970",
"nuernberg-moebelhaus_xxxlutz-f406490",
"nuernberg-moebelhaus_xxxlutz-n076720",
"nuernberg-moegeldorf-c081230",
"nuernberg-moegeldorf-c132770",
"nuernberg-moegeldorf-c155990",
"nuernberg-moegeldorf-c156010",
"nuernberg-moegeldorf-c207400",
"nuernberg-moegeldorf-c208120",
"nuernberg-moegeldorf-c208130",
"nuernberg-moegeldorf-c21880",
"nuernberg-moegeldorf-c21890",
"nuernberg-moegeldorf-c21900",
"nuernberg-moegeldorf-c21910",
"nuernberg-moegeldorf-c226750",
"nuernberg-moegeldorf-c226760",
"nuernberg-moegeldorfer_plaerrer-c132780",
"nuernberg-moegeldorfer_plaerrer-c194360",
"nuernberg-moegeldorfer_plaerrer-c194370",
"nuernberg-moegeldorfer_plaerrer-n262470",
"nuernberg-moegeldorfer_plaerrer-n262510",
"nuernberg-moegeldorfer_plaerrer-n262580",
"nuernberg-moegeldorf-f383380",
"nuernberg-moegeldorf-f39470",
"nuernberg-moegeldorf-f39480",
"nuernberg-moegeldorf-f413180",
"nuernberg-moegeldorf-f464650",
"nuernberg-moegeldorf-f464650",
"nuernberg-moegeldorf-f464660",
"nuernberg-moegeldorf-f464670",
"nuernberg-moegeldorf-f464670",
"nuernberg-moegeldorf-n262480",
"nuernberg-moegeldorf-n262530",
"nuernberg-moegeldorf-n262540",
"nuernberg-moegeldorf-n262570",
"nuernberg-moegeldorf-n262590",
"nuernberg-moegeldorf-n262600",
"nuernberg-moegeldorf-n262610",
"nuernberg-moegeldorf-n262620",
"nuernberg-moegeldorf-n262630",
"nuernberg-moegeldorf-n262640",
"nuernberg-moegeldorf-n262650",
"nuernberg-moegeldorf-n262660",
"nuernberg-moegeldorf-n262670",
"nuernberg-moegeldorf-n262680",
"nuernberg-moegeldorf-n362060",
"nuernberg-moegeldorf-n362100",
"nuernberg-moegeldorf-n362110",
"nuernberg-moegeldorf-n362150",
"nuernberg-moegeldorf-n525060",
"nuernberg-moegeldorf-n525070",
"nuernberg-moegeldorf-n525080",
"nuernberg-moegeldorf-n525090",
"nuernberg-moegeldorf-n525100",
"nuernberg-moegeldorf-n525110",
"nuernberg-moltkestrasse-cb8790",
"nuernberg-moltkestrasse-cc17310",
"nuernberg-moltkestrasse-cc24700",
"nuernberg-mommsenstrasse-c207330",
"nuernberg-mommsenstrasse-c25410",
"nuernberg-mommsenstrasse-f492730",
"nuernberg-monopol_491-n515320",
"nuernberg-monopol_491-n515350",
"nuernberg-monopol_491-n515360",
"nuernberg-monopol_491-n515450",
"nuernberg-moorenbrunn___siemens-n36510",
"nuernberg-moorenbrunn_und_altenfurt-n36550",
"nuernberg-moorenbrunn_und_altenfurt-n36560",
"nuernberg-moorenbrunn_und_altenfurt-n36580",
"nuernberg-moorenbrunn_und_altenfurt-n36630",
"nuernberg-moorenbrunn-f520400",
"nuernberg-moorenbrunn-n293360",
"nuernberg-moorenbrunn-n36530",
"nuernberg-moritzberg-c231410",
"nuernberg-muehle-f383390",
"nuernberg-muehlhof-n273920",
"nuernberg-muehlhof-n273930",
"nuernberg-muehlhof-n273940",
"nuernberg-muehlweg-f393870",
"nuernberg-muehlweg-f541040",
"nuernberg-muehlweg-f541060",
"nuernberg-muehlweg-f541080",
"nuernberg-muehlweg-n06840",
"nuernberg-muehlweg-n525500",
"nuernberg-mueller_verlag-c244700",
"nuernberg-mueller_verlag-c312680",
"nuernberg-mueller_verlag-n06480",
"nuernberg-mueller_verlag-n06500",
"nuernberg-mueller_verlag-n06560",
"nuernberg-muellverbrennungsanlage_sandreuth-f39330",
"nuernberg-muellverbrennungsanlage-c054890",
"nuernberg-muellverbrennungsanlage-c122840",
"nuernberg-muellverbrennungsanlage-c19480",
"nuernberg-muellverbrennungsanlage-cc4240",
"nuernberg-muellverbrennungsanlage-f39310",
"nuernberg-muellverbrennungsanlage-f3950",
"nuernberg-muellverbrennungsanlage-f412100",
"nuernberg-muellverbrennungsanlage-f412400",
"nuernberg-muellverbrennungsanlage-f412420",
"nuernberg-muellverbrennungsanlage-f554870",
"nuernberg-muellverbrennungsanlage-n027770",
"nuernberg-muellverbrennungsanlage-n075320",
"nuernberg-muellverbrennungsanlage-n147500",
"nuernberg-muenchener_strasse-c109470",
"nuernberg-muenchener_strasse-c191780",
"nuernberg-muenchener_strasse-f406710",
"nuernberg-muggenhof-c124710",
"nuernberg-muggenhof-c283890",
"nuernberg-muggenhof-c283900",
"nuernberg-muggenhof-c283910",
"nuernberg-muggenhof-c283920",
"nuernberg-muggenhof-cc17410",
"nuernberg-muggenhof-doos-n364650",
"nuernberg-muggenhof-f407220",
"nuernberg-muggenhof-f407230",
"nuernberg-muggenhof-f411910",
"nuernberg-muggenhof-f413620",
"nuernberg-muggenhof-f465480",
"nuernberg-muggenhof-f465490",
"nuernberg-muggenhof-f471300",
"nuernberg-muggenhof-f485040",
"nuernberg-muggenhof-f492240",
"nuernberg-muggenhof-f554390",
"nuernberg-muggenhof-n343010",
"nuernberg-muggenhof-n343030",
"nuernberg-murata_elektronik-c111490",
"nuernberg-murrstrasse-cc51070",
"nuernberg-murrstrasse-cc51180",
"nuernberg-museumsbruecke-c212170",
"nuernberg-nachtpanorama-c195600",
"nuernberg-nachtpanorama-c196260",
"nuernberg-naturgartenbad-c21950",
"nuernberg-naturgartenbad-c243030",
"nuernberg-ncc_messezentrum-c106160",
"nuernberg-ncc_messezentrum-c106200",
"nuernberg-nebel_ueber_nuernberg-f412710",
"nuernberg-nebel_ueber_nuernberg-f412720",
"nuernberg-nelson-mandela-platz-c311240",
"nuernberg-nelson-mandela-platz-c311320",
"nuernberg-nelson-mandela-platz-f383290",
"nuernberg-nelson-mandela-platz-f383320",
"nuernberg-nelson-mandela-platz-f384050",
"nuernberg-nelson-mandela-platz-n147990",
"nuernberg-nelson-mandela-platz-n148000",
"nuernberg-nelson-mandela-platz-n149460",
"nuernberg-nelson-mandela-platz-n149470",
"nuernberg-nelson-mandela-platz-n294500",
"nuernberg-nelson-mandela-platz-n294530",
"nuernberg-nelson-mandela-platz-n294620",
"nuernberg-nelson-mandela-platz-n364520",
"nuernberg-nelson-mandela-platz-n364540",
"nuernberg-n-ergie_ag-f463700",
"nuernberg-nerzstrasse_am_rangierbahnhofgelaende-c11580",
"nuernberg-nerzstrasse_am_rangierbahnhofgelaende-c11600",
"nuernberg-nerzstrasse-c226200",
"nuernberg-nerzstrasse-c252240",
"nuernberg-nerzstrasse-c252300",
"nuernberg-nerzstrasse-c281540",
"nuernberg-nerzstrasse-c281550",
"nuernberg-nerzstrasse-f540630",
"nuernberg-nerzstrasse-n294300",
"nuernberg-nettelbeckstrasse-n261860",
"nuernberg-neubau_am_ehem__nordbahnhof-nn8860",
"nuernberg-neubau_autohaus_porsche-n074750",
"nuernberg-neubau_forchheimer_strasse-nn67920",
"nuernberg-neubau_sebald_kontore-nn82960",
"nuernberg-neubau-f493020",
"nuernberg-neue_feuerwache-c283510",
"nuernberg-neue_feuerwache-c283530",
"nuernberg-neue_gasse-cc42070",
"nuernberg-neue_gasse-cc42090",
"nuernberg-neue_gasse-cc42100",
"nuernberg-neuer_juedischer_friedhof-f541000",
"nuernberg-neuer_juedischer_friedhof-f541010",
"nuernberg-neues_museum-b182040",
"nuernberg-neues_museum-b182050",
"nuernberg-neues_museum-b182270",
"nuernberg-neues_museum-b182290",
"nuernberg-neues_museum-bb86990",
"nuernberg-neues_museum-c109110",
"nuernberg-neues_museum-c109130",
"nuernberg-neues_museum-c109190",
"nuernberg-neues_museum-c191490",
"nuernberg-neues_museum-c191620",
"nuernberg-neues_museum-c191650",
"nuernberg-neues_museum-c192330",
"nuernberg-neues_museum-c192510",
"nuernberg-neues_museum-cc25940",
"nuernberg-neues_museum-n148700",
"nuernberg-neulichtenhof-c213080",
"nuernberg-neulichtenhof-c24310",
"nuernberg-neulichtenhof-c24390",
"nuernberg-neulichtenhof-c24410",
"nuernberg-neulichtenhof-c24420",
"nuernberg-neulichtenhof-c24580",
"nuernberg-neulichtenhof-c282490",
"nuernberg-neulichtenhof-c282520",
"nuernberg-neulichtenhof-f490420",
"nuernberg-neulichtenhof-n262970",
"nuernberg-neumarkter_strasse-c109990",
"nuernberg-neumeyerstrasse-n275050",
"nuernberg-neunhhof_im_winter-cc44350",
"nuernberg-neunhof_koppel-n144170",
"nuernberg-neunhof_koppel-n144180",
"nuernberg-neunhof-b18350",
"nuernberg-neunhof-c188610",
"nuernberg-neunhof-c199640",
"nuernberg-neunhof-c227290",
"nuernberg-neunhof-c23250",
"nuernberg-neunhof-cc26590",
"nuernberg-neunhofer_schloss-f490200",
"nuernberg-neunhofer_schloss-n01920",
"nuernberg-neunhof-f38690",
"nuernberg-neunhof-f426880",
"nuernberg-neunhof-f426890",
"nuernberg-neunhof-f490190",
"nuernberg-neunhof-n144160",
"nuernberg-neunhof-n144190",
"nuernberg-neunhof-n144210",
"nuernberg-neunhof-n3280",
"nuernberg-neunhof-n36180",
"nuernberg-neunhof-n510350",
"nuernberg-neunhof-n510360",
"nuernberg-neunhof-nn68090",
"nuernberg-neuroethenbach-c199980",
"nuernberg-neuroethenbach-f393360",
"nuernberg-neuroethenbach-f393370",
"nuernberg-neuroethenbach-f434710",
"nuernberg-neuroethenbach-n146840",
"nuernberg-neuroethenbach-n24230",
"nuernberg-neuroethenbach-n244280",
"nuernberg-neuroethenbach-n274360",
"nuernberg-neuselsbrunn-c161840",
"nuernberg-neuselsbrunn-c232670",
"nuernberg-neuselsbrunn-f406660",
"nuernberg-neuselsbrunn-n293700",
"nuernberg-neuselsbrunn-n293710",
"nuernberg-neuselsbrunn-n293740",
"nuernberg-neuselsbrunn-n293760",
"nuernberg-neuselsbrunn-n293770",
"nuernberg-neuselsbrunn-n293780",
"nuernberg-neusorgstrasse-cc26030",
"nuernberg-neutor-c119590",
"nuernberg-neutor-c119600",
"nuernberg-neutor-f531650",
"nuernberg-neutorgraben-c134850",
"nuernberg-neutorgraben-c134860",
"nuernberg-neutorgraben-c134900",
"nuernberg-neutorgraben-c212110",
"nuernberg-neutorgraben-cc53120",
"nuernberg-neutormauer-c283060",
"nuernberg-nibelungenviertel-cc17050",
"nuernberg-nibelungenviertel-cc17070",
"nuernberg-nizzastrasse-f434690",
"nuernberg-nodbahnhof-c152160",
"nuernberg-noerdliche_altstadt-f412840",
"nuernberg-nopitschstrasse_-_mr__wash-c283570",
"nuernberg-nopitschstrasse-c28660",
"nuernberg-nopitschstrasse-f383110",
"nuernberg-nopitschstrasse-f3960",
"nuernberg-nopitschstrasse-f491880",
"nuernberg-nordbahnhof__baustelle_-cc53540",
"nuernberg-nordbahnhof-c132460",
"nuernberg-nordbahnhof-c155590",
"nuernberg-nordbahnhof-c155680",
"nuernberg-nordbahnhof-c155720",
"nuernberg-nordbahnhof-c155750",
"nuernberg-nordbahnhof-c188370",
"nuernberg-nordbahnhof-c207860",
"nuernberg-nordbahnhof-c207870",
"nuernberg-nordbahnhof-c211630",
"nuernberg-nordbahnhof-cc53510",
"nuernberg-nordbahnhof-n149840",
"nuernberg-nordbahnhof-n247400",
"nuernberg-nordbahnhof-n247430",
"nuernberg-nordbahnhof-n247450",
"nuernberg-nordbahnhof-n247490",
"nuernberg-nordbahnhof-n247600",
"nuernberg-nordbahnhof-n29380",
"nuernberg-nordbahnhof-n29390",
"nuernberg-nordbahnhof-n29400",
"nuernberg-nordbahonhof-c211600",
"nuernberg-nordbahonhof-c211610",
"nuernberg-nord-ost_panorama-f464720",
"nuernberg-nordostbad-c25450",
"nuernberg-nordostbad-c25460",
"nuernberg-nordostbad-c25480",
"nuernberg-nordostbad-c283350",
"nuernberg-nordostbad-n26990",
"nuernberg-nordostbahnhof_-_kieslingstrasse-c107620",
"nuernberg-nordostbahnhof_-_kieslingstrasse-c107640",
"nuernberg-nordostbahnhof_-_kieslingstrasse-c107680",
"nuernberg-nordostbahnhof-c107720",
"nuernberg-nordostbahnhof-c107750",
"nuernberg-nordostbahnhof-c107770",
"nuernberg-nordostbahnhof-c119190",
"nuernberg-nordostbahnhof-c119240",
"nuernberg-nordostbahnhof-c121260",
"nuernberg-nordostbahnhof-c121270",
"nuernberg-nordostbahnhof-c211370",
"nuernberg-nordostbahnhof-c211390",
"nuernberg-nordostbahnhof-c211400",
"nuernberg-nordostbahnhof-c211410",
"nuernberg-nordostbahnhof-c211420",
"nuernberg-nordostbahnhof-c211480",
"nuernberg-nordostbahnhof-c23780",
"nuernberg-nordostbahnhof-f393620",
"nuernberg-nordostbahnhof-f393630",
"nuernberg-nordostbahnhof-f407040",
"nuernberg-nordostbahnhof-n303810",
"nuernberg-nordostbahnhof-n33730",
"nuernberg-nordostbahnhof-n36340",
"nuernberg-nordostbahnhof-n36350",
"nuernberg-nordostpark-c193220",
"nuernberg-nordostpark-c211200",
"nuernberg-nordostpark-c211210",
"nuernberg-nordostpark-f381450",
"nuernberg-nordostpark-f38210",
"nuernberg-nordostpark-f382120",
"nuernberg-nordostpark-f382130",
"nuernberg-nordostpark-f382830",
"nuernberg-nordostpark-f382840",
"nuernberg-nordostpark-f407030",
"nuernberg-nordostpark-f520330",
"nuernberg-nordostpark-f520340",
"nuernberg-nordostpark-n261050",
"nuernberg-nordostpark-n261830",
"nuernberg-nordostpark-n275030",
"nuernberg-nordostpark-n275040",
"nuernberg-nordostpark-n275060",
"nuernberg-nordostpark-n275070",
"nuernberg-nordostpark-n275080",
"nuernberg-nordostpark-n275090",
"nuernberg-nordostpark-n275100",
"nuernberg-nordostpark-n520380",
"nuernberg-nordostpark-nn67170",
"nuernberg-nordostpark-nn77940",
"nuernberg-nordostring-c133070",
"nuernberg-nordostring-c133100",
"nuernberg-nordostring-c133150",
"nuernberg-nordostring-c133190",
"nuernberg-nordring-c132680",
"nuernberg-nordring-c152170",
"nuernberg-nordring-c152180",
"nuernberg-nordring-c152190",
"nuernberg-nordring-c207840",
"nuernberg-nordring-c253700",
"nuernberg-nordring-f405520",
"nuernberg-nordring-f434050",
"nuernberg-nordring-f472130",
"nuernberg-nordring-f514120",
"nuernberg-nordring-n32130",
"nuernberg-nordstadt__bucher_strasse-f412750",
"nuernberg-nordstadt_panorama-f463780",
"nuernberg-nordstadt_panorama-f463800",
"nuernberg-nordstadt-c124600",
"nuernberg-nordstadt-c208240",
"nuernberg-nordstadt-c253650",
"nuernberg-nordstadt-c282930",
"nuernberg-nordstadt-c283430",
"nuernberg-nordstadt-c283440",
"nuernberg-nordstadt-c564130",
"nuernberg-nordstadt-c564140",
"nuernberg-nordstadt-cc25130",
"nuernberg-nordstadt-cc26330",
"nuernberg-nordstadt-cc26480",
"nuernberg-nordstadt-cc32110",
"nuernberg-nordstadt-f382220",
"nuernberg-nordstadt-f383580",
"nuernberg-nordstadt-f391250",
"nuernberg-nordstadt-f393250",
"nuernberg-nordstadt-f393470",
"nuernberg-nordstadt-f393530",
"nuernberg-nordstadt-f407410",
"nuernberg-nordstadt-f412770",
"nuernberg-nordstadt-f455410",
"nuernberg-nordstadt-f455430",
"nuernberg-nordstadt-f455470",
"nuernberg-nordstadt-f455630",
"nuernberg-nordstadt-f455810",
"nuernberg-nordstadt-f492360",
"nuernberg-nordstadt-f492610",
"nuernberg-nordstadt-f530250",
"nuernberg-nordstadt-f550190",
"nuernberg-nordstadt-f555270",
"nuernberg-nordstadtgaerten-f383530",
"nuernberg-nordstadtgaerten-f383550",
"nuernberg-nordstadtgaerten-f404790",
"nuernberg-nordstadtgaerten-n247500",
"nuernberg-nordstadtgaerten-n247560",
"nuernberg-nordstadtgaerten-n247570",
"nuernberg-nordstadtgaerten-n26960",
"nuernberg-nordstadtgaerten-n26970",
"nuernberg-nordstadtgaerten-n29250",
"nuernberg-nordstadtgaerten-n29260",
"nuernberg-nordstadtgaerten-n29270",
"nuernberg-nordstadtgaerten-n29280",
"nuernberg-nordstadtgaerten-n29290",
"nuernberg-nordstadtgaerten-n29300",
"nuernberg-nordstadtgaerten-n29310",
"nuernberg-nordstadtgaerten-n29340",
"nuernberg-nordstadtgaerten-n29360",
"nuernberg-nordstadtgaerten-n29440",
"nuernberg-nordstadtgaerten-n29450",
"nuernberg-nordstadtgaerten-n29470",
"nuernberg-nordstadtgaerten-n29510",
"nuernberg-nordstadtgaerten-n29530",
"nuernberg-nordstadtgaerten-n362640",
"nuernberg-nordstadt-n362610",
"nuernberg-nordstadt-n510410",
"nuernberg-nordstadtpanorama-n363870",
"nuernberg-nordwestring_-_radloff-c312420",
"nuernberg-nordwestring_-_radloff-c312450",
"nuernberg-nordwestring_ecke_bielefelder_strasse-nn74730",
"nuernberg-nordwestring-c253710",
"nuernberg-nordwestring-c312400",
"nuernberg-nordwestring-f381960",
"nuernberg-nordwestring-f383660",
"nuernberg-nordwestring-f404630",
"nuernberg-nordwestring-f404740",
"nuernberg-nordwestring-f426080",
"nuernberg-nordwestring-f426110",
"nuernberg-nordwestring-f434770",
"nuernberg-nordwestring-f445380",
"nuernberg-nordwestring-f445420",
"nuernberg-nordwestring-f445440",
"nuernberg-nordwestring-f445460",
"nuernberg-nordwestring-f445470",
"nuernberg-nordwestring-f445480",
"nuernberg-nordwestring-f471360",
"nuernberg-nordwestring-f471400",
"nuernberg-nordwestring-f484850",
"nuernberg-nordwestring-f484880",
"nuernberg-nordwestring-f514220",
"nuernberg-nordwestring-f530220",
"nuernberg-nordwestring-f530230",
"nuernberg-nordwestring-f530270",
"nuernberg-nordwestring-f530300",
"nuernberg-nordwestring-f530320",
"nuernberg-nordwestring-f531010",
"nuernberg-nordwestring-f531020",
"nuernberg-nordwestring-f540230",
"nuernberg-nordwestring-f553830",
"nuernberg-nordwestring-f553850",
"nuernberg-nordwestring-n363030",
"nuernberg-nordwestring-n363050",
"nuernberg-norikus_hochhaus-c105340",
"nuernberg-norikus-b182700",
"nuernberg-norikus-c1050",
"nuernberg-norikus-c208180",
"nuernberg-norikus-n144640",
"nuernberg-norisring-f455150",
"nuernberg-nornenstrasse-c564020",
"nuernberg-novartis__roonstrasse_-cb99610",
"nuernberg-novartis__roonstrasse_-n069730",
"nuernberg-novina_hotel-n069200",
"nuernberg-novina_hotel-n069210",
"nuernberg-novina_hotel-n069320",
"nuernberg-novina_hotel-n069330",
"nuernberg-novotel-b182530",
"nuernberg-novotel-b182540",
"nuernberg-novotel-bb8140",
"nuernberg-novotel-c191980",
"nuernberg-novotel-c192010",
"nuernberg-novotel-c192080",
"nuernberg-novotel-c192090",
"nuernberg-nuerbanum-c564000",
"nuernberg-nuerbanum-c564010",
"nuernberg-nuerbanum-f391780",
"nuernberg-nuerbanum-n341590",
"nuernberg-nuernbaerland_am_volksfestplatz-f443940",
"nuernberg-nuernbaerland_am_volksfestplatz-f444560",
"nuernberg-nuernberg_hafen-sued-f454850",
"nuernberg-nuernberg_nord_ost-f530950",
"nuernberg-nuernberg_nord_panorama-f463820",
"nuernberg-nuernberg_nord-f411780",
"nuernberg-nuernberg_nord-f465010",
"nuernberg-nuernberg_nord-f514140",
"nuernberg-nuernberg_nordost-f407000",
"nuernberg-nuernberg_ost-n33570",
"nuernberg-nuernberg_ostring-f444900",
"nuernberg-nuernberg_panorama-f463750",
"nuernberg-nuernberg_panorama-f465400",
"nuernberg-nuernberg_sued-f38910",
"nuernberg-nuernberg_sued-n510530",
"nuernberg-nuernberg_sued-ost-n33580",
"nuernberg-nuernberg_west-f38780",
"nuernberg-nuernberg_west-f424260",
"nuernberg-nuernberg-c125790",
"nuernberg-nuernberg-cc31370",
"nuernberg-nuernberger_altstadt-f406140",
"nuernberg-nuernberger_flughafen-cc44220",
"nuernberg-nuernberger_pressehaus-c11360",
"nuernberg-nuernberger_pressehaus-c11390",
"nuernberg-nuernberger_strasse-f383060",
"nuernberg-nuernberger_versicherung__dach_-c038550",
"nuernberg-nuernberger_versicherung-cc41840",
"nuernberg-nuernberg-fischbach-f510210",
"nuernberg-nuernberg-hafen-ost-f403610",
"nuernberg-nuernberg-hafen-sued-f434190",
"nuernberg-nuernberg-hafen-sued-f434580",
"nuernberg-nuernberg-hafen-sued-f434610",
"nuernberg-nuernberg-koenigshof-f402890",
"nuernberg-nuernberg-koenigshof-f402930",
"nuernberg-nuernberg-koenigshof-f425550",
"nuernberg-nuernberg-zollhaus-f402840",
"nuernberg-nuernberg-zollhaus-f403130",
"nuernberg-nuernberg-zollhaus-f403140",
"nuernberg-nuernberg-zollhaus-f403330",
"nuernberg-nuernberg-zollhaus-f424330",
"nuernberg-nuernberg-zollhaus-f424520",
"nuernberg-nuernberg-zollhaus-f434250",
"nuernberg-nuernberg-zollhaus-f434510",
"nuernberg-obere_baustrasse-n148130",
"nuernberg-obere_baustrasse-n148140",
"nuernberg-obere_schmiedgasse-f382500",
"nuernberg-obere_turnstrasse-c564260",
"nuernberg-obere_turnstrasse-cb8780",
"nuernberg-obere_turnstrasse-cc42640",
"nuernberg-obere_turnstrasse-f382430",
"nuernberg-obere_turnstrasse-f382440",
"nuernberg-obere_turnstrasse-f383870",
"nuernberg-obere_turnstrasse-n069750",
"nuernberg-obere_turnstrasse-n149160",
"nuernberg-obere_turnstrasse-n149170",
"nuernberg-obi_herrnhuette-c119140",
"nuernberg-obi_leyher_strasse-c564400",
"nuernberg-obi-b184700",
"nuernberg-obi-b184730",
"nuernberg-obi-ca85230",
"nuernberg-oekumenisches_zentrum_st__clemens-n540190",
"nuernberg-oelberg-f424200",
"nuernberg-oestliche_altstadt-f471690",
"nuernberg-olivenweg-c187730",
"nuernberg-olivenweg-c187770",
"nuernberg-olivenweg-f384710",
"nuernberg-olivenweg-f491810",
"nuernberg-olivenweg-n146820",
"nuernberg-opel-n149180",
"nuernberg-opernhaus-b182490",
"nuernberg-opernhaus-c041060",
"nuernberg-opernhaus-c122550",
"nuernberg-opernhaus-c122580",
"nuernberg-opernhaus-c122600",
"nuernberg-opernhaus-c155170",
"nuernberg-opernhaus-c194060",
"nuernberg-opernhaus-c194090",
"nuernberg-opernhaus-c196410",
"nuernberg-opernhaus-c226410",
"nuernberg-opernhaus-c226420",
"nuernberg-opernhaus-c226440",
"nuernberg-opernhaus-f392230",
"nuernberg-opernhaus-f39670",
"nuernberg-opernhaus-f406130",
"nuernberg-opernhaus-f531800",
"nuernberg-opernhaus-n076080",
"nuernberg-opernhaus-n076090",
"nuernberg-opernhaus-nn81290",
"nuernberg-opernhaus-nn81310",
"nuernberg-orange_campus-c311690",
"nuernberg-orange_campus-c311730",
"nuernberg-orange_campus-c311740",
"nuernberg-orange_campus-f382730",
"nuernberg-orange_campus-n295000",
"nuernberg-orange_campus-n295030",
"nuernberg-orange_campus-n295060",
"nuernberg-orange_campus-n295070",
"nuernberg-orange_campus-n342420",
"nuernberg-orange_campus-n364220",
"nuernberg-orange_campus-n364240",
"nuernberg-orange_campus-n364280",
"nuernberg-orange_campus-n364300",
"nuernberg-orange_campus-n364330",
"nuernberg-oskar-von-miller-strasse-c213120",
"nuernberg-oskar-von-miller-strasse-c213130",
"nuernberg-oskar-von-miller-strasse-c213140",
"nuernberg-oskar-von-miller-strasse-c213150",
"nuernberg-oskar-von-miller-strasse-c213160",
"nuernberg-oskar-von-miller-strasse-c213170",
"nuernberg-oskar-von-miller-strasse-c213180",
"nuernberg-oskar-von-miller-strasse-c213200",
"nuernberg-ossietzkystrasse-f471750",
"nuernberg-ostbahnhof-c081760",
"nuernberg-ostendstrasse-c081280",
"nuernberg-ostendstrasse-c132960",
"nuernberg-ostendstrasse-c132970",
"nuernberg-ostendstrasse-c133010",
"nuernberg-ostendstrasse-c133040",
"nuernberg-ostendstrasse-c133050",
"nuernberg-ostendstrasse-c133060",
"nuernberg-ostendstrasse-c154800",
"nuernberg-ostendstrasse-c208090",
"nuernberg-ostendstrasse-c208110",
"nuernberg-ostendstrasse-c223720",
"nuernberg-ostendstrasse-f381630",
"nuernberg-ostendstrasse-f413130",
"nuernberg-ostendstrasse-f413140",
"nuernberg-ostendstrasse-f492780",
"nuernberg-ostendstrasse-f492800",
"nuernberg-ostendstrasse-n262170",
"nuernberg-ostendstrasse-n293990",
"nuernberg-ostendstrasse-n294060",
"nuernberg-ostendstrasse-n303640",
"nuernberg-ostendstrasse-n303650",
"nuernberg-ostendstrasse-n33630",
"nuernberg-ostendstrasse-n33660",
"nuernberg-ostendstrasse-n36410",
"nuernberg-ostermarkt_am_hauptmarkt-c251390",
"nuernberg-ostermarkt_am_hauptmarkt-n027330",
"nuernberg-ostring-c194450",
"nuernberg-ostring-n510480",
"nuernberg-ostring-n510490",
"nuernberg-ostring-n515470",
"nuernberg-oststadt-n361510",
"nuernberg-otto-brenner-bruecke-f393330",
"nuernberg-ottostrasse-cc17290",
"nuernberg-paketzentrum_dhl-n068860",
"nuernberg-paketzentrum_tnt-n068840",
"nuernberg-palais_am_milchhof-f435060",
"nuernberg-panorama_-_knoblauchsland-c254790",
"nuernberg-panorama_altstadt-c212100",
"nuernberg-panorama_altstadt-n242690",
"nuernberg-panorama_bei_nacht-c041490",
"nuernberg-panorama_bei_nacht-ca87320",
"nuernberg-panorama_dutzendteich-c213230",
"nuernberg-panorama_dutzendteich-c231890",
"nuernberg-panorama_fernmeldeturm-c214890",
"nuernberg-panorama_gartenstadt-n241590",
"nuernberg-panorama_gebersdorf-c214830",
"nuernberg-panorama_nebel-c23130",
"nuernberg-panorama_nebel-c23150",
"nuernberg-panorama_nebel-c23210",
"nuernberg-panorama_nord-ost-f465030",
"nuernberg-panorama_nordost-n242670",
"nuernberg-panorama_nordstadt-n242680",
"nuernberg-panorama_ost-f464790",
"nuernberg-panorama_richtung_ost-c133550",
"nuernberg-panorama_sonnenuntergang-c234690",
"nuernberg-panorama_sonnenuntergang-c234720",
"nuernberg-panorama-b184610",
"nuernberg-panorama-bb87030",
"nuernberg-panorama-c053510",
"nuernberg-panorama-c069360",
"nuernberg-panorama-c069410",
"nuernberg-panorama-c119230",
"nuernberg-panorama-c134330",
"nuernberg-panorama-c135390",
"nuernberg-panorama-c135620",
"nuernberg-panorama-c192630",
"nuernberg-panorama-c195450",
"nuernberg-panorama-c19960",
"nuernberg-panorama-c213040",
"nuernberg-panorama-c213240",
"nuernberg-panorama-c213250",
"nuernberg-panorama-c213260",
"nuernberg-panorama-c213270",
"nuernberg-panorama-c213290",
"nuernberg-panorama-c213330",
"nuernberg-panorama-c213340",
"nuernberg-panorama-c213350",
"nuernberg-panorama-c214870",
"nuernberg-panorama-c226730",
"nuernberg-panorama-c226880",
"nuernberg-panorama-c226900",
"nuernberg-panorama-c227040",
"nuernberg-panorama-c227060",
"nuernberg-panorama-c227120",
"nuernberg-panorama-c227130",
"nuernberg-panorama-c227160",
"nuernberg-panorama-c227220",
"nuernberg-panorama-c227240",
"nuernberg-panorama-c233210",
"nuernberg-panorama-c252480",
"nuernberg-panorama-c252550",
"nuernberg-panorama-c253750",
"nuernberg-panorama-c254450",
"nuernberg-panorama-c254460",
"nuernberg-panorama-c254470",
"nuernberg-panorama-f464940",
"nuernberg-panorama-n054230",
"nuernberg-panorama-n054240",
"nuernberg-panorama-n054270",
"nuernberg-panorama-n054290",
"nuernberg-panorama-n054400",
"nuernberg-panorama-n05610",
"nuernberg-panorama-n056600",
"nuernberg-panorama-n148250",
"nuernberg-panorama-n148260",
"nuernberg-panorama-n245570",
"nuernberg-panorama-n247370",
"nuernberg-panorama-nn66880",
"nuernberg-panorama-nn68150",
"nuernberg-paracelsusstrasse-f406260",
"nuernberg-park_lane-n515510",
"nuernberg-park_lane-n515530",
"nuernberg-park_lane-n515540",
"nuernberg-parkhaus_klinikum-nuernberg-sued-c124170",
"nuernberg-parkhaus_klinikum-nuernberg-sued-c124190",
"nuernberg-parkhaus_klinikum-nuernberg-sued-c124200",
"nuernberg-parkhaus_klinikum-nuernberg-sued-c281930",
"nuernberg-parkhaus_suedstadt-c154120",
"nuernberg-parkhaus_vordere_sterngasse-c194100",
"nuernberg-parkhaus-c187440",
"nuernberg-parkhaus-c193740",
"nuernberg-parkhaus-c193760",
"nuernberg-parkhaus-f424160",
"nuernberg-parkhaus-f426190",
"nuernberg-parkplatz-c125200",
"nuernberg-parkplatz-f426230",
"nuernberg-parks___stadtpark-f472270",
"nuernberg-parkside_am_stadtpark-c119500",
"nuernberg-parkside-f554450",
"nuernberg-parkside-n29500",
"nuernberg-paul-ritter-foerderschule-f485000",
"nuernberg-paul-ritter-foerderschule-f485000",
"nuernberg-paul-ritter-foerderschule-f540980",
"nuernberg-paul-ritter-schule-n515670",
"nuernberg-paul-ritter-schule-n515680",
"nuernberg-paulskirche-c226270",
"nuernberg-paulskirche-n147140",
"nuernberg-paulskirche-n147150",
"nuernberg-paulskirche-n147750",
"nuernberg-paulstrasse-c135040",
"nuernberg-paumannstrasse-c08500",
"nuernberg-paumannstrasse-c111390",
"nuernberg-paumannstrasse-c111400",
"nuernberg-pegnitz_ost-c211310",
"nuernberg-pegnitztal_ost-c253360",
"nuernberg-pegnitztal_ost-f404870",
"nuernberg-peterskirche-n076230",
"nuernberg-peterskirche-n147230",
"nuernberg-peterskirche-n147240",
"nuernberg-peterskirche-n293850",
"nuernberg-peter-vischer-schule-c119650",
"nuernberg-peter-vischer-schule-c119660",
"nuernberg-peter-vischer-schule-c119670",
"nuernberg-peter-vischer-schule-c119690",
"nuernberg-peter-vischer-schule-c119740",
"nuernberg-peter-vischer-schule-c119750",
"nuernberg-peter-vischer-schule-c121870",
"nuernberg-peter-vischer-schule-c253660",
"nuernberg-peter-vischer-schule-c253680",
"nuernberg-peter-vischer-schule-cc32170",
"nuernberg-peter-vischer-schule-f383590",
"nuernberg-peter-vischer-strasse-n341990",
"nuernberg-peter-vischer-strasse-n364090",
"nuernberg-pettenkoferstrasse-c213540",
"nuernberg-pettenkoferstrasse-c213550",
"nuernberg-petzenschloss-c11720",
"nuernberg-petzenschloss-c122270",
"nuernberg-peuntgasse-n263300",
"nuernberg-pfarramt_st__rupert-c226020",
"nuernberg-pferdemarkt-c281630",
"nuernberg-pferdemarkt-c283750",
"nuernberg-pferdemarkt-cc17680",
"nuernberg-pferdemarkt-f382750",
"nuernberg-pferdemarkt-f384380",
"nuernberg-pferdemarkt-f39340",
"nuernberg-pferdemarkt-f435220",
"nuernberg-pferdemarkt-n149000",
"nuernberg-pferdemarkt-n244580",
"nuernberg-pferdemarkt-n363820",
"nuernberg-photovoltaik-f435190",
"nuernberg-pillenreuther_baustelle-n247340",
"nuernberg-pillenreuther_baustelle-n24860",
"nuernberg-pillenreuther_strasse-c154140",
"nuernberg-pillenreuther_strasse-f490410",
"nuernberg-pillenreuther_strasse-f490430",
"nuernberg-pillenreuther_strasse-f531770",
"nuernberg-pillenreuther_strasse-n147330",
"nuernberg-pillenreuther_strasse-n147370",
"nuernberg-pillenreuther_strasse-n147390",
"nuernberg-pillenreuther_strasse-n147450",
"nuernberg-pillenreuther_strasse-n147460",
"nuernberg-pillenreuther_strasse-n147670",
"nuernberg-pillenreuther_strasse-n147680",
"nuernberg-pillenreuther_strasse-n147700",
"nuernberg-pillenreuther_strasse-n148010",
"nuernberg-pillenreuther_strasse-n262840",
"nuernberg-pillenreuth-f381100",
"nuernberg-pillenreuth-f490760",
"nuernberg-pillenreuth-f490770",
"nuernberg-pillenreuth-n146970",
"nuernberg-pilotystrasse-c233290",
"nuernberg-pilotystrasse-n14430",
"nuernberg-pirckheimer_gymnasium-c135490",
"nuernberg-pirckheimer_strasse-f532210",
"nuernberg-pirckheimerstrasse-b18900",
"nuernberg-pirckheimerstrasse-c119930",
"nuernberg-pirckheimerstrasse-c134870",
"nuernberg-pirckheimerstrasse-c243690",
"nuernberg-pirckheimerstrasse-c282920",
"nuernberg-pirckheimerstrasse-cc53340",
"nuernberg-pirckheimerstrasse-cc53400",
"nuernberg-pirckheimerstrasse-cc53420",
"nuernberg-pirckheimerstrasse-cc53450",
"nuernberg-pirckheimerstrasse-f382480",
"nuernberg-pirckheimerstrasse-f38710",
"nuernberg-plaerrer___gostenhof-c037200",
"nuernberg-plaerrer_bei_nacht-c049990",
"nuernberg-plaerrer_volksbad-cb99630",
"nuernberg-plaerrer-b181490",
"nuernberg-plaerrer-b181500",
"nuernberg-plaerrer-b181510",
"nuernberg-plaerrer-b181520",
"nuernberg-plaerrer-b181530",
"nuernberg-plaerrer-b181540",
"nuernberg-plaerrer-c04990",
"nuernberg-plaerrer-c051170",
"nuernberg-plaerrer-c051200",
"nuernberg-plaerrer-c057050",
"nuernberg-plaerrer-c068710",
"nuernberg-plaerrer-c11310",
"nuernberg-plaerrer-c192590",
"nuernberg-plaerrer-c192810",
"nuernberg-plaerrer-c192820",
"nuernberg-plaerrer-c193980",
"nuernberg-plaerrer-c196420",
"nuernberg-plaerrer-c212020",
"nuernberg-plaerrer-c212030",
"nuernberg-plaerrer-c212940",
"nuernberg-plaerrer-ca85380",
"nuernberg-plaerrer-cb99640",
"nuernberg-plaerrer-cc18310",
"nuernberg-plaerrer-f393440",
"nuernberg-plaerrer-f394810",
"nuernberg-plaerrer-f395830",
"nuernberg-plaerrer-f407370",
"nuernberg-plaerrer-f412960",
"nuernberg-plaerrer-f425700",
"nuernberg-plaerrer-f531500",
"nuernberg-plaerrer-f531820",
"nuernberg-plaerrer-f531830",
"nuernberg-plaerrer-f531840",
"nuernberg-plaerrer-f554910",
"nuernberg-plaerrer-f554980",
"nuernberg-plaerrer-n076060",
"nuernberg-plaerrer-n149120",
"nuernberg-plaerrer-n149140",
"nuernberg-plaerrer-n245160",
"nuernberg-plaerrer-n342430",
"nuernberg-plaerrer-nn65980",
"nuernberg-plaerrer-nn75010",
"nuernberg-plaerrer-nn75090",
"nuernberg-plaerrer-nn75170",
"nuernberg-planetenring-c161850",
"nuernberg-planetenring-cc51750",
"nuernberg-planetenring-n293790",
"nuernberg-platnersberg-n261640",
"nuernberg-platnersberg-n261650",
"nuernberg-platnersberg-n261660",
"nuernberg-platnersberg-n261670",
"nuernberg-platnersberg-n261700",
"nuernberg-platnersberg-n261720",
"nuernberg-platnersberg-n261740",
"nuernberg-platnersberg-n261750",
"nuernberg-platnersgasse-c311540",
"nuernberg-platz_der_deutschen_einheit-f384630",
"nuernberg-platz_der_opfer_des_faschischmus-f471010",
"nuernberg-platz_der_opfer_des_faschischmus-f471800",
"nuernberg-poco_domaene-f39740",
"nuernberg-polizeipraesidium-nn65750",
"nuernberg-porsche_zentrum_erlanger_strasse-c081980",
"nuernberg-porsche_zentrum_erlanger_strasse-c081990",
"nuernberg-porsche_zentrum_erlanger_strasse-c082000",
"nuernberg-porsche_zentrum_erlanger_strasse-c082010",
"nuernberg-porsche_zentrum_erlanger_strasse-c082030",
"nuernberg-porsche_zentrum_erlanger_strasse-c082110",
"nuernberg-porsche_zentrum_erlanger_strasse-c082120",
"nuernberg-porsche_zentrum_erlanger_strasse-c082130",
"nuernberg-porsche_zentrum_erlanger_strasse-c082140",
"nuernberg-porsche_zentrum_erlanger_strasse-c082150",
"nuernberg-porsche_zentrum_erlanger_strasse-c082160",
"nuernberg-porsche_zentrum_erlanger_strasse-c082170",
"nuernberg-porsche_zentrum_erlanger_strasse-c082180",
"nuernberg-porsche_zentrum_erlanger_strasse-c082200",
"nuernberg-porsche_zentrum_erlanger_strasse-c082210",
"nuernberg-porsche_zentrum_erlanger_strasse-c082400",
"nuernberg-porsche_zentrum_erlanger_strasse-cb81060",
"nuernberg-porsche_zentrum_erlanger_strasse-cb81070",
"nuernberg-porsche_zentrum_erlanger_strasse-n06650",
"nuernberg-porsche_zentrum_erlanger_strasse-n06660",
"nuernberg-porsche_zentrum_erlanger_strasse-n06670",
"nuernberg-porsche_zentrum_erlanger_strasse-n06680",
"nuernberg-porsche_zentrum_erlanger_strasse-n06690",
"nuernberg-porsche_zentrum_erlanger_strasse-n06700",
"nuernberg-porsche_zentrum_erlanger_strasse-n074740",
"nuernberg-porsche_zentrum-c082410",
"nuernberg-porsche_zentrum-c123790",
"nuernberg-porsche_zentrum-c12510",
"nuernberg-porsche_zentrum-c12580",
"nuernberg-porsche_zentrum-c12610",
"nuernberg-porsche_zentrum-c12660",
"nuernberg-porsche_zentrum-cb99040",
"nuernberg-porsche_zentrum-cb99050",
"nuernberg-porsche_zentrum-cb99060",
"nuernberg-porsche_zentrum-cb99070",
"nuernberg-porsche_zentrum-cb99080",
"nuernberg-porsche_zentrum-cb99090",
"nuernberg-porsche_zentrum-cb99100",
"nuernberg-porsche_zentrum-cb99110",
"nuernberg-porsche_zentrum-cb99120",
"nuernberg-porsche_zentrum-cb99130",
"nuernberg-porsche_zentrum-cb99140",
"nuernberg-porsche_zentrum-cb99150",
"nuernberg-porsche_zentrum-cb99160",
"nuernberg-porsche_zentrum-cb99170",
"nuernberg-porsche_zentrum-cb99180",
"nuernberg-porsche_zentrum-cb99190",
"nuernberg-porsche_zentrum-cb99200",
"nuernberg-porsche_zentrum-cb99210",
"nuernberg-porsche_zentrum-cb99220",
"nuernberg-porsche_zentrum-cb99230",
"nuernberg-porsche_zentrum-cb99240",
"nuernberg-porsche_zentrum-cb99250",
"nuernberg-porsche_zentrum-cb99260",
"nuernberg-porsche_zentrum-cb99270",
"nuernberg-porsche_zentrum-cb99280",
"nuernberg-porsche_zentrum-cb99290",
"nuernberg-porsche_zentrum-cb99300",
"nuernberg-porsche_zentrum-n342610",
"nuernberg-porsche-c152050",
"nuernberg-porsche-c192880",
"nuernberg-porsche-c208320",
"nuernberg-porsche-cc54750",
"nuernberg-porsche-f555320",
"nuernberg-post_am_hauptbahnhof-n149390",
"nuernberg-post_am_hauptbahnhof-n149400",
"nuernberg-post_am_hauptbahnhof-nn81020",
"nuernberg-post_kleestrasse-n076790",
"nuernberg-posthof-c11670",
"nuernberg-posthof-c11700",
"nuernberg-posthof-c11840",
"nuernberg-posthof-c11870",
"nuernberg-posthof-c124480",
"nuernberg-poststrasse-c161780",
"nuernberg-poststrasse-c187500",
"nuernberg-poststrasse-c187510",
"nuernberg-poststrasse-c187520",
"nuernberg-poststrasse-f412210",
"nuernberg-poststrasse-f444590",
"nuernberg-poststrasse-n361130",
"nuernberg-prinovis_druck-nn75880",
"nuernberg-prinovis-f406570",
"nuernberg-prinovis-f406580",
"nuernberg-prinovis-f406590",
"nuernberg-prinovis-f47870",
"nuernberg-prinovis-f47890",
"nuernberg-prinzregentenufer-c121600",
"nuernberg-prinzregentenufer-c121620",
"nuernberg-prinzregentenufer-c121640",
"nuernberg-prinzregentenufer-c121670",
"nuernberg-prinzregentenufer-c133740",
"nuernberg-prinzregentenufer-c154840",
"nuernberg-prinzregentenufer-c191150",
"nuernberg-prinzregentenufer-c212370",
"nuernberg-prinzregentenufer-c212410",
"nuernberg-prinzregentenufer-c212460",
"nuernberg-prinzregentenufer-c212550",
"nuernberg-prinzregentenufer-c212640",
"nuernberg-prinzregentenufer-c226350",
"nuernberg-prinzregentenufer-c226360",
"nuernberg-prinzregentenufer-c226370",
"nuernberg-prinzregentenufer-c232850",
"nuernberg-prinzregentenufer-c232860",
"nuernberg-prinzregentenufer-c232870",
"nuernberg-prinzregentenufer-c232900",
"nuernberg-prinzregentenufer-c243870",
"nuernberg-prinzregentenufer-c564100",
"nuernberg-prinzregentenufer-cc17810",
"nuernberg-prinzregentenufer-cc17820",
"nuernberg-prinzregentenufer-f405390",
"nuernberg-prinzregentenufer-f471620",
"nuernberg-prinzregentenufer-f550210",
"nuernberg-prinzregentenufer-f554950",
"nuernberg-prinzregentenufer-n053770",
"nuernberg-prinzregentenufer-n055680",
"nuernberg-prosol-n149780",
"nuernberg-public_viewing_am_flughafen-c105140",
"nuernberg-public_viewing_am_flughafen-c10620",
"nuernberg-quelle_areal-f384010",
"nuernberg-quelle_areal-f384010",
"nuernberg-quelle_areal-f384460",
"nuernberg-quelle_areal-f392340",
"nuernberg-quelle_park-f471200",
"nuernberg-quelle_park-f471210",
"nuernberg-quelle_park-f471260",
"nuernberg-quelle_park-f471270",
"nuernberg-quelle-c156510",
"nuernberg-quelle-c199820",
"nuernberg-quelle-f407270",
"nuernberg-quelle-f413600",
"nuernberg-quelle-park-f493560",
"nuernberg-quelle-park-f493580",
"nuernberg-quellepark-n531250",
"nuernberg-quelleturm-c124650",
"nuernberg-quelleturm-n531290",
"nuernberg-raben_spedition-f39130",
"nuernberg-rabus-n294400",
"nuernberg-radar_am_flughafen-cb98960",
"nuernberg-radrennbahn-n146300",
"nuernberg-radrennbahn-n146320",
"nuernberg-radrennbahn-n146370",
"nuernberg-radrennbahn-n146380",
"nuernberg-raeumfahrzeuge-c108490",
"nuernberg-rahm-cc17840",
"nuernberg-rahtenauplatz-cc17530",
"nuernberg-raiffeisenstrasse-f383030",
"nuernberg-raiffeisenstrasse-f383040",
"nuernberg-raiffeisenstrasse-f393860",
"nuernberg-raiffeisenstrasse-f455910",
"nuernberg-raiffeisenstrasse-f472350",
"nuernberg-raiffeisenstrasse-f472360",
"nuernberg-raiffeisenstrasse-n06820",
"nuernberg-rampen_bruecke-b181600",
"nuernberg-rampen_bruecke-b181610",
"nuernberg-rampen_bruecke-b181650",
"nuernberg-rampen_bruecke-b181680",
"nuernberg-rampen_bruecke-b181740",
"nuernberg-rampen-c155460",
"nuernberg-rampen-c155490",
"nuernberg-rampen-n149040",
"nuernberg-rampen-n149050",
"nuernberg-rampen-n149070",
"nuernberg-rangierbahnhof__rondel_-f425590",
"nuernberg-rangierbahnhof-b183530",
"nuernberg-rangierbahnhof-b183540",
"nuernberg-rangierbahnhof-b183560",
"nuernberg-rangierbahnhof-b183580",
"nuernberg-rangierbahnhof-c036210",
"nuernberg-rangierbahnhof-c036320",
"nuernberg-rangierbahnhof-c036890",
"nuernberg-rangierbahnhof-c036930",
"nuernberg-rangierbahnhof-c052790",
"nuernberg-rangierbahnhof-c08230",
"nuernberg-rangierbahnhof-c08270",
"nuernberg-rangierbahnhof-c08430",
"nuernberg-rangierbahnhof-c111200",
"nuernberg-rangierbahnhof-c111220",
"nuernberg-rangierbahnhof-c187630",
"nuernberg-rangierbahnhof-c187650",
"nuernberg-rangierbahnhof-c226160",
"nuernberg-rangierbahnhof-c226180",
"nuernberg-rangierbahnhof-c232680",
"nuernberg-rangierbahnhof-c232690",
"nuernberg-rangierbahnhof-c242150",
"nuernberg-rangierbahnhof-c242170",
"nuernberg-rangierbahnhof-c242200",
"nuernberg-rangierbahnhof-c252250",
"nuernberg-rangierbahnhof-c252260",
"nuernberg-rangierbahnhof-c252270",
"nuernberg-rangierbahnhof-c252280",
"nuernberg-rangierbahnhof-c281200",
"nuernberg-rangierbahnhof-cc41030",
"nuernberg-rangierbahnhof-cc4990",
"nuernberg-rangierbahnhof-f38850",
"nuernberg-rangierbahnhof-f395610",
"nuernberg-rangierbahnhof-f403640",
"nuernberg-rangierbahnhof-f425600",
"nuernberg-rangierbahnhof-f425620",
"nuernberg-rangierbahnhof-f490470",
"nuernberg-rangierbahnhof-f491550",
"nuernberg-rangierbahnhof-f491660",
"nuernberg-rangierbahnhof-f540640",
"nuernberg-rangierbahnhof-f540820",
"nuernberg-rangierbahnhof-n294310",
"nuernberg-rangierbahnhof-n294330",
"nuernberg-rangierbahnhof-n36980",
"nuernberg-rangierbahnhof-nn65060",
"nuernberg-rangierbahnhof-siedlung-c232700",
"nuernberg-rangierbahnhof-siedlung-c232710",
"nuernberg-rangierbahnhof-siedlung-c232730",
"nuernberg-rangierbahnhof-siedlung-c252290",
"nuernberg-rangierbahnhofsiedlung-f406690",
"nuernberg-rangierbahnhofsiedlung-f406700",
"nuernberg-rangierbahnhofsiedlung-f490480",
"nuernberg-rangierbahnhofsiedlung-f490490",
"nuernberg-rangierbahnhofsiedlung-f491530",
"nuernberg-rangierbahnhofsiedlung-f491540",
"nuernberg-rangierbahnhofsiedlung-f491680",
"nuernberg-rangierbahnhofsiedlung-f513920",
"nuernberg-rangierbahnhof-siedlung-n361010",
"nuernberg-rangierbahnsiedlung-f513940",
"nuernberg-ranigerbahnhof-c213360",
"nuernberg-rankestrasse-c153830",
"nuernberg-rankestrasse-c153940",
"nuernberg-rankestrasse-c153950",
"nuernberg-rankestrasse-c153960",
"nuernberg-rankestrasse-c154050",
"nuernberg-rankestrasse-c154100",
"nuernberg-rasthof-n145310",
"nuernberg-rasthof-n145340",
"nuernberg-rasthof-n145360",
"nuernberg-rathaus___lorenzkirche-f405460",
"nuernberg-rathaus___sebalduskirche-c108960",
"nuernberg-rathaus___sebalduskirche-c119990",
"nuernberg-rathaus___sebalduskirche-cc26020",
"nuernberg-rathaus___sebalduskirche-cc31990",
"nuernberg-rathaus___sebalduskirche-cc33140",
"nuernberg-rathaus___sebalduskirche-f530730",
"nuernberg-rathaus___sebalduskirche-n33470",
"nuernberg-rathaus-b181250",
"nuernberg-rathaus-b181300",
"nuernberg-rathaus-cc33600",
"nuernberg-rathenauplatz_bei_nacht-c04860",
"nuernberg-rathenauplatz-c052010",
"nuernberg-rathenauplatz-c052030",
"nuernberg-rathenauplatz-c121500",
"nuernberg-rathenauplatz-c121580",
"nuernberg-rathenauplatz-c121680",
"nuernberg-rathenauplatz-c121690",
"nuernberg-rathenauplatz-c156150",
"nuernberg-rathenauplatz-c187190",
"nuernberg-rathenauplatz-c194230",
"nuernberg-rathenauplatz-c226380",
"nuernberg-rathenauplatz-c243720",
"nuernberg-rathenauplatz-c253590",
"nuernberg-rathenauplatz-cb840",
"nuernberg-rathenauplatz-cb8650",
"nuernberg-rathenauplatz-f381770",
"nuernberg-rathenauplatz-f383800",
"nuernberg-rathenauplatz-f394710",
"nuernberg-rathenauplatz-f39900",
"nuernberg-rathenauplatz-f39910",
"nuernberg-rathenauplatz-f434990",
"nuernberg-rathenauplatz-f464730",
"nuernberg-rathenauplatz-f471480",
"nuernberg-rathenauplatz-f484750",
"nuernberg-rathenauplatz-f530750",
"nuernberg-rathenauplatz-f532180",
"nuernberg-rathenauplatz-f532190",
"nuernberg-rathenauplatz-f532200",
"nuernberg-rathenauplatz-f532220",
"nuernberg-rathenauplatz-f532240",
"nuernberg-rathenauplatz-f532250",
"nuernberg-rathenauplatz-f532260",
"nuernberg-rathenauplatz-f532690",
"nuernberg-rathenauplatz-f550200",
"nuernberg-rathenauplatz-n055700",
"nuernberg-rathenauplatz-n076110",
"nuernberg-rathenauplatz-n14110",
"nuernberg-rathenauplatz-n14120",
"nuernberg-rathenauplatz-n14250",
"nuernberg-rathenauplatz-n247780",
"nuernberg-rathenauplatz-n274970",
"nuernberg-rathenauplatz-n33490",
"nuernberg-rathenauplatz-n33550",
"nuernberg-rathenauplatz-n525240",
"nuernberg-rathenauplatz-n525250",
"nuernberg-rathenauplatz-n530650",
"nuernberg-rathenauplatz-n550100",
"nuernberg-rathenauplatz-nn77480",
"nuernberg-rechenberganlage-f493060",
"nuernberg-rechenberg-n261850",
"nuernberg-rechenberg-n510420",
"nuernberg-rechenberg-n510430",
"nuernberg-rechenberg-n515480",
"nuernberg-recylinghof-n149010",
"nuernberg-recylinghof-n149020",
"nuernberg-recylinghof-n149030",
"nuernberg-rednitzstrasse-c19440",
"nuernberg-rednitztal-bruecke-c254280",
"nuernberg-reformations-gedaechtnis-kirche-c105240",
"nuernberg-reformations-gedaechtnis-kirche-c105280",
"nuernberg-reformations-gedaechtnis-kirche-c563890",
"nuernberg-reformations-gedaechtnis-kirche-f383490",
"nuernberg-reformations-gedaechtnis-kirche-f406870",
"nuernberg-reformations-gedaechtnis-kirche-f472110",
"nuernberg-reformations-gedaechtnis-kirche-f472110",
"nuernberg-reformations-gedaechtnis-kirche-n012310",
"nuernberg-regenburger_strasse-f554730",
"nuernberg-regenburger_viertel-f554640",
"nuernberg-regenburger_viertel-f554760",
"nuernberg-regenburger_viertel-f554780",
"nuernberg-regensburger_strasse___hainstrasse-c31800",
"nuernberg-regensburger_strasse___hainstrasse-c31810",
"nuernberg-regensburger_strasse___hainstrasse-f426540",
"nuernberg-regensburger_strasse___hainstrasse-f426560",
"nuernberg-regensburger_strasse___hainstrasse-f444630",
"nuernberg-regensburger_strasse___hainstrasse-f444650",
"nuernberg-regensburger_strasse___hainstrasse-f444660",
"nuernberg-regensburger_strasse___hainstrasse-f444670",
"nuernberg-regensburger_strasse___hainstrasse-f444730",
"nuernberg-regensburger_strasse___hainstrasse-f455190",
"nuernberg-regensburger_strasse___hainstrasse-n32160",
"nuernberg-regensburger_strasse___hainstrasse-n341720",
"nuernberg-regensburger_strasse___hainstrasse-n341780",
"nuernberg-regensburger_strasse___hainstrasse-n341800",
"nuernberg-regensburger_strasse-c106760",
"nuernberg-regensburger_strasse-c161770",
"nuernberg-regensburger_strasse-c19850",
"nuernberg-regensburger_strasse-c207470",
"nuernberg-regensburger_strasse-c231480",
"nuernberg-regensburger_strasse-c231500",
"nuernberg-regensburger_strasse-c231510",
"nuernberg-regensburger_strasse-c231520",
"nuernberg-regensburger_strasse-c231530",
"nuernberg-regensburger_strasse-c231610",
"nuernberg-regensburger_strasse-c282140",
"nuernberg-regensburger_strasse-c31680",
"nuernberg-regensburger_strasse-c31690",
"nuernberg-regensburger_strasse-c31700",
"nuernberg-regensburger_strasse-f382670",
"nuernberg-regensburger_strasse-f383340",
"nuernberg-regensburger_strasse-f38790",
"nuernberg-regensburger_strasse-f38810",
"nuernberg-regensburger_strasse-f405990",
"nuernberg-regensburger_strasse-f412190",
"nuernberg-regensburger_strasse-f412200",
"nuernberg-regensburger_strasse-f412270",
"nuernberg-regensburger_strasse-f464610",
"nuernberg-regensburger_strasse-f47750",
"nuernberg-regensburger_strasse-f47820",
"nuernberg-regensburger_strasse-f502450",
"nuernberg-regensburger_strasse-n076130",
"nuernberg-regensburger_strasse-n076140",
"nuernberg-regensburger_strasse-n263170",
"nuernberg-regensburger_strasse-n293810",
"nuernberg-regensburger_strasse-n361030",
"nuernberg-regensburger_strasse-n36460",
"nuernberg-regensburger_strasse-n510520",
"nuernberg-regensburger_viertel__siedlungswerk_nuernberg_-f47760",
"nuernberg-regensburger_viertel__siedlungswerk_nuernberg_-f47770",
"nuernberg-regensburger_viertel__siedlungswerk_nuernberg_-f47780",
"nuernberg-regensburger_viertel-c505320",
"nuernberg-regiomontanus_sternwarte-c121300",
"nuernberg-regiomontanus_sternwarte-c121330",
"nuernberg-regiomontanus_sternwarte-c121340",
"nuernberg-regiomontanus_sternwarte-c121350",
"nuernberg-regiomontanus_sternwarte-c121370",
"nuernberg-regio-werkstatt_nuernberg-s562250",
"nuernberg-regio-werkstatt_nuernberg-s562260",
"nuernberg-regomontanus_sternwarte-f493060",
"nuernberg-regomontanus_sternwarte-f493090",
"nuernberg-rehhof-f520360",
"nuernberg-rehhof-n145150",
"nuernberg-rehhof-n525040",
"nuernberg-rehhof-n525050",
"nuernberg-reichelsdorfer_keller-n146260",
"nuernberg-reichelsdorf-f412560",
"nuernberg-reichelsdorf-f412570",
"nuernberg-reichelsdorf-f412620",
"nuernberg-reichelsdorf-n245950",
"nuernberg-reichelsdorf-n246000",
"nuernberg-reichsparteitagsgelaende-f443820",
"nuernberg-reichsparteitagsgelaende-f443860",
"nuernberg-reifen_lorenz-f434030",
"nuernberg-reindelstrasse-f471870",
"nuernberg-reindlstrasse-c212290",
"nuernberg-reindlstrasse-c212320",
"nuernberg-reinigung_woehrder_see-c038570",
"nuernberg-reinigung_woehrder_see-c038590",
"nuernberg-reiterstaffel-f485130",
"nuernberg-reitstaffel_nuernberg-f435400",
"nuernberg-reitstaffel-f407930",
"nuernberg-reitstaffel-f407940",
"nuernberg-reitstaffel-f407950",
"nuernberg-reitstaffel-f472520",
"nuernberg-reitstaffel-n531560",
"nuernberg-rennweg___schoppershof-c283170",
"nuernberg-rennweg-c107940",
"nuernberg-rennweg-c108170",
"nuernberg-rennweg-c108200",
"nuernberg-rennweg-c119520",
"nuernberg-rennweg-c207970",
"nuernberg-rennweg-c207980",
"nuernberg-rennweg-c207990",
"nuernberg-rennweg-c208000",
"nuernberg-rennweg-c208010",
"nuernberg-rennweg-c208020",
"nuernberg-rennweg-c505590",
"nuernberg-rennweg-f407780",
"nuernberg-rennweg-f472240",
"nuernberg-rennweg-n262050",
"nuernberg-rennweg-n515500",
"nuernberg-rennweg-n515520",
"nuernberg-rennweg-n525220",
"nuernberg-resi-c068490",
"nuernberg-resi-c121190",
"nuernberg-resi-c23690",
"nuernberg-resi-f406940",
"nuernberg-resi-n261040",
"nuernberg-resi-nn67160",
"nuernberg-reststoffdeponie_nuernberg-sued-c281760",
"nuernberg-reststoffdeponie_nuernberg-sued-f444280",
"nuernberg-reststoffdeponie-f402960",
"nuernberg-reutles-c208570",
"nuernberg-rewe_pillenreuther-n246820",
"nuernberg-rewe_pillenreuther-n246850",
"nuernberg-rewe_pillenreuther-n246940",
"nuernberg-rheinstrasse-n146640",
"nuernberg-richard-wagner-platz-c196350",
"nuernberg-richard-wagner-platz-c196380",
"nuernberg-richard-wagner-platz-c226450",
"nuernberg-richard-wagner-platz-f413350",
"nuernberg-richard-wagner-platz-nn65610",
"nuernberg-richard-wagner-platz-nn66860",
"nuernberg-riesenrad-c153870",
"nuernberg-rieterbogen_kornburg-f490580",
"nuernberg-rieterbogen_kornburg-f490590",
"nuernberg-rieterbogen_kornburg-f490610",
"nuernberg-rieterbogen_kornburg-f490620",
"nuernberg-rieterbogen_kornburg-f490650",
"nuernberg-rieterbogen_kornburg-f490680",
"nuernberg-ringlokschuppen-n36960",
"nuernberg-rochusfriedhof-cb99680",
"nuernberg-rochusfriedhof-f381260",
"nuernberg-rochusfriedhof-f392160",
"nuernberg-rochusfriedhof-n263950",
"nuernberg-rock_im_park-c505270",
"nuernberg-rock_im_park-c505280",
"nuernberg-rock_im_park-c505290",
"nuernberg-rock_im_park-c505300",
"nuernberg-rock_im_park-c505330",
"nuernberg-rock_im_park-c505340",
"nuernberg-rock_im_park-c505350",
"nuernberg-rock_im_park-c505380",
"nuernberg-rock_im_park-c505390",
"nuernberg-rock_im_park-f502430",
"nuernberg-rock_im_park-f502440",
"nuernberg-rock_im_park-f502480",
"nuernberg-roethenbach-c089470",
"nuernberg-roethenbach-c19200",
"nuernberg-roethenbach-c19210",
"nuernberg-roethenbach-c19220",
"nuernberg-roethenbach-c19230",
"nuernberg-roethenbach-c199970",
"nuernberg-roethenbacher_einkaufszentrum-f384680",
"nuernberg-roethenbacher_einkaufszentrum-f491800",
"nuernberg-roethenbach-f391390",
"nuernberg-roethenbach-f391400",
"nuernberg-roethenbach-f391530",
"nuernberg-roethenbach-f391540",
"nuernberg-roethenbach-f391550",
"nuernberg-roethenbach-f405660",
"nuernberg-roethenbach-f412070",
"nuernberg-roethenbach-f412080",
"nuernberg-roethenbach-f491790",
"nuernberg-roethenbach-f491800",
"nuernberg-roethenbach-f491940",
"nuernberg-roethenbach-f491950",
"nuernberg-roethenbach-n146800",
"nuernberg-roethenbach-n146810",
"nuernberg-roethensteig-c564160",
"nuernberg-roethgasse-c118740",
"nuernberg-roethgasse-c312940",
"nuernberg-roethgasse-c312970",
"nuernberg-roethgasse-n531460",
"nuernberg-roethgasse-n531490",
"nuernberg-roethgasse-n531570",
"nuernberg-rollnerstrasse-c123760",
"nuernberg-rollnerstrasse-c132620",
"nuernberg-rollnerstrasse-c132650",
"nuernberg-rollnerstrasse-c207880",
"nuernberg-rollnerstrasse-c208270",
"nuernberg-rollnerstrasse-c208280",
"nuernberg-rollnerstrasse-c21850",
"nuernberg-rollnerstrasse-f382930",
"nuernberg-rollnerstrasse-f38760",
"nuernberg-rollnerstrasse-n144420",
"nuernberg-ronhof-f407170",
"nuernberg-roonstrasse_novartis-c124590",
"nuernberg-roonstrasse-c192830",
"nuernberg-roonstrasse-c19800",
"nuernberg-roonstrasse-c252070",
"nuernberg-roonstrasse-cd17690",
"nuernberg-roonstrasse-f381270",
"nuernberg-roonstrasse-f383890",
"nuernberg-roonstrasse-f383890",
"nuernberg-roonstrasse-f383900",
"nuernberg-roonstrasse-f412990",
"nuernberg-roonstrasse-f413540",
"nuernberg-roonstrasse-f471450",
"nuernberg-roonstrasse-n263560",
"nuernberg-roonstrasse-n294950",
"nuernberg-rosa-lusemburg-platz-f532230",
"nuernberg-rosenau-cc17300",
"nuernberg-rosenau-cc31520",
"nuernberg-rosenau-f392180",
"nuernberg-rosenau-f492510",
"nuernberg-rosenau-f554920",
"nuernberg-rosenau-n263960",
"nuernberg-rosenaupark-cb99620",
"nuernberg-rosenaupark-n149150",
"nuernberg-rosenaupark-n263920",
"nuernberg-rosenaupark-n263930",
"nuernberg-rosenaupark-n263940",
"nuernberg-rosental-c173210",
"nuernberg-rothenburger_strasse___virnsberger_strasse-n074870",
"nuernberg-rothenburger_strasse__strassenanbindung_-n363760",
"nuernberg-rothenburger_strasse_ecke_bluecherstrasse-n075930",
"nuernberg-rothenburger_strasse_ecke_fuggerstrasse-n075840",
"nuernberg-rothenburger_strasse-c283820",
"nuernberg-rothenburger_strasse-f384370",
"nuernberg-rothenburger_strasse-f425810",
"nuernberg-rothenburger_strasse-f435250",
"nuernberg-rothenburger_strasse-f530700",
"nuernberg-rothenburger_strasse-f554860",
"nuernberg-rothenburger_strasse-n363740",
"nuernberg-rotterdamer_strasse-c152500",
"nuernberg-rotterdamer_strasse-c152510",
"nuernberg-rudolf-steiner-schule-f464870",
"nuernberg-rueckertstrasse-n362950",
"nuernberg-ruesternweg-n146660",
"nuernberg-rundfunkmuseum-c068860",
"nuernberg-rundfunkstudio_des_br-f394330",
"nuernberg-sandreuth__n-ergie-n540230",
"nuernberg-sandreuth__n-ergie-n540240",
"nuernberg-sandreuth__n-ergie-n540250",
"nuernberg-sandreuth-c037310",
"nuernberg-sandreuth-c187710",
"nuernberg-sandreuth-c187720",
"nuernberg-sandreuth-c188270",
"nuernberg-sandreuth-c19510",
"nuernberg-sandreuth-c226680",
"nuernberg-sandreuth-c28400",
"nuernberg-sandreuth-f3970",
"nuernberg-sandreuth-f3980",
"nuernberg-sandreuth-f405720",
"nuernberg-sandreuth-f406330",
"nuernberg-sandreuth-f412390",
"nuernberg-sandreuth-f424220",
"nuernberg-sandreuth-f463720",
"nuernberg-sandreuth-n341690",
"nuernberg-sandstrasse-f434090",
"nuernberg-sandstrasse-f435180",
"nuernberg-sandstrasse-f492470",
"nuernberg-sandstrasse-n29620",
"nuernberg-sandstrasse-n29630",
"nuernberg-sandstrasse-n342040",
"nuernberg-sankt_martin_kirche-c563750",
"nuernberg-sankt-paul-haus-c031780",
"nuernberg-sausalitos-f434080",
"nuernberg-sc_worzeldorf-c232630",
"nuernberg-schafherde-f490250",
"nuernberg-schafhof_und_herrnhuette-n362250",
"nuernberg-schafhof-c156110",
"nuernberg-schafhof-f381840",
"nuernberg-schafhof-f406890",
"nuernberg-schafhof-n362210",
"nuernberg-schafhof-nn67250",
"nuernberg-scharfreiterring-f406600",
"nuernberg-scharfreiterring-f406630",
"nuernberg-scharfreiterring-f406640",
"nuernberg-scharfreiterring-f406650",
"nuernberg-scharfreiterring-f406680",
"nuernberg-scharnhorststrasse-f393680",
"nuernberg-schauspielhaus-f382710",
"nuernberg-schauspielhaus-n148360",
"nuernberg-schauspielhaus-n148370",
"nuernberg-schauspielhaus-n148380",
"nuernberg-schauspielhaus-n148390",
"nuernberg-schauspielhaus-n148400",
"nuernberg-schauspielhaus-nn81280",
"nuernberg-schenker-b183810",
"nuernberg-schiffanlegestelle-c241580",
"nuernberg-schiffanlegestelle-c241640",
"nuernberg-schiffanlegestelle-c241660",
"nuernberg-schiffanlegestelle-c241680",
"nuernberg-schiffanlegestelle-c241710",
"nuernberg-schiffanlegestelle-c242120",
"nuernberg-schiff-c135580",
"nuernberg-schiffe-b183790",
"nuernberg-schiffe-b183800",
"nuernberg-schifffahrt-nn75580",
"nuernberg-schillerplatz-c10110",
"nuernberg-schillerplatz-c10120",
"nuernberg-schillerplatz-n29320",
"nuernberg-schillerplatz-n29330",
"nuernberg-schillingstrasse-c24560",
"nuernberg-schillingstrasse-c24730",
"nuernberg-schillingstrasse-c252350",
"nuernberg-schillingstrasse-c252360",
"nuernberg-schillingstrasse-c252390",
"nuernberg-schillingstrasse-c252420",
"nuernberg-schillingstrasse-c252430",
"nuernberg-schillingstrasse-c282560",
"nuernberg-schillingstrasse-c282610",
"nuernberg-schillingstrasse-c31930",
"nuernberg-schillingstrasse-c31940",
"nuernberg-schillingstrasse-c31960",
"nuernberg-schillingstrasse-f490410",
"nuernberg-schillingstrasse-f491600",
"nuernberg-schillingstrasse-f540670",
"nuernberg-schillingstrasse-f540690",
"nuernberg-schillingstrasse-n262850",
"nuernberg-schillingstrasse-n262860",
"nuernberg-schillingstrasse-n262870",
"nuernberg-schillingstrasse-n262880",
"nuernberg-schillingstrasse-n262890",
"nuernberg-schillingstrasse-n262900",
"nuernberg-schillingstrasse-n262910",
"nuernberg-schillingstrasse-n262920",
"nuernberg-schillingstrasse-n294480",
"nuernberg-schillingstrasse-n341640",
"nuernberg-schillingstrasse-n361360",
"nuernberg-schlachthof_und_pferdemarkt-n363860",
"nuernberg-schlachthof-b181770",
"nuernberg-schlachthof-b181810",
"nuernberg-schlayenturm_am_kettensteg-n274440",
"nuernberg-schleifweg-c563920",
"nuernberg-schleifweg-f472140",
"nuernberg-schleifweg-f492650",
"nuernberg-schleifweg-f514130",
"nuernberg-schleifweg-n144430",
"nuernberg-schleifweg-n149870",
"nuernberg-schleifweg-n29410",
"nuernberg-schleifweg-n33710",
"nuernberg-schleifweg-n362660",
"nuernberg-schleifweg-n362720",
"nuernberg-schleifweg-n362800",
"nuernberg-schleswiger_strasse-f472330",
"nuernberg-schleuse_am_hafen-f490790",
"nuernberg-schleuse_baustelle-n246480",
"nuernberg-schleuse_eibach-f381110",
"nuernberg-schleuse_eibach-f47250",
"nuernberg-schleuse_-f434170",
"nuernberg-schleuse-c213680",
"nuernberg-schleusenbecken_bei_hafen-n245830",
"nuernberg-schleusenbecken-cc4760",
"nuernberg-schleyer_turm-n274700",
"nuernberg-schlittschuhweiher-cc41650",
"nuernberg-schloss_grossgruendlach-c506020",
"nuernberg-schloss_grossgruendlach-cc5250",
"nuernberg-schloss_grossgruendlach-n056310",
"nuernberg-schloss_grossgruendlach-n525660",
"nuernberg-schloss_grossgruendlach-n525670",
"nuernberg-schloss_neunhof-cc24440",
"nuernberg-schloss_neunhof-f47100",
"nuernberg-schloss_neunhof-n510340",
"nuernberg-schloss_unterbuerg-n361950",
"nuernberg-schloss_unterbuerg-n361980",
"nuernberg-schloss_unterbuerg-n362010",
"nuernberg-schloss_unterbuerg-n362040",
"nuernberg-schlossaeckerstrasse-c122880",
"nuernberg-schlossaeckerstrasse-c122900",
"nuernberg-schlossaeckerstrasse-c122920",
"nuernberg-schlossaeckerstrasse-c122980",
"nuernberg-schlossstrasse-c31820",
"nuernberg-schmalau-c111990",
"nuernberg-schmalau-c124980",
"nuernberg-schmalau-c22230",
"nuernberg-schmalau-c254770",
"nuernberg-schmalau-c254830",
"nuernberg-schmalau-c564780",
"nuernberg-schmalau-c564790",
"nuernberg-schmalau-c564810",
"nuernberg-schmalau-c564820",
"nuernberg-schmalau-n249140",
"nuernberg-schmalau-n249150",
"nuernberg-schmalau-n249160",
"nuernberg-schmausenbuck-c231330",
"nuernberg-schmausenbuckturm-n262190",
"nuernberg-schmausenbuckturm-n262210",
"nuernberg-schmausenbuckturm-n262240",
"nuernberg-schmausenbuckturm-n262260",
"nuernberg-schmausenbuckturm-n262290",
"nuernberg-schmausenbuckturm-n262300",
"nuernberg-schmausenbuckturm-n262330",
"nuernberg-schmausenbuckturm-n262340",
"nuernberg-schmausengasse-f490330",
"nuernberg-schneise-n146530",
"nuernberg-schnepfenreuth-c152090",
"nuernberg-schnepfenreuth-c152100",
"nuernberg-schnepfenreuth-c227140",
"nuernberg-schnepfenreuth-c564340",
"nuernberg-schnepfenreuth-cc16870",
"nuernberg-schnepfenreuth-cc26510",
"nuernberg-schnepfenreuth-f381950",
"nuernberg-schnepfenreuth-f391140",
"nuernberg-schnepfenreuth-f393800",
"nuernberg-schnepfenreuth-f393810",
"nuernberg-schnepfenreuth-f393820",
"nuernberg-schnepfenreuth-f393830",
"nuernberg-schnepfenreuth-f393840",
"nuernberg-schnepfenreuth-f393850",
"nuernberg-schnepfenreuth-f407090",
"nuernberg-schnepfenreuth-f407120",
"nuernberg-schnepfenreuth-f472400",
"nuernberg-schniegling-c19730",
"nuernberg-schniegling-c227010",
"nuernberg-schniegling-c227030",
"nuernberg-schniegling-c253720",
"nuernberg-schniegling-c253730",
"nuernberg-schniegling-c253780",
"nuernberg-schniegling-c283950",
"nuernberg-schnieglinger_strasse_ecke_fuchsloch-cd17520",
"nuernberg-schnieglinger_strasse-c283960",
"nuernberg-schnieglinger_strasse-c283970",
"nuernberg-schnieglinger_strasse-f383650",
"nuernberg-schnieglinger_strasse-f426090",
"nuernberg-schnieglinger_strasse-f493370",
"nuernberg-schniegling-f39810",
"nuernberg-schniegling-f39830",
"nuernberg-schniegling-f39840",
"nuernberg-schniegling-f425950",
"nuernberg-schniegling-f435310",
"nuernberg-schniegling-f445520",
"nuernberg-schniegling-f455870",
"nuernberg-schniegling-f465500",
"nuernberg-schniegling-f472500",
"nuernberg-schniegling-f484890",
"nuernberg-schniegling-f493660",
"nuernberg-schniegling-f493670",
"nuernberg-schniegling-n074780",
"nuernberg-schniegling-n364640",
"nuernberg-schniegling-n525470",
"nuernberg-schniegling-n525480",
"nuernberg-schoeller_holding-f434850",
"nuernberg-schoeller_links-f412760",
"nuernberg-schoeller-c312600",
"nuernberg-schoeller-c312690",
"nuernberg-schoeller-f381300",
"nuernberg-schoeller-f381750",
"nuernberg-schoeller-f381760",
"nuernberg-schoeller-f382060",
"nuernberg-schoeller-f382070",
"nuernberg-schoeller-f383610",
"nuernberg-schoeller-f383620",
"nuernberg-schoeller-f383630",
"nuernberg-schoeller-f383640",
"nuernberg-schoeller-f393230",
"nuernberg-schoeller-f411810",
"nuernberg-schoeller-f412760",
"nuernberg-schoeller-f434970",
"nuernberg-schoeller-f493180",
"nuernberg-schoeller-f540210",
"nuernberg-schoeller-f540220",
"nuernberg-schoeller-f550180",
"nuernberg-schoellerfabrik-cc33890",
"nuernberg-schoeller-n261370",
"nuernberg-schoeller-n531450",
"nuernberg-schoen_klinik-n530990",
"nuernberg-schoen_klinik-n531110",
"nuernberg-schoenleben_park-f424950",
"nuernberg-schoenleben_park-f425120",
"nuernberg-schoenleben_park-f425140",
"nuernberg-schoenleben_park-f425270",
"nuernberg-schoenleben_park-f444480",
"nuernberg-schoenleben_park-f444510",
"nuernberg-schoenleben_park-f47910",
"nuernberg-schoenleben_park-f47920",
"nuernberg-schoenleben_park-f47930",
"nuernberg-schoenleben-park-c505220",
"nuernberg-schoenleben-park-c505250",
"nuernberg-schoenleben-park-c505260",
"nuernberg-schoenlebenpark-n241010",
"nuernberg-schoenlebenpark-n241090",
"nuernberg-schoenlebenpark-n241170",
"nuernberg-schoenlebenpark-n241350",
"nuernberg-schoenlebenpark-n242430",
"nuernberg-schoenlebenpark-n242540",
"nuernberg-schoenlebenpark-n24960",
"nuernberg-schoenlebenpark-n24980",
"nuernberg-schoenweissstrasse-n147440",
"nuernberg-schopenhauerstrasse-f382090",
"nuernberg-schopenhauerstrasse-n077210",
"nuernberg-schopenhauerstrasse-n362770",
"nuernberg-schoppershof-c133830",
"nuernberg-schoppershof-c207960",
"nuernberg-schoppershof-c253540",
"nuernberg-schoppershof-c253560",
"nuernberg-schoppershof-c563900",
"nuernberg-schoppershof-f391070",
"nuernberg-schoppershof-f393570",
"nuernberg-schoppershof-f393580",
"nuernberg-schoppershof-f393590",
"nuernberg-schoppershof-f393710",
"nuernberg-schoppershof-f406860",
"nuernberg-schoppershof-f407790",
"nuernberg-schoppershof-f413490",
"nuernberg-schoppershof-f413500",
"nuernberg-schoppershof-f492670",
"nuernberg-schoppershof-f493120",
"nuernberg-schoppershof-f531350",
"nuernberg-schoppershof-n261840",
"nuernberg-schoppershof-n303700",
"nuernberg-schoppershof-n303710",
"nuernberg-schoppershof-n303720",
"nuernberg-schoppershof-n303740",
"nuernberg-schoppershofstrasse-f393700",
"nuernberg-schrebergaerten_am_fussballstadion-c036070",
"nuernberg-schrebergaerten-c136780",
"nuernberg-schrebergaerten-cc33950",
"nuernberg-schrebergaerten-n145160",
"nuernberg-schrebergaerten-n146850",
"nuernberg-schrotthaendler-f445520",
"nuernberg-schrottplatz_horneckerweg-c132590",
"nuernberg-schrottplatz-c123750",
"nuernberg-schrottplatz-c152560",
"nuernberg-schrottplatz-f47140",
"nuernberg-schuckertplatz-c154230",
"nuernberg-schule_gudrunstrasse-n147250",
"nuernberg-schule_gudrunstrasse-n147270",
"nuernberg-schule_gudrunstrasse-n147310",
"nuernberg-schule_gudrunstrasse-n147350",
"nuernberg-schule_gudrunstrasse-n147360",
"nuernberg-schule_kornburg-f425460",
"nuernberg-schule_naehe_rankestrasse-n147800",
"nuernberg-schule_schlachthof-b181760",
"nuernberg-schule_schlachthof-b181890",
"nuernberg-schule_schlachthof-b181900",
"nuernberg-schule_schlachthof-b181950",
"nuernberg-schule_st__leonhard-c283810",
"nuernberg-schule-f411870",
"nuernberg-schultheiss_wohnbau-f472310",
"nuernberg-schultheissallee-f406470",
"nuernberg-schultheissallee-f47990",
"nuernberg-schultheissallee-f540360",
"nuernberg-schultheissallee-n33330",
"nuernberg-schultheiss-c132320",
"nuernberg-schultheiss-f434030",
"nuernberg-schumannstrasse-n363460",
"nuernberg-schwabacher_strasse-n075970",
"nuernberg-schwaig_b__nuernberg-n525030",
"nuernberg-schwaig_bei_nuernberg-f403700",
"nuernberg-schwaig-c106860",
"nuernberg-schwaig-c106870",
"nuernberg-schwaig-c253330",
"nuernberg-schwaig-c253340",
"nuernberg-schwaig-c253350",
"nuernberg-schwaig-f403730",
"nuernberg-schwan_stabilo-c12240",
"nuernberg-schwan_stabilo-c208550",
"nuernberg-schwanhardtstrasse-n149430",
"nuernberg-schwarzachbruecke-f484300",
"nuernberg-schwarzachbruecke-f484310",
"nuernberg-schweiggerstrasse-n294210",
"nuernberg-schweinau_panorama-b184130",
"nuernberg-schweinau_panorama-b184140",
"nuernberg-schweinau-c172790",
"nuernberg-schweinau-c188110",
"nuernberg-schweinau-c28410",
"nuernberg-schweinau-c28510",
"nuernberg-schweinau-c312100",
"nuernberg-schweinauer_buck-c123980",
"nuernberg-schweinauer_buck-c135590",
"nuernberg-schweinauer_buck-f464370",
"nuernberg-schweinauer_buck-n146670",
"nuernberg-schweinauer_buck-n146710",
"nuernberg-schweinauer_strasse-n146720",
"nuernberg-schweinauerstrasse-n146760",
"nuernberg-schweinau-f383170",
"nuernberg-schweinau-f39250",
"nuernberg-schweinau-f393350",
"nuernberg-schweinau-f393380",
"nuernberg-schweinau-f405630",
"nuernberg-schweinau-f405670",
"nuernberg-schweinau-f405680",
"nuernberg-schweinau-f412130",
"nuernberg-schweinau-f464470",
"nuernberg-schweinau-f464510",
"nuernberg-schweinau-f491910",
"nuernberg-schweinau-f491920",
"nuernberg-schweinau-f530690",
"nuernberg-schweinau-n146730",
"nuernberg-schweinau-n146770",
"nuernberg-schweinau-n146790",
"nuernberg-schweinau-n243530",
"nuernberg-schweinau-n243540",
"nuernberg-schweinau-n274340",
"nuernberg-scnieglinger_strasse-c123050",
"nuernberg-sebald_kontore-c108860",
"nuernberg-sebald_kontore-c108890",
"nuernberg-sebald_kontore-c119530",
"nuernberg-sebald_kontore-n076910",
"nuernberg-sebald_kontore-n077050",
"nuernberg-sebald_kontore-nn77370",
"nuernberg-sebalder_hoefe-cb8660",
"nuernberg-sebalder_hoefe-f426140",
"nuernberg-sebalduskirche___rathaus-c121740",
"nuernberg-sebalduskirche___rathaus-cc33060",
"nuernberg-sebalduskirche___rathaus-cc4320",
"nuernberg-sebalduskirche___rathaus-f405350",
"nuernberg-sebalduskirche___rathaus-f405350",
"nuernberg-sebalduskirche___rathaus-f464750",
"nuernberg-sebalduskirche___rathaus-f532780",
"nuernberg-sebalduskirche_im_herbst-nn8700",
"nuernberg-sebalduskirche-c082760",
"nuernberg-sebalduskirche-c121730",
"nuernberg-sebalduskirche-c121830",
"nuernberg-sebalduskirche-c155040",
"nuernberg-sebalduskirche-c187100",
"nuernberg-sebalduskirche-c187110",
"nuernberg-sebalduskirche-c187120",
"nuernberg-sebalduskirche-c195750",
"nuernberg-sebalduskirche-c196210",
"nuernberg-sebalduskirche-c233160",
"nuernberg-sebalduskirche-cc19100",
"nuernberg-sebalduskirche-cc33270",
"nuernberg-sebalduskirche-cc33580",
"nuernberg-sebalduskirche-f407500",
"nuernberg-sebalduskirche-f407510",
"nuernberg-sebalduskirche-f407560",
"nuernberg-sebalduskirche-f412850",
"nuernberg-sebalduskirche-f426680",
"nuernberg-sebalduskirche-n294780",
"nuernberg-sebaldusstrasse-c10240",
"nuernberg-sebaldusstrasse-n540180",
"nuernberg-sebastianspital_und_boulevardsteg-c23640",
"nuernberg-sebastianspital-c117530",
"nuernberg-sebastianspital-c117540",
"nuernberg-sebastianspital-c133130",
"nuernberg-sebastianspital-c232800",
"nuernberg-sebastianspital-c23620",
"nuernberg-sebastianspital-c23630",
"nuernberg-sebastianspital-n261890",
"nuernberg-sebastianspital-n261900",
"nuernberg-sebastianspital-n261910",
"nuernberg-sebastianspital-n261920",
"nuernberg-sebastianspital-n261930",
"nuernberg-sebastianspital-nn77020",
"nuernberg-sebastianspital-nn77050",
"nuernberg-sebastianspital-nn77110",
"nuernberg-seetor_city_campus-f492780",
"nuernberg-seetor_city_campus-f492820",
"nuernberg-seetor_city_campus-f492830",
"nuernberg-seetor_city_campus-f492850",
"nuernberg-seetor_city_campus-f530870",
"nuernberg-seetor_city_campus-f530880",
"nuernberg-seetor_city_campus-f530890",
"nuernberg-seetor_city_campus-n510460",
"nuernberg-seetor_city_campus-n510470",
"nuernberg-seetor_city_campus-n515380",
"nuernberg-seetor_city_campus-n515400",
"nuernberg-seetor_city_campus-n515410",
"nuernberg-seetor_city_campus-n515420",
"nuernberg-seetor_city_campus-n515440",
"nuernberg-seetor_city_campus-n525130",
"nuernberg-seetor_city-f405070",
"nuernberg-seetor-f464690",
"nuernberg-seetor-f472060",
"nuernberg-segmueller-f404940",
"nuernberg-selfstorage-n075280",
"nuernberg-sellbytell-cc32870",
"nuernberg-senefelderstrasse-c10310",
"nuernberg-seniorenanlage_bingstrasse-c106810",
"nuernberg-senioren-wohnanlage_platnersberg-nn67320",
"nuernberg-senkrechtaufnahme-c156570",
"nuernberg-senkrechtaufnahme-cc16970",
"nuernberg-senkrechtaufnahme-cc32580",
"nuernberg-senkrechtaufnahme-nn65090",
"nuernberg-serenadenhof-c153890",
"nuernberg-seumestrasse-c24240",
"nuernberg-seumestrasse-c24260",
"nuernberg-sf_grossgruendlach-f456070",
"nuernberg-sf_grossgruendlach-f456070",
"nuernberg-sf_grossgruendlach-f541160",
"nuernberg-sf_grossgruendlach-f541170",
"nuernberg-sf_grossgruendlach-n525620",
"nuernberg-sf_grossgruendlach-n550080",
"nuernberg-sieben_zeilen-c133990",
"nuernberg-siedlung_materlach-f491760",
"nuernberg-siemens___man-f405740",
"nuernberg-siemens_-_von_der_tann_strasse-cd18050",
"nuernberg-siemens_altenfurt-c171410",
"nuernberg-siemens_altenfurt-n242370",
"nuernberg-siemens_altenfurt-n242400",
"nuernberg-siemens_altenfurt-n242410",
"nuernberg-siemens_energy-f425630",
"nuernberg-siemens_energy-f540840",
"nuernberg-siemens_gugelstrasse-c281270",
"nuernberg-siemens_nuernberg-f471040",
"nuernberg-siemens-c052650",
"nuernberg-siemens-c055740",
"nuernberg-siemens-c135800",
"nuernberg-siemens-c135840",
"nuernberg-siemens-c152380",
"nuernberg-siemens-c188300",
"nuernberg-siemens-c19450",
"nuernberg-siemens-f391310",
"nuernberg-siemens-f406300",
"nuernberg-siemens-f425660",
"nuernberg-siemens-f425720",
"nuernberg-siemens-f434720",
"nuernberg-siemens-f492030",
"nuernberg-siemens-f492040",
"nuernberg-siemens-n294390",
"nuernberg-siemens-n363950",
"nuernberg-siemensstrasse-c154220",
"nuernberg-sigena_st__johannis__wbg_-f455830",
"nuernberg-sigmundstrasse-c199840",
"nuernberg-sigmundstrasse-f492220",
"nuernberg-sigmundstrasse-f492230",
"nuernberg-sigmundstrasse-f530380",
"nuernberg-sigmundstrasse-f530410",
"nuernberg-sinwellturm-c156330",
"nuernberg-sinwellturm-c193690",
"nuernberg-sinwellturm-nn83080",
"nuernberg-soederblomstrasse-f445160",
"nuernberg-soederblomstrasse-f445340",
"nuernberg-soederblomstrasse-f445350",
"nuernberg-soer-c105180",
"nuernberg-soer-c563950",
"nuernberg-soer-f472160",
"nuernberg-soer-f472160",
"nuernberg-soer-n144380",
"nuernberg-soer-n144400",
"nuernberg-soer-n29240",
"nuernberg-solar-c156530",
"nuernberg-solnhofener_beton-f492230",
"nuernberg-sommertage_am_aufsessplatz-f384270",
"nuernberg-sommertage_am_hauptmarkt-f382390",
"nuernberg-sommertage_am_hauptmarkt-f382410",
"nuernberg-sommertage_am_hauptmarkt-f383830",
"nuernberg-sommertage_auf_der_insel_schuett-f382810",
"nuernberg-sommertage_auf_der_insel_schuett-f383820",
"nuernberg-sozailgericht_nuernberg-f492420",
"nuernberg-sozialgericht_nuernberg-f484810",
"nuernberg-sparkasse_marientorgraben-n055540",
"nuernberg-sparkasse_marientorgraben-nn82650",
"nuernberg-sparkasse-c192230",
"nuernberg-spedition_emons-b183830",
"nuernberg-spiegelsaal-b182900",
"nuernberg-spielplatz_am_friedrich-ebert-platz-c119730",
"nuernberg-spielplatz_rechenberg-n362400",
"nuernberg-spielplatz-c11470",
"nuernberg-spielplatz-n145100",
"nuernberg-spittlertorturm-f554970",
"nuernberg-spittlertorzwinger-c226500",
"nuernberg-spohrstrasse-c283540",
"nuernberg-spohrstrasse-n264050",
"nuernberg-spohrstrasse-n264060",
"nuernberg-spohrstrasse-n264080",
"nuernberg-spohrstrasse-n363400",
"nuernberg-spohrstrasse-n363440",
"nuernberg-spohrstrasse-n363480",
"nuernberg-sportanlage_in_zerzabelshof-cc53840",
"nuernberg-sportboothafen_nuernberg-f471090",
"nuernberg-sportgemeinschaft_viktoria_nuernberg-fuerth_1883-c564360",
"nuernberg-sportgemeinschaft_viktoria_nuernberg-fuerth_1883-c564370",
"nuernberg-sportgemeinschaft_viktoria_nuernberg-fuerth_1883-f445360",
"nuernberg-sportgemeinschaft_viktoria-c312190",
"nuernberg-sporthalle_am_tillypark__baustelle_-n363560",
"nuernberg-sportheim_asv_buchenbuehl-cc42750",
"nuernberg-sportheim_asv_buchenbuehl-cc42760",
"nuernberg-sportheim_asv_buchenbuehl-cc42830",
"nuernberg-sportpaetze_zerzabelshof-nn67690",
"nuernberg-sportpark_valznerweiher-c505310",
"nuernberg-sportpark_valznerweiher-f554790",
"nuernberg-sportpark_valznerweiher-n30450",
"nuernberg-sportpark_valznerweiher-n341520",
"nuernberg-sportpark_valznerweiher-n36440",
"nuernberg-sportplatz_asv_buchenbuehl-cc31310",
"nuernberg-sportplatz-b183660",
"nuernberg-sportplatz-n530370",
"nuernberg-sportverein_sc_viktoria-n075870",
"nuernberg-spvgg_nuernberg-f492160",
"nuernberg-spvgg_nuernberg-f492170",
"nuernberg-st__anton_kirche-c19610",
"nuernberg-st__egidien_kirche-f484770",
"nuernberg-st__egidienkirche-c563710",
"nuernberg-st__egidienkirche-c563720",
"nuernberg-st__elisabethkirche-c055500",
"nuernberg-st__elisabethkirche-cb99570",
"nuernberg-st__elisabethkirche-cb99580",
"nuernberg-st__elisabethkirche-n055240",
"nuernberg-st__elisabethkirche-nn83120",
"nuernberg-st__felicitas-kapelle-n29130",
"nuernberg-st__georg_wehrkirche-c208490",
"nuernberg-st__jakob_kirche___elisabethkirche-c122430",
"nuernberg-st__jakobskirche-n055260",
"nuernberg-st__jobst-f383430",
"nuernberg-st__jobst-f383470",
"nuernberg-st__jobst-f393670",
"nuernberg-st__jobst-f39430",
"nuernberg-st__jobst-f405130",
"nuernberg-st__jobst-f426480",
"nuernberg-st__jobst-f464840",
"nuernberg-st__jobst-f464850",
"nuernberg-st__jobst-f493040",
"nuernberg-st__jobst-f493100",
"nuernberg-st__jobst-f493110",
"nuernberg-st__jobst-n261730",
"nuernberg-st__jobst-n261790",
"nuernberg-st__jobst-n261800",
"nuernberg-st__jobst-n261810",
"nuernberg-st__jobst-n261820",
"nuernberg-st__jobst-n361450",
"nuernberg-st__jobst-n361820",
"nuernberg-st__jobst-n361860",
"nuernberg-st__jobst-n362360",
"nuernberg-st__jobst-n515330",
"nuernberg-st__jobst-n515460",
"nuernberg-st__jobst-n525120",
"nuernberg-st__jobst-n525150",
"nuernberg-st__jobst-n525160",
"nuernberg-st__jobst-n530690",
"nuernberg-st__johannis_friedhof-n261500",
"nuernberg-st__johannis_friedhof-n261510",
"nuernberg-st__johannis-c152360",
"nuernberg-st__johannis-c152370",
"nuernberg-st__johannis-c19740",
"nuernberg-st__johannis-c19760",
"nuernberg-st__johannis-c19770",
"nuernberg-st__johannis-c233180",
"nuernberg-st__johannis-c245170",
"nuernberg-st__johannis-c245220",
"nuernberg-st__johannis-c24780",
"nuernberg-st__johannis-c24800",
"nuernberg-st__johannis-c24810",
"nuernberg-st__johannis-c24830",
"nuernberg-st__johannis-c24840",
"nuernberg-st__johannis-c24990",
"nuernberg-st__johannis-c283450",
"nuernberg-st__johannis-c283460",
"nuernberg-st__johannis-c312220",
"nuernberg-st__johannis-c312250",
"nuernberg-st__johannis-c312280",
"nuernberg-st__johannis-c312310",
"nuernberg-st__johannis-cc17450",
"nuernberg-st__johannis-cc17470",
"nuernberg-st__johannis-f391190",
"nuernberg-st__johannis-f39380",
"nuernberg-st__johannis-f39390",
"nuernberg-st__johannis-f405500",
"nuernberg-st__johannis-f412790",
"nuernberg-st__johannis-f455750",
"nuernberg-st__johannis-f455790",
"nuernberg-st__johannis-f455830",
"nuernberg-st__johannis-f492270",
"nuernberg-st__johannis-f492590",
"nuernberg-st__johannis-f493230",
"nuernberg-st__johannis-f514200",
"nuernberg-st__johannis-f530280",
"nuernberg-st__johannis-f530290",
"nuernberg-st__johannis-f532140",
"nuernberg-st__johannis-f553860",
"nuernberg-st__johannis-n14510",
"nuernberg-st__johannis-n295160",
"nuernberg-st__johannis-s562200",
"nuernberg-st__konrad_kirche-f493660",
"nuernberg-st__leonhard-b181820",
"nuernberg-st__leonhard-b181830",
"nuernberg-st__leonhard-b181840",
"nuernberg-st__leonhard-b181970",
"nuernberg-st__leonhard-c283760",
"nuernberg-st__leonhard-c283770",
"nuernberg-st__leonhard-c283780",
"nuernberg-st__leonhard-c283790",
"nuernberg-st__leonhard-c28390",
"nuernberg-st__leonhard-cb8300",
"nuernberg-st__leonhard-cd18030",
"nuernberg-st__leonhard-cd18040",
"nuernberg-st__leonhard-n075750",
"nuernberg-st__leonhard-n076000",
"nuernberg-st__leonhard-s562220",
"nuernberg-st__leonhard-s562230",
"nuernberg-st__leonhardt-f491820",
"nuernberg-st__leonhardt-f491830",
"nuernberg-st__leonhardt-f491850",
"nuernberg-st__leonhardt-f491860",
"nuernberg-st__lorenz-f391220",
"nuernberg-st__lorenz-f391230",
"nuernberg-st__lorenz-f550240",
"nuernberg-st__lorenz-n33410",
"nuernberg-st__ludwig_kirche-c188330",
"nuernberg-st__ludwig_kirche-c188340",
"nuernberg-st__ludwig_kirche-c188360",
"nuernberg-st__markus_kirche-n29640",
"nuernberg-st__martha_kirche-n263400",
"nuernberg-st__martha_kirche-n263410",
"nuernberg-st__martha_kirche-n263420",
"nuernberg-st__martin_kirche-c207900",
"nuernberg-st__martin_kirche-f492330",
"nuernberg-st__michael_kirche-c564270",
"nuernberg-st__michael_kirche-f492270",
"nuernberg-st__michael-c123110",
"nuernberg-st__paul_kirche-f491680",
"nuernberg-st__peter___woehrd-c111110",
"nuernberg-st__peter-c135240",
"nuernberg-st__peter-c191910",
"nuernberg-st__peter-c225640",
"nuernberg-st__peter-c28860",
"nuernberg-st__peter-c505420",
"nuernberg-st__peter-c505490",
"nuernberg-st__peter-f384200",
"nuernberg-st__peter-f384200",
"nuernberg-st__peter-f406000",
"nuernberg-st__peter-f406010",
"nuernberg-st__peter-f444570",
"nuernberg-st__peter-f471000",
"nuernberg-st__peter-f554540",
"nuernberg-st__peter-f554610",
"nuernberg-st__peter-n144610",
"nuernberg-st__peter-n144620",
"nuernberg-st__peter-n144630",
"nuernberg-st__peter-n293830",
"nuernberg-st__rochusfriedhof-c212980",
"nuernberg-st__rochusfriedhof-c212990",
"nuernberg-st__sebald-f405330",
"nuernberg-st__sebald-f405460",
"nuernberg-st__sebald-f405470",
"nuernberg-st__sebald-f407430",
"nuernberg-st__sebald-f407680",
"nuernberg-st__sebald-f426170",
"nuernberg-st__sebald-f464770",
"nuernberg-st__sebald-f484770",
"nuernberg-st__sebald-n33230",
"nuernberg-st__sebaldus-c193910",
"nuernberg-st__theresien-krankenhaus-n530810",
"nuernberg-st__willibald_kirche-c161860",
"nuernberg-st__willibald_kirche-c161880",
"nuernberg-st__willibald_kirche-f490490",
"nuernberg-st__willibald_kirche-f491530",
"nuernberg-st__wunibald-n146560",
"nuernberg-st__wunibald-n146570",
"nuernberg-st_-gallen-ring-cd18070",
"nuernberg-staatstheater-nn65630",
"nuernberg-stadion_gelaende-c153730",
"nuernberg-stadionbad_rutsche-c106460",
"nuernberg-stadionbad-c242380",
"nuernberg-stadionbad-c242410",
"nuernberg-stadionbad-c242460",
"nuernberg-stadionbad-c242470",
"nuernberg-stadionbad-n052740",
"nuernberg-stadionbad-nn66660",
"nuernberg-stadion-c153720",
"nuernberg-stadion-c207560",
"nuernberg-stadion-c207570",
"nuernberg-stadion-c242250",
"nuernberg-stadion-c242280",
"nuernberg-stadion-c242360",
"nuernberg-stadiongelaende-c505360",
"nuernberg-stadiongelaende-n244180",
"nuernberg-stadion-nn81760",
"nuernberg-stadtbibliothek-c134170",
"nuernberg-stadtbibliothek-nn77300",
"nuernberg-stadtbibliothek-nn82700",
"nuernberg-stadtgrenze-f392370",
"nuernberg-stadtgrenze-f413610",
"nuernberg-stadtgrenze-f493470",
"nuernberg-stadtgrenze-n364660",
"nuernberg-stadtkirche_st__clemens-cb99330",
"nuernberg-stadtpark_im_herbst-nn81140",
"nuernberg-stadtpark-c036620",
"nuernberg-stadtpark-c123660",
"nuernberg-stadtpark-c191180",
"nuernberg-stadtpark-c191210",
"nuernberg-stadtpark-c191260",
"nuernberg-stadtpark-c191270",
"nuernberg-stadtpark-c191280",
"nuernberg-stadtpark-c207940",
"nuernberg-stadtpark-c208220",
"nuernberg-stadtpark-c208230",
"nuernberg-stadtpark-c223640",
"nuernberg-stadtpark-c243670",
"nuernberg-stadtpark-c253570",
"nuernberg-stadtpark-c253600",
"nuernberg-stadtpark-cc18420",
"nuernberg-stadtpark-cc43940",
"nuernberg-stadtpark-cc44080",
"nuernberg-stadtpark-cc44090",
"nuernberg-stadtpark-cc44110",
"nuernberg-stadtpark-cc44120",
"nuernberg-stadtpark-f383500",
"nuernberg-stadtpark-f383510",
"nuernberg-stadtpark-f413470",
"nuernberg-stadtpark-f413480",
"nuernberg-stadtpark-f472120",
"nuernberg-stadtpark-f472270",
"nuernberg-stadtpark-f514110",
"nuernberg-stadtpark-f530940",
"nuernberg-stadtpark-f530960",
"nuernberg-stadtpark-n05500",
"nuernberg-stadtpark-n14300",
"nuernberg-stadtpark-n14310",
"nuernberg-stadtpark-n14370",
"nuernberg-stadtpark-n14380",
"nuernberg-stadtpark-n144480",
"nuernberg-stadtpark-n247770",
"nuernberg-stadtpark-n247820",
"nuernberg-stadtpark-n515550",
"nuernberg-stadtpark-n525230",
"nuernberg-stadtparkweiher-c081380",
"nuernberg-stadtparkweiher-c107820",
"nuernberg-stadtparkweiher-c107850",
"nuernberg-stadtparkweiher-c107860",
"nuernberg-stadtparkweiher-c133780",
"nuernberg-stadtparkweiher-n14330",
"nuernberg-stadtquartier_luitpoldviertel-n361050",
"nuernberg-stadtquartier_luitpoldviertel-n361060",
"nuernberg-stadtstrand_an_der_insel_schuett-f484760",
"nuernberg-stadtstrand_auf_der_insel_schuett-n263340",
"nuernberg-stadtstrand_auf_der_insel_schuett-n263350",
"nuernberg-stadtstrand_auf_der_insel_schuett-n263360",
"nuernberg-stadtstrand_bei_nacht-c04550",
"nuernberg-staedler-c193140",
"nuernberg-staedler-c199700",
"nuernberg-staedler-n056260",
"nuernberg-staedtler-c12260",
"nuernberg-staedtler-c505960",
"nuernberg-staedtler-f464210",
"nuernberg-stapf_kinderhaus-cd17970",
"nuernberg-starkstromleitung-c125100",
"nuernberg-steigerwaldstrasse-c23790",
"nuernberg-steigerwaldstrasse-n144990",
"nuernberg-steinbruck_bei_worzeldorf-c281770",
"nuernberg-steinbruechle-f490540",
"nuernberg-steinbruechle-f490550",
"nuernberg-steinbuehl-cc17650",
"nuernberg-steinbuehler_strasse-c124570",
"nuernberg-steinbuehler_strasse-n295090",
"nuernberg-steinbuehler_strasse-n295100",
"nuernberg-steinbuehler_strasse-n295110",
"nuernberg-steinbuehler_tunnel-c108440",
"nuernberg-steinbuehler_tunnel-n148950",
"nuernberg-steinbuehl-f384310",
"nuernberg-stein-c241790",
"nuernberg-steiner_schloss-f532090",
"nuernberg-stein-n242920",
"nuernberg-steintribuene___zeppelinfeld-n068960",
"nuernberg-steintribuene-c124380",
"nuernberg-steintribuene-c153750",
"nuernberg-steintribuene-c207540",
"nuernberg-steintribuene-c207550",
"nuernberg-steintribuene-c225890",
"nuernberg-steintribuene-c231590",
"nuernberg-steintribuene-c242490",
"nuernberg-steintribuene-c242510",
"nuernberg-steintribuene-f47970",
"nuernberg-steintribuene-f554740",
"nuernberg-steintruebe-c242270",
"nuernberg-stephanstrasse-cc24910",
"nuernberg-stephanstrasse-f39560",
"nuernberg-stephanstrasse-f39570",
"nuernberg-stephanstrasse-f413270",
"nuernberg-stephanstrasse-f413280",
"nuernberg-stephanstrasse-f435020",
"nuernberg-stephanstrasse-n144590",
"nuernberg-stephanstrasse-n144600",
"nuernberg-sternwarte-regiomontanus-c119310",
"nuernberg-strafjustizzentrum-n363430",
"nuernberg-strand_am_woehrder_see-c068620",
"nuernberg-strand_am_woehrder_see-c231250",
"nuernberg-strand_am_woehrder_see-n053480",
"nuernberg-strand_am_woehrder_see-n053650",
"nuernberg-strand_am_woehrder_see-n053730",
"nuernberg-strand_am_woehrder_see-n076120",
"nuernberg-strand_am_woehrder_see-n261970",
"nuernberg-strand_am_woehrder_see-n261980",
"nuernberg-strand_am_woehrder_see-n262130",
"nuernberg-strand-c154620",
"nuernberg-strand-cc19060",
"nuernberg-strandfest__insel_schuett_-c039110",
"nuernberg-strandfest__insel_schuett_-cc33210",
"nuernberg-strandfest__insel_schuett_-cc33510",
"nuernberg-strandfest_insel_schuett-nn65890",
"nuernberg-strandfest_insel_schuett-nn67800",
"nuernberg-strandfest-n1400",
"nuernberg-strandfest-n1420",
"nuernberg-strandfest-n148090",
"nuernberg-strandfest-n148100",
"nuernberg-strassenbahndepot_st__peter-f471830",
"nuernberg-strauchstrasse-n147790",
"nuernberg-strauchstrasse-n147810",
"nuernberg-strauchstrasse-n147820",
"nuernberg-strauchstrasse-n147960",
"nuernberg-stresemannplatz-n247720",
"nuernberg-stressemannplatz-c194160",
"nuernberg-sued_punkt-c122340",
"nuernberg-sued_punkt-c122400",
"nuernberg-suedausgang-n149440",
"nuernberg-suedausgang-n149450",
"nuernberg-suedbad___gustav_adolf_gedaechtniskirche-c124500",
"nuernberg-suedbad-cc52490",
"nuernberg-suedbad-n147420",
"nuernberg-suedfriedhof-c08450",
"nuernberg-suedfriedhof-c111350",
"nuernberg-suedfriedhof-f425590",
"nuernberg-suedfriedhof-f490500",
"nuernberg-suedfriedhof-n241580",
"nuernberg-suedfriedhof-n36970",
"nuernberg-suedstadt_forum-f490410",
"nuernberg-suedstadtbad-f540380",
"nuernberg-suedstadtbad-n076820",
"nuernberg-suedstadt-c252030",
"nuernberg-suedstadt-c252340",
"nuernberg-suedstadt-c281290",
"nuernberg-suedstadt-cc17910",
"nuernberg-suedstadt-cc17960",
"nuernberg-suedstadt-f391210",
"nuernberg-suedstadt-f391990",
"nuernberg-suedstadt-f392000",
"nuernberg-suedstadt-f392010",
"nuernberg-suedstadt-f393400",
"nuernberg-suedstadt-f393410",
"nuernberg-suedstadt-f406340",
"nuernberg-suedstadt-f406430",
"nuernberg-suedstadt-f425650",
"nuernberg-suedstadt-f425670",
"nuernberg-suedstadt-f444940",
"nuernberg-suedstadt-f47200",
"nuernberg-suedstadt-f490360",
"nuernberg-suedstadt-f490380",
"nuernberg-suedstadt-f490390",
"nuernberg-suedstadt-f490400",
"nuernberg-suedstadt-f532680",
"nuernberg-suedstadt-f540540",
"nuernberg-suedstadt-f540550",
"nuernberg-suedstadt-f554810",
"nuernberg-suedstadt-f554840",
"nuernberg-suedstadtforum-c135290",
"nuernberg-suedstadt-n05600",
"nuernberg-suedstadt-n147210",
"nuernberg-suedstadt-n147220",
"nuernberg-suedstadt-n147320",
"nuernberg-suedstadt-n147340",
"nuernberg-suedstadt-n147650",
"nuernberg-suedstadt-n147730",
"nuernberg-suedstadt-n148440",
"nuernberg-suedstadt-n246950",
"nuernberg-suedstadt-n247350",
"nuernberg-suedstadt-n247360",
"nuernberg-suedstadt-n294490",
"nuernberg-suedstadt-n29610",
"nuernberg-suedstadtpark-cc17620",
"nuernberg-suedwestpark-c035330",
"nuernberg-suedwestpark-c035340",
"nuernberg-suedwestpark-c037020",
"nuernberg-suedwestpark-c037060",
"nuernberg-suedwestpark-c089540",
"nuernberg-suedwestpark-c089730",
"nuernberg-suedwestpark-c135900",
"nuernberg-suedwestpark-c135910",
"nuernberg-suedwestpark-f391380",
"nuernberg-suedwestpark-f411990",
"nuernberg-suedwestpark-f412000",
"nuernberg-suedwestpark-f471080",
"nuernberg-suedwestpark-f530630",
"nuernberg-suedwestpark-f530640",
"nuernberg-suedwestpark-f530650",
"nuernberg-suedwestpark-n075100",
"nuernberg-suedwestpark-n075180",
"nuernberg-suedwestpark-n075200",
"nuernberg-suedwestpark-n274330",
"nuernberg-suedwestpark-nn75420",
"nuernberg-suedwesttangente_bei_roethenbach-f405650",
"nuernberg-suedwesttangente-c252520",
"nuernberg-suedwesttangente-f391570",
"nuernberg-suedwesttangente-f395360",
"nuernberg-suedwesttangente-f434730",
"nuernberg-suedwesttangente-n295290",
"nuernberg-suendersbuehl-c312110",
"nuernberg-suendersbuehl-c312150",
"nuernberg-suendersbuehl-f382770",
"nuernberg-suendersbuehl-n363890",
"nuernberg-suendersbuehl-n363930",
"nuernberg-sulzbacher_strasse-n30350",
"nuernberg-sulzbacher_strasse-n33510",
"nuernberg-sv_maiach_hinterhof_e_v_-f403620",
"nuernberg-ta_mittelstandszentrum-n525430",
"nuernberg-tafelfeld-f406390",
"nuernberg-tafelfeld-f434100",
"nuernberg-tafelfeldstrasse-c155160",
"nuernberg-tafelfeldstrasse-c155370",
"nuernberg-tafelfeldstrasse-c155400",
"nuernberg-tafelfeldstrasse-n148230",
"nuernberg-tafelgelaende-f382230",
"nuernberg-tafelgelaende-n362350",
"nuernberg-tafelhalle-c036470",
"nuernberg-tafelhalle-c036480",
"nuernberg-tafelhalle-c037930",
"nuernberg-tafelhalle-c038160",
"nuernberg-tafelhalle-c038200",
"nuernberg-tafelhalle-c038230",
"nuernberg-tafelhalle-c038520",
"nuernberg-tafelhalle-c208060",
"nuernberg-tafelhalle-c225730",
"nuernberg-tafelhalle-c23610",
"nuernberg-tafelhalle-f381430",
"nuernberg-tafelhalle-f405170",
"nuernberg-tafelhalle-f413070",
"nuernberg-tafelhalle-f413080",
"nuernberg-tafelhalle-f413090",
"nuernberg-tafelhalle-n144760",
"nuernberg-tafelhalle-n144780",
"nuernberg-tafelhalle-n294070",
"nuernberg-tafelhalle-n294090",
"nuernberg-tafelhalle-n294100",
"nuernberg-tafelhalle-n303670",
"nuernberg-tafelhalle-n303680",
"nuernberg-tafelhalle-n525170",
"nuernberg-tafelhalle-n525180",
"nuernberg-tafelhalle-n525190",
"nuernberg-tafelhof_palais-c192280",
"nuernberg-tafelhof_palais-c282370",
"nuernberg-tafelhof_palais-c282790",
"nuernberg-tafelhof_palais-c311070",
"nuernberg-tafelhof_palais-c311090",
"nuernberg-tafelhof_palais-c31970",
"nuernberg-tafelhof_palais-f382660",
"nuernberg-tafelhof_palais-f382690",
"nuernberg-tafelhof_palais-f383310",
"nuernberg-tafelhof_palais-f39590",
"nuernberg-tafelhof_palais-f39620",
"nuernberg-tafelhof_palais-f405770",
"nuernberg-tafelhof_palais-f405800",
"nuernberg-tafelhof_palais-f405810",
"nuernberg-tafelhof_palais-f406070",
"nuernberg-tafelhof_palais-f412870",
"nuernberg-tafelhof_palais-f412940",
"nuernberg-tafelhof_palais-f413310",
"nuernberg-tafelhof_palais-f413320",
"nuernberg-tafelhof_palais-f426350",
"nuernberg-tafelhof_palais-f426360",
"nuernberg-tafelhof_palais-f426620",
"nuernberg-tafelhof_palais-f426640",
"nuernberg-tafelhof_palais-f435130",
"nuernberg-tafelhof_palais-f471630",
"nuernberg-tafelhof_palais-f471940",
"nuernberg-tafelhof_palais-f471940",
"nuernberg-tafelhof_palais-f484920",
"nuernberg-tafelhof_palais-f490350",
"nuernberg-tafelhof_palais-n148040",
"nuernberg-tafelhof_palais-n148160",
"nuernberg-tafelhof_palais-n148170",
"nuernberg-tafelhof_palais-n262750",
"nuernberg-tafelhof_palais-n262760",
"nuernberg-tafelhof_palais-n263050",
"nuernberg-tafelhof_palais-n263060",
"nuernberg-tafelhof_palais-n263240",
"nuernberg-tafelhof_palais-n274500",
"nuernberg-tafelhof_palais-n274650",
"nuernberg-tafelhof_palais-n274910",
"nuernberg-tafelhof_palais-n274930",
"nuernberg-tafelhof_palais-n294560",
"nuernberg-tafelhof_palais-n294600",
"nuernberg-tafelhof_palais-n294730",
"nuernberg-tafelhof_palais-n341900",
"nuernberg-tafelhof_palais-n364350",
"nuernberg-tafelhof_palais-n364390",
"nuernberg-tafelhof_palais-n364450",
"nuernberg-tafelhof_palais-n364490",
"nuernberg-tafelhof-f382720",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_albrecht-duerer-airport-f532940",
"nuernberg-tanklager_am_albrecht-duerer-airport-c188490",
"nuernberg-tanklager_d__albrecht-duerer-airport-n552030",
"nuernberg-teambank_neubau_beuthener_strasse-c105560",
"nuernberg-teambank_neubau_beuthener_strasse-c105590",
"nuernberg-teambank_neubau_beuthener_strasse-c105630",
"nuernberg-teambank_neubau_beuthener_strasse-c105670",
"nuernberg-teambank_neubau_beuthener_strasse-c109940",
"nuernberg-teambank-b181340",
"nuernberg-teambank-b181360",
"nuernberg-teambank-b184540",
"nuernberg-teambank-c135120",
"nuernberg-teambank-c135170",
"nuernberg-teambank-c135210",
"nuernberg-teambank-n14240",
"nuernberg-technische_hochschule_georg-simon-ohm-f471850",
"nuernberg-technische_hochschule_gso-f540320",
"nuernberg-technische_hochschule_nuernberg-f540480",
"nuernberg-technische_hochschule-c243750",
"nuernberg-technische_hochschule-f383780",
"nuernberg-technische_hochschule-f39930",
"nuernberg-technische_universitaet_nuernberg-erlagen-cc18620",
"nuernberg-telekom_rathenauplatz-n14270",
"nuernberg-telekom_rathenauplatz-n14290",
"nuernberg-tempohaus-c133820",
"nuernberg-tempohaus-c244350",
"nuernberg-tempohaus-c244370",
"nuernberg-tempohaus-c244410",
"nuernberg-tempohaus-c244430",
"nuernberg-tempohaus-c25500",
"nuernberg-tempohaus-c25510",
"nuernberg-tempohaus-c25530",
"nuernberg-tempohaus-c25540",
"nuernberg-tempohaus-c283190",
"nuernberg-tempohaus-c283210",
"nuernberg-tempohaus-c283250",
"nuernberg-tempohaus-c283260",
"nuernberg-tempohaus-c283290",
"nuernberg-tempohaus-f393720",
"nuernberg-tempohaus-n14350",
"nuernberg-tempohaus-n144950",
"nuernberg-tempohaus-n247520",
"nuernberg-tempohaus-n261020",
"nuernberg-tempohaus-n261600",
"nuernberg-tempohaus-n26980",
"nuernberg-tempohaus-n303780",
"nuernberg-tennenlohe-f404050",
"nuernberg-tennenlohe-f404090",
"nuernberg-tennisclub_noris_weiss-blau-n362390",
"nuernberg-tennisplaetze-c135070",
"nuernberg-tetzelgasse-c251580",
"nuernberg-tetzelgasse-f391040",
"nuernberg-tetzelgasse-f531580",
"nuernberg-tetzelgasse-n148840",
"nuernberg-tetzelgasse-n148860",
"nuernberg-tevi-c193490",
"nuernberg-theatergasse-c251220",
"nuernberg-theodor-heuss-bruecke-c251770",
"nuernberg-theodor-heuss-bruecke-n295210",
"nuernberg-theodor-heuss-bruecke-n363110",
"nuernberg-theodor-heuss-bruecke-n515650",
"nuernberg-theodor-heuss-bruecke-s562300",
"nuernberg-theodorstrasse-c212390",
"nuernberg-theodorstrasse-c212470",
"nuernberg-theresien-krankenhaus-c10400",
"nuernberg-theresien-krankenhaus-c121220",
"nuernberg-theresien-krankenhaus-c173580",
"nuernberg-theresien-krankenhaus-c207320",
"nuernberg-theresien-krankenhaus-c207340",
"nuernberg-theresien-krankenhaus-c207350",
"nuernberg-theresien-krankenhaus-c23750",
"nuernberg-thomas-mann-strasse-c281970",
"nuernberg-thon_plaza-c564180",
"nuernberg-thon_plaza-c564220",
"nuernberg-thon_plaza-c564230",
"nuernberg-thon_plaza-c564240",
"nuernberg-thon_plaza-f540100",
"nuernberg-thon_plaza-f540110",
"nuernberg-thon_plaza-f540120",
"nuernberg-thon_plaza-f540160",
"nuernberg-thon_plaza-f540170",
"nuernberg-thon_plaza-f540180",
"nuernberg-thon_plaza-f540200",
"nuernberg-thon_plaza-f553940",
"nuernberg-thon-b18710",
"nuernberg-thon-b18730",
"nuernberg-thon-b18740",
"nuernberg-thon-b18750",
"nuernberg-thon-b18760",
"nuernberg-thon-b18770",
"nuernberg-thon-c132340",
"nuernberg-thon-c196780",
"nuernberg-thon-c244690",
"nuernberg-thon-c244710",
"nuernberg-thon-c244810",
"nuernberg-thon-c244840",
"nuernberg-thon-c244850",
"nuernberg-thon-c505830",
"nuernberg-thon-c505840",
"nuernberg-thon-c505860",
"nuernberg-thon-c506380",
"nuernberg-thon-cb81000",
"nuernberg-thon-cc44150",
"nuernberg-thon-f381740",
"nuernberg-thon-f382990",
"nuernberg-thon-f383000",
"nuernberg-thon-f425970",
"nuernberg-thon-f434850",
"nuernberg-thon-f472280",
"nuernberg-thon-f472290",
"nuernberg-thon-f472290",
"nuernberg-thon-f472300",
"nuernberg-thon-f472310",
"nuernberg-thon-f472310",
"nuernberg-thon-f472370",
"nuernberg-thon-f472380",
"nuernberg-thon-f531470",
"nuernberg-thon-f532350",
"nuernberg-thon-f553790",
"nuernberg-thon-f553800",
"nuernberg-thon-f553820",
"nuernberg-thon-f553930",
"nuernberg-thon-f553970",
"nuernberg-thon-f553990",
"nuernberg-thon-n362830",
"nuernberg-thon-n362850",
"nuernberg-thon-nn67890",
"nuernberg-thon-nn74670",
"nuernberg-thumenberger_weg-c243370",
"nuernberg-thumenberger_weg-c243400",
"nuernberg-thumenberger_weg-c243480",
"nuernberg-thumenberger_weg-c243550",
"nuernberg-thumenberger_weg-c243560",
"nuernberg-thumenberger_weg-c243580",
"nuernberg-thumenberger_weg-f383420",
"nuernberg-thumenberger_weg-f426440",
"nuernberg-thumenberger_weg-f444770",
"nuernberg-thumenberger_weg-f444800",
"nuernberg-thumenberger_weg-f444830",
"nuernberg-thumenberger_weg-f471540",
"nuernberg-thumenberger_weg-f530770",
"nuernberg-thumenberger_weg-f530780",
"nuernberg-thumenberger_weg-f530790",
"nuernberg-thumenberger_weg-f530800",
"nuernberg-thumenberger_weg-n145110",
"nuernberg-thumenberger_weg-n145130",
"nuernberg-thumenberger_weg-n261760",
"nuernberg-thumenberger_weg-n261780",
"nuernberg-thumenberger_weg-n361720",
"nuernberg-thumenberger_weg-n362310",
"nuernberg-thumenberger_weg-n515340",
"nuernberg-thumenberger_weg-n530680",
"nuernberg-thusneldaschule-f404970",
"nuernberg-thusneldaschule-n33670",
"nuernberg-tiergaertnertor-cc42000",
"nuernberg-tiergaertnertor-f382560",
"nuernberg-tiergaertnertor-f382570",
"nuernberg-tiergaertnertor-f382600",
"nuernberg-tiergaertnertorplatz-c191070",
"nuernberg-tiergaertnertorplatz-c196730",
"nuernberg-tiergaertnertorplatz-c251290",
"nuernberg-tiergaertnertorplatz-c251300",
"nuernberg-tiergaertnertorplatz-c251310",
"nuernberg-tiergaertnertorplatz-c251320",
"nuernberg-tiergaertnertorplatz-c251530",
"nuernberg-tiergaertnertorplatz-c251540",
"nuernberg-tiergaertnertorplatz-c251560",
"nuernberg-tiergaertnertorplatz-c252100",
"nuernberg-tiergaertnertorplatz-c252110",
"nuernberg-tiergaertnertorplatz-c252120",
"nuernberg-tiergaertnertorplatz-c253610",
"nuernberg-tiergaertnertorplatz-c253620",
"nuernberg-tiergaertnertorplatz-c283050",
"nuernberg-tiergaertnertorplatz-cc25690",
"nuernberg-tiergaertnertorplatz-f426670",
"nuernberg-tiergaertnertorplatz-f492370",
"nuernberg-tiergaertnertorplatz-f492370",
"nuernberg-tiergaertnertorplatz-f492380",
"nuernberg-tiergarten_lager-c231300",
"nuernberg-tiergarten_lager-c231360",
"nuernberg-tiergarten-c106850",
"nuernberg-tiergarten-c207410",
"nuernberg-tiergarten-c211280",
"nuernberg-tiergarten-c231340",
"nuernberg-tiergarten-c231420",
"nuernberg-tiergarten-f484410",
"nuernberg-tiergarten-f484420",
"nuernberg-tiergarten-n262220",
"nuernberg-tiergarten-n262230",
"nuernberg-tiergarten-n262250",
"nuernberg-tiergarten-n262280",
"nuernberg-tiergarten-n262310",
"nuernberg-tiergarten-n262320",
"nuernberg-tiergarten-n262350",
"nuernberg-tiergarten-n262360",
"nuernberg-tiergarten-n262370",
"nuernberg-tiergarten-n262380",
"nuernberg-tierheim-c117440",
"nuernberg-tierheim-c117460",
"nuernberg-tierheim-c117510",
"nuernberg-tierheim-c211000",
"nuernberg-tillypark-c251850",
"nuernberg-tillypark-c251860",
"nuernberg-tillypark-c28450",
"nuernberg-tillypark-f383200",
"nuernberg-tillypark-f383220",
"nuernberg-tillypark-f405690",
"nuernberg-tillypark-f412050",
"nuernberg-tillypark-f530680",
"nuernberg-tillypark-n295380",
"nuernberg-tower_flughafen-n011380",
"nuernberg-tower-b185690",
"nuernberg-tower-c24140",
"nuernberg-tower-n144260",
"nuernberg-tower-n144280",
"nuernberg-tower-n144290",
"nuernberg-tramlofts-f39800",
"nuernberg-tramlofts-f471310",
"nuernberg-tramlofts-f471310",
"nuernberg-tramlofts-f485020",
"nuernberg-tramlofts-f485050",
"nuernberg-tramlofts-f493430",
"nuernberg-tramlofts-f493440",
"nuernberg-tramlofts-f493460",
"nuernberg-tramlofts-f493460",
"nuernberg-tramlofts-f493480",
"nuernberg-tramlofts-f493490",
"nuernberg-tramlofts-f493640",
"nuernberg-tramlofts-f493640",
"nuernberg-tramlofts-f554250",
"nuernberg-tramlofts-f554260",
"nuernberg-tretboote-c282700",
"nuernberg-trierer_strasse-c111240",
"nuernberg-trierer_strasse-c152470",
"nuernberg-trierer_strasse-c152480",
"nuernberg-trierer_strasse-c152490",
"nuernberg-trierer_strasse-f406610",
"nuernberg-trierer_strasse-f425580",
"nuernberg-trierer_strasse-n146550",
"nuernberg-trinkwasserhochbehaelter_schmausenbuck-n262200",
"nuernberg-trinkwasserhochbehaelter_schmausenbuck-n262270",
"nuernberg-troedelmarkt-cc42310",
"nuernberg-troedelmarkt-cc43890",
"nuernberg-troedelmarkt-cc43900",
"nuernberg-troedelmarkt-f484790",
"nuernberg-troedelmarkt-n054880",
"nuernberg-troedelmarkt-n069760",
"nuernberg-troedelmarkt-n069810",
"nuernberg-troedelmarkt-n069890",
"nuernberg-troedelmarkt-n069920",
"nuernberg-troedelmarkt-n069960",
"nuernberg-troedelmarkt-n069970",
"nuernberg-troedelmarkt-n294820",
"nuernberg-troedelmarkt-nn65760",
"nuernberg-troedelmarkt-nn77570",
"nuernberg-tsv_1860_jahn_schweinau-f464460",
"nuernberg-tsv_1860_jahn_schweinau-f491770",
"nuernberg-tsv_buch-c083000",
"nuernberg-tsv_buch-f407900",
"nuernberg-tsv_falkenheim-f490520",
"nuernberg-tsv_johannis_1883-f553900",
"nuernberg-tsv_johannis_1883-n06740",
"nuernberg-tsv_katzwang-c171640",
"nuernberg-tsv_sack-f555430",
"nuernberg-tsv-buch-f407880",
"nuernberg-tsv-buch-f407890",
"nuernberg-tucher_braeu_ag_abfuellanlage-f492200",
"nuernberg-tucher_braeu_ag_abfuellanlage-f492200",
"nuernberg-tuchergarten-c12780",
"nuernberg-tucherhof-b185290",
"nuernberg-tucherhof-f411760",
"nuernberg-tucherland_bei_marienbergstrasse-c12760",
"nuernberg-tucherland_bei_marienbergstrasse-c12870",
"nuernberg-tucherland_bei_marienbergstrasse-c12910",
"nuernberg-tucherland_bei_marienbergstrasse-c12920",
"nuernberg-tucherland-c12730",
"nuernberg-tucherschloss-c232920",
"nuernberg-tucherschloss-c232930",
"nuernberg-tucherschloss-c233030",
"nuernberg-tullnau_vr_bank-f413240",
"nuernberg-tullnau-b182710",
"nuernberg-tullnau-c505460",
"nuernberg-tullnau-f394450",
"nuernberg-tullnau-f395940",
"nuernberg-tullnau-f395950",
"nuernberg-tullnau-f406820",
"nuernberg-tullnau-f413240",
"nuernberg-tullnau-f465260",
"nuernberg-tullnau-n33420",
"nuernberg-tullnau-n515310",
"nuernberg-tunnelstrasse-b182310",
"nuernberg-tunnelstrasse-b182400",
"nuernberg-tunnelstrasse-c134990",
"nuernberg-tunnelstrasse-c155350",
"nuernberg-tunnelstrasse-c155360",
"nuernberg-tunnelstrasse-c172940",
"nuernberg-tunnelstrasse-c212870",
"nuernberg-tunnelstrasse-c212900",
"nuernberg-tunnelstrasse-n246510",
"nuernberg-tunnelstrasse-n246560",
"nuernberg-tunnelstrasse-n246590",
"nuernberg-tunnelstrasse-n246630",
"nuernberg-tunnelstrasse-n246680",
"nuernberg-turm_am_rangierbahnhof-c111300",
"nuernberg-turm_am_rangierbahnhof-c226150",
"nuernberg-turm_der_nuernberger_versicherung-c049810",
"nuernberg-turm-f404790",
"nuernberg-turm-f445070",
"nuernberg-turm-n1460",
"nuernberg-turm-n1470",
"nuernberg-turm-n148960",
"nuernberg-turm-n148970",
"nuernberg-turnerheimstrasse-c135760",
"nuernberg-turnerheimstrasse-c135770",
"nuernberg-turnerheimstrasse-f383160",
"nuernberg-turnerheimstrasse-f491900",
"nuernberg-turnerheimstrasse-n146740",
"nuernberg-ubahn_bei_zuericher_str-n24590",
"nuernberg-u-bahn_gebersdorf-f530420",
"nuernberg-u-bahn_grossreuth_bei_schweinau-n363940",
"nuernberg-u-bahn-betriebshof_langwasser-c31130",
"nuernberg-u-bahn-betriebshof_langwasser-c31600",
"nuernberg-u-bahnline_gebersdorf-f471120",
"nuernberg-u-bahnline_gebersdorf-f471130",
"nuernberg-u-bahnlinie_bauabschnitt-f530400",
"nuernberg-ueber_den_wolken-n051170",
"nuernberg-uebungsplatz_flughafenfeuerwehr-c25210",
"nuernberg-uhlandschule-nn76600",
"nuernberg-ulmenstrasse-c152390",
"nuernberg-ulmenstrasse-c152400",
"nuernberg-ulmenstrasse-c152410",
"nuernberg-ulmenstrasse-c154260",
"nuernberg-ulmenstrasse-c154280",
"nuernberg-ulmenstrasse-c154290",
"nuernberg-ulmenstrasse-c154320",
"nuernberg-ulmenstrasse-c154350",
"nuernberg-ulmenstrasse-c154360",
"nuernberg-ulmenstrasse-c154370",
"nuernberg-ulmenstrasse-c154430",
"nuernberg-ulmenstrasse-c154450",
"nuernberg-ulmenstrasse-c154490",
"nuernberg-ulmenstrasse-c154500",
"nuernberg-ulmenstrasse-c154510",
"nuernberg-ulmenstrasse-c154530",
"nuernberg-ulmenstrasse-c194570",
"nuernberg-ulmenstrasse-c194600",
"nuernberg-ulmenstrasse-c194610",
"nuernberg-ulmenstrasse-c194660",
"nuernberg-ulmenstrasse-c194680",
"nuernberg-ulmenstrasse-c194720",
"nuernberg-ulmenstrasse-c194730",
"nuernberg-ulmenstrasse-cc17130",
"nuernberg-ulmenstrasse-f391700",
"nuernberg-ulmenstrasse-f392040",
"nuernberg-ulmenstrasse-f412370",
"nuernberg-umspannwerk-c111420",
"nuernberg-umspannwerk-n147550",
"nuernberg-umweltbank___flora54-f471390",
"nuernberg-umweltbank___flora54-f471410",
"nuernberg-umweltbank__baustelle_-f493210",
"nuernberg-umweltbank__baustelle_-f493210",
"nuernberg-umweltbank__baustelle_-f493220",
"nuernberg-umweltbank__baustelle_-f493300",
"nuernberg-umweltbank__baustelle_-f493300",
"nuernberg-umweltbank__baustelle_-f493320",
"nuernberg-umweltbank__baustelle_-f493360",
"nuernberg-umweltbank__baustelle_-f493360",
"nuernberg-umweltbank__baustelle_-f493390",
"nuernberg-umweltbank-c564280",
"nuernberg-umweltbank-c564290",
"nuernberg-umweltbank-c564300",
"nuernberg-umweltbank-f471350",
"nuernberg-umweltbank-f553870",
"nuernberg-umweltbank-f553880",
"nuernberg-umweltbank-f555250",
"nuernberg-umweltbank-f555260",
"nuernberg-umweltbank-n530140",
"nuernberg-umweltbank-n530160",
"nuernberg-umweltbank-n530170",
"nuernberg-umweltbank-n530220",
"nuernberg-umweltbank-n530240",
"nuernberg-umweltbank-n530280",
"nuernberg-umweltbank-n530300",
"nuernberg-umweltbank-n530320",
"nuernberg-umweltbank-n530350",
"nuernberg-umweltbank-n531430",
"nuernberg-unschlittplatz-c156440",
"nuernberg-unschlittplatz-cb8740",
"nuernberg-unterbuerg-n520400",
"nuernberg-unterbuerg-n520410",
"nuernberg-untere_linke_gebaeude__modern_-f444810",
"nuernberg-untere_soeldnersgasse-c212130",
"nuernberg-untere_turnstrasse-cc53090",
"nuernberg-untere_woerthstrasse-b181420",
"nuernberg-untere_woerthstrasse-c155250",
"nuernberg-untere_woerthstrasse-c156430",
"nuernberg-untere_woerthstrasse-c211660",
"nuernberg-untere_woerthstrasse-cc24820",
"nuernberg-untere_woerthstrasse-cc53210",
"nuernberg-untere_woerthstrasse-n054180",
"nuernberg-untere_woerthstrasse-n069780",
"nuernberg-untere_woerthstrasse-n148310",
"nuernberg-untere_woerthstrasse-n148320",
"nuernberg-untere_woerthstrasse-n148330",
"nuernberg-untere_woerthstrasse-n148790",
"nuernberg-untere_woerthstrasse-n148800",
"nuernberg-untere_woerthstrasse-n148830",
"nuernberg-untere_woerthstrasse-n148870",
"nuernberg-untere_woerthstrasse-n148880",
"nuernberg-untere_woerthstrasse-n149230",
"nuernberg-untere_woerthstrasse-n149250",
"nuernberg-untere_woerthstrasse-n149260",
"nuernberg-valznerweiher-c31100",
"nuernberg-valznerweiher-c31110",
"nuernberg-valznerweiher-cc43570",
"nuernberg-valznerweiher-f384100",
"nuernberg-valznerweiher-f384110",
"nuernberg-valznerweiher-f384120",
"nuernberg-valznerweiher-f384130",
"nuernberg-valznerweiher-f554800",
"nuernberg-veilhof-f383760",
"nuernberg-veilhof-f383770",
"nuernberg-veilhof-f413120",
"nuernberg-veilhof-f484510",
"nuernberg-veilhof-f530920",
"nuernberg-veilhof-n261870",
"nuernberg-veilhof-n261880",
"nuernberg-veilhof-n261990",
"nuernberg-veilhof-n262000",
"nuernberg-veilhof-n262010",
"nuernberg-veilhofstrasse-c232810",
"nuernberg-veit-stoss-platz-c311750",
"nuernberg-veit-stoss-platz-f383920",
"nuernberg-veit-stoss-platz-f471440",
"nuernberg-veit-stoss-platz-s562160",
"nuernberg-veit-stoss-platz-s562170",
"nuernberg-veit-stoss-realschule-f492720",
"nuernberg-verkehrsuebungsplatz_boxdorf-f550150",
"nuernberg-verlagshaus_nuernberg_presse-f382610",
"nuernberg-verlagshaus_nuernberger_presse-c192130",
"nuernberg-verlagshaus_nuernberger_presse-c192730",
"nuernberg-verlagshaus_nuernberger_presse-c192750",
"nuernberg-vestnertorgraben-f514190",
"nuernberg-villa_leon-n075520",
"nuernberg-villa_leon-n075530",
"nuernberg-villa_leon-nn82280",
"nuernberg-virchowstrasse-c283390",
"nuernberg-virchowstrasse-f406880",
"nuernberg-virchowstrasse-f493140",
"nuernberg-virchowstrasse-f493140",
"nuernberg-virchowstrasse-n144960",
"nuernberg-virchowstrasse-n144980",
"nuernberg-virchowstrasse-n303770",
"nuernberg-virchowstrasse-nn77740",
"nuernberg-vogelherd-f39850",
"nuernberg-vogelherd-f404750",
"nuernberg-vogelherd-f493190",
"nuernberg-vogelherd-f493200",
"nuernberg-vogelherd-n530190",
"nuernberg-vogelherstrasse-f471420",
"nuernberg-vogelsgarten-f406060",
"nuernberg-vogelweiherstrasse-f391680",
"nuernberg-vogelweiherstrasse-f391690",
"nuernberg-vogelweiherstrasse-n147560",
"nuernberg-vogelweiherstrasse-s562060",
"nuernberg-volckamer_platz-cc17110",
"nuernberg-volckamerplatz-f392050",
"nuernberg-volksbad___planetarium-cc42540",
"nuernberg-volksbad-nn65590",
"nuernberg-volksfest-c153900",
"nuernberg-volksfest-n069030",
"nuernberg-volksfest-n069100",
"nuernberg-volkspark_dutzendteich-c231880",
"nuernberg-volkspark_marienbergpark-c226820",
"nuernberg-volkspark_marienbergpark-c226840",
"nuernberg-volkspark_marienbergpark-c226870",
"nuernberg-von-der-tann-strasse-c136140",
"nuernberg-von-der-tann-strasse-cc4410",
"nuernberg-von-der-tann-strasse-f492050",
"nuernberg-von-der-tann-strasse-f492060",
"nuernberg-vor-f555400",
"nuernberg-waaggasse-c156410",
"nuernberg-wachendorfer_strasse-c187850",
"nuernberg-waermespeicher-c122670",
"nuernberg-waermespeicher-c122700",
"nuernberg-waermespeicher-c122710",
"nuernberg-waermespeicher-c122720",
"nuernberg-waermespeicher-c122750",
"nuernberg-waermespeicher-c122770",
"nuernberg-waermespeicher-cb8170",
"nuernberg-wagenseilstrasse-c225590",
"nuernberg-wagenseilstrasse-f472070",
"nuernberg-wagenseilstrasse-f472070",
"nuernberg-wald_bei_nuernberg-f423950",
"nuernberg-waldrestaurant_schiesshaus-n361930",
"nuernberg-waldsportplatz-f520350",
"nuernberg-waldweg-n30250",
"nuernberg-walkuerenstrasse-c213100",
"nuernberg-wallensteinstrasse_baustelle-c136000",
"nuernberg-wallensteinstrasse-c136050",
"nuernberg-wallensteinstrasse-c136080",
"nuernberg-wallensteinstrasse-c136100",
"nuernberg-wallensteinstrasse-c136760",
"nuernberg-wallensteinstrasse-c187810",
"nuernberg-wallensteinstrasse-c187840",
"nuernberg-wallensteinstrasse-c199870",
"nuernberg-wallensteinstrasse-c199880",
"nuernberg-wallensteinstrasse-c199890",
"nuernberg-wallensteinstrasse-c199910",
"nuernberg-wallensteinstrasse-c199940",
"nuernberg-wallensteinstrasse-c199950",
"nuernberg-wallensteinstrasse-c199960",
"nuernberg-wallensteinstrasse-c28530",
"nuernberg-wallensteinstrasse-f492070",
"nuernberg-wallensteinstrasse-f492070",
"nuernberg-wallensteinstrasse-n295490",
"nuernberg-walzwerkstrasse-c038480",
"nuernberg-walzwerkstrasse-c208050",
"nuernberg-walzwerkstrasse-n144800",
"nuernberg-walzwerkstrasse-n144810",
"nuernberg-wandererstrasse-c123420",
"nuernberg-wandererstrasse-c123440",
"nuernberg-wandererstrasse-c123460",
"nuernberg-wandererstrasse-c199830",
"nuernberg-wandererstrasse-c245410",
"nuernberg-wandererstrasse-f493620",
"nuernberg-wandererstrasse-f554380",
"nuernberg-warmwasserspeicher-c134510",
"nuernberg-warmwasserspeicher-c134530",
"nuernberg-warmwasserspeicher-c134580",
"nuernberg-warmwasserspeicher-c134610",
"nuernberg-warmwasserspeicher-c134620",
"nuernberg-warmwasserspeicher-c134640",
"nuernberg-warmwasserspeicher-c134660",
"nuernberg-warmwasserspeicher-c134680",
"nuernberg-warmwasserspeicher-c134700",
"nuernberg-warmwasserspeicher-c134710",
"nuernberg-warmwasserspeicher-c134720",
"nuernberg-wassertorstrasse-c154820",
"nuernberg-wassertorstrasse-c187170",
"nuernberg-wassertorstrasse-n053710",
"nuernberg-wasserturm_boxdorf-f541120",
"nuernberg-wasserturm_boxdorf-f541130",
"nuernberg-wasserturm_boxdorf-f555470",
"nuernberg-wastl-c154630",
"nuernberg-wastl-c154640",
"nuernberg-wastl-c154660",
"nuernberg-wastl-c154680",
"nuernberg-wastl-c154700",
"nuernberg-wastl-n144730",
"nuernberg-wastl-n144750",
"nuernberg-wastl-n144820",
"nuernberg-wastl-n144830",
"nuernberg-wastl-n144840",
"nuernberg-wbg_kundencenter_nordwest-f555230",
"nuernberg-wbg_monopol491-f554470",
"nuernberg-wbg_monopol491-f554480",
"nuernberg-wbg_monopol491-f554490",
"nuernberg-wbg_monopol491-f554500",
"nuernberg-wehr-f445070",
"nuernberg-wehrkirche_kraftshof-c132140",
"nuernberg-wehrkirche_kraftshof-f47110",
"nuernberg-wehrkirche_kraftshof-f47110",
"nuernberg-wehrkirche_kraftshof-nn83220",
"nuernberg-weigelshofer_weg-c21920",
"nuernberg-weigelshof-f492710",
"nuernberg-weiher_am_marienbergpark-cc43190",
"nuernberg-weintraubengasse-c251260",
"nuernberg-weissensee__an_autobahn_a3_-f403910",
"nuernberg-weisser_turm-bb8290",
"nuernberg-weisser_turm-c055510",
"nuernberg-weisser_turm-c156270",
"nuernberg-weisser_turm-c193790",
"nuernberg-weisser_turm-f426690",
"nuernberg-weisser_turm-f426720",
"nuernberg-weisser_turm-f426830",
"nuernberg-weisser_turm-f471910",
"nuernberg-weisser_turm-f471920",
"nuernberg-weisser_turm-f471920",
"nuernberg-weisser_turm-f484970",
"nuernberg-weisser_turm-n055270",
"nuernberg-weisser_weg-f492950",
"nuernberg-welserstrasse-bb86580",
"nuernberg-welserstrasse-c119160",
"nuernberg-welserstrasse-c119170",
"nuernberg-welserstrasse-c208030",
"nuernberg-welserstrasse-c208040",
"nuernberg-welserstrasse-cc17000",
"nuernberg-welserstrasse-cc17010",
"nuernberg-welserstrasse-f493130",
"nuernberg-welserstrasse-f493130",
"nuernberg-welserstrasse-n525200",
"nuernberg-werderau-f391640",
"nuernberg-werderau-f391650",
"nuernberg-werderau-f391660",
"nuernberg-werderau-f3990",
"nuernberg-werderau-n147520",
"nuernberg-werderau-n147530",
"nuernberg-wertstoffhof_am_pferdemarkt-f383260",
"nuernberg-westbad__neubau_-cc54270",
"nuernberg-westbad__umbau_-cc54350",
"nuernberg-westbad_neubau-cc54300",
"nuernberg-westbad-c108370",
"nuernberg-westbad-c19780",
"nuernberg-westbad-c19790",
"nuernberg-westbad-c241330",
"nuernberg-westbad-c241430",
"nuernberg-westbad-cc31510",
"nuernberg-westbad-f413000",
"nuernberg-westbad-f425710",
"nuernberg-westbad-f425710",
"nuernberg-westbad-f484990",
"nuernberg-westbad-f492560",
"nuernberg-westbad-f554440",
"nuernberg-westbad-n053940",
"nuernberg-westbad-n14540",
"nuernberg-westbad-n14550",
"nuernberg-westbad-n525320",
"nuernberg-westbad-nn66410",
"nuernberg-westbad-s562190",
"nuernberg-westfriedhof__krematorium-f493270",
"nuernberg-westfriedhof_-_trauerhalle-n363090",
"nuernberg-westfriedhof-c19670",
"nuernberg-westfriedhof-c19700",
"nuernberg-westfriedhof-c223540",
"nuernberg-westfriedhof-c245150",
"nuernberg-westfriedhof-c245180",
"nuernberg-westfriedhof-c245190",
"nuernberg-westfriedhof-c245200",
"nuernberg-westfriedhof-cb89910",
"nuernberg-westfriedhof-cb99890",
"nuernberg-westfriedhof-f435300",
"nuernberg-westfriedhof-f493240",
"nuernberg-westfriedhof-f493240",
"nuernberg-westfriedhof-f493250",
"nuernberg-westfriedhof-f493250",
"nuernberg-westfriedhof-n074800",
"nuernberg-westfriedhof-n245130",
"nuernberg-westfriedhof-n525460",
"nuernberg-westfriedhof-s562310",
"nuernberg-westpark-c199850",
"nuernberg-westpark-f425720",
"nuernberg-westpark-f492040",
"nuernberg-westpark-n075920",
"nuernberg-westtorgraben-c252080",
"nuernberg-westtorgraben-cb8750",
"nuernberg-wetzendorf-c132400",
"nuernberg-wetzendorf-c132420",
"nuernberg-wetzendorf-c132450",
"nuernberg-wetzendorf-c227090",
"nuernberg-wetzendorf-c227100",
"nuernberg-wetzendorf-c227110",
"nuernberg-wetzendorf-f393180",
"nuernberg-wetzendorf-f393190",
"nuernberg-wetzendorf-f393200",
"nuernberg-wetzendorf-f393210",
"nuernberg-wetzendorf-f393220",
"nuernberg-wetzendorf-f541020",
"nuernberg-wiener_kreisel-b183910",
"nuernberg-wiener_kreisel-b184040",
"nuernberg-wiener_kreisel-b184060",
"nuernberg-wiener_kreisel-b184110",
"nuernberg-wiener_kreisel-c161990",
"nuernberg-wiener_kreisel-c162050",
"nuernberg-wiener_kreisel-c162080",
"nuernberg-wiener_kreisel-c162120",
"nuernberg-wiener_kreisel-c252620",
"nuernberg-wiener_kreisel-c252630",
"nuernberg-wiener_kreisel-c252680",
"nuernberg-wiener_kreisel-f532060",
"nuernberg-wiese-cc18190",
"nuernberg-wiesengrund-f492260",
"nuernberg-wilhelm-loehe-schule-c226520",
"nuernberg-wilhelm-loehe-schule-f381280",
"nuernberg-wilhelm-loehe-schule-n341940",
"nuernberg-wilhelmshavener_strasse-c118900",
"nuernberg-wilhelmshavener_strasse-c21660",
"nuernberg-wilhelmshavener_strasse-c21680",
"nuernberg-wilhelmshavener_strasse-c21710",
"nuernberg-wilhelmshavener_strasse-c21750",
"nuernberg-wilhelmshavener_strasse-c244580",
"nuernberg-wilhelmshavener_strasse-c244600",
"nuernberg-wilhelmshavener_strasse-c244620",
"nuernberg-wilhelmshavener_strasse-c244650",
"nuernberg-wilhelmshavener_strasse-c312720",
"nuernberg-wilhelmshavener_strasse-c312730",
"nuernberg-wilhelmshavener_strasse-c312740",
"nuernberg-wilhelmshavener_strasse-c312770",
"nuernberg-wilhelmshavener_strasse-n26760",
"nuernberg-wilhelmshavener_strasse-n26780",
"nuernberg-wilhelmshavener_strasse-n26800",
"nuernberg-wilhelmshavener_strasse-n26830",
"nuernberg-wilhelmshavener_strasse-n26860",
"nuernberg-wilhelmshavener_strasse-n26870",
"nuernberg-wilhelmshavener_strasse-n342710",
"nuernberg-wilhelm-spaeth-strasse-f406800",
"nuernberg-wilhelm-spaeth-strasse-f426580",
"nuernberg-willstaetter_gymnasium-c119550",
"nuernberg-willstrasse-cd17660",
"nuernberg-willy-brandt-platz-c192180",
"nuernberg-willy-brandt-platz-c282360",
"nuernberg-willy-brandt-platz-f490350",
"nuernberg-willy-brandt-platz-n263090",
"nuernberg-willy-brandt-platz-n263100",
"nuernberg-willy-brandt-platz-n263160",
"nuernberg-willy-brandt-platz-n274900",
"nuernberg-winklerstrasse-c1130",
"nuernberg-winter-guenther-strasse-n262800",
"nuernberg-wirtschaftsrathaus-c212140",
"nuernberg-wirtschaftsrathaus-cc26170",
"nuernberg-witschelstrasse-c089790",
"nuernberg-witschelstrasse-c089810",
"nuernberg-witschelstrasse-c089860",
"nuernberg-witschelstrasse-c089900",
"nuernberg-witschelstrasse-c283850",
"nuernberg-witschelstrasse-c283860",
"nuernberg-witschelstrasse-f391300",
"nuernberg-witschelstrasse-f471460",
"nuernberg-witschelstrasse-f554330",
"nuernberg-witschelstrasse-n069720",
"nuernberg-witschelstrasse-n525370",
"nuernberg-witschelstrasse-n525380",
"nuernberg-witschelstrasse-n525390",
"nuernberg-wittekindstrasse-f4120",
"nuernberg-wittekindstrasse-f413630",
"nuernberg-wodanstrasse-f444580",
"nuernberg-woehrder_friedhof-c563870",
"nuernberg-woehrder_friedhof-f472090",
"nuernberg-woehrder_see_im_winter-cc43720",
"nuernberg-woehrder_see_sportplatz-n261950",
"nuernberg-woehrder_see-c036390",
"nuernberg-woehrder_see-c154600",
"nuernberg-woehrder_see-c154770",
"nuernberg-woehrder_see-c211230",
"nuernberg-woehrder_see-c211240",
"nuernberg-woehrder_see-c211250",
"nuernberg-woehrder_see-c211270",
"nuernberg-woehrder_see-c21860",
"nuernberg-woehrder_see-c21870",
"nuernberg-woehrder_see-c223670",
"nuernberg-woehrder_see-c223680",
"nuernberg-woehrder_see-c223690",
"nuernberg-woehrder_see-c223700",
"nuernberg-woehrder_see-c225570",
"nuernberg-woehrder_see-c225580",
"nuernberg-woehrder_see-c225600",
"nuernberg-woehrder_see-c225650",
"nuernberg-woehrder_see-c225660",
"nuernberg-woehrder_see-c225680",
"nuernberg-woehrder_see-c231100",
"nuernberg-woehrder_see-c231110",
"nuernberg-woehrder_see-c231120",
"nuernberg-woehrder_see-c231130",
"nuernberg-woehrder_see-c231140",
"nuernberg-woehrder_see-c231150",
"nuernberg-woehrder_see-c231160",
"nuernberg-woehrder_see-c231170",
"nuernberg-woehrder_see-c231180",
"nuernberg-woehrder_see-c231190",
"nuernberg-woehrder_see-c231200",
"nuernberg-woehrder_see-c231260",
"nuernberg-woehrder_see-c231270",
"nuernberg-woehrder_see-c231280",
"nuernberg-woehrder_see-c252890",
"nuernberg-woehrder_see-c252910",
"nuernberg-woehrder_see-c252920",
"nuernberg-woehrder_see-c252930",
"nuernberg-woehrder_see-c252940",
"nuernberg-woehrder_see-c252950",
"nuernberg-woehrder_see-c252960",
"nuernberg-woehrder_see-c253470",
"nuernberg-woehrder_see-c253490",
"nuernberg-woehrder_see-c253510",
"nuernberg-woehrder_see-c282680",
"nuernberg-woehrder_see-c28930",
"nuernberg-woehrder_see-c28940",
"nuernberg-woehrder_see-c564080",
"nuernberg-woehrder_see-c564090",
"nuernberg-woehrder_see-cc43730",
"nuernberg-woehrder_see-f381610",
"nuernberg-woehrder_see-f39460",
"nuernberg-woehrder_see-f404810",
"nuernberg-woehrder_see-f404960",
"nuernberg-woehrder_see-f405020",
"nuernberg-woehrder_see-f405050",
"nuernberg-woehrder_see-f405100",
"nuernberg-woehrder_see-f405110",
"nuernberg-woehrder_see-f405820",
"nuernberg-woehrder_see-f406840",
"nuernberg-woehrder_see-f413150",
"nuernberg-woehrder_see-f413160",
"nuernberg-woehrder_see-f413170",
"nuernberg-woehrder_see-f413200",
"nuernberg-woehrder_see-f435000",
"nuernberg-woehrder_see-f464680",
"nuernberg-woehrder_see-f530820",
"nuernberg-woehrder_see-f530860",
"nuernberg-woehrder_see-f554460",
"nuernberg-woehrder_see-n028830",
"nuernberg-woehrder_see-n076250",
"nuernberg-woehrder_see-n144920",
"nuernberg-woehrder_see-n242650",
"nuernberg-woehrder_see-n262070",
"nuernberg-woehrder_see-n262080",
"nuernberg-woehrder_see-n262090",
"nuernberg-woehrder_see-n262100",
"nuernberg-woehrder_see-n262110",
"nuernberg-woehrder_see-n262140",
"nuernberg-woehrder_see-n33430",
"nuernberg-woehrder_see-n33560",
"nuernberg-woehrder_see-n361650",
"nuernberg-woehrder_see-n361670",
"nuernberg-woehrder_see-n362170",
"nuernberg-woehrder_see-n362180",
"nuernberg-woehrder_see-n36380",
"nuernberg-woehrder_see-n530660",
"nuernberg-woehrder_see-nn67770",
"nuernberg-woehrder_taluebergang-cc31890",
"nuernberg-woehrder_taluebergang-f382820",
"nuernberg-woehrder_taluebergang-f435010",
"nuernberg-woehrder_taluebergang-f435050",
"nuernberg-woehrder_taluebergang-n294160",
"nuernberg-woehrder_taluebergang-n361420",
"nuernberg-woehrder_wiese_im_herbst-n076510",
"nuernberg-woehrder_wiese_im_herbst-nn81200",
"nuernberg-woehrder_wiese-c117550",
"nuernberg-woehrder_wiese-c207790",
"nuernberg-woehrder_wiese-c207800",
"nuernberg-woehrder_wiese-c243920",
"nuernberg-woehrder_wiese-c564070",
"nuernberg-woehrder_wiese-f426380",
"nuernberg-woehrder_wiese-f435080",
"nuernberg-woehrder_wiese-f471610",
"nuernberg-woehrder_wiese-n05560",
"nuernberg-woehrder_wiese-n294670",
"nuernberg-woehrder_wiese-n32140",
"nuernberg-woehrder_wiese-nn65860",
"nuernberg-woehrd-f39920",
"nuernberg-woehrd-f405370",
"nuernberg-woehrd-f465280",
"nuernberg-woehrd-f465300",
"nuernberg-woehrd-f484720",
"nuernberg-woehrd-f484740",
"nuernberg-woehrd-n14160",
"nuernberg-woehrd-n262060",
"nuernberg-woehrl-n364130",
"nuernberg-woelckernstrasse-c134450",
"nuernberg-woelckernstrasse-c135030",
"nuernberg-woelckernstrasse-f383330",
"nuernberg-woelckernstrasse-n076370",
"nuernberg-woelckernstrasse-n147160",
"nuernberg-wohnanlage_norikus-nn67050",
"nuernberg-wohnsiedlung_am_westpark-n075390",
"nuernberg-wohnsiedlung_bei_gleiwitzer_strasse-c109880",
"nuernberg-wohnstift_am_tiergarten-cc43590",
"nuernberg-wohnstift_am_tiergarten-f484430",
"nuernberg-wohnstift_am_tiergarten-f484440",
"nuernberg-wolgemutstrasse-f384360",
"nuernberg-wolgemutstrasse-n24790",
"nuernberg-wollentorstrasse-c134350",
"nuernberg-wollentorstrasse-c212250",
"nuernberg-worzeldorf-c232380",
"nuernberg-worzeldorf-c232580",
"nuernberg-worzeldorfer_steinbruch-f381080",
"nuernberg-worzeldorfer_steinbruch-n29740",
"nuernberg-worzeldorfer_steinbruch-n29760",
"nuernberg-worzeldorf-f490560",
"nuernberg-worzeldorf-f490700",
"nuernberg-worzeldorf-f490710",
"nuernberg-worzeldorf-f490720",
"nuernberg-worzeldorf-n146470",
"nuernberg-worzeldorf-n146510",
"nuernberg-worzeldorf-n243230",
"nuernberg-worzeldorf-n29780",
"nuernberg-worzeldorf-n29790",
"nuernberg-worzeldorf-n29800",
"nuernberg-worzeldorf-nn75770",
"nuernberg-zabo_kirche-c207450",
"nuernberg-zabo_kirche-c207460",
"nuernberg-zabo_kreisel-c195500",
"nuernberg-zabo_kreisel-c195540",
"nuernberg-z-bau-c122230",
"nuernberg-zeisigweg-f540130",
"nuernberg-zeltnerschloss-b182740",
"nuernberg-zeltnerschloss-c039250",
"nuernberg-zeltnerschloss-c039270",
"nuernberg-zeltnerschloss-c242540",
"nuernberg-zeltnerschloss-c563830",
"nuernberg-zeltnerschloss-cc41880",
"nuernberg-zeltnerschloss-f444920",
"nuernberg-zeltnerschloss-f554620",
"nuernberg-zeltnerschloss-f554630",
"nuernberg-zeltnerschloss-n013380",
"nuernberg-zeltnerschloss-nn81960",
"nuernberg-zeltnerschloss-nn82190",
"nuernberg-zeppelinfeld___steintribuene-c282080",
"nuernberg-zeppelinfeld___steintribuene-n076570",
"nuernberg-zeppelinfeld-c047300",
"nuernberg-zeppelinfeld-c281480",
"nuernberg-zeppelinfeld-n068990",
"nuernberg-zerzabelshof-c1010",
"nuernberg-zerzabelshof-c135060",
"nuernberg-zerzabelshof-c135220",
"nuernberg-zerzabelshof-c23660",
"nuernberg-zerzabelshof-c31710",
"nuernberg-zerzabelshof-f384140",
"nuernberg-zerzabelshof-f384150",
"nuernberg-zerzabelshof-f391810",
"nuernberg-zerzabelshof-f391820",
"nuernberg-zerzabelshof-f391830",
"nuernberg-zerzabelshof-f39500",
"nuernberg-zerzabelshof-f39510",
"nuernberg-zerzabelshof-f39520",
"nuernberg-zerzabelshof-f39530",
"nuernberg-zerzabelshof-f444920",
"nuernberg-zerzabelshof-n144580",
"nuernberg-zerzabelshof-n242630",
"nuernberg-zerzabelshof-n262390",
"nuernberg-zerzabelshof-n262400",
"nuernberg-zerzabelshof-n262410",
"nuernberg-zerzabelshof-n303610",
"nuernberg-zerzabelshof-n30400",
"nuernberg-zerzabelshof-n30420",
"nuernberg-zerzabelshof-n30430",
"nuernberg-zerzabelshof-n341540",
"nuernberg-zerzabelshof-n36450",
"nuernberg-zerzabelshof-n510540",
"nuernberg-zerzableshof-f413220",
"nuernberg-zerzableshof-f47800",
"nuernberg-ziegelstein-b181990",
"nuernberg-ziegelstein-c12960",
"nuernberg-ziegelstein-c191190",
"nuernberg-ziegelstein-c196890",
"nuernberg-ziegelstein-c196930",
"nuernberg-ziegelstein-c196950",
"nuernberg-ziegelstein-c24180",
"nuernberg-ziegelstein-c24210",
"nuernberg-ziegelstein-f381460",
"nuernberg-ziegelstein-f381870",
"nuernberg-ziegelstein-f382890",
"nuernberg-ziegelstein-f382900",
"nuernberg-ziegelstein-f391080",
"nuernberg-ziegelstein-f406970",
"nuernberg-ziegelstein-f472170",
"nuernberg-ziegelstein-f472170",
"nuernberg-ziegelstein-f472170",
"nuernberg-ziegelstein-n261210",
"nuernberg-ziegelstein-n261220",
"nuernberg-ziegelstein-n303840",
"nuernberg-ziegelstein-n303850",
"nuernberg-zirkus_flicflac-b182930",
"nuernberg-zirkus_flicflac-b183020",
"nuernberg-zirkus_roncalli-n076660",
"nuernberg-zirkus_roncalli-n076680",
"nuernberg-zollhaus_biergarten-f434280",
"nuernberg-zollhaus-c505110",
"nuernberg-zollhaus-c505130",
"nuernberg-zollhaus-f38880",
"nuernberg-zollhaus-f444180",
"nuernberg-zollhaus-f454750",
"nuernberg-zollhaus-n36720",
"nuernberg-zollhaus-n36750",
"nuernberg-zollhof-f384300",
"nuernberg-zollhof-f393310",
"nuernberg-zollhof-f393320",
"nuernberg-zollhof-f413360",
"nuernberg-zollhof-f434110",
"nuernberg-zollhof-f435190",
"nuernberg-zuericher_strasse-c251890",
"nuernberg-zuericher_strasse-c281690",
"nuernberg-zuericher_strasse-f412440",
"nuernberg-zuericher_strasse-n295410",
"nuernberg-zuericher_strasse-n295500",
"nuernberg-zuericher_strasse-n363680",
"nuernberg-zug-c134970",
"nuernberg-zug-c19540",
"nuernberg-zug-c21310",
"nuernberg-zugefrorenes_schleusenbecken-cc4720",
"nuernberg-zug-n144540",
"nuernberg-zweibrueckener_strasse-f39280",
"nuernberg-zwischen_den_fleischbaenken-f445060",
"oberalbach-oberalbach-f42210",
"oberammergau-alpenvorland-c501450",
"oberammergau-alpenvorland-c501460",
"oberammergau-alpenvorland-c501490",
"oberammergau-alpenvorland-c501500",
"oberampfrach-oberampfrach-f40460",
"oberasbach-grundschule_altenberg-c500300",
"oberasbach-hainpark-c19100",
"oberasbach-oberasbach-c162330",
"oberasbach-oberasbach-c162350",
"oberasbach-oberasbach-c162360",
"oberasbach-oberasbach-c254430",
"oberasbach-oberasbach-c254440",
"oberasbach-petershoehe-n244460",
"oberferrieden-etzelsdorf__oberferrieden-f510340",
"oberfueberg-oberfuerberg-n530900",
"ober-igelheim-ober-igelheim-f374910",
"ober-igelheim-ober-ingelheim-f374900",
"oberkrumbach-kirche_in_oberkrumbach-f423500",
"oberlindach-oberlindach-f378600",
"obermichelbach-biogasanlage_obermichelbach-c284940",
"obermichelbach-rothenberg-c284910",
"obermichelbach-rothenberg-c284930",
"obermichelbach-untermichelbach-c284950",
"obermichelbach-untermichelbach-c284970",
"obermichelbach-untermichelbach-c284980",
"obernbiebert-obernbiebert-f40210",
"oberndorf-oberndorf-f512530",
"obernzenn-obernzenn-n271200",
"oberpeiching-baggersee_bei_oberpeiching-n323720",
"oberreichenbach-oberreichenbach-c500330",
"oberreichenbach-oberreichenbach-c560120",
"oberreichenbach-oberreichenbach-c560130",
"oberreichenbach-oberreichenbach-c560140",
"oberreichenbach-oberreichenbach-f46300",
"oberreichenbach-oberreichenbach-f513840",
"oberreichenbach-sc_oberreichenbach-c560150",
"oberrimbach-oberrimbach-f37180",
"oberstrahlbach-oberstrahlbach-f378560",
"obersulzbach-obersulzbach-f42600",
"obersulzbach-obersulzbach-f42610",
"oberwall-burkertshof-n524780",
"oberwall-gebertshof-n524830",
"oberweickenhof-baernreuther_deuerlein_schotterwerke-f422280",
"oberweickenhof-baernreuther_deuerlein_schotterwerke-f422290",
"oberweickenhof-baernreuther_deuerlein_schotterwerke-f422300",
"oberweiling-autobahn_a3_bei_oberweiling-f422230",
"oberweiling-autobahnbruecke_a3_bei_kalkhofen-f422170",
"oberwohlsbach-bahntunnel-n356910",
"ochsenfurt-alte_mainbruecke_-_ochsenfurt-c561540",
"ochsenfurt-campingplatz_polisina-c561370",
"ochsenfurt-gewerbegebiet_ochsenfurt-c561520",
"ochsenfurt-gewerbegebiet_ochsenfurt-c561530",
"ochsenfurt-main_insel_bad_ochsenfurt-c561560",
"ochsenfurt-main_insel_bad_ochsenfurt-c561570",
"ochsenfurt-ochsenfurt_-_altstadt-s560380",
"ochsenfurt-ochsenfurt_-_altstadt-s560390",
"ochsenfurt-ochsenfurt_-_taubenturm-c561490",
"ochsenfurt-ochsenfurt-c561360",
"ochsenfurt-ochsenfurt-c561470",
"ochsenfurt-ochsenfurt-c561500",
"ochsenfurt-ochsenfurt-c561510",
"ochsenfurt-ochsenfurt-s560360",
"ochsenfurt-ochsenfurt-s560370",
"ochsenfurt-st__andreas_kirche_ochsenfurt-c561480",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-c561410",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-c561420",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-c561430",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-c561440",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-c561580",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-s560330",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-s560340",
"ochsenfurt-suedzucker_ag_werk_ochsenfurt-s560350",
"ochsenfurt-volksschule_ochsenfurt-c561450",
"ochsenfurt-volksschule_ochsenfurt-c561460",
"ochsenfurt-volksschule_ochsenfurt-c561550",
"ochsenfurt-wasserkraftwerk_gossmannsdorf-s560430",
"ochsenfurt-wasserkraftwerk_gossmannsdorf-s560440",
"offenberg-neuhausen-f521680",
"offenberg-neuhausen-f521690",
"offenberg-neuhausen-f521700",
"offenberg-neuhausen-f521710",
"offenberg-offenberg-n522980",
"offenberg-schloss_offenberg-n522950",
"offenberg-schloss_offenberg-n522970",
"oy-mittelberg-autobahn_a7-c502150",
"oy-mittelberg-autobahn_a7-c502160",
"oy-mittelberg-autobahn_a7-c502170",
"oy-mittelberg-autobahn_a7-c502180",
"oy-mittelberg-kreisverkehr-c502130",
"oy-mittelberg-oy-mittelberg-c502110",
"oy-mittelberg-oy-mittelberg-c502120",
"oy-mittelberg-schwarzenberger_weiher-c502140",
"parkstetten-lieblsee-f522020",
"parkstetten-lieblsee-f522030",
"parkstetten-oeberauer_donauschleife-f522000",
"parkstetten-oeberauer_donauschleife-f522010",
"parsberg-darshofen-n302820",
"parsberg-darshofen-n302830",
"parsberg-freibad-n301220",
"parsberg-kipfenberg-n302850",
"parsberg-krankenhaus-n301240",
"parsberg-parsberg-n301230",
"parsberg-parsberg-n302750",
"parsberg-parsberg-n302760",
"parsberg-parsberg-n302770",
"parsberg-parsberg-n302780",
"parsberg-parsberg-n302790",
"parsberg-parsberg-n302800",
"parsberg-parsberg-n302810",
"passau-alstadt_passau-n521770",
"passau-alstadt_passau-n521820",
"passau-alstadt_passau-n521830",
"passau-alstadt_passau-n521840",
"passau-alstadt_passau-n521850",
"passau-alstadt_passau-n521880",
"passau-altstadt_passau-n521600",
"passau-altstadt_passau-n521740",
"passau-brauerei_hacklberg-n521690",
"passau-brauerei_hacklberg-n521930",
"passau-dom_st__stephan-n521580",
"passau-dom_st__stephan-n521670",
"passau-dom_st__stephan-n521780",
"passau-dom_st__stephan-n521790",
"passau-dom_st__stephan-n521870",
"passau-domplatz_passau-n521800",
"passau-donau-n521710",
"passau-fensterfabrik_niederhofer-f521160",
"passau-fensterfabrik_niederhofer-f521170",
"passau-flussmuendung_donau_inn-n521810",
"passau-franz-josef-strauss-bruecke-n521970",
"passau-franz-josef-strauss-bruecke-n521980",
"passau-gymnasium_leopoldinum-n521760",
"passau-hacklberg_passau-n521900",
"passau-hacklberg_passau-n521940",
"passau-hauptbahnhof_passau-n521680",
"passau-innstadt_passau-n521590",
"passau-kaiserin-elisabeth-bruecke-n521640",
"passau-kirche_st__nikola-n521610",
"passau-kraftwerk_kachlet-n521950",
"passau-kraftwerk_kachlet-n521990",
"passau-marienbruecke__passau-n521630",
"passau-marienbruecke__passau-n521730",
"passau-passau_inn-n521650",
"passau-passau_inn-n521660",
"passau-passau_neustift-n522040",
"passau-passau_neustift-n522050",
"passau-passau-f521110",
"passau-passau-f521130",
"passau-passau-f521140",
"passau-passau-f521150",
"passau-sankt_severin_kirche-n521620",
"passau-schaiblingsturm-n521750",
"passau-schanzlbruecke-n521720",
"passau-schloss_freudenhain-n521700",
"passau-schloss_freudenhain-n521910",
"passau-schloss_freudenhain-n521920",
"passau-solarpark_maierhof_passau-n521960",
"passau-steinbachstrasse-n522000",
"passau-veste_oberhaus-f521100",
"passau-veste_oberhaus-f521120",
"passau-veste_oberhaus-n521570",
"pausa-muehltroff-ranspach-n351360",
"pausa-muehltroff-ranspach-n351370",
"pegnitz-bronn-n275880",
"peiting-peiting-f500580",
"peiting-schwarzlaichmoor-c501440",
"petersgmuend-petersgmuender_baggerweiher-n321760",
"pettendorf-adlersberg-n302300",
"pettendorf-adlersberg-n302310",
"pettendorf-eibrunn-n302350",
"pettendorf-guenzenried-n302280",
"pettendorf-hummelberg-n302290",
"pettendorf-naab-n302330",
"pettendorf-penk-n301350",
"pielenhofen-campingplatz-n301340",
"pielenhofen-kloster_pielenhofen-n520930",
"pielenhofen-kloster_pielenhofen-n521010",
"pielenhofen-konstein_bei_pielenhofen-f520700",
"pielenhofen-konstein_bei_pielenhofen-f520710",
"pielenhofen-pielenhofen-f520720",
"pielenhofen-pielenhofen-n302360",
"pielenhofen-pielenhofen-n302370",
"pielenhofen-pielenhofen-n302380",
"pielenhofen-pielenhofen-n302390",
"pielenhofen-pielenhofen-n302400",
"pielenhofen-pielenhofen-n302430",
"pielenhofen-pielenhofen-n520950",
"pielenhofen-pielenhofen-n520960",
"pilsach-braeunertshof-f522480",
"pilsach-braeunertshof-f522490",
"pilsach-braeunertshof-f522500",
"pilsach-talbruecke_pilsach-f461790",
"pinzberg-dobenreuth-n276470",
"pinzberg-dobenreuth-n276480",
"pinzberg-dobenreuth-n276500",
"pinzberg-dobenreuth-n276510",
"pinzberg-elsenberg-n276550",
"pinzberg-pinzberg-n276560",
"pinzberg-pinzberg-n276570",
"pinzberg-pinzberg-n276580",
"pinzberg-pinzberg-n276600",
"pinzberg-pinzberg-n276610",
"pleinfeld-abbau_pappenheim-f500260",
"pleinfeld-abbau_pappenheim-f500270",
"pleinfeld-abbau_pappenheim-f500290",
"pleinfeld-allmannsdorf-f500180",
"pleinfeld-asphaltmischanlage-n273250",
"pleinfeld-asphaltmischanlage-n273280",
"pleinfeld-asphaltmischanlage-n273300",
"pleinfeld-brombachsee-c09780",
"pleinfeld-brombachsee-f500190",
"pleinfeld-brombachsee-f500200",
"pleinfeld-brombachsee-f500210",
"pleinfeld-brombachsee-f500230",
"pleinfeld-brombachsee-f502300",
"pleinfeld-brombachsee-f513790",
"pleinfeld-brombachsee-n292130",
"pleinfeld-brombachsee-n292180",
"pleinfeld-brombachsee-n292200",
"pleinfeld-brombachsee-n321980",
"pleinfeld-brombachsee-n321990",
"pleinfeld-brombachsee-n514980",
"pleinfeld-brombachsee-n514990",
"pleinfeld-brombachsee-n515020",
"pleinfeld-firma_fiegel_bei_pleinfeld-n321860",
"pleinfeld-guendersbach-n292060",
"pleinfeld-heiligenwaldsee-n321870",
"pleinfeld-hohenweiler-n321850",
"pleinfeld-kemnathen-n291150",
"pleinfeld-kreisverkehr_bei_pleinfeld-n321950",
"pleinfeld-mackenmuehle-n321840",
"pleinfeld-mandlesweiher-n515000",
"pleinfeld-pleinfeld-f513780",
"pleinfeld-pleinfeld-n321930",
"pleinfeld-pleinfeld-n321940",
"pleinfeld-ramsberg-f500220",
"pleinfeld-sankt_veit-f500240",
"pleinfeld-veitserlbach-n292100",
"pleinfeld-walkerszell-n292070",
"pleinfeld-wurmmuehle-n321920",
"pleinfeld-wurmmuehle-n321970",
"ploessberg-beidl-f550670",
"polling-holzhausen-f510990",
"polling-holzhausen-f511000",
"polling-liebhartsberg-n512010",
"polling-oberflossing-f510980",
"polling-oberflossing-n512030",
"pommersfelden-oberndorf-n265700",
"pommersfelden-sambach-n265680",
"pommersfelden-sambach-n265710",
"pommersfelden-sambach-n265720",
"pommersfelden-schloss_weissenstein-n265480",
"pommersfelden-schloss_weissenstein-n265490",
"pommersfelden-schloss_weissenstein-n265520",
"pommersfelden-schloss_weissenstein-n265530",
"pommersfelden-schloss_weissenstein-n265570",
"pommersfelden-schloss_weissenstein-n265600",
"pommersfelden-schloss_weissenstein-n265610",
"pommersfelden-schloss_weissenstein-n265620",
"pommersfelden-schloss_weissenstein-n265630",
"pommersfelden-schloss_weissenstein-n265640",
"pommersfelden-schloss_weissenstein-n265660",
"pommersfelden-schloss_weissenstein-n265670",
"poppberg-alfeld_bei_poppberg-f442930",
"poppberg-autobahn_a6_bei_poppberg-f423140",
"poppberg-autobahn_a6_bei_poppberg-f423140",
"poppberg-autobahn_a6_bei_poppberg-f423160",
"poppberg-autobahn_a6_bei_poppberg-f423230",
"poppberg-autobahn_a6_bei_poppberg-f423310",
"poppberg-autobahn_a6_bei_poppberg-f462290",
"poppberg-baustelle_autobahn_a6_bei_poppberg-f442770",
"poppberg-baustelle_autobahn_a6_bei_poppberg-f442860",
"poppberg-baustelle_autobahn_bei_poppberg-f432630",
"poppberg-baustelle_autobahn_bei_poppberg-f432700",
"poppberg-baustelle_autobahn_bei_poppberg-f432760",
"poppberg-frankenjura__bei_poppberg_-f462310",
"poppberg-frankenjura__bei_poppberg_-f462330",
"poppberg-haus_im_wald-f462320",
"poppberg-poppberg-f402110",
"poppberg-poppberg-f423130",
"poppberg-poppberg-f453130",
"poppberg-windrad_bei_poppberg-f423350",
"poppberg-windrad_bei_poppberg-f423350",
"postbauer_heng-buch-n303280",
"postbauer_heng-buch-n303340",
"postbauer_heng-buch-n303350",
"postbauer_heng-dillberg-n303290",
"postbauer_heng-dillberg-n303300",
"postbauer_heng-kago_villa-n068470",
"postbauer_heng-kago_villa-n068500",
"postbauer_heng-kago_villa-n068600",
"postbauer_heng-kago_villa-n30690",
"postbauer_heng-kago_villa-n30720",
"postbauer_heng-kago_villa-n30730",
"postbauer-heng-kago_villa-n520590",
"postbauer-heng-kago_villa-n520600",
"postbauer-heng-kago_villa-n520610",
"postbauer-heng-kago_villa-n520620",
"postbauer-heng-postbauer-heng-f520520",
"postbauer-heng-postbauer-heng-f520530",
"pottenstein-burg_pottenstein-n276000",
"pottenstein-burg_pottenstein-n276020",
"pottenstein-burg_pottenstein-n276040",
"pottenstein-burg_pottenstein-n276060",
"pottenstein-himmelsleiter-n275940",
"pottenstein-himmelsleiter-n275950",
"pottenstein-tuechersfeld-n276070",
"pottenstein-tuechersfeld-n276080",
"pretzfeld-roethelfeld_-_eberhardstein-f553490",
"pretzfeld-roethelfeld_-_eberhardstein-f553500",
"pretzfeld-roethelfeld_-_eberhardstein-f553510",
"pretzfeld-unterzaunsbach-f553530",
"pretzfeld-urspring-f553520",
"probstzella-lichtentanne-n356680",
"prutting-erdgas-untergrundspeicher_inzenham-f512930",
"pullhausen-windrad_bei_pullhausen-f481340",
"pullhausen-windrad_bei_pullhausen-f481350",
"rain-gaertnersiedlung-n323650",
"rain-gewerbegebiet-n323660",
"rain-gewerbegebiet-n325940",
"rain-landwirtschaft_bei_rain-n323700",
"rain-mittelstetten-n323640",
"rain-rain-n323680",
"rain-rain-n323690",
"rain-rain-n325870",
"rain-rain-n325880",
"rain-rain-n325900",
"raitenbuch-reuth_am_wald-f48820",
"ramsberg-brombachsee-n292090",
"ramsberg-brombachsee-n292120",
"ranis-barockschloss_brandenstein-n356360",
"ranis-burg_ranis-n356270",
"ranis-burg_ranis-n356280",
"ranis-burg_ranis-n356300",
"ranis-burg_ranis-n356340",
"ranis-burg_ranis-n356350",
"ranis-burg_ranis-n356370",
"ranis-burg_ranis-n356440",
"rauenthal-rauenthal-f374690",
"ravensburg-bei_ravensburg-f501580",
"ravensburg-bundesstrasse_b30-c503820",
"ravensburg-bundesstrasse_b30-c503830",
"ravensburg-bundesstrasse_b30-c503910",
"ravensburg-egelsee-c503950",
"ravensburg-gewerbegebiet_karrer-c503840",
"ravensburg-gewerbegebiet_karrer-c503850",
"ravensburg-gewerbegebiet_niederbiegen-c503920",
"ravensburg-gewerbegebiet_niederbiegen-c503930",
"ravensburg-golfclub_ravensburg-f501490",
"ravensburg-golfclub_ravensburg-f501500",
"ravensburg-golfclub_ravensburg-f501510",
"ravensburg-hagenbach-f501470",
"ravensburg-huebscher-f501460",
"ravensburg-klaeranlage_langwiese-c503860",
"ravensburg-oberzell__weinanbau_-f501430",
"ravensburg-oberzell-f501420",
"ravensburg-okatreute-f501480",
"ravensburg-ravensburg-f501450",
"ravensburg-schmalegg-f501520",
"ravensburg-schussentalhalle-c503880",
"ravensburg-tsv_berg-c503900",
"reckenstetten-landwirtschaftliche_anlage-f421730",
"reckenstetten-landwirtschaftliche_anlage-f421750",
"rednitzhembach-rednitzhembach-c213800",
"rednitzhembach-untermainbach-n292790",
"rednitzhembach-untermainbach-n292800",
"regensburg-arcaden-n302030",
"regensburg-arcaden-n302060",
"regensburg-dom_sankt_peter-n521090",
"regensburg-dom_sankt_peter-n521100",
"regensburg-dom_sankt_peter-n521110",
"regensburg-dom_sankt_peter-n521130",
"regensburg-donaubruecke_sinzing-n521190",
"regensburg-donaustaufer_altwasser-n301480",
"regensburg-emmeramsplatz-n521150",
"regensburg-gewerbegebiet-n301420",
"regensburg-hauptbahnhof_regensburg-f520830",
"regensburg-hauptbahnhof-n302020",
"regensburg-hauptbahnhof-n302070",
"regensburg-jahnstadion_regenburg-n521210",
"regensburg-jahnstadion_regenburg-n521220",
"regensburg-jahnstadion_regenburg-n521230",
"regensburg-jahnstadion_regenburg-n521240",
"regensburg-jahnstadion_regenburg-n521260",
"regensburg-jahnstadion_regenburg-n521280",
"regensburg-jahnstadion_regenburg-n521300",
"regensburg-kneiting-n302250",
"regensburg-kreuz_regenburg-n521200",
"regensburg-museum_der_bayerischen_geschichte-n521050",
"regensburg-museum_der_bayerischen_geschichte-n521080",
"regensburg-neupfarrplatz-n521120",
"regensburg-oberwinzer-n302240",
"regensburg-pettendorf-n302270",
"regensburg-pfaffensteiner_wehr-n521030",
"regensburg-regensburg_karolinenhof-f520840",
"regensburg-regensburg_karolinenhof-f520850",
"regensburg-regensburg_koenigswiesen-f520860",
"regensburg-regensburg-f520730",
"regensburg-regensburg-f520740",
"regensburg-regensburg-f520750",
"regensburg-regensburg-f520760",
"regensburg-regensburg-f520770",
"regensburg-regensburg-f520780",
"regensburg-regensburg-f520790",
"regensburg-regensburg-f520800",
"regensburg-regensburg-f520810",
"regensburg-regensburg-f520820",
"regensburg-regensburg-f520870",
"regensburg-regensburg-n301370",
"regensburg-regensburg-n301390",
"regensburg-regensburg-n301400",
"regensburg-regensburg-n301440",
"regensburg-regensburg-n301450",
"regensburg-regensburg-n301460",
"regensburg-regensburg-n301730",
"regensburg-regensburg-n301740",
"regensburg-regensburg-n301750",
"regensburg-regensburg-n301760",
"regensburg-regensburg-n301770",
"regensburg-regensburg-n301780",
"regensburg-regensburg-n301790",
"regensburg-regensburg-n301800",
"regensburg-regensburg-n301820",
"regensburg-regensburg-n301830",
"regensburg-regensburg-n301840",
"regensburg-regensburg-n301850",
"regensburg-regensburg-n301870",
"regensburg-regensburg-n301880",
"regensburg-regensburg-n301890",
"regensburg-regensburg-n301900",
"regensburg-regensburg-n301910",
"regensburg-regensburg-n301920",
"regensburg-regensburg-n301930",
"regensburg-regensburg-n301940",
"regensburg-regensburg-n301950",
"regensburg-regensburg-n301960",
"regensburg-regensburg-n301970",
"regensburg-regensburg-n301980",
"regensburg-regensburg-n301990",
"regensburg-regensburg-n302010",
"regensburg-regensburg-n302040",
"regensburg-regensburg-n302080",
"regensburg-regensburg-n302090",
"regensburg-regensburg-n302110",
"regensburg-regensburg-n302120",
"regensburg-regensburg-n302130",
"regensburg-regensburg-n302140",
"regensburg-regensburg-n302150",
"regensburg-regensburg-n302160",
"regensburg-regensburg-n302170",
"regensburg-regensburg-n302180",
"regensburg-regensburg-n302190",
"regensburg-regensburg-n302200",
"regensburg-regensburg-n302210",
"regensburg-regensburg-n302220",
"regensburg-regensburg-n302260",
"regensburg-regensburg-n521060",
"regensburg-regensburg-n521140",
"regensburg-regensburg-n521160",
"regensburg-regensburg-n521270",
"regensburg-schloss_st__emmeram-n302100",
"regensburg-schloss_st__emmeram-n521170",
"regensburg-schwimmbad-n302230",
"regensburg-siemens_rail_inbetriebsetzungsstuetzpunkt-n521180",
"regensburg-steinerne_bruecke-n521040",
"regensburg-steinerne_bruecke-n521070",
"regensburg-tegernheim_am_weinberg-n301670",
"regensburg-tegernheim_am_weinberg-n301680",
"regensburg-tegernheim-n301690",
"regensburg-tegernheim-n301700",
"regensburg-tegernheim-n301710",
"regensburg-tegernheim-n301720",
"regensburg-walhalla-n301500",
"regensburg-walhalla-n301510",
"regensburg-walhalla-n301520",
"regensburg-walhalla-n301530",
"regensburg-walhalla-n301540",
"regensburg-walhalla-n301580",
"regensburg-walhalla-n301610",
"regensburg-walhalla-n301620",
"regensburg-walhalla-n301640",
"regensburg-walhalla-n301650",
"reichenschwand-bauhof_reichenschwand-f550470",
"reichenschwand-schloss_reichenschwand-c313520",
"reichenschwand-schloss_reichenschwand-c313570",
"reichenschwand-schloss_reichenschwand-c313630",
"reichenschwand-schloss_reichenschwand-c313650",
"reichenschwand-schlosshotel_reichenschwand-c313580",
"reichertshofen-reichertshofen-f431420",
"reinersdorf-reinersdorf-c560060",
"reinersdorf-reinersdorf-f3760",
"reinersdorf-reinersdorf-f3770",
"rennertshofen-rennertshofen-n323430",
"rennhofen-rennhofen-f40120",
"rennhofen-rennhofen-f40130",
"rennhofen-rennhofen-f42290",
"rezelsdorf-rezelsdorf-f4070",
"rezelsdorf-windraeder_bei_rezelsdorf-f42180",
"rhein-schifffahrt_am_rhein-f374820",
"richthofen-wallfahrtskirche_maria_heil_der_kranken-f422340",
"rieden_am_forggensee-alpenvorland-f500950",
"rieden_am_forggensee-alpenvorland-f500970",
"rieden_am_forggensee-forggensee-f500850",
"rieden_am_forggensee-forggensee-f500880",
"rieneck-burg_rieneck-c562920",
"rieneck-burg_rieneck-c562950",
"rieneck-burg_rieneck-c562970",
"rieneck-burg_rieneck-c562990",
"rieneck-burg_rieneck-c563030",
"rieneck-burg_rieneck-c563050",
"rieneck-rieneck-c562930",
"rieneck-rieneck-c563010",
"rieneck-rieneck-c563020",
"rieneck-rieneck-c563060",
"rittsteig-sv_schalding-heining-n522060",
"roeslau-roeslau-f551360",
"roeslau-roeslau-f551370",
"roethenbach__allgaeu_-rentershofen-c502780",
"roethenbach__allgaeu_-weihers__allgaeu_-c502810",
"roethenbach_an_der_pegnitz-freibad_roethenbach-f433490",
"roethenbach_an_der_pegnitz-gewerbegebiet_roethenbachtal-c253190",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c16750",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c16770",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c16780",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c223830",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c223870",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c223970",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c253210",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c253220",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c253240",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c253250",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c253260",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c253280",
"roethenbach_an_der_pegnitz-roethenbach_an_der_pegnitz-c253300",
"roethenbach_an_der_pegnitz-tsv_1899_roethenbach-f433480",
"roettenbach-niedermauk-n321780",
"rohrbrunn-anschlussstelle_rohrbrunn-s561400",
"rohrbrunn-anschlussstelle_rohrbrunn-s561420",
"rohrbrunn-anschlussstelle_rohrbrunn-s561430",
"rohrdorf-raststaette_samerberg_a8-n513550",
"rohrdorf-raststaette_samerberg_a8-n513560",
"rohrdorf-steinbruch_rohrdorf-n513500",
"rohrdorf-steinbruch_rohrdorf-n513530",
"rohr-golfrange_nuernberg-f500170",
"rohr-golfrange_nuernberg-f513860",
"rohr-golfrange_nuernberg-f513870",
"rosenbach-mehltheuer-n351350",
"rosenbach-rosenbach-f40260",
"rosenheim-alpenvorland-f512550",
"rosenheim-alpenvorland-f512590",
"rosenheim-berufliche_oberschule_rosenheim-f512780",
"rosenheim-gewerbegebiet_griesenholz-f512600",
"rosenheim-hamberger_industriewerke-f512620",
"rosenheim-hauptbahnhof_rosenheim-f512700",
"rosenheim-hauptbahnhof_rosenheim-f512710",
"rosenheim-innkraftwerk_rosenheim-n513630",
"rosenheim-innkraftwerk_rosenheim-n513640",
"rosenheim-rosenheim-f512670",
"rosenheim-rosenheim-f512680",
"rosenheim-rosenheim-f512690",
"rosenheim-rosenheim-f512720",
"rosenheim-rosenheim-f512730",
"rosenheim-rosenheim-f512740",
"rosenheim-rosenheim-f512750",
"rosenheim-rosenheim-f512760",
"rosenheim-rosenheim-f512790",
"rosenheim-rosenheim-f512800",
"rosenheim-rosenheim-f512830",
"rosenheim-rosenheim-f512840",
"rosenheim-rosenheim-f512850",
"rosenheim-rosenheim-f512860",
"rosenheim-rosenheim-f512880",
"rosenheim-rosenheim-f512890",
"rosenheim-rosenheim-f512900",
"rosenheim-rosenheim-f512910",
"rosenheim-rosenheim-n513580",
"rosenheim-rosenheim-n513620",
"rosenheim-simssee-f512580",
"rosenheim-simssee-f512610",
"rosenheim-staustufe_rosenheim-f512630",
"rosenheim-staustufe_rosenheim-f512640",
"rosenheim-staustufe_rosenheim-f512650",
"rosenheim-staustufe_rosenheim-f512660",
"rosenheim-technische_hochschule_rosenheim-f512770",
"rosenheim-wertstoffhof_rosenheim-n513570",
"rosenheim-wertstoffhof_rosenheim-n513590",
"rosenheim-wertstoffhof_rosenheim-n513600",
"rosenheim-wertstoffhof_rosenheim-n513610",
"rosstal-neuses-n265010",
"rosstal-neuses-n265020",
"rosstal-neuses-n265030",
"roth-altstadt-n292590",
"rothaurach-erdbau_reithelshoefer-f431300",
"roth-autobahn_a6_bei_roth-n292830",
"roth-autobahn_a6_bei_roth-n292840",
"roth-autobahnausfahrt_a6_roth-n293100",
"roth-barthelmesaurach-c214040",
"roth-barthelmesaurach-c214050",
"roth-barthelmesaurach-c214060",
"roth-barthelmesaurach-c214080",
"roth-buechenbach_-_breitenlohe-n273620",
"roth-buechenbach_-_kuehedorf-n273630",
"roth-buechenbach_-_kuehedorf-n273640",
"roth-buechenbach_-_tennenlohe-n273650",
"roth-buechenbach-n273610",
"roth-eckersmuehlen-n291000",
"roth-eckersmuehlen-n291020",
"roth-eckersmuehlen-n291030",
"rothenburg_ob_der_tauber-aeg_electrolux-f378270",
"rothenburg_ob_der_tauber-evangelisches_tageszentrum_wildbad-f378080",
"rothenburg_ob_der_tauber-evangelisches_tageszentrum_wildbad-f378230",
"rothenburg_ob_der_tauber-flugplatz_rothenburg_ob_der_tauber-f378360",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378110",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378120",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378140",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378150",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378160",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378170",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378180",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378190",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378260",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378280",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378300",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378310",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378320",
"rothenburg_ob_der_tauber-rothenburg_ob_der_tauber-f378340",
"rothenburg_ob_der_tauber-spitalbastai-f378060",
"rothenburg_ob_der_tauber-spitalbastai-f378070",
"rothenburg_ob_der_tauber-spitalbastai-f378250",
"rothenburg_ob_der_tauber-spitalhof-f378090",
"rothenfels-wasserkraftwerk_rothenfels-f371520",
"rothenfels-wasserkraftwerk_rothenfels-f371540",
"roth-frankenschotter-n29950",
"roth-freibad-n292560",
"roth-gewerbegebiet_roth-f48580",
"roth-gewerbegebiet_roth-n321260",
"roth-gewerbegebiet_roth-n321300",
"roth-gewerbegebiet_roth-n321400",
"roth-gewerbegebiet_roth-n321420",
"roth-gewerbegebiet_roth-n32770",
"roth-gewerbegebiet_roth-n32810",
"roth-guenzersreuth-c214030",
"roth-guenzersreuth-c214070",
"roth-hasenbrucker_insel__rothsee_-f484270",
"roth-kanalbruecke_bei_rednitzhembach-n32640",
"roth-kanalbruecke_bei_rednitzhembach-n32660",
"roth-kanalbruecke_bei_rednitzhembach-n32670",
"roth-pfaffenhofen-n292750",
"roth-pfaffenhofen-n292760",
"roth-pfaffenhofen-n292770",
"roth-pruppach-f48550",
"roth-pruppach-n32730",
"roth-rednitzhembach-f48520",
"roth-rednitzhembach-f48530",
"roth-rednitzhembach-f48540",
"roth-roth-f48560",
"roth-roth-f48570",
"roth-roth-n292550",
"roth-roth-n292610",
"roth-roth-n292630",
"roth-roth-n292660",
"roth-roth-n292680",
"roth-roth-n292710",
"roth-roth-n292740",
"roth-roth-n29960",
"roth-roth-n29970",
"roth-roth-n29980",
"roth-roth-n29990",
"roth-rothsee-f421620",
"roth-rothsee-f421650",
"roth-rothsee-f484220",
"roth-rothsee-f484240",
"roth-rothsee-f484280",
"roth-rudelsdorf-c214090",
"roth-rudelsdorf-c214100",
"roth-sandgrube-n292500",
"roth-sandgrube-n292530",
"roth-schleuse_eckersmuehlen-f421590",
"roth-schleuse_eckersmuehlen-f484230",
"roth-schleuse_eckersmuehlen-f484260",
"roth-schleuse_leerstetten-n32680",
"roth-schleuse_leerstetten-n32710",
"roth-talbruecke_bei_pruppach-f48550",
"roth-wallesau-n291050",
"roth-wallesau-n291080",
"roth-wasserturm_bei_eckersmuehle-f480630",
"roth-wasserturm_bei_eckersmuehle-f48630",
"rottenbuch-rottenbuch-f500590",
"rottendorf-mainfrankenpark-s560540",
"rottendorf-rottendorf-s560550",
"rottendorf-rottendorf-s560560",
"rottendorf-tsv_rottendorf-s560570",
"ruegland-schloss_ruegland-n271440",
"rummelsberg-rummelsberg-f510300",
"rummelsberg-rummelsberg-f510310",
"saal_an_der_donau-kalkwerk_saal-n511360",
"saal_an_der_donau-kalkwerk_saal-n511370",
"saal_an_der_donau-peterfecking-n511380",
"saale-klaeranlage_naumburg-n355250",
"saale-naumburg-n355240",
"saale-porstendorfer_wehr-n355590",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356480",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356490",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356500",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356510",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356520",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356530",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356550",
"saalfeld-rudolstadt-talsperre_hohenwarte_1-n356560",
"saladorf-dietenhofen-f510810",
"saladorf-dietenhofen-f510820",
"satteldorf-bei_schleehardshof-f40520",
"satteldorf-bei_schleehardshof-f40530",
"saulgrub-acheleschwaig-f500640",
"schalding-donaubruecke_schalding-n522110",
"schalding-raststaette_donau_west-n522070",
"schalding-raststaette_donau_west-n522080",
"schalding-schalding-n522090",
"schalding-schalding-n522130",
"schalkau-bahntunnel-n356760",
"schallershof-schallershof-f514310",
"schauenstein-feuerwehrmuseum-n351000",
"schauenstein-feuerwehrmuseum-n351010",
"schauenstein-feuerwehrmuseum-n351020",
"schauenstein-feuerwehrmuseum-n351030",
"schauenstein-feuerwehrmuseum-n351040",
"schauenstein-feuerwehrmuseum-n35990",
"schechen-pfaffenhofen_am_inn-f512920",
"scheinfeld-scheinfeld-n27500",
"scheinfeld-scheinfeld-n27510",
"scheinfeld-schloss_schwarzenberg-n27540",
"scheinfeld-schloss_schwarzenberg-n27550",
"scheinfeld-schloss_schwarzenberg-n27590",
"scheinfeld-schloss_schwarzenberg-n27600",
"scheinfeld-schloss_schwarzenberg-n27630",
"scheinfeld-schloss_schwarzenberg-n27660",
"scheinfeld-schloss_schwarzenberg-n27680",
"scheinfeld-schloss_schwarzenberg-n27700",
"scheinfeld-schloss_schwarzenberg-n27710",
"scheinfeld-schloss_schwarzenberg-n27720",
"scheinfeld-schloss_schwarzenberg-n27740",
"scheinfeld-schloss_schwarzenberg-n27750",
"scheinfeld-schloss_schwarzenberg-n27780",
"schernfeld-baustofflager-n322640",
"schernfeld-photovoltaikanlage-n322650",
"schernfeld-sandgrube-n322660",
"schesslitz-bei_litzendorf-n266930",
"schesslitz-giechburg-n266700",
"schesslitz-giechburg-n266720",
"schesslitz-giechburg-n266730",
"schesslitz-giechburg-n266740",
"schesslitz-giechburg-n266750",
"schesslitz-giechburg-n266760",
"schesslitz-giechburg-n266770",
"schesslitz-giechburg-n266780",
"schesslitz-giechburg-n266790",
"schesslitz-giechburg-n266800",
"schesslitz-giechburg-n266810",
"schesslitz-giechburg-n266830",
"schesslitz-giechburg-n266840",
"schesslitz-giechburg-n266850",
"schesslitz-giechburg-n266860",
"schesslitz-peulendorf-n266670",
"schesslitz-peulendorf-n266690",
"schesslitz-windradpanorama-n266880",
"schesslitz-windradpanorama-n266890",
"schesslitz-windraeder-n266940",
"schesslitz-windraeder-n266950",
"schesslitz-zeckendorf-n266710",
"schillingsfuerst-baumaschinen_knoll-f42900",
"schillingsfuerst-baustofflager_bei_schmeermuehle-f42950",
"schillingsfuerst-schillingsfuerst-f42850",
"schillingsfuerst-schloss_schillingsfuerst-f42870",
"schillingsfuerst-schloss_schillingsfuerst-f42880",
"schillingsfuerst-schloss_schillingsfuerst-f42890",
"schlangenbad-holz_bei_schlangenbad-f374680",
"schlangenbad-schlangenbad-f374660",
"schleehardshof-karpfenweiher_bei_schleehardshof-f40560",
"schleehardshof-schleehardshof-f40550",
"schluesselfeld-anschlussstelle_schluesselfeld-c563540",
"schluesselfeld-anschlussstelle_schluesselfeld-c563560",
"schluesselfeld-schluesselfeld-c563510",
"schluesselfeld-schluesselfeld-c563520",
"schluesselfeld-schluesselfeld-c563530",
"schmeermuehle-gewerbegebiet_schmeermuehle-f42920",
"schnaittach-autobahnbruecke_a9_bei_schnaittach-f433110",
"schnaittach-autohof_schnaittach-f443270",
"schnaittach-brauerei_wolfhoehe-f423510",
"schnaittach-brueckenbau_autobahn_a9_bei_schnaittach-f453910",
"schnaittach-brueckenbau_autobahn_a9_bei_schnaittach-f453990",
"schnaittach-brueckenbau_autobahn_a9_bei_schnaittach-f454030",
"schnaittach-brueckenbau_bei_schnaittach-f432860",
"schnaittach-brueckenbau_bei_schnaittach-f432900",
"schnaittach-brueckenbau_bei_schnaittach-f432990",
"schnaittach-brueckenbau_bei_schnaittach-f433020",
"schnaittach-brueckenbau_bei_schnaittach-f433030",
"schnaittach-brueckenbau_bei_schnaittach-f443160",
"schnaittach-brueckenbau_bei_schnaittach-f443190",
"schnaittach-brueckenbau_bei_schnaittach-f443280",
"schnaittach-brueckenbau_bei_schnaittach-f443290",
"schnaittach-brueckenbau_bei_schnaittach-f462580",
"schnaittach-brueckenbau_bei_schnaittach-f462610",
"schnaittach-brueckenbau_bei_schnaittach-f462770",
"schnaittach-entmersberg-n275650",
"schnaittach-enzenreuth-c313920",
"schnaittach-enzenreuth-c313930",
"schnaittach-festung_rothenberg-f453610",
"schnaittach-festung_rothenberg-f453650",
"schnaittach-festung_rothenberg-f453710",
"schnaittach-festung_rothenberg-f462510",
"schnaittach-festung_rothenberg-f462530",
"schnaittach-festung_rothenberg-f462550",
"schnaittach-festung_rothenberg-n275360",
"schnaittach-festung_rothenberg-n275380",
"schnaittach-festung_rothenberg-n275390",
"schnaittach-festung_rothenberg-n275400",
"schnaittach-festung_rothenberg-n275410",
"schnaittach-festung_rothenberg-n275420",
"schnaittach-festung_rothenberg-n275430",
"schnaittach-festung_rothenberg-n275450",
"schnaittach-festung_rothenberg-n275460",
"schnaittach-festung_rothenberg-n275470",
"schnaittach-festung_rothenberg-n275480",
"schnaittach-festung_rothenberg-n275490",
"schnaittach-festung_rothenberg-n275500",
"schnaittach-festung_rothenberg-n275510",
"schnaittach-festung_rothenberg-n275520",
"schnaittach-festung_rothenberg-n275530",
"schnaittach-festung_rothenberg-n275540",
"schnaittach-festung_rothenberg-n275550",
"schnaittach-festung_rothenberg-n275560",
"schnaittach-festung_rothenberg-n275610",
"schnaittach-freibad_schnaittach-f433040",
"schnaittach-hienberg-c314000",
"schnaittach-hienberg-c314010",
"schnaittach-kleinbellhofen_bei_schnaittach-f453930",
"schnaittach-landwirtschaft-c314020",
"schnaittach-rabenshof-c313910",
"schnaittach-sandgrube_hammerand_bei_schnaittach-f433090",
"schnaittach-sandgrube_hammerand_bei_schnaittach-f433100",
"schnaittach-sandgrube_hammerand_bei_schnaittach-f462800",
"schnaittach-schnaittach-c313940",
"schnaittach-schnaittach-c313980",
"schnaittach-untersdorf-c314040",
"schneckenlohe-moedlitz-f552350",
"schneckenlohe-neubrand-f552360",
"schnelldorf-autobahn_a6-f421080",
"schnelldorf-autobahn_a6-f42990",
"schnelldorf-parkplatz_rothensteig-f40470",
"schnelldorf-parkplatz_schleehardt-f40500",
"schnelldorf-parkplatz_schleehardt-f40510",
"schnelldorf-parkplatz_schleehardt-f40600",
"schnelldorf-parkplatz_schleehardt-f40950",
"schnelldorf-schnelldorf-f401010",
"schnelldorf-schnelldorf-f40480",
"schnelldorf-schnelldorf-f40490",
"schnelldorf-schnelldorf-f40570",
"schnelldorf-schnelldorf-f40610",
"schnelldorf-schnelldorf-f40620",
"schnelldorf-schnelldorf-f40630",
"schnelldorf-schnelldorf-f40860",
"schnoedhof-donaualtwasser_schnoedhof-f513690",
"schnufenhofen-schnufenhofen-f510530",
"schnufenhofen-schnufenhofen-f510540",
"schoeffelding-autobahn_a96-c501270",
"schoeffelding-autobahn_a96-c501280",
"schoeffelding-autobahn_a96-c501290",
"schoeffelding-delo-allee-c501250",
"schoeffelding-schoeffelding-c501260",
"schoenau-kaeserei_denklingen_gmbh-c502750",
"schorndorf-schorndorf_radling-n523530",
"schwabach-autobahn_a6_bei_schwabach-f502380",
"schwabach-autobahn_a6_bei_schwabach-f502390",
"schwabach-autobahn_a6-n273720",
"schwabach-autobahn_a6-n273740",
"schwabach-autobahn_a6-n273780",
"schwabach-autobahnausfahrt_a6_schwabach-sued-n293000",
"schwabach-autobahnausfahrt_a6_schwabach-sued-n293070",
"schwabach-baugrube-c213970",
"schwabach-bei_schwabach-f502400",
"schwabach-berufsschule_schwabach-c505040",
"schwabach-bruecke_kanal_neusses-c213720",
"schwabach-dietersdorf-f48410",
"schwabach-dietersdorf-n242190",
"schwabach-eichwasen-f48420",
"schwabach-forsthof-n273710",
"schwabach-gewerbegiebt-n292810",
"schwabach-goetzenreuth-c213930",
"schwabach-haydnstrasse-n273760",
"schwabach-kanalbruecke_neuses-c213790",
"schwabach-krankenhaus-n292910",
"schwabach-nasbach-n273830",
"schwabach-nasbach-n273850",
"schwabach-nemsdorf-n515160",
"schwabach-obermainbach-n273660",
"schwabach-ottersdorf_und_tennenlohe-c213900",
"schwabach-panorama-c213870",
"schwabach-plockendorf-f48510",
"schwabach-raststaette_kammersteiner_land_sued-c500350",
"schwabach-rohr_reck_reisen-c172370",
"schwabach-rohr_reck_reisen-c172440",
"schwabach-rohr_reck_reisen-c172450",
"schwabach-rohr-c171960",
"schwabach-rohr-c172010",
"schwabach-rohr-c172100",
"schwabach-rohr-c172130",
"schwabach-sandgrube_bei_schwabach-n242970",
"schwabach-sandgrube-c171650",
"schwabach-sandgrube-c171690",
"schwabach-sc_04_schwabach_e_v_-f502410",
"schwabach-sc_worzeldorf-c505100",
"schwabach-schwabach-c118050",
"schwabach-schwabach-c118060",
"schwabach-schwabach-c118100",
"schwabach-schwabach-c118120",
"schwabach-schwabach-c118190",
"schwabach-schwabach-c118230",
"schwabach-schwabach-c118270",
"schwabach-schwabach-c152660",
"schwabach-schwabach-c152700",
"schwabach-schwabach-c152740",
"schwabach-schwabach-c152750",
"schwabach-schwabach-c152770",
"schwabach-schwabach-c152780",
"schwabach-schwabach-c152790",
"schwabach-schwabach-c152800",
"schwabach-schwabach-c153020",
"schwabach-schwabach-c153060",
"schwabach-schwabach-c153080",
"schwabach-schwabach-c505060",
"schwabach-schwabach-c505070",
"schwabach-schwabach-c505080",
"schwabach-schwabach-f48430",
"schwabach-schwabach-f48440",
"schwabach-schwabach-f48450",
"schwabach-schwabach-f48460",
"schwabach-schwabach-f48480",
"schwabach-schwabach-f48490",
"schwabach-schwabach-n273670",
"schwabach-schwabach-n273750",
"schwabach-schwabach-n273810",
"schwabach-schwabach-n273820",
"schwabach-schwabach-n292850",
"schwabach-schwabach-n292860",
"schwabach-schwabach-n292870",
"schwabach-schwabach-n292880",
"schwabach-schwabach-n292890",
"schwabach-schwabach-n292900",
"schwabach-schwabach-n292940",
"schwabach-schwarzach-c213730",
"schwabach-schwarzach-c213750",
"schwabach-schwarzach-c213770",
"schwabach-waldfriedhof_schwabach-c505090",
"schwabach-wolkersdorf-c171720",
"schwabach-wolkersdorf-c171740",
"schwabach-wolkersdorfer_sandgrube-n273840",
"schwabach-wolkersdorfer_sandgrube-n273890",
"schwabhausen-bosch_testgelaende-f377920",
"schwabhausen-bosch_testgelaende-f377930",
"schwabhausen-bosch_testgelaende-f377940",
"schwabhausen-bosch_testgelaende-f377950",
"schwabhausen-bosch_testgelaende-f377970",
"schwabhausen-bosch_testgelaende-f377980",
"schwabhausen-schloss_weikersheim-f378000",
"schwabhausen-schloss_weikersheim-f378040",
"schwabhausen-weikersheim-f378030",
"schwaig_b__nuernberg-brueckebau_autobahn_a3_bei_schwaig-f454330",
"schwaig_b__nuernberg-brueckenbau_bei_schwaig-f433610",
"schwaig_b__nuernberg-ueberfuehrung_bei_schwaig-f423790",
"schwaig_b__nuernberg-ueberfuehrung_bei_schwaig-f423790",
"schwaig-pegnitztal_ost-c253310",
"schwaig-pegnitztal_ost-c253400",
"schwaig-pegnitztal_ost-c253410",
"schwaig-pegnitztal_ost-c253420",
"schwaig-pegnitztal_ost-c253430",
"schwaig-pegnitztal_ost-c253440",
"schwaig-pegnitztal_ost-c253450",
"schwaig-pegnitztal_ost-c253460",
"schwaig-schwaig-c224230",
"schwaig-schwaig-c224250",
"schwaig-schwaig-c224440",
"schwaig-schwaig-c225450",
"schwaig-schwaig-c225470",
"schwandorf-betriebswerk_die_laenderbahn-n524000",
"schwandorf-globus_schwandorf-n523950",
"schwandorf-grafenricht-f522300",
"schwandorf-hauptbahnhof_schwandorf-n524130",
"schwandorf-innovationspark_wackersdorf-f522270",
"schwandorf-kreuzberg_kirche-n524010",
"schwandorf-kreuzberg_kirche-n524030",
"schwandorf-kreuzberg_kirche-n524050",
"schwandorf-kreuzberg_kirche-n524060",
"schwandorf-kreuzberg_kirche-n524100",
"schwandorf-niederhof-n523960",
"schwandorf-rothlindenviertel-n523990",
"schwandorf-schwandorf_innenstadt-n524160",
"schwandorf-schwandorf_innenstadt-n524170",
"schwandorf-schwandorf_innenstadt-n524220",
"schwandorf-schwandorf_mitte-n523940",
"schwandorf-schwandorf-n524110",
"schwandorf-schwandorf-n524140",
"schwandorf-schwandorf-n524240",
"schwandorf-schwandorf-n524250",
"schwandorf-st__jakob_kirche-n524150",
"schwandorf-st__jakob_kirche-n524180",
"schwandorf-twf_gelaende-n524080",
"schwandorf-twf_gelaende-n524090",
"schwandorf-wackersdorf-f522310",
"schwand-schwanstetten-n29890",
"schwand-schwanstetten-n29900",
"schwanstetten-mittelmembach-n29910",
"schwarzenberg-bildungshaus_kloster-n27520",
"schwarzenberg-wallfahrtskirche_maria_hilf-n27620",
"schwarzenbruck-altenthann-n303450",
"schwarzenbruck-altenthann-n303460",
"schwarzenbruck-altenthann-n303470",
"schwarzenbruck-faberschloss_in_schwarzenbruck-f441670",
"schwarzenbruck-faberschloss_in_schwarzenbruck-f441680",
"schwarzenbruck-faberschloss_in_schwarzenbruck-f441720",
"schwarzenbruck-gewerbegebiet_bei_schwarzenbruck-f441810",
"schwarzenbruck-gewerbegebiet_mittellandholz-f520480",
"schwarzenbruck-gewerbegebiet_mittellandholz-f520490",
"schwarzenbruck-gewerbegebiet_mittellandholz-f520500",
"schwarzenbruck-pfeifferhuette-n30590",
"schwarzenbruck-pfeifferhuette-n30600",
"schwarzenbruck-rummelsberg-f522550",
"schwarzenbruck-rummelsberg-f522560",
"schwarzenbruck-schwarzenbruck-f520460",
"schwarzenbruck-schwarzenbruck-f520470",
"schwarzenbruck-schwarzenbruck-n30560",
"schwarzenbruck-schwarzenbruck-n30570",
"schwarzenbruck-schwarzenbruck-n30580",
"schwebheim-schwebheim-f378490",
"schweikartswinden-schweikartswinden-f42830",
"schweinfurt-frettstadt_-_gewerbegebiet_nord-s561920",
"schweinfurt-frettstadt_-_gewerbegebiet_nord-s561940",
"schweinfurt-gochsheim-s561900",
"schweinfurt-leopoldina_krankenhaus-s561800",
"schweinfurt-marktplatz_schweinfurt-c563320",
"schweinfurt-marktplatz_schweinfurt-c563340",
"schweinfurt-marktplatz_schweinfurt-c563380",
"schweinfurt-schweinfurt_-_altstadt-c563330",
"schweinfurt-schweinfurt_-_altstadt-s561810",
"schweinfurt-schweinfurt_-_altstadt-s561820",
"schweinfurt-schweinfurt_-_altstadt-s561850",
"schweinfurt-schweinfurt_-_altstadt-s561870",
"schweinfurt-schweinfurt_-_friedhof-c563480",
"schweinfurt-schweinfurt_-_hubschrauberlandeplatz-c563460",
"schweinfurt-schweinfurt_-_kunsthalle-c563420",
"schweinfurt-schweinfurt_-_landwirtschaft-c563500",
"schweinfurt-schweinfurt_-_maxbruecke-c563470",
"schweinfurt-schweinfurt_-_rossmarkt-c563370",
"schweinfurt-schweinfurt_-_rossmarkt-c563430",
"schweinfurt-schweinfurt-c563350",
"schweinfurt-schweinfurt-c563360",
"schweinfurt-schweinfurt-c563390",
"schweinfurt-schweinfurt-c563400",
"schweinfurt-schweinfurt-c563490",
"schweinfurt-schweinfurt-s561730",
"schweinfurt-schweinfurt-s561750",
"schweinfurt-schweinfurt-s561780",
"schweinfurt-schweinfurt-s561880",
"schweinfurt-schweinfurt-s561890",
"schweinfurt-zeughaus_schweinfurt-c563310",
"schweinfurt-zeughaus_schweinfurt-c563410",
"schweinfurt-zeughaus_schweinfurt-c563440",
"schwetzingen-moschee_im_schwetzinger_schloss-f377600",
"schwetzingen-moschee_im_schwetzinger_schloss-f377670",
"schwetzingen-schloss_schwetzingen-f377570",
"schwetzingen-schloss_schwetzingen-f377620",
"schwetzingen-schloss_schwetzingen-f377650",
"schwetzingen-schloss_schwetzingen-f377680",
"schwetzingen-schloss_schwetzingen-f377710",
"seitenroda-leuchtenburg-n356090",
"seitenroda-leuchtenburg-n356100",
"seitenroda-leuchtenburg-n356110",
"seitenroda-leuchtenburg-n356120",
"seitenroda-leuchtenburg-n356140",
"seitenroda-leuchtenburg-n356170",
"seitenroda-leuchtenburg-n356200",
"seitenroda-leuchtenburg-n356210",
"seitenroda-leuchtenburg-n356220",
"senden-gewerbegebiet_senden-f501930",
"senden-seen_bei_senden-f501900",
"senden-seen_bei_senden-f501910",
"sengenthal-gewerbegebiet_schlierferheide-f431430",
"sengenthal-heidelberger_cement-n520630",
"sengenthal-heidelberger_cement-n520640",
"sengenthal-heidelberger_cement-n520650",
"sengenthal-heidelberger_cement-n520660",
"sengenthal-heidelberger_cement-n520670",
"sengenthal-winnberg-n520680",
"sengenthal-winnberg-n520690",
"sengenthal-winnberg-n520710",
"seubersdorf_i_d__oberpfalz-schnufenhofen-f510520",
"seubersdorf-eichenhofen-n302870",
"seubersdorf-eichenhofen-n302880",
"seubersdorf-eichenhofen-n302890",
"seubersdorf-gastelhof-n302840",
"seubersdorf-krappenhofen-n301210",
"seubersdorf-seubersdorf-n520740",
"seubersdorf-seubersdorf-n520750",
"seubersdorf-seubersdorf-n520760",
"seubersdorf-seubersdorf-n520770",
"seubersdorf-waldhausen-n302900",
"seubersdorf-waldhausen-n302910",
"seubersdorf-waldhausen-n302920",
"seubersdorf-waldhausen-n302930",
"seukendorf-bauschuttdeponie_seukendorf-c284390",
"simmelsdorf-baernreuther___deuerlein_schotterwerke-f462010",
"simmerberg-geiger_kies-___betonwerk-c502800",
"sintmann-sintmann-c560110",
"sintmann-sintmann-f42170",
"sintmann-sintmann-s560140",
"sittenbach-sittenbach-n514620",
"solnhofen-solnhofen-f513730",
"solnhofen-ssg_solnhofen_stone_group-n514840",
"solnhofen-ssg_solnhofen_stone_group-n514850",
"sondernohe-sondernohe-f42460",
"sondernohe-sondernohe-f42480",
"sonneberg-foernitztal-n356740",
"spalt-enderndorf_am_see-n292210",
"spalt-enderndorf_am_see-n292220",
"spalt-enderndorf_am_see-n292230",
"spalt-gewerbepark_huegelmuehle-c500460",
"spalt-gewerbepark_huegelmuehle-c500470",
"spalt-gewerbepark_huegelmuehle-n515060",
"spalt-gewerbepark_huegelmuehle-n515070",
"spalt-gewerbepark_huegelmuehle-n515090",
"spalt-hagsbronn-n292240",
"spalt-huegelmuehle-n515080",
"spalt-massendorf-n292310",
"spalt-mosbach-c500430",
"spalt-mosbach-c500440",
"spalt-mosbach-n515100",
"spalt-reiterhof_mosbach-c500450",
"spalt-spalt-n292250",
"spalt-spalt-n292260",
"spalt-spalt-n292270",
"spalt-spalt-n292290",
"spalt-spalt-n292300",
"speyer-alter_hafen_speyer-f377430",
"speyer-angelhofer_altrhein__speyer_-f377030",
"speyer-angelhofer_altrhein__speyer_-f377060",
"speyer-angelhofer_altrhein__speyer_-f377450",
"speyer-bellamar_freizeitbad__speyer-f377510",
"speyer-deutsche_wuhl__speyer-f377080",
"speyer-diakonissen-stiftungs-krankenhaus-f377090",
"speyer-diakonissen-stiftungs-krankenhaus-f377110",
"speyer-dom_zu_speyer-f377200",
"speyer-dom_zu_speyer-f377350",
"speyer-dom_zu_speyer-f377380",
"speyer-dom_zu_speyer-f377410",
"speyer-gedaechtniskirche_speyer-f377150",
"speyer-hockenheimring-f377460",
"speyer-hockenheimring-f377470",
"speyer-hockenheimring-f377480",
"speyer-hockenheimring-f377490",
"speyer-hockenheimring-f377500",
"speyer-parkstadt_am_rhein__speyer-f377210",
"speyer-postplatz__speyer-f377400",
"speyer-sankt_vincentuius_krankenhaus__speyer-f377180",
"speyer-speyer-f377100",
"speyer-speyer-f377120",
"speyer-speyer-f377130",
"speyer-speyer-f377170",
"speyer-speyer-f377190",
"speyer-technik_museum_speyer-f377230",
"speyer-technik_museum_speyer-f377250",
"speyer-technik_museum_speyer-f377280",
"speyer-technik_museum_speyer-f377320",
"speyer-technik_museum_speyer-f377340",
"speyer-technik_museum_speyer-f377360",
"st__johann-st__johann-f512030",
"st__johann-st__johann-f512040",
"st__johann-st__johann-f512050",
"st__johann-st__johann-f512060",
"st__johann-st__johann-f512070",
"st__johann-st__johann-f512080",
"st__johann-st__johann-f512090",
"st__johann-st__johann-f512100",
"st__johann-st__johann-f512110",
"st__johann-st__johann-f512120",
"st__johann-st__johann-f512260",
"stadecken-elsheim-stadecken-elsheim-f374960",
"stadecken-elsheim-stadecken-elsheim-f374980",
"stadtsteinach-naturwaldreservat_kuehberg-f551960",
"stadtsteinach-rugendorf-eisenwind-f552000",
"stadtsteinach-rugendorf-eisenwind-f552020",
"stadtsteinach-rugendorf-eisenwind-f552040",
"stadtsteinach-rugendorf-eisenwind-f552050",
"stadtsteinach-rugendorf-f551980",
"stadtsteinach-rugendorf-f551990",
"stadtsteinach-rugendorf-n550910",
"stadtsteinach-rugendorf-n550920",
"stadtsteinach-triebenreuth-f551930",
"stadtsteinach-triebenreuth-f551950",
"staitz-staitz-n351640",
"staitz-staitz-n351650",
"stamsried-enzenried-n523860",
"stamsried-hilpersried-n523850",
"stamsried-naturerlebnisbad_stamsried-n523830",
"stamsried-scheiblhof-n523880",
"stamsried-stamsried-n523810",
"stamsried-stamsried-n523820",
"stamsried-stamsried-n523840",
"stein_b__nuernberg-hans_reif_sportzentrum-f530440",
"stein_b__nuernberg-im_blumenviertel-n530440",
"stein_b__nuernberg-im_blumenviertel-n530450",
"stein_b__nuernberg-im_blumenviertel-n530480",
"stein_b__nuernberg-im_blumenviertel-n530490",
"stein_b__nuernberg-im_blumenviertel-n530500",
"stein_b__nuernberg-im_blumenviertel-n530550",
"stein_b__nuernberg-im_blumenviertel-n530570",
"stein_b__nuernberg-im_blumenviertel-n530580",
"stein_b__nuernberg-im_blumenviertel-n530600",
"stein_b__nuernberg-steiner_schloss-f531910",
"stein_b__nuernberg-unterweihersbuch-f530450",
"stein_b__nuernberg-unterweihersbuch-f530460",
"stein_b__nuernberg-unterweihersbuch-f530490",
"stein_b__nuernberg-unterweihersbuch-f530530",
"stein_b__nuernberg-unterweihersbuch-f530550",
"stein_b__nuernberg-unterweihersbuch-f530560",
"stein_b__nuernberg-unterweihersbuch-f530570",
"stein_bei_nuernberg-forum_stein-n515180",
"stein-deutenbach-c162140",
"stein-deutenbach-c162150",
"stein-deutenbach-c162160",
"stein-deutenbach-c162190",
"stein-deutenbach-c162210",
"stein-deutenbach-c162220",
"stein-fabrik_faber-castell-c19310",
"stein-fabrik_faber-castell-n274100",
"stein-fabrik_faber-castell-n274190",
"stein-fabrik_faber-castell-n274210",
"stein-fabrik_faber-castell-nn66150",
"stein-forum_stein-c281730",
"stein-gymnasium_stein-f491070",
"stein-heizkraftwerk_franken_1-f490980",
"stein-kruegelpark-f490880",
"stein-kruegelpark-f490890",
"stein-muehlstrasse-n274110",
"stein-neuer_friedhof_stein-f391440",
"stein-neuer_friedhof_stein-f491170",
"stein-oberweihersbuch-f491130",
"stein-palm_beach_erlebnisbad-c053010",
"stein-palm_beach_erlebnisbad-c156700",
"stein-palm_beach_erlebnisbad-c156730",
"stein-palm_beach_erlebnisbad-c156820",
"stein-palm_beach_erlebnisbad-c156870",
"stein-palm_beach_erlebnisbad-c156880",
"stein-palm_beach_erlebnisbad-c156930",
"stein-palm_beach_erlebnisbad-c156950",
"stein-palm_beach_erlebnisbad-n274030",
"stein-palm_beach_erlebnisbad-n274060",
"stein-palm_beach_erlebnisbad-nn66060",
"stein-palm_beach-f491070",
"stein-palm_beach-f491090",
"stein-schloss_faber-castell_im_herbst-nn82170",
"stein-schloss_faber-castell-c19280",
"stein-schloss_faber-castell-c19380",
"stein-schloss_faber-castell-c19430",
"stein-schloss_faber-castell-n274080",
"stein-schloss_faber-castell-n274120",
"stein-schloss_faber-castell-n274130",
"stein-schloss_faber-castell-n274140",
"stein-schloss_faber-castell-n274150",
"stein-schloss_faber-castell-n274160",
"stein-schloss_faber-castell-n274170",
"stein-schloss_faber-castell-n274200",
"stein-schloss_faber-castell-n274220",
"stein-schloss_faber-castell-n274230",
"stein-schloss_faber-castell-n274240",
"stein-schloss_faber-castell-n274260",
"stein-schloss_faber-castell-n274270",
"stein-schloss_faber-castell-n274280",
"stein-schloss_faber-castell-nn66100",
"stein-stein_bei_nuernberg-f490880",
"stein-stein_bei_nuernberg-f490890",
"stein-stein_bei_nuernberg-f490910",
"stein-stein_bei_nuernberg-f490920",
"stein-stein_bei_nuernberg-f491020",
"stein-stein_bei_nuernberg-f491040",
"stein-stein_bei_nuernberg-f491050",
"stein-stein_bei_nuernberg-f491060",
"stein-stein_bei_nuernberg-f491070",
"stein-stein_bei_nuernberg-f491090",
"stein-stein_bei_nuernberg-f491110",
"stein-stein_bei_nuernberg-f491160",
"stein-stein_bei_nuernberg-f491170",
"stein-stein_bei_nuernberg-f491190",
"stein-stein-c162230",
"stein-stein-c162240",
"stein-stein-c162250",
"stein-stein-c1910",
"stein-stein-c1920",
"stein-stein-c19320",
"stein-stein-c19350",
"stein-stein-c281740",
"stein-stein-cc51600",
"stein-stein-deutenbach-f412520",
"stein-stein-deutenbach-f412540",
"stein-stein-n274010",
"stein-stein-n274020",
"stein-stein-n274300",
"stein-unterweihersbuch-f490900",
"stein-unterweihersbuch-f490930",
"stein-unterweihersbuch-f490940",
"stein-unterweihersbuch-f490950",
"stein-unterweihersbuch-f491140",
"stein-unterweihersbuch-f491150",
"stein-waldsportpark-f490960",
"stein-waldsportpark-f490970",
"stockhausen-stockhausen-f481260",
"strassbessenbach-strassbessenbach-f371690",
"strassbessenbach-strassbessenbach-f371710",
"straubing-altstadt_straubing-f521890",
"straubing-altstadt_straubing-f521920",
"straubing-basilika_st__jakob-n523210",
"straubing-basilika_st__jakob-n523240",
"straubing-basilika_st__jakob-n523370",
"straubing-basilika_st__jakob-n523400",
"straubing-flugplatz_straubing-wallmuehle-f521940",
"straubing-flugplatz_straubing-wallmuehle-f521950",
"straubing-flugplatz_straubing-wallmuehle-n523440",
"straubing-friedhof_straubing-f521840",
"straubing-friedhof_straubing-f521860",
"straubing-geberviertel-f521900",
"straubing-gewerbegebiet_koenigreich-f521810",
"straubing-gewerbegebiet_koenigreich-f521820",
"straubing-industriepark_straubing_sand-n523160",
"straubing-ittling-f521790",
"straubing-kagers-f521930",
"straubing-kraftwerk_straubing-n523310",
"straubing-messehalle_straubing-n523270",
"straubing-messehalle_straubing-n523280",
"straubing-papbst_benedikt_schule-n523320",
"straubing-stadtturm_straubing-n523340",
"straubing-stadtturm_straubing-n523350",
"straubing-staubing_ittling-n523170",
"straubing-straubing_friedhof-n523180",
"straubing-straubing_kagers-n523430",
"straubing-straubing_ost-f521830",
"straubing-straubing-f521850",
"straubing-straubing-f521870",
"straubing-straubing-f521880",
"straubing-straubing-n523230",
"straubing-straubing-n523290",
"straubing-straubing-n523330",
"straubing-straubing-n523390",
"straubing-volksfest_in_straubing-n523250",
"straubing-volksfest_in_straubing-n523260",
"straubing-volksfest_in_straubing-n523420",
"strullendorf-schleuse_strullendorf-n358500",
"strullendorf-strullendorf-n358510",
"suenching-schloss_suenching-n521380",
"suenching-schloss_suenching-n521390",
"suenching-schloss_suenching-n521400",
"tacherting-emertsham-f511020",
"tacherting-emertsham-f511030",
"tacherting-emertsham-f511050",
"tacherting-linde_werk_in_lengloh-f511150",
"tacherting-linde_werk_in_lengloh-f511160",
"tacherting-tacherting-f511140",
"tachterting-wehr_tacherting-n512050",
"tachterting-wehr_tacherting-n512080",
"tanna-stelzen-n351320",
"tanna-unterkoskau-n351330",
"tanna-willersdorf-n351310",
"taunusstein-burg_bei_taunusstein-f374600",
"taunusstein-residenz_bei_taunusstein-f374610",
"taunusstein-residenz_bei_taunusstein-f374640",
"tautenburg-burgruine_tautenburg-n355480",
"tautenburg-burgruine_tautenburg-n355500",
"tautenburg-kirche_tautenburg-n355510",
"tautenburg-tautenburg-n355520",
"thalmaessing-schweinezucht_bei_bechthal-f484100",
"thalmaessing-thalmannsfeld-f48740",
"thalmaessing-thalmannsfeld-f48750",
"thalmaessing-tiefenbach-f48690",
"thalmaessing-tiefenbach-f48700",
"theuern-autobahnbruecke_a6_bei_amberg-sued-f422810",
"theuern-gewerbegebiet_theuern-f422780",
"thierhaupten-kloster_thierhaupten-n323810",
"thierhaupten-kloster_thierhaupten-n323840",
"thierhaupten-kloster_thierhaupten-n323860",
"thierhaupten-kloster_thierhaupten-n323910",
"thierhaupten-kloster_thierhaupten-n323930",
"thierhaupten-thierhaupten-n323880",
"thierhaupten-thierhaupten-n323890",
"thierhaupten-thierhaupten-n323900",
"thierhaupten-thierhaupten-n323940",
"thulba-schotterwerke_oberthulba-s561660",
"tirol-alpen-f512390",
"tirol-alpen-f512400",
"tirol-alpen-n513350",
"tirol-alpen-n513360",
"tirol-alpen-n513370",
"tirol-alpen-n513380",
"tirol-alpen-n513440",
"tirol-alpen-n513450",
"tirol-alpen-n513460",
"tirol-alpen-n513470",
"tirol-alpen-n513480",
"tirol-alpen-n513490",
"tirol-gruenwaldkopf-n513010",
"tirol-gruenwaldkopf-n513020",
"tirol-gruenwaldkopf-n513030",
"tirol-gruenwaldkopf-n513040",
"tirol-gruenwaldkopf-n513050",
"tirol-gruenwaldkopf-n513060",
"tirol-hiefelstein-f511910",
"tirol-hintersteiner_see_in_tirol-f512290",
"tirol-hintersteiner_see_in_tirol-f512300",
"tirol-hintersteiner_see_in_tirol-f512310",
"tirol-hintersteiner_see_in_tirol-f512350",
"tirol-hintersteiner_see_in_tirol-f512360",
"tirol-hintersteiner_see_in_tirol-f512410",
"tirol-hintersteiner_see_in_tirol-n513400",
"tirol-kirchdorf_in_tirol-n513080",
"tirol-kirchdorf_in_tirol-n513090",
"tirol-martinsbichl-n513070",
"tirol-maukspitze-f512020",
"tirol-maukspitze-n513100",
"tirol-mittlerer_hackenkopf-f512380",
"tirol-niederndorf_in_tirol-n513430",
"tirol-prama_in_tirol-n513300",
"tirol-prama_in_tirol-n513310",
"tirol-prama_in_tirol-n513320",
"tirol-regalmspitze_gruttenkopf_maukspitze_kleiner_kaiser-n513330",
"tirol-strasserbach_badesee_in_tirol-n513270",
"tirol-strasserbach_badesee_in_tirol-n513280",
"tirol-strasserbach_badesee_in_tirol-n513290",
"tirol-tirol-f511850",
"tirol-tirol-f511880",
"tirol-tirol-f511900",
"tirol-tirol-f511920",
"tirol-tirol-f511930",
"tirol-tirol-f511940",
"tirol-tirol-f511950",
"tirol-tirol-f511960",
"tirol-tirol-f512270",
"tirol-tirol-f512280",
"tirol-tirol-f512340",
"tirol-tirol-n513110",
"tirol-tirol-n513120",
"tirol-tirol-n513130",
"tirol-tirol-n513210",
"tirol-tirol-n513220",
"tirol-tirol-n513230",
"tirol-tirol-n513240",
"tirol-tirol-n513250",
"tirol-tirol-n513260",
"tirol-wochenbrunneralm_in_tirol-n513340",
"tirschenreuth-amtsgericht_tirschenreuth-n550320",
"tirschenreuth-amtsgericht_tirschenreuth-n550370",
"tirschenreuth-amtsgericht_tirschenreuth-n550380",
"tirschenreuth-amtsgericht_tirschenreuth-n550390",
"tirschenreuth-fc_tirschenreuth-f550740",
"tirschenreuth-festplatz_tischenreuth-n550530",
"tirschenreuth-hamm_ag-f550840",
"tirschenreuth-hamm_ag-f550860",
"tirschenreuth-pilmersreuth_an_der_strasse-f550700",
"tirschenreuth-st__michael_kirche-n550310",
"tirschenreuth-tirschenreuth_-_altstadt-n550400",
"tirschenreuth-tirschenreuth_-_altstadt-n550410",
"tirschenreuth-tirschenreuth_-_altstadt-n550420",
"tirschenreuth-tirschenreuth_-_altstadt-n550430",
"tirschenreuth-tirschenreuth_-_altstadt-n550440",
"tirschenreuth-tirschenreuth_-_altstadt-n550450",
"tirschenreuth-tirschenreuth_-_altstadt-n550460",
"tirschenreuth-tirschenreuth_-_altstadt-n550470",
"tirschenreuth-tirschenreuth_-_fischhofbruecke-n550330",
"tirschenreuth-tirschenreuth_-_fischhofbruecke-n550360",
"tirschenreuth-tirschenreuth-f550730",
"tirschenreuth-tirschenreuth-f550750",
"tirschenreuth-tirschenreuth-f550760",
"tirschenreuth-tirschenreuth-f550770",
"tirschenreuth-tirschenreuth-f550780",
"tirschenreuth-tirschenreuth-f550790",
"tirschenreuth-tirschenreuth-f550800",
"tirschenreuth-tirschenreuth-f550810",
"tirschenreuth-tirschenreuth-f550820",
"tirschenreuth-tirschenreuth-n550480",
"tirschenreuth-tirschenreuth-n550490",
"tirschenreuth-tirschenreuth-n550500",
"tirschenreuth-tirschenreuth-n550510",
"tirschenreuth-tirschenreuth-n550520",
"titting-erkertshofen-f484030",
"titting-kaldorf-f48830",
"titting-kaldorf-f48840",
"titting-kaldorf-f48870",
"titting-titting-f484060",
"toedting-toedting-f513680",
"traitsching-traitsching-f522080",
"traunreut-traunreut-f511220",
"traunreut-traunreut-f511240",
"traunstein-aberg__traunstein-n512350",
"traunstein-agentur_fuer_arbeit_in_traunstein-n512290",
"traunstein-alpen-f511330",
"traunstein-anger__hoechstaufen-f511310",
"traunstein-anger__hoechstaufen-f511320",
"traunstein-bei_traunstein-n512520",
"traunstein-chiemgau_gymnasium-n512190",
"traunstein-klaerwerk_traunstein-n512170",
"traunstein-rvo_betriebshof_traunstein-n512310",
"traunstein-schwimmbad_traunstein-n512250",
"traunstein-schwimmbad_traunstein-n512260",
"traunstein-solarpark_teisendorf-f511300",
"traunstein-stadtplatz_traunstein-n512210",
"traunstein-stadtplatz_traunstein-n512370",
"traunstein-stadtplatz_traunstein-n512380",
"traunstein-stadtplatz_traunstein-n512390",
"traunstein-stadtplatz_traunstein-n512480",
"traunstein-stadtplatz_traunstein-n512490",
"traunstein-studienseminar_st__michael-n512280",
"traunstein-traunstein-f511250",
"traunstein-traunstein-f511270",
"traunstein-traunstein-f511280",
"traunstein-traunstein-n512180",
"traunstein-traunstein-n512200",
"traunstein-traunstein-n512220",
"traunstein-traunstein-n512230",
"traunstein-traunstein-n512240",
"traunstein-traunstein-n512270",
"traunstein-traunstein-n512300",
"traunstein-traunstein-n512320",
"traunstein-traunstein-n512330",
"traunstein-traunstein-n512360",
"traunstein-traunstein-n512410",
"traunstein-traunstein-n512420",
"traunstein-traunstein-n512450",
"traunstein-traunstein-n512460",
"traunstein-traunstein-n512470",
"traunstein-traunstein-n512510",
"traunstein-traunstein-n512530",
"traunstein-traunstein-n512540",
"traunstein-wasserkraftwerk_traunstein-n512430",
"traunstein-wasserkraftwerk_traunstein-n512440",
"traunstein-wertstoffhof_traunstein-n512400",
"treuchtlingen-auernheim-n326220",
"treuchtlingen-biotop_schambachried-c500560",
"treuchtlingen-flemmuehle-n514860",
"treuchtlingen-gundelsheim-n326120",
"treuchtlingen-gundelsheim-n326130",
"treuchtlingen-gundelsheim-n326160",
"treuchtlingen-gundelsheim-n326170",
"treuchtlingen-schambach-n514870",
"treuchtlingen-treuchtlingen-schambach-c500570",
"trostberg-reithof_hilling-f511190",
"trostberg-reithof_hilling-f511200",
"trostberg-trostberg__hofstett-f511170",
"truckenthal-truckenthalbruecke-n356800",
"truckenthal-truckenthalbruecke-n356810",
"truckenthal-truckenthalbruecke-n356830",
"truckenthal-truckenthalbruecke-n356850",
"truckenthal-truckenthalbruecke-n356870",
"truckenthal-truckenthalbruecke-n356880",
"truckenthal-truckenthalbruecke-n356890",
"tuchenbach-tuchenbach-c158200",
"tuchenbach-tuchenbach-c158240",
"tuchenbach-tuchenbach-c158260",
"tuntenhausen-beyharting-n513690",
"tuntenhausen-beyharting-n513700",
"tuntenhausen-beyharting-n513710",
"tuntenhausen-beyharting-n513720",
"tuntenhausen-fuchsholz-n513670",
"tuntenhausen-fuchsholz-n513680",
"tuntenhausen-innerthann_reithof-n513730",
"tuntenhausen-innerthann-n513740",
"turm_bei_neustadt_aisch-aussichtsturm-f378550",
"uffenheim-autobahn_a7_-_gollhofen-c561060",
"uffenheim-autobahn_a7_-_gollhofen-c561070",
"uffenheim-freibad_uffenheim-c561020",
"uffenheim-freibad_uffenheim-s560310",
"uffenheim-geisslingen_-_jakobshof-c561140",
"uffenheim-gollhofen_-_gewerbepark-c561080",
"uffenheim-gollhofen_-_gewerbepark-c561090",
"uffenheim-gollhofen-c561040",
"uffenheim-gollhofen-c561050",
"uffenheim-mainbruecke_gossmannsdorf-c561160",
"uffenheim-rodheim-c561120",
"uffenheim-uffenheim_-_marktgrafenschloss-c560960",
"uffenheim-uffenheim_-_rathaus-c560930",
"uffenheim-uffenheim_-_rathaus-c560940",
"uffenheim-uffenheim-c560870",
"uffenheim-uffenheim-c560880",
"uffenheim-uffenheim-c560890",
"uffenheim-uffenheim-c560910",
"uffenheim-uffenheim-c560920",
"uffenheim-uffenheim-c560950",
"uffenheim-uffenheim-c560970",
"uffenheim-uffenheim-c560980",
"uffenheim-uffenheim-c560990",
"uffenheim-uffenheim-c561010",
"uffenheim-uffenheimer_parkett-s560230",
"uffenheim-uffenheim-s560220",
"uffenheim-uffenheim-s560240",
"uffenheim-uffenheim-s560250",
"uffenheim-uffenheim-s560260",
"uffenheim-uffenheim-s560270",
"uffenheim-uffenheim-s560280",
"uffenheim-uffenheim-s560290",
"uffenheim-uffenheim-s560300",
"uffenheim-uffenheim-s560320",
"uffenheim-windrad_gollhofen-c561100",
"uffenheim-windrad_gollhofen-c561110",
"ulm-congresszentrum_ulm-c504520",
"ulm-pauluskirche-c504460",
"ulm-pauluskirche-c504470",
"ulm-schopfenmuehle-c504640",
"ulm-schopfenmuehle-c504650",
"ulm-schopfenmuehle-c504660",
"ulm-schopfenmuehle-c504680",
"ulm-schopfenmuehle-c504710",
"ulm-schopfenmuehle-c504730",
"ulm-st_-georgs-kirche-c504450",
"ulm-ulm_hauptbahnhof-c504410",
"ulm-ulm_hauptbahnhof-c504420",
"ulm-ulm_hauptbahnhof-c504620",
"ulm-ulm_hauptbahnhof-c504630",
"ulm-ulm-c504440",
"ulm-ulmer_muenster-c504350",
"ulm-ulmer_muenster-c504380",
"ulm-ulmer_muenster-c504400",
"ulm-ulmer_muenster-c504430",
"ulm-ulmer_muenster-c504550",
"ulm-ulmer_muenster-c504560",
"ulm-ulmer_muenster-c504570",
"ulm-ulmer_muenster-c504580",
"ulm-ulmer_muenster-c504610",
"ulm-ulm-f501940",
"ulm-ulm-f501960",
"ulm-ulm-f501970",
"ulm-ulm-f501980",
"ulm-ulm-f501990",
"ulm-umspannwerk_ulm-c504700",
"unbekannt-aecker-c214800",
"unbekannt-aecker-c214810",
"unbekannt-aufforstung-n356450",
"unbekannt-autobahnbruecke_a6-f401290",
"unbekannt-autobahnbruecke_a6-f401320",
"unbekannt-autobahnbruecke_a6-f401340",
"unbekannt-autobahnbruecke_a6-f401520",
"unbekannt-autobahnbruecke_a6-f401540",
"unbekannt-autobahnbruecke_a6-f401940",
"unbekannt-autobahn-c214700",
"unbekannt-autobahn-cc16740",
"unbekannt-autobahnraststaette_jura_ost-f401980",
"unbekannt-bauernhof-c163760",
"unbekannt-bauernhof-c163770",
"unbekannt-bauernhof-f402500",
"unbekannt-baustelle_autobahn_a6-f401370",
"unbekannt-baustelle-c163610",
"unbekannt-baustelle-c163620",
"unbekannt-biogasanlage-c214600",
"unbekannt-bruecke-cd18610",
"unbekannt-bruecke-n144080",
"unbekannt-bruecke-n144090",
"unbekannt-dorf-c28140",
"unbekannt-felder-c175220",
"unbekannt-firma_ostendorf-c091190",
"unbekannt-forstwirtschaft_bei_hammerbach-n277070",
"unbekannt-forstwirtschaft-n356630",
"unbekannt-friedhof-n144050",
"unbekannt-fruehling-c09600",
"unbekannt-fussballplatz-c158400",
"unbekannt-garten-c158280",
"unbekannt-glascontainer-cd18460",
"unbekannt-gleitschirmflieger-n356590",
"unbekannt-haus-c163640",
"unbekannt-helikopter-n325540",
"unbekannt-kirche-c158360",
"unbekannt-kirche-c158380",
"unbekannt-kirche-n144060",
"unbekannt-kloster_naehe_cadolzburg-c175270",
"unbekannt-kornfeld-f401730",
"unbekannt-kreisverkehr-f401850",
"unbekannt-landwirtschaft-c214770",
"unbekannt-landwirtschaft-c214780",
"unbekannt-landwirtschaft-n355450",
"unbekannt-lkw_parkplatz-f402460",
"unbekannt-luftbildarchaeologie-n325850",
"unbekannt-luftbildarchaeologie-n325860",
"unbekannt-natur-c09790",
"unbekannt-natur-c214650",
"unbekannt-natur-c214670",
"unbekannt-neubau-c158270",
"unbekannt-neubausiedlung-c163650",
"unbekannt-panoramaaufnahme-cd18400",
"unbekannt-panoramaaufnahme-cd18430",
"unbekannt-panoramaaufnahme-cd18530",
"unbekannt-panorama-c137380",
"unbekannt-panorama-cd19230",
"unbekannt-panorama-n302860",
"unbekannt-pferdestall-n143960",
"unbekannt-photovoltaikanlage-f401670",
"unbekannt-rapsfelder-cd18840",
"unbekannt-saegewerk-c098480",
"unbekannt-schafherde-n356410",
"unbekannt-schneise-n326110",
"unbekannt-schrottplatz-c118330",
"unbekannt-senkrechtaufnahme-c118450",
"unbekannt-senkrechtaufnahme-c118520",
"unbekannt-senkrechtaufnahme-c118530",
"unbekannt-senkrechtaufnahme-cc16790",
"unbekannt-senkrechtaufnahme-cc16820",
"unbekannt-solar_pferdehof-c163700",
"unbekannt-solar_pferdehof-c163710",
"unbekannt-solar_pferdehof-c163720",
"unbekannt-solar-c158170",
"unbekannt-solar-c163680",
"unbekannt-solar-cd18490",
"unbekannt-sonnenuntergang-c091060",
"unbekannt-sonnenuntergang-c091330",
"unbekannt-staudamm_naehe_donau-c091160",
"unbekannt-thueringen-n356640",
"unbekannt-thueringen-n356670",
"unbekannt-wald-n267910",
"unbekannt-wald-n267920",
"unbekannt-weinquelle-n143980",
"unbekannt-windpark_panorama-c214620",
"unbekannt-windrad-c175310",
"unbekannt-windrad-c175330",
"unbekannt-windrad-cd18780",
"unbekannt-windrad-cd18890",
"unbekannt-windraeder-cd18670",
"unbekannt-windraeder-f402530",
"unbekannt-windraeder-n277100",
"unbekannt-windraeder-n302950",
"unbekannt-windraeder-n302960",
"unbekannt-windraeder-n302970",
"unbekannt-windraeder-n302980",
"unbekannt-ziegelwerk-c158460",
"unbekannt-ziegelwerk-c158640",
"unbekannt-ziegelwerk-cd18580",
"unterahrain-kernkraftwerk_isar-n511780",
"unterahrain-kernkraftwerk_isar-n511790",
"unterahrain-kernkraftwerk_isar-n511800",
"unterahrain-kernkraftwerk_isar-n511810",
"unterahrain-kernkraftwerk_isar-n511820",
"unterahrain-kernkraftwerk_isar-n511830",
"unterahrain-kernkraftwerk_isar-n511840",
"unterahrain-kernkraftwerk_isar-n511850",
"unterahrain-kernkraftwerk_isar-n511870",
"unterahrain-kernkraftwerk_isar-n511880",
"unterahrain-kernkraftwerk_isar-n511890",
"unterahrain-kernkraftwerk_isar-n511910",
"unterahrain-kernkraftwerk_isar-n511920",
"unterammergau-unterammergau-f500670",
"unterammergau-unterammergau-f500690",
"unterammergau-unterammergau-f500830",
"unterasbach-unterasbach-c162260",
"unterasbach-unterasbach-c162270",
"unterasbach-unterasbach-c162280",
"unterasbach-unterasbach-c162300",
"unterasbach-unterasbach-c500310",
"unterasbach-unterasbach-c500320",
"untergrasheim-solarpark_schornhof-f481180",
"untergrasheim-solarpark_schornhof-f481210",
"unterleinleitner-schloss_unterleinleiter-n35200",
"untermembach-frauenreuthweiher-f436150",
"untermembach-untermembach-f4020",
"untermerzbach-roesler_oberflaechentechnik_gmbh-n551510",
"unteroelsbach-autobahnbaustelle_bei_unteroelsbach-f441850",
"unteroelsbach-kreisverkehr_bei_unteroelsbach-f442010",
"unterrieden-talbruecke_unterrieden-c171070",
"unterrieden-talbruecke_unterrieden-c171100",
"unterrieden-talbruecke_unterrieden-f402560",
"unterrieden-talbruecke_unterrieden-f402600",
"unterrieden-talbruecke_unterrieden-f402620",
"unterrieden-talbruecke_unterrieden-f402630",
"unterrieden-talbruecke_unterrieden-f402670",
"unterschwaningen-schloss_dennenlohe-n326530",
"unterschwaningen-schloss_dennenlohe-n326560",
"unterschwaningen-schloss_dennenlohe-n326570",
"unterschwaningen-schloss_dennenlohe-n326590",
"unterschwaningen-schloss_dennenlohe-n326620",
"unterschwaningen-schloss_dennenlohe-n326670",
"unterschwaningen-schloss_dennenlohe-n326690",
"unterschwaningen-schloss_dennenlohe-n326710",
"untersiemau-talbruecke_weissenbrunn_am_forst-n551300",
"untersiemau-talbruecke_weissenbrunn_am_forst-n551310",
"untersiemau-talbruecke_weissenbrunn_am_forst-n551350",
"untersiemau-talbruecke_weissenbrunn_am_forst-n551360",
"untersiemau-talbruecke_weissenbrunn_am_forst-n551370",
"untersiemau-talbruecke_weissenbrunn_am_forst-n551380",
"ursensollen-dettnach_bei_ursensollen-f423090",
"ursensollen-ehringsfeld_bei_ursensollen-f423050",
"ursensollen-gewerbegebiet_ursensollen-f423000",
"ursensollen-grundschule_ursensollen-f423020",
"ursensollen-hainhof_bei_ursensollen-f423060",
"ursensollen-hainhof_bei_ursensollen-f423070",
"ursensollen-talbruecke_bei_hohenkemnath-f432370",
"urspringen-urspringen-s561150",
"urspringen-urspringen-s561170",
"urspringen-urspringen-s561180",
"urspringen-windraeder_bei_urspringen-s561140",
"velburg-ausfahrt_velburg-f431530",
"velburg-autobahn_a3_bei_velburg-f422020",
"velburg-autobahn_a3_bei_velburg-f422020",
"velburg-autobahn_a6_bei_velburg-f421880",
"velburg-autobahn_a6_bei_velburg-f421910",
"velburg-autobahn_a6_bei_velburg-f421930",
"velburg-autobahn_a6_bei_velburg-f421960",
"velburg-autobahn_a6_bei_velburg-f422080",
"velburg-autobahn_a6_bei_velburg-f422090",
"velburg-autobahn_a6_bei_velburg-f422100",
"velburg-autobahnbruecke_frauenbach-f431590",
"velburg-autobahnbruecke_frauenbach-f431610",
"velburg-baustelle_autobahn_a6_bei_velburg-f452250",
"velburg-baustelle_autobahn_a6_bei_velburg-f452570",
"velburg-baustelle_autobahn_a6_bei_velburg-f452850",
"velburg-baustelle_bei_velburg-f442150",
"velburg-baustelle_bei_velburg-f442280",
"velburg-baustelle_bei_velburg-f442360",
"velburg-baustelle_bei_velburg-f442430",
"velburg-bruecke_bei_geigerheid-f431650",
"velburg-bruecke_bei_krondorf-f442530",
"velburg-bruecke_bei_krondorf-f442640",
"velburg-bruecke_bei_krondorf-f442710",
"velburg-gewerbegebiet_bei_velburg-f421850",
"velburg-herz_jesu_kapelle-f432010",
"velburg-herz_jesu_kapelle-f432040",
"velburg-herz_jesu_kapelle-f432050",
"velburg-herz_jesu_kapelle-f432060",
"velburg-kirche_bei_velburg-f462050",
"velburg-kirche_bei_velburg-f462080",
"velburg-kreisverkehr_in_velburg-f432030",
"velburg-photovoltaikanlage_bei_hollerstetten-f422160",
"velburg-talbruecke_bei_oberweiling-f431680",
"velburg-talbruecke_bei_oberweiling-f431700",
"velburg-talbruecke_krondorf-f432100",
"velburg-talbruecke_krondorf-f432110",
"velburg-talbruecke_krondorf-f432200",
"velburg-talbruecke_krondorf-f452950",
"velburg-talbruecke_schallermuehle-f422150",
"velburg-unterfuehrung_bei_oberweiling-f431710",
"velburg-unterfuehrung_bei_oberweiling-f431870",
"velburg-unterfuehrung_bei_oberweiling-f431880",
"velburg-unterfuehrung_bei_vogelbrunn-f431800",
"velburg-unterfuehrung_bei_vogelbrunn-f431820",
"velburg-velburg-f461970",
"vestenbergsgreuth-vestenbergsgreuth-f37130",
"vilseck-burg_dagestein-n550130",
"vilseck-vilseck-n550120",
"vilshofen-abtei_schweiklberg-f521250",
"vilshofen-abtei_schweiklberg-n522240",
"vilshofen-abtei_schweiklberg-n522350",
"vilshofen-abtei_schweiklberg-n522360",
"vilshofen-abtei_schweiklberg-n522370",
"vilshofen-abtei_schweiklberg-n522390",
"vilshofen-abtei_schweiklberg-n522400",
"vilshofen-autobahnbruecke_bei_vilshofen-n522490",
"vilshofen-autobahnbruecke_bei_vilshofen-n522510",
"vilshofen-berger_bau_gmbh-n522420",
"vilshofen-berger_bau_gmbh-n522430",
"vilshofen-burgruine_hilgartsberg-n522450",
"vilshofen-burgruine_hilgartsberg-n522460",
"vilshofen-donau-f521270",
"vilshofen-flugplatz_vilshofen-f521350",
"vilshofen-flugplatz_vilshofen-n522260",
"vilshofen-flugplatz_vilshofen-n522290",
"vilshofen-flugplatz_vilshofen-n522310",
"vilshofen-kreisverkehr_vilshofen-f521240",
"vilshofen-kuffing-n522160",
"vilshofen-kuffing-n522170",
"vilshofen-lindach-n522230",
"vilshofen-marienbruecke_vilshofen-f521300",
"vilshofen-nicklgut-f521190",
"vilshofen-nicklgut-f521200",
"vilshofen-nicklgut-f521210",
"vilshofen-schwimmbad_vilshofen-n522250",
"vilshofen-solarpark_kuffing-n522180",
"vilshofen-solarpark_kuffing-n522200",
"vilshofen-vilshofen_hoerdt-f521380",
"vilshofen-vilshofen-f521180",
"vilshofen-vilshofen-f521220",
"vilshofen-vilshofen-f521230",
"vilshofen-vilshofen-f521260",
"vilshofen-vilshofen-f521280",
"vilshofen-vilshofen-f521290",
"vilshofen-vilshofen-f521310",
"vilshofen-vilshofen-f521320",
"vilshofen-vilshofen-f521330",
"vilshofen-vilshofen-f521360",
"vilshofen-vilshofen-f521370",
"vilshofen-vilshofen-n522320",
"vilshofen-vilshofen-n522330",
"vilshofen-vilshofen-n522340",
"virnsberg-schloss_virnsberg-f42500",
"virnsberg-schloss_virnsberg-f42520",
"virnsberg-schloss_virnsberg-f42540",
"virnsberg-schloss_virnsberg-n271800",
"virnsberg-schloss_virnsberg-n271810",
"virnsberg-schloss_virnsberg-n271840",
"virnsberg-schloss_virnsberg-n271860",
"virnsberg-schloss_virnsberg-n271870",
"virnsberg-schloss_virnsberg-n271880",
"virnsberg-schloss_virnsberg-n271900",
"virnsberg-schloss_virnsberg-n271910",
"virnsberg-schloss_virnsberg-n271930",
"virnsberg-virnsberg-n271680",
"virnsberg-virnsberg-n271690",
"voehringen-karl-eychmueller-stadion-c504320",
"voehringen-voehringer_see-f501860",
"voehringen-wieland_werke_in_voehringen-f501780",
"voehringen-wieland_werke_in_voehringen-f501790",
"voehringen-wieland_werke_in_voehringen-f501810",
"voehringen-wieland_werke_in_voehringen-f501830",
"voehringen-wieland_werke_in_voehringen-f501840",
"wachendorf-wachendorf-f392510",
"wachendorf-wachendorf-f392520",
"wachendorf-wachendorf-f392530",
"wachendorf-wachendorf-f392540",
"wackersdorf-irlach-n523930",
"waischenfeld-burg_rabeneck-n267840",
"waischenfeld-burg_rabeneck-n267850",
"waischenfeld-burg_rabeneck-n267870",
"waischenfeld-burg_rabeneck-n267890",
"waischenfeld-eichenbirking-n267810",
"waischenfeld-eichenbirking-n267820",
"waischenfeld-koettweinsdorf-n267620",
"waischenfeld-koettweinsdorf-n267630",
"waischenfeld-langenloh-n267640",
"waldaschaff-kauppenbruecke-f371640",
"waldaschaff-kauppenbruecke-f371660",
"waldsee-campingplatz-n291070",
"walting-brunnmuehle-f484010",
"warth-vilstalsee-f521080",
"warth-vilstalsee-f521090",
"wassermungenau-hans_henglein___sohn_gmbh-c505020",
"wassermungenau-wassermungenau-c504990",
"wassermungenau-wassermungenau-c505030",
"wassermungenau-wasserwerk_wassermungenau-c505010",
"weibersbrunn-autobahn_a3_-_rohrbrunn-c562690",
"weibersbrunn-autobahn_a3_-_rohrbrunn-c562700",
"weibersbrunn-autobahn_a3-c562720",
"weibersbrunn-autobahn_a3-c562740",
"weibersbrunn-rasthof_spessart-c562750",
"weibersbrunn-rasthof_spessart-c562760",
"weibersbrunn-rasthof_spessart-s561370",
"weibersbrunn-rasthof_spessart-s561390",
"weibersbrunn-rohrruchbruecke_a3-c562710",
"weibersbrunn-rohrruchbruecke_a3-c562730",
"weichselstein-industriegebiet_weissmarterstrasse_ii-n30950",
"weida-talsperre_weida-n351610",
"weida-talsperre_weida-n351620",
"weiden_in_der_oberpfalz-hammerweg___nachtmann-f550660",
"weiden_in_der_oberpfalz-nordoberpfalz_center__noc_-n550250",
"weiden_in_der_oberpfalz-st__josef_kirche-n550190",
"weiden_in_der_oberpfalz-st__josef_kirche-n550200",
"weiden_in_der_oberpfalz-st__josef_kirche-n550230",
"weiden_in_der_oberpfalz-st__michael_kirche-n550210",
"weiden_in_der_oberpfalz-st__michael_kirche-n550270",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz_-_altstadt-n550220",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz_-_altstadt-n550240",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz_-_altstadt-n550260",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz_-_altstadt-n550280",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz_-_altstadt-n550290",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz_-_altstadt-n550300",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550530",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550540",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550560",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550570",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550580",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550590",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550600",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550610",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550620",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550630",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-f550640",
"weiden_in_der_oberpfalz-weiden_i__d__oberpfalz-n550160",
"weidensees-autobahn_a9-n275850",
"weidensees-autobahn_a9-n275870",
"weidhausen_bei_coburg-weidhausen_bei_coburg-f552370",
"weidhausen_bei_coburg-weidhausen_bei_coburg-f552380",
"weidhausen_bei_coburg-weidhausen_bei_coburg-f552390",
"weidhausen_bei_coburg-weidhausen_bei_coburg-f552400",
"weidhausen_bei_coburg-weidhausen_bei_coburg-f552410",
"weigenheim-schloss_frankenberg-n27850",
"weigenheim-schloss_frankenberg-n27880",
"weigenheim-schloss_frankenberg-n27890",
"weigenheim-schloss_frankenberg-n27930",
"weigenheim-schloss_frankenberg-n27950",
"weigenheim-weigenheim-n27900",
"weihenzell-beutellohe-n327520",
"weihenzell-weihenzell_haasgang-n271290",
"weihenzell-weihenzell_haasgang-n271310",
"weihenzell-weihenzell_haasgang-n271320",
"weihenzell-weihenzell_haasgang-n271350",
"weihenzell-weihenzell_haasgang-n271360",
"weihenzell-zellrueglingen-n327510",
"weikershof-gewerbegebiet_weikershof-f531200",
"weilersbach-st__nikolaus_kapelle_kirche_-_vexierkapelle-n268070",
"weilersbach-st__nikolaus_kapelle_kirche_-_vexierkapelle-n268080",
"weilersbach-st__nikolaus_kapelle_kirche_-_vexierkapelle-n268090",
"weilersbach-st__nikolaus_kapelle_kirche_-_vexierkapelle-n268100",
"weilersbach-st__nikolaus_kapelle_kirche_-_vexierkapelle-n268120",
"weilersbach-st__nikolaus_kapelle_kirche_-_vexierkapelle-n268130",
"weisendorf-asv_weisendorf-c560090",
"weisendorf-asv_weisendorf-c560100",
"weisendorf-buch-n265280",
"weisendorf-buch-n265290",
"weisendorf-buch-n269450",
"weisendorf-nankendorf-n343310",
"weisendorf-sauerheim-s560130",
"weisendorf-weisendorf-c560070",
"weisendorf-weisendorf-c560080",
"weisendorf-weisendorf-f3790",
"weisendorf-weisendorf-f4050",
"weisendorf-weisendorf-f4060",
"weisendorf-weisendorf-f42100",
"weisendorf-weisendorf-f42110",
"weisendorf-weisendorf-f4250",
"weisendorf-weisendorf-f4260",
"weisendorf-weisendorf-f4270",
"weisendorf-weisendorf-f4280",
"weisendorf-weisendorf-f4290",
"weisendorf-weisendorf-f46240",
"weisendorf-weisendorf-f46250",
"weisendorf-weisendorf-n265300",
"weisendorf-weisendorf-n265310",
"weisendorf-weisendorf-s560120",
"weissenburg-bismarckturm-n34340",
"weissenburg-ellingen_-_hoerlbach-n292020",
"weissenburg-ellingen_-_hoerlbach-n292030",
"weissenburg-ellinger_tor-n291300",
"weissenburg-ellinger_tor-n291310",
"weissenburg-ellinger_tor-n291320",
"weissenburg-ellinger_tor-n291330",
"weissenburg-ellinger_tor-n291350",
"weissenburg-ellinger_tor-n291360",
"weissenburg-ellinger_tor-n291370",
"weissenburg-ellinger_tor-n291380",
"weissenburg-ellinger_tor-n291390",
"weissenburg-ellinger_tor-n291400",
"weissenburg-ellinger_tor-n291410",
"weissenburg-ellinger_tor-n291420",
"weissenburg-ellinger_tor-n291430",
"weissenburg-ellinger_tor-n291440",
"weissenburg-ellinger_tor-n291450",
"weissenburg-ellinger_tor-n291460",
"weissenburg-ellinger_tor-n291490",
"weissenburg-ellinger_tor-n291530",
"weissenburg-ellinger_tor-n291540",
"weissenburg-ellinger_tor-n291550",
"weissenburg-ellinger_tor-n291560",
"weissenburg-ellinger_tor-n291580",
"weissenburg-ellinger_tor-n291600",
"weissenburg-ellinger_tor-n291610",
"weissenburg-ellinger_tor-n291650",
"weissenburg-ellinger_tor-n291660",
"weissenburg-ellinger_tor-n291670",
"weissenburg-ellinger_tor-n291690",
"weissenburg-freibad-n291810",
"weissenburg-hubschrauberlandeplatz-n34540",
"weissenburg-kaufland-n322170",
"weissenburg-kaufland-n322410",
"weissenburg-kaufland-n34230",
"weissenburg-kirche_st__andreas-n3470",
"weissenburg-kirche_st__andreas-n3490",
"weissenburg-kirche-n291820",
"weissenburg-kirche-n291830",
"weissenburg-klaeranlage-n291480",
"weissenburg-klinikum_altmuehlfranken-n34520",
"weissenburg-klinikum-n322490",
"weissenburg-rezatanlage-n291340",
"weissenburg-schmalwiesen-n292010",
"weissenburg-spitalturm-n3480",
"weissenburg-weissenburg-n291470",
"weissenburg-weissenburg-n291620",
"weissenburg-weissenburg-n291700",
"weissenburg-weissenburg-n291770",
"weissenburg-weissenburg-n291790",
"weissenburg-weissenburg-n291800",
"weissenburg-weissenburg-n291850",
"weissenburg-weissenburg-n291940",
"weissenburg-weissenburg-n291950",
"weissenburg-weissenburg-n291990",
"weissenburg-weissenburg-n322190",
"weissenburg-weissenburg-n322350",
"weissenburg-weissenburg-n322450",
"weissenburg-weissenburg-n34110",
"weissenburg-weissenburg-n3450",
"weissenburg-weissenburg-n514890",
"weissenburg-weissenburg-n514900",
"weissenburg-weissenburg-n514910",
"weissenburg-weissenburg-n514920",
"weissenburg-weissenburg-n514930",
"weissenburg-wuelzburger_weg-n322520",
"weissenburg-wuelzburg-n272730",
"weissenburg-wuelzburg-n272740",
"weissenburg-wuelzburg-n272780",
"weissenburg-wuelzburg-n272800",
"weissenburg-wuelzburg-n272830",
"weissenburg-wuelzburg-n272840",
"weissenburg-wuelzburg-n272880",
"weissenburg-wuelzburg-n272890",
"weissenburg-wuelzburg-n272910",
"weissenburg-wuelzburg-n272970",
"weissenburg-wuelzburg-n272980",
"weissenburg-wuelzburg-n273000",
"weissenburg-wuelzburg-n273030",
"weissenburg-wuelzburg-n273050",
"weissenburg-wuelzburg-n273100",
"weissenburg-wuelzburg-n273140",
"weissenburg-wuelzburg-n273160",
"weissenburg-wuelzburg-n273170",
"weissenburg-wuelzburg-n273180",
"weissenburg-wuelzburg-n273190",
"weissenburg-zentralklaeranlage_weissenburg-n514940",
"wellheim-aicha-n323290",
"wellheim-burg_wellheim-n323340",
"wellheim-burg_wellheim-n323360",
"wellheim-gammersfeld-n323410",
"wendelstein-grossschwarzenlohe_-_kaufland-n32230",
"wendelstein-grossschwarzenlohe_-_kaufland-n32390",
"wendelstein-grossschwarzenlohe_-_kaufland-n32400",
"wendelstein-grossschwarzenlohe_-_kaufland-n32480",
"wendelstein-grossschwarzenlohe-n341020",
"wendelstein-grossschwarzenlohe-n341200",
"wendelstein-grossschwarzenlohe-n34880",
"wendelstein-grossschwarzenlohe-n34930",
"wendelstein-grossschwarzenlohe-n34940",
"wendelstein-grossschwarzenlohe-n34970",
"wendelstein-grossschwarzenlohe-n34980",
"wendelstein-neuses-n341240",
"wendelstein-neuses-n341250",
"wendelstein-neuses-n341260",
"wendelstein-pfarrkirche_allerheiligen-n34700",
"wendelstein-schwanstetten_-_harm-n32580",
"wendelstein-schwanstetten_-_mittelmembach-n32610",
"wendelstein-schwarzenbruck-n068780",
"wendelstein-wasserturm-n341050",
"wessobrunn-ehem__kloster_wessenbrunn-c501340",
"wessobrunn-wessobrunn-c501360",
"westendorf-westendorf-n325680",
"wiesenbronn-wiesenbronn-f37260",
"wiesenfelden-thurasdorf-n523470",
"wiesenfelden-thurasdorf-n523480",
"wiesenthau-walberla-n268030",
"wiesenthau-walberla-n268040",
"wiesenthau-walberla-n268050",
"wiesenttal-burgruine_neideck-n267450",
"wiesenttal-burgruine_neideck-n267480",
"wiesenttal-burgruine_neideck-n267490",
"wiesenttal-burgruine_neideck-n267540",
"wiesenttal-burgruine_neideck-n267570",
"wiesenttal-burgruine_neideck-n267610",
"wilhelmsdorf-wilhelmsdorf-c560170",
"wilhermsdorf-wilhermsdorf-n327570",
"wilting-churpflazpark_loifling-n523490",
"wilting-churpflazpark_loifling-n523500",
"wilting-churpflazpark_loifling-n523510",
"wilting-churpflazpark_loifling-n523520",
"wilting-wilting-f522090",
"wilting-wilting-f522100",
"windorf-windorf-n522140",
"winkelhaid-winkelhaid-c161420",
"winkelhaid-winkelhaid-c161440",
"winkelhaid-winkelhaid-c161500",
"winzer-burgruine_doebl-n522530",
"winzer-doebl-n522560",
"winzer-winzer_hinterrechkenberg-n522570",
"winzer-winzer_hinterrechkenberg-n522580",
"woernitz-walkersdorf_bei_woernitz-f42970",
"wohlmuting-wohlmuting-f512010",
"wolframs-eschenbach-selgenstadt-c214540",
"worms-bei_worms-f375160",
"worms-dom_st__peter-f375270",
"worms-festplatz_worms-f375210",
"worms-hafen_worms-f375330",
"worms-hafen_worms-f375350",
"worms-hafen_worms-f375400",
"worms-hauptbahnhof_worms-f375310",
"worms-jahnwiese_in_worms-f375200",
"worms-jahnwiese_in_worms-f375250",
"worms-liebfrauenkirche_in_worms-f375170",
"worms-liebfrauenkirche_in_worms-f375180",
"worms-liebfrauenkirche_in_worms-f375340",
"worms-liebfrauenkirche_in_worms-f375480",
"worms-neue_nibelungenbruecke_in_worms-f375300",
"worms-nibelungenbruecke_in_worms-f375240",
"worms-nibelungenbruecke_in_worms-f375450",
"worms-rhein_bei_worms-f375360",
"worms-rheinbruecke_worms-f375390",
"worms-rheinbruecke_worms-f375470",
"worms-schlossplatz_worms-f375280",
"worms-silbersee_bei_worms-f375540",
"worms-sportflugplatz_bei_worms-f375500",
"worms-stadtzentrum_worms-f375460",
"worms-theater_worms-f375290",
"worms-wohnquartier_gerbergasse_in_worms-f375220",
"worms-worms-f375190",
"worms-worms-f375260",
"wuerzburg-alte_mainbruecke_-_wuerzburg-c562290",
"wuerzburg-alte_mainbruecke-f371280",
"wuerzburg-alte_mainbruecke-f37550",
"wuerzburg-alte_mainbruecke-f37600",
"wuerzburg-amtsgericht-f37740",
"wuerzburg-exerzitienhaus_himmelspforten-f371300",
"wuerzburg-festung_marienberg-c562310",
"wuerzburg-festung_marienberg-c562320",
"wuerzburg-festung_marienberg-c562330",
"wuerzburg-festung_marienberg-c562340",
"wuerzburg-festung_marienberg-f371010",
"wuerzburg-festung_marienberg-f371020",
"wuerzburg-festung_marienberg-f37530",
"wuerzburg-festung_marienberg-f37540",
"wuerzburg-festung_marienberg-f37570",
"wuerzburg-festung_marienberg-f37590",
"wuerzburg-festung_marienberg-f37610",
"wuerzburg-festung_marienberg-f37620",
"wuerzburg-festung_marienberg-f37730",
"wuerzburg-festung_marienberg-f37780",
"wuerzburg-festung_marienberg-f37830",
"wuerzburg-festung_marienberg-f37840",
"wuerzburg-festung_marienberg-f37850",
"wuerzburg-festung_marienberg-f37860",
"wuerzburg-festung_marienberg-f37880",
"wuerzburg-festung_marienberg-f37960",
"wuerzburg-festung_marienberg-f37970",
"wuerzburg-festung_marienberg-f37990",
"wuerzburg-festung_marienberg-s560730",
"wuerzburg-festung_marienberg-s560740",
"wuerzburg-festung_marienberg-s560760",
"wuerzburg-friedensbruecke-f371290",
"wuerzburg-friedrich-berguis-ring-s560590",
"wuerzburg-greussenheim-f371430",
"wuerzburg-gut_greussenheim-f371450",
"wuerzburg-gut_greussenheim-f371460",
"wuerzburg-hafen_wuerzburg-f371320",
"wuerzburg-hafen_wuerzburg-f371360",
"wuerzburg-hauptbahnhof_wuerzburg-f371040",
"wuerzburg-hauptbahnhof_wuerzburg-f371070",
"wuerzburg-hauptbahnhof_wuerzburg-f371100",
"wuerzburg-hauptbahnhof_wuerzburg-f371120",
"wuerzburg-hauptbahnhof_wuerzburg-f371130",
"wuerzburg-hauptbahnhof_wuerzburg-f371180",
"wuerzburg-juliusspital_wuerzburg-f371250",
"wuerzburg-kalksteinbruch_der_schwenk_kg-c562350",
"wuerzburg-kalksteinbruch_der_schwenk_kg-c562360",
"wuerzburg-klaeranlage_wuerzburg-f371310",
"wuerzburg-krankenhaus_wuerzburg-s560640",
"wuerzburg-mainfrankenpark-c561890",
"wuerzburg-mainfrankenpark-c561900",
"wuerzburg-mainfrankenpark-c561920",
"wuerzburg-maintalbruecke_veitshoechheim-s560860",
"wuerzburg-neubaukirche_wuerzburg-f371230",
"wuerzburg-neuer_hafen_wuerzburg-f371330",
"wuerzburg-neuer_hafen_wuerzburg-f371380",
"wuerzburg-orangerie_wuerzburg-c561960",
"wuerzburg-residenz_wuerzburg-c561930",
"wuerzburg-residenz_wuerzburg-c561940",
"wuerzburg-residenz_wuerzburg-c561950",
"wuerzburg-residenz_wuerzburg-c561970",
"wuerzburg-residenz_wuerzburg-c562010",
"wuerzburg-residenz_wuerzburg-c562170",
"wuerzburg-residenz_wuerzburg-c562180",
"wuerzburg-residenz_wuerzburg-c562190",
"wuerzburg-residenz_wuerzburg-c562200",
"wuerzburg-residenz_wuerzburg-c562240",
"wuerzburg-residenz_wuerzburg-c562250",
"wuerzburg-residenz_wuerzburg-c562260",
"wuerzburg-residenz_wuerzburg-c562270",
"wuerzburg-residenz_wuerzburg-f371190",
"wuerzburg-residenz_wuerzburg-f371210",
"wuerzburg-residenz_wuerzburg-s560700",
"wuerzburg-residenz-f37750",
"wuerzburg-residenz-f37770",
"wuerzburg-residenz-f37790",
"wuerzburg-residenz-f37920",
"wuerzburg-stettiner_berg-s560970",
"wuerzburg-stettiner_berg-s560980",
"wuerzburg-stift_haug-c562040",
"wuerzburg-stift_haug-c562050",
"wuerzburg-stift_haug-c562070",
"wuerzburg-stift_haug-c562080",
"wuerzburg-stift_haug-c562090",
"wuerzburg-universitaesklinikum_wuerzburg-s560650",
"wuerzburg-wuerzburg_-_altstadt-c561980",
"wuerzburg-wuerzburg_-_altstadt-s560710",
"wuerzburg-wuerzburg_-_altstadt-s560720",
"wuerzburg-wuerzburg_-_barbarossaplatz-c562110",
"wuerzburg-wuerzburg_-_exerzitierenhaus-s560790",
"wuerzburg-wuerzburg_-_exerzitierenhaus-s560800",
"wuerzburg-wuerzburg_-_ghotel-c562130",
"wuerzburg-wuerzburg_-_ghotel-c562140",
"wuerzburg-wuerzburg_-_ghotel-c562150",
"wuerzburg-wuerzburg_-_ghotel-c562160",
"wuerzburg-wuerzburg_-_hafen-s560810",
"wuerzburg-wuerzburg_-_hauptbahnhof-c561990",
"wuerzburg-wuerzburg_-_hauptbahnhof-c562000",
"wuerzburg-wuerzburg_-_hauptbahnhof-c562020",
"wuerzburg-wuerzburg_-_hauptbahnhof-c562030",
"wuerzburg-wuerzburg_-_hauptbahnhof-c562060",
"wuerzburg-wuerzburg_-_hauptbahnhof-c562120",
"wuerzburg-wuerzburg_-_kloster-s560820",
"wuerzburg-wuerzburg_-_main-c562300",
"wuerzburg-wuerzburg_-_versbach-s560630",
"wuerzburg-wuerzburg_klaeranlage-s560780",
"wuerzburg-wuerzburg_zell-s560770",
"wuerzburg-wuerzburg_zell-s560830",
"wuerzburg-wuerzburg_zell-s560850",
"wuerzburg-wuerzburg-c562220",
"wuerzburg-wuerzburg-c562230",
"wuerzburg-wuerzburger_dom-f371240",
"wuerzburg-wuerzburg-f371050",
"wuerzburg-wuerzburg-f371060",
"wuerzburg-wuerzburg-f371110",
"wuerzburg-wuerzburg-f371140",
"wuerzburg-wuerzburg-f371160",
"wuerzburg-wuerzburg-f371220",
"wuerzburg-wuerzburg-f371340",
"wuerzburg-wuerzburg-f371350",
"wuerzburg-wuerzburg-f371410",
"wuerzburg-wuerzburg-f37480",
"wuerzburg-wuerzburg-f37490",
"wuerzburg-wuerzburg-f37580",
"wuerzburg-wuerzburg-f37690",
"wuerzburg-wuerzburg-f37710",
"wuerzburg-wuerzburg-f37720",
"wuerzburg-wuerzburg-f37800",
"wuerzburg-wuerzburg-f37810",
"wuerzburg-wuerzburg-f37820",
"wuerzburg-wuerzburg-f37900",
"wuerzburg-wuerzburg-f37940",
"wuerzburg-wuerzburg-s560660",
"wuerzburg-wuerzburg-s560670",
"wulkersdorf-wulkersdorf-f40100",
"wunsiedel-wunsiedel-f551250",
"wunsiedel-wunsiedel-f551260",
"wunsiedel-wunsiedel-f551270",
"wunsiedel-wunsiedel-f551290",
"wunsiedel-wunsiedel-f551300",
"wunsiedel-wunsiedel-f551320",
"wunsiedel-wunsiedel-f551350",
"wunsiedel-wunsiedel-krohenhammer-f551310",
"zeitz-absetzanlage_suedzucker-n352110",
"zeitz-weisse_elster-n352090",
"zeitz-weisse_elster-n352120",
"zeitz-weisse_elster-n352130",
"zellingen-klaeranlage_zellingen-s560950",
"zellingen-zellingen-s560930",
"zellingen-zellingen-s560940",
"zeulenroda-triebes-quingenberg-n351540",
"zeulenroda-triebes-quingenberg-n351550",
"zeulenroda-triebes-quingenberg-n351560",
"zeulenroda-triebes-quingenberg-n351570",
"zeulenroda-triebes-quingenberg-n351590",
"zeulenroda-triebes-quingenberg-n351600",
"zeulenroda-triebes-zeulenroda-n351430",
"zeulenroda-triebes-zeulenroda-n351440",
"zeulenroda-triebes-zeulenroda-n351460",
"zeulenroda-triebes-zeulenroda-n351480",
"zeulenroda-triebes-zeulenroda-n351510",
"zeulenroda-triebes-zeulenroda-n351520",
"zirndorf-alte_veste-c174810",
"zirndorf-alte_veste-c174820",
"zirndorf-alte_veste-c174830",
"zirndorf-alte_veste-c174890",
"zirndorf-alte_veste-c174930",
"zirndorf-alte_veste-c174960",
"zirndorf-alte_veste-c174970",
"zirndorf-alte_veste-c215310",
"zirndorf-alte_veste-f531190",
"zirndorf-baustelle-c162810",
"zirndorf-mischwerk-c162770",
"zirndorf-panorama-c162340",
"zirndorf-panorama-c254380",
"zirndorf-panorama-c254390",
"zirndorf-playmobil_park-c162370",
"zirndorf-playmobil_park-c162390",
"zirndorf-playmobil_park-c162400",
"zirndorf-playmobil_park-c162420",
"zirndorf-playmobil_park-c162450",
"zirndorf-playmobil_park-c162460",
"zirndorf-playmobil_park-c162480",
"zirndorf-playmobil_park-c162490",
"zirndorf-playmobil_park-c162500",
"zirndorf-playmobil_park-c162540",
"zirndorf-playmobil_park-c162550",
"zirndorf-playmobil_park-c162590",
"zirndorf-playmobil_park-c162610",
"zirndorf-playmobil_park-c162630",
"zirndorf-playmobil_park-c162640",
"zirndorf-playmobil_park-c162650",
"zirndorf-playmobil_park-c162660",
"zirndorf-playmobil_park-c162670",
"zirndorf-playmobil_park-c162680",
"zirndorf-playmobil_park-c162710",
"zirndorf-playmobil_park-c162720",
"zirndorf-playmobil_park-c162730",
"zirndorf-playmobil_park-c162750",
"zirndorf-zirndorf-c162760",
"zirndorf-zirndorf-c254290",
"zirndorf-zirndorf-c254300",
"zirndorf-zirndorf-c254310",
"zirndorf-zirndorf-c254320",
"zirndorf-zirndorf-c254330",
"zirndorf-zirndorf-c254340",
"zirndorf-zirndorf-c254350",
"zirndorf-zirndorf-c254360",
"zirndorf-zirndorf-c254410",
"zirndorf-zirndorf-c500290",
"zirndorf-zirndorf-f531180",
"zochenreuth-zochenreuth-n35220",
"zwingenberg-schloss_zwingenberg-f377830",
"zwingenberg-schloss_zwingenberg-f377860",
"zwingenberg-zwingenberg-f377850"

 
];

var buttons = document.querySelectorAll(".zufall_luftbild, .zufall_luftbild2");

buttons.forEach(function(button) {
  button.style.cursor = "pointer";
  button.addEventListener("click", function() {
    var randomSuffix = suffixes[Math.floor(Math.random() * suffixes.length)];
    var link = prefix + randomSuffix;
    window.location.href = link;
  });
});